// Generated by Avo VERSION 172.19.0. You should never have to make changes to this file.
// If you find yourself in the situation where you have to edit the file please contact us at hi@avo.app.
// If you encounter a git conflict in this file run `avo pull` and it will be resolved automatically.
/* eslint-disable */

// fetch() polyfill
(function () {
  if (typeof window === 'undefined') {
    return;
  }
  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function() {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  function isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function(obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift();
        return {done: value === undefined, value: value}
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {};

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value);
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1]);
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
      }, this);
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function(name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true;
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result);
      };
      reader.onerror = function() {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]);
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false;

    this._initBody = function(body) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this);
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      };

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      };
    }

    this.text = function() {
      var rejected = consumed(this);
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    };

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      };
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    };

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input, options) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url;
      this.credentials = input.credentials;
      if (!options.headers) {
        this.headers = new Headers(input.headers);
      }
      this.method = input.method;
      this.mode = input.mode;
      this.signal = input.signal;
      if (!body && input._bodyInit != null) {
        body = input._bodyInit;
        input.bodyUsed = true;
      }
    } else {
      this.url = String(input);
    }

    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers);
    }
    this.method = normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal;
    this.referrer = null;

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body);
  }

  Request.prototype.clone = function() {
    return new Request(this, {body: this._bodyInit})
  };

  function decode(body) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function(bytes) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit, options) {
    if (!options) {
      options = {};
    }

    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    this.headers = new Headers(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''});
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  };

  self.DOMException = self.DOMException;
  try {
    new self.DOMException();
  } catch (err) {
    self.DOMException = function(message, name) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    self.DOMException.prototype = Object.create(Error.prototype);
    self.DOMException.prototype.constructor = self.DOMException;
  }

  function fetch(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new self.DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : xhr.responseText;
        resolve(new Response(body, options));
      };

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function() {
        reject(new self.DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function() {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    self.fetch = fetch;
    self.Headers = Headers;
    self.Request = Request;
    self.Response = Response;
  }
})();

(function(exports) {
  var __AVO_DEV__ = false;
  var __AVO_NOOP__ = false;
  var __AVO_LOGGER__ = null;
  var __AVO_ENV__ = null;
  var __REPORT_FAILURE_AS__ = null;
  var __STRICT__ = null;
  
  var __WEB_DEBUGGER__ = true;
  const avoInspectorApiKey = "ncKE8oVxtcaE4Hdy9XP1";
  var __INSPECTOR__ = null;
  
  // polyfill Array.isArray
  if (!Array.isArray) {
    Array.isArray = function(arg) {
      return Object.prototype.toString.call(arg) === '[object Array]';
    };
  }

  // polyfill Object.assign
  if (typeof Object.assign !== 'function') {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, "assign", {
      value: function assign(target, varArgs) { // .length of function is 2
        if (target == null) { // TypeError if undefined or null
          throw new TypeError('Cannot convert undefined or null to object');
        }

        var to = Object(target);

        for (var index = 1; index < arguments.length; index++) {
          var nextSource = arguments[index];

          if (nextSource != null) { // Skip over if undefined or null
            for (var nextKey in nextSource) {
              // Avoid bugs when hasOwnProperty is shadowed
              if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                to[nextKey] = nextSource[nextKey];
              }
            }
          }
        }
        return to;
      },
      writable: true,
      configurable: true
    });
  }

  // From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys
  if (!Object.keys) {
    Object.keys = (function() {
      'use strict';
      var hasOwnProperty = Object.prototype.hasOwnProperty,
          hasDontEnumBug = !({ toString: null }).propertyIsEnumerable('toString'),
          dontEnums = [
            'toString',
            'toLocaleString',
            'valueOf',
            'hasOwnProperty',
            'isPrototypeOf',
            'propertyIsEnumerable',
            'constructor'
          ],
          dontEnumsLength = dontEnums.length;

      return function(obj) {
        if (typeof obj !== 'function' && (typeof obj !== 'object' || obj === null)) {
          throw new TypeError('Object.keys called on non-object');
        }

        var result = [], prop, i;

        for (prop in obj) {
          if (hasOwnProperty.call(obj, prop)) {
            result.push(prop);
          }
        }

        if (hasDontEnumBug) {
          for (i = 0; i < dontEnumsLength; i++) {
            if (hasOwnProperty.call(obj, dontEnums[i])) {
              result.push(dontEnums[i]);
            }
          }
        }
        return result;
      };
    }());
  }

  // polyfill Array.indexOf
  if (!Array.prototype.indexOf)  Array.prototype.indexOf = (function(Object, max, min){
    "use strict";
    return function indexOf(member, fromIndex) {
      if(this===null||this===undefined)throw TypeError("Array.prototype.indexOf called on null or undefined");

      var that = Object(this), Len = that.length >>> 0, i = min(fromIndex | 0, Len);
      if (i < 0) i = max(0, Len+i); else if (i >= Len) return -1;

      if(member===void 0){ for(; i !== Len; ++i) if(that[i]===void 0 && i in that) return i; // undefined
      }else if(member !== member){   for(; i !== Len; ++i) if(that[i] !== that[i]) return i; // NaN
      }else                           for(; i !== Len; ++i) if(that[i] === member) return i; // all else

      return -1; // if the value was not found, then return -1
    };
  })(Object, Math.max, Math.min);
  
  var array_difference, AvoAssert, InternalAvoLogger;
  array_difference = function array_difference(a1, a2) {
    var result = [];
    for (var i = 0; i < a1.length; i++) {
      if (a2.indexOf(a1[i]) === -1) {
        result.push(a1[i]);
      }
    }
    return result;
  }
  
  AvoAssert = {
    assertObject: function assertObject(propertyId, propName, obj) {
      if (typeof obj !== 'object') {
        var message = propName +
          ' should be of type object but you provided type ' +
          typeof obj +
          ' with value ' +
          JSON.stringify(obj);
        return [{tag: 'expectedObjectType', propertyId: propertyId, message: message, actualType: typeof obj}];
      } else {
        return [];
      }
    },

    assertString: function assertString(propertyId, propName, str) {
      if (typeof str !== 'string') {
        var message = propName +
          ' should be of type string but you provided type ' +
          typeof str +
          ' with value ' +
          JSON.stringify(str);
        return [{tag: 'expectedStringType', propertyId: propertyId, message: message, actualType: typeof str}];
      } else {
        return [];
      }
    },

    assertInt: function assertInt(propertyId, propName, int) {
      if (typeof int === 'number' && int !== Math.round(int)) {
        var message = propName +
          ' should be of type int but you provided type float with value ' +
          JSON.stringify(int);
        return [{tag: 'expectedIntType', propertyId: propertyId, actualType: 'float'}];
      } else if (typeof int !== 'number') {
        var message = propName +
          ' should be of type int but you provided type ' +
          typeof int +
          ' with value ' +
          JSON.stringify(int);
        return [{tag: 'expectedIntType', propertyId: propertyId, message: message, actualType: typeof int}];
      } else {
        return [];
      }
    },

    assertLong: function assertLong(propertyId, propName, long) {
      if (typeof long === 'number' && long !== Math.round(long)) {
        var message = propName +
          ' should be of type long but you provided type float with value ' +
          JSON.stringify(long);
        return [{tag: 'expectedLongType', propertyId: propertyId, actualType: 'float'}];
      } else if (typeof long !== 'number') {
        var message = propName +
          ' should be of type long but you provided type ' +
          typeof long +
          ' with value ' +
          JSON.stringify(long);
        return [{tag: 'expectedLongType', propertyId: propertyId, message: message, actualType: typeof long}];
      } else {
        return [];
      }
    },

    assertFloat: function assertFloat(propertyId, propName, float) {
      if (typeof float !== 'number') {
        var message = propName +
          ' should be of type float but you provided type ' +
          typeof float +
          ' with value ' +
          JSON.stringify(float);
        return [{tag: 'expectedFloatType', propertyId: propertyId, message: message, actualType: typeof float}];
      } else {
        return [];
      }
    },

    assertBool: function assertBool(propertyId, propName, bool) {
      if (typeof bool !== 'boolean') {
        var message = propName +
          ' should be of type boolean but you provided type ' +
          typeof bool +
          ' with value ' +
          JSON.stringify(bool);
        return [{tag: 'expectedBoolType', propertyId: propertyId, message: message, actualType: typeof bool}];
      } else {
        return [];
      }
    },

    assertMax: function assertMax(propertyId, propName, max, value) {
      if (value > max) {
        var message = propName +
          ' has a maximum value of ' +
          max +
          ' but you provided the value ' +
          JSON.stringify(value);
        return [{tag: 'expectedMax', propertyId: propertyId, message: message}];
      } else {
        return [];
      }
    },

    assertMin: function assertMin(propertyId, propName, min, value) {
      if (value < min) {
        var message = propName +
          ' has a minimum value of ' +
          min +
          ' but you provided the value ' +
          JSON.stringify(value);
        return [{tag: 'expectedMin', propertyId: propertyId, message: message}];
      } else {
        return [];
      }
    },

    assertList: function assertList(propertyId, propName, value) {
      if (!Array.isArray(value)) {
        var message = propName + ' should be of type list but you provided type ' + typeof value;
        return [{tag: 'expectedList', propertyId: propertyId, message: message, actualType: typeof value}];
      } else {
        return [];
      }
    },

    assertNoAdditionalProperties: function assertNoAdditionalProperties(eventName, input, spec) {
      var additionalKeys = array_difference(input, spec);
      if (additionalKeys.length) {
        var message = "Additional properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
        return [{tag: 'expectedNoAdditionalProperties', additionalProperties: additionalKeys, message: message}];
      } else {
        return [];
      }
    },

    assertNoAdditionalUserProperties: function assertNoAdditionalProperties(eventName, input, spec) {
      var additionalKeys = array_difference(input, spec);
      if (additionalKeys.length) {
        var message = "Additional user properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
        return [{tag: 'expectedNoAdditionalUserProperties', additionalProperties: additionalKeys, message: message}];
      } else {
        return [];
      }
    }
  };
  
    const WebDebuggerAssertions = {
      hasKey(obj, key) {
        return obj && obj[key] != null;
      },
      assertKey(obj, key, assert) {
        if (this.hasKey(obj, key) && assert(obj[key])) {
          return true;
        } else {
          throw new Error('WebDebugger: Object key: "' + key + '" failed assertion.')
        }
      },
      assertKeys(obj, arrayOfAssertions) {
        return arrayOfAssertions.every(assertionForKey => {
          if (this.hasKey(assertionForKey, "key") && this.hasKey(assertionForKey, "assert")) {
            return this.assertKey(obj, assertionForKey.key, assertionForKey.assert);
          } else {
            throw new Error('WebDebugger: Object form for assertion invalid.');
          }
        });
      },
      assertInt(int) {
        return Number.isInteger(int);
      },
    };

    var WebDebuggerPosition = {
      position: {
        BOTTOM_RIGHT: 'BottomRight',
        BOTTOM_LEFT: 'BottomLeft',
        TOP_RIGHT: 'TopRight',
        TOP_LEFT: 'TopLeft',
      },
      BottomRight(parameters) {
        return WebDebuggerAssertions.assertKeys(
          parameters,
          [
            { key: "bottom", assert: WebDebuggerAssertions.assertInt },
            { key: "right", assert: WebDebuggerAssertions.assertInt },
          ],
        ) && {
          position: this.position.BOTTOM_RIGHT,
          bottom: parameters.bottom,
          right: parameters.right,
        };
      },
      BottomLeft(parameters) {
        return WebDebuggerAssertions.assertKeys(
          parameters,
          [
            { key: "bottom", assert: WebDebuggerAssertions.assertInt },
            { key: "left", assert: WebDebuggerAssertions.assertInt },
          ],
        ) && {
          position: this.position.BOTTOM_LEFT,
          bottom: parameters.bottom,
          left: parameters.left,
        };
      },
      TopRight(parameters) {
        return WebDebuggerAssertions.assertKeys(
          parameters,
          [
            { key: "top", assert: WebDebuggerAssertions.assertInt },
            { key: "right", assert: WebDebuggerAssertions.assertInt },
          ],
        ) && {
          position: this.position.TOP_RIGHT,
          top: parameters.top,
          right: parameters.right,
        };
      },
      TopLeft(parameters) {
        return WebDebuggerAssertions.assertKeys(
          parameters,
          [
            { key: "top", assert: WebDebuggerAssertions.assertInt },
            { key: "left", assert: WebDebuggerAssertions.assertInt },
          ],
        ) && {
          position: this.position.TOP_LEFT,
          top: parameters.top,
          left: parameters.left,
        };
      },
    }
    
  
  InternalAvoLogger = {
    logEventSent: function logEventSent(eventName, eventProperties, userProperties, groupProperties) {
      const message = "Event Sent:" + eventName + "Event Props:" + JSON.stringify(eventProperties) + "User Props:" + JSON.stringify(userProperties) + "Group Props:" + JSON.stringify(groupProperties);

      if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
        return
      }
      typeof console !== 'undefined' && console.log("[avo] Event Sent:", eventName, "Event Props:", eventProperties, "User Props:", userProperties, "Group Props:", groupProperties);
    },

    log: function log(message) {
      if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
        return
      }
      typeof console !== 'undefined' && console.log("[avo] " + message);
    },

    warn: function warn(message) {
      if (__AVO_LOGGER__ && __AVO_LOGGER__.logWarn && __AVO_LOGGER__.logWarn(__AVO_ENV__, message)) {
        return
      }
      typeof console !== 'undefined' && console.warn("[avo] " + message);
    },

    error: function error(message, error) {
      if (__AVO_LOGGER__ && __AVO_LOGGER__.logError && __AVO_LOGGER__.logError(__AVO_ENV__, message + error)) {
        return
      }
      typeof console !== 'undefined' && console.error("[avo] " + message, error);
    }
  };
  
  var _avo_invoke, _avo_invoke_meta;
var _avo_sampling_rate = 1.0;
function _avo_invoke_payload(body) {
  if (typeof window === 'undefined') { return; }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      fetch("https://api.avo.app/i", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify(body)
      }).then(function(res) { return res.json(); }).then(function(data) { _avo_sampling_rate = data.sa; }).catch(function() {});
    }
  }
}

_avo_invoke = function _avo_invoke(env, eventId, hash, messages, origin) {
  _avo_invoke_payload({
    "ac": "sovySGOrgA66IXN8kycR",
    "br": "master",
    "en": env,
    "ev": eventId,
    "ha": hash,
    "sc": "6drybyLTwHSLSiD6Yicr",
    "se": (new Date()).toISOString(),
    "so": "EhraNYm6f",
    "va": messages.length === 0,
    "me": messages,
    "or": origin
  });
}

_avo_invoke_meta = function _avo_invoke_meta(env, type, messages, origin) {
  _avo_invoke_payload({
    "ac": "sovySGOrgA66IXN8kycR",
    "br": "master",
    "en": env,
    "ty": type,
    "sc": "6drybyLTwHSLSiD6Yicr",
    "se": (new Date()).toISOString(),
    "so": "EhraNYm6f",
    "va": messages.length === 0,
    "me": messages,
    "or": origin
  });
}
  
  
  var _avo_debugger_log;
var _avo_debugger_events_during_boot = [];
var _avo_debugger_ready = false;

if (typeof window !== 'undefined') {
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    var iframe = document.getElementById("avo-debugger");
    if (iframe && event && event.data && event.data.type_ === "avo-debugger-update-style") {
      iframe.style = event.data.style;
    } else if (iframe && event && event.data && event.data.type_ === "avo-debugger-ready") {
      var message = {
        type_: "avo-debugger-boot-events",
        schemaId: "6drybyLTwHSLSiD6Yicr",
        href: window.location.href,
        events: _avo_debugger_events_during_boot
      };
      _avo_debugger_events_during_boot = [];
      _avo_debugger_ready = true;
      iframe.contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  });
}

_avo_debugger_log = function _avo_debugger_log(eventId, eventName, messages, eventProperties, userProperties, groupProperties) {
  if (typeof window === 'undefined') { return; }
  var event = {
    eventId: eventId,
    eventName: eventName,
    messages: messages,
    timestamp: Date.now(),
    eventProperties: eventProperties,
    userProperties: userProperties,
    groupProperties: groupProperties
  };

  if (_avo_debugger_ready) {
    var message = {type_: "avo-debugger-events", events: [event]};
    document.getElementById("avo-debugger").contentWindow.postMessage(message, "https://www.avo.app/_debugger")
  } else {
    _avo_debugger_events_during_boot.push(event);
  }
}

function _avo_debugger_send_position(position) {
  if (typeof window === 'undefined') { return; }
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    if (event.data.type_ === "avo-debugger-ready" && position !== null) {
      var message = {type_: "avo-debugger-position", position: position};
      document.getElementById("avo-debugger").contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  })
}
  
  
  var DiscountPitch = {
    URGENCY_DISCOUNT: "Urgency Discount",
  };
  
  var Difficulty = {
    EASY: "Easy",
    MEDIUM: "Medium",
    HARD: "Hard",
  };
  
  var State = {
    VALID: "Valid",
    EXPIRED: "Expired",
    FREE: "Free",
    LOCKED: "Locked",
  };
  
  var UserPersonaType = {
    CLASS_ONLY: "class only",
    PTL: "ptl",
  };
  
  var Source = {
    LEFT_NAV: "Left Nav",
    TAB: "Tab",
    FAB: "FAB",
    OBW: "OBW",
    CURRICULUM_WIDGET: "Curriculum Widget",
    PAGE_REFRESH: "Page Refresh",
  };
  
  var QuestionType = {
    SINGLE_SELECT: "Single Select",
    MULTI_SELECT: "Multi Select",
    MULTIMINUSSELECT_WITH_CAPPED_SELECTIONS: "Multi-Select with capped selections",
    FREE_TEXT: "Free Text",
    DROPDOWN: "Dropdown",
  };
  
  var CSVUploadStatus = {
    SUCCESS: "Success",
    FAILURE: "Failure",
    NA: "na",
  };
  
  var Grade = {
    _1: "1",
    _2: "2",
    _3: "3",
    _4: "4",
    _5: "5",
    PK: "pk",
    K: "k",
    NA: "NA",
  };
  
  var Mode = {
    SCHOOL: "school",
    HOME: "home",
    B2CHOME: "b2chome",
  };
  
  var MFAssignedTo = {
    WHOLE_CLASS: "Whole Class",
    SELECTED_STUDENTS: "Selected Students",
  };
  
  var WorksheetFilterAppliedOn = {
    L1: "L1",
    L2: "L2",
    L3: "L3",
    L4: "L4",
    L5: "L5",
    L6: "L6",
  };
  
  var EndPoint = {
    PORTAL: "Portal",
    JUNGLE: "Jungle",
    CITY: "City",
    CAFE: "Cafe",
    NIGHT_TIME_LOBBY: "Night Time Lobby",
  };
  
  var Status = {
    SUCCESS: "Success",
    FAILED: "Failed",
  };
  
  var ClickedOnCustomReportPage = {
    VIEW_RESPONSE: "View Response",
    MARK_AS_COMPLETE: "Mark as Complete",
    EDIT_TEST: "Edit Test",
    SORT_STUDENTS: "Sort Students",
  };
  
  var MathGrade = {
    _1: "1",
    _2: "2",
    _3: "3",
    _4: "4",
    _5: "5",
    PK: "pk",
    K: "k",
  };
  
  var GradeSelected = {
    PK: "pk",
    K: "k",
    _1: "1",
    _2: "2",
    _3: "3",
    _4: "4",
    _5: "5",
  };
  
  var WorksheetGrade = {
    K: "k",
    _1: "1",
    _2: "2",
    _3: "3",
    _4: "4",
    _5: "5",
  };
  
  var ReportType = {
    GRID: "Grid",
    GROUP: "Group",
  };
  
  var APISource = {
    BACKEND: "Backend",
    FRONTEND: "Frontend",
  };
  
  var ClickedOnTrackCustomPage = {
    VIEW_REPORT: "View Report",
    PRINT_WORKSHEET: "Print Worksheet",
    EDIT_TEST: "Edit Test",
    MARK_AS_COMPLETE: "Mark as Complete",
    COPY_PRACTICE_LINK: "Copy Practice Link",
    DELETE_TEST: "Delete Test",
  };
  
  var InteractionType = {
    CLICKED: "Clicked",
    SCROLLED: "Scrolled",
    HOVERED: "Hovered",
    HEARD: "Heard",
  };
  
  var Subject = {
    ELA: "ela",
    MATH: "math",
    EXTRA_CURRICULUM: "extra curriculum",
    READING: "reading",
    BOOK: "book",
  };
  
  var GameMode = {
    PWC: "pwc",
    SOLO: "solo",
    _1_V_1: "1_v_1",
  };
  
  var InteractedWith = {
    TAKE_A_TOUR: "Take a Tour",
    ILL_TAKE_IT_LATER: "I'll take it later",
  };
  
  var ScrolledThrough = {
    MULTIPLAYER_GAMES: "Multiplayer Games",
    ACTIVITIES: "Activities",
    REWARDS: "Rewards",
    FOUNDATIONAL_GAMES: "Foundational Games",
    ADVANCED_GAMES: "Advanced Games",
    LOGIC_THINKING: "Logic & Thinking",
    ART_CREATIVITY: "Art & Creativity",
    GENERAL_KNOWLEDGE: "General Knowledge",
  };
  
  var OpponentType = {
    BOT: "Bot",
    STUDENT: "Student",
  };
  
  var MFMode = {
    ADAPTIVE: "Adaptive",
    CUSTOM: "Custom",
  };
  
  var CardType = {
    CARD_TYPE_NOT_AVAILABLE: "Card Type not available",
    DEBIT: "debit",
    CREDIT: "credit",
    PREPAID: "prepaid",
  };
  
  var CustomMFOperatorSelected = {
    ADD: "Add",
    SUBTRACT: "Subtract",
    MULTIPLY: "Multiply",
    DIVIDE: "Divide",
  };
  
  var SchoolFormType = {
    US: "US",
    NON_US: "Non US",
  };
  
  var MFOperatorSelected = {
    ADDITION_SUBTRACTION: "Addition & Subtraction",
    MULTIPLICATION_DIVISION: "Multiplication & Division",
  };
  
  var ClickedOnNewMFPractice = {
    ASSIGN_ADAPTIVE_PRACTICE: "Assign Adaptive Practice",
    CREATE_CUSTOM_TEST: "Create Custom Test",
  };
  
  var PlayAgainState = {
    USER_INITIATED: "User initiated",
    OPPONENT_INITIATED: "Opponent Initiated",
    FRIENDS_JOINED: "Friends joined",
  };
  
  var ClassType = {
    GOOGLE_CLASSROOM: "Google Classroom",
    CLEVER: "Clever",
    MANUAL: "Manual",
  };
  
  var MFCustomSettingsClickedOn = {
    PRINT_WORKSHEET: "Print Worksheet",
    SELECT_STUDENTS: "Select Students",
  };
  
  var ReachedVia = {
    NEW_FACT_PRACTICE: "New Fact Practice",
    TRACK_FACT_PRACTICE: "Track Fact Practice",
  };
  
  var Winner = {
    BOT: "Bot",
    STUDENT: "Student",
  };
  
  var InteractionDetails = {
    STARTED_TYPING_CREDIT_CARD_DETAILS: "Started Typing Credit Card Details",
    STARTED_TYPING_CITY: "Started Typing City",
    STARTED_TYPING_SCHOOL: "Started Typing School",
    STOPPED_TYPING_CITY: "Stopped Typing City",
    STOPPED_TYPING_SCHOOL: "Stopped Typing School",
    SELECTED_CITY_FROM_SUGGESTIONS: "Selected city from suggestions",
    SELECTED_SCHOOL_FROM_SUGGESTIONS: "Selected school from suggestions",
    SELECTED_COUNTRY_FROM_DROPDOWN: "Selected country from dropdown",
    SELECTED_STATE_FROM_DROPDOWN: "Selected state from dropdown",
    SELECTED_GRADE_FROM_DROPDOWN: "Selected grade from dropdown",
    IMPORTED_FROM_CSV_EXCEL: "Imported from csv/excel",
    TYPED: "Typed",
    COPY_PASTED: "Copy pasted",
    SELECTED_CLASS: "Selected class",
    UNSELECTED_CLASS: "Unselected class",
    STARTED_TYPING_ZIP_CODE: "Started Typing ZIP Code",
  };
  
  var ValidSavedCardExists = {
    YES: "Yes",
    NO: "No",
  };
  
  var View = {
    WITHCROSS: "withcross",
    WITHOUTCROSS: "withoutcross",
  };
  
  var GooglePayButtonAvailable = {
    YES: "Yes",
    NO: "No",
  };
  
  var ElaGrade = {
    _1: "1",
    _2: "2",
    _3: "3",
    _4: "4",
    _5: "5",
    PK: "pk",
    K: "k",
    NA: "NA",
  };
  
  var MFPracticeQuestionsCount = {
    _20: "20",
    _30: "30",
    _40: "40",
  };
  
  var MFTimePerQuestion = {
    OFF: "Off",
    _5_SECS: "5 Secs",
    _10_SECS: "10 Secs",
    _15_SECS: "15 Secs",
    _20_SECS: "20 Secs",
  };
  
  var UserType = {
    TEACHER: "Teacher",
    PARENT: "Parent",
    GUEST_PARENT: "Guest Parent",
    STUDENT: "Student",
    GUEST_TEACHER: "Guest Teacher",
  };
  
  var SignupFlow = {
    TRIAL_CLASS_25: "trial_class_25",
    CLASSROOM_LINKED: "classroom_linked",
    STUDENT_EXPERIENCE: "student_experience",
    CLASSCODE: "classcode",
  };
  
  var ClickedOnStudentSelectionPopup = {
    ASSIGN: "Assign",
  };
  
  function assertOnlineClassmates(onlineClassmates, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("-6EWaVnSU8", label_ ? "Online Classmates" + ": " + label_ : "Online Classmates", onlineClassmates));
    return messages;
  }
  
  function assertOptionalMilestoneChanged(milestoneChanged, label_) {
    var messages = [];
    if (milestoneChanged !== undefined && milestoneChanged !== null) {
      messages = messages.concat(AvoAssert.assertString("-8NMIzT9n", label_ ? "Milestone Changed" + ": " + label_ : "Milestone Changed", milestoneChanged));
    }
    return messages;
  }
  
  function assertOptionalStripeCountry(stripeCountry, label_) {
    var messages = [];
    if (stripeCountry !== undefined && stripeCountry !== null) {
      messages = messages.concat(AvoAssert.assertString("-NRkASDdl", label_ ? "Stripe Country" + ": " + label_ : "Stripe Country", stripeCountry));
    }
    return messages;
  }
  
  function assertOptionalDiscountPitch(discountPitch, label_) {
    var messages = [];
    if (discountPitch !== undefined && discountPitch !== null) {
      messages = messages.concat(AvoAssert.assertString("-tPNSAQK6", label_ ? "Discount Pitch" + ": " + label_ : "Discount Pitch", discountPitch));
      if ("Urgency Discount" !== discountPitch) {
        var message = (label_ ? "Discount Pitch" + ": " + label_ : "Discount Pitch") + " should match one of the following values [ Urgency Discount ] but you provided the value " + discountPitch
        messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "-tPNSAQK6", message: message}]);
      }
    }
    return messages;
  }
  
  function assertOptionalRecommendedPlayableCode(recommendedPlayableCode, label_) {
    var messages = [];
    if (recommendedPlayableCode !== undefined && recommendedPlayableCode !== null) {
      messages = messages.concat(AvoAssert.assertList("09LOni_Ki3", "Recommended Playable Code", recommendedPlayableCode));
      recommendedPlayableCode.forEach(function (value, index) {
      });
    }
    return messages;
  }
  
  function assertPagesRead(pagesRead, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("09yl86H3gLOygFRleu5dh", label_ ? "Pages Read" + ": " + label_ : "Pages Read", pagesRead));
    return messages;
  }
  
  function assertCurrentDatePickerView(currentDatePickerView, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("0S4aBLQG_", label_ ? "Current Date Picker View" + ": " + label_ : "Current Date Picker View", currentDatePickerView));
    return messages;
  }
  
  function assertFromDate(fromDate, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("0U9QBn95C", label_ ? "From Date" + ": " + label_ : "From Date", fromDate));
    return messages;
  }
  
  function assertOptionalFromDate(fromDate, label_) {
    var messages = [];
    if (fromDate !== undefined && fromDate !== null) {
      messages = messages.concat(AvoAssert.assertString("0U9QBn95C", label_ ? "From Date" + ": " + label_ : "From Date", fromDate));
    }
    return messages;
  }
  
  function assertNotificationSource(notificationSource, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("0zT29qODq6yxzJjbmuRzz", label_ ? "Notification Source" + ": " + label_ : "Notification Source", notificationSource));
    return messages;
  }
  
  function assertSelectedTopics(selectedTopics, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("0zw-Zh02K", label_ ? "Selected Topics" + ": " + label_ : "Selected Topics", selectedTopics));
    return messages;
  }
  
  function assertOptionalDifficulty(difficulty, label_) {
    var messages = [];
    if (difficulty !== undefined && difficulty !== null) {
      messages = messages.concat(AvoAssert.assertString("12tG17N4vG", label_ ? "Difficulty" + ": " + label_ : "Difficulty", difficulty));
      if ("Easy" !== difficulty &&
          "Medium" !== difficulty &&
          "Hard" !== difficulty) {
        var message = (label_ ? "Difficulty" + ": " + label_ : "Difficulty") + " should match one of the following values [ Easy | Medium | Hard ] but you provided the value " + difficulty
        messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "12tG17N4vG", message: message}]);
      }
    }
    return messages;
  }
  
  function assertOptionalNumberOfCollectionsSelected(numberOfCollectionsSelected, label_) {
    var messages = [];
    if (numberOfCollectionsSelected !== undefined && numberOfCollectionsSelected !== null) {
      messages = messages.concat(AvoAssert.assertInt("13ZQ1yCAS", label_ ? "Number of Collections Selected" + ": " + label_ : "Number of Collections Selected", numberOfCollectionsSelected));
    }
    return messages;
  }
  
  function assertState(state, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("19zWDg2Ccm", label_ ? "State" + ": " + label_ : "State", state));
    if ("Valid" !== state &&
        "Expired" !== state &&
        "Free" !== state &&
        "Locked" !== state) {
      var message = (label_ ? "State" + ": " + label_ : "State") + " should match one of the following values [ Valid | Expired | Free | Locked ] but you provided the value " + state
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "19zWDg2Ccm", message: message}]);
    }
    return messages;
  }
  
  function assertOptionalQuestionNo(questionNo, label_) {
    var messages = [];
    if (questionNo !== undefined && questionNo !== null) {
      messages = messages.concat(AvoAssert.assertString("1BxvMk6Nz6", label_ ? "Question No." + ": " + label_ : "Question No.", questionNo));
    }
    return messages;
  }
  
  function assertRail2Interacted(rail2Interacted, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("1Hjsl9j-e", label_ ? "Rail 2 Interacted" + ": " + label_ : "Rail 2 Interacted", rail2Interacted));
    return messages;
  }
  
  function assertOptionalTopicName(topicName, label_) {
    var messages = [];
    if (topicName !== undefined && topicName !== null) {
      messages = messages.concat(AvoAssert.assertString("1Yc2cQ5iyN", label_ ? "Topic Name" + ": " + label_ : "Topic Name", topicName));
    }
    return messages;
  }
  
  function assertCountOfOnlineFriends(countOfOnlineFriends, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("1hgGFRPeiA", label_ ? "Count of online friends" + ": " + label_ : "Count of online friends", countOfOnlineFriends));
    return messages;
  }
  
  function assertStepValue(stepValue, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("1kYllRnFw", label_ ? "Step value" + ": " + label_ : "Step value", stepValue));
    return messages;
  }
  
  function assertErrorMessage(errorMessage, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("1n3Bq4GKWy", label_ ? "Error Message" + ": " + label_ : "Error Message", errorMessage));
    return messages;
  }
  
  function assertOptionalErrorMessage(errorMessage, label_) {
    var messages = [];
    if (errorMessage !== undefined && errorMessage !== null) {
      messages = messages.concat(AvoAssert.assertString("1n3Bq4GKWy", label_ ? "Error Message" + ": " + label_ : "Error Message", errorMessage));
    }
    return messages;
  }
  
  function assertPurchaseClickID(purchaseClickId, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("1sxa4mA1P", label_ ? "Purchase Click ID" + ": " + label_ : "Purchase Click ID", purchaseClickId));
    return messages;
  }
  
  function assertUserPersonaType(userPersonaType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("1z9szfE-j", label_ ? "User Persona Type" + ": " + label_ : "User Persona Type", userPersonaType));
    if ("class only" !== userPersonaType &&
        "ptl" !== userPersonaType) {
      var message = (label_ ? "User Persona Type" + ": " + label_ : "User Persona Type") + " should match one of the following values [ class only | ptl ] but you provided the value " + userPersonaType
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "1z9szfE-j", message: message}]);
    }
    return messages;
  }
  
  function assertSource(source, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("293juZE8KT", label_ ? "Source" + ": " + label_ : "Source", source));
    if ("Left Nav" !== source &&
        "Tab" !== source &&
        "FAB" !== source &&
        "OBW" !== source &&
        "Curriculum Widget" !== source &&
        "Page Refresh" !== source) {
      var message = (label_ ? "Source" + ": " + label_ : "Source") + " should match one of the following values [ Left Nav | Tab | FAB | OBW | Curriculum Widget | Page Refresh ] but you provided the value " + source
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "293juZE8KT", message: message}]);
    }
    return messages;
  }
  
  function assertOptionalPercentClassInvited(percentClassInvited, label_) {
    var messages = [];
    if (percentClassInvited !== undefined && percentClassInvited !== null) {
      messages = messages.concat(AvoAssert.assertString("2Q7hpPm9y", label_ ? "Percent Class Invited" + ": " + label_ : "Percent Class Invited", percentClassInvited));
    }
    return messages;
  }
  
  function assertPercentClassInvited(percentClassInvited, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("2Q7hpPm9y", label_ ? "Percent Class Invited" + ": " + label_ : "Percent Class Invited", percentClassInvited));
    return messages;
  }
  
  function assertGameType(gameType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("2da5NLAEc", label_ ? "Game Type" + ": " + label_ : "Game Type", gameType));
    return messages;
  }
  
  function assertOptionalGameType(gameType, label_) {
    var messages = [];
    if (gameType !== undefined && gameType !== null) {
      messages = messages.concat(AvoAssert.assertString("2da5NLAEc", label_ ? "Game Type" + ": " + label_ : "Game Type", gameType));
    }
    return messages;
  }
  
  function assertTotalMemory(totalMemory, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertFloat("2hMTTBgU30", label_ ? "Total Memory" + ": " + label_ : "Total Memory", totalMemory));
    return messages;
  }
  
  function assertDBPaidUser(dbPaidUser, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("2j7_L0vfh", label_ ? "DB Paid User" + ": " + label_ : "DB Paid User", dbPaidUser));
    return messages;
  }
  
  function assertOptionalGameCode(gameCode, label_) {
    var messages = [];
    if (gameCode !== undefined && gameCode !== null) {
      messages = messages.concat(AvoAssert.assertString("2oZQdvXRu", label_ ? "Game Code" + ": " + label_ : "Game Code", gameCode));
    }
    return messages;
  }
  
  function assertGameCode(gameCode, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("2oZQdvXRu", label_ ? "Game Code" + ": " + label_ : "Game Code", gameCode));
    return messages;
  }
  
  function assertQuestionType(questionType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("2pLBcf4Iyi", label_ ? "Question Type" + ": " + label_ : "Question Type", questionType));
    if ("Single Select" !== questionType &&
        "Multi Select" !== questionType &&
        "Multi-Select with capped selections" !== questionType &&
        "Free Text" !== questionType &&
        "Dropdown" !== questionType) {
      var message = (label_ ? "Question Type" + ": " + label_ : "Question Type") + " should match one of the following values [ Single Select | Multi Select | Multi-Select with capped selections | Free Text | Dropdown ] but you provided the value " + questionType
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "2pLBcf4Iyi", message: message}]);
    }
    return messages;
  }
  
  function assertSnSpent(snSpent, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("2rctRWE0j", label_ ? "Sn Spent" + ": " + label_ : "Sn Spent", snSpent));
    return messages;
  }
  
  function assertTileStrClickedCount(tileStrClickedCount, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("33JWk0cGdkpH6MbvcXKfL", label_ ? "Tile Str Clicked Count" + ": " + label_ : "Tile Str Clicked Count", tileStrClickedCount));
    return messages;
  }
  
  function assertOptionalCSVUploadStatus(csvUploadStatus, label_) {
    var messages = [];
    if (csvUploadStatus !== undefined && csvUploadStatus !== null) {
      messages = messages.concat(AvoAssert.assertString("35LO2FVxA", label_ ? "CSV Upload Status" + ": " + label_ : "CSV Upload Status", csvUploadStatus));
      if ("Success" !== csvUploadStatus &&
          "Failure" !== csvUploadStatus &&
          "na" !== csvUploadStatus) {
        var message = (label_ ? "CSV Upload Status" + ": " + label_ : "CSV Upload Status") + " should match one of the following values [ Success | Failure | na ] but you provided the value " + csvUploadStatus
        messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "35LO2FVxA", message: message}]);
      }
    }
    return messages;
  }
  
  function assertGrade(grade, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("3LbQtKEdjc", label_ ? "Grade" + ": " + label_ : "Grade", grade));
    if ("1" !== grade &&
        "2" !== grade &&
        "3" !== grade &&
        "4" !== grade &&
        "5" !== grade &&
        "pk" !== grade &&
        "k" !== grade &&
        "NA" !== grade) {
      var message = (label_ ? "Grade" + ": " + label_ : "Grade") + " should match one of the following values [ 1 | 2 | 3 | 4 | 5 | pk | k | NA ] but you provided the value " + grade
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "3LbQtKEdjc", message: message}]);
    }
    return messages;
  }
  
  function assertOptionalGrade(grade, label_) {
    var messages = [];
    if (grade !== undefined && grade !== null) {
      messages = messages.concat(AvoAssert.assertString("3LbQtKEdjc", label_ ? "Grade" + ": " + label_ : "Grade", grade));
      if ("1" !== grade &&
          "2" !== grade &&
          "3" !== grade &&
          "4" !== grade &&
          "5" !== grade &&
          "pk" !== grade &&
          "k" !== grade &&
          "NA" !== grade) {
        var message = (label_ ? "Grade" + ": " + label_ : "Grade") + " should match one of the following values [ 1 | 2 | 3 | 4 | 5 | pk | k | NA ] but you provided the value " + grade
        messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "3LbQtKEdjc", message: message}]);
      }
    }
    return messages;
  }
  
  function assertOptionalStripePaymentMethodInfo(stripePaymentMethodInfo, label_) {
    var messages = [];
    if (stripePaymentMethodInfo !== undefined && stripePaymentMethodInfo !== null) {
      messages = messages.concat(AvoAssert.assertString("3kx20gfYw", label_ ? "Stripe Payment Method Info" + ": " + label_ : "Stripe Payment Method Info", stripePaymentMethodInfo));
    }
    return messages;
  }
  
  function assertHairColour(hairColour, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("3o26B0SjY", label_ ? "Hair Colour" + ": " + label_ : "Hair Colour", hairColour));
    return messages;
  }
  
  function assertMode(mode, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("3pg8bY1LfC", label_ ? "Mode" + ": " + label_ : "Mode", mode));
    if ("school" !== mode &&
        "home" !== mode &&
        "b2chome" !== mode) {
      var message = (label_ ? "Mode" + ": " + label_ : "Mode") + " should match one of the following values [ school | home | b2chome ] but you provided the value " + mode
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "3pg8bY1LfC", message: message}]);
    }
    return messages;
  }
  
  function assertNudgeShownOnPage(nudgeShownOnPage, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("3ysDI0za_", label_ ? "Nudge Shown on Page" + ": " + label_ : "Nudge Shown on Page", nudgeShownOnPage));
    return messages;
  }
  
  function assertMFAssignedTo(mfAssignedTo, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("4BthSPAer", label_ ? "MF Assigned To" + ": " + label_ : "MF Assigned To", mfAssignedTo));
    if ("Whole Class" !== mfAssignedTo &&
        "Selected Students" !== mfAssignedTo) {
      var message = (label_ ? "MF Assigned To" + ": " + label_ : "MF Assigned To") + " should match one of the following values [ Whole Class | Selected Students ] but you provided the value " + mfAssignedTo
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "4BthSPAer", message: message}]);
    }
    return messages;
  }
  
  function assertCertificatesEarned(certificatesEarned, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("4DPFLSCCa", label_ ? "Certificates Earned" + ": " + label_ : "Certificates Earned", certificatesEarned));
    return messages;
  }
  
  function assertPopupType(popupType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("4JcpJcKm5", label_ ? "Popup Type" + ": " + label_ : "Popup Type", popupType));
    return messages;
  }
  
  function assertAssignmentDueInDays(assignmentDueInDays, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("4M0W7L2cW", label_ ? "Assignment Due in Days" + ": " + label_ : "Assignment Due in Days", assignmentDueInDays));
    return messages;
  }
  
  function assertOptionalOrdering(ordering, label_) {
    var messages = [];
    if (ordering !== undefined && ordering !== null) {
      messages = messages.concat(AvoAssert.assertInt("4YcQJt7EU", label_ ? "Ordering" + ": " + label_ : "Ordering", ordering));
    }
    return messages;
  }
  
  function assertOrdering(ordering, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("4YcQJt7EU", label_ ? "Ordering" + ": " + label_ : "Ordering", ordering));
    return messages;
  }
  
  function assertWorksheetFilterAppliedOn(worksheetFilterAppliedOn, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("4bmBhSOqz4", label_ ? "Worksheet Filter Applied On" + ": " + label_ : "Worksheet Filter Applied On", worksheetFilterAppliedOn));
    if ("L1" !== worksheetFilterAppliedOn &&
        "L2" !== worksheetFilterAppliedOn &&
        "L3" !== worksheetFilterAppliedOn &&
        "L4" !== worksheetFilterAppliedOn &&
        "L5" !== worksheetFilterAppliedOn &&
        "L6" !== worksheetFilterAppliedOn) {
      var message = (label_ ? "Worksheet Filter Applied On" + ": " + label_ : "Worksheet Filter Applied On") + " should match one of the following values [ L1 | L2 | L3 | L4 | L5 | L6 ] but you provided the value " + worksheetFilterAppliedOn
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "4bmBhSOqz4", message: message}]);
    }
    return messages;
  }
  
  function assertFiredFrom(firedFrom, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("4e2iM_rBA", label_ ? "Fired From" + ": " + label_ : "Fired From", firedFrom));
    return messages;
  }
  
  function assertSessionIdentifier(sessionIdentifier, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("4uNrPBulmW", label_ ? "session_identifier" + ": " + label_ : "session_identifier", sessionIdentifier));
    return messages;
  }
  
  function assertTimesViewed(timesViewed, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("55lAHL7kM", label_ ? "Times Viewed" + ": " + label_ : "Times Viewed", timesViewed));
    return messages;
  }
  
  function assertDBGenerationSource(dbGenerationSource, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("5AVoY71YG", label_ ? "DB Generation Source" + ": " + label_ : "DB Generation Source", dbGenerationSource));
    return messages;
  }
  
  function assertOptionalStudentID(studentId, label_) {
    var messages = [];
    if (studentId !== undefined && studentId !== null) {
      messages = messages.concat(AvoAssert.assertList("5IEpaITD9", "Student ID", studentId));
      studentId.forEach(function (value, index) {
      });
    }
    return messages;
  }
  
  function assertCountOfSearchResults(countOfSearchResults, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("5OAHrQIZt", label_ ? "Count of Search Results" + ": " + label_ : "Count of Search Results", countOfSearchResults));
    return messages;
  }
  
  function assertSmLoadedSuccessfully(smLoadedSuccessfully, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("5z8RzmY9J", label_ ? "Sm Loaded Successfully" + ": " + label_ : "Sm Loaded Successfully", smLoadedSuccessfully));
    return messages;
  }
  
  function assertProductSelectionFlow(productSelectionFlow, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("66B3Sc44X", label_ ? "Product Selection Flow" + ": " + label_ : "Product Selection Flow", productSelectionFlow));
    return messages;
  }
  
  function assertQuestType(questType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("6JT-uGIorzYZLeLKXO-mB", label_ ? "Quest Type" + ": " + label_ : "Quest Type", questType));
    return messages;
  }
  
  function assertOptionalDashboardVersion(dashboardVersion, label_) {
    var messages = [];
    if (dashboardVersion !== undefined && dashboardVersion !== null) {
      messages = messages.concat(AvoAssert.assertString("6QT3mtqEUD", label_ ? "Dashboard Version" + ": " + label_ : "Dashboard Version", dashboardVersion));
    }
    return messages;
  }
  
  function assertEndPoint(endPoint, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("6R8Dsubm7", label_ ? "End Point" + ": " + label_ : "End Point", endPoint));
    if ("Portal" !== endPoint &&
        "Jungle" !== endPoint &&
        "City" !== endPoint &&
        "Cafe" !== endPoint &&
        "Night Time Lobby" !== endPoint) {
      var message = (label_ ? "End Point" + ": " + label_ : "End Point") + " should match one of the following values [ Portal | Jungle | City | Cafe | Night Time Lobby ] but you provided the value " + endPoint
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "6R8Dsubm7", message: message}]);
    }
    return messages;
  }
  
  function assertClickedOnStep(clickedOnStep, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("6k1AQb1jR", label_ ? "Clicked on Step" + ": " + label_ : "Clicked on Step", clickedOnStep));
    return messages;
  }
  
  function assertRecommendedRailName(recommendedRailName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertList("6lrsWYY5Y", "Recommended Rail Name", recommendedRailName));
    if (recommendedRailName !== null && recommendedRailName !== undefined && recommendedRailName.forEach) {
      recommendedRailName.forEach(function (value, index) {
      });
    }
    return messages;
  }
  
  function assertOptionalRecommendedRailName(recommendedRailName, label_) {
    var messages = [];
    if (recommendedRailName !== undefined && recommendedRailName !== null) {
      messages = messages.concat(AvoAssert.assertList("6lrsWYY5Y", "Recommended Rail Name", recommendedRailName));
      recommendedRailName.forEach(function (value, index) {
      });
    }
    return messages;
  }
  
  function assertTileStrStartedCount(tileStrStartedCount, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("72Hz7CelRpVYf1warHrRP", label_ ? "Tile Str Started Count" + ": " + label_ : "Tile Str Started Count", tileStrStartedCount));
    return messages;
  }
  
  function assertFrameColour(frameColour, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("7HDxveLB0", label_ ? "Frame Colour" + ": " + label_ : "Frame Colour", frameColour));
    return messages;
  }
  
  function assertPurchaseSource(purchaseSource, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("7J3z9wrkRMnQgFFbo9-g-", label_ ? "Purchase Source" + ": " + label_ : "Purchase Source", purchaseSource));
    return messages;
  }
  
  function assertTabStrClickedCount(tabStrClickedCount, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("7PQh3G9ITCcMDMNeMTM8q", label_ ? "Tab Str Clicked Count" + ": " + label_ : "Tab Str Clicked Count", tabStrClickedCount));
    return messages;
  }
  
  function assertCountOfForSaleItems(countOfForSaleItems, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("7TW4Q4Izl", label_ ? "Count of for Sale Items" + ": " + label_ : "Count of for Sale Items", countOfForSaleItems));
    return messages;
  }
  
  function assertAssignmentGrade(assignmentGrade, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("7d3MiAKT4oiit-t-kjZ6R", label_ ? "Assignment Grade" + ": " + label_ : "Assignment Grade", assignmentGrade));
    return messages;
  }
  
  function assertAPIStatus(apiStatus, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("7e4uFkiW6", label_ ? "API Status" + ": " + label_ : "API Status", apiStatus));
    return messages;
  }
  
  function assertHoveredOver(hoveredOver, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("7wbK1QRC0", label_ ? "Hovered Over" + ": " + label_ : "Hovered Over", hoveredOver));
    return messages;
  }
  
  function assertOptionalNextPlayableCode(nextPlayableCode, label_) {
    var messages = [];
    if (nextPlayableCode !== undefined && nextPlayableCode !== null) {
      messages = messages.concat(AvoAssert.assertString("88sHuVDRp", label_ ? "Next Playable Code" + ": " + label_ : "Next Playable Code", nextPlayableCode));
    }
    return messages;
  }
  
  function assertOptionalPlanAmount(planAmount, label_) {
    var messages = [];
    if (planAmount !== undefined && planAmount !== null) {
      messages = messages.concat(AvoAssert.assertInt("8ATWzSmrM", label_ ? "Plan Amount" + ": " + label_ : "Plan Amount", planAmount));
    }
    return messages;
  }
  
  function assertTabName(tabName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("8Mz1CdVTk", label_ ? "Tab Name" + ": " + label_ : "Tab Name", tabName));
    return messages;
  }
  
  function assertOptionalTabName(tabName, label_) {
    var messages = [];
    if (tabName !== undefined && tabName !== null) {
      messages = messages.concat(AvoAssert.assertString("8Mz1CdVTk", label_ ? "Tab Name" + ": " + label_ : "Tab Name", tabName));
    }
    return messages;
  }
  
  function assertPitstopType(pitstopType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("8Vq9HABFDQ", label_ ? "Pitstop Type" + ": " + label_ : "Pitstop Type", pitstopType));
    return messages;
  }
  
  function assertRailPosition(railPosition, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("8kx_PUpkb", label_ ? "Rail Position" + ": " + label_ : "Rail Position", railPosition));
    return messages;
  }
  
  function assertMFPracticeDaysCount(mfPracticeDaysCount, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertList("8mj3Kb8zsO", "MF Practice Days Count", mfPracticeDaysCount));
    if (mfPracticeDaysCount !== null && mfPracticeDaysCount !== undefined && mfPracticeDaysCount.forEach) {
      mfPracticeDaysCount.forEach(function (value, index) {
        messages = messages.concat(AvoAssert.assertInt("8mj3Kb8zsO", "item at index " + index + " in MF Practice Days Count", value));
        messages = messages.concat(AvoAssert.assertMin("8mj3Kb8zsO", label_ ? "item at index " + index + " in MF Practice Days Count" + ": " + label_ : "item at index " + index + " in MF Practice Days Count", 1, value));
        messages = messages.concat(AvoAssert.assertInt("8mj3Kb8zsO", "item at index " + index + " in MF Practice Days Count", value));
        messages = messages.concat(AvoAssert.assertMax("8mj3Kb8zsO", label_ ? "item at index " + index + " in MF Practice Days Count" + ": " + label_ : "item at index " + index + " in MF Practice Days Count", 7, value));
      });
    }
    return messages;
  }
  
  function assertIsPersonalised(isPersonalised, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("8n1iVKkl7", label_ ? "Is Personalised" + ": " + label_ : "Is Personalised", isPersonalised));
    return messages;
  }
  
  function assertStatus(status, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("9_Al8_kuam", label_ ? "Status" + ": " + label_ : "Status", status));
    if ("Success" !== status &&
        "Failed" !== status) {
      var message = (label_ ? "Status" + ": " + label_ : "Status") + " should match one of the following values [ Success | Failed ] but you provided the value " + status
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "9_Al8_kuam", message: message}]);
    }
    return messages;
  }
  
  function assertClassName(className, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("9dTrjsxjG", label_ ? "Class Name" + ": " + label_ : "Class Name", className));
    return messages;
  }
  
  function assertOptionalMathGoal(mathGoal, label_) {
    var messages = [];
    if (mathGoal !== undefined && mathGoal !== null) {
      messages = messages.concat(AvoAssert.assertString("9dh_jBFOn", label_ ? "Math Goal" + ": " + label_ : "Math Goal", mathGoal));
    }
    return messages;
  }
  
  function assertOptionalCardStatus(cardStatus, label_) {
    var messages = [];
    if (cardStatus !== undefined && cardStatus !== null) {
      messages = messages.concat(AvoAssert.assertString("9q8Cz_SQv", label_ ? "Card Status" + ": " + label_ : "Card Status", cardStatus));
    }
    return messages;
  }
  
  function assertClickedOnCustomReportPage(clickedOnCustomReportPage, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("9xTjWsrhLS", label_ ? "Clicked on- Custom Report Page" + ": " + label_ : "Clicked on- Custom Report Page", clickedOnCustomReportPage));
    if ("View Response" !== clickedOnCustomReportPage &&
        "Mark as Complete" !== clickedOnCustomReportPage &&
        "Edit Test" !== clickedOnCustomReportPage &&
        "Sort Students" !== clickedOnCustomReportPage) {
      var message = (label_ ? "Clicked on- Custom Report Page" + ": " + label_ : "Clicked on- Custom Report Page") + " should match one of the following values [ View Response | Mark as Complete | Edit Test | Sort Students ] but you provided the value " + clickedOnCustomReportPage
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "9xTjWsrhLS", message: message}]);
    }
    return messages;
  }
  
  function assertJoinEnabled(joinEnabled, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("A-lFlAcNj", label_ ? "Join Enabled" + ": " + label_ : "Join Enabled", joinEnabled));
    return messages;
  }
  
  function assertOptionalRecommendedMilestone(recommendedMilestone, label_) {
    var messages = [];
    if (recommendedMilestone !== undefined && recommendedMilestone !== null) {
      messages = messages.concat(AvoAssert.assertInt("ACsEf3MYO", label_ ? "Recommended Milestone" + ": " + label_ : "Recommended Milestone", recommendedMilestone));
    }
    return messages;
  }
  
  function assertMemoryLimit(memoryLimit, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertFloat("ADfS21LlJH", label_ ? "Memory Limit" + ": " + label_ : "Memory Limit", memoryLimit));
    return messages;
  }
  
  function assertRailStrCompletedCount(railStrCompletedCount, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("AFC3Xnyx0vxpH2PWZIjdO", label_ ? "Rail Str Completed Count" + ": " + label_ : "Rail Str Completed Count", railStrCompletedCount));
    return messages;
  }
  
  function assertReadingMode(readingMode, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("AWdUIbzg1", label_ ? "Reading Mode" + ": " + label_ : "Reading Mode", readingMode));
    return messages;
  }
  
  function assertWeeksSinceLatestReportingWeek(weeksSinceLatestReportingWeek, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("AdKRXxQJd", label_ ? "Weeks Since Latest Reporting Week" + ": " + label_ : "Weeks Since Latest Reporting Week", weeksSinceLatestReportingWeek));
    return messages;
  }
  
  function assertSearchResultType(searchResultType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("AeBTQBXi0", label_ ? "Search Result Type" + ": " + label_ : "Search Result Type", searchResultType));
    return messages;
  }
  
  function assertOptionalPaymentElementsRendered(paymentElementsRendered, label_) {
    var messages = [];
    if (paymentElementsRendered !== undefined && paymentElementsRendered !== null) {
      messages = messages.concat(AvoAssert.assertString("AjgnWgaBe", label_ ? "Payment Elements Rendered" + ": " + label_ : "Payment Elements Rendered", paymentElementsRendered));
    }
    return messages;
  }
  
  function assertRail1Interacted(rail1Interacted, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("ArTZFw0C7", label_ ? "Rail 1 Interacted" + ": " + label_ : "Rail 1 Interacted", rail1Interacted));
    return messages;
  }
  
  function assertAvailableCategories(availableCategories, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("AyInbeAyU", label_ ? "Available Categories" + ": " + label_ : "Available Categories", availableCategories));
    return messages;
  }
  
  function assertCgPack(cgPack, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("BTWKtfoSCfAut3FUrYeuT", label_ ? "Cg Pack" + ": " + label_ : "Cg Pack", cgPack));
    return messages;
  }
  
  function assertMathGrade(mathGrade, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("BaOSrmfa3A", label_ ? "Math Grade" + ": " + label_ : "Math Grade", mathGrade));
    if ("1" !== mathGrade &&
        "2" !== mathGrade &&
        "3" !== mathGrade &&
        "4" !== mathGrade &&
        "5" !== mathGrade &&
        "pk" !== mathGrade &&
        "k" !== mathGrade) {
      var message = (label_ ? "Math Grade" + ": " + label_ : "Math Grade") + " should match one of the following values [ 1 | 2 | 3 | 4 | 5 | pk | k ] but you provided the value " + mathGrade
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "BaOSrmfa3A", message: message}]);
    }
    return messages;
  }
  
  function assertCoqBasedPersona(coqBasedPersona, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("Bb6PCfOO6", label_ ? "Coq Based Persona" + ": " + label_ : "Coq Based Persona", coqBasedPersona));
    return messages;
  }
  
  function assertRecommendationSubVersionName(recommendationSubVersionName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("BchWbNpV0WYRnYxTnBQ-c", label_ ? "Recommendation Sub Version Name" + ": " + label_ : "Recommendation Sub Version Name", recommendationSubVersionName));
    return messages;
  }
  
  function assertMilestoneCode(milestoneCode, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("Bx_g6ZB1b", label_ ? "Milestone Code" + ": " + label_ : "Milestone Code", milestoneCode));
    return messages;
  }
  
  function assertTapType(tapType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("CG846K8Ql", label_ ? "Tap Type" + ": " + label_ : "Tap Type", tapType));
    return messages;
  }
  
  function assertOptionalSetupIntentStatus(setupIntentStatus, label_) {
    var messages = [];
    if (setupIntentStatus !== undefined && setupIntentStatus !== null) {
      messages = messages.concat(AvoAssert.assertString("CGZP6dYmm", label_ ? "Setup Intent Status" + ": " + label_ : "Setup Intent Status", setupIntentStatus));
    }
    return messages;
  }
  
  function assertNudgeTitleMessage(nudgeTitleMessage, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("CLVHX-1DH", label_ ? "Nudge Title Message" + ": " + label_ : "Nudge Title Message", nudgeTitleMessage));
    return messages;
  }
  
  function assertOptionalPaypalCountry(paypalCountry, label_) {
    var messages = [];
    if (paypalCountry !== undefined && paypalCountry !== null) {
      messages = messages.concat(AvoAssert.assertString("CNxDRbOnm", label_ ? "Paypal Country" + ": " + label_ : "Paypal Country", paypalCountry));
    }
    return messages;
  }
  
  function assertPendingMemory(pendingMemory, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("C_BFBZn2V", label_ ? "Pending Memory" + ": " + label_ : "Pending Memory", pendingMemory));
    return messages;
  }
  
  function assertOptionalPendingMemory(pendingMemory, label_) {
    var messages = [];
    if (pendingMemory !== undefined && pendingMemory !== null) {
      messages = messages.concat(AvoAssert.assertString("C_BFBZn2V", label_ ? "Pending Memory" + ": " + label_ : "Pending Memory", pendingMemory));
    }
    return messages;
  }
  
  function assertLOName(loName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("CdbCi-2yB", label_ ? "LO Name" + ": " + label_ : "LO Name", loName));
    return messages;
  }
  
  function assertRecommendedVia(recommendedVia, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("CptvN7aTfWej4MrTLiZsM", label_ ? "Recommended Via" + ": " + label_ : "Recommended Via", recommendedVia));
    return messages;
  }
  
  function assertPlayablePath(playablePath, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("CxhubqT3Hp", label_ ? "Playable Path" + ": " + label_ : "Playable Path", playablePath));
    return messages;
  }
  
  function assertStateMachineTid(stateMachineTid, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("D325IngkY", label_ ? "State Machine Tid" + ": " + label_ : "State Machine Tid", stateMachineTid));
    return messages;
  }
  
  function assertClassSchoolYear(classSchoolYear, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("DFN7pb5A8", label_ ? "Class School Year" + ": " + label_ : "Class School Year", classSchoolYear));
    return messages;
  }
  
  function assertEventName(eventName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertList("DmZydOAXd", "Event Name", eventName));
    if (eventName !== null && eventName !== undefined && eventName.forEach) {
      eventName.forEach(function (value, index) {
      });
    }
    return messages;
  }
  
  function assertCustomisedLp(customisedLp, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("EGScs-yrX", label_ ? "Customised Lp" + ": " + label_ : "Customised Lp", customisedLp));
    return messages;
  }
  
  function assertEyeShape(eyeShape, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("EKclsunCv", label_ ? "Eye Shape" + ": " + label_ : "Eye Shape", eyeShape));
    return messages;
  }
  
  function assertFrom(from, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("ENjG288F1l", label_ ? "From" + ": " + label_ : "From", from));
    return messages;
  }
  
  function assertOptionalFrom(from, label_) {
    var messages = [];
    if (from !== undefined && from !== null) {
      messages = messages.concat(AvoAssert.assertString("ENjG288F1l", label_ ? "From" + ": " + label_ : "From", from));
    }
    return messages;
  }
  
  function assertQuizSubject(quizSubject, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("El8KEuVMR", label_ ? "Quiz Subject" + ": " + label_ : "Quiz Subject", quizSubject));
    return messages;
  }
  
  function assertQuestion(question, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("EsalTilTi7", label_ ? "Question" + ": " + label_ : "Question", question));
    return messages;
  }
  
  function assertBlushStyle(blushStyle, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("FCvVNF6GY", label_ ? "Blush Style" + ": " + label_ : "Blush Style", blushStyle));
    return messages;
  }
  
  function assertRecommendationVersionName(recommendationVersionName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("FH6REXldlxqxCPK0pvsML", label_ ? "Recommendation Version Name" + ": " + label_ : "Recommendation Version Name", recommendationVersionName));
    return messages;
  }
  
  function assertRecommendedTileRank(recommendedTileRank, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertList("FLDtSJNKL", "Recommended Tile Rank", recommendedTileRank));
    if (recommendedTileRank !== null && recommendedTileRank !== undefined && recommendedTileRank.forEach) {
      recommendedTileRank.forEach(function (value, index) {
      });
    }
    return messages;
  }
  
  function assertOptionalRecommendedTileRank(recommendedTileRank, label_) {
    var messages = [];
    if (recommendedTileRank !== undefined && recommendedTileRank !== null) {
      messages = messages.concat(AvoAssert.assertList("FLDtSJNKL", "Recommended Tile Rank", recommendedTileRank));
      recommendedTileRank.forEach(function (value, index) {
      });
    }
    return messages;
  }
  
  function assertTimerValue(timerValue, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("FQr65Ct5y", label_ ? "Timer Value" + ": " + label_ : "Timer Value", timerValue));
    return messages;
  }
  
  function assertOptionalOptionsSelected(optionsSelected, label_) {
    var messages = [];
    if (optionsSelected !== undefined && optionsSelected !== null) {
      messages = messages.concat(AvoAssert.assertList("FZg42lPcF", "Options Selected", optionsSelected));
      optionsSelected.forEach(function (value, index) {
      });
    }
    return messages;
  }
  
  function assertOptionsSelected(optionsSelected, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertList("FZg42lPcF", "Options Selected", optionsSelected));
    if (optionsSelected !== null && optionsSelected !== undefined && optionsSelected.forEach) {
      optionsSelected.forEach(function (value, index) {
      });
    }
    return messages;
  }
  
  function assertOptionalLiveClassName(liveClassName, label_) {
    var messages = [];
    if (liveClassName !== undefined && liveClassName !== null) {
      messages = messages.concat(AvoAssert.assertString("F__odFSVZ", label_ ? "Live Class Name" + ": " + label_ : "Live Class Name", liveClassName));
    }
    return messages;
  }
  
  function assertLiveClassName(liveClassName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("F__odFSVZ", label_ ? "Live Class Name" + ": " + label_ : "Live Class Name", liveClassName));
    return messages;
  }
  
  function assertOptionalGradeSelected(gradeSelected, label_) {
    var messages = [];
    if (gradeSelected !== undefined && gradeSelected !== null) {
      messages = messages.concat(AvoAssert.assertString("Fcl7PSdr4", label_ ? "Grade Selected" + ": " + label_ : "Grade Selected", gradeSelected));
      if ("pk" !== gradeSelected &&
          "k" !== gradeSelected &&
          "1" !== gradeSelected &&
          "2" !== gradeSelected &&
          "3" !== gradeSelected &&
          "4" !== gradeSelected &&
          "5" !== gradeSelected) {
        var message = (label_ ? "Grade Selected" + ": " + label_ : "Grade Selected") + " should match one of the following values [ pk | k | 1 | 2 | 3 | 4 | 5 ] but you provided the value " + gradeSelected
        messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "Fcl7PSdr4", message: message}]);
      }
    }
    return messages;
  }
  
  function assertGradeSelected(gradeSelected, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("Fcl7PSdr4", label_ ? "Grade Selected" + ": " + label_ : "Grade Selected", gradeSelected));
    if ("pk" !== gradeSelected &&
        "k" !== gradeSelected &&
        "1" !== gradeSelected &&
        "2" !== gradeSelected &&
        "3" !== gradeSelected &&
        "4" !== gradeSelected &&
        "5" !== gradeSelected) {
      var message = (label_ ? "Grade Selected" + ": " + label_ : "Grade Selected") + " should match one of the following values [ pk | k | 1 | 2 | 3 | 4 | 5 ] but you provided the value " + gradeSelected
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "Fcl7PSdr4", message: message}]);
    }
    return messages;
  }
  
  function assertItemStyle(itemStyle, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("FkHymvGjK", label_ ? "Item Style" + ": " + label_ : "Item Style", itemStyle));
    return messages;
  }
  
  function assertOnboardingWidgetStepName(onboardingWidgetStepName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("FyfKKmNk3", label_ ? "Onboarding Widget Step Name" + ": " + label_ : "Onboarding Widget Step Name", onboardingWidgetStepName));
    return messages;
  }
  
  function assertOptionalWallet(wallet, label_) {
    var messages = [];
    if (wallet !== undefined && wallet !== null) {
      messages = messages.concat(AvoAssert.assertString("G8FSLVPgG", label_ ? "Wallet" + ": " + label_ : "Wallet", wallet));
    }
    return messages;
  }
  
  function assertTabStrCompletedCount(tabStrCompletedCount, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("GAdbKqJ5y9HJPos5lx5qt", label_ ? "Tab Str Completed Count" + ": " + label_ : "Tab Str Completed Count", tabStrCompletedCount));
    return messages;
  }
  
  function assertOptionalTileCode(tileCode, label_) {
    var messages = [];
    if (tileCode !== undefined && tileCode !== null) {
      messages = messages.concat(AvoAssert.assertString("GJYEymipLkc1xy54AyhV8", label_ ? "Tile Code" + ": " + label_ : "Tile Code", tileCode));
    }
    return messages;
  }
  
  function assertTileCode(tileCode, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("GJYEymipLkc1xy54AyhV8", label_ ? "Tile Code" + ": " + label_ : "Tile Code", tileCode));
    return messages;
  }
  
  function assertUserCity(userCity, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("Gh85Hi8uN0", label_ ? "User City" + ": " + label_ : "User City", userCity));
    return messages;
  }
  
  function assertHairStyle(hairStyle, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("GlA8jAx3H", label_ ? "Hair Style" + ": " + label_ : "Hair Style", hairStyle));
    return messages;
  }
  
  function assertFreeWorksheetsLeftCount(freeWorksheetsLeftCount, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("H4pP9av1w", label_ ? "Free Worksheets Left Count" + ": " + label_ : "Free Worksheets Left Count", freeWorksheetsLeftCount));
    return messages;
  }
  
  function assertOptionalFreeWorksheetsLeftCount(freeWorksheetsLeftCount, label_) {
    var messages = [];
    if (freeWorksheetsLeftCount !== undefined && freeWorksheetsLeftCount !== null) {
      messages = messages.concat(AvoAssert.assertString("H4pP9av1w", label_ ? "Free Worksheets Left Count" + ": " + label_ : "Free Worksheets Left Count", freeWorksheetsLeftCount));
    }
    return messages;
  }
  
  function assertTabStrStartedCount(tabStrStartedCount, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("HFnzATNuS7GI6VZs6tZ15", label_ ? "Tab Str Started Count" + ": " + label_ : "Tab Str Started Count", tabStrStartedCount));
    return messages;
  }
  
  function assertFileName(fileName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("HGBR29ljk7ONEgZDhxExr", label_ ? "File Name" + ": " + label_ : "File Name", fileName));
    return messages;
  }
  
  function assertOverallStartedCount(overallStartedCount, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("HJUIBmGrsUmqa_TYCtwQ0", label_ ? "Overall Started Count" + ": " + label_ : "Overall Started Count", overallStartedCount));
    return messages;
  }
  
  function assertActiveAssignment(activeAssignment, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("HMu5eJkRj5", label_ ? "Active Assignment" + ": " + label_ : "Active Assignment", activeAssignment));
    return messages;
  }
  
  function assertNewTopicSelected(newTopicSelected, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("HkxSt1enX", label_ ? "New Topic Selected" + ": " + label_ : "New Topic Selected", newTopicSelected));
    return messages;
  }
  
  function assertWorksheetGrade(worksheetGrade, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("HqigT1cZJV", label_ ? "Worksheet Grade" + ": " + label_ : "Worksheet Grade", worksheetGrade));
    if ("k" !== worksheetGrade &&
        "1" !== worksheetGrade &&
        "2" !== worksheetGrade &&
        "3" !== worksheetGrade &&
        "4" !== worksheetGrade &&
        "5" !== worksheetGrade) {
      var message = (label_ ? "Worksheet Grade" + ": " + label_ : "Worksheet Grade") + " should match one of the following values [ k | 1 | 2 | 3 | 4 | 5 ] but you provided the value " + worksheetGrade
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "HqigT1cZJV", message: message}]);
    }
    return messages;
  }
  
  function assertOptionalSortBy(sortBy, label_) {
    var messages = [];
    if (sortBy !== undefined && sortBy !== null) {
      messages = messages.concat(AvoAssert.assertString("IIQJLClTN", label_ ? "Sort By" + ": " + label_ : "Sort By", sortBy));
    }
    return messages;
  }
  
  function assertReportType(reportType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("Iye0o_TlZ0", label_ ? "Report Type" + ": " + label_ : "Report Type", reportType));
    if ("Grid" !== reportType &&
        "Group" !== reportType) {
      var message = (label_ ? "Report Type" + ": " + label_ : "Report Type") + " should match one of the following values [ Grid | Group ] but you provided the value " + reportType
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "Iye0o_TlZ0", message: message}]);
    }
    return messages;
  }
  
  function assertOptionalSelectedMilestone(selectedMilestone, label_) {
    var messages = [];
    if (selectedMilestone !== undefined && selectedMilestone !== null) {
      messages = messages.concat(AvoAssert.assertInt("J8GQmfwD7", label_ ? "Selected Milestone" + ": " + label_ : "Selected Milestone", selectedMilestone));
    }
    return messages;
  }
  
  function assertOptionalErrorCode(errorCode, label_) {
    var messages = [];
    if (errorCode !== undefined && errorCode !== null) {
      messages = messages.concat(AvoAssert.assertString("JSl62lgk3", label_ ? "Error Code" + ": " + label_ : "Error Code", errorCode));
    }
    return messages;
  }
  
  function assertGameEngine(gameEngine, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("JVkBdMN1_", label_ ? "Game Engine" + ": " + label_ : "Game Engine", gameEngine));
    return messages;
  }
  
  function assertGameNamePosition(gameNamePosition, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("JnQC7Gu0QJ", label_ ? "Game Name Position" + ": " + label_ : "Game Name Position", gameNamePosition));
    return messages;
  }
  
  function assertVoText(voText, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("KEGhoZGvu", label_ ? "Vo Text" + ": " + label_ : "Vo Text", voText));
    return messages;
  }
  
  function assertOptionalOTPEntered(otpEntered, label_) {
    var messages = [];
    if (otpEntered !== undefined && otpEntered !== null) {
      messages = messages.concat(AvoAssert.assertBool("KQDoDel93", label_ ? "OTP Entered" + ": " + label_ : "OTP Entered", otpEntered));
    }
    return messages;
  }
  
  function assertAPISource(apiSource, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("KgDSWGuTz", label_ ? "API Source" + ": " + label_ : "API Source", apiSource));
    if ("Backend" !== apiSource &&
        "Frontend" !== apiSource) {
      var message = (label_ ? "API Source" + ": " + label_ : "API Source") + " should match one of the following values [ Backend | Frontend ] but you provided the value " + apiSource
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "KgDSWGuTz", message: message}]);
    }
    return messages;
  }
  
  function assertTeacherSignupDate(teacherSignupDate, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("L3Bn5aQc2GJb6e2NuVU3C", label_ ? "Teacher Signup Date" + ": " + label_ : "Teacher Signup Date", teacherSignupDate));
    return messages;
  }
  
  function assertModifiedTopics(modifiedTopics, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("L6Gb3dOJ3", label_ ? "Modified Topics" + ": " + label_ : "Modified Topics", modifiedTopics));
    return messages;
  }
  
  function assertPTLFlow(ptlFlow, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("LKpPivRaqhv1iRgHvCBQE", label_ ? "PTL Flow" + ": " + label_ : "PTL Flow", ptlFlow));
    return messages;
  }
  
  function assertClickedOnTrackCustomPage(clickedOnTrackCustomPage, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("LqyojH3QzY", label_ ? "Clicked on - Track Custom Page" + ": " + label_ : "Clicked on - Track Custom Page", clickedOnTrackCustomPage));
    if ("View Report" !== clickedOnTrackCustomPage &&
        "Print Worksheet" !== clickedOnTrackCustomPage &&
        "Edit Test" !== clickedOnTrackCustomPage &&
        "Mark as Complete" !== clickedOnTrackCustomPage &&
        "Copy Practice Link" !== clickedOnTrackCustomPage &&
        "Delete Test" !== clickedOnTrackCustomPage) {
      var message = (label_ ? "Clicked on - Track Custom Page" + ": " + label_ : "Clicked on - Track Custom Page") + " should match one of the following values [ View Report | Print Worksheet | Edit Test | Mark as Complete | Copy Practice Link | Delete Test ] but you provided the value " + clickedOnTrackCustomPage
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "LqyojH3QzY", message: message}]);
    }
    return messages;
  }
  
  function assertCompanionState(companionState, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("MBcj_KFnG", label_ ? "Companion State" + ": " + label_ : "Companion State", companionState));
    return messages;
  }
  
  function assertPageName(pageName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("MJKSzmqfHu", label_ ? "Page Name" + ": " + label_ : "Page Name", pageName));
    return messages;
  }
  
  function assertOptionalPageName(pageName, label_) {
    var messages = [];
    if (pageName !== undefined && pageName !== null) {
      messages = messages.concat(AvoAssert.assertString("MJKSzmqfHu", label_ ? "Page Name" + ": " + label_ : "Page Name", pageName));
    }
    return messages;
  }
  
  function assertCertificateName(certificateName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("MfWi2aBDZ", label_ ? "Certificate Name" + ": " + label_ : "Certificate Name", certificateName));
    return messages;
  }
  
  function assertOptionalSubscriptionPlan(subscriptionPlan, label_) {
    var messages = [];
    if (subscriptionPlan !== undefined && subscriptionPlan !== null) {
      messages = messages.concat(AvoAssert.assertString("N8pv_Xjhj", label_ ? "Subscription Plan" + ": " + label_ : "Subscription Plan", subscriptionPlan));
    }
    return messages;
  }
  
  function assertCurrentPage(currentPage, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("NB48F50R-rZtUyefpnEti", label_ ? "Current Page" + ": " + label_ : "Current Page", currentPage));
    return messages;
  }
  
  function assertDaysSinceSY23Onboarding(daysSinceSy23Onboarding, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("NF129Gymtv", label_ ? "Days Since SY23 Onboarding" + ": " + label_ : "Days Since SY23 Onboarding", daysSinceSy23Onboarding));
    messages = messages.concat(AvoAssert.assertMin("NF129Gymtv", label_ ? "Days Since SY23 Onboarding" + ": " + label_ : "Days Since SY23 Onboarding", 0, daysSinceSy23Onboarding));
    return messages;
  }
  
  function assertChangedGoal(changedGoal, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("NOQe2s5vk", label_ ? "Changed Goal" + ": " + label_ : "Changed Goal", changedGoal));
    return messages;
  }
  
  function assertUserIntervention(userIntervention, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("NPXDMFP1_", label_ ? "User Intervention" + ": " + label_ : "User Intervention", userIntervention));
    return messages;
  }
  
  function assertOptionalWorksheetCode(worksheetCode, label_) {
    var messages = [];
    if (worksheetCode !== undefined && worksheetCode !== null) {
      messages = messages.concat(AvoAssert.assertString("NRFYZYLxy", label_ ? "Worksheet Code" + ": " + label_ : "Worksheet Code", worksheetCode));
    }
    return messages;
  }
  
  function assertWorksheetCode(worksheetCode, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("NRFYZYLxy", label_ ? "Worksheet Code" + ": " + label_ : "Worksheet Code", worksheetCode));
    return messages;
  }
  
  function assertTutorName(tutorName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("NS3VU6-SM", label_ ? "Tutor Name" + ": " + label_ : "Tutor Name", tutorName));
    return messages;
  }
  
  function assertDBDayZero(dbDayZero, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("NaQMaElOq", label_ ? "DB Day Zero" + ": " + label_ : "DB Day Zero", dbDayZero));
    return messages;
  }
  
  function assertContentType(contentType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("Nfs9QLl8W7", label_ ? "Content Type" + ": " + label_ : "Content Type", contentType));
    return messages;
  }
  
  function assertOptionalContentType(contentType, label_) {
    var messages = [];
    if (contentType !== undefined && contentType !== null) {
      messages = messages.concat(AvoAssert.assertString("Nfs9QLl8W7", label_ ? "Content Type" + ": " + label_ : "Content Type", contentType));
    }
    return messages;
  }
  
  function assertEnabledCTA(enabledCta, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("Nspz0JPS5", label_ ? "Enabled CTA" + ": " + label_ : "Enabled CTA", enabledCta));
    return messages;
  }
  
  function assertOptionalClickedOn(clickedOn, label_) {
    var messages = [];
    if (clickedOn !== undefined && clickedOn !== null) {
      messages = messages.concat(AvoAssert.assertString("O0dEFLrgl", label_ ? "Clicked On" + ": " + label_ : "Clicked On", clickedOn));
    }
    return messages;
  }
  
  function assertClickedOn(clickedOn, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("O0dEFLrgl", label_ ? "Clicked On" + ": " + label_ : "Clicked On", clickedOn));
    return messages;
  }
  
  function assertOverallCompletedCount(overallCompletedCount, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("OHBx0fnhzlxvHhw0e87pM", label_ ? "Overall Completed Count" + ": " + label_ : "Overall Completed Count", overallCompletedCount));
    return messages;
  }
  
  function assertQuizGrade(quizGrade, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("OdOreTGEK", label_ ? "Quiz Grade" + ": " + label_ : "Quiz Grade", quizGrade));
    return messages;
  }
  
  function assertOptionalContentGroup(contentGroup, label_) {
    var messages = [];
    if (contentGroup !== undefined && contentGroup !== null) {
      messages = messages.concat(AvoAssert.assertString("Otu1r2JQW", label_ ? "Content Group" + ": " + label_ : "Content Group", contentGroup));
    }
    return messages;
  }
  
  function assertContentGroup(contentGroup, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("Otu1r2JQW", label_ ? "Content Group" + ": " + label_ : "Content Group", contentGroup));
    return messages;
  }
  
  function assertOpponentCity(opponentCity, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("P9dar0xMXW", label_ ? "Opponent City" + ": " + label_ : "Opponent City", opponentCity));
    return messages;
  }
  
  function assertOptionalSetupIntentId(setupIntentId, label_) {
    var messages = [];
    if (setupIntentId !== undefined && setupIntentId !== null) {
      messages = messages.concat(AvoAssert.assertString("PFXfXOuvy", label_ ? "Setup Intent Id" + ": " + label_ : "Setup Intent Id", setupIntentId));
    }
    return messages;
  }
  
  function assertEyeColour(eyeColour, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("PXb4BjQrg", label_ ? "Eye Colour" + ": " + label_ : "Eye Colour", eyeColour));
    return messages;
  }
  
  function assertOptionalInteractionType(interactionType, label_) {
    var messages = [];
    if (interactionType !== undefined && interactionType !== null) {
      messages = messages.concat(AvoAssert.assertString("PokUqOLpg8", label_ ? "Interaction Type" + ": " + label_ : "Interaction Type", interactionType));
      if ("Clicked" !== interactionType &&
          "Scrolled" !== interactionType &&
          "Hovered" !== interactionType &&
          "Heard" !== interactionType) {
        var message = (label_ ? "Interaction Type" + ": " + label_ : "Interaction Type") + " should match one of the following values [ Clicked | Scrolled | Hovered | Heard ] but you provided the value " + interactionType
        messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "PokUqOLpg8", message: message}]);
      }
    }
    return messages;
  }
  
  function assertInteractionType(interactionType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("PokUqOLpg8", label_ ? "Interaction Type" + ": " + label_ : "Interaction Type", interactionType));
    if ("Clicked" !== interactionType &&
        "Scrolled" !== interactionType &&
        "Hovered" !== interactionType &&
        "Heard" !== interactionType) {
      var message = (label_ ? "Interaction Type" + ": " + label_ : "Interaction Type") + " should match one of the following values [ Clicked | Scrolled | Hovered | Heard ] but you provided the value " + interactionType
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "PokUqOLpg8", message: message}]);
    }
    return messages;
  }
  
  function assertSpringboardRank(springboardRank, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("PpLUQoMje", label_ ? "Springboard Rank" + ": " + label_ : "Springboard Rank", springboardRank));
    return messages;
  }
  
  function assertClass(class_, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("PxWDGuxq95", label_ ? "Class" + ": " + label_ : "Class", class_));
    return messages;
  }
  
  function assertRecommendationAlgorithmFlag(recommendationAlgorithmFlag, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("Q2q6j4dEnjH8uo-MY-mr7", label_ ? "Recommendation Algorithm Flag" + ": " + label_ : "Recommendation Algorithm Flag", recommendationAlgorithmFlag));
    return messages;
  }
  
  function assertOptionalCellPosition(cellPosition, label_) {
    var messages = [];
    if (cellPosition !== undefined && cellPosition !== null) {
      messages = messages.concat(AvoAssert.assertInt("Q2tHPdj30", label_ ? "Cell Position" + ": " + label_ : "Cell Position", cellPosition));
    }
    return messages;
  }
  
  function assertOptionalRailCode(railCode, label_) {
    var messages = [];
    if (railCode !== undefined && railCode !== null) {
      messages = messages.concat(AvoAssert.assertString("QDMKmRkRjbW4pFvqlGOM6", label_ ? "Rail Code" + ": " + label_ : "Rail Code", railCode));
    }
    return messages;
  }
  
  function assertRailCode(railCode, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("QDMKmRkRjbW4pFvqlGOM6", label_ ? "Rail Code" + ": " + label_ : "Rail Code", railCode));
    return messages;
  }
  
  function assertSubject(subject, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("QE2CTvenDi", label_ ? "Subject" + ": " + label_ : "Subject", subject));
    if ("ela" !== subject &&
        "math" !== subject &&
        "extra curriculum" !== subject &&
        "reading" !== subject &&
        "book" !== subject) {
      var message = (label_ ? "Subject" + ": " + label_ : "Subject") + " should match one of the following values [ ela | math | extra curriculum | reading | book ] but you provided the value " + subject
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "QE2CTvenDi", message: message}]);
    }
    return messages;
  }
  
  function assertOptionalSubject(subject, label_) {
    var messages = [];
    if (subject !== undefined && subject !== null) {
      messages = messages.concat(AvoAssert.assertString("QE2CTvenDi", label_ ? "Subject" + ": " + label_ : "Subject", subject));
      if ("ela" !== subject &&
          "math" !== subject &&
          "extra curriculum" !== subject &&
          "reading" !== subject &&
          "book" !== subject) {
        var message = (label_ ? "Subject" + ": " + label_ : "Subject") + " should match one of the following values [ ela | math | extra curriculum | reading | book ] but you provided the value " + subject
        messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "QE2CTvenDi", message: message}]);
      }
    }
    return messages;
  }
  
  function assertPlayableClickId(playableClickId, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("QQeu-Td4-0", label_ ? "Playable Click Id" + ": " + label_ : "Playable Click Id", playableClickId));
    return messages;
  }
  
  function assertPlayableCode(playableCode, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("QjCwFasvW0", label_ ? "Playable Code" + ": " + label_ : "Playable Code", playableCode));
    return messages;
  }
  
  function assertOptionalPlayableCode(playableCode, label_) {
    var messages = [];
    if (playableCode !== undefined && playableCode !== null) {
      messages = messages.concat(AvoAssert.assertString("QjCwFasvW0", label_ ? "Playable Code" + ": " + label_ : "Playable Code", playableCode));
    }
    return messages;
  }
  
  function assertSlide(slide, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("Qo8RFu5jt2", label_ ? "Slide" + ": " + label_ : "Slide", slide));
    messages = messages.concat(AvoAssert.assertMin("Qo8RFu5jt2", label_ ? "Slide" + ": " + label_ : "Slide", 1, slide));
    messages = messages.concat(AvoAssert.assertMax("Qo8RFu5jt2", label_ ? "Slide" + ": " + label_ : "Slide", 3, slide));
    return messages;
  }
  
  function assertFlowName(flowName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("QvqHzz_24", label_ ? "Flow Name" + ": " + label_ : "Flow Name", flowName));
    return messages;
  }
  
  function assertQuizMeetingSlug(quizMeetingSlug, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("QwEJtFNQB", label_ ? "Quiz Meeting Slug" + ": " + label_ : "Quiz Meeting Slug", quizMeetingSlug));
    return messages;
  }
  
  function assertRecommendationRailCode(recommendationRailCode, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("Qwa4E7UWbmonbiv7JbciC", label_ ? "Recommendation Rail Code" + ": " + label_ : "Recommendation Rail Code", recommendationRailCode));
    return messages;
  }
  
  function assertLoginMethod(loginMethod, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("RzhjpWea8R6s1FWo1fgS4", label_ ? "Login Method" + ": " + label_ : "Login Method", loginMethod));
    return messages;
  }
  
  function assertGameMode(gameMode, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("SCiKCU5kRo", label_ ? "Game Mode" + ": " + label_ : "Game Mode", gameMode));
    if ("pwc" !== gameMode &&
        "solo" !== gameMode &&
        "1_v_1" !== gameMode) {
      var message = (label_ ? "Game Mode" + ": " + label_ : "Game Mode") + " should match one of the following values [ pwc | solo | 1_v_1 ] but you provided the value " + gameMode
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "SCiKCU5kRo", message: message}]);
    }
    return messages;
  }
  
  function assertIsFtue(isFtue, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("SGNPV5nP-", label_ ? "Is Ftue" + ": " + label_ : "Is Ftue", isFtue));
    return messages;
  }
  
  function assertOptionalStripePaymentMethodInfoFrontend(stripePaymentMethodInfoFrontend, label_) {
    var messages = [];
    if (stripePaymentMethodInfoFrontend !== undefined && stripePaymentMethodInfoFrontend !== null) {
      messages = messages.concat(AvoAssert.assertString("SMxi3L9R_W", label_ ? "Stripe Payment Method Info Frontend" + ": " + label_ : "Stripe Payment Method Info Frontend", stripePaymentMethodInfoFrontend));
    }
    return messages;
  }
  
  function assertStripePaymentMethodInfoFrontend(stripePaymentMethodInfoFrontend, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("SMxi3L9R_W", label_ ? "Stripe Payment Method Info Frontend" + ": " + label_ : "Stripe Payment Method Info Frontend", stripePaymentMethodInfoFrontend));
    return messages;
  }
  
  function assertCurrentGoals(currentGoals, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("SO6SLa4H5", label_ ? "Current Goals" + ": " + label_ : "Current Goals", currentGoals));
    return messages;
  }
  
  function assertTid(tid, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("SYGmTqa9e", label_ ? "Tid" + ": " + label_ : "Tid", tid));
    return messages;
  }
  
  function assertOptionalColumnPosition(columnPosition, label_) {
    var messages = [];
    if (columnPosition !== undefined && columnPosition !== null) {
      messages = messages.concat(AvoAssert.assertInt("Sq_wyVgw4s", label_ ? "Column Position" + ": " + label_ : "Column Position", columnPosition));
    }
    return messages;
  }
  
  function assertInteractedWith(interactedWith, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("Ssr_b4cA9A", label_ ? "Interacted With" + ": " + label_ : "Interacted With", interactedWith));
    if ("Take a Tour" !== interactedWith &&
        "I'll take it later" !== interactedWith) {
      var message = (label_ ? "Interacted With" + ": " + label_ : "Interacted With") + " should match one of the following values [ Take a Tour | I'll take it later ] but you provided the value " + interactedWith
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "Ssr_b4cA9A", message: message}]);
    }
    return messages;
  }
  
  function assertCertificateType(certificateType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("T1COE_Of2", label_ ? "Certificate Type" + ": " + label_ : "Certificate Type", certificateType));
    return messages;
  }
  
  function assertFaceShape(faceShape, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("T446VyHk1", label_ ? "Face Shape" + ": " + label_ : "Face Shape", faceShape));
    return messages;
  }
  
  function assertStateMachineCode(stateMachineCode, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("T9gjnp76o", label_ ? "State Machine Code" + ": " + label_ : "State Machine Code", stateMachineCode));
    return messages;
  }
  
  function assertMessageType(messageType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("THmuig1mn", label_ ? "Message Type" + ": " + label_ : "Message Type", messageType));
    return messages;
  }
  
  function assertOptionalScrolledThrough(scrolledThrough, label_) {
    var messages = [];
    if (scrolledThrough !== undefined && scrolledThrough !== null) {
      messages = messages.concat(AvoAssert.assertString("TLBtHE5cOx", label_ ? "Scrolled Through" + ": " + label_ : "Scrolled Through", scrolledThrough));
      if ("Multiplayer Games" !== scrolledThrough &&
          "Activities" !== scrolledThrough &&
          "Rewards" !== scrolledThrough &&
          "Foundational Games" !== scrolledThrough &&
          "Advanced Games" !== scrolledThrough &&
          "Logic & Thinking" !== scrolledThrough &&
          "Art & Creativity" !== scrolledThrough &&
          "General Knowledge" !== scrolledThrough) {
        var message = (label_ ? "Scrolled Through" + ": " + label_ : "Scrolled Through") + " should match one of the following values [ Multiplayer Games | Activities | Rewards | Foundational Games | Advanced Games | Logic & Thinking | Art & Creativity | General Knowledge ] but you provided the value " + scrolledThrough
        messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "TLBtHE5cOx", message: message}]);
      }
    }
    return messages;
  }
  
  function assertOptionalRecommendedTileName(recommendedTileName, label_) {
    var messages = [];
    if (recommendedTileName !== undefined && recommendedTileName !== null) {
      messages = messages.concat(AvoAssert.assertList("TYbmk5DQn", "Recommended Tile Name", recommendedTileName));
      recommendedTileName.forEach(function (value, index) {
      });
    }
    return messages;
  }
  
  function assertReadingLevel(readingLevel, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertList("TYsaD1VcN", "Reading Level", readingLevel));
    if (readingLevel !== null && readingLevel !== undefined && readingLevel.forEach) {
      readingLevel.forEach(function (value, index) {
      });
    }
    return messages;
  }
  
  function assertOptionalReadingLevel(readingLevel, label_) {
    var messages = [];
    if (readingLevel !== undefined && readingLevel !== null) {
      messages = messages.concat(AvoAssert.assertList("TYsaD1VcN", "Reading Level", readingLevel));
      readingLevel.forEach(function (value, index) {
      });
    }
    return messages;
  }
  
  function assertContentGroupName(contentGroupName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("TfrlXL1gV", label_ ? "Content Group Name" + ": " + label_ : "Content Group Name", contentGroupName));
    return messages;
  }
  
  function assertOptionalUrl(url, label_) {
    var messages = [];
    if (url !== undefined && url !== null) {
      messages = messages.concat(AvoAssert.assertString("ToCgaA4KN", label_ ? "Url" + ": " + label_ : "Url", url));
    }
    return messages;
  }
  
  function assertUrl(url, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("ToCgaA4KN", label_ ? "Url" + ": " + label_ : "Url", url));
    return messages;
  }
  
  function assertOptionalNewGradeSelected(newGradeSelected, label_) {
    var messages = [];
    if (newGradeSelected !== undefined && newGradeSelected !== null) {
      messages = messages.concat(AvoAssert.assertString("Tps4I1ukM", label_ ? "New Grade Selected" + ": " + label_ : "New Grade Selected", newGradeSelected));
    }
    return messages;
  }
  
  function assertNewGradeSelected(newGradeSelected, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("Tps4I1ukM", label_ ? "New Grade Selected" + ": " + label_ : "New Grade Selected", newGradeSelected));
    return messages;
  }
  
  function assertDaysSinceClassCreation(daysSinceClassCreation, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("TuspgTIuZ1", label_ ? "Days Since Class Creation" + ": " + label_ : "Days Since Class Creation", daysSinceClassCreation));
    messages = messages.concat(AvoAssert.assertMin("TuspgTIuZ1", label_ ? "Days Since Class Creation" + ": " + label_ : "Days Since Class Creation", 0, daysSinceClassCreation));
    return messages;
  }
  
  function assertModifiedOperator(modifiedOperator, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("Tz8yoJEXaS", label_ ? "Modified Operator" + ": " + label_ : "Modified Operator", modifiedOperator));
    return messages;
  }
  
  function assertOpponentType(opponentType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("U2QSiMZrpE", label_ ? "Opponent Type" + ": " + label_ : "Opponent Type", opponentType));
    if ("Bot" !== opponentType &&
        "Student" !== opponentType) {
      var message = (label_ ? "Opponent Type" + ": " + label_ : "Opponent Type") + " should match one of the following values [ Bot | Student ] but you provided the value " + opponentType
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "U2QSiMZrpE", message: message}]);
    }
    return messages;
  }
  
  function assertOptionalClassStatusInNewSchoolYear(classStatusInNewSchoolYear, label_) {
    var messages = [];
    if (classStatusInNewSchoolYear !== undefined && classStatusInNewSchoolYear !== null) {
      messages = messages.concat(AvoAssert.assertString("U5iz3PtWf", label_ ? "Class Status in New School Year" + ": " + label_ : "Class Status in New School Year", classStatusInNewSchoolYear));
    }
    return messages;
  }
  
  function assertClassStatusInNewSchoolYear(classStatusInNewSchoolYear, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("U5iz3PtWf", label_ ? "Class Status in New School Year" + ": " + label_ : "Class Status in New School Year", classStatusInNewSchoolYear));
    return messages;
  }
  
  function assertWorksheetFilterValue(worksheetFilterValue, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("UGULV7SI7o", label_ ? "Worksheet Filter Value" + ": " + label_ : "Worksheet Filter Value", worksheetFilterValue));
    return messages;
  }
  
  function assertBookName(bookName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("UPVjvJlbS", label_ ? "Book Name" + ": " + label_ : "Book Name", bookName));
    return messages;
  }
  
  function assertAssignmentType(assignmentType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("Ueowl7sRb", label_ ? "Assignment Type" + ": " + label_ : "Assignment Type", assignmentType));
    return messages;
  }
  
  function assertIsEmailUpdated(isEmailUpdated, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("UgsrIrCRxEEZ_LjtRRk8N", label_ ? "Is Email Updated" + ": " + label_ : "Is Email Updated", isEmailUpdated));
    return messages;
  }
  
  function assertModifiedFor(modifiedFor, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("UrJ4r6Tv4Q", label_ ? "Modified For" + ": " + label_ : "Modified For", modifiedFor));
    messages = messages.concat(AvoAssert.assertMin("UrJ4r6Tv4Q", label_ ? "Modified For" + ": " + label_ : "Modified For", 0, modifiedFor));
    return messages;
  }
  
  function assertOptionalTeacherType(teacherType, label_) {
    var messages = [];
    if (teacherType !== undefined && teacherType !== null) {
      messages = messages.concat(AvoAssert.assertString("UsQGEDnYDs", label_ ? "Teacher Type" + ": " + label_ : "Teacher Type", teacherType));
    }
    return messages;
  }
  
  function assertNumberOfResults(numberOfResults, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("UtPMQu4JE", label_ ? "Number of Results" + ": " + label_ : "Number of Results", numberOfResults));
    return messages;
  }
  
  function assertOptionalNumberOfResults(numberOfResults, label_) {
    var messages = [];
    if (numberOfResults !== undefined && numberOfResults !== null) {
      messages = messages.concat(AvoAssert.assertInt("UtPMQu4JE", label_ ? "Number of Results" + ": " + label_ : "Number of Results", numberOfResults));
    }
    return messages;
  }
  
  function assertPlayablePlayed(playablePlayed, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("V16Tay7p5", label_ ? "Playable Played" + ": " + label_ : "Playable Played", playablePlayed));
    return messages;
  }
  
  function assertOptionalClickedSpecificallyOn(clickedSpecificallyOn, label_) {
    var messages = [];
    if (clickedSpecificallyOn !== undefined && clickedSpecificallyOn !== null) {
      messages = messages.concat(AvoAssert.assertString("V61EIIAa1", label_ ? "Clicked Specifically On" + ": " + label_ : "Clicked Specifically On", clickedSpecificallyOn));
    }
    return messages;
  }
  
  function assertNudgeType(nudgeType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("VPMGzU0YX", label_ ? "Nudge Type" + ": " + label_ : "Nudge Type", nudgeType));
    return messages;
  }
  
  function assertOptionalDiscountOfferingCodeApplied(discountOfferingCodeApplied, label_) {
    var messages = [];
    if (discountOfferingCodeApplied !== undefined && discountOfferingCodeApplied !== null) {
      messages = messages.concat(AvoAssert.assertString("VUkpaROVL", label_ ? "Discount Offering Code Applied" + ": " + label_ : "Discount Offering Code Applied", discountOfferingCodeApplied));
    }
    return messages;
  }
  
  function assertTotalProblemsAnswered(totalProblemsAnswered, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("V_eCbteEGc", label_ ? "Total Problems Answered" + ": " + label_ : "Total Problems Answered", totalProblemsAnswered));
    return messages;
  }
  
  function assertOptionalRecommendedCategory(recommendedCategory, label_) {
    var messages = [];
    if (recommendedCategory !== undefined && recommendedCategory !== null) {
      messages = messages.concat(AvoAssert.assertList("VdJhEU0H6s", "Recommended Category", recommendedCategory));
      recommendedCategory.forEach(function (value, index) {
      });
    }
    return messages;
  }
  
  function assertRecommendedCategory(recommendedCategory, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertList("VdJhEU0H6s", "Recommended Category", recommendedCategory));
    if (recommendedCategory !== null && recommendedCategory !== undefined && recommendedCategory.forEach) {
      recommendedCategory.forEach(function (value, index) {
      });
    }
    return messages;
  }
  
  function assertOptionalDiscountType(discountType, label_) {
    var messages = [];
    if (discountType !== undefined && discountType !== null) {
      messages = messages.concat(AvoAssert.assertString("VdxNoqe4b", label_ ? "Discount Type" + ": " + label_ : "Discount Type", discountType));
    }
    return messages;
  }
  
  function assertDailyBundleCourse(dailyBundleCourse, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("Vw8Hds8A5", label_ ? "Daily Bundle Course" + ": " + label_ : "Daily Bundle Course", dailyBundleCourse));
    return messages;
  }
  
  function assertMFMode(mfMode, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("W2HLoVKJnA", label_ ? "MF Mode" + ": " + label_ : "MF Mode", mfMode));
    if ("Adaptive" !== mfMode &&
        "Custom" !== mfMode) {
      var message = (label_ ? "MF Mode" + ": " + label_ : "MF Mode") + " should match one of the following values [ Adaptive | Custom ] but you provided the value " + mfMode
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "W2HLoVKJnA", message: message}]);
    }
    return messages;
  }
  
  function assertAttendanceCount(attendanceCount, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("WIwN37Vje", label_ ? "Attendance Count" + ": " + label_ : "Attendance Count", attendanceCount));
    return messages;
  }
  
  function assertOptionalChangesApplied(changesApplied, label_) {
    var messages = [];
    if (changesApplied !== undefined && changesApplied !== null) {
      messages = messages.concat(AvoAssert.assertString("WKUcnjiy_", label_ ? "Changes Applied" + ": " + label_ : "Changes Applied", changesApplied));
    }
    return messages;
  }
  
  function assertOptionalCardType(cardType, label_) {
    var messages = [];
    if (cardType !== undefined && cardType !== null) {
      messages = messages.concat(AvoAssert.assertString("WZ4UUsQFg", label_ ? "Card Type" + ": " + label_ : "Card Type", cardType));
      if ("Card Type not available" !== cardType &&
          "debit" !== cardType &&
          "credit" !== cardType &&
          "prepaid" !== cardType) {
        var message = (label_ ? "Card Type" + ": " + label_ : "Card Type") + " should match one of the following values [ Card Type not available | debit | credit | prepaid ] but you provided the value " + cardType
        messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "WZ4UUsQFg", message: message}]);
      }
    }
    return messages;
  }
  
  function assertOverallClickedCount(overallClickedCount, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("X4kgAx81N5AHgcI6NaNiS", label_ ? "Overall Clicked Count" + ": " + label_ : "Overall Clicked Count", overallClickedCount));
    return messages;
  }
  
  function assertOptionalSubscriptionPlanStartsFromAmount(subscriptionPlanStartsFromAmount, label_) {
    var messages = [];
    if (subscriptionPlanStartsFromAmount !== undefined && subscriptionPlanStartsFromAmount !== null) {
      messages = messages.concat(AvoAssert.assertList("XIwdg9nE7", "Subscription Plan Starts From Amount", subscriptionPlanStartsFromAmount));
      subscriptionPlanStartsFromAmount.forEach(function (value, index) {
      });
    }
    return messages;
  }
  
  function assertCustomMFOperatorSelected(customMfOperatorSelected, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertList("XJ6AZrYTI-", "Custom MF Operator Selected", customMfOperatorSelected));
    if (customMfOperatorSelected !== null && customMfOperatorSelected !== undefined && customMfOperatorSelected.forEach) {
      customMfOperatorSelected.forEach(function (value, index) {
        messages = messages.concat(AvoAssert.assertString("XJ6AZrYTI-", "item at index " + index + " in Custom MF Operator Selected", value));
        if ("Add" !== value &&
            "Subtract" !== value &&
            "Multiply" !== value &&
            "Divide" !== value) {
          var message = (label_ ? "item at index " + index + " in Custom MF Operator Selected" + ": " + label_ : "item at index " + index + " in Custom MF Operator Selected") + " should match one of the following values [ Add | Subtract | Multiply | Divide ] but you provided the value " + value
          messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "XJ6AZrYTI-", message: message}]);
        }
      });
    }
    return messages;
  }
  
  function assertSchoolFormType(schoolFormType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("XVqfVlPwm", label_ ? "School Form Type" + ": " + label_ : "School Form Type", schoolFormType));
    if ("US" !== schoolFormType &&
        "Non US" !== schoolFormType) {
      var message = (label_ ? "School Form Type" + ": " + label_ : "School Form Type") + " should match one of the following values [ US | Non US ] but you provided the value " + schoolFormType
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "XVqfVlPwm", message: message}]);
    }
    return messages;
  }
  
  function assertMFOperatorSelected(mfOperatorSelected, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("XkzC7k3g8c", label_ ? "MF Operator Selected" + ": " + label_ : "MF Operator Selected", mfOperatorSelected));
    if ("Addition & Subtraction" !== mfOperatorSelected &&
        "Multiplication & Division" !== mfOperatorSelected) {
      var message = (label_ ? "MF Operator Selected" + ": " + label_ : "MF Operator Selected") + " should match one of the following values [ Addition & Subtraction | Multiplication & Division ] but you provided the value " + mfOperatorSelected
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "XkzC7k3g8c", message: message}]);
    }
    return messages;
  }
  
  function assertCurriculumType(curriculumType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("Xvxho3cru", label_ ? "Curriculum Type" + ": " + label_ : "Curriculum Type", curriculumType));
    return messages;
  }
  
  function assertAPIName(apiName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("Y6EoEtXpW", label_ ? "API Name" + ": " + label_ : "API Name", apiName));
    return messages;
  }
  
  function assertEligibleClassesCount(eligibleClassesCount, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("YARhyVGOR", label_ ? "Eligible Classes Count" + ": " + label_ : "Eligible Classes Count", eligibleClassesCount));
    return messages;
  }
  
  function assertPercent(percent, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("YQmfn3FNosNNeMxSmOsXJ", label_ ? "Percent" + ": " + label_ : "Percent", percent));
    return messages;
  }
  
  function assertDBCOQAnswered(dbCoqAnswered, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("YcZvlYnV3", label_ ? "DB COQ Answered" + ": " + label_ : "DB COQ Answered", dbCoqAnswered));
    return messages;
  }
  
  function assertImportCount(importCount, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("YkNoE278N", label_ ? "Import Count" + ": " + label_ : "Import Count", importCount));
    return messages;
  }
  
  function assertOptionalLiveClassSubject(liveClassSubject, label_) {
    var messages = [];
    if (liveClassSubject !== undefined && liveClassSubject !== null) {
      messages = messages.concat(AvoAssert.assertString("Ys_LWCV8p", label_ ? "Live Class Subject" + ": " + label_ : "Live Class Subject", liveClassSubject));
    }
    return messages;
  }
  
  function assertLiveClassSubject(liveClassSubject, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("Ys_LWCV8p", label_ ? "Live Class Subject" + ": " + label_ : "Live Class Subject", liveClassSubject));
    return messages;
  }
  
  function assertOptionalIsRecommendedContent(isRecommendedContent, label_) {
    var messages = [];
    if (isRecommendedContent !== undefined && isRecommendedContent !== null) {
      messages = messages.concat(AvoAssert.assertString("YzXAIbKaI", label_ ? "Is Recommended Content" + ": " + label_ : "Is Recommended Content", isRecommendedContent));
    }
    return messages;
  }
  
  function assertOptionalIsClassNameUpdated(isClassNameUpdated, label_) {
    var messages = [];
    if (isClassNameUpdated !== undefined && isClassNameUpdated !== null) {
      messages = messages.concat(AvoAssert.assertInt("Z4R_4lCL0", label_ ? "Is Class Name Updated" + ": " + label_ : "Is Class Name Updated", isClassNameUpdated));
    }
    return messages;
  }
  
  function assertOptionalGameName(gameName, label_) {
    var messages = [];
    if (gameName !== undefined && gameName !== null) {
      messages = messages.concat(AvoAssert.assertString("_L1z86KIYb", label_ ? "Game Name" + ": " + label_ : "Game Name", gameName));
    }
    return messages;
  }
  
  function assertGameName(gameName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("_L1z86KIYb", label_ ? "Game Name" + ": " + label_ : "Game Name", gameName));
    return messages;
  }
  
  function assertTileStrCompletedCount(tileStrCompletedCount, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("_QL92wEdpoa8wH50vOPYt", label_ ? "Tile Str Completed Count" + ": " + label_ : "Tile Str Completed Count", tileStrCompletedCount));
    return messages;
  }
  
  function assertCACompletedSuccessfully(caCompletedSuccessfully, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("_YDbEIGLh", label_ ? "CA Completed Successfully" + ": " + label_ : "CA Completed Successfully", caCompletedSuccessfully));
    return messages;
  }
  
  function assertQuestionNumber(questionNumber, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("_cuCZnBI_", label_ ? "Question Number" + ": " + label_ : "Question Number", questionNumber));
    return messages;
  }
  
  function assertClickedOnNewMFPractice(clickedOnNewMfPractice, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("_fUyjKBzmx", label_ ? "Clicked on - New MF Practice" + ": " + label_ : "Clicked on - New MF Practice", clickedOnNewMfPractice));
    if ("Assign Adaptive Practice" !== clickedOnNewMfPractice &&
        "Create Custom Test" !== clickedOnNewMfPractice) {
      var message = (label_ ? "Clicked on - New MF Practice" + ": " + label_ : "Clicked on - New MF Practice") + " should match one of the following values [ Assign Adaptive Practice | Create Custom Test ] but you provided the value " + clickedOnNewMfPractice
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "_fUyjKBzmx", message: message}]);
    }
    return messages;
  }
  
  function assertOptionalActiveLpSubjects(activeLpSubjects, label_) {
    var messages = [];
    if (activeLpSubjects !== undefined && activeLpSubjects !== null) {
      messages = messages.concat(AvoAssert.assertString("_fnvZDP5s", label_ ? "Active Lp Subjects" + ": " + label_ : "Active Lp Subjects", activeLpSubjects));
    }
    return messages;
  }
  
  function assertActiveLpSubjects(activeLpSubjects, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("_fnvZDP5s", label_ ? "Active Lp Subjects" + ": " + label_ : "Active Lp Subjects", activeLpSubjects));
    return messages;
  }
  
  function assertQuizCode(quizCode, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("_gr4kO5vEN", label_ ? "Quiz Code" + ": " + label_ : "Quiz Code", quizCode));
    return messages;
  }
  
  function assertNumberOfLearnCards(numberOfLearnCards, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("_rbYN5Au4", label_ ? "Number of 'Learn' Cards" + ": " + label_ : "Number of 'Learn' Cards", numberOfLearnCards));
    return messages;
  }
  
  function assertOptionalAssignmentName(assignmentName, label_) {
    var messages = [];
    if (assignmentName !== undefined && assignmentName !== null) {
      messages = messages.concat(AvoAssert.assertString("a1f6ssVyg", label_ ? "Assignment Name" + ": " + label_ : "Assignment Name", assignmentName));
    }
    return messages;
  }
  
  function assertLOStatus(loStatus, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("a7Ojd0Pzt", label_ ? "LO Status" + ": " + label_ : "LO Status", loStatus));
    return messages;
  }
  
  function assertOptionalRowNumber(rowNumber, label_) {
    var messages = [];
    if (rowNumber !== undefined && rowNumber !== null) {
      messages = messages.concat(AvoAssert.assertInt("a9l_OugqB", label_ ? "Row Number" + ": " + label_ : "Row Number", rowNumber));
    }
    return messages;
  }
  
  function assertRowNumber(rowNumber, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("a9l_OugqB", label_ ? "Row Number" + ": " + label_ : "Row Number", rowNumber));
    return messages;
  }
  
  function assertLessonPlanName(lessonPlanName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("aESgK6MlY", label_ ? "Lesson Plan Name" + ": " + label_ : "Lesson Plan Name", lessonPlanName));
    return messages;
  }
  
  function assertFiltersApplied(filtersApplied, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertObject("aX1-5O7eP", label_ ? "Filters Applied" + ": " + label_ : "Filters Applied", filtersApplied));
    return messages;
  }
  
  function assertOptionalFiltersApplied(filtersApplied, label_) {
    var messages = [];
    if (filtersApplied !== undefined && filtersApplied !== null) {
      messages = messages.concat(AvoAssert.assertObject("aX1-5O7eP", label_ ? "Filters Applied" + ": " + label_ : "Filters Applied", filtersApplied));
    }
    return messages;
  }
  
  function assertWorksheetCategory(worksheetCategory, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("ahxpYE3lQW", label_ ? "Worksheet Category" + ": " + label_ : "Worksheet Category", worksheetCategory));
    return messages;
  }
  
  function assertStaleData(staleData, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("amiw6GdIfAgKr7MxhRYGM", label_ ? "Stale Data" + ": " + label_ : "Stale Data", staleData));
    return messages;
  }
  
  function assertClassImportedBefore(classImportedBefore, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("axwj3awcZ", label_ ? "Class Imported Before" + ": " + label_ : "Class Imported Before", classImportedBefore));
    return messages;
  }
  
  function assertCollectionName(collectionName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertList("b8Fx1iSZI", "Collection Name", collectionName));
    if (collectionName !== null && collectionName !== undefined && collectionName.forEach) {
      collectionName.forEach(function (value, index) {
      });
    }
    return messages;
  }
  
  function assertOptionalCollectionName(collectionName, label_) {
    var messages = [];
    if (collectionName !== undefined && collectionName !== null) {
      messages = messages.concat(AvoAssert.assertList("b8Fx1iSZI", "Collection Name", collectionName));
      collectionName.forEach(function (value, index) {
      });
    }
    return messages;
  }
  
  function assertTransferredClassesCount(transferredClassesCount, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("b9faRmp_O", label_ ? "Transferred Classes Count" + ": " + label_ : "Transferred Classes Count", transferredClassesCount));
    return messages;
  }
  
  function assertReasonForImportUnsuccessful(reasonForImportUnsuccessful, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("bBX3FEBN-", label_ ? "Reason for Import Unsuccessful" + ": " + label_ : "Reason for Import Unsuccessful", reasonForImportUnsuccessful));
    return messages;
  }
  
  function assertPTLSignupFlowSegmentName(ptlSignupFlowSegmentName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("bD4JrEqtTf4IACKroNfTR", label_ ? "PTL Signup Flow Segment Name" + ": " + label_ : "PTL Signup Flow Segment Name", ptlSignupFlowSegmentName));
    return messages;
  }
  
  function assertIsStudentsCountUpdated(isStudentsCountUpdated, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("bDM9SfUbv", label_ ? "Is Students Count Updated" + ": " + label_ : "Is Students Count Updated", isStudentsCountUpdated));
    return messages;
  }
  
  function assertReadingSystem(readingSystem, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("bJOqfTjmu", label_ ? "Reading System" + ": " + label_ : "Reading System", readingSystem));
    return messages;
  }
  
  function assertOptionalReadingSystem(readingSystem, label_) {
    var messages = [];
    if (readingSystem !== undefined && readingSystem !== null) {
      messages = messages.concat(AvoAssert.assertString("bJOqfTjmu", label_ ? "Reading System" + ": " + label_ : "Reading System", readingSystem));
    }
    return messages;
  }
  
  function assertQuestionCode(questionCode, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("bZZvnMF1m", label_ ? "Question Code" + ": " + label_ : "Question Code", questionCode));
    return messages;
  }
  
  function assertPlayAgainState(playAgainState, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("bZsbP1uDvn", label_ ? "Play Again State" + ": " + label_ : "Play Again State", playAgainState));
    if ("User initiated" !== playAgainState &&
        "Opponent Initiated" !== playAgainState &&
        "Friends joined" !== playAgainState) {
      var message = (label_ ? "Play Again State" + ": " + label_ : "Play Again State") + " should match one of the following values [ User initiated | Opponent Initiated | Friends joined ] but you provided the value " + playAgainState
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "bZsbP1uDvn", message: message}]);
    }
    return messages;
  }
  
  function assertMFAssignedStudentCount(mfAssignedStudentCount, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("ba_sAWHkZP", label_ ? "MF Assigned Student Count" + ": " + label_ : "MF Assigned Student Count", mfAssignedStudentCount));
    messages = messages.concat(AvoAssert.assertMin("ba_sAWHkZP", label_ ? "MF Assigned Student Count" + ": " + label_ : "MF Assigned Student Count", 1, mfAssignedStudentCount));
    return messages;
  }
  
  function assertCollectionType(collectionType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("bof7IBLkA", label_ ? "Collection Type" + ": " + label_ : "Collection Type", collectionType));
    return messages;
  }
  
  function assertOptionalCollectionType(collectionType, label_) {
    var messages = [];
    if (collectionType !== undefined && collectionType !== null) {
      messages = messages.concat(AvoAssert.assertString("bof7IBLkA", label_ ? "Collection Type" + ": " + label_ : "Collection Type", collectionType));
    }
    return messages;
  }
  
  function assertPlayableName(playableName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("c2W4X05Jy", label_ ? "Playable Name" + ": " + label_ : "Playable Name", playableName));
    return messages;
  }
  
  function assertOptionalPlayableName(playableName, label_) {
    var messages = [];
    if (playableName !== undefined && playableName !== null) {
      messages = messages.concat(AvoAssert.assertString("c2W4X05Jy", label_ ? "Playable Name" + ": " + label_ : "Playable Name", playableName));
    }
    return messages;
  }
  
  function assertOptionalReferrerPage(referrerPage, label_) {
    var messages = [];
    if (referrerPage !== undefined && referrerPage !== null) {
      messages = messages.concat(AvoAssert.assertString("cYVv-jM3n6", label_ ? "Referrer Page" + ": " + label_ : "Referrer Page", referrerPage));
    }
    return messages;
  }
  
  function assertReferrerPage(referrerPage, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("cYVv-jM3n6", label_ ? "Referrer Page" + ": " + label_ : "Referrer Page", referrerPage));
    return messages;
  }
  
  function assertInvitationSource(invitationSource, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("cccDu2odc", label_ ? "Invitation Source" + ": " + label_ : "Invitation Source", invitationSource));
    return messages;
  }
  
  function assertTappedOn(tappedOn, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("cfvmMqWft", label_ ? "Tapped On" + ": " + label_ : "Tapped On", tappedOn));
    return messages;
  }
  
  function assertAnswer(answer, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("coqPCyLyxy", label_ ? "Answer" + ": " + label_ : "Answer", answer));
    return messages;
  }
  
  function assertTopTab(topTab, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("ctnr0D9n3", label_ ? "Top Tab" + ": " + label_ : "Top Tab", topTab));
    return messages;
  }
  
  function assertTeacherName(teacherName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("d4VuJfq-Y", label_ ? "Teacher Name" + ": " + label_ : "Teacher Name", teacherName));
    return messages;
  }
  
  function assertOptionalPaymentMethodClicked(paymentMethodClicked, label_) {
    var messages = [];
    if (paymentMethodClicked !== undefined && paymentMethodClicked !== null) {
      messages = messages.concat(AvoAssert.assertString("dVRLZ1nWs", label_ ? "Payment Method Clicked" + ": " + label_ : "Payment Method Clicked", paymentMethodClicked));
    }
    return messages;
  }
  
  function assertClassType(classType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("dk2bhnFne", label_ ? "Class Type" + ": " + label_ : "Class Type", classType));
    if ("Google Classroom" !== classType &&
        "Clever" !== classType &&
        "Manual" !== classType) {
      var message = (label_ ? "Class Type" + ": " + label_ : "Class Type") + " should match one of the following values [ Google Classroom | Clever | Manual ] but you provided the value " + classType
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "dk2bhnFne", message: message}]);
    }
    return messages;
  }
  
  function assertOptionalClassType(classType, label_) {
    var messages = [];
    if (classType !== undefined && classType !== null) {
      messages = messages.concat(AvoAssert.assertString("dk2bhnFne", label_ ? "Class Type" + ": " + label_ : "Class Type", classType));
      if ("Google Classroom" !== classType &&
          "Clever" !== classType &&
          "Manual" !== classType) {
        var message = (label_ ? "Class Type" + ": " + label_ : "Class Type") + " should match one of the following values [ Google Classroom | Clever | Manual ] but you provided the value " + classType
        messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "dk2bhnFne", message: message}]);
      }
    }
    return messages;
  }
  
  function assertOptionalELAAssignmentCount(elaAssignmentCount, label_) {
    var messages = [];
    if (elaAssignmentCount !== undefined && elaAssignmentCount !== null) {
      messages = messages.concat(AvoAssert.assertInt("dqG7mb_H0j", label_ ? "ELA Assignment Count" + ": " + label_ : "ELA Assignment Count", elaAssignmentCount));
      messages = messages.concat(AvoAssert.assertMin("dqG7mb_H0j", label_ ? "ELA Assignment Count" + ": " + label_ : "ELA Assignment Count", 0, elaAssignmentCount));
    }
    return messages;
  }
  
  function assertOptionalRecommendedRail(recommendedRail, label_) {
    var messages = [];
    if (recommendedRail !== undefined && recommendedRail !== null) {
      messages = messages.concat(AvoAssert.assertList("drNgwJn5Xg", "Recommended Rail", recommendedRail));
      recommendedRail.forEach(function (value, index) {
      });
    }
    return messages;
  }
  
  function assertRecommendedRail(recommendedRail, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertList("drNgwJn5Xg", "Recommended Rail", recommendedRail));
    if (recommendedRail !== null && recommendedRail !== undefined && recommendedRail.forEach) {
      recommendedRail.forEach(function (value, index) {
      });
    }
    return messages;
  }
  
  function assertAnimationURL(animationUrl, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("dt9ueOw7v", label_ ? "Animation URL" + ": " + label_ : "Animation URL", animationUrl));
    return messages;
  }
  
  function assertOptionalDaysSinceSignup(daysSinceSignup, label_) {
    var messages = [];
    if (daysSinceSignup !== undefined && daysSinceSignup !== null) {
      messages = messages.concat(AvoAssert.assertString("e4g1zZQCJ", label_ ? "Days Since Signup" + ": " + label_ : "Days Since Signup", daysSinceSignup));
    }
    return messages;
  }
  
  function assertDaysSinceSignup(daysSinceSignup, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("e4g1zZQCJ", label_ ? "Days Since Signup" + ": " + label_ : "Days Since Signup", daysSinceSignup));
    return messages;
  }
  
  function assertOptionalColumnNumber(columnNumber, label_) {
    var messages = [];
    if (columnNumber !== undefined && columnNumber !== null) {
      messages = messages.concat(AvoAssert.assertInt("eGs90Bi3pM", label_ ? "Column Number" + ": " + label_ : "Column Number", columnNumber));
    }
    return messages;
  }
  
  function assertColumnNumber(columnNumber, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("eGs90Bi3pM", label_ ? "Column Number" + ": " + label_ : "Column Number", columnNumber));
    return messages;
  }
  
  function assertCollectionCode(collectionCode, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertList("eMtEG5HBc", "Collection Code", collectionCode));
    if (collectionCode !== null && collectionCode !== undefined && collectionCode.forEach) {
      collectionCode.forEach(function (value, index) {
      });
    }
    return messages;
  }
  
  function assertOptionalSubscriptionPlanName(subscriptionPlanName, label_) {
    var messages = [];
    if (subscriptionPlanName !== undefined && subscriptionPlanName !== null) {
      messages = messages.concat(AvoAssert.assertString("eOj3JBu_S", label_ ? "Subscription Plan Name" + ": " + label_ : "Subscription Plan Name", subscriptionPlanName));
    }
    return messages;
  }
  
  function assertLinkedStudentCount(linkedStudentCount, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("eb8RBK1CZ_91zt06w-5iv", label_ ? "Linked Student Count" + ": " + label_ : "Linked Student Count", linkedStudentCount));
    return messages;
  }
  
  function assertClassSize(classSize, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("erbI-IRpim", label_ ? "Class Size" + ": " + label_ : "Class Size", classSize));
    messages = messages.concat(AvoAssert.assertMin("erbI-IRpim", label_ ? "Class Size" + ": " + label_ : "Class Size", 0, classSize));
    return messages;
  }
  
  function assertChildLevel(childLevel, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("fIB6sY9mt", label_ ? "Child Level" + ": " + label_ : "Child Level", childLevel));
    return messages;
  }
  
  function assertMemoryUsagePercentage(memoryUsagePercentage, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertFloat("fXWDPkk_PZ", label_ ? "Memory Usage Percentage" + ": " + label_ : "Memory Usage Percentage", memoryUsagePercentage));
    return messages;
  }
  
  function assertNudgeName(nudgeName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("flFi1cYzR", label_ ? "Nudge Name" + ": " + label_ : "Nudge Name", nudgeName));
    return messages;
  }
  
  function assertModifiedDays(modifiedDays, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("fvYVVEdCul", label_ ? "Modified Days" + ": " + label_ : "Modified Days", modifiedDays));
    return messages;
  }
  
  function assertNumberOfMasterCards(numberOfMasterCards, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("fwzqzcIZ4", label_ ? "Number of 'Master' Cards" + ": " + label_ : "Number of 'Master' Cards", numberOfMasterCards));
    return messages;
  }
  
  function assertTargetValueAchieved(targetValueAchieved, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("fyvryNv-n-eInsoGrt_P5", label_ ? "Target Value Achieved" + ": " + label_ : "Target Value Achieved", targetValueAchieved));
    return messages;
  }
  
  function assertProfilesAvailable(profilesAvailable, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("g7JB969zv", label_ ? "Profiles Available" + ": " + label_ : "Profiles Available", profilesAvailable));
    return messages;
  }
  
  function assertWorksheetName(worksheetName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("g8uPZdwOmF", label_ ? "Worksheet Name" + ": " + label_ : "Worksheet Name", worksheetName));
    return messages;
  }
  
  function assertLOCode(loCode, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("gT0JuYf2B", label_ ? "LO Code" + ": " + label_ : "LO Code", loCode));
    return messages;
  }
  
  function assertCountOfGamesToJoin(countOfGamesToJoin, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("gTDYzkiHPP", label_ ? "Count of games to join" + ": " + label_ : "Count of games to join", countOfGamesToJoin));
    return messages;
  }
  
  function assertTotalTimeTaken(totalTimeTaken, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("gTep6toPK0", label_ ? "Total Time Taken" + ": " + label_ : "Total Time Taken", totalTimeTaken));
    return messages;
  }
  
  function assertSnCount(snCount, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("ggXrRwik-", label_ ? "Sn Count" + ": " + label_ : "Sn Count", snCount));
    return messages;
  }
  
  function assertSearchTerm(searchTerm, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("guJOTwi5T", label_ ? "Search Term" + ": " + label_ : "Search Term", searchTerm));
    return messages;
  }
  
  function assertOptionalSearchTerm(searchTerm, label_) {
    var messages = [];
    if (searchTerm !== undefined && searchTerm !== null) {
      messages = messages.concat(AvoAssert.assertString("guJOTwi5T", label_ ? "Search Term" + ": " + label_ : "Search Term", searchTerm));
    }
    return messages;
  }
  
  function assertUsedMemory(usedMemory, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertFloat("gvDk2xQI4d", label_ ? "Used Memory" + ": " + label_ : "Used Memory", usedMemory));
    return messages;
  }
  
  function assertContentCode(contentCode, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("gwbjSWtxS", label_ ? "Content Code" + ": " + label_ : "Content Code", contentCode));
    return messages;
  }
  
  function assertMFCustomSettingsClickedOn(mfCustomSettingsClickedOn, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("h2KwMOlZr5", label_ ? "MF Custom Settings - Clicked On" + ": " + label_ : "MF Custom Settings - Clicked On", mfCustomSettingsClickedOn));
    if ("Print Worksheet" !== mfCustomSettingsClickedOn &&
        "Select Students" !== mfCustomSettingsClickedOn) {
      var message = (label_ ? "MF Custom Settings - Clicked On" + ": " + label_ : "MF Custom Settings - Clicked On") + " should match one of the following values [ Print Worksheet | Select Students ] but you provided the value " + mfCustomSettingsClickedOn
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "h2KwMOlZr5", message: message}]);
    }
    return messages;
  }
  
  function assertFirstTime(firstTime, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("hApb_Iria", label_ ? "First Time" + ": " + label_ : "First Time", firstTime));
    return messages;
  }
  
  function assertTotalAssignmentCount(totalAssignmentCount, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("hBgoB0mPff", label_ ? "Total Assignment Count" + ": " + label_ : "Total Assignment Count", totalAssignmentCount));
    messages = messages.concat(AvoAssert.assertMin("hBgoB0mPff", label_ ? "Total Assignment Count" + ": " + label_ : "Total Assignment Count", 0, totalAssignmentCount));
    return messages;
  }
  
  function assertOptionalTotalAssignmentCount(totalAssignmentCount, label_) {
    var messages = [];
    if (totalAssignmentCount !== undefined && totalAssignmentCount !== null) {
      messages = messages.concat(AvoAssert.assertInt("hBgoB0mPff", label_ ? "Total Assignment Count" + ": " + label_ : "Total Assignment Count", totalAssignmentCount));
      messages = messages.concat(AvoAssert.assertMin("hBgoB0mPff", label_ ? "Total Assignment Count" + ": " + label_ : "Total Assignment Count", 0, totalAssignmentCount));
    }
    return messages;
  }
  
  function assertRailStrClickedCount(railStrClickedCount, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("hKAJ3izCFVFH-D4_886C8", label_ ? "Rail Str Clicked Count" + ": " + label_ : "Rail Str Clicked Count", railStrClickedCount));
    return messages;
  }
  
  function assertOptionalCategory(category, label_) {
    var messages = [];
    if (category !== undefined && category !== null) {
      messages = messages.concat(AvoAssert.assertString("hVOa_xHVR", label_ ? "Category" + ": " + label_ : "Category", category));
    }
    return messages;
  }
  
  function assertCategory(category, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("hVOa_xHVR", label_ ? "Category" + ": " + label_ : "Category", category));
    return messages;
  }
  
  function assertSkinColour(skinColour, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("hlzuuiCIe", label_ ? "Skin Colour" + ": " + label_ : "Skin Colour", skinColour));
    return messages;
  }
  
  function assertFirstQuest(firstQuest, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("hr6uH-iMXnpBW1gQsWcLH", label_ ? "First Quest" + ": " + label_ : "First Quest", firstQuest));
    return messages;
  }
  
  function assertCoachmarkText(coachmarkText, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("htmKRbaew", label_ ? "Coachmark Text" + ": " + label_ : "Coachmark Text", coachmarkText));
    return messages;
  }
  
  function assertReasonForSyncFailure(reasonForSyncFailure, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("iFDeKMBSm", label_ ? "Reason for Sync Failure" + ": " + label_ : "Reason for Sync Failure", reasonForSyncFailure));
    return messages;
  }
  
  function assertMilestoneSelected(milestoneSelected, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("iMRbxEjXB", label_ ? "Milestone Selected" + ": " + label_ : "Milestone Selected", milestoneSelected));
    return messages;
  }
  
  function assertIsDueDateUpdated(isDueDateUpdated, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("iMhjpqQ9V", label_ ? "Is Due Date Updated" + ": " + label_ : "Is Due Date Updated", isDueDateUpdated));
    return messages;
  }
  
  function assertOptionalEnglishGoal(englishGoal, label_) {
    var messages = [];
    if (englishGoal !== undefined && englishGoal !== null) {
      messages = messages.concat(AvoAssert.assertString("iOlmdC6rO", label_ ? "English Goal" + ": " + label_ : "English Goal", englishGoal));
    }
    return messages;
  }
  
  function assertReachedVia(reachedVia, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("iRAn4RfO3I", label_ ? "Reached Via" + ": " + label_ : "Reached Via", reachedVia));
    if ("New Fact Practice" !== reachedVia &&
        "Track Fact Practice" !== reachedVia) {
      var message = (label_ ? "Reached Via" + ": " + label_ : "Reached Via") + " should match one of the following values [ New Fact Practice | Track Fact Practice ] but you provided the value " + reachedVia
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "iRAn4RfO3I", message: message}]);
    }
    return messages;
  }
  
  function assertWinner(winner, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("j-WLQ2tjI", label_ ? "Winner" + ": " + label_ : "Winner", winner));
    if ("Bot" !== winner &&
        "Student" !== winner) {
      var message = (label_ ? "Winner" + ": " + label_ : "Winner") + " should match one of the following values [ Bot | Student ] but you provided the value " + winner
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "j-WLQ2tjI", message: message}]);
    }
    return messages;
  }
  
  function assertOptionalLevel1Topic(level1Topic, label_) {
    var messages = [];
    if (level1Topic !== undefined && level1Topic !== null) {
      messages = messages.concat(AvoAssert.assertString("jHXiFNYU2", label_ ? "Level 1 Topic" + ": " + label_ : "Level 1 Topic", level1Topic));
    }
    return messages;
  }
  
  function assertQuestionIndex(questionIndex, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("jJNP65jPw7", label_ ? "Question Index" + ": " + label_ : "Question Index", questionIndex));
    messages = messages.concat(AvoAssert.assertMin("jJNP65jPw7", label_ ? "Question Index" + ": " + label_ : "Question Index", 1, questionIndex));
    return messages;
  }
  
  function assertOptionalClickId(clickId, label_) {
    var messages = [];
    if (clickId !== undefined && clickId !== null) {
      messages = messages.concat(AvoAssert.assertString("jVQaLzj_1", label_ ? "Click Id" + ": " + label_ : "Click Id", clickId));
    }
    return messages;
  }
  
  function assertClickId(clickId, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("jVQaLzj_1", label_ ? "Click Id" + ": " + label_ : "Click Id", clickId));
    return messages;
  }
  
  function assertCurriculumAssignmentAvailable(curriculumAssignmentAvailable, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("jiop2Ii29S", label_ ? "Curriculum Assignment Available" + ": " + label_ : "Curriculum Assignment Available", curriculumAssignmentAvailable));
    return messages;
  }
  
  function assertOptionalRoundNumber(roundNumber, label_) {
    var messages = [];
    if (roundNumber !== undefined && roundNumber !== null) {
      messages = messages.concat(AvoAssert.assertInt("jw_xpal_L1", label_ ? "Round Number" + ": " + label_ : "Round Number", roundNumber));
    }
    return messages;
  }
  
  function assertRoundNumber(roundNumber, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("jw_xpal_L1", label_ ? "Round Number" + ": " + label_ : "Round Number", roundNumber));
    return messages;
  }
  
  function assertCleverClassesFetchCount(cleverClassesFetchCount, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("kCQhGPMSr", label_ ? "Clever Classes Fetch Count" + ": " + label_ : "Clever Classes Fetch Count", cleverClassesFetchCount));
    return messages;
  }
  
  function assertOptionalCategoryName(categoryName, label_) {
    var messages = [];
    if (categoryName !== undefined && categoryName !== null) {
      messages = messages.concat(AvoAssert.assertString("kZQO8-HD9", label_ ? "Category Name" + ": " + label_ : "Category Name", categoryName));
    }
    return messages;
  }
  
  function assertCategoryName(categoryName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("kZQO8-HD9", label_ ? "Category Name" + ": " + label_ : "Category Name", categoryName));
    return messages;
  }
  
  function assertCount(count, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("k_9EFdeYQ", label_ ? "Count" + ": " + label_ : "Count", count));
    return messages;
  }
  
  function assertQuizLiveClassId(quizLiveClassId, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("kjjqNSO2f", label_ ? "Quiz Live Class Id" + ": " + label_ : "Quiz Live Class Id", quizLiveClassId));
    return messages;
  }
  
  function assertInteraction(interaction, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("kwwJ5LAMqN", label_ ? "Interaction" + ": " + label_ : "Interaction", interaction));
    return messages;
  }
  
  function assertMilestoneName(milestoneName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("ky5tzfihY", label_ ? "Milestone Name" + ": " + label_ : "Milestone Name", milestoneName));
    return messages;
  }
  
  function assertTo(to, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("kz8nJYHNvkhWPcSeERcL2", label_ ? "To" + ": " + label_ : "To", to));
    return messages;
  }
  
  function assertOptionalValueName(valueName, label_) {
    var messages = [];
    if (valueName !== undefined && valueName !== null) {
      messages = messages.concat(AvoAssert.assertString("l-8JNUE0q", label_ ? "Value Name" + ": " + label_ : "Value Name", valueName));
    }
    return messages;
  }
  
  function assertValueName(valueName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("l-8JNUE0q", label_ ? "Value Name" + ": " + label_ : "Value Name", valueName));
    return messages;
  }
  
  function assertTabCode(tabCode, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("l9PbANZBu", label_ ? "Tab Code" + ": " + label_ : "Tab Code", tabCode));
    return messages;
  }
  
  function assertLearningPathSetting(learningPathSetting, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("lRClAbIX-", label_ ? "Learning Path Setting" + ": " + label_ : "Learning Path Setting", learningPathSetting));
    return messages;
  }
  
  function assertEnglishActiveGoals(englishActiveGoals, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("l_c9W4nI2", label_ ? "English Active Goals" + ": " + label_ : "English Active Goals", englishActiveGoals));
    return messages;
  }
  
  function assertPasswordType(passwordType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("ltdeD9kflSPTHD993aqQW", label_ ? "Password Type" + ": " + label_ : "Password Type", passwordType));
    return messages;
  }
  
  function assertModifiedTime(modifiedTime, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("m-vmQiLuIl", label_ ? "Modified Time" + ": " + label_ : "Modified Time", modifiedTime));
    return messages;
  }
  
  function assertTargetValue(targetValue, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("m8wssFRvZ8wgHs0IAO2mi", label_ ? "Target Value" + ": " + label_ : "Target Value", targetValue));
    return messages;
  }
  
  function assertEmail(email, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("mGe3lMWlNY", label_ ? "Email" + ": " + label_ : "Email", email));
    return messages;
  }
  
  function assertOptionalRowPosition(rowPosition, label_) {
    var messages = [];
    if (rowPosition !== undefined && rowPosition !== null) {
      messages = messages.concat(AvoAssert.assertInt("mOXSzLg0Im", label_ ? "Row Position" + ": " + label_ : "Row Position", rowPosition));
    }
    return messages;
  }
  
  function assertClickSource(clickSource, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("mVqeh4I8W", label_ ? "Click Source" + ": " + label_ : "Click Source", clickSource));
    return messages;
  }
  
  function assertOptionalClickSource(clickSource, label_) {
    var messages = [];
    if (clickSource !== undefined && clickSource !== null) {
      messages = messages.concat(AvoAssert.assertString("mVqeh4I8W", label_ ? "Click Source" + ": " + label_ : "Click Source", clickSource));
    }
    return messages;
  }
  
  function assertContentName(contentName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("mWOBwcMoZ", label_ ? "Content Name" + ": " + label_ : "Content Name", contentName));
    return messages;
  }
  
  function assertOptionalMathAssignmentCount(mathAssignmentCount, label_) {
    var messages = [];
    if (mathAssignmentCount !== undefined && mathAssignmentCount !== null) {
      messages = messages.concat(AvoAssert.assertInt("mdeQgK543Z", label_ ? "Math Assignment Count" + ": " + label_ : "Math Assignment Count", mathAssignmentCount));
      messages = messages.concat(AvoAssert.assertMin("mdeQgK543Z", label_ ? "Math Assignment Count" + ": " + label_ : "Math Assignment Count", 0, mathAssignmentCount));
    }
    return messages;
  }
  
  function assertStudentsAssignedTo(studentsAssignedTo, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("mvOIacTNl", label_ ? "Students Assigned To" + ": " + label_ : "Students Assigned To", studentsAssignedTo));
    return messages;
  }
  
  function assertOptionalSection(section, label_) {
    var messages = [];
    if (section !== undefined && section !== null) {
      messages = messages.concat(AvoAssert.assertString("my9qL7M8w6", label_ ? "Section" + ": " + label_ : "Section", section));
    }
    return messages;
  }
  
  function assertSection(section, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("my9qL7M8w6", label_ ? "Section" + ": " + label_ : "Section", section));
    return messages;
  }
  
  function assertLessonPlanSubject(lessonPlanSubject, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("n3rBqFq3X", label_ ? "Lesson Plan Subject" + ": " + label_ : "Lesson Plan Subject", lessonPlanSubject));
    return messages;
  }
  
  function assertOptionalClickedOnSection(clickedOnSection, label_) {
    var messages = [];
    if (clickedOnSection !== undefined && clickedOnSection !== null) {
      messages = messages.concat(AvoAssert.assertString("n4HbuwgZ_E", label_ ? "Clicked on Section" + ": " + label_ : "Clicked on Section", clickedOnSection));
    }
    return messages;
  }
  
  function assertOptionalDaysGoal(daysGoal, label_) {
    var messages = [];
    if (daysGoal !== undefined && daysGoal !== null) {
      messages = messages.concat(AvoAssert.assertList("nAyyn2Mnw", "Days Goal", daysGoal));
      daysGoal.forEach(function (value, index) {
      });
    }
    return messages;
  }
  
  function assertItemName(itemName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("nSZ12H8zV", label_ ? "Item Name" + ": " + label_ : "Item Name", itemName));
    return messages;
  }
  
  function assertOptionalSubscriberId(subscriberId, label_) {
    var messages = [];
    if (subscriberId !== undefined && subscriberId !== null) {
      messages = messages.concat(AvoAssert.assertString("nSwyEoLcJ", label_ ? "Subscriber Id" + ": " + label_ : "Subscriber Id", subscriberId));
    }
    return messages;
  }
  
  function assertFromPage(fromPage, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("nbgkWrkHkN", label_ ? "From Page" + ": " + label_ : "From Page", fromPage));
    return messages;
  }
  
  function assertOptionalInteractionDetails(interactionDetails, label_) {
    var messages = [];
    if (interactionDetails !== undefined && interactionDetails !== null) {
      messages = messages.concat(AvoAssert.assertString("ncdYto9gZ", label_ ? "Interaction Details" + ": " + label_ : "Interaction Details", interactionDetails));
      if ("Started Typing Credit Card Details" !== interactionDetails &&
          "Started Typing City" !== interactionDetails &&
          "Started Typing School" !== interactionDetails &&
          "Stopped Typing City" !== interactionDetails &&
          "Stopped Typing School" !== interactionDetails &&
          "Selected city from suggestions" !== interactionDetails &&
          "Selected school from suggestions" !== interactionDetails &&
          "Selected country from dropdown" !== interactionDetails &&
          "Selected state from dropdown" !== interactionDetails &&
          "Selected grade from dropdown" !== interactionDetails &&
          "Imported from csv/excel" !== interactionDetails &&
          "Typed" !== interactionDetails &&
          "Copy pasted" !== interactionDetails &&
          "Selected class" !== interactionDetails &&
          "Unselected class" !== interactionDetails &&
          "Started Typing ZIP Code" !== interactionDetails) {
        var message = (label_ ? "Interaction Details" + ": " + label_ : "Interaction Details") + " should match one of the following values [ Started Typing Credit Card Details | Started Typing City | Started Typing School | Stopped Typing City | Stopped Typing School | Selected city from suggestions | Selected school from suggestions | Selected country from dropdown | Selected state from dropdown | Selected grade from dropdown | Imported from csv/excel | Typed | Copy pasted | Selected class | Unselected class | Started Typing ZIP Code ] but you provided the value " + interactionDetails
        messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "ncdYto9gZ", message: message}]);
      }
    }
    return messages;
  }
  
  function assertInteractionDetails(interactionDetails, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("ncdYto9gZ", label_ ? "Interaction Details" + ": " + label_ : "Interaction Details", interactionDetails));
    if ("Started Typing Credit Card Details" !== interactionDetails &&
        "Started Typing City" !== interactionDetails &&
        "Started Typing School" !== interactionDetails &&
        "Stopped Typing City" !== interactionDetails &&
        "Stopped Typing School" !== interactionDetails &&
        "Selected city from suggestions" !== interactionDetails &&
        "Selected school from suggestions" !== interactionDetails &&
        "Selected country from dropdown" !== interactionDetails &&
        "Selected state from dropdown" !== interactionDetails &&
        "Selected grade from dropdown" !== interactionDetails &&
        "Imported from csv/excel" !== interactionDetails &&
        "Typed" !== interactionDetails &&
        "Copy pasted" !== interactionDetails &&
        "Selected class" !== interactionDetails &&
        "Unselected class" !== interactionDetails &&
        "Started Typing ZIP Code" !== interactionDetails) {
      var message = (label_ ? "Interaction Details" + ": " + label_ : "Interaction Details") + " should match one of the following values [ Started Typing Credit Card Details | Started Typing City | Started Typing School | Stopped Typing City | Stopped Typing School | Selected city from suggestions | Selected school from suggestions | Selected country from dropdown | Selected state from dropdown | Selected grade from dropdown | Imported from csv/excel | Typed | Copy pasted | Selected class | Unselected class | Started Typing ZIP Code ] but you provided the value " + interactionDetails
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "ncdYto9gZ", message: message}]);
    }
    return messages;
  }
  
  function assertMathActiveGoals(mathActiveGoals, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("o9Eq-BcYF", label_ ? "Math Active Goals" + ": " + label_ : "Math Active Goals", mathActiveGoals));
    return messages;
  }
  
  function assertStudentCountImportedClasses(studentCountImportedClasses, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertList("oZoIifrMw", "Student Count Imported Classes", studentCountImportedClasses));
    if (studentCountImportedClasses !== null && studentCountImportedClasses !== undefined && studentCountImportedClasses.forEach) {
      studentCountImportedClasses.forEach(function (value, index) {
      });
    }
    return messages;
  }
  
  function assertOptionalValidSavedCardExists(validSavedCardExists, label_) {
    var messages = [];
    if (validSavedCardExists !== undefined && validSavedCardExists !== null) {
      messages = messages.concat(AvoAssert.assertString("o_O7Lq7wz", label_ ? "Valid Saved Card Exists" + ": " + label_ : "Valid Saved Card Exists", validSavedCardExists));
      if ("Yes" !== validSavedCardExists &&
          "No" !== validSavedCardExists) {
        var message = (label_ ? "Valid Saved Card Exists" + ": " + label_ : "Valid Saved Card Exists") + " should match one of the following values [ Yes | No ] but you provided the value " + validSavedCardExists
        messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "o_O7Lq7wz", message: message}]);
      }
    }
    return messages;
  }
  
  function assertSearchResultSelected(searchResultSelected, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("of6hlcB4H", label_ ? "Search Result Selected" + ": " + label_ : "Search Result Selected", searchResultSelected));
    return messages;
  }
  
  function assertScreenHeight(screenHeight, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("ofwq9A74yc", label_ ? "Screen Height" + ": " + label_ : "Screen Height", screenHeight));
    return messages;
  }
  
  function assertFeatureSource(featureSource, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("ogGTBAdVa", label_ ? "Feature Source" + ": " + label_ : "Feature Source", featureSource));
    return messages;
  }
  
  function assertView(view, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("p6UnsWI0U", label_ ? "View" + ": " + label_ : "View", view));
    if ("withcross" !== view &&
        "withoutcross" !== view) {
      var message = (label_ ? "View" + ": " + label_ : "View") + " should match one of the following values [ withcross | withoutcross ] but you provided the value " + view
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "p6UnsWI0U", message: message}]);
    }
    return messages;
  }
  
  function assertInvitesAvailable(invitesAvailable, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("pFfp-zamld", label_ ? "Invites Available" + ": " + label_ : "Invites Available", invitesAvailable));
    return messages;
  }
  
  function assertOptionalSubscriptionPlansShown(subscriptionPlansShown, label_) {
    var messages = [];
    if (subscriptionPlansShown !== undefined && subscriptionPlansShown !== null) {
      messages = messages.concat(AvoAssert.assertList("pJEe4G1yr", "Subscription Plans Shown", subscriptionPlansShown));
      subscriptionPlansShown.forEach(function (value, index) {
      });
    }
    return messages;
  }
  
  function assertOptionalGooglePayButtonAvailable(googlePayButtonAvailable, label_) {
    var messages = [];
    if (googlePayButtonAvailable !== undefined && googlePayButtonAvailable !== null) {
      messages = messages.concat(AvoAssert.assertString("pMtnCZl-R", label_ ? "Google Pay Button Available" + ": " + label_ : "Google Pay Button Available", googlePayButtonAvailable));
      if ("Yes" !== googlePayButtonAvailable &&
          "No" !== googlePayButtonAvailable) {
        var message = (label_ ? "Google Pay Button Available" + ": " + label_ : "Google Pay Button Available") + " should match one of the following values [ Yes | No ] but you provided the value " + googlePayButtonAvailable
        messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "pMtnCZl-R", message: message}]);
      }
    }
    return messages;
  }
  
  function assertStudentName(studentName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("ptvPVC2md", label_ ? "Student Name" + ": " + label_ : "Student Name", studentName));
    return messages;
  }
  
  function assertScreenName(screenName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("qfHzr0Pfa", label_ ? "Screen Name" + ": " + label_ : "Screen Name", screenName));
    return messages;
  }
  
  function assertElaGrade(elaGrade, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("qvkkIrTx4s", label_ ? "Ela Grade" + ": " + label_ : "Ela Grade", elaGrade));
    if ("1" !== elaGrade &&
        "2" !== elaGrade &&
        "3" !== elaGrade &&
        "4" !== elaGrade &&
        "5" !== elaGrade &&
        "pk" !== elaGrade &&
        "k" !== elaGrade &&
        "NA" !== elaGrade) {
      var message = (label_ ? "Ela Grade" + ": " + label_ : "Ela Grade") + " should match one of the following values [ 1 | 2 | 3 | 4 | 5 | pk | k | NA ] but you provided the value " + elaGrade
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "qvkkIrTx4s", message: message}]);
    }
    return messages;
  }
  
  function assertEmailCount(emailCount, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("qw-3rdTO7", label_ ? "Email Count" + ": " + label_ : "Email Count", emailCount));
    return messages;
  }
  
  function assertIsGradeDifferent(isGradeDifferent, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("qwCZiUS_99", label_ ? "Is Grade Different" + ": " + label_ : "Is Grade Different", isGradeDifferent));
    return messages;
  }
  
  function assertZoom(zoom, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("rNJ9tqfNc", label_ ? "Zoom" + ": " + label_ : "Zoom", zoom));
    return messages;
  }
  
  function assertAdaptiveSwitchReason(adaptiveSwitchReason, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("rPcVX3AW0ohpa4UMeGcFG", label_ ? "Adaptive Switch Reason" + ": " + label_ : "Adaptive Switch Reason", adaptiveSwitchReason));
    return messages;
  }
  
  function assertPlayerBand(playerBand, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("rQb5nwMS5I", label_ ? "Player Band" + ": " + label_ : "Player Band", playerBand));
    return messages;
  }
  
  function assertCoachmarkName(coachmarkName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("rZrsY9rgC", label_ ? "Coachmark Name" + ": " + label_ : "Coachmark Name", coachmarkName));
    return messages;
  }
  
  function assertOptionalErrorMessageFromApi(errorMessageFromApi, label_) {
    var messages = [];
    if (errorMessageFromApi !== undefined && errorMessageFromApi !== null) {
      messages = messages.concat(AvoAssert.assertString("rbMXuJsBw", label_ ? "Error Message From Api" + ": " + label_ : "Error Message From Api", errorMessageFromApi));
    }
    return messages;
  }
  
  function assertOptionalPosition(position, label_) {
    var messages = [];
    if (position !== undefined && position !== null) {
      messages = messages.concat(AvoAssert.assertInt("rlSRn44vYq", label_ ? "Position" + ": " + label_ : "Position", position));
    }
    return messages;
  }
  
  function assertMFPracticeQuestionsCount(mfPracticeQuestionsCount, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("rpd15EbJEO", label_ ? "MF Practice Questions Count" + ": " + label_ : "MF Practice Questions Count", mfPracticeQuestionsCount));
    if ("20" !== mfPracticeQuestionsCount &&
        "30" !== mfPracticeQuestionsCount &&
        "40" !== mfPracticeQuestionsCount) {
      var message = (label_ ? "MF Practice Questions Count" + ": " + label_ : "MF Practice Questions Count") + " should match one of the following values [ 20 | 30 | 40 ] but you provided the value " + mfPracticeQuestionsCount
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "rpd15EbJEO", message: message}]);
    }
    return messages;
  }
  
  function assertOptionalNewGoals(newGoals, label_) {
    var messages = [];
    if (newGoals !== undefined && newGoals !== null) {
      messages = messages.concat(AvoAssert.assertString("s065vXrjO", label_ ? "New Goals" + ": " + label_ : "New Goals", newGoals));
    }
    return messages;
  }
  
  function assertMaxWorksheetViewed(maxWorksheetViewed, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("s4DOhHgK_6", label_ ? "Max Worksheet Viewed" + ": " + label_ : "Max Worksheet Viewed", maxWorksheetViewed));
    return messages;
  }
  
  function assertOptionalClickedOnCategory(clickedOnCategory, label_) {
    var messages = [];
    if (clickedOnCategory !== undefined && clickedOnCategory !== null) {
      messages = messages.concat(AvoAssert.assertString("s4K0XLoiQ", label_ ? "Clicked on Category" + ": " + label_ : "Clicked on Category", clickedOnCategory));
    }
    return messages;
  }
  
  function assertOptionalDailyPracticeTime(dailyPracticeTime, label_) {
    var messages = [];
    if (dailyPracticeTime !== undefined && dailyPracticeTime !== null) {
      messages = messages.concat(AvoAssert.assertInt("sGjYFiQA4", label_ ? "Daily Practice Time" + ": " + label_ : "Daily Practice Time", dailyPracticeTime));
    }
    return messages;
  }
  
  function assertDailyPracticeTime(dailyPracticeTime, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("sGjYFiQA4", label_ ? "Daily Practice Time" + ": " + label_ : "Daily Practice Time", dailyPracticeTime));
    return messages;
  }
  
  function assertRailStrStartedCount(railStrStartedCount, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("sRPi7ITwtlHeD7HQEGzmG", label_ ? "Rail Str Started Count" + ": " + label_ : "Rail Str Started Count", railStrStartedCount));
    return messages;
  }
  
  function assertOptionalLiveClassWeek(liveClassWeek, label_) {
    var messages = [];
    if (liveClassWeek !== undefined && liveClassWeek !== null) {
      messages = messages.concat(AvoAssert.assertString("spiyY6nfy", label_ ? "Live Class Week" + ": " + label_ : "Live Class Week", liveClassWeek));
    }
    return messages;
  }
  
  function assertStep(step, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("srWUcoAhJ", label_ ? "Step" + ": " + label_ : "Step", step));
    return messages;
  }
  
  function assertMFAssignmentAvailable(mfAssignmentAvailable, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("t3iU5mo89Y", label_ ? "MF Assignment Available" + ": " + label_ : "MF Assignment Available", mfAssignmentAvailable));
    return messages;
  }
  
  function assertPlayableType(playableType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("tHAI3DRE4", label_ ? "Playable Type" + ": " + label_ : "Playable Type", playableType));
    return messages;
  }
  
  function assertOptionalPlayableType(playableType, label_) {
    var messages = [];
    if (playableType !== undefined && playableType !== null) {
      messages = messages.concat(AvoAssert.assertString("tHAI3DRE4", label_ ? "Playable Type" + ": " + label_ : "Playable Type", playableType));
    }
    return messages;
  }
  
  function assertMFTimePerQuestion(mfTimePerQuestion, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("ti40sCZ5Kg", label_ ? "MF Time Per Question" + ": " + label_ : "MF Time Per Question", mfTimePerQuestion));
    if ("Off" !== mfTimePerQuestion &&
        "5 Secs" !== mfTimePerQuestion &&
        "10 Secs" !== mfTimePerQuestion &&
        "15 Secs" !== mfTimePerQuestion &&
        "20 Secs" !== mfTimePerQuestion) {
      var message = (label_ ? "MF Time Per Question" + ": " + label_ : "MF Time Per Question") + " should match one of the following values [ Off | 5 Secs | 10 Secs | 15 Secs | 20 Secs ] but you provided the value " + mfTimePerQuestion
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "ti40sCZ5Kg", message: message}]);
    }
    return messages;
  }
  
  function assertClassID(classId, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("tmoviENyM", label_ ? "Class ID" + ": " + label_ : "Class ID", classId));
    return messages;
  }
  
  function assertTotalClassesCount(totalClassesCount, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("tmyzDsXJ-", label_ ? "Total Classes Count" + ": " + label_ : "Total Classes Count", totalClassesCount));
    return messages;
  }
  
  function assertReadingSkill(readingSkill, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("tt7EpUhgU", label_ ? "Reading Skill" + ": " + label_ : "Reading Skill", readingSkill));
    return messages;
  }
  
  function assertAPIUrl(apiUrl, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("u9ncLCjsR", label_ ? "API Url" + ": " + label_ : "API Url", apiUrl));
    return messages;
  }
  
  function assertRecommendedRailRank(recommendedRailRank, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertList("uyLgqxbg7", "Recommended Rail Rank", recommendedRailRank));
    if (recommendedRailRank !== null && recommendedRailRank !== undefined && recommendedRailRank.forEach) {
      recommendedRailRank.forEach(function (value, index) {
      });
    }
    return messages;
  }
  
  function assertOptionalRecommendedRailRank(recommendedRailRank, label_) {
    var messages = [];
    if (recommendedRailRank !== undefined && recommendedRailRank !== null) {
      messages = messages.concat(AvoAssert.assertList("uyLgqxbg7", "Recommended Rail Rank", recommendedRailRank));
      recommendedRailRank.forEach(function (value, index) {
      });
    }
    return messages;
  }
  
  function assertOptionalCollectionDescription(collectionDescription, label_) {
    var messages = [];
    if (collectionDescription !== undefined && collectionDescription !== null) {
      messages = messages.concat(AvoAssert.assertString("v02OnlI5e", label_ ? "Collection Description" + ": " + label_ : "Collection Description", collectionDescription));
    }
    return messages;
  }
  
  function assertCollectionDescription(collectionDescription, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("v02OnlI5e", label_ ? "Collection Description" + ": " + label_ : "Collection Description", collectionDescription));
    return messages;
  }
  
  function assertTopicSelectionMode(topicSelectionMode, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("v2bSgov-m", label_ ? "Topic Selection Mode" + ": " + label_ : "Topic Selection Mode", topicSelectionMode));
    return messages;
  }
  
  function assertSearchResultPosition(searchResultPosition, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("vCfnwTQU8", label_ ? "Search Result Position" + ": " + label_ : "Search Result Position", searchResultPosition));
    return messages;
  }
  
  function assertUserCountry(userCountry, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("vHdXCmyiec", label_ ? "User Country" + ": " + label_ : "User Country", userCountry));
    return messages;
  }
  
  function assertOptionalGradeChanged(gradeChanged, label_) {
    var messages = [];
    if (gradeChanged !== undefined && gradeChanged !== null) {
      messages = messages.concat(AvoAssert.assertString("vbOzDO_fd", label_ ? "Grade Changed" + ": " + label_ : "Grade Changed", gradeChanged));
    }
    return messages;
  }
  
  function assertPlatform(platform, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("vjELcWf4BG", label_ ? "Platform" + ": " + label_ : "Platform", platform));
    return messages;
  }
  
  function assertQuizName(quizName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("w5nsMhHyb", label_ ? "Quiz Name" + ": " + label_ : "Quiz Name", quizName));
    return messages;
  }
  
  function assertOpponentCountry(opponentCountry, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("wT_TBNcHj2", label_ ? "Opponent Country" + ": " + label_ : "Opponent Country", opponentCountry));
    return messages;
  }
  
  function assertSpringboardWeek(springboardWeek, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("wZVJV2Yc5", label_ ? "Springboard Week" + ": " + label_ : "Springboard Week", springboardWeek));
    return messages;
  }
  
  function assertOptionsViewed(optionsViewed, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertList("xHPp8yOuv", "Options Viewed", optionsViewed));
    if (optionsViewed !== null && optionsViewed !== undefined && optionsViewed.forEach) {
      optionsViewed.forEach(function (value, index) {
      });
    }
    return messages;
  }
  
  function assertSelectedClassesForImporting(selectedClassesForImporting, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("xTv8S7XAS", label_ ? "Selected Classes for Importing" + ": " + label_ : "Selected Classes for Importing", selectedClassesForImporting));
    return messages;
  }
  
  function assertOptionalFilterName(filterName, label_) {
    var messages = [];
    if (filterName !== undefined && filterName !== null) {
      messages = messages.concat(AvoAssert.assertString("xU_rUr8u6", label_ ? "Filter Name" + ": " + label_ : "Filter Name", filterName));
    }
    return messages;
  }
  
  function assertFilterName(filterName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("xU_rUr8u6", label_ ? "Filter Name" + ": " + label_ : "Filter Name", filterName));
    return messages;
  }
  
  function assertUserType(userType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("xZ9GCD71LN", label_ ? "User Type" + ": " + label_ : "User Type", userType));
    if ("Teacher" !== userType &&
        "Parent" !== userType &&
        "Guest Parent" !== userType &&
        "Student" !== userType &&
        "Guest Teacher" !== userType) {
      var message = (label_ ? "User Type" + ": " + label_ : "User Type") + " should match one of the following values [ Teacher | Parent | Guest Parent | Student | Guest Teacher ] but you provided the value " + userType
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "xZ9GCD71LN", message: message}]);
    }
    return messages;
  }
  
  function assertFeatureSelected(featureSelected, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("xrO01pNoi", label_ ? "Feature Selected" + ": " + label_ : "Feature Selected", featureSelected));
    return messages;
  }
  
  function assertSignupFlow(signupFlow, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("y8YSspTxeO", label_ ? "Signup Flow" + ": " + label_ : "Signup Flow", signupFlow));
    if ("trial_class_25" !== signupFlow &&
        "classroom_linked" !== signupFlow &&
        "student_experience" !== signupFlow &&
        "classcode" !== signupFlow) {
      var message = (label_ ? "Signup Flow" + ": " + label_ : "Signup Flow") + " should match one of the following values [ trial_class_25 | classroom_linked | student_experience | classcode ] but you provided the value " + signupFlow
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "y8YSspTxeO", message: message}]);
    }
    return messages;
  }
  
  function assertRailState(railState, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("yPuqeki21", label_ ? "Rail State" + ": " + label_ : "Rail State", railState));
    return messages;
  }
  
  function assertVoURL(voUrl, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertList("yeiCDbEMb", "Vo URL", voUrl));
    if (voUrl !== null && voUrl !== undefined && voUrl.forEach) {
      voUrl.forEach(function (value, index) {
      });
    }
    return messages;
  }
  
  function assertOptionalVoURL(voUrl, label_) {
    var messages = [];
    if (voUrl !== undefined && voUrl !== null) {
      messages = messages.concat(AvoAssert.assertList("yeiCDbEMb", "Vo URL", voUrl));
      voUrl.forEach(function (value, index) {
      });
    }
    return messages;
  }
  
  function assertOptionalTimeGoal(timeGoal, label_) {
    var messages = [];
    if (timeGoal !== undefined && timeGoal !== null) {
      messages = messages.concat(AvoAssert.assertString("ypVRFOT1Z", label_ ? "Time Goal" + ": " + label_ : "Time Goal", timeGoal));
    }
    return messages;
  }
  
  function assertOptionalNumberOfCollectionsDeSelected(numberOfCollectionsDeSelected, label_) {
    var messages = [];
    if (numberOfCollectionsDeSelected !== undefined && numberOfCollectionsDeSelected !== null) {
      messages = messages.concat(AvoAssert.assertInt("ytpuP_rkW", label_ ? "Number of Collections De-Selected" + ": " + label_ : "Number of Collections De-Selected", numberOfCollectionsDeSelected));
    }
    return messages;
  }
  
  function assertWorksheetSubcategory(worksheetSubcategory, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("z0AEnWmrqD", label_ ? "Worksheet Subcategory" + ": " + label_ : "Worksheet Subcategory", worksheetSubcategory));
    return messages;
  }
  
  function assertOptionalSEOGradeSelected(seoGradeSelected, label_) {
    var messages = [];
    if (seoGradeSelected !== undefined && seoGradeSelected !== null) {
      messages = messages.concat(AvoAssert.assertString("zAaw21fC2", label_ ? "SEO Grade Selected" + ": " + label_ : "SEO Grade Selected", seoGradeSelected));
    }
    return messages;
  }
  
  function assertPendingNotification(pendingNotification, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("zCFxLL-Ai", label_ ? "Pending Notification" + ": " + label_ : "Pending Notification", pendingNotification));
    return messages;
  }
  
  function assertClickedOnStudentSelectionPopup(clickedOnStudentSelectionPopup, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("zDpSmq5T0V", label_ ? "Clicked on - Student Selection Popup" + ": " + label_ : "Clicked on - Student Selection Popup", clickedOnStudentSelectionPopup));
    if ("Assign" !== clickedOnStudentSelectionPopup) {
      var message = (label_ ? "Clicked on - Student Selection Popup" + ": " + label_ : "Clicked on - Student Selection Popup") + " should match one of the following values [ Assign ] but you provided the value " + clickedOnStudentSelectionPopup
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "zDpSmq5T0V", message: message}]);
    }
    return messages;
  }
  
  function assertStudentsAddedCount(studentsAddedCount, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("zE5EQnQZc", label_ ? "Students Added Count" + ": " + label_ : "Students Added Count", studentsAddedCount));
    return messages;
  }
  
  function assertOptionalFreeActivitiesLeftCount(freeActivitiesLeftCount, label_) {
    var messages = [];
    if (freeActivitiesLeftCount !== undefined && freeActivitiesLeftCount !== null) {
      messages = messages.concat(AvoAssert.assertInt("zY_qKY7KjA", label_ ? "Free Activities Left Count" + ": " + label_ : "Free Activities Left Count", freeActivitiesLeftCount));
    }
    return messages;
  }
  
  function assertFreeActivitiesLeftCount(freeActivitiesLeftCount, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("zY_qKY7KjA", label_ ? "Free Activities Left Count" + ": " + label_ : "Free Activities Left Count", freeActivitiesLeftCount));
    return messages;
  }
  
  function assertOptionalErrorStep(errorStep, label_) {
    var messages = [];
    if (errorStep !== undefined && errorStep !== null) {
      messages = messages.concat(AvoAssert.assertString("zagTegBN_", label_ ? "Error Step" + ": " + label_ : "Error Step", errorStep));
    }
    return messages;
  }
  
  function setAvoLogger(avoLogger) {
    __AVO_LOGGER__ = avoLogger;
  }
  
  var sysScreenHeight;
  
  function setSystemProperties(properties) {
    if (properties.screenHeight !== null && properties.screenHeight !== undefined) {
      sysScreenHeight = properties.screenHeight;
      assertScreenHeight(sysScreenHeight);
    }
  }
  
  function setSystemProperties_(properties) {
    if (properties.screenHeight !== null && properties.screenHeight !== undefined) {
      sysScreenHeight = properties.screenHeight;
      assertScreenHeight(sysScreenHeight);
    }
  }
  
  
  var CustomDestination;
  function setup_(options, systemProperties, CustomDestinationDestination, destinationOptions) {
    __WEB_DEBUGGER__ = false;
    if (options.validateProperties === true) {
      __AVO_DEV__ = true;
    }
    
    setSystemProperties_(systemProperties);
    
    destinationOptions = destinationOptions || {};
    
    if (!__AVO_NOOP__) {
      if (options.useProductionKey) {
      } else {
      }
      
      CustomDestination = CustomDestinationDestination;
      CustomDestination.make(options.useProductionKey);
      if (__AVO_DEV__) {
        // debug console in Avo
        _avo_invoke_meta(__AVO_ENV__, 'setup', [], 'setup');
      }
    }
  }
  
  function initAvo(options, systemProperties, destinationOptions, CustomDestinationDestination) {
    if (__AVO_ENV__ !== null) {
      return;
    }
    __AVO_ENV__ = options.env.toLowerCase();
    if (options.avoLogger !== undefined) {
      __AVO_LOGGER__ = options.avoLogger;
    }
    if (options.noop === true) {
      __AVO_NOOP__ = true;
    }
    if (__AVO_NOOP__ && __AVO_ENV__ == 'prod') {
      InternalAvoLogger.warn("****************************************************");
      InternalAvoLogger.warn("WARNING Avo cannot be initialized in noop mode in production:");
      InternalAvoLogger.warn("- Overwriting configuration with noop=false.");
      InternalAvoLogger.warn("- Please reach out if you want to be able to run Avo in production mode with noop=true");
      InternalAvoLogger.warn("****************************************************");
      __AVO_NOOP__ = false;
    }
    if (__AVO_NOOP__) {
      InternalAvoLogger.log("****************************************************");
      InternalAvoLogger.log("Avo is now initialized in noop mode. This means:");
      InternalAvoLogger.log("- No events will be sent");
      InternalAvoLogger.log("- No network requests are made");
      InternalAvoLogger.log("****************************************************");
    }
    if (options.strict !== undefined) {
      __STRICT__ = options.strict !== false;
    }
    if (options.reportFailureAs !== undefined) {
      __REPORT_FAILURE_AS__ = options.reportFailureAs;
    }
    __WEB_DEBUGGER__ = !__AVO_NOOP__ && ((typeof window !== 'undefined' && window.location.search.indexOf("avo_debug=1") > -1) || (options.webDebugger !== false && __AVO_ENV__ !== 'prod'));
    if (!__AVO_NOOP__ && options.inspector !== undefined) {
      __INSPECTOR__ = options.inspector;
    } else if (__AVO_ENV__ !== 'prod') {
      InternalAvoLogger.warn("Avo Inspector not provided in initAvo() call");
    }
    if (__AVO_ENV__ !== 'prod') {
      __AVO_DEV__ = true;
    }
    
    setSystemProperties(systemProperties);
    
    destinationOptions = destinationOptions || {};
    
    if (__WEB_DEBUGGER__ && !__AVO_NOOP__) {
    if (options.webDebuggerOptions && options.webDebuggerOptions.position) {
      const {
        BOTTOM_RIGHT,
        BOTTOM_LEFT,
        TOP_RIGHT,
        TOP_LEFT,
        } =
        WebDebuggerPosition.position;

      try {
        WebDebuggerAssertions.assertKey(
          options.webDebuggerOptions.position,
          "position",
          position => {
            return position === BOTTOM_RIGHT ||
            position === BOTTOM_LEFT ||
            position === TOP_RIGHT ||
            position === TOP_LEFT;
          }
        )
      } catch (e) {
        throw new Error('WebDebugger: Position object incorrect. Use methods from WebDebuggerPosition.');
      }

      const top = options.webDebuggerOptions.position.top || 0;
      const right = options.webDebuggerOptions.position.right || 0;
      const bottom = options.webDebuggerOptions.position.bottom || 0;
      const left = options.webDebuggerOptions.position.left || 0;

      let positionParams;

      switch (options.webDebuggerOptions.position.position) {
        case BOTTOM_RIGHT:
          positionParams = {
            position: BOTTOM_RIGHT,
            bottom,
            right,
          };
          break;
        case BOTTOM_LEFT:
          positionParams = {
            position: BOTTOM_LEFT,
            bottom,
            left,
          };
          break;
        case TOP_RIGHT:
          positionParams = {
            position: TOP_RIGHT,
            top,
            right,
          };
          break;
        case TOP_LEFT:
          positionParams = {
            position: TOP_LEFT,
            top,
            left,
          };
          break;
        default: throw new Error('WebDebugger: Position object incorrect. Use methods from WebDebuggerPosition.');
      }

      _avo_debugger_send_position(positionParams);
    }

(function() {
  if (typeof window === 'undefined') { return; }
  var init = function() {
    if (document.getElementById("avo-debugger") === null) {
      var iframe = document.createElement("iframe");
      document.body.appendChild(iframe);
      iframe.id = "avo-debugger";
      iframe.src = "https://www.avo.app/_debugger";
      iframe.style = "display: none;";
    }
  };

  if (document.body) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
      
    }
    if (!__AVO_NOOP__) {
      if (__AVO_ENV__ === 'prod') {
      }
      if (__AVO_ENV__ === 'dev') {
      }
      
      CustomDestination = CustomDestinationDestination;
      if (__AVO_ENV__ === 'prod') {
        CustomDestination.make && CustomDestination.make(__AVO_ENV__, "skPUDmCt3kW3bttlaOrVZ96m9uEuoIl0");
      } else if (__AVO_ENV__ === 'dev') {
        CustomDestination.make && CustomDestination.make(__AVO_ENV__, "skPUDmCt3kW3bttlaOrVZ96m9uEuoIl0");
      } else {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] No staging key is set for Custom Destination. Head to destination settings in Avo to set a staging key.");
        CustomDestination.make && CustomDestination.make(__AVO_ENV__, null);
      }
      if (__AVO_DEV__) {
        // debug console in Avo
        _avo_invoke_meta(__AVO_ENV__, 'init', [], 'init');
      }
    }
  }
  
  /**
   * Viewed Take-Tour Popup: This will be triggered when the user is shown the Take a Tour Pop-up during the onboarding journey.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/MSkdFC-Z0Z}
   */
  function viewedTakeTourPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Take-Tour Popup", Object.keys(properties), [
        "subject",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "MSkdFC-Z0Z", "ec1bf930c457c405ea5372875824b1ea0e241a91aa6fcab4e17d3b9021492ecc", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Take-Tour Popup", {
        "Subject": properties.subject,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("MSkdFC-Z0Z", "Viewed Take-Tour Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Take-Tour Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Take-Tour Popup", {
          "Subject": properties.subject,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "MSkdFC-Z0Z", "ec1bf930c457c405ea5372875824b1ea0e241a91aa6fcab4e17d3b9021492ecc");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Take-Tour Popup", {
      "Subject": properties.subject,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted on Take-Tour Popup: This will be triggered when the user clicks on Take a Tour Pop-up.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.interactedWith - This property will help us know where the user has clicked/interacted on the Pop-up.
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/eIF8UWSAVZ}
   */
  function interactedOnTakeTourPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertInteractedWith(properties.interactedWith));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted on Take-Tour Popup", Object.keys(properties), [
        "interactedWith",
        "subject",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "eIF8UWSAVZ", "1350640bfe88f2206a64c053f13461758a9a2351425b313241f7a5508db3909f", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted on Take-Tour Popup", {
        "Interacted With": properties.interactedWith,
        "Subject": properties.subject,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("eIF8UWSAVZ", "Interacted on Take-Tour Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "Ssr_b4cA9A", name: "Interacted With", value: properties.interactedWith},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted on Take-Tour Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted on Take-Tour Popup", {
          "Interacted With": properties.interactedWith,
          "Subject": properties.subject,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "eIF8UWSAVZ", "1350640bfe88f2206a64c053f13461758a9a2351425b313241f7a5508db3909f");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted on Take-Tour Popup", {
      "Interacted With": properties.interactedWith,
      "Subject": properties.subject,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted MP game tab: When the user clicks on a mini game, 'game invites' or 'classmates'
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/UBNqWf5cXD}
   */
  function interactedMpGameTab(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted MP game tab", Object.keys(properties), [
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "UBNqWf5cXD", "e0f1005e207d8a16ea94e59308d7844cbbb9e7b78cbeeea96942f24a2f653cc6", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted MP game tab", {
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("UBNqWf5cXD", "Interacted MP game tab", messages, [
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted MP game tab': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted MP game tab", {
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "UBNqWf5cXD", "e0f1005e207d8a16ea94e59308d7844cbbb9e7b78cbeeea96942f24a2f653cc6");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted MP game tab", {
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed MP Classmates Drawer: When the classmates drawer is shown after clicking on the 'Classmates' button
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {int} properties.onlineClassmates - Count of online classmates when Classmates Drawer is opened
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/JNPQbCl3U9}
   */
  function viewedMpClassmatesDrawer(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOnlineClassmates(properties.onlineClassmates));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed MP Classmates Drawer", Object.keys(properties), [
        "onlineClassmates"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "JNPQbCl3U9", "916ffb0d408f6dddd355cd5a144278cd6491b31a6286df9eca1e6cc16aeb07bf", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed MP Classmates Drawer", {
        "Online Classmates": properties.onlineClassmates,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("JNPQbCl3U9", "Viewed MP Classmates Drawer", messages, [
        {id: "-6EWaVnSU8", name: "Online Classmates", value: properties.onlineClassmates},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed MP Classmates Drawer': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed MP Classmates Drawer", {
          "Online Classmates": properties.onlineClassmates,
          "Screen Height": sysScreenHeight,
          }, "JNPQbCl3U9", "916ffb0d408f6dddd355cd5a144278cd6491b31a6286df9eca1e6cc16aeb07bf");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed MP Classmates Drawer", {
      "Online Classmates": properties.onlineClassmates,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed MP game tab: Upon clicking on the MP tab
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.countOfGamesToJoin - no description
   * @param {string} properties.countOfOnlineFriends - no description
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/NkI3XGDy5W}
   */
  function viewedMpGameTab(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertCountOfGamesToJoin(properties.countOfGamesToJoin));
      messages = messages.concat(assertCountOfOnlineFriends(properties.countOfOnlineFriends));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed MP game tab", Object.keys(properties), [
        "countOfGamesToJoin",
        "countOfOnlineFriends"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "NkI3XGDy5W", "23b198ad42f04fae4c82d499a814657db59ee8e66a21f3444243591152c770a5", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed MP game tab", {
        "Count of games to join": properties.countOfGamesToJoin,
        "Count of online friends": properties.countOfOnlineFriends,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("NkI3XGDy5W", "Viewed MP game tab", messages, [
        {id: "1hgGFRPeiA", name: "Count of online friends", value: properties.countOfOnlineFriends},
        {id: "gTDYzkiHPP", name: "Count of games to join", value: properties.countOfGamesToJoin},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed MP game tab': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed MP game tab", {
          "Count of games to join": properties.countOfGamesToJoin,
          "Count of online friends": properties.countOfOnlineFriends,
          "Screen Height": sysScreenHeight,
          }, "NkI3XGDy5W", "23b198ad42f04fae4c82d499a814657db59ee8e66a21f3444243591152c770a5");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed MP game tab", {
      "Count of games to join": properties.countOfGamesToJoin,
      "Count of online friends": properties.countOfOnlineFriends,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted MP Classmates Drawer: When the user interacts with classmates drawer
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {int} properties.onlineClassmates - Count of online classmates when Classmates Drawer is opened
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/-KzxvEzOvM}
   */
  function interactedMpClassmatesDrawer(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOnlineClassmates(properties.onlineClassmates));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted MP Classmates Drawer", Object.keys(properties), [
        "onlineClassmates",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "-KzxvEzOvM", "8c8ed56c4e6cd06ae4c7953c83b5a6852a387005dc193551a358ef943786155f", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted MP Classmates Drawer", {
        "Online Classmates": properties.onlineClassmates,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("-KzxvEzOvM", "Interacted MP Classmates Drawer", messages, [
        {id: "-6EWaVnSU8", name: "Online Classmates", value: properties.onlineClassmates},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted MP Classmates Drawer': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted MP Classmates Drawer", {
          "Online Classmates": properties.onlineClassmates,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "-KzxvEzOvM", "8c8ed56c4e6cd06ae4c7953c83b5a6852a387005dc193551a358ef943786155f");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted MP Classmates Drawer", {
      "Online Classmates": properties.onlineClassmates,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed MP Game Invites Drawer: When the game invites drawer is shown after clicking on the 'Game Invites' button
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {int} properties.invitesAvailable - Count of invites available when the drawer is viewed
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/SQiMt0jFUE}
   */
  function viewedMpGameInvitesDrawer(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertInvitesAvailable(properties.invitesAvailable));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed MP Game Invites Drawer", Object.keys(properties), [
        "invitesAvailable"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "SQiMt0jFUE", "a4cc9f03869b7065eaf6bba744675d6f084c156c58229bf2ea2bdf8d973431e6", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed MP Game Invites Drawer", {
        "Invites Available": properties.invitesAvailable,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("SQiMt0jFUE", "Viewed MP Game Invites Drawer", messages, [
        {id: "pFfp-zamld", name: "Invites Available", value: properties.invitesAvailable},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed MP Game Invites Drawer': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed MP Game Invites Drawer", {
          "Invites Available": properties.invitesAvailable,
          "Screen Height": sysScreenHeight,
          }, "SQiMt0jFUE", "a4cc9f03869b7065eaf6bba744675d6f084c156c58229bf2ea2bdf8d973431e6");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed MP Game Invites Drawer", {
      "Invites Available": properties.invitesAvailable,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted MP Game Invites Drawer: When the user interacts with the game invites drawer
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {int} properties.invitesAvailable - Count of invites available when the drawer is viewed
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/W7dU3uJ3ea}
   */
  function interactedMpGameInvitesDrawer(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertInvitesAvailable(properties.invitesAvailable));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted MP Game Invites Drawer", Object.keys(properties), [
        "invitesAvailable",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "W7dU3uJ3ea", "b1e754d81c414b269fd6845f94065d74d548878710d2721d4b2a9391aadfdb0d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted MP Game Invites Drawer", {
        "Invites Available": properties.invitesAvailable,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("W7dU3uJ3ea", "Interacted MP Game Invites Drawer", messages, [
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "pFfp-zamld", name: "Invites Available", value: properties.invitesAvailable},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted MP Game Invites Drawer': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted MP Game Invites Drawer", {
          "Invites Available": properties.invitesAvailable,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "W7dU3uJ3ea", "b1e754d81c414b269fd6845f94065d74d548878710d2721d4b2a9391aadfdb0d");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted MP Game Invites Drawer", {
      "Invites Available": properties.invitesAvailable,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed MP invite notification: When the user sees the game invite notification
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.state - Multiplayer: Is the multiplayer invitation still valid or expired

Freemium: Whether the content was 'locked' or 'free' in Freemium while the user interacted with it
   * @param {string} [properties.gameName] - Name of the Game being tapped (Optional)
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/7JdHxdW-BG}
   */
  function viewedMpInviteNotification(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertState(properties.state));
      messages = messages.concat(assertOptionalGameName(properties.gameName));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed MP invite notification", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "state",
        "gameName",
        "grade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "7JdHxdW-BG", "c1734fb9489c31f7bbea3ac2b8cfd6e06babb4394798fab77d906920d877baed", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed MP invite notification", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "State": properties.state,
        "Game Name": properties.gameName,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("7JdHxdW-BG", "Viewed MP invite notification", messages, [
        {id: "19zWDg2Ccm", name: "State", value: properties.state},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed MP invite notification': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed MP invite notification", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "State": properties.state,
          "Game Name": properties.gameName,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "7JdHxdW-BG", "c1734fb9489c31f7bbea3ac2b8cfd6e06babb4394798fab77d906920d877baed");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed MP invite notification", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "State": properties.state,
      "Game Name": properties.gameName,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted MP invite notification: When the user clicks on the game invite notification
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.state - Multiplayer: Is the multiplayer invitation still valid or expired

Freemium: Whether the content was 'locked' or 'free' in Freemium while the user interacted with it
   * @param {string} [properties.gameName] - Name of the Game being tapped (Optional)
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/wt_rx3iaqx}
   */
  function interactedMpInviteNotification(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertState(properties.state));
      messages = messages.concat(assertOptionalGameName(properties.gameName));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted MP invite notification", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "state",
        "gameName",
        "clickedOn",
        "grade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "wt_rx3iaqx", "c4596027f09e37a2b4e6320919ecf46e73bc6ba839ab11d5d036d493264e8ecf", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted MP invite notification", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "State": properties.state,
        "Game Name": properties.gameName,
        "Clicked On": properties.clickedOn,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("wt_rx3iaqx", "Interacted MP invite notification", messages, [
        {id: "19zWDg2Ccm", name: "State", value: properties.state},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted MP invite notification': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted MP invite notification", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "State": properties.state,
          "Game Name": properties.gameName,
          "Clicked On": properties.clickedOn,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "wt_rx3iaqx", "c4596027f09e37a2b4e6320919ecf46e73bc6ba839ab11d5d036d493264e8ecf");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted MP invite notification", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "State": properties.state,
      "Game Name": properties.gameName,
      "Clicked On": properties.clickedOn,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed MP Mode Selection Screen: The Game Mode selection screen, which comes after clicking on a game tile in Playzone main page
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} [properties.gameName] - Name of the Game being tapped (Optional)
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.playableCode - Pass the 'Playable Code' of the Playable being started/clicked
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/6mtusYc6Bo}
   */
  function viewedMpModeSelectionScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertOptionalGameName(properties.gameName));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertPlayableCode(properties.playableCode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed MP Mode Selection Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "gameName",
        "from",
        "elaGrade",
        "grade",
        "playableCode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "6mtusYc6Bo", "df6afedbc7977e47eb23f7996454965af1902083747d017362b2398669205db8", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed MP Mode Selection Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Game Name": properties.gameName,
        "From": properties.from,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Playable Code": properties.playableCode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("6mtusYc6Bo", "Viewed MP Mode Selection Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "QjCwFasvW0", name: "Playable Code", value: properties.playableCode},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed MP Mode Selection Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed MP Mode Selection Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Game Name": properties.gameName,
          "From": properties.from,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Playable Code": properties.playableCode,
          "Screen Height": sysScreenHeight,
          }, "6mtusYc6Bo", "df6afedbc7977e47eb23f7996454965af1902083747d017362b2398669205db8");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed MP Mode Selection Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Game Name": properties.gameName,
      "From": properties.from,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Playable Code": properties.playableCode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted MP Mode Selection Screen: Interaction in the Game Mode selection screen, which comes after clicking on a game tile in Playzone main page
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.gameMode - The mode of the game player is playing
   * @param {string} [properties.gameName] - Name of the Game being tapped (Optional)
   * @param {string} properties.playerBand - Band of the player
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.playableCode - Pass the 'Playable Code' of the Playable being started/clicked
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/9LFWQmHtqp}
   */
  function interactedMpModeSelectionScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGameMode(properties.gameMode));
      messages = messages.concat(assertOptionalGameName(properties.gameName));
      messages = messages.concat(assertPlayerBand(properties.playerBand));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertPlayableCode(properties.playableCode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted MP Mode Selection Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "gameMode",
        "gameName",
        "playerBand",
        "clickedOn",
        "elaGrade",
        "grade",
        "playableCode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "9LFWQmHtqp", "7ab2d0500db99d0c05e56c03eaadecc1f0461aa23a5681eef06be1a3de36601b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted MP Mode Selection Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Game Mode": properties.gameMode,
        "Game Name": properties.gameName,
        "Player Band": properties.playerBand,
        "Clicked On": properties.clickedOn,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Playable Code": properties.playableCode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("9LFWQmHtqp", "Interacted MP Mode Selection Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "QjCwFasvW0", name: "Playable Code", value: properties.playableCode},
        {id: "SCiKCU5kRo", name: "Game Mode", value: properties.gameMode},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "rQb5nwMS5I", name: "Player Band", value: properties.playerBand},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted MP Mode Selection Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted MP Mode Selection Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Game Mode": properties.gameMode,
          "Game Name": properties.gameName,
          "Player Band": properties.playerBand,
          "Clicked On": properties.clickedOn,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Playable Code": properties.playableCode,
          "Screen Height": sysScreenHeight,
          }, "9LFWQmHtqp", "7ab2d0500db99d0c05e56c03eaadecc1f0461aa23a5681eef06be1a3de36601b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted MP Mode Selection Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Game Mode": properties.gameMode,
      "Game Name": properties.gameName,
      "Player Band": properties.playerBand,
      "Clicked On": properties.clickedOn,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Playable Code": properties.playableCode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed MP Options Selection Screen: When the user lands on the game options selection screen
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} [properties.gameName] - Name of the Game being tapped (Optional)
   * @param {string} properties.gameMode - The mode of the game player is playing
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ghPmoCm7jQ}
   */
  function viewedMpOptionsSelectionScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertOptionalGameName(properties.gameName));
      messages = messages.concat(assertGameMode(properties.gameMode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed MP Options Selection Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "gameName",
        "gameMode",
        "grade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ghPmoCm7jQ", "f411c8ef09a3241d7c0affecdc66c0687285bebcfdf24e450e0f8117bc2bbed2", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed MP Options Selection Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Game Name": properties.gameName,
        "Game Mode": properties.gameMode,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ghPmoCm7jQ", "Viewed MP Options Selection Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "SCiKCU5kRo", name: "Game Mode", value: properties.gameMode},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed MP Options Selection Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed MP Options Selection Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Game Name": properties.gameName,
          "Game Mode": properties.gameMode,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "ghPmoCm7jQ", "f411c8ef09a3241d7c0affecdc66c0687285bebcfdf24e450e0f8117bc2bbed2");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed MP Options Selection Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Game Name": properties.gameName,
      "Game Mode": properties.gameMode,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted MP Options Selection Screen: When the user interacts with the game options selection screen
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.gameMode - The mode of the game player is playing
   * @param {string} [properties.gameName] - Name of the Game being tapped (Optional)
   * @param {string} [properties.topicName] - The academic name of the topic that user selected
   * @param {string} [properties.difficulty] - no description
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/mU1fymKPK7}
   */
  function interactedMpOptionsSelectionScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGameMode(properties.gameMode));
      messages = messages.concat(assertOptionalGameName(properties.gameName));
      messages = messages.concat(assertOptionalTopicName(properties.topicName));
      messages = messages.concat(assertOptionalDifficulty(properties.difficulty));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted MP Options Selection Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "gameMode",
        "gameName",
        "topicName",
        "difficulty",
        "clickedOn",
        "grade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "mU1fymKPK7", "8533cf36f1efe2b366f915f3e3b14ce0c0b3a994866d539d135892cf3191e14e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted MP Options Selection Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Game Mode": properties.gameMode,
        "Game Name": properties.gameName,
        "Topic Name": properties.topicName,
        "Difficulty": properties.difficulty,
        "Clicked On": properties.clickedOn,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("mU1fymKPK7", "Interacted MP Options Selection Screen", messages, [
        {id: "12tG17N4vG", name: "Difficulty", value: properties.difficulty},
        {id: "1Yc2cQ5iyN", name: "Topic Name", value: properties.topicName},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "SCiKCU5kRo", name: "Game Mode", value: properties.gameMode},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted MP Options Selection Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted MP Options Selection Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Game Mode": properties.gameMode,
          "Game Name": properties.gameName,
          "Topic Name": properties.topicName,
          "Difficulty": properties.difficulty,
          "Clicked On": properties.clickedOn,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "mU1fymKPK7", "8533cf36f1efe2b366f915f3e3b14ce0c0b3a994866d539d135892cf3191e14e");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted MP Options Selection Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Game Mode": properties.gameMode,
      "Game Name": properties.gameName,
      "Topic Name": properties.topicName,
      "Difficulty": properties.difficulty,
      "Clicked On": properties.clickedOn,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed MP Invite Friends Screen: When the user lands on the invite friends screen
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} [properties.gameName] - Name of the Game being tapped (Optional)
   * @param {string} properties.gameMode - The mode of the game player is playing
   * @param {string} [properties.topicName] - The academic name of the topic that user selected
   * @param {string} [properties.difficulty] - no description
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/AmnCjxWpXG}
   */
  function viewedMpInviteFriendsScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertOptionalGameName(properties.gameName));
      messages = messages.concat(assertGameMode(properties.gameMode));
      messages = messages.concat(assertOptionalTopicName(properties.topicName));
      messages = messages.concat(assertOptionalDifficulty(properties.difficulty));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed MP Invite Friends Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "gameName",
        "gameMode",
        "topicName",
        "difficulty",
        "grade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "AmnCjxWpXG", "7e2e9a60859231cbb45a03ef4aaf2e9271d87071b3b4f4c412f83195a9536996", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed MP Invite Friends Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Game Name": properties.gameName,
        "Game Mode": properties.gameMode,
        "Topic Name": properties.topicName,
        "Difficulty": properties.difficulty,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("AmnCjxWpXG", "Viewed MP Invite Friends Screen", messages, [
        {id: "12tG17N4vG", name: "Difficulty", value: properties.difficulty},
        {id: "1Yc2cQ5iyN", name: "Topic Name", value: properties.topicName},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "SCiKCU5kRo", name: "Game Mode", value: properties.gameMode},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed MP Invite Friends Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed MP Invite Friends Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Game Name": properties.gameName,
          "Game Mode": properties.gameMode,
          "Topic Name": properties.topicName,
          "Difficulty": properties.difficulty,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "AmnCjxWpXG", "7e2e9a60859231cbb45a03ef4aaf2e9271d87071b3b4f4c412f83195a9536996");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed MP Invite Friends Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Game Name": properties.gameName,
      "Game Mode": properties.gameMode,
      "Topic Name": properties.topicName,
      "Difficulty": properties.difficulty,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted MP Invite Friends Screen: When the user interacts with the invite friends screen
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} [properties.gameName] - Name of the Game being tapped (Optional)
   * @param {string} properties.gameMode - The mode of the game player is playing
   * @param {string} [properties.topicName] - The academic name of the topic that user selected
   * @param {string} [properties.difficulty] - no description
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Q19-PF_ZDV}
   */
  function interactedMpInviteFriendsScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertOptionalGameName(properties.gameName));
      messages = messages.concat(assertGameMode(properties.gameMode));
      messages = messages.concat(assertOptionalTopicName(properties.topicName));
      messages = messages.concat(assertOptionalDifficulty(properties.difficulty));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted MP Invite Friends Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "gameName",
        "gameMode",
        "topicName",
        "difficulty",
        "clickedOn",
        "grade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Q19-PF_ZDV", "b196405194c527e2e442408872c2391faa04efdfa4d470c988a3874c194c5fdf", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted MP Invite Friends Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Game Name": properties.gameName,
        "Game Mode": properties.gameMode,
        "Topic Name": properties.topicName,
        "Difficulty": properties.difficulty,
        "Clicked On": properties.clickedOn,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Q19-PF_ZDV", "Interacted MP Invite Friends Screen", messages, [
        {id: "12tG17N4vG", name: "Difficulty", value: properties.difficulty},
        {id: "1Yc2cQ5iyN", name: "Topic Name", value: properties.topicName},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "SCiKCU5kRo", name: "Game Mode", value: properties.gameMode},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted MP Invite Friends Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted MP Invite Friends Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Game Name": properties.gameName,
          "Game Mode": properties.gameMode,
          "Topic Name": properties.topicName,
          "Difficulty": properties.difficulty,
          "Clicked On": properties.clickedOn,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "Q19-PF_ZDV", "b196405194c527e2e442408872c2391faa04efdfa4d470c988a3874c194c5fdf");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted MP Invite Friends Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Game Name": properties.gameName,
      "Game Mode": properties.gameMode,
      "Topic Name": properties.topicName,
      "Difficulty": properties.difficulty,
      "Clicked On": properties.clickedOn,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed MP Game Loader Screen: When the game loader screen comes after selecting all options
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.gameName] - Name of the Game being tapped (Optional)
   * @param {string} properties.gameMode - The mode of the game player is playing
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/2dfVM_yh-2}
   */
  function viewedMpGameLoaderScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalGameName(properties.gameName));
      messages = messages.concat(assertGameMode(properties.gameMode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed MP Game Loader Screen", Object.keys(properties), [
        "gameName",
        "gameMode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "2dfVM_yh-2", "a0954138cc00f17501802a2e3b115912cfc01134653dcdb8c21411f7155e5314", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed MP Game Loader Screen", {
        "Game Name": properties.gameName,
        "Game Mode": properties.gameMode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("2dfVM_yh-2", "Viewed MP Game Loader Screen", messages, [
        {id: "SCiKCU5kRo", name: "Game Mode", value: properties.gameMode},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed MP Game Loader Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed MP Game Loader Screen", {
          "Game Name": properties.gameName,
          "Game Mode": properties.gameMode,
          "Screen Height": sysScreenHeight,
          }, "2dfVM_yh-2", "a0954138cc00f17501802a2e3b115912cfc01134653dcdb8c21411f7155e5314");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed MP Game Loader Screen", {
      "Game Name": properties.gameName,
      "Game Mode": properties.gameMode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed MP Game play screen: When the game actually starts (at student level)
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.gameMode - The mode of the game player is playing
   * @param {string} [properties.gameName] - Name of the Game being tapped (Optional)
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/_ewD-1nCoc}
   */
  function viewedMpGamePlayScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGameMode(properties.gameMode));
      messages = messages.concat(assertOptionalGameName(properties.gameName));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed MP Game play screen", Object.keys(properties), [
        "gameMode",
        "gameName",
        "from"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "_ewD-1nCoc", "4c40dfdcad61d771d054e80745cc0248aedb51c3e0c38538af3c6efd064f96a7", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed MP Game play screen", {
        "Game Mode": properties.gameMode,
        "Game Name": properties.gameName,
        "From": properties.from,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("_ewD-1nCoc", "Viewed MP Game play screen", messages, [
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "SCiKCU5kRo", name: "Game Mode", value: properties.gameMode},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed MP Game play screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed MP Game play screen", {
          "Game Mode": properties.gameMode,
          "Game Name": properties.gameName,
          "From": properties.from,
          "Screen Height": sysScreenHeight,
          }, "_ewD-1nCoc", "4c40dfdcad61d771d054e80745cc0248aedb51c3e0c38538af3c6efd064f96a7");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed MP Game play screen", {
      "Game Mode": properties.gameMode,
      "Game Name": properties.gameName,
      "From": properties.from,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Opponent Search Started: When 1v1 opponent search is started
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.gameName] - Name of the Game being tapped (Optional)
   * @param {string} properties.gameMode - The mode of the game player is playing
   * @param {string} properties.userCity - Name of the city the user is from
   * @param {string} properties.userCountry - Name of the country the user is from
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/3MqfYYony}
   */
  function opponentSearchStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalGameName(properties.gameName));
      messages = messages.concat(assertGameMode(properties.gameMode));
      messages = messages.concat(assertUserCity(properties.userCity));
      messages = messages.concat(assertUserCountry(properties.userCountry));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Opponent Search Started", Object.keys(properties), [
        "gameName",
        "gameMode",
        "userCity",
        "userCountry"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "3MqfYYony", "18ade68e07bf220ee102d59231532c3db00f6a90b90fa9d12e8a59afd02c2123", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Opponent Search Started", {
        "Game Name": properties.gameName,
        "Game Mode": properties.gameMode,
        "User City": properties.userCity,
        "User Country": properties.userCountry,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("3MqfYYony", "Opponent Search Started", messages, [
        {id: "Gh85Hi8uN0", name: "User City", value: properties.userCity},
        {id: "SCiKCU5kRo", name: "Game Mode", value: properties.gameMode},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "vHdXCmyiec", name: "User Country", value: properties.userCountry},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Opponent Search Started': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Opponent Search Started", {
          "Game Name": properties.gameName,
          "Game Mode": properties.gameMode,
          "User City": properties.userCity,
          "User Country": properties.userCountry,
          "Screen Height": sysScreenHeight,
          }, "3MqfYYony", "18ade68e07bf220ee102d59231532c3db00f6a90b90fa9d12e8a59afd02c2123");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Opponent Search Started", {
      "Game Name": properties.gameName,
      "Game Mode": properties.gameMode,
      "User City": properties.userCity,
      "User Country": properties.userCountry,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Opponent Found: When 1v1 opponent is found (either bot or human)
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.gameName] - Name of the Game being tapped (Optional)
   * @param {string} properties.gameMode - The mode of the game player is playing
   * @param {string} properties.opponentType - Type of opponent which got matched
   * @param {string} properties.opponentCity - no description
   * @param {string} properties.opponentCountry - no description
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/i9BMwZIVVB}
   */
  function opponentFound(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalGameName(properties.gameName));
      messages = messages.concat(assertGameMode(properties.gameMode));
      messages = messages.concat(assertOpponentType(properties.opponentType));
      messages = messages.concat(assertOpponentCity(properties.opponentCity));
      messages = messages.concat(assertOpponentCountry(properties.opponentCountry));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Opponent Found", Object.keys(properties), [
        "gameName",
        "gameMode",
        "opponentType",
        "opponentCity",
        "opponentCountry"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "i9BMwZIVVB", "c04719dcf8ccbd9e43a57db452e6365b9b0d51aacf78f581a45dcdcecb61e78c", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Opponent Found", {
        "Game Name": properties.gameName,
        "Game Mode": properties.gameMode,
        "Opponent Type": properties.opponentType,
        "Opponent City": properties.opponentCity,
        "Opponent Country": properties.opponentCountry,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("i9BMwZIVVB", "Opponent Found", messages, [
        {id: "P9dar0xMXW", name: "Opponent City", value: properties.opponentCity},
        {id: "SCiKCU5kRo", name: "Game Mode", value: properties.gameMode},
        {id: "U2QSiMZrpE", name: "Opponent Type", value: properties.opponentType},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "wT_TBNcHj2", name: "Opponent Country", value: properties.opponentCountry},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Opponent Found': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Opponent Found", {
          "Game Name": properties.gameName,
          "Game Mode": properties.gameMode,
          "Opponent Type": properties.opponentType,
          "Opponent City": properties.opponentCity,
          "Opponent Country": properties.opponentCountry,
          "Screen Height": sysScreenHeight,
          }, "i9BMwZIVVB", "c04719dcf8ccbd9e43a57db452e6365b9b0d51aacf78f581a45dcdcecb61e78c");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Opponent Found", {
      "Game Name": properties.gameName,
      "Game Mode": properties.gameMode,
      "Opponent Type": properties.opponentType,
      "Opponent City": properties.opponentCity,
      "Opponent Country": properties.opponentCountry,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Countdown Animation Started: When the countdown animation starts
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/A3HU3gCLIr/trigger/DgAm8aw2E
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.gameName] - Name of the Game being tapped (Optional)
   * @param {string} properties.gameMode - The mode of the game player is playing
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/A3HU3gCLIr}
   */
  function countdownAnimationStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalGameName(properties.gameName));
      messages = messages.concat(assertGameMode(properties.gameMode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Countdown Animation Started", Object.keys(properties), [
        "gameName",
        "gameMode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "A3HU3gCLIr", "197b69db6f80463f092fc40a42855d539e2b1a09568fcbce5aae37b221a18ed2", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Countdown Animation Started", {
        "Game Name": properties.gameName,
        "Game Mode": properties.gameMode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("A3HU3gCLIr", "Countdown Animation Started", messages, [
        {id: "SCiKCU5kRo", name: "Game Mode", value: properties.gameMode},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Countdown Animation Started': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Countdown Animation Started", {
          "Game Name": properties.gameName,
          "Game Mode": properties.gameMode,
          "Screen Height": sysScreenHeight,
          }, "A3HU3gCLIr", "197b69db6f80463f092fc40a42855d539e2b1a09568fcbce5aae37b221a18ed2");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Countdown Animation Started", {
      "Game Name": properties.gameName,
      "Game Mode": properties.gameMode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed MP questions exhausted screen: When the player has completed all questions and land on the 'waiting for other players to finish' screen
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.gameName] - Name of the Game being tapped (Optional)
   * @param {string} properties.gameMode - The mode of the game player is playing
   * @param {string} properties.opponentType - Type of opponent which got matched
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/HaJwK75SM}
   */
  function viewedMpQuestionsExhaustedScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalGameName(properties.gameName));
      messages = messages.concat(assertGameMode(properties.gameMode));
      messages = messages.concat(assertOpponentType(properties.opponentType));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed MP questions exhausted screen", Object.keys(properties), [
        "gameName",
        "gameMode",
        "opponentType"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "HaJwK75SM", "c3e749143f5c6adfbb9c7f6857a12044908ac2bfb304b57ec840d785e6055906", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed MP questions exhausted screen", {
        "Game Name": properties.gameName,
        "Game Mode": properties.gameMode,
        "Opponent Type": properties.opponentType,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("HaJwK75SM", "Viewed MP questions exhausted screen", messages, [
        {id: "SCiKCU5kRo", name: "Game Mode", value: properties.gameMode},
        {id: "U2QSiMZrpE", name: "Opponent Type", value: properties.opponentType},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed MP questions exhausted screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed MP questions exhausted screen", {
          "Game Name": properties.gameName,
          "Game Mode": properties.gameMode,
          "Opponent Type": properties.opponentType,
          "Screen Height": sysScreenHeight,
          }, "HaJwK75SM", "c3e749143f5c6adfbb9c7f6857a12044908ac2bfb304b57ec840d785e6055906");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed MP questions exhausted screen", {
      "Game Name": properties.gameName,
      "Game Mode": properties.gameMode,
      "Opponent Type": properties.opponentType,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed MP Game Lobby: When the user lands on the 1v1 game lobby screen
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.gameName] - Name of the Game being tapped (Optional)
   * @param {string} properties.gameMode - The mode of the game player is playing
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {string} [properties.referrerPage] - Shows the description of the previous page name/URL
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/jp7yphWiL-}
   */
  function viewedMpGameLobby(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalGameName(properties.gameName));
      messages = messages.concat(assertGameMode(properties.gameMode));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertOptionalReferrerPage(properties.referrerPage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed MP Game Lobby", Object.keys(properties), [
        "gameName",
        "gameMode",
        "from",
        "referrerPage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "jp7yphWiL-", "32c383cbc88a0981d4ba19e2c24ad4b7053bf3623f9249b1efb2896f7c89056b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed MP Game Lobby", {
        "Game Name": properties.gameName,
        "Game Mode": properties.gameMode,
        "From": properties.from,
        "Referrer Page": properties.referrerPage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("jp7yphWiL-", "Viewed MP Game Lobby", messages, [
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "SCiKCU5kRo", name: "Game Mode", value: properties.gameMode},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "cYVv-jM3n6", name: "Referrer Page", value: properties.referrerPage},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed MP Game Lobby': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed MP Game Lobby", {
          "Game Name": properties.gameName,
          "Game Mode": properties.gameMode,
          "From": properties.from,
          "Referrer Page": properties.referrerPage,
          "Screen Height": sysScreenHeight,
          }, "jp7yphWiL-", "32c383cbc88a0981d4ba19e2c24ad4b7053bf3623f9249b1efb2896f7c89056b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed MP Game Lobby", {
      "Game Name": properties.gameName,
      "Game Mode": properties.gameMode,
      "From": properties.from,
      "Referrer Page": properties.referrerPage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted MP Game Lobby: When the user interacts with the 1v1 game lobby screen
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.gameName] - Name of the Game being tapped (Optional)
   * @param {string} properties.gameMode - The mode of the game player is playing
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/MWCTaK2cLc}
   */
  function interactedMpGameLobby(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalGameName(properties.gameName));
      messages = messages.concat(assertGameMode(properties.gameMode));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted MP Game Lobby", Object.keys(properties), [
        "gameName",
        "gameMode",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "MWCTaK2cLc", "8fbdabfe48a88dbef8330b33b1c5abb74b2315e1a9711c8fe72d5f9530f5bfd1", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted MP Game Lobby", {
        "Game Name": properties.gameName,
        "Game Mode": properties.gameMode,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("MWCTaK2cLc", "Interacted MP Game Lobby", messages, [
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "SCiKCU5kRo", name: "Game Mode", value: properties.gameMode},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted MP Game Lobby': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted MP Game Lobby", {
          "Game Name": properties.gameName,
          "Game Mode": properties.gameMode,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "MWCTaK2cLc", "8fbdabfe48a88dbef8330b33b1c5abb74b2315e1a9711c8fe72d5f9530f5bfd1");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted MP Game Lobby", {
      "Game Name": properties.gameName,
      "Game Mode": properties.gameMode,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed MP game rewards screen: When user views the rewards screen after gameplay
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.gameName] - Name of the Game being tapped (Optional)
   * @param {string} properties.gameMode - The mode of the game player is playing
   * @param {string} properties.winner - no description
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/zjROke5TKW}
   */
  function viewedMpGameRewardsScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalGameName(properties.gameName));
      messages = messages.concat(assertGameMode(properties.gameMode));
      messages = messages.concat(assertWinner(properties.winner));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed MP game rewards screen", Object.keys(properties), [
        "gameName",
        "gameMode",
        "winner"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "zjROke5TKW", "97221c32f14ffd2de8ea6386be71d7880f9bf14edddf2e769b86e555c2080bcc", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed MP game rewards screen", {
        "Game Name": properties.gameName,
        "Game Mode": properties.gameMode,
        "Winner": properties.winner,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("zjROke5TKW", "Viewed MP game rewards screen", messages, [
        {id: "SCiKCU5kRo", name: "Game Mode", value: properties.gameMode},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "j-WLQ2tjI", name: "Winner", value: properties.winner},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed MP game rewards screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed MP game rewards screen", {
          "Game Name": properties.gameName,
          "Game Mode": properties.gameMode,
          "Winner": properties.winner,
          "Screen Height": sysScreenHeight,
          }, "zjROke5TKW", "97221c32f14ffd2de8ea6386be71d7880f9bf14edddf2e769b86e555c2080bcc");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed MP game rewards screen", {
      "Game Name": properties.gameName,
      "Game Mode": properties.gameMode,
      "Winner": properties.winner,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed MP Rematch Popup: When opponent sees the rematch popup after rewards screen
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.gameName] - Name of the Game being tapped (Optional)
   * @param {string} properties.gameMode - The mode of the game player is playing
   * @param {string} properties.winner - no description
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/gZZTa4cJeO}
   */
  function viewedMpRematchPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalGameName(properties.gameName));
      messages = messages.concat(assertGameMode(properties.gameMode));
      messages = messages.concat(assertWinner(properties.winner));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed MP Rematch Popup", Object.keys(properties), [
        "gameName",
        "gameMode",
        "winner"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "gZZTa4cJeO", "eb1fc06beb2fb2d2ce9c15e3864a127d798240503064d32ffe214302f2f5c2dd", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed MP Rematch Popup", {
        "Game Name": properties.gameName,
        "Game Mode": properties.gameMode,
        "Winner": properties.winner,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("gZZTa4cJeO", "Viewed MP Rematch Popup", messages, [
        {id: "SCiKCU5kRo", name: "Game Mode", value: properties.gameMode},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "j-WLQ2tjI", name: "Winner", value: properties.winner},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed MP Rematch Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed MP Rematch Popup", {
          "Game Name": properties.gameName,
          "Game Mode": properties.gameMode,
          "Winner": properties.winner,
          "Screen Height": sysScreenHeight,
          }, "gZZTa4cJeO", "eb1fc06beb2fb2d2ce9c15e3864a127d798240503064d32ffe214302f2f5c2dd");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed MP Rematch Popup", {
      "Game Name": properties.gameName,
      "Game Mode": properties.gameMode,
      "Winner": properties.winner,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted MP Rematch Popup: When user interacts with rematch popup
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.tappedOn - UI element that user tapped on - used in conjunction with the event name which identifies the screen name
   * @param {string} properties.gameMode - The mode of the game player is playing
   * @param {string} properties.winner - no description
   * @param {string} [properties.gameName] - Name of the Game being tapped (Optional)
   * @param {string} properties.playAgainState - no description
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/V5bm2a68De}
   */
  function interactedMpRematchPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertTappedOn(properties.tappedOn));
      messages = messages.concat(assertGameMode(properties.gameMode));
      messages = messages.concat(assertWinner(properties.winner));
      messages = messages.concat(assertOptionalGameName(properties.gameName));
      messages = messages.concat(assertPlayAgainState(properties.playAgainState));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted MP Rematch Popup", Object.keys(properties), [
        "tappedOn",
        "gameMode",
        "winner",
        "gameName",
        "playAgainState"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "V5bm2a68De", "a545de36f290fd29f9c3561701615b1c2eafb60b1179e49bd66d8caa5269d0f7", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted MP Rematch Popup", {
        "Tapped On": properties.tappedOn,
        "Game Mode": properties.gameMode,
        "Winner": properties.winner,
        "Game Name": properties.gameName,
        "Play Again State": properties.playAgainState,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("V5bm2a68De", "Interacted MP Rematch Popup", messages, [
        {id: "SCiKCU5kRo", name: "Game Mode", value: properties.gameMode},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "bZsbP1uDvn", name: "Play Again State", value: properties.playAgainState},
        {id: "cfvmMqWft", name: "Tapped On", value: properties.tappedOn},
        {id: "j-WLQ2tjI", name: "Winner", value: properties.winner},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted MP Rematch Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted MP Rematch Popup", {
          "Tapped On": properties.tappedOn,
          "Game Mode": properties.gameMode,
          "Winner": properties.winner,
          "Game Name": properties.gameName,
          "Play Again State": properties.playAgainState,
          "Screen Height": sysScreenHeight,
          }, "V5bm2a68De", "a545de36f290fd29f9c3561701615b1c2eafb60b1179e49bd66d8caa5269d0f7");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted MP Rematch Popup", {
      "Tapped On": properties.tappedOn,
      "Game Mode": properties.gameMode,
      "Winner": properties.winner,
      "Game Name": properties.gameName,
      "Play Again State": properties.playAgainState,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Post 3PM Pop-Up: This event should be triggered when we show the Post 3PM Pop-up/Blocker to the student.
   * 
   * When to trigger this event:
   * 1. This event should be triggered when we show the Post 3PM Pop-up/Blocker to the student
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/cAqkdiuXFJ/trigger/HYuOFvfQU
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.view - View will represent weather the pop-up view has a cross or not; The default value of the event property will be 'withoutcross' as the default pop-up is without cross. 
The other value of this event property will be 'withcross' when we are showing the pop-up with cross.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/cAqkdiuXFJ}
   */
  function viewedPost3pmPopUp(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertView(properties.view));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Post 3PM Pop-Up", Object.keys(properties), [
        "mathGrade",
        "mode",
        "platform",
        "userType",
        "signupFlow",
        "view",
        "grade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "cAqkdiuXFJ", "1a3dbf3884f348584a60a3ea8841a606c4e95919f2d37c3e4e406f9597213316", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Post 3PM Pop-Up", {
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "View": properties.view,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("cAqkdiuXFJ", "Viewed Post 3PM Pop-Up", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "p6UnsWI0U", name: "View", value: properties.view},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Post 3PM Pop-Up': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Post 3PM Pop-Up", {
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "View": properties.view,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "cAqkdiuXFJ", "1a3dbf3884f348584a60a3ea8841a606c4e95919f2d37c3e4e406f9597213316");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Post 3PM Pop-Up", {
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "View": properties.view,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Post 3PM Pop-Up: When the user clicks on anywhere on this Pop-up, this event is fired. When the user clicks on the cross of the Post 3PM Pop-up sent Clicked on event property as cross.
   * 
   * When to trigger this event:
   * 1. When the user clicks on anywhere on this Pop-up, this event is fired.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/kdTIcfSyik/trigger/Y3WylVQmj
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/kdTIcfSyik}
   */
  function interactedPost3pmPopUp(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Post 3PM Pop-Up", Object.keys(properties), [
        "mathGrade",
        "mode",
        "platform",
        "clickedOn",
        "userType",
        "grade",
        "elaGrade",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "kdTIcfSyik", "9d08a54d52e89305c6ec99de0780ab2ab6c62b2e110a203af41dd2636d404dc9", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Post 3PM Pop-Up", {
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Platform": properties.platform,
        "Clicked On": properties.clickedOn,
        "User Type": properties.userType,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("kdTIcfSyik", "Interacted Post 3PM Pop-Up", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Post 3PM Pop-Up': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Post 3PM Pop-Up", {
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Platform": properties.platform,
          "Clicked On": properties.clickedOn,
          "User Type": properties.userType,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "kdTIcfSyik", "9d08a54d52e89305c6ec99de0780ab2ab6c62b2e110a203af41dd2636d404dc9");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Post 3PM Pop-Up", {
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Platform": properties.platform,
      "Clicked On": properties.clickedOn,
      "User Type": properties.userType,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Error on Post 3PM Pop-Up: This event is shown when we show an error message on the Post 3PM Pop-up.
   * 
   * When to trigger this event:
   * 1. This event is shown when we show an error message on the Post 3PM Pop-up.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/hbj3YgMUEy/trigger/b8kfi6tP2
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.errorMessage - Error message shown to the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/hbj3YgMUEy}
   */
  function viewedErrorOnPost3pmPopUp(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertErrorMessage(properties.errorMessage));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Error on Post 3PM Pop-Up", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "errorMessage",
        "grade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "hbj3YgMUEy", "de05e6c1a279019cb74ce5b3d31a5dfccc070e472449c54ca76aceaeeb6e4b7a", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Error on Post 3PM Pop-Up", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Error Message": properties.errorMessage,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("hbj3YgMUEy", "Viewed Error on Post 3PM Pop-Up", messages, [
        {id: "1n3Bq4GKWy", name: "Error Message", value: properties.errorMessage},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Error on Post 3PM Pop-Up': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Error on Post 3PM Pop-Up", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Error Message": properties.errorMessage,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "hbj3YgMUEy", "de05e6c1a279019cb74ce5b3d31a5dfccc070e472449c54ca76aceaeeb6e4b7a");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Error on Post 3PM Pop-Up", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Error Message": properties.errorMessage,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Suspected Email Nudge: This event will get triggered when nudge to suspected domain user is shown
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/8k0kUqm42K}
   */
  function viewedSuspectedEmailNudge(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Suspected Email Nudge", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "grade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "8k0kUqm42K", "310d8d1714270a11a0bb5da478d75432f2de615300661e05b431617b5341e35a", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Suspected Email Nudge", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("8k0kUqm42K", "Viewed Suspected Email Nudge", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Suspected Email Nudge': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Suspected Email Nudge", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "8k0kUqm42K", "310d8d1714270a11a0bb5da478d75432f2de615300661e05b431617b5341e35a");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Suspected Email Nudge", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Suspected Email Nudge: This event will be triggered when user interacts on nudge for suspected domain users
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/KAC_5fChIR}
   */
  function interactedSuspectedEmailNudge(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Suspected Email Nudge", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "clickedOn",
        "elaGrade",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "KAC_5fChIR", "3ba56b1452f0e39406a3482cd0fea2175cdeb9897b4c22e1b8e1e73b88e88c2f", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Suspected Email Nudge", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Clicked On": properties.clickedOn,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("KAC_5fChIR", "Interacted Suspected Email Nudge", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Suspected Email Nudge': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Suspected Email Nudge", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Clicked On": properties.clickedOn,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "KAC_5fChIR", "3ba56b1452f0e39406a3482cd0fea2175cdeb9897b4c22e1b8e1e73b88e88c2f");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Suspected Email Nudge", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Clicked On": properties.clickedOn,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed MP Game Tab Coachmark: When the user sees the nudge on the 'Splash Arena' tab
   * 
   * When to trigger this event:
   * 1. When the user sees the nudge on the Splash Arena tab
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ni3ys2ia8d/trigger/oMYi9KVse
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ni3ys2ia8d}
   */
  function viewedMpGameTabCoachmark(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed MP Game Tab Coachmark", Object.keys(properties), [
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ni3ys2ia8d", "856075b5ed69a8009e0ea566a68fa54419cdab65f99398bd09fd0f8e4a5f56a3", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed MP Game Tab Coachmark", {
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ni3ys2ia8d", "Viewed MP Game Tab Coachmark", messages, [
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed MP Game Tab Coachmark': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed MP Game Tab Coachmark", {
          "Screen Height": sysScreenHeight,
          }, "ni3ys2ia8d", "856075b5ed69a8009e0ea566a68fa54419cdab65f99398bd09fd0f8e4a5f56a3");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed MP Game Tab Coachmark", {
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed MP Game Tile Coachmark: When the user sees the nudge on the Game tile on the Game listing page of the Splash Arena tab
   * 
   * When to trigger this event:
   * 1. When the user sees the nudge on the Game tile on the Game listing page of the Splash Arena tab
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ChALjdcHk/trigger/IwHVbOY0d
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ChALjdcHk}
   */
  function viewedMpGameTileCoachmark(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed MP Game Tile Coachmark", Object.keys(properties), [
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ChALjdcHk", "007b06e218e31ef208803b95787f77c3102ca11bf9d11405978f44a795095c0a", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed MP Game Tile Coachmark", {
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ChALjdcHk", "Viewed MP Game Tile Coachmark", messages, [
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed MP Game Tile Coachmark': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed MP Game Tile Coachmark", {
          "Screen Height": sysScreenHeight,
          }, "ChALjdcHk", "007b06e218e31ef208803b95787f77c3102ca11bf9d11405978f44a795095c0a");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed MP Game Tile Coachmark", {
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Visited Dashboard Tab: Just after Login and landing on teacher dashboard OR clicking dashboard tab
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/KFGFZqsRoC}
   */
  function visitedDashboardTab(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Visited Dashboard Tab", Object.keys(properties), [
        "class_",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "KFGFZqsRoC", "1567ea2383375c00adc020a7d352a6cb6cc60d548fae0dca6469ee0c4dd8fc86", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Visited Dashboard Tab", {
        "Class": properties.class_,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("KFGFZqsRoC", "Visited Dashboard Tab", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Visited Dashboard Tab': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Visited Dashboard Tab", {
          "Class": properties.class_,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "KFGFZqsRoC", "1567ea2383375c00adc020a7d352a6cb6cc60d548fae0dca6469ee0c4dd8fc86");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Visited Dashboard Tab", {
      "Class": properties.class_,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed MF Walkthrough Popup: When the walkthrough is shown to the teacher.
   * 
   * When to trigger this event:
   * 1. When the walkthrough is shown to the teacher.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/xHOoo91p8l/trigger/3eSZ1IKN1
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {int} properties.daysSinceSy23Onboarding - Day since teacher lands on the dashboard for the first time in current school year.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/xHOoo91p8l}
   */
  function viewedMfWalkthroughPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertDaysSinceSY23Onboarding(properties.daysSinceSy23Onboarding));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed MF Walkthrough Popup", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "daysSinceSy23Onboarding"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "xHOoo91p8l", "bf698ccea2031d9713c1ec3cc678f45834e06b8cfe262e2c4596ee53ccf35639", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed MF Walkthrough Popup", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Days Since SY23 Onboarding": properties.daysSinceSy23Onboarding,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("xHOoo91p8l", "Viewed MF Walkthrough Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "NF129Gymtv", name: "Days Since SY23 Onboarding", value: properties.daysSinceSy23Onboarding},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed MF Walkthrough Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed MF Walkthrough Popup", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Days Since SY23 Onboarding": properties.daysSinceSy23Onboarding,
          "Screen Height": sysScreenHeight,
          }, "xHOoo91p8l", "bf698ccea2031d9713c1ec3cc678f45834e06b8cfe262e2c4596ee53ccf35639");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed MF Walkthrough Popup", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Days Since SY23 Onboarding": properties.daysSinceSy23Onboarding,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted MF Walkthrough Popup: When a teacher clicks on the CTAs of the Math Fact Walkthrough
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {int} properties.slide - On which slide of the walkthrough action happened
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ENwKfE5l7l}
   */
  function interactedMfWalkthroughPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertSlide(properties.slide));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted MF Walkthrough Popup", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "slide",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ENwKfE5l7l", "885941ca662bbb359edc07eb0f14ef266b1769d9291345697ad13d95f739d669", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted MF Walkthrough Popup", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Slide": properties.slide,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ENwKfE5l7l", "Interacted MF Walkthrough Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "Qo8RFu5jt2", name: "Slide", value: properties.slide},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted MF Walkthrough Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted MF Walkthrough Popup", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Slide": properties.slide,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "ENwKfE5l7l", "885941ca662bbb359edc07eb0f14ef266b1769d9291345697ad13d95f739d669");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted MF Walkthrough Popup", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Slide": properties.slide,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Nav Clicked MF New Practice: On Clicking "New Fact Practice" from left Nav or top horizontal tab
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.source - Click source
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/hGAJNwWTDT}
   */
  function navClickedMfNewPractice(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertSource(properties.source));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Nav Clicked MF New Practice", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "source",
        "fromPage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "hGAJNwWTDT", "1ef2f1e5ccfa19a08a5de0f00772054cef89cd761de0ec91e950d02f1da01b07", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Nav Clicked MF New Practice", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Source": properties.source,
        "From Page": properties.fromPage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("hGAJNwWTDT", "Nav Clicked MF New Practice", messages, [
        {id: "293juZE8KT", name: "Source", value: properties.source},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Nav Clicked MF New Practice': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Nav Clicked MF New Practice", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Source": properties.source,
          "From Page": properties.fromPage,
          "Screen Height": sysScreenHeight,
          }, "hGAJNwWTDT", "1ef2f1e5ccfa19a08a5de0f00772054cef89cd761de0ec91e950d02f1da01b07");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Nav Clicked MF New Practice", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Click Source": properties.source,
      "From Page": properties.fromPage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed MF Settings Popup: When Math Fact assign settings popup is loaded
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mfMode - Adaptive or Custom mode of the math facts.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/3ZgKYQ_qGM}
   */
  function viewedMfSettingsPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMFMode(properties.mfMode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed MF Settings Popup", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "mfMode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "3ZgKYQ_qGM", "24f9e10f5ee9c9f2ede27d24b78ffb04ca7b22ec13682ac761e7dcad060f4a9f", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed MF Settings Popup", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "MF Mode": properties.mfMode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("3ZgKYQ_qGM", "Viewed MF Settings Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "W2HLoVKJnA", name: "MF Mode", value: properties.mfMode},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed MF Settings Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed MF Settings Popup", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "MF Mode": properties.mfMode,
          "Screen Height": sysScreenHeight,
          }, "3ZgKYQ_qGM", "24f9e10f5ee9c9f2ede27d24b78ffb04ca7b22ec13682ac761e7dcad060f4a9f");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed MF Settings Popup", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "MF Mode": properties.mfMode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted MF Settings Popup: Event to collect all the settings chosen by the teacher to assign an Adaptive mode. Triggered on clicking assign to whole class OR assign to selected students.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mfOperatorSelected - Which operator was selected while assigning Math Facts.
   * @param {Array<int>} properties.mfPracticeDaysCount - Total practice days selected by the teacher for Adaptive mode.
   * @param {string} properties.mfPracticeQuestionsCount - Count of selected questions for Adaptive mode. Range is 20, 30 , 40
   * @param {string} properties.mfMode - Adaptive or Custom mode of the math facts.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/oMQiynYg2}
   */
  function interactedMfSettingsPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMFOperatorSelected(properties.mfOperatorSelected));
      messages = messages.concat(assertMFPracticeDaysCount(properties.mfPracticeDaysCount));
      messages = messages.concat(assertMFPracticeQuestionsCount(properties.mfPracticeQuestionsCount));
      messages = messages.concat(assertMFMode(properties.mfMode));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted MF Settings Popup", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "mfOperatorSelected",
        "mfPracticeDaysCount",
        "mfPracticeQuestionsCount",
        "mfMode",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "oMQiynYg2", "6bf5dc3e5c55a41c3ef875038086f80c03b77150d9339f721085626270c99a3f", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted MF Settings Popup", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "MF Operator Selected": properties.mfOperatorSelected,
        "MF Practice Days Count": properties.mfPracticeDaysCount,
        "MF Practice Questions Count": properties.mfPracticeQuestionsCount,
        "MF Mode": properties.mfMode,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("oMQiynYg2", "Interacted MF Settings Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "8mj3Kb8zsO", name: "MF Practice Days Count", value: properties.mfPracticeDaysCount},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "W2HLoVKJnA", name: "MF Mode", value: properties.mfMode},
        {id: "XkzC7k3g8c", name: "MF Operator Selected", value: properties.mfOperatorSelected},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "rpd15EbJEO", name: "MF Practice Questions Count", value: properties.mfPracticeQuestionsCount},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted MF Settings Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted MF Settings Popup", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "MF Operator Selected": properties.mfOperatorSelected,
          "MF Practice Days Count": properties.mfPracticeDaysCount,
          "MF Practice Questions Count": properties.mfPracticeQuestionsCount,
          "MF Mode": properties.mfMode,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "oMQiynYg2", "6bf5dc3e5c55a41c3ef875038086f80c03b77150d9339f721085626270c99a3f");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted MF Settings Popup", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "MF Operator Selected": properties.mfOperatorSelected,
      "MF Practice Days Count": properties.mfPracticeDaysCount,
      "MF Practice Questions Count": properties.mfPracticeQuestionsCount,
      "MF Mode": properties.mfMode,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Successfully Assigned: Triggered when teacher selects students and clicks "Assign".
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {int} properties.mfAssignedStudentCount - Count of students selected
   * @param {string} properties.mfMode - Adaptive or Custom mode of the math facts.
   * @param {int} properties.classSize - Total students in the class at the time this event was triggered.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/E-gfm7YPDX}
   */
  function successfullyAssigned(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMFAssignedStudentCount(properties.mfAssignedStudentCount));
      messages = messages.concat(assertMFMode(properties.mfMode));
      messages = messages.concat(assertClassSize(properties.classSize));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Successfully Assigned", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "mfAssignedStudentCount",
        "mfMode",
        "classSize"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "E-gfm7YPDX", "88e47eb371d290b56056cc6d847bd7becf121256b2ef09a34f28a14f0bab762e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Successfully Assigned", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "MF Assigned Student Count": properties.mfAssignedStudentCount,
        "MF Mode": properties.mfMode,
        "Class Size": properties.classSize,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("E-gfm7YPDX", "Successfully Assigned", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "W2HLoVKJnA", name: "MF Mode", value: properties.mfMode},
        {id: "ba_sAWHkZP", name: "MF Assigned Student Count", value: properties.mfAssignedStudentCount},
        {id: "erbI-IRpim", name: "Class Size", value: properties.classSize},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Successfully Assigned': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Successfully Assigned", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "MF Assigned Student Count": properties.mfAssignedStudentCount,
          "MF Mode": properties.mfMode,
          "Class Size": properties.classSize,
          "Screen Height": sysScreenHeight,
          }, "E-gfm7YPDX", "88e47eb371d290b56056cc6d847bd7becf121256b2ef09a34f28a14f0bab762e");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Successfully Assigned", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "MF Assigned Student Count": properties.mfAssignedStudentCount,
      "MF Mode": properties.mfMode,
      "Class Size": properties.classSize,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Nav Clicked MF Track Fluency: On clicking "Track Fact Fluency" tab either from left nav or horizontal tab.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.source - Click source
   * @param {string} properties.mfMode - Adaptive or Custom mode of the math facts.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/t2wrxSd9aW}
   */
  function navClickedMfTrackFluency(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertSource(properties.source));
      messages = messages.concat(assertMFMode(properties.mfMode));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Nav Clicked MF Track Fluency", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "source",
        "mfMode",
        "fromPage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "t2wrxSd9aW", "ce709a046a4a2b5a93239857c4dbd7bbe80f140d1ed293debe48b9388dbefce1", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Nav Clicked MF Track Fluency", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Source": properties.source,
        "MF Mode": properties.mfMode,
        "From Page": properties.fromPage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("t2wrxSd9aW", "Nav Clicked MF Track Fluency", messages, [
        {id: "293juZE8KT", name: "Source", value: properties.source},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "W2HLoVKJnA", name: "MF Mode", value: properties.mfMode},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Nav Clicked MF Track Fluency': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Nav Clicked MF Track Fluency", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Source": properties.source,
          "MF Mode": properties.mfMode,
          "From Page": properties.fromPage,
          "Screen Height": sysScreenHeight,
          }, "t2wrxSd9aW", "ce709a046a4a2b5a93239857c4dbd7bbe80f140d1ed293debe48b9388dbefce1");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Nav Clicked MF Track Fluency", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Click Source": properties.source,
      "MF Mode": properties.mfMode,
      "From Page": properties.fromPage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed MF Track Adaptive Page: Triggered when the "Track adaptive practice" tab is rendered. 
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {bool} properties.activeAssignment - Was there any active assignment when teacher visited this page.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/1uz5oUrT2u}
   */
  function viewedMfTrackAdaptivePage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertActiveAssignment(properties.activeAssignment));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed MF Track Adaptive Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "activeAssignment",
        "fromPage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "1uz5oUrT2u", "0d93b4d4e30edb20814b2f1e77e00e9ea08fbe8c143fe0971854d7cf1f04a7d2", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed MF Track Adaptive Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Active Assignment": properties.activeAssignment,
        "From Page": properties.fromPage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("1uz5oUrT2u", "Viewed MF Track Adaptive Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "HMu5eJkRj5", name: "Active Assignment", value: properties.activeAssignment},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed MF Track Adaptive Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed MF Track Adaptive Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Active Assignment": properties.activeAssignment,
          "From Page": properties.fromPage,
          "Screen Height": sysScreenHeight,
          }, "1uz5oUrT2u", "0d93b4d4e30edb20814b2f1e77e00e9ea08fbe8c143fe0971854d7cf1f04a7d2");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed MF Track Adaptive Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Active Assignment": properties.activeAssignment,
      "From Page": properties.fromPage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed MF Track Custom Page: Triggered when the "Track custom test" tab is rendered. 
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {bool} properties.activeAssignment - Was there any active assignment when teacher visited this page.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ZUgsBQSpEG}
   */
  function viewedMfTrackCustomPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertActiveAssignment(properties.activeAssignment));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed MF Track Custom Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "activeAssignment"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ZUgsBQSpEG", "b48041cf3ad854e028aa0d762b761ad97fe45f671eabafa6091a32abb76aa186", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed MF Track Custom Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Active Assignment": properties.activeAssignment,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ZUgsBQSpEG", "Viewed MF Track Custom Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "HMu5eJkRj5", name: "Active Assignment", value: properties.activeAssignment},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed MF Track Custom Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed MF Track Custom Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Active Assignment": properties.activeAssignment,
          "Screen Height": sysScreenHeight,
          }, "ZUgsBQSpEG", "b48041cf3ad854e028aa0d762b761ad97fe45f671eabafa6091a32abb76aa186");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed MF Track Custom Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Active Assignment": properties.activeAssignment,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted MF Track Adaptive Page: Clicked on key CTAs in the Track Adaptive practice page
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/sBSbnqgKlq}
   */
  function interactedMfTrackAdaptivePage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted MF Track Adaptive Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "sBSbnqgKlq", "8136ad8d4ab994e7f411a29bbfbc5677984c6b191b77ce992d98586f66ad832e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted MF Track Adaptive Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("sBSbnqgKlq", "Interacted MF Track Adaptive Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted MF Track Adaptive Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted MF Track Adaptive Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "sBSbnqgKlq", "8136ad8d4ab994e7f411a29bbfbc5677984c6b191b77ce992d98586f66ad832e");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted MF Track Adaptive Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Nav Clicked Student Report: Clicking the Student Progress tab on the left nav/Top horizontal tab
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.source - Click source
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/fLFcae43mS}
   */
  function navClickedStudentReport(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertSource(properties.source));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Nav Clicked Student Report", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "source",
        "fromPage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "fLFcae43mS", "fd377ba8d9ad15d907b1eb93be335e7575cfcd5d9d94b7dea680db4320de4153", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Nav Clicked Student Report", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Source": properties.source,
        "From Page": properties.fromPage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("fLFcae43mS", "Nav Clicked Student Report", messages, [
        {id: "293juZE8KT", name: "Source", value: properties.source},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Nav Clicked Student Report': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Nav Clicked Student Report", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Source": properties.source,
          "From Page": properties.fromPage,
          "Screen Height": sysScreenHeight,
          }, "fLFcae43mS", "fd377ba8d9ad15d907b1eb93be335e7575cfcd5d9d94b7dea680db4320de4153");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Nav Clicked Student Report", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Click Source": properties.source,
      "From Page": properties.fromPage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed MF Student Progress Page: When Math Fact student progress report page is rendered.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/mZBu_P3Wz_}
   */
  function viewedMfStudentProgressPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed MF Student Progress Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "mZBu_P3Wz_", "6a6aa153e4e33856bb44b86d05ad46564348e5345811e28d9409acd85ec15526", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed MF Student Progress Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("mZBu_P3Wz_", "Viewed MF Student Progress Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed MF Student Progress Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed MF Student Progress Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "mZBu_P3Wz_", "6a6aa153e4e33856bb44b86d05ad46564348e5345811e28d9409acd85ec15526");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed MF Student Progress Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted MF Student Progress Page: Clicked on the key CTAs on Math Fact student report page.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ZhhC2ruUxR}
   */
  function interactedMfStudentProgressPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted MF Student Progress Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ZhhC2ruUxR", "98df4d66e7c5ab5a9102b326eb8a8153a729c9fa579dd575b3fdbead87a73f63", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted MF Student Progress Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ZhhC2ruUxR", "Interacted MF Student Progress Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted MF Student Progress Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted MF Student Progress Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "ZhhC2ruUxR", "98df4d66e7c5ab5a9102b326eb8a8153a729c9fa579dd575b3fdbead87a73f63");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted MF Student Progress Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Nav Clicked Class Report: On clicking Class Progress Tab on the left nav/top horizontal tab.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.source - Click source
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/qcbY_UukS}
   */
  function navClickedClassReport(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertSource(properties.source));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Nav Clicked Class Report", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "source",
        "fromPage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "qcbY_UukS", "27ad515e0b0617c84e0fdf3a445ae77c9dbe60b1a25b8616a0aa9750c8c0d3f5", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Nav Clicked Class Report", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Source": properties.source,
        "From Page": properties.fromPage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("qcbY_UukS", "Nav Clicked Class Report", messages, [
        {id: "293juZE8KT", name: "Source", value: properties.source},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Nav Clicked Class Report': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Nav Clicked Class Report", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Source": properties.source,
          "From Page": properties.fromPage,
          "Screen Height": sysScreenHeight,
          }, "qcbY_UukS", "27ad515e0b0617c84e0fdf3a445ae77c9dbe60b1a25b8616a0aa9750c8c0d3f5");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Nav Clicked Class Report", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Click Source": properties.source,
      "From Page": properties.fromPage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Class Curriculum Report Page: Event thrown when Class curriculum Grid report OR Group report is rendered.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.reportType - Type of report 
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/vOTO87mhnR}
   */
  function viewedClassCurriculumReportPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertReportType(properties.reportType));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Class Curriculum Report Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "reportType"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "vOTO87mhnR", "b00276eb8b53b7e5bec96b3762650376cee698ef9daacb2a7a76e0b65874797c", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Class Curriculum Report Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Report Type": properties.reportType,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("vOTO87mhnR", "Viewed Class Curriculum Report Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "Iye0o_TlZ0", name: "Report Type", value: properties.reportType},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Class Curriculum Report Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Class Curriculum Report Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Report Type": properties.reportType,
          "Screen Height": sysScreenHeight,
          }, "vOTO87mhnR", "b00276eb8b53b7e5bec96b3762650376cee698ef9daacb2a7a76e0b65874797c");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Class Curriculum Report Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Report Type": properties.reportType,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed MF Class Progress Page: When Math fact class report is rendered.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Tz6ZvP9MQu}
   */
  function viewedMfClassProgressPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed MF Class Progress Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Tz6ZvP9MQu", "bb9c3eb581f2838e4768c6cef88c07fa84eef9a3b3a54d61f64ba2779b706482", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed MF Class Progress Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Tz6ZvP9MQu", "Viewed MF Class Progress Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed MF Class Progress Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed MF Class Progress Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "Tz6ZvP9MQu", "bb9c3eb581f2838e4768c6cef88c07fa84eef9a3b3a54d61f64ba2779b706482");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed MF Class Progress Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted MF Class Progress Page: On clicking on the grid cell or Operator 
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/S_We7spjZ}
   */
  function interactedMfClassProgressPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted MF Class Progress Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "S_We7spjZ", "037b6bf5a3df5de2bd48abf3130dea765908f2c567d46f1ffc45b36f91175ba3", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted MF Class Progress Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("S_We7spjZ", "Interacted MF Class Progress Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted MF Class Progress Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted MF Class Progress Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "S_We7spjZ", "037b6bf5a3df5de2bd48abf3130dea765908f2c567d46f1ffc45b36f91175ba3");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted MF Class Progress Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed MF Modify Practice Page: When modify practice page of the math facts is rendered
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.reachedVia - Reached this page from this page.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/mwvLOCxMqn}
   */
  function viewedMfModifyPracticePage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertReachedVia(properties.reachedVia));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed MF Modify Practice Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "reachedVia"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "mwvLOCxMqn", "b3ba43e1ae2a721f48c680915e3d72292666bf6f876aa839a6d59f7fca68cba8", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed MF Modify Practice Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Reached Via": properties.reachedVia,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("mwvLOCxMqn", "Viewed MF Modify Practice Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "iRAn4RfO3I", name: "Reached Via", value: properties.reachedVia},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed MF Modify Practice Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed MF Modify Practice Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Reached Via": properties.reachedVia,
          "Screen Height": sysScreenHeight,
          }, "mwvLOCxMqn", "b3ba43e1ae2a721f48c680915e3d72292666bf6f876aa839a6d59f7fca68cba8");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed MF Modify Practice Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Reached Via": properties.reachedVia,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted MF Modify Practice Page: Teacher pressed the "Save" button after doing the modifications in Math Facts modify practice screen OR Unassign
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {int} properties.modifiedFor - Student count for which modification was done
   * @param {bool} properties.modifiedTime - Has teacher changed time from modify screen?
   * @param {bool} properties.modifiedOperator - Has teacher modified the operator from modify practice screen?
   * @param {bool} properties.modifiedDays - Has teacher modified practice days from modify practice screen?
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Iceg173HtQ}
   */
  function interactedMfModifyPracticePage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertModifiedFor(properties.modifiedFor));
      messages = messages.concat(assertModifiedTime(properties.modifiedTime));
      messages = messages.concat(assertModifiedOperator(properties.modifiedOperator));
      messages = messages.concat(assertModifiedDays(properties.modifiedDays));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted MF Modify Practice Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "modifiedFor",
        "modifiedTime",
        "modifiedOperator",
        "modifiedDays",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Iceg173HtQ", "5b9d92b58b89546eda062ec3b6b4582ad2e926887292cbb454f37dad281efe35", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted MF Modify Practice Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Modified For": properties.modifiedFor,
        "Modified Time": properties.modifiedTime,
        "Modified Operator": properties.modifiedOperator,
        "Modified Days": properties.modifiedDays,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Iceg173HtQ", "Interacted MF Modify Practice Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "Tz8yoJEXaS", name: "Modified Operator", value: properties.modifiedOperator},
        {id: "UrJ4r6Tv4Q", name: "Modified For", value: properties.modifiedFor},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "fvYVVEdCul", name: "Modified Days", value: properties.modifiedDays},
        {id: "m-vmQiLuIl", name: "Modified Time", value: properties.modifiedTime},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted MF Modify Practice Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted MF Modify Practice Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Modified For": properties.modifiedFor,
          "Modified Time": properties.modifiedTime,
          "Modified Operator": properties.modifiedOperator,
          "Modified Days": properties.modifiedDays,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "Iceg173HtQ", "5b9d92b58b89546eda062ec3b6b4582ad2e926887292cbb454f37dad281efe35");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted MF Modify Practice Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Modified For": properties.modifiedFor,
      "Modified Time": properties.modifiedTime,
      "Modified Operator": properties.modifiedOperator,
      "Modified Days": properties.modifiedDays,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed MyToDo Page: When MyToDo page is opened on the Student Dashboard
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {bool} properties.mfAssignmentAvailable - Is active MF assignment (adaptive or custom)  available in MyToDo section? 
   * @param {bool} properties.curriculumAssignmentAvailable - Is assignment from core curriculum available? Includes Learning Path and LOs but not assessment.
   * @param {int} properties.totalAssignmentCount - Assignment count shown on the myToDo card on student dashboard.
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} [properties.from] - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {int} properties.daysSinceClassCreation - Self explanatory
   * @param {string} [properties.daysSinceSignup] - Days since parent or teacher signs up on the product
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/-JCqGnIn92}
   */
  function viewedMytodoPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMFAssignmentAvailable(properties.mfAssignmentAvailable));
      messages = messages.concat(assertCurriculumAssignmentAvailable(properties.curriculumAssignmentAvailable));
      messages = messages.concat(assertTotalAssignmentCount(properties.totalAssignmentCount));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertOptionalFrom(properties.from));
      messages = messages.concat(assertDaysSinceClassCreation(properties.daysSinceClassCreation));
      messages = messages.concat(assertOptionalDaysSinceSignup(properties.daysSinceSignup));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed MyToDo Page", Object.keys(properties), [
        "mathGrade",
        "mode",
        "platform",
        "userType",
        "signupFlow",
        "mfAssignmentAvailable",
        "curriculumAssignmentAvailable",
        "totalAssignmentCount",
        "subject",
        "from",
        "daysSinceClassCreation",
        "daysSinceSignup",
        "fromPage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "-JCqGnIn92", "21d74b3c0b0ab603a78c472d250f7613f26edeb5a7ce52d7455b1e3efbabb494", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed MyToDo Page", {
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "MF Assignment Available": properties.mfAssignmentAvailable,
        "Curriculum Assignment Available": properties.curriculumAssignmentAvailable,
        "Total Assignment Count": properties.totalAssignmentCount,
        "Subject": properties.subject,
        "From": properties.from,
        "Days Since Class Creation": properties.daysSinceClassCreation,
        "Days Since Signup": properties.daysSinceSignup,
        "From Page": properties.fromPage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("-JCqGnIn92", "Viewed MyToDo Page", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "TuspgTIuZ1", name: "Days Since Class Creation", value: properties.daysSinceClassCreation},
        {id: "e4g1zZQCJ", name: "Days Since Signup", value: properties.daysSinceSignup},
        {id: "hBgoB0mPff", name: "Total Assignment Count", value: properties.totalAssignmentCount},
        {id: "jiop2Ii29S", name: "Curriculum Assignment Available", value: properties.curriculumAssignmentAvailable},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "t3iU5mo89Y", name: "MF Assignment Available", value: properties.mfAssignmentAvailable},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed MyToDo Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed MyToDo Page", {
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "MF Assignment Available": properties.mfAssignmentAvailable,
          "Curriculum Assignment Available": properties.curriculumAssignmentAvailable,
          "Total Assignment Count": properties.totalAssignmentCount,
          "Subject": properties.subject,
          "From": properties.from,
          "Days Since Class Creation": properties.daysSinceClassCreation,
          "Days Since Signup": properties.daysSinceSignup,
          "From Page": properties.fromPage,
          "Screen Height": sysScreenHeight,
          }, "-JCqGnIn92", "21d74b3c0b0ab603a78c472d250f7613f26edeb5a7ce52d7455b1e3efbabb494");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed MyToDo Page", {
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "MF Assignment Available": properties.mfAssignmentAvailable,
      "Curriculum Assignment Available": properties.curriculumAssignmentAvailable,
      "Total Assignment Count": properties.totalAssignmentCount,
      "Subject": properties.subject,
      "From": properties.from,
      "Days Since Class Creation": properties.daysSinceClassCreation,
      "Days Since Signup": properties.daysSinceSignup,
      "From Page": properties.fromPage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Math Fact Started: Existing event: When Math facts adaptive or custom mode is started and rendered in the iFrame. 
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mfMode - Adaptive or Custom mode of the math facts.
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/F11zQeD1tk}
   */
  function mathFactStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMFMode(properties.mfMode));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Math Fact Started", Object.keys(properties), [
        "mathGrade",
        "mode",
        "platform",
        "userType",
        "signupFlow",
        "mfMode",
        "from"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "F11zQeD1tk", "577fcda14fb253bcdac001abc81c520b49061802c70a805854150ed4d7ba0403", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Math Fact Started", {
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "MF Mode": properties.mfMode,
        "From": properties.from,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("F11zQeD1tk", "Math Fact Started", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "W2HLoVKJnA", name: "MF Mode", value: properties.mfMode},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Math Fact Started': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Math Fact Started", {
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "MF Mode": properties.mfMode,
          "From": properties.from,
          "Screen Height": sysScreenHeight,
          }, "F11zQeD1tk", "577fcda14fb253bcdac001abc81c520b49061802c70a805854150ed4d7ba0403");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Math Fact Started", {
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "MF Mode": properties.mfMode,
      "From": properties.from,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Completed Math Fact Assignment: Triggered when completed the custom mode test or daily adaptive practice. 
   * 
   * When to trigger this event:
   * 1. Triggered when completed the custom mode test or daily adaptive practice. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Ho-URePgar/trigger/qHMy80JHl
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.mfMode - Adaptive or Custom mode of the math facts.
   * @param {string} properties.totalTimeTaken - Total time spent in completing the assignment
   * @param {int} properties.totalProblemsAnswered - Total problems answered to complete the assignment.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Ho-URePgar}
   */
  function completedMathFactAssignment(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertMFMode(properties.mfMode));
      messages = messages.concat(assertTotalTimeTaken(properties.totalTimeTaken));
      messages = messages.concat(assertTotalProblemsAnswered(properties.totalProblemsAnswered));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Completed Math Fact Assignment", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "mfMode",
        "totalTimeTaken",
        "totalProblemsAnswered"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Ho-URePgar", "ccf53de9f2390433bcb7ee8d3b2ae4c21213da2ee012fc511396dc43102b31e6", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Completed Math Fact Assignment", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "MF Mode": properties.mfMode,
        "Total Time Taken": properties.totalTimeTaken,
        "Total Problems Answered": properties.totalProblemsAnswered,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Ho-URePgar", "Completed Math Fact Assignment", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "V_eCbteEGc", name: "Total Problems Answered", value: properties.totalProblemsAnswered},
        {id: "W2HLoVKJnA", name: "MF Mode", value: properties.mfMode},
        {id: "gTep6toPK0", name: "Total Time Taken", value: properties.totalTimeTaken},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Completed Math Fact Assignment': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Completed Math Fact Assignment", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "MF Mode": properties.mfMode,
          "Total Time Taken": properties.totalTimeTaken,
          "Total Problems Answered": properties.totalProblemsAnswered,
          "Screen Height": sysScreenHeight,
          }, "Ho-URePgar", "ccf53de9f2390433bcb7ee8d3b2ae4c21213da2ee012fc511396dc43102b31e6");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Completed Math Fact Assignment", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "MF Mode": properties.mfMode,
      "Total Time Taken": properties.totalTimeTaken,
      "Total Problems Answered": properties.totalProblemsAnswered,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Delete Account Alert: This event is fired when user clicks on delete account option & alert is presented
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/kel_sQL_IK}
   */
  function viewedDeleteAccountAlert(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Delete Account Alert", Object.keys(properties), [
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "kel_sQL_IK", "cb9521bf170a9bd88ada236a7a415c04de9bacf7c2e3c655926f88a0632fa1d1", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Delete Account Alert", {
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("kel_sQL_IK", "Viewed Delete Account Alert", messages, [
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Delete Account Alert': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Delete Account Alert", {
          "Screen Height": sysScreenHeight,
          }, "kel_sQL_IK", "cb9521bf170a9bd88ada236a7a415c04de9bacf7c2e3c655926f88a0632fa1d1");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Delete Account Alert", {
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Delete Account Alert: Fired when user selects either option on delete account alert
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.tappedOn - UI element that user tapped on - used in conjunction with the event name which identifies the screen name
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/QWnXgL0unn}
   */
  function interactedDeleteAccountAlert(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertTappedOn(properties.tappedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Delete Account Alert", Object.keys(properties), [
        "tappedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "QWnXgL0unn", "c8607e876c73086e9a72472093a5df59ed8ee670307e79e1dc472c3f23588b87", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Delete Account Alert", {
        "Tapped On": properties.tappedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("QWnXgL0unn", "Interacted Delete Account Alert", messages, [
        {id: "cfvmMqWft", name: "Tapped On", value: properties.tappedOn},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Delete Account Alert': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Delete Account Alert", {
          "Tapped On": properties.tappedOn,
          "Screen Height": sysScreenHeight,
          }, "QWnXgL0unn", "c8607e876c73086e9a72472093a5df59ed8ee670307e79e1dc472c3f23588b87");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Delete Account Alert", {
      "Tapped On": properties.tappedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Started Game: Whenever a new games or activity is started
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.gameName] - Name of the Game being tapped (Optional)
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Mmp3DnDn5T}
   */
  function startedGame(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalGameName(properties.gameName));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Started Game", Object.keys(properties), [
        "gameName"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Mmp3DnDn5T", "be3c7c9680f4f73df4d170fe90a5c5bd23fffeac3a9d4c5c201ee5eaad39aa6e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Started Game", {
        "Game Name": properties.gameName,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Mmp3DnDn5T", "Started Game", messages, [
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Started Game': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Started Game", {
          "Game Name": properties.gameName,
          "Screen Height": sysScreenHeight,
          }, "Mmp3DnDn5T", "be3c7c9680f4f73df4d170fe90a5c5bd23fffeac3a9d4c5c201ee5eaad39aa6e");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Started Game", {
      "Game Name": properties.gameName,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Games: The first time whenever a new game is viewed
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {int} [properties.position] - 1. The position of the game group from left to right on the Pre-K dashboard
2. In the Activities section, position on Iphone is from left to right but on Ipad having dual row layout, the first column has position 1,2, second column has positions 3,4 and so on
   * @param {string} [properties.gameName] - Name of the Game being tapped (Optional)
   * @param {int} [properties.columnNumber] - The column in which the game is appearing
   * @param {int} [properties.rowNumber] - no description
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/I_BknrYsE}
   */
  function viewedGames(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalPosition(properties.position));
      messages = messages.concat(assertOptionalGameName(properties.gameName));
      messages = messages.concat(assertOptionalColumnNumber(properties.columnNumber));
      messages = messages.concat(assertOptionalRowNumber(properties.rowNumber));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Games", Object.keys(properties), [
        "position",
        "gameName",
        "columnNumber",
        "rowNumber"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "I_BknrYsE", "e7e5d33111cda779719075b27cb75e49b3855b74d32058e7c04e8e675ba94721", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Games", {
        "Position": properties.position,
        "Game Name": properties.gameName,
        "Column Number": properties.columnNumber,
        "Row Number": properties.rowNumber,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("I_BknrYsE", "Viewed Games", messages, [
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "a9l_OugqB", name: "Row Number", value: properties.rowNumber},
        {id: "eGs90Bi3pM", name: "Column Number", value: properties.columnNumber},
        {id: "rlSRn44vYq", name: "Position", value: properties.position},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Games': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Games", {
          "Position": properties.position,
          "Game Name": properties.gameName,
          "Column Number": properties.columnNumber,
          "Row Number": properties.rowNumber,
          "Screen Height": sysScreenHeight,
          }, "I_BknrYsE", "e7e5d33111cda779719075b27cb75e49b3855b74d32058e7c04e8e675ba94721");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Games", {
      "Position": properties.position,
      "Game Name": properties.gameName,
      "Column Number": properties.columnNumber,
      "Row Number": properties.rowNumber,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Tapped Game: Whenever a new game or activity is tapped/clicked
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.gameName] - Name of the Game being tapped (Optional)
   * @param {int} [properties.position] - 1. The position of the game group from left to right on the Pre-K dashboard
2. In the Activities section, position on Iphone is from left to right but on Ipad having dual row layout, the first column has position 1,2, second column has positions 3,4 and so on
   * @param {int} [properties.columnNumber] - The column in which the game is appearing
   * @param {int} [properties.rowNumber] - no description
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/SGkQR8dCqg}
   */
  function tappedGame(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalGameName(properties.gameName));
      messages = messages.concat(assertOptionalPosition(properties.position));
      messages = messages.concat(assertOptionalColumnNumber(properties.columnNumber));
      messages = messages.concat(assertOptionalRowNumber(properties.rowNumber));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Tapped Game", Object.keys(properties), [
        "gameName",
        "position",
        "columnNumber",
        "rowNumber"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "SGkQR8dCqg", "ee1c140a56817874aadd6f7bd636eaf10c1ac7a7fc1b1ae3e62e5473b08bfb7d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Tapped Game", {
        "Game Name": properties.gameName,
        "Position": properties.position,
        "Column Number": properties.columnNumber,
        "Row Number": properties.rowNumber,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("SGkQR8dCqg", "Tapped Game", messages, [
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "a9l_OugqB", name: "Row Number", value: properties.rowNumber},
        {id: "eGs90Bi3pM", name: "Column Number", value: properties.columnNumber},
        {id: "rlSRn44vYq", name: "Position", value: properties.position},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Tapped Game': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Tapped Game", {
          "Game Name": properties.gameName,
          "Position": properties.position,
          "Column Number": properties.columnNumber,
          "Row Number": properties.rowNumber,
          "Screen Height": sysScreenHeight,
          }, "SGkQR8dCqg", "ee1c140a56817874aadd6f7bd636eaf10c1ac7a7fc1b1ae3e62e5473b08bfb7d");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Tapped Game", {
      "Game Name": properties.gameName,
      "Position": properties.position,
      "Column Number": properties.columnNumber,
      "Row Number": properties.rowNumber,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted MF New Practice Page: When the teacher clicks on the CTAs on New fact practice page
   * 
   * When to trigger this event:
   * 1. When the teacher clicks on the CTAs on New fact practice page
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/M7mAq9QvRA/trigger/eTL_psnH0
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOnNewMfPractice - Alias event property for clicked on. List of key links on 'New Fact Practice' page key
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/M7mAq9QvRA}
   */
  function interactedMfNewPracticePage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOnNewMFPractice(properties.clickedOnNewMfPractice));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted MF New Practice Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOnNewMfPractice",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "M7mAq9QvRA", "653e799f968a76f85bfba9c129d4bc71244cb6d47fed36be19f27fc1f890cf37", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted MF New Practice Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked on - New MF Practice": properties.clickedOnNewMfPractice,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("M7mAq9QvRA", "Interacted MF New Practice Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "_fUyjKBzmx", name: "Clicked on - New MF Practice", value: properties.clickedOnNewMfPractice},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted MF New Practice Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted MF New Practice Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked on - New MF Practice": properties.clickedOnNewMfPractice,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "M7mAq9QvRA", "653e799f968a76f85bfba9c129d4bc71244cb6d47fed36be19f27fc1f890cf37");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted MF New Practice Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOnNewMfPractice,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted MF Custom Mode Settings Popup: Event to collect all the settings chosen by the teacher to assign custom mode. Triggered on clicking Print Worksheet or Select Students
   * 
   * When to trigger this event:
   * 1. Triggered on clicking Print Worksheet or Select Students
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/brWXxCW-RK/trigger/xtDQIT3Vw
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {Array<string>} properties.customMfOperatorSelected - Math Fact operators that are selected by the teacher to assign custom test.
   * @param {string} properties.mfPracticeQuestionsCount - Count of selected questions for Adaptive mode. Range is 20, 30 , 40
   * @param {string} properties.mfMode - Adaptive or Custom mode of the math facts.
   * @param {string} properties.mfCustomSettingsClickedOn - Alias event property for clicked on. When teacher clicks on key CTA's of settings popup.
   * @param {string} properties.mfTimePerQuestion - Time per question setting selected by the teacher for custom test.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/brWXxCW-RK}
   */
  function interactedMfCustomModeSettingsPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertCustomMFOperatorSelected(properties.customMfOperatorSelected));
      messages = messages.concat(assertMFPracticeQuestionsCount(properties.mfPracticeQuestionsCount));
      messages = messages.concat(assertMFMode(properties.mfMode));
      messages = messages.concat(assertMFCustomSettingsClickedOn(properties.mfCustomSettingsClickedOn));
      messages = messages.concat(assertMFTimePerQuestion(properties.mfTimePerQuestion));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted MF Custom Mode Settings Popup", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "customMfOperatorSelected",
        "mfPracticeQuestionsCount",
        "mfMode",
        "mfCustomSettingsClickedOn",
        "mfTimePerQuestion"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "brWXxCW-RK", "cc56abfee21c1dce6b4807a246f4c525658cd7578e6e3f7614759f4aa0260957", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted MF Custom Mode Settings Popup", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Custom MF Operator Selected": properties.customMfOperatorSelected,
        "MF Practice Questions Count": properties.mfPracticeQuestionsCount,
        "MF Mode": properties.mfMode,
        "MF Custom Settings - Clicked On": properties.mfCustomSettingsClickedOn,
        "MF Time Per Question": properties.mfTimePerQuestion,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("brWXxCW-RK", "Interacted MF Custom Mode Settings Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "W2HLoVKJnA", name: "MF Mode", value: properties.mfMode},
        {id: "XJ6AZrYTI-", name: "Custom MF Operator Selected", value: properties.customMfOperatorSelected},
        {id: "h2KwMOlZr5", name: "MF Custom Settings - Clicked On", value: properties.mfCustomSettingsClickedOn},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "rpd15EbJEO", name: "MF Practice Questions Count", value: properties.mfPracticeQuestionsCount},
        {id: "ti40sCZ5Kg", name: "MF Time Per Question", value: properties.mfTimePerQuestion},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted MF Custom Mode Settings Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted MF Custom Mode Settings Popup", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Custom MF Operator Selected": properties.customMfOperatorSelected,
          "MF Practice Questions Count": properties.mfPracticeQuestionsCount,
          "MF Mode": properties.mfMode,
          "MF Custom Settings - Clicked On": properties.mfCustomSettingsClickedOn,
          "MF Time Per Question": properties.mfTimePerQuestion,
          "Screen Height": sysScreenHeight,
          }, "brWXxCW-RK", "cc56abfee21c1dce6b4807a246f4c525658cd7578e6e3f7614759f4aa0260957");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted MF Settings Popup", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "MF Operator Selected": properties.customMfOperatorSelected,
      "MF Practice Questions Count": properties.mfPracticeQuestionsCount,
      "MF Mode": properties.mfMode,
      "Clicked On": properties.mfCustomSettingsClickedOn,
      "MF Time Per Question": properties.mfTimePerQuestion,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted MF Student Selection Popup: When the teacher clicks on "Assign" on student selection popup.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOnStudentSelectionPopup - When teacher clicks on 'Assign'
   * @param {string} properties.mfAssignedTo - Whether assigned to whole class or selected students.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/xXSLdh88n_}
   */
  function interactedMfStudentSelectionPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOnStudentSelectionPopup(properties.clickedOnStudentSelectionPopup));
      messages = messages.concat(assertMFAssignedTo(properties.mfAssignedTo));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted MF Student Selection Popup", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOnStudentSelectionPopup",
        "mfAssignedTo"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "xXSLdh88n_", "1e07614e4447815ef417ddbe6819c9c849dbc86025d77d21f6ea19fbcc363822", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted MF Student Selection Popup", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked on - Student Selection Popup": properties.clickedOnStudentSelectionPopup,
        "MF Assigned To": properties.mfAssignedTo,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("xXSLdh88n_", "Interacted MF Student Selection Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "4BthSPAer", name: "MF Assigned To", value: properties.mfAssignedTo},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "zDpSmq5T0V", name: "Clicked on - Student Selection Popup", value: properties.clickedOnStudentSelectionPopup},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted MF Student Selection Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted MF Student Selection Popup", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked on - Student Selection Popup": properties.clickedOnStudentSelectionPopup,
          "MF Assigned To": properties.mfAssignedTo,
          "Screen Height": sysScreenHeight,
          }, "xXSLdh88n_", "1e07614e4447815ef417ddbe6819c9c849dbc86025d77d21f6ea19fbcc363822");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted MF Student Selection Popup", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOnStudentSelectionPopup,
      "MF Assigned To": properties.mfAssignedTo,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted MF Track Custom Page: When teacher clicks on "View report" or "Print worksheet" or links in the kebab menu
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOnTrackCustomPage - Alias event property for clicked on. List of key links on the track custom test page.

   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/pvVgCRq8iF}
   */
  function interactedMfTrackCustomPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOnTrackCustomPage(properties.clickedOnTrackCustomPage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted MF Track Custom Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOnTrackCustomPage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "pvVgCRq8iF", "26d7ef82d2a4d3980f9b4bd441b39caad7e296e889ca50a8a950920a9c2a62c9", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted MF Track Custom Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked on - Track Custom Page": properties.clickedOnTrackCustomPage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("pvVgCRq8iF", "Interacted MF Track Custom Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "LqyojH3QzY", name: "Clicked on - Track Custom Page", value: properties.clickedOnTrackCustomPage},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted MF Track Custom Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted MF Track Custom Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked on - Track Custom Page": properties.clickedOnTrackCustomPage,
          "Screen Height": sysScreenHeight,
          }, "pvVgCRq8iF", "26d7ef82d2a4d3980f9b4bd441b39caad7e296e889ca50a8a950920a9c2a62c9");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted MF Track Custom Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOnTrackCustomPage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted MF Custom Report Page: When teacher clicks on the key CTAs on individual online custom test report.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOnCustomReportPage - List of links on Individual custom test page.  For Sort Students, click on any of the option will be considered.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/GdMHcuHiJD}
   */
  function interactedMfCustomReportPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOnCustomReportPage(properties.clickedOnCustomReportPage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted MF Custom Report Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOnCustomReportPage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "GdMHcuHiJD", "5e9ab25755c8bc0029a19061ec3259df26ea44bc53fe87cda1dba5dd31d3856c", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted MF Custom Report Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked on- Custom Report Page": properties.clickedOnCustomReportPage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("GdMHcuHiJD", "Interacted MF Custom Report Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "9xTjWsrhLS", name: "Clicked on- Custom Report Page", value: properties.clickedOnCustomReportPage},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted MF Custom Report Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted MF Custom Report Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked on- Custom Report Page": properties.clickedOnCustomReportPage,
          "Screen Height": sysScreenHeight,
          }, "GdMHcuHiJD", "5e9ab25755c8bc0029a19061ec3259df26ea44bc53fe87cda1dba5dd31d3856c");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted MF Custom Report Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOnCustomReportPage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Weekly Goal Interacted: Interacted with the weekly goal screen
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/I1V6823U-w/trigger/xZ5_XapPj
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/I1V6823U-w}
   */
  function weeklyGoalInteracted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Weekly Goal Interacted", Object.keys(properties), [
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "I1V6823U-w", "37e9cd7230056ea41eb3e2fe00334ed7dde7f217b39ea3d1d08627b71a3e10df", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Weekly Goal Interacted", {
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("I1V6823U-w", "Weekly Goal Interacted", messages, [
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Weekly Goal Interacted': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Weekly Goal Interacted", {
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "I1V6823U-w", "37e9cd7230056ea41eb3e2fe00334ed7dde7f217b39ea3d1d08627b71a3e10df");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Weekly Goal Interacted", {
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Tiled Dashboard: Fired when the user lands on the student Dashboard
   * 
   * When to trigger this event:
   * 1. The event will get fired when the user lands on the student dashboard on any of the 2 tabs
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Ea2mFo-LsZ/trigger/Lqhlc1iG1
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.dashboardVersion] - What kind of Dashboard is visible to the child
   * @param {int} [properties.totalAssignmentCount] - Assignment count shown on the myToDo card on student dashboard.
   * @param {int} [properties.mathAssignmentCount] - Total number of assignment (including assessment, Learning Plan, Math Facts) pending for a student in their My To Dos section
   * @param {int} [properties.elaAssignmentCount] - Total number of ELA assignment (including assessment, Learning Plan) pending for a student in their My To Dos section
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {Array<string>} [properties.recommendedCategory] - This property will be used to store what recommendations were shown to the user in the all tabs.
We'll be saving them in this format:
<Category Name>
where possible values are:
Category name =  MyToDo, Math_LP, ELA_LP, Math Facts, Books, Spelling, Reading Comprehension, Playzone, Activities, Learning Games
   * @param {Array<string>} [properties.recommendedPlayableCode] - This will be used to store the recommended playable code to the user in the HOME tab , with the daily recommendation system. We'll be saving it in this format:

 <Category Name>|<Playable Code>

where <Category Name> will be same as the values passed in the 'recommended category' property.
   * @param {string} properties.tabCode - Specifies the tab which has been opened in the event 'Viewed Tiled Dashboard' and Other events too
   * @param {Array<string>} [properties.recommendedRail] - This property will be used to store which rails were shown to the user in the HOME tab.

Where possible values are:
Rail Name = Curriculum, Game Zone, Math, Language, Logic & Thinking, Art & Creativity, General Knowledge, Motor Skills, Live Classes, Fluency, Multiplayer
This comes with Rank also with | separation
   * @param {string} [properties.grade] - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.from] - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {string} [properties.worksheetCode] - Worksheet code of selected worksheet
   * @param {string} [properties.discountPitch] - This property highlights if we are offering any discount at the time of user doing that event - Eg: 'Viewed Tiled Dashboard' , 'clicking the CTA - Unlock Content'
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} [properties.activeLpSubjects] - This property stores the active subjects in LP

Math, English, Both

It is only sent on Tab Code = Home
   * @param {float} properties.totalMemory - This property stores the total memory allocated by the client device
   * @param {float} properties.usedMemory - This property stores the memory consumed by the website
   * @param {float} properties.memoryLimit - The max memory allocated by the client device
   * @param {float} properties.memoryUsagePercentage - This property stores the % used memory
   * @param {Array<string>} [properties.recommendedTileName] - This property will store the code of the tile user has interacted with - CG code for curriculum rails and game code for non curr. rails

   * @param {Array<int>} properties.recommendedTileRank - This property will store the position of the tile on which user has clciked. Earlier this was sent as column position

   * @param {Array<string>} properties.recommendedRailName - This is the name of the rail viewed by the user. 
Recommended rail property comes with rail name and rail rank, pipe separated - with the introduction of this property, we intend to separate rail name to calculate CTR on Mixpanel.
   * @param {Array<int>} properties.recommendedRailRank - Recommended Rail Rank will carry the rank of the rail in integer format viewed by the user. 
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Ea2mFo-LsZ}
   */
  function viewedTiledDashboard(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalDashboardVersion(properties.dashboardVersion));
      messages = messages.concat(assertOptionalTotalAssignmentCount(properties.totalAssignmentCount));
      messages = messages.concat(assertOptionalMathAssignmentCount(properties.mathAssignmentCount));
      messages = messages.concat(assertOptionalELAAssignmentCount(properties.elaAssignmentCount));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertOptionalRecommendedCategory(properties.recommendedCategory));
      messages = messages.concat(assertOptionalRecommendedPlayableCode(properties.recommendedPlayableCode));
      messages = messages.concat(assertTabCode(properties.tabCode));
      messages = messages.concat(assertOptionalRecommendedRail(properties.recommendedRail));
      messages = messages.concat(assertOptionalGrade(properties.grade));
      messages = messages.concat(assertOptionalFrom(properties.from));
      messages = messages.concat(assertOptionalWorksheetCode(properties.worksheetCode));
      messages = messages.concat(assertOptionalDiscountPitch(properties.discountPitch));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertOptionalActiveLpSubjects(properties.activeLpSubjects));
      messages = messages.concat(assertTotalMemory(properties.totalMemory));
      messages = messages.concat(assertUsedMemory(properties.usedMemory));
      messages = messages.concat(assertMemoryLimit(properties.memoryLimit));
      messages = messages.concat(assertMemoryUsagePercentage(properties.memoryUsagePercentage));
      messages = messages.concat(assertOptionalRecommendedTileName(properties.recommendedTileName));
      messages = messages.concat(assertRecommendedTileRank(properties.recommendedTileRank));
      messages = messages.concat(assertRecommendedRailName(properties.recommendedRailName));
      messages = messages.concat(assertRecommendedRailRank(properties.recommendedRailRank));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Tiled Dashboard", Object.keys(properties), [
        "mathGrade",
        "mode",
        "platform",
        "userType",
        "signupFlow",
        "dashboardVersion",
        "totalAssignmentCount",
        "mathAssignmentCount",
        "elaAssignmentCount",
        "teacherType",
        "recommendedCategory",
        "recommendedPlayableCode",
        "tabCode",
        "recommendedRail",
        "grade",
        "from",
        "worksheetCode",
        "discountPitch",
        "elaGrade",
        "activeLpSubjects",
        "totalMemory",
        "usedMemory",
        "memoryLimit",
        "memoryUsagePercentage",
        "recommendedTileName",
        "recommendedTileRank",
        "recommendedRailName",
        "recommendedRailRank"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Ea2mFo-LsZ", "062237b886915113baedd9a4a446187882546070bea0163a5fa4beaf4c9a3227", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Tiled Dashboard", {
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Dashboard Version": properties.dashboardVersion,
        "Total Assignment Count": properties.totalAssignmentCount,
        "Math Assignment Count": properties.mathAssignmentCount,
        "ELA Assignment Count": properties.elaAssignmentCount,
        "Teacher Type": properties.teacherType,
        "Recommended Category": properties.recommendedCategory,
        "Recommended Playable Code": properties.recommendedPlayableCode,
        "Tab Code": properties.tabCode,
        "Recommended Rail": properties.recommendedRail,
        "Grade": properties.grade,
        "From": properties.from,
        "Worksheet Code": properties.worksheetCode,
        "Discount Pitch": properties.discountPitch,
        "Ela Grade": properties.elaGrade,
        "Active Lp Subjects": properties.activeLpSubjects,
        "Total Memory": properties.totalMemory,
        "Used Memory": properties.usedMemory,
        "Memory Limit": properties.memoryLimit,
        "Memory Usage Percentage": properties.memoryUsagePercentage,
        "Recommended Tile Name": properties.recommendedTileName,
        "Recommended Tile Rank": properties.recommendedTileRank,
        "Recommended Rail Name": properties.recommendedRailName,
        "Recommended Rail Rank": properties.recommendedRailRank,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Ea2mFo-LsZ", "Viewed Tiled Dashboard", messages, [
        {id: "-tPNSAQK6", name: "Discount Pitch", value: properties.discountPitch},
        {id: "09LOni_Ki3", name: "Recommended Playable Code", value: properties.recommendedPlayableCode},
        {id: "2hMTTBgU30", name: "Total Memory", value: properties.totalMemory},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "6QT3mtqEUD", name: "Dashboard Version", value: properties.dashboardVersion},
        {id: "6lrsWYY5Y", name: "Recommended Rail Name", value: properties.recommendedRailName},
        {id: "ADfS21LlJH", name: "Memory Limit", value: properties.memoryLimit},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "FLDtSJNKL", name: "Recommended Tile Rank", value: properties.recommendedTileRank},
        {id: "NRFYZYLxy", name: "Worksheet Code", value: properties.worksheetCode},
        {id: "TYbmk5DQn", name: "Recommended Tile Name", value: properties.recommendedTileName},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "VdJhEU0H6s", name: "Recommended Category", value: properties.recommendedCategory},
        {id: "_fnvZDP5s", name: "Active Lp Subjects", value: properties.activeLpSubjects},
        {id: "dqG7mb_H0j", name: "ELA Assignment Count", value: properties.elaAssignmentCount},
        {id: "drNgwJn5Xg", name: "Recommended Rail", value: properties.recommendedRail},
        {id: "fXWDPkk_PZ", name: "Memory Usage Percentage", value: properties.memoryUsagePercentage},
        {id: "gvDk2xQI4d", name: "Used Memory", value: properties.usedMemory},
        {id: "hBgoB0mPff", name: "Total Assignment Count", value: properties.totalAssignmentCount},
        {id: "l9PbANZBu", name: "Tab Code", value: properties.tabCode},
        {id: "mdeQgK543Z", name: "Math Assignment Count", value: properties.mathAssignmentCount},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "uyLgqxbg7", name: "Recommended Rail Rank", value: properties.recommendedRailRank},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Tiled Dashboard': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Tiled Dashboard", {
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Dashboard Version": properties.dashboardVersion,
          "Total Assignment Count": properties.totalAssignmentCount,
          "Math Assignment Count": properties.mathAssignmentCount,
          "ELA Assignment Count": properties.elaAssignmentCount,
          "Teacher Type": properties.teacherType,
          "Recommended Category": properties.recommendedCategory,
          "Recommended Playable Code": properties.recommendedPlayableCode,
          "Tab Code": properties.tabCode,
          "Recommended Rail": properties.recommendedRail,
          "Grade": properties.grade,
          "From": properties.from,
          "Worksheet Code": properties.worksheetCode,
          "Discount Pitch": properties.discountPitch,
          "Ela Grade": properties.elaGrade,
          "Active Lp Subjects": properties.activeLpSubjects,
          "Total Memory": properties.totalMemory,
          "Used Memory": properties.usedMemory,
          "Memory Limit": properties.memoryLimit,
          "Memory Usage Percentage": properties.memoryUsagePercentage,
          "Recommended Tile Name": properties.recommendedTileName,
          "Recommended Tile Rank": properties.recommendedTileRank,
          "Recommended Rail Name": properties.recommendedRailName,
          "Recommended Rail Rank": properties.recommendedRailRank,
          "Screen Height": sysScreenHeight,
          }, "Ea2mFo-LsZ", "062237b886915113baedd9a4a446187882546070bea0163a5fa4beaf4c9a3227");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Tiled Dashboard", {
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Dashboard Version": properties.dashboardVersion,
      "Total Assignment Count": properties.totalAssignmentCount,
      "Math Assignment Count": properties.mathAssignmentCount,
      "ELA Assignment Count": properties.elaAssignmentCount,
      "Teacher Type": properties.teacherType,
      "Recommended Category": properties.recommendedCategory,
      "Recommended Playable Code": properties.recommendedPlayableCode,
      "Tab Code": properties.tabCode,
      "Recommended Rail": properties.recommendedRail,
      "Grade": properties.grade,
      "From": properties.from,
      "Worksheet Code": properties.worksheetCode,
      "Discount Pitch": properties.discountPitch,
      "Ela Grade": properties.elaGrade,
      "Active Lp Subjects": properties.activeLpSubjects,
      "Total Memory": properties.totalMemory,
      "Used Memory": properties.usedMemory,
      "Memory Limit": properties.memoryLimit,
      "Memory Usage Percentage": properties.memoryUsagePercentage,
      "Recommended Tile Name": properties.recommendedTileName,
      "Recommended Tile Rank": properties.recommendedTileRank,
      "Recommended Rail Name": properties.recommendedRailName,
      "Recommended Rail Rank": properties.recommendedRailRank,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Tiled Dashboard: This event get fired when the user clicks on any element on the Student Dashboard
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {string} [properties.dashboardVersion] - What kind of Dashboard is visible to the child
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {string} [properties.playableCode] - Pass the 'Playable Code' of the Playable being started/clicked
   * @param {int} [properties.freeActivitiesLeftCount] - Stores the number of free activities left for the user to play on a particular day, at that moment

   * @param {int} [properties.rowPosition] - The row position where the user has clicked. Will start from 1.
   * @param {int} [properties.columnPosition] - The column position where the user has clicked. Will start from 1.
   * @param {string} [properties.clickedOnSection] - Name of the section header where a user clicked/tapped

Comes as Anchor Links for all rails, Lp Customisation for Learning Path customise button
   * @param {string} [properties.clickedOnCategory] - Describes the category on which the user has clicked .
the categories are the broad content types which can be recommended in the daily recommendation section. Eg:  MyToDo, Math_LP, ELA_LP, Math Facts, Books, Spelling, Reading Comprehension, Playzone, Activities, Learning Games
   * @param {string} [properties.isRecommendedContent] - This property will differentiate whether the user is clicking on a recommended content or some other content like headers, tabs etc.
Values can be 'Yes' or 'No'
   * @param {string} [properties.section] - This will capture the widget name that is being viewed/interacted by the user in that viewport. For example, 'Onboarding Widget', 'Home Access Widget', 'Assignment Widget', 'Assessment Widget', 'Math Fact Widget'
The list will only have 1 value for 'Section' property for Interacted event.
   * @param {string} [properties.category] - This represents the different types of content being recommended to the user through the DRS. Possible values = MyToDo, Math_LP, ELA_LP, Math Facts, Books, Spelling, Reading Comprehension, Playzone, Activities, Learning Games, etc







   * @param {string} [properties.gameCode] - Game code of the playable selected, for example: Math learning games have multiple variations, all those variations will have one game code
   * @param {int} [properties.ordering] - This field defines the order of the recommendation. It will start from 0 and then progress by one count at a time.
Since the users' recommendation can change in a particular day for a particular category, this ordering will let us know how the recommended category has changed over a day for the user.
   * @param {Array<string>} [properties.recommendedCategory] - This property will be used to store what recommendations were shown to the user in the all tabs.
We'll be saving them in this format:
<Category Name>
where possible values are:
Category name =  MyToDo, Math_LP, ELA_LP, Math Facts, Books, Spelling, Reading Comprehension, Playzone, Activities, Learning Games
   * @param {Array<string>} [properties.recommendedPlayableCode] - This will be used to store the recommended playable code to the user in the HOME tab , with the daily recommendation system. We'll be saving it in this format:

 <Category Name>|<Playable Code>

where <Category Name> will be same as the values passed in the 'recommended category' property.
   * @param {Array<string>} [properties.recommendedRail] - This property will be used to store which rails were shown to the user in the HOME tab.

Where possible values are:
Rail Name = Curriculum, Game Zone, Math, Language, Logic & Thinking, Art & Creativity, General Knowledge, Motor Skills, Live Classes, Fluency, Multiplayer
This comes with Rank also with | separation
   * @param {string} [properties.contentGroup] - Code of content group user clicked/tapped on
   * @param {string} [properties.worksheetCode] - Worksheet code of selected worksheet
   * @param {string} [properties.topicName] - The academic name of the topic that user selected
   * @param {string} [properties.subject] - Subject Selected during onboarding

   * @param {string} [properties.level1Topic] - Name of Level 1 Topic for worksheets
   * @param {string} [properties.url] - This will capture the URL of the certificates tab on the Springboard page for that particuar class
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} [properties.gradeSelected] - Grade selected by user in curriculum tab
   * @param {Array<string>} [properties.recommendedRailName] - This is the name of the rail viewed by the user. 
Recommended rail property comes with rail name and rail rank, pipe separated - with the introduction of this property, we intend to separate rail name to calculate CTR on Mixpanel.
   * @param {Array<int>} [properties.recommendedRailRank] - Recommended Rail Rank will carry the rank of the rail in integer format viewed by the user. 
   * @param {Array<string>} [properties.recommendedTileName] - This property will store the code of the tile user has interacted with - CG code for curriculum rails and game code for non curr. rails

   * @param {Array<int>} [properties.recommendedTileRank] - This property will store the position of the tile on which user has clciked. Earlier this was sent as column position

   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.interactionType] - Defines the type of interaction (click, scroll, hover etc)
   * @param {string} [properties.valueName] - This will capture the value/text of the field that is selected.
   * @param {string} properties.purchaseClickId - Unique ID associated with each purchase flow. Gets reset when the user exits the purchase flowing (irrespective of successful or unsuccessful purchase)
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/QYCOZy8NPj}
   */
  function interactedTiledDashboard(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertOptionalDashboardVersion(properties.dashboardVersion));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertOptionalPlayableCode(properties.playableCode));
      messages = messages.concat(assertOptionalFreeActivitiesLeftCount(properties.freeActivitiesLeftCount));
      messages = messages.concat(assertOptionalRowPosition(properties.rowPosition));
      messages = messages.concat(assertOptionalColumnPosition(properties.columnPosition));
      messages = messages.concat(assertOptionalClickedOnSection(properties.clickedOnSection));
      messages = messages.concat(assertOptionalClickedOnCategory(properties.clickedOnCategory));
      messages = messages.concat(assertOptionalIsRecommendedContent(properties.isRecommendedContent));
      messages = messages.concat(assertOptionalSection(properties.section));
      messages = messages.concat(assertOptionalCategory(properties.category));
      messages = messages.concat(assertOptionalGameCode(properties.gameCode));
      messages = messages.concat(assertOptionalOrdering(properties.ordering));
      messages = messages.concat(assertOptionalRecommendedCategory(properties.recommendedCategory));
      messages = messages.concat(assertOptionalRecommendedPlayableCode(properties.recommendedPlayableCode));
      messages = messages.concat(assertOptionalRecommendedRail(properties.recommendedRail));
      messages = messages.concat(assertOptionalContentGroup(properties.contentGroup));
      messages = messages.concat(assertOptionalWorksheetCode(properties.worksheetCode));
      messages = messages.concat(assertOptionalTopicName(properties.topicName));
      messages = messages.concat(assertOptionalSubject(properties.subject));
      messages = messages.concat(assertOptionalLevel1Topic(properties.level1Topic));
      messages = messages.concat(assertOptionalUrl(properties.url));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertOptionalGradeSelected(properties.gradeSelected));
      messages = messages.concat(assertOptionalRecommendedRailName(properties.recommendedRailName));
      messages = messages.concat(assertOptionalRecommendedRailRank(properties.recommendedRailRank));
      messages = messages.concat(assertOptionalRecommendedTileName(properties.recommendedTileName));
      messages = messages.concat(assertOptionalRecommendedTileRank(properties.recommendedTileRank));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalInteractionType(properties.interactionType));
      messages = messages.concat(assertOptionalValueName(properties.valueName));
      messages = messages.concat(assertPurchaseClickID(properties.purchaseClickId));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Tiled Dashboard", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "teacherType",
        "dashboardVersion",
        "from",
        "playableCode",
        "freeActivitiesLeftCount",
        "rowPosition",
        "columnPosition",
        "clickedOnSection",
        "clickedOnCategory",
        "isRecommendedContent",
        "section",
        "category",
        "gameCode",
        "ordering",
        "recommendedCategory",
        "recommendedPlayableCode",
        "recommendedRail",
        "contentGroup",
        "worksheetCode",
        "topicName",
        "subject",
        "level1Topic",
        "url",
        "clickedOn",
        "gradeSelected",
        "recommendedRailName",
        "recommendedRailRank",
        "recommendedTileName",
        "recommendedTileRank",
        "elaGrade",
        "grade",
        "interactionType",
        "valueName",
        "purchaseClickId"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "QYCOZy8NPj", "72dd9ebd2b0203ac7d3f3fea8034681f31a90724001341af8ddab600254ba642", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Tiled Dashboard", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Teacher Type": properties.teacherType,
        "Dashboard Version": properties.dashboardVersion,
        "From": properties.from,
        "Playable Code": properties.playableCode,
        "Free Activities Left Count": properties.freeActivitiesLeftCount,
        "Row Position": properties.rowPosition,
        "Column Position": properties.columnPosition,
        "Clicked on Section": properties.clickedOnSection,
        "Clicked on Category": properties.clickedOnCategory,
        "Is Recommended Content": properties.isRecommendedContent,
        "Section": properties.section,
        "Category": properties.category,
        "Game Code": properties.gameCode,
        "Ordering": properties.ordering,
        "Recommended Category": properties.recommendedCategory,
        "Recommended Playable Code": properties.recommendedPlayableCode,
        "Recommended Rail": properties.recommendedRail,
        "Content Group": properties.contentGroup,
        "Worksheet Code": properties.worksheetCode,
        "Topic Name": properties.topicName,
        "Subject": properties.subject,
        "Level 1 Topic": properties.level1Topic,
        "Url": properties.url,
        "Clicked On": properties.clickedOn,
        "Grade Selected": properties.gradeSelected,
        "Recommended Rail Name": properties.recommendedRailName,
        "Recommended Rail Rank": properties.recommendedRailRank,
        "Recommended Tile Name": properties.recommendedTileName,
        "Recommended Tile Rank": properties.recommendedTileRank,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Interaction Type": properties.interactionType,
        "Value Name": properties.valueName,
        "Purchase Click ID": properties.purchaseClickId,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("QYCOZy8NPj", "Interacted Tiled Dashboard", messages, [
        {id: "09LOni_Ki3", name: "Recommended Playable Code", value: properties.recommendedPlayableCode},
        {id: "1Yc2cQ5iyN", name: "Topic Name", value: properties.topicName},
        {id: "1sxa4mA1P", name: "Purchase Click ID", value: properties.purchaseClickId},
        {id: "2oZQdvXRu", name: "Game Code", value: properties.gameCode},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "4YcQJt7EU", name: "Ordering", value: properties.ordering},
        {id: "6QT3mtqEUD", name: "Dashboard Version", value: properties.dashboardVersion},
        {id: "6lrsWYY5Y", name: "Recommended Rail Name", value: properties.recommendedRailName},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "FLDtSJNKL", name: "Recommended Tile Rank", value: properties.recommendedTileRank},
        {id: "Fcl7PSdr4", name: "Grade Selected", value: properties.gradeSelected},
        {id: "NRFYZYLxy", name: "Worksheet Code", value: properties.worksheetCode},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "Otu1r2JQW", name: "Content Group", value: properties.contentGroup},
        {id: "PokUqOLpg8", name: "Interaction Type", value: properties.interactionType},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "QjCwFasvW0", name: "Playable Code", value: properties.playableCode},
        {id: "Sq_wyVgw4s", name: "Column Position", value: properties.columnPosition},
        {id: "TYbmk5DQn", name: "Recommended Tile Name", value: properties.recommendedTileName},
        {id: "ToCgaA4KN", name: "Url", value: properties.url},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "VdJhEU0H6s", name: "Recommended Category", value: properties.recommendedCategory},
        {id: "YzXAIbKaI", name: "Is Recommended Content", value: properties.isRecommendedContent},
        {id: "drNgwJn5Xg", name: "Recommended Rail", value: properties.recommendedRail},
        {id: "hVOa_xHVR", name: "Category", value: properties.category},
        {id: "jHXiFNYU2", name: "Level 1 Topic", value: properties.level1Topic},
        {id: "l-8JNUE0q", name: "Value Name", value: properties.valueName},
        {id: "mOXSzLg0Im", name: "Row Position", value: properties.rowPosition},
        {id: "my9qL7M8w6", name: "Section", value: properties.section},
        {id: "n4HbuwgZ_E", name: "Clicked on Section", value: properties.clickedOnSection},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "s4K0XLoiQ", name: "Clicked on Category", value: properties.clickedOnCategory},
        {id: "uyLgqxbg7", name: "Recommended Rail Rank", value: properties.recommendedRailRank},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "zY_qKY7KjA", name: "Free Activities Left Count", value: properties.freeActivitiesLeftCount},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Tiled Dashboard': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Tiled Dashboard", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Teacher Type": properties.teacherType,
          "Dashboard Version": properties.dashboardVersion,
          "From": properties.from,
          "Playable Code": properties.playableCode,
          "Free Activities Left Count": properties.freeActivitiesLeftCount,
          "Row Position": properties.rowPosition,
          "Column Position": properties.columnPosition,
          "Clicked on Section": properties.clickedOnSection,
          "Clicked on Category": properties.clickedOnCategory,
          "Is Recommended Content": properties.isRecommendedContent,
          "Section": properties.section,
          "Category": properties.category,
          "Game Code": properties.gameCode,
          "Ordering": properties.ordering,
          "Recommended Category": properties.recommendedCategory,
          "Recommended Playable Code": properties.recommendedPlayableCode,
          "Recommended Rail": properties.recommendedRail,
          "Content Group": properties.contentGroup,
          "Worksheet Code": properties.worksheetCode,
          "Topic Name": properties.topicName,
          "Subject": properties.subject,
          "Level 1 Topic": properties.level1Topic,
          "Url": properties.url,
          "Clicked On": properties.clickedOn,
          "Grade Selected": properties.gradeSelected,
          "Recommended Rail Name": properties.recommendedRailName,
          "Recommended Rail Rank": properties.recommendedRailRank,
          "Recommended Tile Name": properties.recommendedTileName,
          "Recommended Tile Rank": properties.recommendedTileRank,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Interaction Type": properties.interactionType,
          "Value Name": properties.valueName,
          "Purchase Click ID": properties.purchaseClickId,
          "Screen Height": sysScreenHeight,
          }, "QYCOZy8NPj", "72dd9ebd2b0203ac7d3f3fea8034681f31a90724001341af8ddab600254ba642");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Tiled Dashboard", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Teacher Type": properties.teacherType,
      "Dashboard Version": properties.dashboardVersion,
      "From": properties.from,
      "Playable Code": properties.playableCode,
      "Free Activities Left Count": properties.freeActivitiesLeftCount,
      "Row Position": properties.rowPosition,
      "Column Position": properties.columnPosition,
      "Clicked on Section": properties.clickedOnSection,
      "Clicked on Category": properties.clickedOnCategory,
      "Is Recommended Content": properties.isRecommendedContent,
      "Section": properties.section,
      "Category": properties.category,
      "Game Code": properties.gameCode,
      "Ordering": properties.ordering,
      "Recommended Category": properties.recommendedCategory,
      "Recommended Playable Code": properties.recommendedPlayableCode,
      "Recommended Rail": properties.recommendedRail,
      "Content Group": properties.contentGroup,
      "Worksheet Code": properties.worksheetCode,
      "Topic Name": properties.topicName,
      "Subject": properties.subject,
      "Level 1 Topic": properties.level1Topic,
      "Url": properties.url,
      "Clicked On": properties.clickedOn,
      "Grade Selected": properties.gradeSelected,
      "Recommended Rail Name": properties.recommendedRailName,
      "Recommended Rail Rank": properties.recommendedRailRank,
      "Recommended Tile Name": properties.recommendedTileName,
      "Recommended Tile Rank": properties.recommendedTileRank,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Interaction Type": properties.interactionType,
      "Value Name": properties.valueName,
      "Purchase Click ID": properties.purchaseClickId,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Completed Student Dashboard Scroll: When the user completed scrolling the full student dashboard page
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} [properties.from] - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/qzgiqToXI_}
   */
  function completedStudentDashboardScroll(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertOptionalFrom(properties.from));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Completed Student Dashboard Scroll", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "from",
        "elaGrade",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "qzgiqToXI_", "a67e732ae27d3a6def35efe0db61531fdd75217dcb6c250d4319b9a2c9b8b082", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Completed Student Dashboard Scroll", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "From": properties.from,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("qzgiqToXI_", "Completed Student Dashboard Scroll", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Completed Student Dashboard Scroll': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Completed Student Dashboard Scroll", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "From": properties.from,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "qzgiqToXI_", "a67e732ae27d3a6def35efe0db61531fdd75217dcb6c250d4319b9a2c9b8b082");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Completed Student Dashboard Scroll", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "From": properties.from,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Completed Page Rendering: Event gets fired when the page rendering is complete and the user can interact with the page
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.pageName - Includes the name of the page (Eg: Playzone game listing page, ). This is not the URL but a easily understandable definition of what page is the user at.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/FW5Xw4S2_v}
   */
  function completedPageRendering(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertPageName(properties.pageName));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Completed Page Rendering", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "pageName"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "FW5Xw4S2_v", "d80031869a54695a8e690baaff8fe769e7a2e99f0fb88a718cd60c520f4b593e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Completed Page Rendering", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Page Name": properties.pageName,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("FW5Xw4S2_v", "Completed Page Rendering", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "MJKSzmqfHu", name: "Page Name", value: properties.pageName},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Completed Page Rendering': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Completed Page Rendering", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Page Name": properties.pageName,
          "Screen Height": sysScreenHeight,
          }, "FW5Xw4S2_v", "d80031869a54695a8e690baaff8fe769e7a2e99f0fb88a718cd60c520f4b593e");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Completed Page Rendering", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Page Name": properties.pageName,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Downloaded Worksheet: Triggers when the teacher downloads any worksheet
   * 
   * When to trigger this event:
   * 1. when the teacher downloads any worksheet.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/lGQI-2ZA69/trigger/jgj_zXiND
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.worksheetGrade - The grade of the worksheets being viewed.
   * @param {string} properties.worksheetName - Name of the Worksheet that is downloaded, clicked or tapped. 
   * @param {string} properties.worksheetCategory - L1 Category of the Worksheet that is download, clicked or viewed
   * @param {string} properties.worksheetSubcategory - Sub-Category of the Worksheet viewed, clicked or downloaded
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/lGQI-2ZA69}
   */
  function downloadedWorksheet(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertWorksheetGrade(properties.worksheetGrade));
      messages = messages.concat(assertWorksheetName(properties.worksheetName));
      messages = messages.concat(assertWorksheetCategory(properties.worksheetCategory));
      messages = messages.concat(assertWorksheetSubcategory(properties.worksheetSubcategory));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Downloaded Worksheet", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "worksheetGrade",
        "worksheetName",
        "worksheetCategory",
        "worksheetSubcategory",
        "from"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "lGQI-2ZA69", "02a6f5da14c994fc1de8de8327be2ac684df4fa0947a6eacefadffe10569090d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Downloaded Worksheet", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Worksheet Grade": properties.worksheetGrade,
        "Worksheet Name": properties.worksheetName,
        "Worksheet Category": properties.worksheetCategory,
        "Worksheet Subcategory": properties.worksheetSubcategory,
        "From": properties.from,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("lGQI-2ZA69", "Downloaded Worksheet", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "HqigT1cZJV", name: "Worksheet Grade", value: properties.worksheetGrade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "ahxpYE3lQW", name: "Worksheet Category", value: properties.worksheetCategory},
        {id: "g8uPZdwOmF", name: "Worksheet Name", value: properties.worksheetName},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "z0AEnWmrqD", name: "Worksheet Subcategory", value: properties.worksheetSubcategory},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Downloaded Worksheet': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Downloaded Worksheet", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Worksheet Grade": properties.worksheetGrade,
          "Worksheet Name": properties.worksheetName,
          "Worksheet Category": properties.worksheetCategory,
          "Worksheet Subcategory": properties.worksheetSubcategory,
          "From": properties.from,
          "Screen Height": sysScreenHeight,
          }, "lGQI-2ZA69", "02a6f5da14c994fc1de8de8327be2ac684df4fa0947a6eacefadffe10569090d");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Downloaded Worksheet", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Worksheet Grade": properties.worksheetGrade,
      "Worksheet Name": properties.worksheetName,
      "Worksheet Category": properties.worksheetCategory,
      "Worksheet Subcategory": properties.worksheetSubcategory,
      "From": properties.from,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Clicked Worksheet Tab: When the teacher clicks the left navigation download worksheets CTA. This event should trigger. This highlights discovery of the download worksheets feature.
   * 
   * When to trigger this event:
   * 1. When the teacher clicks the Worksheet tab within the left nav
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/5p59KeeWV/trigger/eQVZ1S38b
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/5p59KeeWV}
   */
  function clickedWorksheetTab(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Clicked Worksheet Tab", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "5p59KeeWV", "74790f14fddc2beec081ead2a8d164070992d1b1a43b5f0f2c344bddfc078cfd", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Clicked Worksheet Tab", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("5p59KeeWV", "Clicked Worksheet Tab", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Clicked Worksheet Tab': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Clicked Worksheet Tab", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "5p59KeeWV", "74790f14fddc2beec081ead2a8d164070992d1b1a43b5f0f2c344bddfc078cfd");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Clicked Worksheet Tab", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Applied Worksheet Filters: When the teacher applies the worksheet filters. This event is triggered every time a filter is applied.
   * 
   * When to trigger this event:
   * 1. When the teacher applies the worksheet filters. This event is triggered every time a filter is applied.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/kjj5usN5Kz/trigger/xYJLOhJ9R
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.worksheetGrade - The grade of the worksheets being viewed.
   * @param {string} properties.worksheetFilterValue - Value of the applied filter It will be categories or subcategories names - L1, L2, L3, etc.
   * @param {string} properties.worksheetFilterAppliedOn - On which level, the filter got applied.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/kjj5usN5Kz}
   */
  function appliedWorksheetFilters(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertWorksheetGrade(properties.worksheetGrade));
      messages = messages.concat(assertWorksheetFilterValue(properties.worksheetFilterValue));
      messages = messages.concat(assertWorksheetFilterAppliedOn(properties.worksheetFilterAppliedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Applied Worksheet Filters", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "worksheetGrade",
        "worksheetFilterValue",
        "worksheetFilterAppliedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "kjj5usN5Kz", "84b2270ea7d75e1a8c11073d23727efa56369c22483b6efd39b758cc0e760d45", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Applied Worksheet Filters", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Worksheet Grade": properties.worksheetGrade,
        "Worksheet Filter Value": properties.worksheetFilterValue,
        "Worksheet Filter Applied On": properties.worksheetFilterAppliedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("kjj5usN5Kz", "Applied Worksheet Filters", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "4bmBhSOqz4", name: "Worksheet Filter Applied On", value: properties.worksheetFilterAppliedOn},
        {id: "HqigT1cZJV", name: "Worksheet Grade", value: properties.worksheetGrade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UGULV7SI7o", name: "Worksheet Filter Value", value: properties.worksheetFilterValue},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Applied Worksheet Filters': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Applied Worksheet Filters", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Worksheet Grade": properties.worksheetGrade,
          "Worksheet Filter Value": properties.worksheetFilterValue,
          "Worksheet Filter Applied On": properties.worksheetFilterAppliedOn,
          "Screen Height": sysScreenHeight,
          }, "kjj5usN5Kz", "84b2270ea7d75e1a8c11073d23727efa56369c22483b6efd39b758cc0e760d45");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Applied Worksheet Filters", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Worksheet Grade": properties.worksheetGrade,
      "Worksheet Filter Value": properties.worksheetFilterValue,
      "Worksheet Filter Applied On": properties.worksheetFilterAppliedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Cleared Worksheet Filters: When the teacher clears the filters with the click to the filter
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.worksheetGrade - The grade of the worksheets being viewed.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/a-k3T3B34U}
   */
  function clearedWorksheetFilters(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertWorksheetGrade(properties.worksheetGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Cleared Worksheet Filters", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "worksheetGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "a-k3T3B34U", "b32e919343de7525f337d5a624aa8d11497daca15e2fab7fded3baea959bee6e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Cleared Worksheet Filters", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Worksheet Grade": properties.worksheetGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("a-k3T3B34U", "Cleared Worksheet Filters", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "HqigT1cZJV", name: "Worksheet Grade", value: properties.worksheetGrade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Cleared Worksheet Filters': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Cleared Worksheet Filters", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Worksheet Grade": properties.worksheetGrade,
          "Screen Height": sysScreenHeight,
          }, "a-k3T3B34U", "b32e919343de7525f337d5a624aa8d11497daca15e2fab7fded3baea959bee6e");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Cleared Worksheet Filters", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Worksheet Grade": properties.worksheetGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Worksheet Listing Page: When the user views the worksheets listing page. This event should get fired.
   * 
   * When to trigger this event:
   * 1. When the user views the worksheet listing screen.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/N8fH5uK5Ju/trigger/h6ihma18M
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.worksheetGrade - The grade of the worksheets being viewed.
   * @param {string} properties.freeWorksheetsLeftCount - Stores the number of free worksheets left for the user to play on a particular day, at that moment
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/N8fH5uK5Ju}
   */
  function viewedWorksheetListingPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertWorksheetGrade(properties.worksheetGrade));
      messages = messages.concat(assertFreeWorksheetsLeftCount(properties.freeWorksheetsLeftCount));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Worksheet Listing Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "worksheetGrade",
        "freeWorksheetsLeftCount",
        "fromPage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "N8fH5uK5Ju", "bcf2a228c80cdcceb256d4ce4240deddd08069d99a8d3f8126718c58f4de6453", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Worksheet Listing Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Worksheet Grade": properties.worksheetGrade,
        "Free Worksheets Left Count": properties.freeWorksheetsLeftCount,
        "From Page": properties.fromPage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("N8fH5uK5Ju", "Viewed Worksheet Listing Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "H4pP9av1w", name: "Free Worksheets Left Count", value: properties.freeWorksheetsLeftCount},
        {id: "HqigT1cZJV", name: "Worksheet Grade", value: properties.worksheetGrade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Worksheet Listing Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Worksheet Listing Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Worksheet Grade": properties.worksheetGrade,
          "Free Worksheets Left Count": properties.freeWorksheetsLeftCount,
          "From Page": properties.fromPage,
          "Screen Height": sysScreenHeight,
          }, "N8fH5uK5Ju", "bcf2a228c80cdcceb256d4ce4240deddd08069d99a8d3f8126718c58f4de6453");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Worksheet Listing Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Worksheet Grade": properties.worksheetGrade,
      "Free Worksheets Left Count": properties.freeWorksheetsLeftCount,
      "From Page": properties.fromPage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Worksheet Listing Page: When the teacher interacts anywhere on the worksheet listing page. 
   * 
   * When to trigger this event:
   * 1. When the teacher interacts anywhere on the worksheet listing page
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/amI4okNeBJ/trigger/ibbC3eEYY
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/amI4okNeBJ}
   */
  function interactedWorksheetListingPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Worksheet Listing Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "amI4okNeBJ", "556bbe83310c54f62b5601d4bf24aa1cc62388f6eeae0565baced2cb91d29044", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Worksheet Listing Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("amI4okNeBJ", "Interacted Worksheet Listing Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Worksheet Listing Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Worksheet Listing Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "amI4okNeBJ", "556bbe83310c54f62b5601d4bf24aa1cc62388f6eeae0565baced2cb91d29044");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Worksheet Listing Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Saved Worksheet: When the teacher saves a worksheet
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.worksheetGrade - The grade of the worksheets being viewed.
   * @param {string} properties.worksheetCategory - L1 Category of the Worksheet that is download, clicked or viewed
   * @param {string} properties.worksheetSubcategory - Sub-Category of the Worksheet viewed, clicked or downloaded
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/6UiDsewmiH}
   */
  function savedWorksheet(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertWorksheetGrade(properties.worksheetGrade));
      messages = messages.concat(assertWorksheetCategory(properties.worksheetCategory));
      messages = messages.concat(assertWorksheetSubcategory(properties.worksheetSubcategory));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Saved Worksheet", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "worksheetGrade",
        "worksheetCategory",
        "worksheetSubcategory",
        "from"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "6UiDsewmiH", "532f94bed507e804295d101b7d50bdf2c07882ab889ff8915526bd06acb2b23e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Saved Worksheet", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Worksheet Grade": properties.worksheetGrade,
        "Worksheet Category": properties.worksheetCategory,
        "Worksheet Subcategory": properties.worksheetSubcategory,
        "From": properties.from,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("6UiDsewmiH", "Saved Worksheet", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "HqigT1cZJV", name: "Worksheet Grade", value: properties.worksheetGrade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "ahxpYE3lQW", name: "Worksheet Category", value: properties.worksheetCategory},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "z0AEnWmrqD", name: "Worksheet Subcategory", value: properties.worksheetSubcategory},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Saved Worksheet': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Saved Worksheet", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Worksheet Grade": properties.worksheetGrade,
          "Worksheet Category": properties.worksheetCategory,
          "Worksheet Subcategory": properties.worksheetSubcategory,
          "From": properties.from,
          "Screen Height": sysScreenHeight,
          }, "6UiDsewmiH", "532f94bed507e804295d101b7d50bdf2c07882ab889ff8915526bd06acb2b23e");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Saved Worksheet", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Worksheet Grade": properties.worksheetGrade,
      "Worksheet Category": properties.worksheetCategory,
      "Worksheet Subcategory": properties.worksheetSubcategory,
      "From": properties.from,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Saved Worksheet Page: When the teacher views the saved worksheet page
   * 
   * When to trigger this event:
   * 1. When the teacher views the saved worksheet page
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/XfIbszF0Oq/trigger/Yz7gjYdNR
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.worksheetGrade - The grade of the worksheets being viewed.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/XfIbszF0Oq}
   */
  function viewedSavedWorksheetPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertWorksheetGrade(properties.worksheetGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Saved Worksheet Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "worksheetGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "XfIbszF0Oq", "64f5cfbbe68362d4cec9966639af3e7eb1aca2b98f03621a564f9910a685ae46", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Saved Worksheet Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Worksheet Grade": properties.worksheetGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("XfIbszF0Oq", "Viewed Saved Worksheet Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "HqigT1cZJV", name: "Worksheet Grade", value: properties.worksheetGrade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Saved Worksheet Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Saved Worksheet Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Worksheet Grade": properties.worksheetGrade,
          "Screen Height": sysScreenHeight,
          }, "XfIbszF0Oq", "64f5cfbbe68362d4cec9966639af3e7eb1aca2b98f03621a564f9910a685ae46");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Saved Worksheet Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Worksheet Grade": properties.worksheetGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Download History Worksheet Page: When the teacher views the Download History Page
   * 
   * When to trigger this event:
   * 1. when the teacher views the download history page
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/rFuxyWHgbL/trigger/XViGJQYMz
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.worksheetGrade - The grade of the worksheets being viewed.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/rFuxyWHgbL}
   */
  function viewedDownloadHistoryWorksheetPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertWorksheetGrade(properties.worksheetGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Download History Worksheet Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "worksheetGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "rFuxyWHgbL", "fc63c346bcc1e2d3bcd418274656ba711e3de2ece86bfc089bc14360a396879d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Download History Worksheet Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Worksheet Grade": properties.worksheetGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("rFuxyWHgbL", "Viewed Download History Worksheet Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "HqigT1cZJV", name: "Worksheet Grade", value: properties.worksheetGrade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Download History Worksheet Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Download History Worksheet Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Worksheet Grade": properties.worksheetGrade,
          "Screen Height": sysScreenHeight,
          }, "rFuxyWHgbL", "fc63c346bcc1e2d3bcd418274656ba711e3de2ece86bfc089bc14360a396879d");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Download History Worksheet Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Worksheet Grade": properties.worksheetGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Previewed Worksheet: When the teacher previews a worksheet
   * 
   * When to trigger this event:
   * 1. When the teacher previews a worksheet
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/JjcYtc2ak/trigger/JCn6YF35A
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.worksheetGrade - The grade of the worksheets being viewed.
   * @param {string} properties.worksheetName - Name of the Worksheet that is downloaded, clicked or tapped. 
   * @param {string} properties.worksheetCategory - L1 Category of the Worksheet that is download, clicked or viewed
   * @param {string} properties.worksheetSubcategory - Sub-Category of the Worksheet viewed, clicked or downloaded
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/JjcYtc2ak}
   */
  function previewedWorksheet(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertWorksheetGrade(properties.worksheetGrade));
      messages = messages.concat(assertWorksheetName(properties.worksheetName));
      messages = messages.concat(assertWorksheetCategory(properties.worksheetCategory));
      messages = messages.concat(assertWorksheetSubcategory(properties.worksheetSubcategory));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Previewed Worksheet", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "worksheetGrade",
        "worksheetName",
        "worksheetCategory",
        "worksheetSubcategory"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "JjcYtc2ak", "d9ff1031bccb177f68cd7160d81ad0835516d10fbdb2bed1f16ebc7df7e04714", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Previewed Worksheet", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Worksheet Grade": properties.worksheetGrade,
        "Worksheet Name": properties.worksheetName,
        "Worksheet Category": properties.worksheetCategory,
        "Worksheet Subcategory": properties.worksheetSubcategory,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("JjcYtc2ak", "Previewed Worksheet", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "HqigT1cZJV", name: "Worksheet Grade", value: properties.worksheetGrade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "ahxpYE3lQW", name: "Worksheet Category", value: properties.worksheetCategory},
        {id: "g8uPZdwOmF", name: "Worksheet Name", value: properties.worksheetName},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "z0AEnWmrqD", name: "Worksheet Subcategory", value: properties.worksheetSubcategory},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Previewed Worksheet': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Previewed Worksheet", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Worksheet Grade": properties.worksheetGrade,
          "Worksheet Name": properties.worksheetName,
          "Worksheet Category": properties.worksheetCategory,
          "Worksheet Subcategory": properties.worksheetSubcategory,
          "Screen Height": sysScreenHeight,
          }, "JjcYtc2ak", "d9ff1031bccb177f68cd7160d81ad0835516d10fbdb2bed1f16ebc7df7e04714");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Previewed Worksheet", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Worksheet Grade": properties.worksheetGrade,
      "Worksheet Name": properties.worksheetName,
      "Worksheet Category": properties.worksheetCategory,
      "Worksheet Subcategory": properties.worksheetSubcategory,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Closed Math Facts: When math facts is closed
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.endPoint - This is the phase of math facts in which user closes the math facts game (e.g. portal, city, jungle, cafe etc)
   * @param {int} properties.totalProblemsAnswered - Total problems answered to complete the assignment.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/SmHULzglN}
   */
  function closedMathFacts(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertEndPoint(properties.endPoint));
      messages = messages.concat(assertTotalProblemsAnswered(properties.totalProblemsAnswered));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Closed Math Facts", Object.keys(properties), [
        "endPoint",
        "totalProblemsAnswered",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "SmHULzglN", "eadd3db8efc3af77decc0e516bb80f2ba7b5c57f4779a49b88c488b2248f52dd", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Closed Math Facts", {
        "End Point": properties.endPoint,
        "Total Problems Answered": properties.totalProblemsAnswered,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("SmHULzglN", "Closed Math Facts", messages, [
        {id: "6R8Dsubm7", name: "End Point", value: properties.endPoint},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "V_eCbteEGc", name: "Total Problems Answered", value: properties.totalProblemsAnswered},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Closed Math Facts': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Closed Math Facts", {
          "End Point": properties.endPoint,
          "Total Problems Answered": properties.totalProblemsAnswered,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "SmHULzglN", "eadd3db8efc3af77decc0e516bb80f2ba7b5c57f4779a49b88c488b2248f52dd");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Closed Math Facts", {
      "End Point": properties.endPoint,
      "Total Problems Answered": properties.totalProblemsAnswered,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Activity Page: When user scrolls down on activity page v1 on web
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.interaction - The type of interaction that occurs
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/UigRfT3ifQ}
   */
  function interactedActivityPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertInteraction(properties.interaction));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Activity Page", Object.keys(properties), [
        "interaction"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "UigRfT3ifQ", "e35ea04fcbff9bd60cdddbb6e23a9710539fbe3db2670394948ac6ae3eb8b057", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Activity Page", {
        "Interaction": properties.interaction,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("UigRfT3ifQ", "Interacted Activity Page", messages, [
        {id: "kwwJ5LAMqN", name: "Interaction", value: properties.interaction},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Activity Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Activity Page", {
          "Interaction": properties.interaction,
          "Screen Height": sysScreenHeight,
          }, "UigRfT3ifQ", "e35ea04fcbff9bd60cdddbb6e23a9710539fbe3db2670394948ac6ae3eb8b057");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Activity Page", {
      "Interaction": properties.interaction,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Email Verified Frontend: This event will be fired from frontend when the email of the user is verified. Ideally, this event will be fired after OTP verification.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.email - Email Id of the user
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Fmn9HpX5I5}
   */
  function emailVerifiedFrontend(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertEmail(properties.email));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Email Verified Frontend", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "email"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Fmn9HpX5I5", "e2f16de1881d262a1bbf595d94bd4bd031088b59e30dd0f41cf75aabae1ded70", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Email Verified Frontend", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Email": properties.email,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Fmn9HpX5I5", "Email Verified Frontend", messages, [
        {id: "mGe3lMWlNY", name: "Email", value: properties.email},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Email Verified Frontend': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Email Verified Frontend", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Email": properties.email,
          "Screen Height": sysScreenHeight,
          }, "Fmn9HpX5I5", "e2f16de1881d262a1bbf595d94bd4bd031088b59e30dd0f41cf75aabae1ded70");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Email Verified Frontend", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Email": properties.email,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Selected Game: When the user selects a game from the game zone section 
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {int} properties.columnNumber - The column in which the game is appearing
   * @param {int} properties.gameNamePosition - Defines the position of the game among many games shown
   * @param {int} properties.rowNumber - no description
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/GUc49405aY}
   */
  function selectedGame(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertColumnNumber(properties.columnNumber));
      messages = messages.concat(assertGameNamePosition(properties.gameNamePosition));
      messages = messages.concat(assertRowNumber(properties.rowNumber));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Selected Game", Object.keys(properties), [
        "columnNumber",
        "gameNamePosition",
        "rowNumber"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "GUc49405aY", "1bcb39a2884e7b7a812b43a2a3ece6a4901cda26508809d61c51835e61acf190", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Selected Game", {
        "Column Number": properties.columnNumber,
        "Game Name Position": properties.gameNamePosition,
        "Row Number": properties.rowNumber,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("GUc49405aY", "Selected Game", messages, [
        {id: "JnQC7Gu0QJ", name: "Game Name Position", value: properties.gameNamePosition},
        {id: "a9l_OugqB", name: "Row Number", value: properties.rowNumber},
        {id: "eGs90Bi3pM", name: "Column Number", value: properties.columnNumber},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Selected Game': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Selected Game", {
          "Column Number": properties.columnNumber,
          "Game Name Position": properties.gameNamePosition,
          "Row Number": properties.rowNumber,
          "Screen Height": sysScreenHeight,
          }, "GUc49405aY", "1bcb39a2884e7b7a812b43a2a3ece6a4901cda26508809d61c51835e61acf190");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Selected Game", {
      "Column Number": properties.columnNumber,
      "Game Name Position": properties.gameNamePosition,
      "Row Number": properties.rowNumber,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Visited Onboarding Welcome: Triggered as soon as the Onboarding Welcome Screen is displayed. This is the 'Let's Get Started' screen before Question 1.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/myZ13O-4HH/trigger/I9qJyBaCH
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/myZ13O-4HH}
   */
  function visitedOnboardingWelcome(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Visited Onboarding Welcome", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "myZ13O-4HH", "a57a4e44c04f0793fe33ce64ce44056a695491a7d8c33d5e73121f285c3d9147", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Visited Onboarding Welcome", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("myZ13O-4HH", "Visited Onboarding Welcome", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Visited Onboarding Welcome': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Visited Onboarding Welcome", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "myZ13O-4HH", "a57a4e44c04f0793fe33ce64ce44056a695491a7d8c33d5e73121f285c3d9147");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Visited Onboarding Welcome", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Teacher Onboarding: This will capture all user activities within the Onboarding Widget
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.question - This will capture the Question in full. For example, 'How big is your class?'
   * @param {string} properties.answer - This will capture the option selected by the user to that question. For example, '1-5'
   * @param {string} properties.questionType - This will capture the type of question such as multi-select, single-select etc.
   * @param {string} [properties.questionNo] - This will capture the Question Serial no. as it appears in sequence
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Qt2dyR-p_T}
   */
  function interactedTeacherOnboarding(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertQuestion(properties.question));
      messages = messages.concat(assertAnswer(properties.answer));
      messages = messages.concat(assertQuestionType(properties.questionType));
      messages = messages.concat(assertOptionalQuestionNo(properties.questionNo));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Teacher Onboarding", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "question",
        "answer",
        "questionType",
        "questionNo",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Qt2dyR-p_T", "9348856b1e52fe17263a4f21832686ded56b59cbf64391562c3fcb14ed8355d1", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Teacher Onboarding", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Question": properties.question,
        "Answer": properties.answer,
        "Question Type": properties.questionType,
        "Question No.": properties.questionNo,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Qt2dyR-p_T", "Interacted Teacher Onboarding", messages, [
        {id: "1BxvMk6Nz6", name: "Question No.", value: properties.questionNo},
        {id: "2pLBcf4Iyi", name: "Question Type", value: properties.questionType},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "EsalTilTi7", name: "Question", value: properties.question},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "coqPCyLyxy", name: "Answer", value: properties.answer},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Teacher Onboarding': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Teacher Onboarding", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Question": properties.question,
          "Answer": properties.answer,
          "Question Type": properties.questionType,
          "Question No.": properties.questionNo,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "Qt2dyR-p_T", "9348856b1e52fe17263a4f21832686ded56b59cbf64391562c3fcb14ed8355d1");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Teacher Onboarding", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Question": properties.question,
      "Answer": properties.answer,
      "Question Type": properties.questionType,
      "Question No.": properties.questionNo,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Age Question Screen Viewed: The age screen viewed by the user.
   * 
   * When to trigger this event:
   * 1. When the user sees the age question screen
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/tcVyFoch9O/trigger/qDLA6RJpx
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/tcVyFoch9O}
   */
  function ageQuestionScreenViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Age Question Screen Viewed", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "tcVyFoch9O", "c56d017402c06fe21373348160b303ae54fe9d05513952422fa610859dc8b4bb", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Age Question Screen Viewed", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("tcVyFoch9O", "Age Question Screen Viewed", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Age Question Screen Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Age Question Screen Viewed", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "tcVyFoch9O", "c56d017402c06fe21373348160b303ae54fe9d05513952422fa610859dc8b4bb");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Age Question Screen Viewed", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Age Question Screen Interacted: When the user interacted the age question screen.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/iccYpaT6xl}
   */
  function ageQuestionScreenInteracted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Age Question Screen Interacted", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "iccYpaT6xl", "99de2ef2ab435ea8917b98d7f7c708de2b1f30c40af779b17bb12029bac0ba76", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Age Question Screen Interacted", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("iccYpaT6xl", "Age Question Screen Interacted", messages, [
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Age Question Screen Interacted': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Age Question Screen Interacted", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "iccYpaT6xl", "99de2ef2ab435ea8917b98d7f7c708de2b1f30c40af779b17bb12029bac0ba76");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Age Question Screen Interacted", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Onboarding Question Screen Viewed: When the user views the POQ Screen
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {int} properties.questionIndex - Index means order of the question
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/l_703E23G}
   */
  function onboardingQuestionScreenViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertQuestionIndex(properties.questionIndex));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Onboarding Question Screen Viewed", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "grade",
        "subject",
        "questionIndex"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "l_703E23G", "11ea271b3ce473a753a4a20a4999be7839488d3853829c4a51b8328b27f91a8b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Onboarding Question Screen Viewed", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Subject": properties.subject,
        "Question Index": properties.questionIndex,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("l_703E23G", "Onboarding Question Screen Viewed", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "jJNP65jPw7", name: "Question Index", value: properties.questionIndex},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Onboarding Question Screen Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Onboarding Question Screen Viewed", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Subject": properties.subject,
          "Question Index": properties.questionIndex,
          "Screen Height": sysScreenHeight,
          }, "l_703E23G", "11ea271b3ce473a753a4a20a4999be7839488d3853829c4a51b8328b27f91a8b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Onboarding Question Screen Viewed", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Subject": properties.subject,
      "Question Index": properties.questionIndex,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Onboarding Question Interacted: When the user interacts the onboarding question
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {int} properties.questionIndex - Index means order of the question
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/HAYu07U2i_}
   */
  function onboardingQuestionInteracted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertQuestionIndex(properties.questionIndex));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Onboarding Question Interacted", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "grade",
        "subject",
        "questionIndex"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "HAYu07U2i_", "9c3c4948d07e002d8e8666aefbd2e8ec91fb93c7513b59fa2b60b212a6f322b2", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Onboarding Question Interacted", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Subject": properties.subject,
        "Question Index": properties.questionIndex,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("HAYu07U2i_", "Onboarding Question Interacted", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "jJNP65jPw7", name: "Question Index", value: properties.questionIndex},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Onboarding Question Interacted': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Onboarding Question Interacted", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Subject": properties.subject,
          "Question Index": properties.questionIndex,
          "Screen Height": sysScreenHeight,
          }, "HAYu07U2i_", "9c3c4948d07e002d8e8666aefbd2e8ec91fb93c7513b59fa2b60b212a6f322b2");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Onboarding Question Interacted", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Subject": properties.subject,
      "Question Index": properties.questionIndex,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Assignment Successfully Assigned Page: This event is triggered upon click of Download Invite/Copy Invite button after assigning assignments to whole class/selected students
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.assignmentType - This will capture the type of assignment - Manual or Auto
   * @param {int} properties.daysSinceClassCreation - Self explanatory
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/4MkkX6efTw}
   */
  function interactedAssignmentSuccessfullyAssignedPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertAssignmentType(properties.assignmentType));
      messages = messages.concat(assertDaysSinceClassCreation(properties.daysSinceClassCreation));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Assignment Successfully Assigned Page", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "clickedOn",
        "assignmentType",
        "daysSinceClassCreation"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "4MkkX6efTw", "6a8578acd176fb1a9c13c51386f0a0367f081b85e180bf68daf7bc69d80e8cf8", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Assignment Successfully Assigned Page", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Clicked On": properties.clickedOn,
        "Assignment Type": properties.assignmentType,
        "Days Since Class Creation": properties.daysSinceClassCreation,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("4MkkX6efTw", "Interacted Assignment Successfully Assigned Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "TuspgTIuZ1", name: "Days Since Class Creation", value: properties.daysSinceClassCreation},
        {id: "Ueowl7sRb", name: "Assignment Type", value: properties.assignmentType},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Assignment Successfully Assigned Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Assignment Successfully Assigned Page", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Clicked On": properties.clickedOn,
          "Assignment Type": properties.assignmentType,
          "Days Since Class Creation": properties.daysSinceClassCreation,
          "Screen Height": sysScreenHeight,
          }, "4MkkX6efTw", "6a8578acd176fb1a9c13c51386f0a0367f081b85e180bf68daf7bc69d80e8cf8");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Assignment Successfully Assigned Page", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Clicked On": properties.clickedOn,
      "Assignment Type": properties.assignmentType,
      "Days Since Class Creation": properties.daysSinceClassCreation,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed MF Successfully Assigned Page: This event is triggered upon viewing the math facts successfully assigned message. 
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/bj93efYuQU}
   */
  function viewedMfSuccessfullyAssignedPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed MF Successfully Assigned Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "bj93efYuQU", "1123a9565ff528d1cdd966bc352b1506119373a894e27dec5d7f9cabe039db2d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed MF Successfully Assigned Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("bj93efYuQU", "Viewed MF Successfully Assigned Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed MF Successfully Assigned Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed MF Successfully Assigned Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "bj93efYuQU", "1123a9565ff528d1cdd966bc352b1506119373a894e27dec5d7f9cabe039db2d");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed MF Successfully Assigned Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Assignment Successfully Assigned Page: This event is triggered upon viewing the assignment successfully assigned message. 
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/2o7dYwXo9D/trigger/Q_5_ZcryM
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * @param {string} properties.source - Click source
   * @param {int} properties.totalAssignmentCount - Assignment count shown on the myToDo card on student dashboard.
   * @param {string} properties.assignmentType - This will capture the type of assignment - Manual or Auto
   * @param {int} properties.studentsAssignedTo - This will capture the no. of students to whom the assignment is assigned.
   * @param {string} properties.contentType - Type of content viz. Game/Learning Path/Activities/Worksheets
   * @param {int} properties.daysSinceClassCreation - Self explanatory
   * @param {string} properties.assignmentDueInDays - This property returns the difference between assignment assigning date and the assignment due date set by the teacher. In case of editing the assignment due date, the difference will be counted between the date of updating due date and the new due date.
   * @param {string} properties.isDueDateUpdated - This property will return 1 if assignment due date has been updated by the teacher, otherwise this will return 0. For control, this property will return 'NA'
   * @param {string} properties.isStudentsCountUpdated - This property will return 1 if students to whom assignment has been assigned is updated by the teacher. Otherwise, this will return 0
   * @param {string} properties.assignmentGrade - This property will return the grade of the curriculum assignment assigned by the teacher
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/2o7dYwXo9D}
   */
  function viewedAssignmentSuccessfullyAssignedPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertSource(properties.source));
      messages = messages.concat(assertTotalAssignmentCount(properties.totalAssignmentCount));
      messages = messages.concat(assertAssignmentType(properties.assignmentType));
      messages = messages.concat(assertStudentsAssignedTo(properties.studentsAssignedTo));
      messages = messages.concat(assertContentType(properties.contentType));
      messages = messages.concat(assertDaysSinceClassCreation(properties.daysSinceClassCreation));
      messages = messages.concat(assertAssignmentDueInDays(properties.assignmentDueInDays));
      messages = messages.concat(assertIsDueDateUpdated(properties.isDueDateUpdated));
      messages = messages.concat(assertIsStudentsCountUpdated(properties.isStudentsCountUpdated));
      messages = messages.concat(assertAssignmentGrade(properties.assignmentGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Assignment Successfully Assigned Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "fromPage",
        "source",
        "totalAssignmentCount",
        "assignmentType",
        "studentsAssignedTo",
        "contentType",
        "daysSinceClassCreation",
        "assignmentDueInDays",
        "isDueDateUpdated",
        "isStudentsCountUpdated",
        "assignmentGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "2o7dYwXo9D", "258602783410f09bf051bd407c6f9d13920a53150a07a27c13035a014db67b89", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Assignment Successfully Assigned Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From Page": properties.fromPage,
        "Source": properties.source,
        "Total Assignment Count": properties.totalAssignmentCount,
        "Assignment Type": properties.assignmentType,
        "Students Assigned To": properties.studentsAssignedTo,
        "Content Type": properties.contentType,
        "Days Since Class Creation": properties.daysSinceClassCreation,
        "Assignment Due in Days": properties.assignmentDueInDays,
        "Is Due Date Updated": properties.isDueDateUpdated,
        "Is Students Count Updated": properties.isStudentsCountUpdated,
        "Assignment Grade": properties.assignmentGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("2o7dYwXo9D", "Viewed Assignment Successfully Assigned Page", messages, [
        {id: "293juZE8KT", name: "Source", value: properties.source},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "4M0W7L2cW", name: "Assignment Due in Days", value: properties.assignmentDueInDays},
        {id: "7d3MiAKT4oiit-t-kjZ6R", name: "Assignment Grade", value: properties.assignmentGrade},
        {id: "Nfs9QLl8W7", name: "Content Type", value: properties.contentType},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "TuspgTIuZ1", name: "Days Since Class Creation", value: properties.daysSinceClassCreation},
        {id: "Ueowl7sRb", name: "Assignment Type", value: properties.assignmentType},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "bDM9SfUbv", name: "Is Students Count Updated", value: properties.isStudentsCountUpdated},
        {id: "hBgoB0mPff", name: "Total Assignment Count", value: properties.totalAssignmentCount},
        {id: "iMhjpqQ9V", name: "Is Due Date Updated", value: properties.isDueDateUpdated},
        {id: "mvOIacTNl", name: "Students Assigned To", value: properties.studentsAssignedTo},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Assignment Successfully Assigned Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Assignment Successfully Assigned Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From Page": properties.fromPage,
          "Source": properties.source,
          "Total Assignment Count": properties.totalAssignmentCount,
          "Assignment Type": properties.assignmentType,
          "Students Assigned To": properties.studentsAssignedTo,
          "Content Type": properties.contentType,
          "Days Since Class Creation": properties.daysSinceClassCreation,
          "Assignment Due in Days": properties.assignmentDueInDays,
          "Is Due Date Updated": properties.isDueDateUpdated,
          "Is Students Count Updated": properties.isStudentsCountUpdated,
          "Assignment Grade": properties.assignmentGrade,
          "Screen Height": sysScreenHeight,
          }, "2o7dYwXo9D", "258602783410f09bf051bd407c6f9d13920a53150a07a27c13035a014db67b89");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Assignment Successfully Assigned Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From Page": properties.fromPage,
      "Click Source": properties.source,
      "Total Assignment Count": properties.totalAssignmentCount,
      "Assignment Type": properties.assignmentType,
      "Students Assigned To": properties.studentsAssignedTo,
      "Content Type": properties.contentType,
      "Days Since Class Creation": properties.daysSinceClassCreation,
      "Assignment Due in Days": properties.assignmentDueInDays,
      "Is Due Date Updated": properties.isDueDateUpdated,
      "Is Students Count Updated": properties.isStudentsCountUpdated,
      "Assignment Grade": properties.assignmentGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted MF Successfully Assigned Page: This event is triggered upon click of Download Invite/Copy Invite button after assigning Math Facts to whole class/selected students
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/FmBMqEoizp}
   */
  function interactedMfSuccessfullyAssignedPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted MF Successfully Assigned Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "FmBMqEoizp", "6590ca773c73dce7474d28a00eb9a99527332e37ed6ebc926ab49cc39fd2cb47", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted MF Successfully Assigned Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("FmBMqEoizp", "Interacted MF Successfully Assigned Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted MF Successfully Assigned Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted MF Successfully Assigned Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "FmBMqEoizp", "6590ca773c73dce7474d28a00eb9a99527332e37ed6ebc926ab49cc39fd2cb47");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted MF Successfully Assigned Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Game Zone: This triggers when user sees the combined game zone page (with games activities rewards etc)
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/IV3pR1u9m1}
   */
  function viewedGameZone(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Game Zone", Object.keys(properties), [
        "grade",
        "mathGrade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "IV3pR1u9m1", "2003e17973cdf120f3becfb54e325cc3820a816a11c507a3e47e34f1b8c1361c", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Game Zone", {
        "Grade": properties.grade,
        "Math Grade": properties.mathGrade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("IV3pR1u9m1", "Viewed Game Zone", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Game Zone': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Game Zone", {
          "Grade": properties.grade,
          "Math Grade": properties.mathGrade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "IV3pR1u9m1", "2003e17973cdf120f3becfb54e325cc3820a816a11c507a3e47e34f1b8c1361c");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Game Zone", {
      "Grade": properties.grade,
      "Math Grade": properties.mathGrade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Game Zone: This triggers when user interacts with (click/tap or scroll) with any element of the game zone page
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.interactionType - Defines the type of interaction (click, scroll, hover etc)
   * @param {string} [properties.clickedOnSection] - Name of the section header where a user clicked/tapped

Comes as Anchor Links for all rails, Lp Customisation for Learning Path customise button
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} [properties.scrolledThrough] - Name of the section header where a user scrolled through
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/yJACkx1pin}
   */
  function interactedGameZone(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertInteractionType(properties.interactionType));
      messages = messages.concat(assertOptionalClickedOnSection(properties.clickedOnSection));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertOptionalScrolledThrough(properties.scrolledThrough));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Game Zone", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "interactionType",
        "clickedOnSection",
        "from",
        "grade",
        "elaGrade",
        "mathGrade",
        "scrolledThrough",
        "clickedOn",
        "mode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "yJACkx1pin", "4f23801cb3023354e4329a069fbd5930c9c45e4f2ca16a16a7e69fea88bf8565", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Game Zone", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Interaction Type": properties.interactionType,
        "Clicked on Section": properties.clickedOnSection,
        "From": properties.from,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Scrolled Through": properties.scrolledThrough,
        "Clicked On": properties.clickedOn,
        "Mode": properties.mode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("yJACkx1pin", "Interacted Game Zone", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PokUqOLpg8", name: "Interaction Type", value: properties.interactionType},
        {id: "TLBtHE5cOx", name: "Scrolled Through", value: properties.scrolledThrough},
        {id: "n4HbuwgZ_E", name: "Clicked on Section", value: properties.clickedOnSection},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Game Zone': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Game Zone", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Interaction Type": properties.interactionType,
          "Clicked on Section": properties.clickedOnSection,
          "From": properties.from,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Scrolled Through": properties.scrolledThrough,
          "Clicked On": properties.clickedOn,
          "Mode": properties.mode,
          "Screen Height": sysScreenHeight,
          }, "yJACkx1pin", "4f23801cb3023354e4329a069fbd5930c9c45e4f2ca16a16a7e69fea88bf8565");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Game Zone", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Interaction Type": properties.interactionType,
      "Clicked on Section": properties.clickedOnSection,
      "From": properties.from,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Scrolled Through": properties.scrolledThrough,
      "Clicked On": properties.clickedOn,
      "Mode": properties.mode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Playable Clicked: When the user clicks on a Playable to start it
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {string} properties.contentType - Type of content viz. Game/Learning Path/Activities/Worksheets
   * @param {string} properties.playableCode - Pass the 'Playable Code' of the Playable being started/clicked
   * @param {string} properties.playableName - Name of playable selected
   * @param {Array<string>} [properties.recommendedRailName] - This is the name of the rail viewed by the user. 
Recommended rail property comes with rail name and rail rank, pipe separated - with the introduction of this property, we intend to separate rail name to calculate CTR on Mixpanel.
   * @param {Array<int>} [properties.recommendedRailRank] - Recommended Rail Rank will carry the rank of the rail in integer format viewed by the user. 
   * @param {Array<string>} [properties.recommendedTileName] - This property will store the code of the tile user has interacted with - CG code for curriculum rails and game code for non curr. rails

   * @param {Array<int>} [properties.recommendedTileRank] - This property will store the position of the tile on which user has clciked. Earlier this was sent as column position

   * @param {string} [properties.contentGroup] - Code of content group user clicked/tapped on
   * @param {string} [properties.clickId] - unique id associated with distinct clicks on the home dashboard on playables
   * @param {string} properties.gameType - Type of game/playable selected
   * @param {string} properties.playableType - Type of playable selected
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.gameEngine - This property will contain the name of the game engine - unity, phaser, cocos, creator or worksheet

   * @param {string} properties.gameCode - Game code of the playable selected, for example: Math learning games have multiple variations, all those variations will have one game code
   * @param {string} properties.gameName - Name of the Game being tapped (Optional)
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.pageName - Includes the name of the page (Eg: Playzone game listing page, ). This is not the URL but a easily understandable definition of what page is the user at.
   * @param {string} properties.assignmentType - This will capture the type of assignment - Manual or Auto
   * @param {float} properties.totalMemory - This property stores the total memory allocated by the client device
   * @param {float} properties.usedMemory - This property stores the memory consumed by the website
   * @param {float} properties.memoryLimit - The max memory allocated by the client device
   * @param {float} properties.memoryUsagePercentage - This property stores the % used memory
   * @param {string} properties.playablePath - This property stores whether the playable is played from the fast path or default path
   * @param {string} properties.playableClickId - This property will hold a unique string for the playable events.
   * @param {string} properties.recommendedVia - This property holds a value when some playable is recommended which would not have in the default setting of the dashboard or CG path. For example, user played a playable on adaptive path, the default path would have recommended a different playable. So in this case, Recommended Via holds 'adaptive'
   * @param {Array<string>} properties.recommendedRail - This property will be used to store which rails were shown to the user in the HOME tab.

Where possible values are:
Rail Name = Curriculum, Game Zone, Math, Language, Logic & Thinking, Art & Creativity, General Knowledge, Motor Skills, Live Classes, Fluency, Multiplayer
This comes with Rank also with | separation
   * @param {string} properties.tabCode - Specifies the tab which has been opened in the event 'Viewed Tiled Dashboard' and Other events too
   * @param {Array<string>} properties.recommendedCategory - This property will be used to store what recommendations were shown to the user in the all tabs.
We'll be saving them in this format:
<Category Name>
where possible values are:
Category name =  MyToDo, Math_LP, ELA_LP, Math Facts, Books, Spelling, Reading Comprehension, Playzone, Activities, Learning Games
   * @param {int} properties.tabStrClickedCount - Streak count of Playable Clicked from a Specific Tab in a day
   * @param {int} properties.tabStrStartedCount - Streak count of Playable Started from a Specific Tab in a day
   * @param {int} properties.railStrClickedCount - Streak count of Playable Clicked from a Specific Rail in a day
   * @param {int} properties.railStrStartedCount - Streak count of Playable Started from a Specific Rail in a day
   * @param {int} properties.tileStrClickedCount - Streak count of Playable Clicked from a Specific Tile in a day
   * @param {int} properties.tileStrStartedCount - Streak count of Playable Started from a Specific Tile in a day
   * @param {int} properties.tabStrCompletedCount - Streak count of Playable Completed from a Specific Tab in a day
   * @param {int} properties.railStrCompletedCount - Streak count of Playable Completed from a Specific Rail in a day
   * @param {int} properties.tileStrCompletedCount - Streak count of Playable Completed from a Specific Tile in a day
   * @param {int} properties.overallClickedCount - Streak count of Playable Clicked in a day from anywhere
   * @param {int} properties.overallStartedCount - Streak count of Playable Started in a day from anywhere
   * @param {int} properties.overallCompletedCount - Streak count of Playable Completed in a day from anywhere
   * @param {string} [properties.railCode] - Code of the Rail: Debugging purpose
   * @param {string} [properties.tileCode] - Code of the Tile: Debugging purpose by tech team
   * @param {bool} properties.staleData - in case of api failure in streak data it will set as 1
   * @param {string} properties.recommendationRailCode - This property will capture the code for recommended rails driven by algorithm
   * @param {string} properties.recommendationVersionName - Parent code for different versions of AB test
   * @param {string} properties.recommendationSubVersionName - It is a code that defines different version of different rail on book library dashboard
   * @param {int} properties.recommendationAlgorithmFlag - If a rail is driven by recommendation version then flag will be 1 else 0
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ohtQbeM-fl}
   */
  function playableClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertContentType(properties.contentType));
      messages = messages.concat(assertPlayableCode(properties.playableCode));
      messages = messages.concat(assertPlayableName(properties.playableName));
      messages = messages.concat(assertOptionalRecommendedRailName(properties.recommendedRailName));
      messages = messages.concat(assertOptionalRecommendedRailRank(properties.recommendedRailRank));
      messages = messages.concat(assertOptionalRecommendedTileName(properties.recommendedTileName));
      messages = messages.concat(assertOptionalRecommendedTileRank(properties.recommendedTileRank));
      messages = messages.concat(assertOptionalContentGroup(properties.contentGroup));
      messages = messages.concat(assertOptionalClickId(properties.clickId));
      messages = messages.concat(assertGameType(properties.gameType));
      messages = messages.concat(assertPlayableType(properties.playableType));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertGameEngine(properties.gameEngine));
      messages = messages.concat(assertGameCode(properties.gameCode));
      messages = messages.concat(assertGameName(properties.gameName));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPageName(properties.pageName));
      messages = messages.concat(assertAssignmentType(properties.assignmentType));
      messages = messages.concat(assertTotalMemory(properties.totalMemory));
      messages = messages.concat(assertUsedMemory(properties.usedMemory));
      messages = messages.concat(assertMemoryLimit(properties.memoryLimit));
      messages = messages.concat(assertMemoryUsagePercentage(properties.memoryUsagePercentage));
      messages = messages.concat(assertPlayablePath(properties.playablePath));
      messages = messages.concat(assertPlayableClickId(properties.playableClickId));
      messages = messages.concat(assertRecommendedVia(properties.recommendedVia));
      messages = messages.concat(assertRecommendedRail(properties.recommendedRail));
      messages = messages.concat(assertTabCode(properties.tabCode));
      messages = messages.concat(assertRecommendedCategory(properties.recommendedCategory));
      messages = messages.concat(assertTabStrClickedCount(properties.tabStrClickedCount));
      messages = messages.concat(assertTabStrStartedCount(properties.tabStrStartedCount));
      messages = messages.concat(assertRailStrClickedCount(properties.railStrClickedCount));
      messages = messages.concat(assertRailStrStartedCount(properties.railStrStartedCount));
      messages = messages.concat(assertTileStrClickedCount(properties.tileStrClickedCount));
      messages = messages.concat(assertTileStrStartedCount(properties.tileStrStartedCount));
      messages = messages.concat(assertTabStrCompletedCount(properties.tabStrCompletedCount));
      messages = messages.concat(assertRailStrCompletedCount(properties.railStrCompletedCount));
      messages = messages.concat(assertTileStrCompletedCount(properties.tileStrCompletedCount));
      messages = messages.concat(assertOverallClickedCount(properties.overallClickedCount));
      messages = messages.concat(assertOverallStartedCount(properties.overallStartedCount));
      messages = messages.concat(assertOverallCompletedCount(properties.overallCompletedCount));
      messages = messages.concat(assertOptionalRailCode(properties.railCode));
      messages = messages.concat(assertOptionalTileCode(properties.tileCode));
      messages = messages.concat(assertStaleData(properties.staleData));
      messages = messages.concat(assertRecommendationRailCode(properties.recommendationRailCode));
      messages = messages.concat(assertRecommendationVersionName(properties.recommendationVersionName));
      messages = messages.concat(assertRecommendationSubVersionName(properties.recommendationSubVersionName));
      messages = messages.concat(assertRecommendationAlgorithmFlag(properties.recommendationAlgorithmFlag));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Playable Clicked", Object.keys(properties), [
        "from",
        "contentType",
        "playableCode",
        "playableName",
        "recommendedRailName",
        "recommendedRailRank",
        "recommendedTileName",
        "recommendedTileRank",
        "contentGroup",
        "clickId",
        "gameType",
        "playableType",
        "platform",
        "elaGrade",
        "mathGrade",
        "mode",
        "userType",
        "signupFlow",
        "grade",
        "gameEngine",
        "gameCode",
        "gameName",
        "subject",
        "pageName",
        "assignmentType",
        "totalMemory",
        "usedMemory",
        "memoryLimit",
        "memoryUsagePercentage",
        "playablePath",
        "playableClickId",
        "recommendedVia",
        "recommendedRail",
        "tabCode",
        "recommendedCategory",
        "tabStrClickedCount",
        "tabStrStartedCount",
        "railStrClickedCount",
        "railStrStartedCount",
        "tileStrClickedCount",
        "tileStrStartedCount",
        "tabStrCompletedCount",
        "railStrCompletedCount",
        "tileStrCompletedCount",
        "overallClickedCount",
        "overallStartedCount",
        "overallCompletedCount",
        "railCode",
        "tileCode",
        "staleData",
        "recommendationRailCode",
        "recommendationVersionName",
        "recommendationSubVersionName",
        "recommendationAlgorithmFlag"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ohtQbeM-fl", "592ea9a7e19ffe4953ba4250cebda07f4b2f5eb8e0bbc1835cbce200e1669688", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Playable Clicked", {
        "From": properties.from,
        "Content Type": properties.contentType,
        "Playable Code": properties.playableCode,
        "Playable Name": properties.playableName,
        "Recommended Rail Name": properties.recommendedRailName,
        "Recommended Rail Rank": properties.recommendedRailRank,
        "Recommended Tile Name": properties.recommendedTileName,
        "Recommended Tile Rank": properties.recommendedTileRank,
        "Content Group": properties.contentGroup,
        "Click Id": properties.clickId,
        "Game Type": properties.gameType,
        "Playable Type": properties.playableType,
        "Platform": properties.platform,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Game Engine": properties.gameEngine,
        "Game Code": properties.gameCode,
        "Game Name": properties.gameName,
        "Subject": properties.subject,
        "Page Name": properties.pageName,
        "Assignment Type": properties.assignmentType,
        "Total Memory": properties.totalMemory,
        "Used Memory": properties.usedMemory,
        "Memory Limit": properties.memoryLimit,
        "Memory Usage Percentage": properties.memoryUsagePercentage,
        "Playable Path": properties.playablePath,
        "Playable Click Id": properties.playableClickId,
        "Recommended Via": properties.recommendedVia,
        "Recommended Rail": properties.recommendedRail,
        "Tab Code": properties.tabCode,
        "Recommended Category": properties.recommendedCategory,
        "Tab Str Clicked Count": properties.tabStrClickedCount,
        "Tab Str Started Count": properties.tabStrStartedCount,
        "Rail Str Clicked Count": properties.railStrClickedCount,
        "Rail Str Started Count": properties.railStrStartedCount,
        "Tile Str Clicked Count": properties.tileStrClickedCount,
        "Tile Str Started Count": properties.tileStrStartedCount,
        "Tab Str Completed Count": properties.tabStrCompletedCount,
        "Rail Str Completed Count": properties.railStrCompletedCount,
        "Tile Str Completed Count": properties.tileStrCompletedCount,
        "Overall Clicked Count": properties.overallClickedCount,
        "Overall Started Count": properties.overallStartedCount,
        "Overall Completed Count": properties.overallCompletedCount,
        "Rail Code": properties.railCode,
        "Tile Code": properties.tileCode,
        "Stale Data": properties.staleData,
        "Recommendation Rail Code": properties.recommendationRailCode,
        "Recommendation Version Name": properties.recommendationVersionName,
        "Recommendation Sub Version Name": properties.recommendationSubVersionName,
        "Recommendation Algorithm Flag": properties.recommendationAlgorithmFlag,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ohtQbeM-fl", "Playable Clicked", messages, [
        {id: "2da5NLAEc", name: "Game Type", value: properties.gameType},
        {id: "2hMTTBgU30", name: "Total Memory", value: properties.totalMemory},
        {id: "2oZQdvXRu", name: "Game Code", value: properties.gameCode},
        {id: "33JWk0cGdkpH6MbvcXKfL", name: "Tile Str Clicked Count", value: properties.tileStrClickedCount},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "6lrsWYY5Y", name: "Recommended Rail Name", value: properties.recommendedRailName},
        {id: "72Hz7CelRpVYf1warHrRP", name: "Tile Str Started Count", value: properties.tileStrStartedCount},
        {id: "7PQh3G9ITCcMDMNeMTM8q", name: "Tab Str Clicked Count", value: properties.tabStrClickedCount},
        {id: "ADfS21LlJH", name: "Memory Limit", value: properties.memoryLimit},
        {id: "AFC3Xnyx0vxpH2PWZIjdO", name: "Rail Str Completed Count", value: properties.railStrCompletedCount},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "BchWbNpV0WYRnYxTnBQ-c", name: "Recommendation Sub Version Name", value: properties.recommendationSubVersionName},
        {id: "CptvN7aTfWej4MrTLiZsM", name: "Recommended Via", value: properties.recommendedVia},
        {id: "CxhubqT3Hp", name: "Playable Path", value: properties.playablePath},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "FH6REXldlxqxCPK0pvsML", name: "Recommendation Version Name", value: properties.recommendationVersionName},
        {id: "FLDtSJNKL", name: "Recommended Tile Rank", value: properties.recommendedTileRank},
        {id: "GAdbKqJ5y9HJPos5lx5qt", name: "Tab Str Completed Count", value: properties.tabStrCompletedCount},
        {id: "GJYEymipLkc1xy54AyhV8", name: "Tile Code", value: properties.tileCode},
        {id: "HFnzATNuS7GI6VZs6tZ15", name: "Tab Str Started Count", value: properties.tabStrStartedCount},
        {id: "HJUIBmGrsUmqa_TYCtwQ0", name: "Overall Started Count", value: properties.overallStartedCount},
        {id: "JVkBdMN1_", name: "Game Engine", value: properties.gameEngine},
        {id: "MJKSzmqfHu", name: "Page Name", value: properties.pageName},
        {id: "Nfs9QLl8W7", name: "Content Type", value: properties.contentType},
        {id: "OHBx0fnhzlxvHhw0e87pM", name: "Overall Completed Count", value: properties.overallCompletedCount},
        {id: "Otu1r2JQW", name: "Content Group", value: properties.contentGroup},
        {id: "Q2q6j4dEnjH8uo-MY-mr7", name: "Recommendation Algorithm Flag", value: properties.recommendationAlgorithmFlag},
        {id: "QDMKmRkRjbW4pFvqlGOM6", name: "Rail Code", value: properties.railCode},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "QQeu-Td4-0", name: "Playable Click Id", value: properties.playableClickId},
        {id: "QjCwFasvW0", name: "Playable Code", value: properties.playableCode},
        {id: "Qwa4E7UWbmonbiv7JbciC", name: "Recommendation Rail Code", value: properties.recommendationRailCode},
        {id: "TYbmk5DQn", name: "Recommended Tile Name", value: properties.recommendedTileName},
        {id: "Ueowl7sRb", name: "Assignment Type", value: properties.assignmentType},
        {id: "VdJhEU0H6s", name: "Recommended Category", value: properties.recommendedCategory},
        {id: "X4kgAx81N5AHgcI6NaNiS", name: "Overall Clicked Count", value: properties.overallClickedCount},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "_QL92wEdpoa8wH50vOPYt", name: "Tile Str Completed Count", value: properties.tileStrCompletedCount},
        {id: "amiw6GdIfAgKr7MxhRYGM", name: "Stale Data", value: properties.staleData},
        {id: "c2W4X05Jy", name: "Playable Name", value: properties.playableName},
        {id: "drNgwJn5Xg", name: "Recommended Rail", value: properties.recommendedRail},
        {id: "fXWDPkk_PZ", name: "Memory Usage Percentage", value: properties.memoryUsagePercentage},
        {id: "gvDk2xQI4d", name: "Used Memory", value: properties.usedMemory},
        {id: "hKAJ3izCFVFH-D4_886C8", name: "Rail Str Clicked Count", value: properties.railStrClickedCount},
        {id: "jVQaLzj_1", name: "Click Id", value: properties.clickId},
        {id: "l9PbANZBu", name: "Tab Code", value: properties.tabCode},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "sRPi7ITwtlHeD7HQEGzmG", name: "Rail Str Started Count", value: properties.railStrStartedCount},
        {id: "tHAI3DRE4", name: "Playable Type", value: properties.playableType},
        {id: "uyLgqxbg7", name: "Recommended Rail Rank", value: properties.recommendedRailRank},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Playable Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Playable Clicked", {
          "From": properties.from,
          "Content Type": properties.contentType,
          "Playable Code": properties.playableCode,
          "Playable Name": properties.playableName,
          "Recommended Rail Name": properties.recommendedRailName,
          "Recommended Rail Rank": properties.recommendedRailRank,
          "Recommended Tile Name": properties.recommendedTileName,
          "Recommended Tile Rank": properties.recommendedTileRank,
          "Content Group": properties.contentGroup,
          "Click Id": properties.clickId,
          "Game Type": properties.gameType,
          "Playable Type": properties.playableType,
          "Platform": properties.platform,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Game Engine": properties.gameEngine,
          "Game Code": properties.gameCode,
          "Game Name": properties.gameName,
          "Subject": properties.subject,
          "Page Name": properties.pageName,
          "Assignment Type": properties.assignmentType,
          "Total Memory": properties.totalMemory,
          "Used Memory": properties.usedMemory,
          "Memory Limit": properties.memoryLimit,
          "Memory Usage Percentage": properties.memoryUsagePercentage,
          "Playable Path": properties.playablePath,
          "Playable Click Id": properties.playableClickId,
          "Recommended Via": properties.recommendedVia,
          "Recommended Rail": properties.recommendedRail,
          "Tab Code": properties.tabCode,
          "Recommended Category": properties.recommendedCategory,
          "Tab Str Clicked Count": properties.tabStrClickedCount,
          "Tab Str Started Count": properties.tabStrStartedCount,
          "Rail Str Clicked Count": properties.railStrClickedCount,
          "Rail Str Started Count": properties.railStrStartedCount,
          "Tile Str Clicked Count": properties.tileStrClickedCount,
          "Tile Str Started Count": properties.tileStrStartedCount,
          "Tab Str Completed Count": properties.tabStrCompletedCount,
          "Rail Str Completed Count": properties.railStrCompletedCount,
          "Tile Str Completed Count": properties.tileStrCompletedCount,
          "Overall Clicked Count": properties.overallClickedCount,
          "Overall Started Count": properties.overallStartedCount,
          "Overall Completed Count": properties.overallCompletedCount,
          "Rail Code": properties.railCode,
          "Tile Code": properties.tileCode,
          "Stale Data": properties.staleData,
          "Recommendation Rail Code": properties.recommendationRailCode,
          "Recommendation Version Name": properties.recommendationVersionName,
          "Recommendation Sub Version Name": properties.recommendationSubVersionName,
          "Recommendation Algorithm Flag": properties.recommendationAlgorithmFlag,
          "Screen Height": sysScreenHeight,
          }, "ohtQbeM-fl", "592ea9a7e19ffe4953ba4250cebda07f4b2f5eb8e0bbc1835cbce200e1669688");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Playable Clicked", {
      "From": properties.from,
      "Content Type": properties.contentType,
      "Playable Code": properties.playableCode,
      "Playable Name": properties.playableName,
      "Recommended Rail Name": properties.recommendedRailName,
      "Recommended Rail Rank": properties.recommendedRailRank,
      "Recommended Tile Name": properties.recommendedTileName,
      "Recommended Tile Rank": properties.recommendedTileRank,
      "Content Group": properties.contentGroup,
      "Click Id": properties.clickId,
      "Game Type": properties.gameType,
      "Playable Type": properties.playableType,
      "Platform": properties.platform,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Game Engine": properties.gameEngine,
      "Game Code": properties.gameCode,
      "Game Name": properties.gameName,
      "Subject": properties.subject,
      "Page Name": properties.pageName,
      "Assignment Type": properties.assignmentType,
      "Total Memory": properties.totalMemory,
      "Used Memory": properties.usedMemory,
      "Memory Limit": properties.memoryLimit,
      "Memory Usage Percentage": properties.memoryUsagePercentage,
      "Playable Path": properties.playablePath,
      "Playable Click Id": properties.playableClickId,
      "Recommended Via": properties.recommendedVia,
      "Recommended Rail": properties.recommendedRail,
      "Tab Code": properties.tabCode,
      "Recommended Category": properties.recommendedCategory,
      "Tab Str Clicked Count": properties.tabStrClickedCount,
      "Tab Str Started Count": properties.tabStrStartedCount,
      "Rail Str Clicked Count": properties.railStrClickedCount,
      "Rail Str Started Count": properties.railStrStartedCount,
      "Tile Str Clicked Count": properties.tileStrClickedCount,
      "Tile Str Started Count": properties.tileStrStartedCount,
      "Tab Str Completed Count": properties.tabStrCompletedCount,
      "Rail Str Completed Count": properties.railStrCompletedCount,
      "Tile Str Completed Count": properties.tileStrCompletedCount,
      "Overall Clicked Count": properties.overallClickedCount,
      "Overall Started Count": properties.overallStartedCount,
      "Overall Completed Count": properties.overallCompletedCount,
      "Rail Code": properties.railCode,
      "Tile Code": properties.tileCode,
      "Stale Data": properties.staleData,
      "Recommendation Rail Code": properties.recommendationRailCode,
      "Recommendation Version Name": properties.recommendationVersionName,
      "Recommendation Sub Version Name": properties.recommendationSubVersionName,
      "Recommendation Algorithm Flag": properties.recommendationAlgorithmFlag,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Playable Started: When the Playable actually starts
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {string} [properties.contentType] - Type of content viz. Game/Learning Path/Activities/Worksheets
   * @param {string} properties.gameCode - Game code of the playable selected, for example: Math learning games have multiple variations, all those variations will have one game code
   * @param {string} [properties.gameName] - Name of the Game being tapped (Optional)
   * @param {string} [properties.gameType] - Type of game/playable selected
   * @param {string} [properties.playableCode] - Pass the 'Playable Code' of the Playable being started/clicked
   * @param {string} [properties.playableName] - Name of playable selected
   * @param {string} [properties.playableType] - Type of playable selected
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {Array<string>} [properties.recommendedRailName] - This is the name of the rail viewed by the user. 
Recommended rail property comes with rail name and rail rank, pipe separated - with the introduction of this property, we intend to separate rail name to calculate CTR on Mixpanel.
   * @param {Array<int>} [properties.recommendedRailRank] - Recommended Rail Rank will carry the rank of the rail in integer format viewed by the user. 
   * @param {Array<string>} [properties.recommendedTileName] - This property will store the code of the tile user has interacted with - CG code for curriculum rails and game code for non curr. rails

   * @param {Array<int>} [properties.recommendedTileRank] - This property will store the position of the tile on which user has clciked. Earlier this was sent as column position

   * @param {string} [properties.clickId] - unique id associated with distinct clicks on the home dashboard on playables
   * @param {string} [properties.contentGroup] - Code of content group user clicked/tapped on
   * @param {string} properties.gameEngine - This property will contain the name of the game engine - unity, phaser, cocos, creator or worksheet

   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} [properties.seoGradeSelected] - Grade the user selected in the SEO pages before clicking on a playable/worksheet.
   * @param {float} properties.totalMemory - This property stores the total memory allocated by the client device
   * @param {float} properties.usedMemory - This property stores the memory consumed by the website
   * @param {float} properties.memoryLimit - The max memory allocated by the client device
   * @param {float} properties.memoryUsagePercentage - This property stores the % used memory
   * @param {string} properties.playablePath - This property stores whether the playable is played from the fast path or default path
   * @param {string} properties.playableClickId - This property will hold a unique string for the playable events.
   * @param {string} properties.recommendedVia - This property holds a value when some playable is recommended which would not have in the default setting of the dashboard or CG path. For example, user played a playable on adaptive path, the default path would have recommended a different playable. So in this case, Recommended Via holds 'adaptive'
   * @param {Array<string>} properties.recommendedRail - This property will be used to store which rails were shown to the user in the HOME tab.

Where possible values are:
Rail Name = Curriculum, Game Zone, Math, Language, Logic & Thinking, Art & Creativity, General Knowledge, Motor Skills, Live Classes, Fluency, Multiplayer
This comes with Rank also with | separation
   * @param {string} properties.tabCode - Specifies the tab which has been opened in the event 'Viewed Tiled Dashboard' and Other events too
   * @param {Array<string>} properties.recommendedCategory - This property will be used to store what recommendations were shown to the user in the all tabs.
We'll be saving them in this format:
<Category Name>
where possible values are:
Category name =  MyToDo, Math_LP, ELA_LP, Math Facts, Books, Spelling, Reading Comprehension, Playzone, Activities, Learning Games
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {int} properties.tabStrClickedCount - Streak count of Playable Clicked from a Specific Tab in a day
   * @param {int} properties.tabStrStartedCount - Streak count of Playable Started from a Specific Tab in a day
   * @param {int} properties.tabStrCompletedCount - Streak count of Playable Completed from a Specific Tab in a day
   * @param {int} properties.railStrClickedCount - Streak count of Playable Clicked from a Specific Rail in a day
   * @param {int} properties.railStrStartedCount - Streak count of Playable Started from a Specific Rail in a day
   * @param {int} properties.railStrCompletedCount - Streak count of Playable Completed from a Specific Rail in a day
   * @param {int} properties.tileStrClickedCount - Streak count of Playable Clicked from a Specific Tile in a day
   * @param {int} properties.tileStrStartedCount - Streak count of Playable Started from a Specific Tile in a day
   * @param {int} properties.tileStrCompletedCount - Streak count of Playable Completed from a Specific Tile in a day
   * @param {int} properties.overallClickedCount - Streak count of Playable Clicked in a day from anywhere
   * @param {int} properties.overallStartedCount - Streak count of Playable Started in a day from anywhere
   * @param {int} properties.overallCompletedCount - Streak count of Playable Completed in a day from anywhere
   * @param {string} properties.recommendationRailCode - This property will capture the code for recommended rails driven by algorithm
   * @param {int} properties.recommendationAlgorithmFlag - If a rail is driven by recommendation version then flag will be 1 else 0
   * @param {string} properties.recommendationVersionName - Parent code for different versions of AB test
   * @param {string} properties.recommendationSubVersionName - It is a code that defines different version of different rail on book library dashboard
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/71_prnfx7Y}
   */
  function playableStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertOptionalContentType(properties.contentType));
      messages = messages.concat(assertGameCode(properties.gameCode));
      messages = messages.concat(assertOptionalGameName(properties.gameName));
      messages = messages.concat(assertOptionalGameType(properties.gameType));
      messages = messages.concat(assertOptionalPlayableCode(properties.playableCode));
      messages = messages.concat(assertOptionalPlayableName(properties.playableName));
      messages = messages.concat(assertOptionalPlayableType(properties.playableType));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertOptionalRecommendedRailName(properties.recommendedRailName));
      messages = messages.concat(assertOptionalRecommendedRailRank(properties.recommendedRailRank));
      messages = messages.concat(assertOptionalRecommendedTileName(properties.recommendedTileName));
      messages = messages.concat(assertOptionalRecommendedTileRank(properties.recommendedTileRank));
      messages = messages.concat(assertOptionalClickId(properties.clickId));
      messages = messages.concat(assertOptionalContentGroup(properties.contentGroup));
      messages = messages.concat(assertGameEngine(properties.gameEngine));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertOptionalSEOGradeSelected(properties.seoGradeSelected));
      messages = messages.concat(assertTotalMemory(properties.totalMemory));
      messages = messages.concat(assertUsedMemory(properties.usedMemory));
      messages = messages.concat(assertMemoryLimit(properties.memoryLimit));
      messages = messages.concat(assertMemoryUsagePercentage(properties.memoryUsagePercentage));
      messages = messages.concat(assertPlayablePath(properties.playablePath));
      messages = messages.concat(assertPlayableClickId(properties.playableClickId));
      messages = messages.concat(assertRecommendedVia(properties.recommendedVia));
      messages = messages.concat(assertRecommendedRail(properties.recommendedRail));
      messages = messages.concat(assertTabCode(properties.tabCode));
      messages = messages.concat(assertRecommendedCategory(properties.recommendedCategory));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertTabStrClickedCount(properties.tabStrClickedCount));
      messages = messages.concat(assertTabStrStartedCount(properties.tabStrStartedCount));
      messages = messages.concat(assertTabStrCompletedCount(properties.tabStrCompletedCount));
      messages = messages.concat(assertRailStrClickedCount(properties.railStrClickedCount));
      messages = messages.concat(assertRailStrStartedCount(properties.railStrStartedCount));
      messages = messages.concat(assertRailStrCompletedCount(properties.railStrCompletedCount));
      messages = messages.concat(assertTileStrClickedCount(properties.tileStrClickedCount));
      messages = messages.concat(assertTileStrStartedCount(properties.tileStrStartedCount));
      messages = messages.concat(assertTileStrCompletedCount(properties.tileStrCompletedCount));
      messages = messages.concat(assertOverallClickedCount(properties.overallClickedCount));
      messages = messages.concat(assertOverallStartedCount(properties.overallStartedCount));
      messages = messages.concat(assertOverallCompletedCount(properties.overallCompletedCount));
      messages = messages.concat(assertRecommendationRailCode(properties.recommendationRailCode));
      messages = messages.concat(assertRecommendationAlgorithmFlag(properties.recommendationAlgorithmFlag));
      messages = messages.concat(assertRecommendationVersionName(properties.recommendationVersionName));
      messages = messages.concat(assertRecommendationSubVersionName(properties.recommendationSubVersionName));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Playable Started", Object.keys(properties), [
        "from",
        "contentType",
        "gameCode",
        "gameName",
        "gameType",
        "playableCode",
        "playableName",
        "playableType",
        "clickedOn",
        "recommendedRailName",
        "recommendedRailRank",
        "recommendedTileName",
        "recommendedTileRank",
        "clickId",
        "contentGroup",
        "gameEngine",
        "subject",
        "seoGradeSelected",
        "totalMemory",
        "usedMemory",
        "memoryLimit",
        "memoryUsagePercentage",
        "playablePath",
        "playableClickId",
        "recommendedVia",
        "recommendedRail",
        "tabCode",
        "recommendedCategory",
        "grade",
        "tabStrClickedCount",
        "tabStrStartedCount",
        "tabStrCompletedCount",
        "railStrClickedCount",
        "railStrStartedCount",
        "railStrCompletedCount",
        "tileStrClickedCount",
        "tileStrStartedCount",
        "tileStrCompletedCount",
        "overallClickedCount",
        "overallStartedCount",
        "overallCompletedCount",
        "recommendationRailCode",
        "recommendationAlgorithmFlag",
        "recommendationVersionName",
        "recommendationSubVersionName"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "71_prnfx7Y", "bbf199f73a17fc125f0ee5725e86164f9a0d48c9d696dc9e21a2b781f316f09c", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Playable Started", {
        "From": properties.from,
        "Content Type": properties.contentType,
        "Game Code": properties.gameCode,
        "Game Name": properties.gameName,
        "Game Type": properties.gameType,
        "Playable Code": properties.playableCode,
        "Playable Name": properties.playableName,
        "Playable Type": properties.playableType,
        "Clicked On": properties.clickedOn,
        "Recommended Rail Name": properties.recommendedRailName,
        "Recommended Rail Rank": properties.recommendedRailRank,
        "Recommended Tile Name": properties.recommendedTileName,
        "Recommended Tile Rank": properties.recommendedTileRank,
        "Click Id": properties.clickId,
        "Content Group": properties.contentGroup,
        "Game Engine": properties.gameEngine,
        "Subject": properties.subject,
        "SEO Grade Selected": properties.seoGradeSelected,
        "Total Memory": properties.totalMemory,
        "Used Memory": properties.usedMemory,
        "Memory Limit": properties.memoryLimit,
        "Memory Usage Percentage": properties.memoryUsagePercentage,
        "Playable Path": properties.playablePath,
        "Playable Click Id": properties.playableClickId,
        "Recommended Via": properties.recommendedVia,
        "Recommended Rail": properties.recommendedRail,
        "Tab Code": properties.tabCode,
        "Recommended Category": properties.recommendedCategory,
        "Grade": properties.grade,
        "Tab Str Clicked Count": properties.tabStrClickedCount,
        "Tab Str Started Count": properties.tabStrStartedCount,
        "Tab Str Completed Count": properties.tabStrCompletedCount,
        "Rail Str Clicked Count": properties.railStrClickedCount,
        "Rail Str Started Count": properties.railStrStartedCount,
        "Rail Str Completed Count": properties.railStrCompletedCount,
        "Tile Str Clicked Count": properties.tileStrClickedCount,
        "Tile Str Started Count": properties.tileStrStartedCount,
        "Tile Str Completed Count": properties.tileStrCompletedCount,
        "Overall Clicked Count": properties.overallClickedCount,
        "Overall Started Count": properties.overallStartedCount,
        "Overall Completed Count": properties.overallCompletedCount,
        "Recommendation Rail Code": properties.recommendationRailCode,
        "Recommendation Algorithm Flag": properties.recommendationAlgorithmFlag,
        "Recommendation Version Name": properties.recommendationVersionName,
        "Recommendation Sub Version Name": properties.recommendationSubVersionName,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("71_prnfx7Y", "Playable Started", messages, [
        {id: "2da5NLAEc", name: "Game Type", value: properties.gameType},
        {id: "2hMTTBgU30", name: "Total Memory", value: properties.totalMemory},
        {id: "2oZQdvXRu", name: "Game Code", value: properties.gameCode},
        {id: "33JWk0cGdkpH6MbvcXKfL", name: "Tile Str Clicked Count", value: properties.tileStrClickedCount},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "6lrsWYY5Y", name: "Recommended Rail Name", value: properties.recommendedRailName},
        {id: "72Hz7CelRpVYf1warHrRP", name: "Tile Str Started Count", value: properties.tileStrStartedCount},
        {id: "7PQh3G9ITCcMDMNeMTM8q", name: "Tab Str Clicked Count", value: properties.tabStrClickedCount},
        {id: "ADfS21LlJH", name: "Memory Limit", value: properties.memoryLimit},
        {id: "AFC3Xnyx0vxpH2PWZIjdO", name: "Rail Str Completed Count", value: properties.railStrCompletedCount},
        {id: "BchWbNpV0WYRnYxTnBQ-c", name: "Recommendation Sub Version Name", value: properties.recommendationSubVersionName},
        {id: "CptvN7aTfWej4MrTLiZsM", name: "Recommended Via", value: properties.recommendedVia},
        {id: "CxhubqT3Hp", name: "Playable Path", value: properties.playablePath},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "FH6REXldlxqxCPK0pvsML", name: "Recommendation Version Name", value: properties.recommendationVersionName},
        {id: "FLDtSJNKL", name: "Recommended Tile Rank", value: properties.recommendedTileRank},
        {id: "GAdbKqJ5y9HJPos5lx5qt", name: "Tab Str Completed Count", value: properties.tabStrCompletedCount},
        {id: "HFnzATNuS7GI6VZs6tZ15", name: "Tab Str Started Count", value: properties.tabStrStartedCount},
        {id: "HJUIBmGrsUmqa_TYCtwQ0", name: "Overall Started Count", value: properties.overallStartedCount},
        {id: "JVkBdMN1_", name: "Game Engine", value: properties.gameEngine},
        {id: "Nfs9QLl8W7", name: "Content Type", value: properties.contentType},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "OHBx0fnhzlxvHhw0e87pM", name: "Overall Completed Count", value: properties.overallCompletedCount},
        {id: "Otu1r2JQW", name: "Content Group", value: properties.contentGroup},
        {id: "Q2q6j4dEnjH8uo-MY-mr7", name: "Recommendation Algorithm Flag", value: properties.recommendationAlgorithmFlag},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "QQeu-Td4-0", name: "Playable Click Id", value: properties.playableClickId},
        {id: "QjCwFasvW0", name: "Playable Code", value: properties.playableCode},
        {id: "Qwa4E7UWbmonbiv7JbciC", name: "Recommendation Rail Code", value: properties.recommendationRailCode},
        {id: "TYbmk5DQn", name: "Recommended Tile Name", value: properties.recommendedTileName},
        {id: "VdJhEU0H6s", name: "Recommended Category", value: properties.recommendedCategory},
        {id: "X4kgAx81N5AHgcI6NaNiS", name: "Overall Clicked Count", value: properties.overallClickedCount},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "_QL92wEdpoa8wH50vOPYt", name: "Tile Str Completed Count", value: properties.tileStrCompletedCount},
        {id: "c2W4X05Jy", name: "Playable Name", value: properties.playableName},
        {id: "drNgwJn5Xg", name: "Recommended Rail", value: properties.recommendedRail},
        {id: "fXWDPkk_PZ", name: "Memory Usage Percentage", value: properties.memoryUsagePercentage},
        {id: "gvDk2xQI4d", name: "Used Memory", value: properties.usedMemory},
        {id: "hKAJ3izCFVFH-D4_886C8", name: "Rail Str Clicked Count", value: properties.railStrClickedCount},
        {id: "jVQaLzj_1", name: "Click Id", value: properties.clickId},
        {id: "l9PbANZBu", name: "Tab Code", value: properties.tabCode},
        {id: "sRPi7ITwtlHeD7HQEGzmG", name: "Rail Str Started Count", value: properties.railStrStartedCount},
        {id: "tHAI3DRE4", name: "Playable Type", value: properties.playableType},
        {id: "uyLgqxbg7", name: "Recommended Rail Rank", value: properties.recommendedRailRank},
        {id: "zAaw21fC2", name: "SEO Grade Selected", value: properties.seoGradeSelected},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Playable Started': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Playable Started", {
          "From": properties.from,
          "Content Type": properties.contentType,
          "Game Code": properties.gameCode,
          "Game Name": properties.gameName,
          "Game Type": properties.gameType,
          "Playable Code": properties.playableCode,
          "Playable Name": properties.playableName,
          "Playable Type": properties.playableType,
          "Clicked On": properties.clickedOn,
          "Recommended Rail Name": properties.recommendedRailName,
          "Recommended Rail Rank": properties.recommendedRailRank,
          "Recommended Tile Name": properties.recommendedTileName,
          "Recommended Tile Rank": properties.recommendedTileRank,
          "Click Id": properties.clickId,
          "Content Group": properties.contentGroup,
          "Game Engine": properties.gameEngine,
          "Subject": properties.subject,
          "SEO Grade Selected": properties.seoGradeSelected,
          "Total Memory": properties.totalMemory,
          "Used Memory": properties.usedMemory,
          "Memory Limit": properties.memoryLimit,
          "Memory Usage Percentage": properties.memoryUsagePercentage,
          "Playable Path": properties.playablePath,
          "Playable Click Id": properties.playableClickId,
          "Recommended Via": properties.recommendedVia,
          "Recommended Rail": properties.recommendedRail,
          "Tab Code": properties.tabCode,
          "Recommended Category": properties.recommendedCategory,
          "Grade": properties.grade,
          "Tab Str Clicked Count": properties.tabStrClickedCount,
          "Tab Str Started Count": properties.tabStrStartedCount,
          "Tab Str Completed Count": properties.tabStrCompletedCount,
          "Rail Str Clicked Count": properties.railStrClickedCount,
          "Rail Str Started Count": properties.railStrStartedCount,
          "Rail Str Completed Count": properties.railStrCompletedCount,
          "Tile Str Clicked Count": properties.tileStrClickedCount,
          "Tile Str Started Count": properties.tileStrStartedCount,
          "Tile Str Completed Count": properties.tileStrCompletedCount,
          "Overall Clicked Count": properties.overallClickedCount,
          "Overall Started Count": properties.overallStartedCount,
          "Overall Completed Count": properties.overallCompletedCount,
          "Recommendation Rail Code": properties.recommendationRailCode,
          "Recommendation Algorithm Flag": properties.recommendationAlgorithmFlag,
          "Recommendation Version Name": properties.recommendationVersionName,
          "Recommendation Sub Version Name": properties.recommendationSubVersionName,
          "Screen Height": sysScreenHeight,
          }, "71_prnfx7Y", "bbf199f73a17fc125f0ee5725e86164f9a0d48c9d696dc9e21a2b781f316f09c");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Playable Started", {
      "From": properties.from,
      "Content Type": properties.contentType,
      "Game Code": properties.gameCode,
      "Game Name": properties.gameName,
      "Game Type": properties.gameType,
      "Playable Code": properties.playableCode,
      "Playable Name": properties.playableName,
      "Playable Type": properties.playableType,
      "Clicked On": properties.clickedOn,
      "Recommended Rail Name": properties.recommendedRailName,
      "Recommended Rail Rank": properties.recommendedRailRank,
      "Recommended Tile Name": properties.recommendedTileName,
      "Recommended Tile Rank": properties.recommendedTileRank,
      "Click Id": properties.clickId,
      "Content Group": properties.contentGroup,
      "Game Engine": properties.gameEngine,
      "Subject": properties.subject,
      "SEO Grade Selected": properties.seoGradeSelected,
      "Total Memory": properties.totalMemory,
      "Used Memory": properties.usedMemory,
      "Memory Limit": properties.memoryLimit,
      "Memory Usage Percentage": properties.memoryUsagePercentage,
      "Playable Path": properties.playablePath,
      "Playable Click Id": properties.playableClickId,
      "Recommended Via": properties.recommendedVia,
      "Recommended Rail": properties.recommendedRail,
      "Tab Code": properties.tabCode,
      "Recommended Category": properties.recommendedCategory,
      "Grade": properties.grade,
      "Tab Str Clicked Count": properties.tabStrClickedCount,
      "Tab Str Started Count": properties.tabStrStartedCount,
      "Tab Str Completed Count": properties.tabStrCompletedCount,
      "Rail Str Clicked Count": properties.railStrClickedCount,
      "Rail Str Started Count": properties.railStrStartedCount,
      "Rail Str Completed Count": properties.railStrCompletedCount,
      "Tile Str Clicked Count": properties.tileStrClickedCount,
      "Tile Str Started Count": properties.tileStrStartedCount,
      "Tile Str Completed Count": properties.tileStrCompletedCount,
      "Overall Clicked Count": properties.overallClickedCount,
      "Overall Started Count": properties.overallStartedCount,
      "Overall Completed Count": properties.overallCompletedCount,
      "Recommendation Rail Code": properties.recommendationRailCode,
      "Recommendation Algorithm Flag": properties.recommendationAlgorithmFlag,
      "Recommendation Version Name": properties.recommendationVersionName,
      "Recommendation Sub Version Name": properties.recommendationSubVersionName,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Playable Completed: When a aplayable gets completed
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {string} [properties.contentType] - Type of content viz. Game/Learning Path/Activities/Worksheets
   * @param {string} properties.gameCode - Game code of the playable selected, for example: Math learning games have multiple variations, all those variations will have one game code
   * @param {string} [properties.gameName] - Name of the Game being tapped (Optional)
   * @param {string} [properties.gameType] - Type of game/playable selected
   * @param {string} [properties.playableCode] - Pass the 'Playable Code' of the Playable being started/clicked
   * @param {string} [properties.playableName] - Name of playable selected
   * @param {string} [properties.playableType] - Type of playable selected
   * @param {Array<string>} [properties.recommendedTileName] - This property will store the code of the tile user has interacted with - CG code for curriculum rails and game code for non curr. rails

   * @param {Array<int>} [properties.recommendedTileRank] - This property will store the position of the tile on which user has clciked. Earlier this was sent as column position

   * @param {Array<string>} [properties.recommendedRailName] - This is the name of the rail viewed by the user. 
Recommended rail property comes with rail name and rail rank, pipe separated - with the introduction of this property, we intend to separate rail name to calculate CTR on Mixpanel.
   * @param {Array<int>} [properties.recommendedRailRank] - Recommended Rail Rank will carry the rank of the rail in integer format viewed by the user. 
   * @param {string} [properties.contentGroup] - Code of content group user clicked/tapped on
   * @param {string} [properties.clickId] - unique id associated with distinct clicks on the home dashboard on playables
   * @param {string} properties.gameEngine - This property will contain the name of the game engine - unity, phaser, cocos, creator or worksheet

   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {float} properties.totalMemory - This property stores the total memory allocated by the client device
   * @param {float} properties.usedMemory - This property stores the memory consumed by the website
   * @param {float} properties.memoryLimit - The max memory allocated by the client device
   * @param {float} properties.memoryUsagePercentage - This property stores the % used memory
   * @param {string} properties.playablePath - This property stores whether the playable is played from the fast path or default path
   * @param {string} properties.playableClickId - This property will hold a unique string for the playable events.
   * @param {string} properties.recommendedVia - This property holds a value when some playable is recommended which would not have in the default setting of the dashboard or CG path. For example, user played a playable on adaptive path, the default path would have recommended a different playable. So in this case, Recommended Via holds 'adaptive'
   * @param {string} properties.tabCode - Specifies the tab which has been opened in the event 'Viewed Tiled Dashboard' and Other events too
   * @param {Array<string>} properties.recommendedRail - This property will be used to store which rails were shown to the user in the HOME tab.

Where possible values are:
Rail Name = Curriculum, Game Zone, Math, Language, Logic & Thinking, Art & Creativity, General Knowledge, Motor Skills, Live Classes, Fluency, Multiplayer
This comes with Rank also with | separation
   * @param {Array<string>} properties.recommendedCategory - This property will be used to store what recommendations were shown to the user in the all tabs.
We'll be saving them in this format:
<Category Name>
where possible values are:
Category name =  MyToDo, Math_LP, ELA_LP, Math Facts, Books, Spelling, Reading Comprehension, Playzone, Activities, Learning Games
   * @param {int} properties.tabStrClickedCount - Streak count of Playable Clicked from a Specific Tab in a day
   * @param {int} properties.tabStrStartedCount - Streak count of Playable Started from a Specific Tab in a day
   * @param {int} properties.railStrClickedCount - Streak count of Playable Clicked from a Specific Rail in a day
   * @param {int} properties.railStrStartedCount - Streak count of Playable Started from a Specific Rail in a day
   * @param {int} properties.tileStrClickedCount - Streak count of Playable Clicked from a Specific Tile in a day
   * @param {int} properties.tileStrStartedCount - Streak count of Playable Started from a Specific Tile in a day
   * @param {int} properties.tabStrCompletedCount - Streak count of Playable Completed from a Specific Tab in a day
   * @param {int} properties.railStrCompletedCount - Streak count of Playable Completed from a Specific Rail in a day
   * @param {int} properties.tileStrCompletedCount - Streak count of Playable Completed from a Specific Tile in a day
   * @param {int} properties.overallClickedCount - Streak count of Playable Clicked in a day from anywhere
   * @param {int} properties.overallStartedCount - Streak count of Playable Started in a day from anywhere
   * @param {int} properties.overallCompletedCount - Streak count of Playable Completed in a day from anywhere
   * @param {string} properties.recommendationRailCode - This property will capture the code for recommended rails driven by algorithm
   * @param {string} properties.recommendationVersionName - Parent code for different versions of AB test
   * @param {string} properties.recommendationSubVersionName - It is a code that defines different version of different rail on book library dashboard
   * @param {int} properties.recommendationAlgorithmFlag - If a rail is driven by recommendation version then flag will be 1 else 0
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ax-GP4kM7u}
   */
  function playableCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertOptionalContentType(properties.contentType));
      messages = messages.concat(assertGameCode(properties.gameCode));
      messages = messages.concat(assertOptionalGameName(properties.gameName));
      messages = messages.concat(assertOptionalGameType(properties.gameType));
      messages = messages.concat(assertOptionalPlayableCode(properties.playableCode));
      messages = messages.concat(assertOptionalPlayableName(properties.playableName));
      messages = messages.concat(assertOptionalPlayableType(properties.playableType));
      messages = messages.concat(assertOptionalRecommendedTileName(properties.recommendedTileName));
      messages = messages.concat(assertOptionalRecommendedTileRank(properties.recommendedTileRank));
      messages = messages.concat(assertOptionalRecommendedRailName(properties.recommendedRailName));
      messages = messages.concat(assertOptionalRecommendedRailRank(properties.recommendedRailRank));
      messages = messages.concat(assertOptionalContentGroup(properties.contentGroup));
      messages = messages.concat(assertOptionalClickId(properties.clickId));
      messages = messages.concat(assertGameEngine(properties.gameEngine));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertTotalMemory(properties.totalMemory));
      messages = messages.concat(assertUsedMemory(properties.usedMemory));
      messages = messages.concat(assertMemoryLimit(properties.memoryLimit));
      messages = messages.concat(assertMemoryUsagePercentage(properties.memoryUsagePercentage));
      messages = messages.concat(assertPlayablePath(properties.playablePath));
      messages = messages.concat(assertPlayableClickId(properties.playableClickId));
      messages = messages.concat(assertRecommendedVia(properties.recommendedVia));
      messages = messages.concat(assertTabCode(properties.tabCode));
      messages = messages.concat(assertRecommendedRail(properties.recommendedRail));
      messages = messages.concat(assertRecommendedCategory(properties.recommendedCategory));
      messages = messages.concat(assertTabStrClickedCount(properties.tabStrClickedCount));
      messages = messages.concat(assertTabStrStartedCount(properties.tabStrStartedCount));
      messages = messages.concat(assertRailStrClickedCount(properties.railStrClickedCount));
      messages = messages.concat(assertRailStrStartedCount(properties.railStrStartedCount));
      messages = messages.concat(assertTileStrClickedCount(properties.tileStrClickedCount));
      messages = messages.concat(assertTileStrStartedCount(properties.tileStrStartedCount));
      messages = messages.concat(assertTabStrCompletedCount(properties.tabStrCompletedCount));
      messages = messages.concat(assertRailStrCompletedCount(properties.railStrCompletedCount));
      messages = messages.concat(assertTileStrCompletedCount(properties.tileStrCompletedCount));
      messages = messages.concat(assertOverallClickedCount(properties.overallClickedCount));
      messages = messages.concat(assertOverallStartedCount(properties.overallStartedCount));
      messages = messages.concat(assertOverallCompletedCount(properties.overallCompletedCount));
      messages = messages.concat(assertRecommendationRailCode(properties.recommendationRailCode));
      messages = messages.concat(assertRecommendationVersionName(properties.recommendationVersionName));
      messages = messages.concat(assertRecommendationSubVersionName(properties.recommendationSubVersionName));
      messages = messages.concat(assertRecommendationAlgorithmFlag(properties.recommendationAlgorithmFlag));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Playable Completed", Object.keys(properties), [
        "from",
        "contentType",
        "gameCode",
        "gameName",
        "gameType",
        "playableCode",
        "playableName",
        "playableType",
        "recommendedTileName",
        "recommendedTileRank",
        "recommendedRailName",
        "recommendedRailRank",
        "contentGroup",
        "clickId",
        "gameEngine",
        "subject",
        "totalMemory",
        "usedMemory",
        "memoryLimit",
        "memoryUsagePercentage",
        "playablePath",
        "playableClickId",
        "recommendedVia",
        "tabCode",
        "recommendedRail",
        "recommendedCategory",
        "tabStrClickedCount",
        "tabStrStartedCount",
        "railStrClickedCount",
        "railStrStartedCount",
        "tileStrClickedCount",
        "tileStrStartedCount",
        "tabStrCompletedCount",
        "railStrCompletedCount",
        "tileStrCompletedCount",
        "overallClickedCount",
        "overallStartedCount",
        "overallCompletedCount",
        "recommendationRailCode",
        "recommendationVersionName",
        "recommendationSubVersionName",
        "recommendationAlgorithmFlag"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ax-GP4kM7u", "257cefa37de1be74ab3057cddd312c4dfe31fc636eb20c806b937971052bfe48", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Playable Completed", {
        "From": properties.from,
        "Content Type": properties.contentType,
        "Game Code": properties.gameCode,
        "Game Name": properties.gameName,
        "Game Type": properties.gameType,
        "Playable Code": properties.playableCode,
        "Playable Name": properties.playableName,
        "Playable Type": properties.playableType,
        "Recommended Tile Name": properties.recommendedTileName,
        "Recommended Tile Rank": properties.recommendedTileRank,
        "Recommended Rail Name": properties.recommendedRailName,
        "Recommended Rail Rank": properties.recommendedRailRank,
        "Content Group": properties.contentGroup,
        "Click Id": properties.clickId,
        "Game Engine": properties.gameEngine,
        "Subject": properties.subject,
        "Total Memory": properties.totalMemory,
        "Used Memory": properties.usedMemory,
        "Memory Limit": properties.memoryLimit,
        "Memory Usage Percentage": properties.memoryUsagePercentage,
        "Playable Path": properties.playablePath,
        "Playable Click Id": properties.playableClickId,
        "Recommended Via": properties.recommendedVia,
        "Tab Code": properties.tabCode,
        "Recommended Rail": properties.recommendedRail,
        "Recommended Category": properties.recommendedCategory,
        "Tab Str Clicked Count": properties.tabStrClickedCount,
        "Tab Str Started Count": properties.tabStrStartedCount,
        "Rail Str Clicked Count": properties.railStrClickedCount,
        "Rail Str Started Count": properties.railStrStartedCount,
        "Tile Str Clicked Count": properties.tileStrClickedCount,
        "Tile Str Started Count": properties.tileStrStartedCount,
        "Tab Str Completed Count": properties.tabStrCompletedCount,
        "Rail Str Completed Count": properties.railStrCompletedCount,
        "Tile Str Completed Count": properties.tileStrCompletedCount,
        "Overall Clicked Count": properties.overallClickedCount,
        "Overall Started Count": properties.overallStartedCount,
        "Overall Completed Count": properties.overallCompletedCount,
        "Recommendation Rail Code": properties.recommendationRailCode,
        "Recommendation Version Name": properties.recommendationVersionName,
        "Recommendation Sub Version Name": properties.recommendationSubVersionName,
        "Recommendation Algorithm Flag": properties.recommendationAlgorithmFlag,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ax-GP4kM7u", "Playable Completed", messages, [
        {id: "2da5NLAEc", name: "Game Type", value: properties.gameType},
        {id: "2hMTTBgU30", name: "Total Memory", value: properties.totalMemory},
        {id: "2oZQdvXRu", name: "Game Code", value: properties.gameCode},
        {id: "33JWk0cGdkpH6MbvcXKfL", name: "Tile Str Clicked Count", value: properties.tileStrClickedCount},
        {id: "6lrsWYY5Y", name: "Recommended Rail Name", value: properties.recommendedRailName},
        {id: "72Hz7CelRpVYf1warHrRP", name: "Tile Str Started Count", value: properties.tileStrStartedCount},
        {id: "7PQh3G9ITCcMDMNeMTM8q", name: "Tab Str Clicked Count", value: properties.tabStrClickedCount},
        {id: "ADfS21LlJH", name: "Memory Limit", value: properties.memoryLimit},
        {id: "AFC3Xnyx0vxpH2PWZIjdO", name: "Rail Str Completed Count", value: properties.railStrCompletedCount},
        {id: "BchWbNpV0WYRnYxTnBQ-c", name: "Recommendation Sub Version Name", value: properties.recommendationSubVersionName},
        {id: "CptvN7aTfWej4MrTLiZsM", name: "Recommended Via", value: properties.recommendedVia},
        {id: "CxhubqT3Hp", name: "Playable Path", value: properties.playablePath},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "FH6REXldlxqxCPK0pvsML", name: "Recommendation Version Name", value: properties.recommendationVersionName},
        {id: "FLDtSJNKL", name: "Recommended Tile Rank", value: properties.recommendedTileRank},
        {id: "GAdbKqJ5y9HJPos5lx5qt", name: "Tab Str Completed Count", value: properties.tabStrCompletedCount},
        {id: "HFnzATNuS7GI6VZs6tZ15", name: "Tab Str Started Count", value: properties.tabStrStartedCount},
        {id: "HJUIBmGrsUmqa_TYCtwQ0", name: "Overall Started Count", value: properties.overallStartedCount},
        {id: "JVkBdMN1_", name: "Game Engine", value: properties.gameEngine},
        {id: "Nfs9QLl8W7", name: "Content Type", value: properties.contentType},
        {id: "OHBx0fnhzlxvHhw0e87pM", name: "Overall Completed Count", value: properties.overallCompletedCount},
        {id: "Otu1r2JQW", name: "Content Group", value: properties.contentGroup},
        {id: "Q2q6j4dEnjH8uo-MY-mr7", name: "Recommendation Algorithm Flag", value: properties.recommendationAlgorithmFlag},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "QQeu-Td4-0", name: "Playable Click Id", value: properties.playableClickId},
        {id: "QjCwFasvW0", name: "Playable Code", value: properties.playableCode},
        {id: "Qwa4E7UWbmonbiv7JbciC", name: "Recommendation Rail Code", value: properties.recommendationRailCode},
        {id: "TYbmk5DQn", name: "Recommended Tile Name", value: properties.recommendedTileName},
        {id: "VdJhEU0H6s", name: "Recommended Category", value: properties.recommendedCategory},
        {id: "X4kgAx81N5AHgcI6NaNiS", name: "Overall Clicked Count", value: properties.overallClickedCount},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "_QL92wEdpoa8wH50vOPYt", name: "Tile Str Completed Count", value: properties.tileStrCompletedCount},
        {id: "c2W4X05Jy", name: "Playable Name", value: properties.playableName},
        {id: "drNgwJn5Xg", name: "Recommended Rail", value: properties.recommendedRail},
        {id: "fXWDPkk_PZ", name: "Memory Usage Percentage", value: properties.memoryUsagePercentage},
        {id: "gvDk2xQI4d", name: "Used Memory", value: properties.usedMemory},
        {id: "hKAJ3izCFVFH-D4_886C8", name: "Rail Str Clicked Count", value: properties.railStrClickedCount},
        {id: "jVQaLzj_1", name: "Click Id", value: properties.clickId},
        {id: "l9PbANZBu", name: "Tab Code", value: properties.tabCode},
        {id: "sRPi7ITwtlHeD7HQEGzmG", name: "Rail Str Started Count", value: properties.railStrStartedCount},
        {id: "tHAI3DRE4", name: "Playable Type", value: properties.playableType},
        {id: "uyLgqxbg7", name: "Recommended Rail Rank", value: properties.recommendedRailRank},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Playable Completed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Playable Completed", {
          "From": properties.from,
          "Content Type": properties.contentType,
          "Game Code": properties.gameCode,
          "Game Name": properties.gameName,
          "Game Type": properties.gameType,
          "Playable Code": properties.playableCode,
          "Playable Name": properties.playableName,
          "Playable Type": properties.playableType,
          "Recommended Tile Name": properties.recommendedTileName,
          "Recommended Tile Rank": properties.recommendedTileRank,
          "Recommended Rail Name": properties.recommendedRailName,
          "Recommended Rail Rank": properties.recommendedRailRank,
          "Content Group": properties.contentGroup,
          "Click Id": properties.clickId,
          "Game Engine": properties.gameEngine,
          "Subject": properties.subject,
          "Total Memory": properties.totalMemory,
          "Used Memory": properties.usedMemory,
          "Memory Limit": properties.memoryLimit,
          "Memory Usage Percentage": properties.memoryUsagePercentage,
          "Playable Path": properties.playablePath,
          "Playable Click Id": properties.playableClickId,
          "Recommended Via": properties.recommendedVia,
          "Tab Code": properties.tabCode,
          "Recommended Rail": properties.recommendedRail,
          "Recommended Category": properties.recommendedCategory,
          "Tab Str Clicked Count": properties.tabStrClickedCount,
          "Tab Str Started Count": properties.tabStrStartedCount,
          "Rail Str Clicked Count": properties.railStrClickedCount,
          "Rail Str Started Count": properties.railStrStartedCount,
          "Tile Str Clicked Count": properties.tileStrClickedCount,
          "Tile Str Started Count": properties.tileStrStartedCount,
          "Tab Str Completed Count": properties.tabStrCompletedCount,
          "Rail Str Completed Count": properties.railStrCompletedCount,
          "Tile Str Completed Count": properties.tileStrCompletedCount,
          "Overall Clicked Count": properties.overallClickedCount,
          "Overall Started Count": properties.overallStartedCount,
          "Overall Completed Count": properties.overallCompletedCount,
          "Recommendation Rail Code": properties.recommendationRailCode,
          "Recommendation Version Name": properties.recommendationVersionName,
          "Recommendation Sub Version Name": properties.recommendationSubVersionName,
          "Recommendation Algorithm Flag": properties.recommendationAlgorithmFlag,
          "Screen Height": sysScreenHeight,
          }, "ax-GP4kM7u", "257cefa37de1be74ab3057cddd312c4dfe31fc636eb20c806b937971052bfe48");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Playable Completed", {
      "From": properties.from,
      "Content Type": properties.contentType,
      "Game Code": properties.gameCode,
      "Game Name": properties.gameName,
      "Game Type": properties.gameType,
      "Playable Code": properties.playableCode,
      "Playable Name": properties.playableName,
      "Playable Type": properties.playableType,
      "Recommended Tile Name": properties.recommendedTileName,
      "Recommended Tile Rank": properties.recommendedTileRank,
      "Recommended Rail Name": properties.recommendedRailName,
      "Recommended Rail Rank": properties.recommendedRailRank,
      "Content Group": properties.contentGroup,
      "Click Id": properties.clickId,
      "Game Engine": properties.gameEngine,
      "Subject": properties.subject,
      "Total Memory": properties.totalMemory,
      "Used Memory": properties.usedMemory,
      "Memory Limit": properties.memoryLimit,
      "Memory Usage Percentage": properties.memoryUsagePercentage,
      "Playable Path": properties.playablePath,
      "Playable Click Id": properties.playableClickId,
      "Recommended Via": properties.recommendedVia,
      "Tab Code": properties.tabCode,
      "Recommended Rail": properties.recommendedRail,
      "Recommended Category": properties.recommendedCategory,
      "Tab Str Clicked Count": properties.tabStrClickedCount,
      "Tab Str Started Count": properties.tabStrStartedCount,
      "Rail Str Clicked Count": properties.railStrClickedCount,
      "Rail Str Started Count": properties.railStrStartedCount,
      "Tile Str Clicked Count": properties.tileStrClickedCount,
      "Tile Str Started Count": properties.tileStrStartedCount,
      "Tab Str Completed Count": properties.tabStrCompletedCount,
      "Rail Str Completed Count": properties.railStrCompletedCount,
      "Tile Str Completed Count": properties.tileStrCompletedCount,
      "Overall Clicked Count": properties.overallClickedCount,
      "Overall Started Count": properties.overallStartedCount,
      "Overall Completed Count": properties.overallCompletedCount,
      "Recommendation Rail Code": properties.recommendationRailCode,
      "Recommendation Version Name": properties.recommendationVersionName,
      "Recommendation Sub Version Name": properties.recommendationSubVersionName,
      "Recommendation Algorithm Flag": properties.recommendationAlgorithmFlag,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Subscribe Popup: When the user sees the popup after hitting the daily limit
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Cv9KkHgNj/trigger/N7LdPQmh8
   * 2. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Cv9KkHgNj/trigger/aM8WGmjk3
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {int} properties.freeActivitiesLeftCount - Stores the number of free activities left for the user to play on a particular day, at that moment

   * @param {string} [properties.freeWorksheetsLeftCount] - Stores the number of free worksheets left for the user to play on a particular day, at that moment
   * @param {string} [properties.contentType] - Type of content viz. Game/Learning Path/Activities/Worksheets
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Cv9KkHgNj}
   */
  function viewedSubscribePopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertFreeActivitiesLeftCount(properties.freeActivitiesLeftCount));
      messages = messages.concat(assertOptionalFreeWorksheetsLeftCount(properties.freeWorksheetsLeftCount));
      messages = messages.concat(assertOptionalContentType(properties.contentType));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Subscribe Popup", Object.keys(properties), [
        "from",
        "freeActivitiesLeftCount",
        "freeWorksheetsLeftCount",
        "contentType",
        "platform",
        "elaGrade",
        "mathGrade",
        "mode",
        "userType",
        "signupFlow",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Cv9KkHgNj", "e2c0c826bf93a48bdbaa3fce277c224030326e84bf7618516f6fe0a58381a5ed", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Subscribe Popup", {
        "From": properties.from,
        "Free Activities Left Count": properties.freeActivitiesLeftCount,
        "Free Worksheets Left Count": properties.freeWorksheetsLeftCount,
        "Content Type": properties.contentType,
        "Platform": properties.platform,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Cv9KkHgNj", "Viewed Subscribe Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "H4pP9av1w", name: "Free Worksheets Left Count", value: properties.freeWorksheetsLeftCount},
        {id: "Nfs9QLl8W7", name: "Content Type", value: properties.contentType},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "zY_qKY7KjA", name: "Free Activities Left Count", value: properties.freeActivitiesLeftCount},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Subscribe Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Subscribe Popup", {
          "From": properties.from,
          "Free Activities Left Count": properties.freeActivitiesLeftCount,
          "Free Worksheets Left Count": properties.freeWorksheetsLeftCount,
          "Content Type": properties.contentType,
          "Platform": properties.platform,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "Cv9KkHgNj", "e2c0c826bf93a48bdbaa3fce277c224030326e84bf7618516f6fe0a58381a5ed");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Subscribe Popup", {
      "From": properties.from,
      "Free Activities Left Count": properties.freeActivitiesLeftCount,
      "Free Worksheets Left Count": properties.freeWorksheetsLeftCount,
      "Content Type": properties.contentType,
      "Platform": properties.platform,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Subscribe Popup: When the user interacts wih the subscribe or daily limit hit popup
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/2oy8ZIYtB/trigger/B4bYHsd_W
   * 2. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/2oy8ZIYtB/trigger/wGS6COqyg
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {int} properties.freeActivitiesLeftCount - Stores the number of free activities left for the user to play on a particular day, at that moment

   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} [properties.freeWorksheetsLeftCount] - Stores the number of free worksheets left for the user to play on a particular day, at that moment
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.purchaseClickId - Unique ID associated with each purchase flow. Gets reset when the user exits the purchase flowing (irrespective of successful or unsuccessful purchase)
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/2oy8ZIYtB}
   */
  function interactedSubscribePopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertFreeActivitiesLeftCount(properties.freeActivitiesLeftCount));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertOptionalFreeWorksheetsLeftCount(properties.freeWorksheetsLeftCount));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertPurchaseClickID(properties.purchaseClickId));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Subscribe Popup", Object.keys(properties), [
        "freeActivitiesLeftCount",
        "clickedOn",
        "freeWorksheetsLeftCount",
        "platform",
        "elaGrade",
        "mathGrade",
        "mode",
        "userType",
        "signupFlow",
        "grade",
        "purchaseClickId"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "2oy8ZIYtB", "740f5a4c7bd760984b37e997e48f90bebd6dc6d33466075ce01927d13f53a902", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Subscribe Popup", {
        "Free Activities Left Count": properties.freeActivitiesLeftCount,
        "Clicked On": properties.clickedOn,
        "Free Worksheets Left Count": properties.freeWorksheetsLeftCount,
        "Platform": properties.platform,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Purchase Click ID": properties.purchaseClickId,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("2oy8ZIYtB", "Interacted Subscribe Popup", messages, [
        {id: "1sxa4mA1P", name: "Purchase Click ID", value: properties.purchaseClickId},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "H4pP9av1w", name: "Free Worksheets Left Count", value: properties.freeWorksheetsLeftCount},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "zY_qKY7KjA", name: "Free Activities Left Count", value: properties.freeActivitiesLeftCount},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Subscribe Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Subscribe Popup", {
          "Free Activities Left Count": properties.freeActivitiesLeftCount,
          "Clicked On": properties.clickedOn,
          "Free Worksheets Left Count": properties.freeWorksheetsLeftCount,
          "Platform": properties.platform,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Purchase Click ID": properties.purchaseClickId,
          "Screen Height": sysScreenHeight,
          }, "2oy8ZIYtB", "740f5a4c7bd760984b37e997e48f90bebd6dc6d33466075ce01927d13f53a902");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Subscribe Popup", {
      "Free Activities Left Count": properties.freeActivitiesLeftCount,
      "Clicked On": properties.clickedOn,
      "Free Worksheets Left Count": properties.freeWorksheetsLeftCount,
      "Platform": properties.platform,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Purchase Click ID": properties.purchaseClickId,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Worksheet Search Dropdown: This will be triggered upon clicking on Worksheet Search bar to see the search dropdown
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/UgHjawTqaf}
   */
  function viewedWorksheetSearchDropdown(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Worksheet Search Dropdown", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "UgHjawTqaf", "17c2e33587334be8572d7532026a647648171c79fea3900ca1c3cbd6fa626172", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Worksheet Search Dropdown", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("UgHjawTqaf", "Viewed Worksheet Search Dropdown", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Worksheet Search Dropdown': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Worksheet Search Dropdown", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "UgHjawTqaf", "17c2e33587334be8572d7532026a647648171c79fea3900ca1c3cbd6fa626172");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Worksheet Search Dropdown", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Worksheet Search Dropdown: This will be triggered when the user does any interaction with the Search dropdown such as clicking, pressing enter, entering search query etc.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/E2AQ9GYXFY}
   */
  function interactedWorksheetSearchDropdown(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Worksheet Search Dropdown", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "E2AQ9GYXFY", "aec47e4fdec527c6bd6b9702f4fce515454dadc8dc9b040fa503a8381092750b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Worksheet Search Dropdown", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("E2AQ9GYXFY", "Interacted Worksheet Search Dropdown", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Worksheet Search Dropdown': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Worksheet Search Dropdown", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "E2AQ9GYXFY", "aec47e4fdec527c6bd6b9702f4fce515454dadc8dc9b040fa503a8381092750b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Worksheet Search Dropdown", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Worksheet Search Results Page: This event gets triggered if the user clicks on a worksheet from the search icon or hits enter after entering the search query in the search bar.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/P6lgzeqvSt}
   */
  function viewedWorksheetSearchResultsPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Worksheet Search Results Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "P6lgzeqvSt", "9585c12fe82a61080a678570af7705ab7cecfd6477210a98f73e1fdded989254", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Worksheet Search Results Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("P6lgzeqvSt", "Viewed Worksheet Search Results Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Worksheet Search Results Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Worksheet Search Results Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "P6lgzeqvSt", "9585c12fe82a61080a678570af7705ab7cecfd6477210a98f73e1fdded989254");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Worksheet Search Results Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Worksheet Search Results Page: This will be triggered when the user interacts with the Search Results Page.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {int} properties.maxWorksheetViewed - This will capture maximum WS no. viewed by the user (scroll depth)
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/DzXGchIbC_}
   */
  function interactedWorksheetSearchResultsPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMaxWorksheetViewed(properties.maxWorksheetViewed));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Worksheet Search Results Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "maxWorksheetViewed",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "DzXGchIbC_", "1384ce55305f7d931f1021962eb4aae504530d5277fc94a285b347937fb00517", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Worksheet Search Results Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Max Worksheet Viewed": properties.maxWorksheetViewed,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("DzXGchIbC_", "Interacted Worksheet Search Results Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "s4DOhHgK_6", name: "Max Worksheet Viewed", value: properties.maxWorksheetViewed},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Worksheet Search Results Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Worksheet Search Results Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Max Worksheet Viewed": properties.maxWorksheetViewed,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "DzXGchIbC_", "1384ce55305f7d931f1021962eb4aae504530d5277fc94a285b347937fb00517");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Worksheet Search Results Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Max Worksheet Viewed": properties.maxWorksheetViewed,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Worksheet Search Results End Page: This is triggered when the user reaches the end of search results after scrolling down
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/GfP64qveJj}
   */
  function viewedWorksheetSearchResultsEndPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Worksheet Search Results End Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "GfP64qveJj", "267ec4572d93e59bacb7ac731eb28a71fb3b1f2c5e900bbc6759402d3040d930", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Worksheet Search Results End Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("GfP64qveJj", "Viewed Worksheet Search Results End Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Worksheet Search Results End Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Worksheet Search Results End Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "GfP64qveJj", "267ec4572d93e59bacb7ac731eb28a71fb3b1f2c5e900bbc6759402d3040d930");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Worksheet Search Results End Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Theme Toggle: When the user toggles between seasonal theme and default theme
   * 
   * When to trigger this event:
   * 1. Clicking/tapping on theme toggle in settings/parents menu
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/CSdnqg_WW/trigger/0zbDMU6mZ
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/CSdnqg_WW}
   */
  function interactedThemeToggle(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Theme Toggle", Object.keys(properties), [
        "clickedOn",
        "platform",
        "elaGrade",
        "mathGrade",
        "mode",
        "userType",
        "signupFlow",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "CSdnqg_WW", "be79be8a8ef07e06a63a148ef9f221be329adada9be433789e5701ba03a5e072", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Theme Toggle", {
        "Clicked On": properties.clickedOn,
        "Platform": properties.platform,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("CSdnqg_WW", "Interacted Theme Toggle", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Theme Toggle': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Theme Toggle", {
          "Clicked On": properties.clickedOn,
          "Platform": properties.platform,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "CSdnqg_WW", "be79be8a8ef07e06a63a148ef9f221be329adada9be433789e5701ba03a5e072");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Theme Toggle", {
      "Clicked On": properties.clickedOn,
      "Platform": properties.platform,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Nudge: This will be triggered every time a teacher views a nudge on any screen of the teacher product
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.nudgeTitleMessage - This will capture the main message of the nudge.
   * @param {string} properties.nudgeShownOnPage - This will capture the page where the teacher sees the nudge such as 'Dashboard', 'Curriculum' etc.
   * @param {string} properties.nudgeName - This will capture nudge name that appears.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/1XVvTNo_hp}
   */
  function viewedNudge(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertNudgeTitleMessage(properties.nudgeTitleMessage));
      messages = messages.concat(assertNudgeShownOnPage(properties.nudgeShownOnPage));
      messages = messages.concat(assertNudgeName(properties.nudgeName));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Nudge", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "nudgeTitleMessage",
        "nudgeShownOnPage",
        "nudgeName"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "1XVvTNo_hp", "149b95674965198014f510564c1c6047510d4ed46c5920184e6d6c48448867db", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Nudge", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Nudge Title Message": properties.nudgeTitleMessage,
        "Nudge Shown on Page": properties.nudgeShownOnPage,
        "Nudge Name": properties.nudgeName,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("1XVvTNo_hp", "Viewed Nudge", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3ysDI0za_", name: "Nudge Shown on Page", value: properties.nudgeShownOnPage},
        {id: "CLVHX-1DH", name: "Nudge Title Message", value: properties.nudgeTitleMessage},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "flFi1cYzR", name: "Nudge Name", value: properties.nudgeName},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Nudge': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Nudge", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Nudge Title Message": properties.nudgeTitleMessage,
          "Nudge Shown on Page": properties.nudgeShownOnPage,
          "Nudge Name": properties.nudgeName,
          "Screen Height": sysScreenHeight,
          }, "1XVvTNo_hp", "149b95674965198014f510564c1c6047510d4ed46c5920184e6d6c48448867db");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Nudge", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Nudge Title Message": properties.nudgeTitleMessage,
      "Nudge Shown on Page": properties.nudgeShownOnPage,
      "Nudge Name": properties.nudgeName,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Nudge: This will capture user interactions with the nudge
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/HUHH-X3BXc/trigger/lWCV8mx-p
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.nudgeTitleMessage - This will capture the main message of the nudge.
   * @param {string} properties.nudgeShownOnPage - This will capture the page where the teacher sees the nudge such as 'Dashboard', 'Curriculum' etc.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.nudgeName - This will capture nudge name that appears.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/HUHH-X3BXc}
   */
  function interactedNudge(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertNudgeTitleMessage(properties.nudgeTitleMessage));
      messages = messages.concat(assertNudgeShownOnPage(properties.nudgeShownOnPage));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertNudgeName(properties.nudgeName));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Nudge", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "nudgeTitleMessage",
        "nudgeShownOnPage",
        "clickedOn",
        "nudgeName"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "HUHH-X3BXc", "a10591a26ab281fe3912318dde63f300bf177454dfd5a0b641c013452b95407f", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Nudge", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Nudge Title Message": properties.nudgeTitleMessage,
        "Nudge Shown on Page": properties.nudgeShownOnPage,
        "Clicked On": properties.clickedOn,
        "Nudge Name": properties.nudgeName,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("HUHH-X3BXc", "Interacted Nudge", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3ysDI0za_", name: "Nudge Shown on Page", value: properties.nudgeShownOnPage},
        {id: "CLVHX-1DH", name: "Nudge Title Message", value: properties.nudgeTitleMessage},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "flFi1cYzR", name: "Nudge Name", value: properties.nudgeName},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Nudge': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Nudge", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Nudge Title Message": properties.nudgeTitleMessage,
          "Nudge Shown on Page": properties.nudgeShownOnPage,
          "Clicked On": properties.clickedOn,
          "Nudge Name": properties.nudgeName,
          "Screen Height": sysScreenHeight,
          }, "HUHH-X3BXc", "a10591a26ab281fe3912318dde63f300bf177454dfd5a0b641c013452b95407f");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Nudge", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Nudge Title Message": properties.nudgeTitleMessage,
      "Nudge Shown on Page": properties.nudgeShownOnPage,
      "Clicked On": properties.clickedOn,
      "Nudge Name": properties.nudgeName,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Student Progress Page: This will be triggered when the user does any activity on the Student Progress page
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/QRcOoO5dfP}
   */
  function interactedStudentProgressPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Student Progress Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "fromPage",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "QRcOoO5dfP", "adb1fdf10762010b8f5a001e9879f9b1f697481ddb164408fc2d27d80449cccb", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Student Progress Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From Page": properties.fromPage,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("QRcOoO5dfP", "Interacted Student Progress Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Student Progress Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Student Progress Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From Page": properties.fromPage,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "QRcOoO5dfP", "adb1fdf10762010b8f5a001e9879f9b1f697481ddb164408fc2d27d80449cccb");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Student Progress Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From Page": properties.fromPage,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Recommended Item: This event captures the details of what is recommended to a user in the Daily Recommendation Section tab/section.
This will have details of what is recommended such as section, content type, game code, playable code
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.section - This will capture the widget name that is being viewed/interacted by the user in that viewport. For example, 'Onboarding Widget', 'Home Access Widget', 'Assignment Widget', 'Assessment Widget', 'Math Fact Widget'
The list will only have 1 value for 'Section' property for Interacted event.
   * @param {string} properties.category - This represents the different types of content being recommended to the user through the DRS. Possible values = MyToDo, Math_LP, ELA_LP, Math Facts, Books, Spelling, Reading Comprehension, Playzone, Activities, Learning Games, etc







   * @param {string} [properties.gameCode] - Game code of the playable selected, for example: Math learning games have multiple variations, all those variations will have one game code
   * @param {string} [properties.playableCode] - Pass the 'Playable Code' of the Playable being started/clicked
   * @param {int} properties.ordering - This field defines the order of the recommendation. It will start from 0 and then progress by one count at a time.
Since the users' recommendation can change in a particular day for a particular category, this ordering will let us know how the recommended category has changed over a day for the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/OgVHdBXh1_}
   */
  function recommendedItem(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertSection(properties.section));
      messages = messages.concat(assertCategory(properties.category));
      messages = messages.concat(assertOptionalGameCode(properties.gameCode));
      messages = messages.concat(assertOptionalPlayableCode(properties.playableCode));
      messages = messages.concat(assertOrdering(properties.ordering));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Recommended Item", Object.keys(properties), [
        "section",
        "category",
        "gameCode",
        "playableCode",
        "ordering"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "OgVHdBXh1_", "734728c2e897c16f11d9537d62908e5002fb3e6737b57ffac545e78d3ee5bee2", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Recommended Item", {
        "Section": properties.section,
        "Category": properties.category,
        "Game Code": properties.gameCode,
        "Playable Code": properties.playableCode,
        "Ordering": properties.ordering,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("OgVHdBXh1_", "Recommended Item", messages, [
        {id: "2oZQdvXRu", name: "Game Code", value: properties.gameCode},
        {id: "4YcQJt7EU", name: "Ordering", value: properties.ordering},
        {id: "QjCwFasvW0", name: "Playable Code", value: properties.playableCode},
        {id: "hVOa_xHVR", name: "Category", value: properties.category},
        {id: "my9qL7M8w6", name: "Section", value: properties.section},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Recommended Item': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Recommended Item", {
          "Section": properties.section,
          "Category": properties.category,
          "Game Code": properties.gameCode,
          "Playable Code": properties.playableCode,
          "Ordering": properties.ordering,
          "Screen Height": sysScreenHeight,
          }, "OgVHdBXh1_", "734728c2e897c16f11d9537d62908e5002fb3e6737b57ffac545e78d3ee5bee2");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Recommended Item", {
      "Section": properties.section,
      "Category": properties.category,
      "Game Code": properties.gameCode,
      "Playable Code": properties.playableCode,
      "Ordering": properties.ordering,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Print Report Popup: This will be triggered when the user clicks on 'Print Report' from the pop-up that appears after clicking on the Print icon.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/orUIPL0SZY/trigger/pNsueznoB
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * @param {string} properties.tappedOn - UI element that user tapped on - used in conjunction with the event name which identifies the screen name
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/orUIPL0SZY}
   */
  function interactedPrintReportPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertTappedOn(properties.tappedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Print Report Popup", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "fromPage",
        "tappedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "orUIPL0SZY", "c447d2915f488fb74ade9d17840cbf467cee4d0b8813b036a5c9bdb02560e4ce", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Print Report Popup", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From Page": properties.fromPage,
        "Tapped On": properties.tappedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("orUIPL0SZY", "Interacted Print Report Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "cfvmMqWft", name: "Tapped On", value: properties.tappedOn},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Print Report Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Print Report Popup", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From Page": properties.fromPage,
          "Tapped On": properties.tappedOn,
          "Screen Height": sysScreenHeight,
          }, "orUIPL0SZY", "c447d2915f488fb74ade9d17840cbf467cee4d0b8813b036a5c9bdb02560e4ce");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Print Report Popup", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From Page": properties.fromPage,
      "Tapped On": properties.tappedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Student Progress: This will be triggered when the user does any activity on the Student Progress page
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/kE-qxL6hLl/trigger/LiB3_-Wln
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/kE-qxL6hLl}
   */
  function interactedStudentProgress(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Student Progress", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "fromPage",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "kE-qxL6hLl", "1fda1cf7ae08ea2b7827ca022a86c08aa31a0860dcfe07fcf3b01c5e2dba541a", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Student Progress", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From Page": properties.fromPage,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("kE-qxL6hLl", "Interacted Student Progress", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Student Progress': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Student Progress", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From Page": properties.fromPage,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "kE-qxL6hLl", "1fda1cf7ae08ea2b7827ca022a86c08aa31a0860dcfe07fcf3b01c5e2dba541a");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Student Progress", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From Page": properties.fromPage,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Playable Tapped: When user taps a playable on iOS or android platform
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.contentType] - Type of content viz. Game/Learning Path/Activities/Worksheets
   * @param {string} [properties.from] - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {string} properties.gameCode - Game code of the playable selected, for example: Math learning games have multiple variations, all those variations will have one game code
   * @param {string} [properties.gameName] - Name of the Game being tapped (Optional)
   * @param {string} [properties.gameType] - Type of game/playable selected
   * @param {string} [properties.playableCode] - Pass the 'Playable Code' of the Playable being started/clicked
   * @param {string} [properties.playableName] - Name of playable selected
   * @param {string} [properties.playableType] - Type of playable selected
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/mdn2gl4z0}
   */
  function playableTapped(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalContentType(properties.contentType));
      messages = messages.concat(assertOptionalFrom(properties.from));
      messages = messages.concat(assertGameCode(properties.gameCode));
      messages = messages.concat(assertOptionalGameName(properties.gameName));
      messages = messages.concat(assertOptionalGameType(properties.gameType));
      messages = messages.concat(assertOptionalPlayableCode(properties.playableCode));
      messages = messages.concat(assertOptionalPlayableName(properties.playableName));
      messages = messages.concat(assertOptionalPlayableType(properties.playableType));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Playable Tapped", Object.keys(properties), [
        "contentType",
        "from",
        "gameCode",
        "gameName",
        "gameType",
        "playableCode",
        "playableName",
        "playableType"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "mdn2gl4z0", "b44d4cce303706ff06bcc26b7d8df54f0437b451a6c38c02a001ba2b4882108b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Playable Tapped", {
        "Content Type": properties.contentType,
        "From": properties.from,
        "Game Code": properties.gameCode,
        "Game Name": properties.gameName,
        "Game Type": properties.gameType,
        "Playable Code": properties.playableCode,
        "Playable Name": properties.playableName,
        "Playable Type": properties.playableType,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("mdn2gl4z0", "Playable Tapped", messages, [
        {id: "2da5NLAEc", name: "Game Type", value: properties.gameType},
        {id: "2oZQdvXRu", name: "Game Code", value: properties.gameCode},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "Nfs9QLl8W7", name: "Content Type", value: properties.contentType},
        {id: "QjCwFasvW0", name: "Playable Code", value: properties.playableCode},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "c2W4X05Jy", name: "Playable Name", value: properties.playableName},
        {id: "tHAI3DRE4", name: "Playable Type", value: properties.playableType},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Playable Tapped': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Playable Tapped", {
          "Content Type": properties.contentType,
          "From": properties.from,
          "Game Code": properties.gameCode,
          "Game Name": properties.gameName,
          "Game Type": properties.gameType,
          "Playable Code": properties.playableCode,
          "Playable Name": properties.playableName,
          "Playable Type": properties.playableType,
          "Screen Height": sysScreenHeight,
          }, "mdn2gl4z0", "b44d4cce303706ff06bcc26b7d8df54f0437b451a6c38c02a001ba2b4882108b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Playable Tapped", {
      "Content Type": properties.contentType,
      "From": properties.from,
      "Game Code": properties.gameCode,
      "Game Name": properties.gameName,
      "Game Type": properties.gameType,
      "Playable Code": properties.playableCode,
      "Playable Name": properties.playableName,
      "Playable Type": properties.playableType,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Math Facts Closed: When user starts math facts game
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.endPoint - This is the phase of math facts in which user closes the math facts game (e.g. portal, city, jungle, cafe etc)
   * @param {int} properties.totalProblemsAnswered - Total problems answered to complete the assignment.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/r6HH9FWsuM}
   */
  function mathFactsClosed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertEndPoint(properties.endPoint));
      messages = messages.concat(assertTotalProblemsAnswered(properties.totalProblemsAnswered));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Math Facts Closed", Object.keys(properties), [
        "endPoint",
        "totalProblemsAnswered"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "r6HH9FWsuM", "1a1d77ff4100c8d2942a3bf3d6298b8ab5cc89f6b55429c4ad8de6a7f5ffc7ad", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Math Facts Closed", {
        "End Point": properties.endPoint,
        "Total Problems Answered": properties.totalProblemsAnswered,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("r6HH9FWsuM", "Math Facts Closed", messages, [
        {id: "6R8Dsubm7", name: "End Point", value: properties.endPoint},
        {id: "V_eCbteEGc", name: "Total Problems Answered", value: properties.totalProblemsAnswered},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Math Facts Closed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Math Facts Closed", {
          "End Point": properties.endPoint,
          "Total Problems Answered": properties.totalProblemsAnswered,
          "Screen Height": sysScreenHeight,
          }, "r6HH9FWsuM", "1a1d77ff4100c8d2942a3bf3d6298b8ab5cc89f6b55429c4ad8de6a7f5ffc7ad");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Math Facts Closed", {
      "End Point": properties.endPoint,
      "Total Problems Answered": properties.totalProblemsAnswered,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Live Classes Tab: Clicked anywhere on the live classes tab
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.subscriberId] - Subscriber Id of user, registered in live class service
   * @param {Array<string>} [properties.studentId] - This will capture the Student analytics IDs in an array.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/_1P0Y6vNcL}
   */
  function interactedLiveClassesTab(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalSubscriberId(properties.subscriberId));
      messages = messages.concat(assertOptionalStudentID(properties.studentId));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Live Classes Tab", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "clickedOn",
        "from",
        "elaGrade",
        "grade",
        "subscriberId",
        "studentId"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "_1P0Y6vNcL", "cd8bc5de0ed6910604454d74499cdeb42d0fa318c3baa482df89e40c55042558", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Live Classes Tab", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Clicked On": properties.clickedOn,
        "From": properties.from,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Subscriber Id": properties.subscriberId,
        "Student ID": properties.studentId,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("_1P0Y6vNcL", "Interacted Live Classes Tab", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "5IEpaITD9", name: "Student ID", value: properties.studentId},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "nSwyEoLcJ", name: "Subscriber Id", value: properties.subscriberId},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Live Classes Tab': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Live Classes Tab", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Clicked On": properties.clickedOn,
          "From": properties.from,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Subscriber Id": properties.subscriberId,
          "Student ID": properties.studentId,
          "Screen Height": sysScreenHeight,
          }, "_1P0Y6vNcL", "cd8bc5de0ed6910604454d74499cdeb42d0fa318c3baa482df89e40c55042558");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Live Classes Tab", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Clicked On": properties.clickedOn,
      "From": properties.from,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Subscriber Id": properties.subscriberId,
      "Student ID": properties.studentId,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Live Classes Subscription Popup: Triggered when user interacts with the subscription required popup which comes after clicking on the class cards
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/MNYS-5whGk}
   */
  function interactedLiveClassesSubscriptionPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Live Classes Subscription Popup", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "clickedOn",
        "elaGrade",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "MNYS-5whGk", "91d6983ec4ed0577842c903c7d3441a051c7955336be80aa1965e5ab2c82c0fa", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Live Classes Subscription Popup", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Clicked On": properties.clickedOn,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("MNYS-5whGk", "Interacted Live Classes Subscription Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Live Classes Subscription Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Live Classes Subscription Popup", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Clicked On": properties.clickedOn,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "MNYS-5whGk", "91d6983ec4ed0577842c903c7d3441a051c7955336be80aa1965e5ab2c82c0fa");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Live Classes Subscription Popup", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Clicked On": properties.clickedOn,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Trial Pitch Screen: When a user sees the trial pitch screen during onboarding on the web
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/DV2sGHW6RB}
   */
  function viewedTrialPitchScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Trial Pitch Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "DV2sGHW6RB", "82e509210721bff0545b4b62eff9d14f701da1bc999c07e12b617b43b493b69b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Trial Pitch Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("DV2sGHW6RB", "Viewed Trial Pitch Screen", messages, [
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Trial Pitch Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Trial Pitch Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "DV2sGHW6RB", "82e509210721bff0545b4b62eff9d14f701da1bc999c07e12b617b43b493b69b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Trial Pitch Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Trial Pitch Screen: Interacted anywhere on the trial pitch screen on web
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ivs9xyQ7uz}
   */
  function interactedTrialPitchScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Trial Pitch Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ivs9xyQ7uz", "815db791dd4cd16ee75ae324b56c1b408afb2ccc2855e785cee2b4abfb267da1", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Trial Pitch Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ivs9xyQ7uz", "Interacted Trial Pitch Screen", messages, [
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Trial Pitch Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Trial Pitch Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "ivs9xyQ7uz", "815db791dd4cd16ee75ae324b56c1b408afb2ccc2855e785cee2b4abfb267da1");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Trial Pitch Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Left Navigation Menu: This event will get fired as soon as a user clicks anywhere in the left navigation menu.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Cq4OazKyjs}
   */
  function interactedLeftNavigationMenu(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Left Navigation Menu", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Cq4OazKyjs", "629d6af869b0d828dede636f9a0c8380b6e826fe85e06678666138365852d67b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Left Navigation Menu", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Cq4OazKyjs", "Interacted Left Navigation Menu", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Left Navigation Menu': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Left Navigation Menu", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "Cq4OazKyjs", "629d6af869b0d828dede636f9a0c8380b6e826fe85e06678666138365852d67b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Left Navigation Menu", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted SplashCommunity Discoverability Pop-Up: This event will get fired when the user interacts with the SplashCommunity Discoverability Pop-Up. These are the ways of interaction - 'Cross Button', 'Check Terms & Conditions', 'Terms & Conditions Details', 'Join SplashCommunity button', 'Uncheck Terms & Conditions'
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/BuymQ_t3Sj}
   */
  function interactedSplashcommunityDiscoverabilityPopUp(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted SplashCommunity Discoverability Pop-Up", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "BuymQ_t3Sj", "8ba501104257c93dbce48e0944f35ae004daf2ca5a3ea402d6e120ae68845f08", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted SplashCommunity Discoverability Pop-Up", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("BuymQ_t3Sj", "Interacted SplashCommunity Discoverability Pop-Up", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted SplashCommunity Discoverability Pop-Up': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted SplashCommunity Discoverability Pop-Up", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "BuymQ_t3Sj", "8ba501104257c93dbce48e0944f35ae004daf2ca5a3ea402d6e120ae68845f08");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted SplashCommunity Discoverability Pop-Up", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed SplashCommunity Discoverability Pop-Up: This event will be fired when a user views the SplashCommunity Discoverability Pop-Up from the left navigation menu.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/E4gkIDQS6a}
   */
  function viewedSplashcommunityDiscoverabilityPopUp(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed SplashCommunity Discoverability Pop-Up", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "E4gkIDQS6a", "01c2c5cb45e6106d0c378c7a2756e77ce371764c246ca722cd04c6d512fba3b3", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed SplashCommunity Discoverability Pop-Up", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("E4gkIDQS6a", "Viewed SplashCommunity Discoverability Pop-Up", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed SplashCommunity Discoverability Pop-Up': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed SplashCommunity Discoverability Pop-Up", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "E4gkIDQS6a", "01c2c5cb45e6106d0c378c7a2756e77ce371764c246ca722cd04c6d512fba3b3");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed SplashCommunity Discoverability Pop-Up", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted New Class Addition Page: This event will be fired when the user clicks with the new class addition screen.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/IqZuaGKSGX/trigger/2lT2jnG2q
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} [properties.interactionDetails] - Stores where is the user interacting with the page
   * @param {string} [properties.valueName] - This will capture the value/text of the field that is selected.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/IqZuaGKSGX}
   */
  function interactedNewClassAdditionPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertOptionalInteractionDetails(properties.interactionDetails));
      messages = messages.concat(assertOptionalValueName(properties.valueName));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted New Class Addition Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "interactionDetails",
        "valueName"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "IqZuaGKSGX", "9b74c4ac4af358f4795ea8d7801a3e6fa9bdbdecf6701adb86eec3ede0e2ba63", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted New Class Addition Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Interaction Details": properties.interactionDetails,
        "Value Name": properties.valueName,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("IqZuaGKSGX", "Interacted New Class Addition Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "l-8JNUE0q", name: "Value Name", value: properties.valueName},
        {id: "ncdYto9gZ", name: "Interaction Details", value: properties.interactionDetails},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted New Class Addition Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted New Class Addition Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Interaction Details": properties.interactionDetails,
          "Value Name": properties.valueName,
          "Screen Height": sysScreenHeight,
          }, "IqZuaGKSGX", "9b74c4ac4af358f4795ea8d7801a3e6fa9bdbdecf6701adb86eec3ede0e2ba63");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted New Class Addition Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Interaction Details": properties.interactionDetails,
      "Value Name": properties.valueName,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Freemium Timer Expired: This event is triggered from the backend when the free timer for the user expires. The user may or may not see any change in the frontend. But as per the backend, the timer is expired. 
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.playablePlayed - The number of playable started by the user within the Freemium Timer Started and Expired. The value can be 1, 2, 3, 4, etc.. This will keep increasing as the number of playable started. 
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/1si8LocV8e}
   */
  function freemiumTimerExpired(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertPlayablePlayed(properties.playablePlayed));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Freemium Timer Expired", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "playablePlayed"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "1si8LocV8e", "bb6f1d517d20573346b010846e2ba9e2dcd4a7fc9f730c010d78aed02bfe05ed", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Freemium Timer Expired", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Playable Played": properties.playablePlayed,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("1si8LocV8e", "Freemium Timer Expired", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "V16Tay7p5", name: "Playable Played", value: properties.playablePlayed},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Freemium Timer Expired': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Freemium Timer Expired", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Playable Played": properties.playablePlayed,
          "Screen Height": sysScreenHeight,
          }, "1si8LocV8e", "bb6f1d517d20573346b010846e2ba9e2dcd4a7fc9f730c010d78aed02bfe05ed");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Freemium Timer Expired", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Playable Played": properties.playablePlayed,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Freemium Timer Started: The freemium timer started when the user starts the first playable. This event should get triggered immediately. 
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.timerValue - The value of the timer in minutes. As the same will be configurable from the backend. The value should be whatever we are showing the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/fdQGkGEW9F}
   */
  function freemiumTimerStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertTimerValue(properties.timerValue));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Freemium Timer Started", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "timerValue"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "fdQGkGEW9F", "858e430d7bdcb95b08130a8fe19c36e368dc0d074a70f1b45fa4b45e6c3957ad", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Freemium Timer Started", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Timer Value": properties.timerValue,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("fdQGkGEW9F", "Freemium Timer Started", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "FQr65Ct5y", name: "Timer Value", value: properties.timerValue},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Freemium Timer Started': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Freemium Timer Started", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Timer Value": properties.timerValue,
          "Screen Height": sysScreenHeight,
          }, "fdQGkGEW9F", "858e430d7bdcb95b08130a8fe19c36e368dc0d074a70f1b45fa4b45e6c3957ad");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Freemium Timer Started", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Timer Value": properties.timerValue,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Reached Daily Limit: This event needs to be fired when the user reaches the daily limit irrespective of the experiment segment. This should happen for 2 free cards or freemium of 10 minutes. 
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} [properties.subject] - Subject Selected during onboarding

   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {string} [properties.contentType] - Type of content viz. Game/Learning Path/Activities/Worksheets
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/QrQdavLJdx}
   */
  function reachedDailyLimit(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertOptionalSubject(properties.subject));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertOptionalContentType(properties.contentType));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Reached Daily Limit", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "subject",
        "grade",
        "from",
        "contentType",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "QrQdavLJdx", "9b6c3827596a46487642c01d6c0c7a5d85a16fc00d7b39f782089f6ee7426f49", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Reached Daily Limit", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Subject": properties.subject,
        "Grade": properties.grade,
        "From": properties.from,
        "Content Type": properties.contentType,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("QrQdavLJdx", "Reached Daily Limit", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "Nfs9QLl8W7", name: "Content Type", value: properties.contentType},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Reached Daily Limit': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Reached Daily Limit", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Subject": properties.subject,
          "Grade": properties.grade,
          "From": properties.from,
          "Content Type": properties.contentType,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "QrQdavLJdx", "9b6c3827596a46487642c01d6c0c7a5d85a16fc00d7b39f782089f6ee7426f49");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Reached Daily Limit", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Subject": properties.subject,
      "Grade": properties.grade,
      "From": properties.from,
      "Content Type": properties.contentType,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Student Auto Logged in Successfully: Whenever there is a Login via the Student - Fire Student Auto Logged in Successfully event with the event property platform as ipad. Also, event property mode as school or home as per the post 3 pm check. Also, event property user type as student whenever there is a student login and user persona as per logic.
   * 
   * When to trigger this event:
   * 1. Login via the Student
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/RdSCAdwoxc/trigger/KmKOPQ6FT
   * 2. PTL Sign Up
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/RdSCAdwoxc/trigger/jCc04AgVb
   * 3. PTL Parent Login Successful
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/RdSCAdwoxc/trigger/3g9myEkWv
   * 4. Parent Signup from the Teacher Invite and Post 3 PM Signup
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/RdSCAdwoxc/trigger/sI_b58Y8x
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.userPersonaType - User persona type at an event level is the property that highlights whether the user persona is class only or after the parent signup - it is ptl. In the school, class the persona is class only and at home the persona is ptl. If the parent is not signed up, it is class only.
   * @param {string} properties.firedFrom - Fired from web-frontent, web-backend, ipad-frontend, ipad-backend.  
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/RdSCAdwoxc}
   */
  function studentAutoLoggedInSuccessfully(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertUserPersonaType(properties.userPersonaType));
      messages = messages.concat(assertFiredFrom(properties.firedFrom));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Student Auto Logged in Successfully", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "userPersonaType",
        "firedFrom"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "RdSCAdwoxc", "ac05a86d48394f31e234db044c105154e81c4eafeed55ea4f5622b485c425d23", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Student Auto Logged in Successfully", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "User Persona Type": properties.userPersonaType,
        "Fired From": properties.firedFrom,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("RdSCAdwoxc", "Student Auto Logged in Successfully", messages, [
        {id: "1z9szfE-j", name: "User Persona Type", value: properties.userPersonaType},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "4e2iM_rBA", name: "Fired From", value: properties.firedFrom},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Student Auto Logged in Successfully': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Student Auto Logged in Successfully", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "User Persona Type": properties.userPersonaType,
          "Fired From": properties.firedFrom,
          "Screen Height": sysScreenHeight,
          }, "RdSCAdwoxc", "ac05a86d48394f31e234db044c105154e81c4eafeed55ea4f5622b485c425d23");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Student Auto Logged in Successfully", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "User Persona Type": properties.userPersonaType,
      "Fired From": properties.firedFrom,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Subscribe Pop-Up on Ptl: Viewed Subscribe Pop-Up on Ptl - When the user sees the pop-up where we show CTA as view plans post the free limit is reached. This will be fired only on the PTL post 3 PM flow.
   * 
   * When to trigger this event:
   * 1. When the user sees the pop-up post limit is reached.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/XnyMsOLC7A/trigger/JIuigb06v
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/XnyMsOLC7A}
   */
  function viewedSubscribePopUpOnPtl(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Subscribe Pop-Up on Ptl", Object.keys(properties), [
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "XnyMsOLC7A", "5597ec99c958be0fcc1b72d438e785301e93abfff4b5c5d909be779368858155", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Subscribe Pop-Up on Ptl", {
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("XnyMsOLC7A", "Viewed Subscribe Pop-Up on Ptl", messages, [
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Subscribe Pop-Up on Ptl': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Subscribe Pop-Up on Ptl", {
          "Screen Height": sysScreenHeight,
          }, "XnyMsOLC7A", "5597ec99c958be0fcc1b72d438e785301e93abfff4b5c5d909be779368858155");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Subscribe Pop-Up on Ptl", {
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Onboarding Step Completion Animation: This event will be fired when the step completion animation will play within the onboarding widget. 
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.onboardingWidgetStepName - This will capture the corresponding step name for which the animation gets completed. FOr example, 'Add Students', 'Explore Splashlearn Content'
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/zZLiNhOaS5}
   */
  function viewedOnboardingStepCompletionAnimation(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOnboardingWidgetStepName(properties.onboardingWidgetStepName));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Onboarding Step Completion Animation", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "onboardingWidgetStepName"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "zZLiNhOaS5", "14b1e562ee9a306a173dd73c30e077d688d5f9619c7559737072a15305da1d93", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Onboarding Step Completion Animation", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Onboarding Widget Step Name": properties.onboardingWidgetStepName,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("zZLiNhOaS5", "Viewed Onboarding Step Completion Animation", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "FyfKKmNk3", name: "Onboarding Widget Step Name", value: properties.onboardingWidgetStepName},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Onboarding Step Completion Animation': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Onboarding Step Completion Animation", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Onboarding Widget Step Name": properties.onboardingWidgetStepName,
          "Screen Height": sysScreenHeight,
          }, "zZLiNhOaS5", "14b1e562ee9a306a173dd73c30e077d688d5f9619c7559737072a15305da1d93");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Onboarding Step Completion Animation", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Onboarding Widget Step Name": properties.onboardingWidgetStepName,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Teacher Dashboard: This event will be fired when the user visits the Teacher Dashboard
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.section - This will capture the widget name that is being viewed/interacted by the user in that viewport. For example, 'Onboarding Widget', 'Home Access Widget', 'Assignment Widget', 'Assessment Widget', 'Math Fact Widget'
The list will only have 1 value for 'Section' property for Interacted event.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/5IeHSXbuvb}
   */
  function viewedTeacherDashboard(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertSection(properties.section));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Teacher Dashboard", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "section"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "5IeHSXbuvb", "fa6bbd28b561ba8fb2dee44156c0792c5609f947ba071e2026c393fda2bd42d8", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Teacher Dashboard", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Section": properties.section,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("5IeHSXbuvb", "Viewed Teacher Dashboard", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "my9qL7M8w6", name: "Section", value: properties.section},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Teacher Dashboard': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Teacher Dashboard", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Section": properties.section,
          "Screen Height": sysScreenHeight,
          }, "5IeHSXbuvb", "fa6bbd28b561ba8fb2dee44156c0792c5609f947ba071e2026c393fda2bd42d8");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Teacher Dashboard", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Section": properties.section,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Teacher Dashboard: This event will be fired when the user clicks anywhere within any section on the Teacher's Dashboard
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.section - This will capture the widget name that is being viewed/interacted by the user in that viewport. For example, 'Onboarding Widget', 'Home Access Widget', 'Assignment Widget', 'Assessment Widget', 'Math Fact Widget'
The list will only have 1 value for 'Section' property for Interacted event.
   * @param {string} properties.hoveredOver - This will fire as soon as the user hovers over the status numbers in the assignment cards.
The values captured will be 'Yet to Start', 'In Progress', 'Completed'
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {int} properties.daysSinceClassCreation - Self explanatory
   * @param {string} properties.pageName - Includes the name of the page (Eg: Playzone game listing page, ). This is not the URL but a easily understandable definition of what page is the user at.
   * @param {string} [properties.valueName] - This will capture the value/text of the field that is selected.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/T6OimMcyg_}
   */
  function interactedTeacherDashboard(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertSection(properties.section));
      messages = messages.concat(assertHoveredOver(properties.hoveredOver));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertDaysSinceClassCreation(properties.daysSinceClassCreation));
      messages = messages.concat(assertPageName(properties.pageName));
      messages = messages.concat(assertOptionalValueName(properties.valueName));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Teacher Dashboard", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "section",
        "hoveredOver",
        "clickedOn",
        "daysSinceClassCreation",
        "pageName",
        "valueName"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "T6OimMcyg_", "2a1dced18122ce65cf6175d09dbef954457494c78c3acc52d0597723f08455f3", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Teacher Dashboard", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Section": properties.section,
        "Hovered Over": properties.hoveredOver,
        "Clicked On": properties.clickedOn,
        "Days Since Class Creation": properties.daysSinceClassCreation,
        "Page Name": properties.pageName,
        "Value Name": properties.valueName,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("T6OimMcyg_", "Interacted Teacher Dashboard", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "7wbK1QRC0", name: "Hovered Over", value: properties.hoveredOver},
        {id: "MJKSzmqfHu", name: "Page Name", value: properties.pageName},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "TuspgTIuZ1", name: "Days Since Class Creation", value: properties.daysSinceClassCreation},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "l-8JNUE0q", name: "Value Name", value: properties.valueName},
        {id: "my9qL7M8w6", name: "Section", value: properties.section},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Teacher Dashboard': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Teacher Dashboard", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Section": properties.section,
          "Hovered Over": properties.hoveredOver,
          "Clicked On": properties.clickedOn,
          "Days Since Class Creation": properties.daysSinceClassCreation,
          "Page Name": properties.pageName,
          "Value Name": properties.valueName,
          "Screen Height": sysScreenHeight,
          }, "T6OimMcyg_", "2a1dced18122ce65cf6175d09dbef954457494c78c3acc52d0597723f08455f3");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Teacher Dashboard", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Section": properties.section,
      "Hovered Over": properties.hoveredOver,
      "Clicked On": properties.clickedOn,
      "Days Since Class Creation": properties.daysSinceClassCreation,
      "Page Name": properties.pageName,
      "Value Name": properties.valueName,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Auto-Enrolled for SpringBoard: This event is fired when the class is auto-enrolled for the springboard. 
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {int} properties.classSize - Total students in the class at the time this event was triggered.
   * @param {string} properties.className - The name of the class that is kept by the teacher. 
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Ck7guxdUU9}
   */
  function autoEnrolledForSpringboard(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertClassSize(properties.classSize));
      messages = messages.concat(assertClassName(properties.className));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Auto-Enrolled for SpringBoard", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "classSize",
        "className"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Ck7guxdUU9", "8a53c4659230823d6791209eb3f6a8551bc72f236fa32f2f8a22c036d5dc533e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Auto-Enrolled for SpringBoard", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Class Size": properties.classSize,
        "Class Name": properties.className,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Ck7guxdUU9", "Auto-Enrolled for SpringBoard", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "9dTrjsxjG", name: "Class Name", value: properties.className},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "erbI-IRpim", name: "Class Size", value: properties.classSize},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Auto-Enrolled for SpringBoard': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Auto-Enrolled for SpringBoard", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Class Size": properties.classSize,
          "Class Name": properties.className,
          "Screen Height": sysScreenHeight,
          }, "Ck7guxdUU9", "8a53c4659230823d6791209eb3f6a8551bc72f236fa32f2f8a22c036d5dc533e");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Auto-Enrolled for SpringBoard", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Class Size": properties.classSize,
      "Class Name": properties.className,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Springboard New Intro: Viewed the springboard new introduction pop-up that we are making similar to the Math Facts.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {int} properties.classSize - Total students in the class at the time this event was triggered.
   * @param {string} properties.className - The name of the class that is kept by the teacher. 
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/qdV3BirFh0}
   */
  function viewedSpringboardNewIntro(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertClassSize(properties.classSize));
      messages = messages.concat(assertClassName(properties.className));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Springboard New Intro", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "classSize",
        "className"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "qdV3BirFh0", "cf8d7c57f4d7b14d74be0123345897d1cec0a993c096807a343bf64581bc1923", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Springboard New Intro", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Class Size": properties.classSize,
        "Class Name": properties.className,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("qdV3BirFh0", "Viewed Springboard New Intro", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "9dTrjsxjG", name: "Class Name", value: properties.className},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "erbI-IRpim", name: "Class Size", value: properties.classSize},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Springboard New Intro': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Springboard New Intro", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Class Size": properties.classSize,
          "Class Name": properties.className,
          "Screen Height": sysScreenHeight,
          }, "qdV3BirFh0", "cf8d7c57f4d7b14d74be0123345897d1cec0a993c096807a343bf64581bc1923");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Springboard New Intro", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Class Size": properties.classSize,
      "Class Name": properties.className,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Springboard New Intro: When the user interacts with the new Springboard intro , this events needs to be fired for every interaction.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/V87v2nKqbJ}
   */
  function interactedSpringboardNewIntro(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Springboard New Intro", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "V87v2nKqbJ", "520fceffcc04e6ed167cfdc539f3b90c1f93e0a6c1c43c31e4d4a53342e6f62b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Springboard New Intro", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("V87v2nKqbJ", "Interacted Springboard New Intro", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Springboard New Intro': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Springboard New Intro", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "V87v2nKqbJ", "520fceffcc04e6ed167cfdc539f3b90c1f93e0a6c1c43c31e4d4a53342e6f62b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Springboard New Intro", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Springboard Tab: When the user views the springboard landing page, this event needs to be fired.
   * 
   * When to trigger this event:
   * 1. When the user views the springboard landing page, this event needs to be fired.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/aH0cJ47tMK/trigger/8kEzeH6QW
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {int} properties.timesViewed - The number of times the page has been viewed by the user at the time of this event being fired
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/aH0cJ47tMK}
   */
  function viewedSpringboardTab(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertTimesViewed(properties.timesViewed));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Springboard Tab", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "from",
        "timesViewed"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "aH0cJ47tMK", "485ff53be099b759ed1bd1959e8120dd70e7f693d73f943834d3d53caf346c2d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Springboard Tab", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "From": properties.from,
        "Times Viewed": properties.timesViewed,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("aH0cJ47tMK", "Viewed Springboard Tab", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "55lAHL7kM", name: "Times Viewed", value: properties.timesViewed},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Springboard Tab': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Springboard Tab", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "From": properties.from,
          "Times Viewed": properties.timesViewed,
          "Screen Height": sysScreenHeight,
          }, "aH0cJ47tMK", "485ff53be099b759ed1bd1959e8120dd70e7f693d73f943834d3d53caf346c2d");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Springboard Tab", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "From": properties.from,
      "Times Viewed": properties.timesViewed,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Springboard Tab: When the user interacted the Springboard landing page and clicks on anything the same needs to be registered via sending this event.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {int} properties.classSize - Total students in the class at the time this event was triggered.
   * @param {string} properties.className - The name of the class that is kept by the teacher. 
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/2H79WEYOwO}
   */
  function interactedSpringboardTab(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertClassSize(properties.classSize));
      messages = messages.concat(assertClassName(properties.className));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Springboard Tab", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "classSize",
        "className",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "2H79WEYOwO", "7b6bc36b6eee747cf469582e7b310a78e332aabe93d6bbaeb4b2e471651a9a45", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Springboard Tab", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Class Size": properties.classSize,
        "Class Name": properties.className,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("2H79WEYOwO", "Interacted Springboard Tab", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "9dTrjsxjG", name: "Class Name", value: properties.className},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "erbI-IRpim", name: "Class Size", value: properties.classSize},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Springboard Tab': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Springboard Tab", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Class Size": properties.classSize,
          "Class Name": properties.className,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "2H79WEYOwO", "7b6bc36b6eee747cf469582e7b310a78e332aabe93d6bbaeb4b2e471651a9a45");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Springboard Tab", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Class Size": properties.classSize,
      "Class Name": properties.className,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Classroom Settings Page: When the user clicks on to unenroll or enroll in the class settings page.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.className - The name of the class that is kept by the teacher. 
   * @param {int} properties.classSize - Total students in the class at the time this event was triggered.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/rH7996zpF}
   */
  function interactedClassroomSettingsPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertClassName(properties.className));
      messages = messages.concat(assertClassSize(properties.classSize));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Classroom Settings Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "className",
        "classSize",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "rH7996zpF", "a46337082cf604774acf786b4b004b8526136539e06205a3140942daee997545", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Classroom Settings Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Class Name": properties.className,
        "Class Size": properties.classSize,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("rH7996zpF", "Interacted Classroom Settings Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "9dTrjsxjG", name: "Class Name", value: properties.className},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "erbI-IRpim", name: "Class Size", value: properties.classSize},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Classroom Settings Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Classroom Settings Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Class Name": properties.className,
          "Class Size": properties.classSize,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "rH7996zpF", "a46337082cf604774acf786b4b004b8526136539e06205a3140942daee997545");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Classroom Settings Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Class Name": properties.className,
      "Class Size": properties.classSize,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Urgency Discount Popup: When the user views the Urgency Discount Popup, this event is fired. 
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/obEYOIabsO}
   */
  function viewedUrgencyDiscountPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Urgency Discount Popup", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "obEYOIabsO", "be9b05e9277bcd11afe9d14e87c9d21e0cf2369233a115d509be75b44c1df958", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Urgency Discount Popup", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("obEYOIabsO", "Viewed Urgency Discount Popup", messages, [
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Urgency Discount Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Urgency Discount Popup", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "obEYOIabsO", "be9b05e9277bcd11afe9d14e87c9d21e0cf2369233a115d509be75b44c1df958");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Urgency Discount Popup", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Urgency Discount Popup: When the user interacts the urgency discount pop-up, this event needs to  be fired. 
   * 
   * When to trigger this event:
   * 1. interacts the urgency discount pop-up
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/lugSmSK6IV/trigger/4dtsxJAs1
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/lugSmSK6IV}
   */
  function interactedUrgencyDiscountPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Urgency Discount Popup", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "lugSmSK6IV", "0ed616c2cd83571583d752894e74fe687934d9adcd0f571a0cdcead25323a186", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Urgency Discount Popup", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("lugSmSK6IV", "Interacted Urgency Discount Popup", messages, [
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Urgency Discount Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Urgency Discount Popup", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "lugSmSK6IV", "0ed616c2cd83571583d752894e74fe687934d9adcd0f571a0cdcead25323a186");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Urgency Discount Popup", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Unlock Content: When the user interacts the unlock content CTA, this event is fired.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.discountPitch] - This property highlights if we are offering any discount at the time of user doing that event - Eg: 'Viewed Tiled Dashboard' , 'clicking the CTA - Unlock Content'
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/rjDd6qtve8}
   */
  function interactedUnlockContent(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalDiscountPitch(properties.discountPitch));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Unlock Content", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "discountPitch"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "rjDd6qtve8", "6040cde06cb0ffd88768f5fc002172cb28f7b1b31fce43238f3cb4c86edc11f6", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Unlock Content", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Discount Pitch": properties.discountPitch,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("rjDd6qtve8", "Interacted Unlock Content", messages, [
        {id: "-tPNSAQK6", name: "Discount Pitch", value: properties.discountPitch},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Unlock Content': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Unlock Content", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Discount Pitch": properties.discountPitch,
          "Screen Height": sysScreenHeight,
          }, "rjDd6qtve8", "6040cde06cb0ffd88768f5fc002172cb28f7b1b31fce43238f3cb4c86edc11f6");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Unlock Content", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Discount Pitch": properties.discountPitch,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Visited Certificate Tab Springboard: This event is fired when the teacher visits the certificate tab of the springboard.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/c84jsTeM80}
   */
  function visitedCertificateTabSpringboard(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Visited Certificate Tab Springboard", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "c84jsTeM80", "70bceaf2defc0c400ef717a1885d711c1ec2089bb3e3de412feaac9f6d76f724", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Visited Certificate Tab Springboard", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("c84jsTeM80", "Visited Certificate Tab Springboard", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Visited Certificate Tab Springboard': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Visited Certificate Tab Springboard", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "c84jsTeM80", "70bceaf2defc0c400ef717a1885d711c1ec2089bb3e3de412feaac9f6d76f724");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Visited Certificate Tab Springboard", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Certificates Page Springboard: This event is fired when the user interacts within the Certificates page of the Springboard.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/HOSLfZP43u}
   */
  function interactedCertificatesPageSpringboard(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Certificates Page Springboard", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "HOSLfZP43u", "0dd0214cbe29fa51b4ef100c026ead511b07655ce38648626c46780dda75cce5", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Certificates Page Springboard", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("HOSLfZP43u", "Interacted Certificates Page Springboard", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Certificates Page Springboard': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Certificates Page Springboard", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "HOSLfZP43u", "0dd0214cbe29fa51b4ef100c026ead511b07655ce38648626c46780dda75cce5");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Certificates Page Springboard", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Certificate: When the teacher views any certificate - this event is fired.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.certificateName - This is the name of the certificate.
   * @param {string} properties.certificateType - the type of the certificate that is viewed
- Springboard Class Certificate 
- Springboard Teacher Certificate
- Springboard Student Cetificate
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/hcXBOD9d15}
   */
  function viewedCertificate(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertCertificateName(properties.certificateName));
      messages = messages.concat(assertCertificateType(properties.certificateType));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Certificate", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "certificateName",
        "certificateType"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "hcXBOD9d15", "3d3062e83a5f231296ad40d681d7c44bec2ba5b8e9b45cdafb066b1c5f4a5d55", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Certificate", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Certificate Name": properties.certificateName,
        "Certificate Type": properties.certificateType,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("hcXBOD9d15", "Viewed Certificate", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "MfWi2aBDZ", name: "Certificate Name", value: properties.certificateName},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "T1COE_Of2", name: "Certificate Type", value: properties.certificateType},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Certificate': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Certificate", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Certificate Name": properties.certificateName,
          "Certificate Type": properties.certificateType,
          "Screen Height": sysScreenHeight,
          }, "hcXBOD9d15", "3d3062e83a5f231296ad40d681d7c44bec2ba5b8e9b45cdafb066b1c5f4a5d55");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Certificate", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Certificate Name": properties.certificateName,
      "Certificate Type": properties.certificateType,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Downloaded Certificate: When the teacher downloads any certificate. This event is fired. 
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.certificateName - This is the name of the certificate.
   * @param {string} properties.certificateType - the type of the certificate that is viewed
- Springboard Class Certificate 
- Springboard Teacher Certificate
- Springboard Student Cetificate
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/UkW63JSZCX}
   */
  function downloadedCertificate(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertCertificateName(properties.certificateName));
      messages = messages.concat(assertCertificateType(properties.certificateType));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Downloaded Certificate", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "certificateName",
        "certificateType"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "UkW63JSZCX", "47de08f790abefb38f2db83228ae5f2fe2516ebed400ab2a61ac1d8dcee2c6f9", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Downloaded Certificate", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Certificate Name": properties.certificateName,
        "Certificate Type": properties.certificateType,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("UkW63JSZCX", "Downloaded Certificate", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "MfWi2aBDZ", name: "Certificate Name", value: properties.certificateName},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "T1COE_Of2", name: "Certificate Type", value: properties.certificateType},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Downloaded Certificate': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Downloaded Certificate", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Certificate Name": properties.certificateName,
          "Certificate Type": properties.certificateType,
          "Screen Height": sysScreenHeight,
          }, "UkW63JSZCX", "47de08f790abefb38f2db83228ae5f2fe2516ebed400ab2a61ac1d8dcee2c6f9");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Downloaded Certificate", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Certificate Name": properties.certificateName,
      "Certificate Type": properties.certificateType,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Introducing Certificates Popup: This event is fired when the teacher views the introductory certificates popup.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/lsKrD9qG5r}
   */
  function viewedIntroducingCertificatesPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Introducing Certificates Popup", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "lsKrD9qG5r", "71e3aa10e715cf4dc4acd96813a5692c58028bef78935f585c60b4ff7009d4a6", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Introducing Certificates Popup", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("lsKrD9qG5r", "Viewed Introducing Certificates Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Introducing Certificates Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Introducing Certificates Popup", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "lsKrD9qG5r", "71e3aa10e715cf4dc4acd96813a5692c58028bef78935f585c60b4ff7009d4a6");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Introducing Certificates Popup", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Introductory Certificates Popup: When the user clicks on the CTA of the Introductory Certificates Popup
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/wTMIYRvIwn}
   */
  function interactedIntroductoryCertificatesPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Introductory Certificates Popup", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "wTMIYRvIwn", "b62e3574a37447fc32b66d65fa7f0749f82827a6d002046e8496b4dd95874a60", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Introductory Certificates Popup", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("wTMIYRvIwn", "Interacted Introductory Certificates Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Introductory Certificates Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Introductory Certificates Popup", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "wTMIYRvIwn", "b62e3574a37447fc32b66d65fa7f0749f82827a6d002046e8496b4dd95874a60");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Introductory Certificates Popup", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Weekly Highlights Popup: When the teacher views the weekly highlights popup. This event is fired.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.springboardWeek - Springboard Week - Springboard is a 10 week big competition. This event property highlights which week of the Springboard. Values will be Week1, Week2, Week3, Week4 so on and so forth till Week10. 
   * @param {string} properties.certificatesEarned - This highlights the number of certificated earned. If no certificate is earned, the value is 0. Else the value is equivalent of the number of certificated earned.
   * @param {string} properties.springboardRank - This highlights whether the springboard rank increased, decreased or remained same when this event got fired compared to last week. 
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Y0b_FoYW5d}
   */
  function viewedWeeklyHighlightsPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertSpringboardWeek(properties.springboardWeek));
      messages = messages.concat(assertCertificatesEarned(properties.certificatesEarned));
      messages = messages.concat(assertSpringboardRank(properties.springboardRank));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Weekly Highlights Popup", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "springboardWeek",
        "certificatesEarned",
        "springboardRank"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Y0b_FoYW5d", "84b20ca8c59e295382c6feb62a736967806c9baff6c0ef9b0e7cd662813b56c8", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Weekly Highlights Popup", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Springboard Week": properties.springboardWeek,
        "Certificates Earned": properties.certificatesEarned,
        "Springboard Rank": properties.springboardRank,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Y0b_FoYW5d", "Viewed Weekly Highlights Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "4DPFLSCCa", name: "Certificates Earned", value: properties.certificatesEarned},
        {id: "PpLUQoMje", name: "Springboard Rank", value: properties.springboardRank},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "wZVJV2Yc5", name: "Springboard Week", value: properties.springboardWeek},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Weekly Highlights Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Weekly Highlights Popup", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Springboard Week": properties.springboardWeek,
          "Certificates Earned": properties.certificatesEarned,
          "Springboard Rank": properties.springboardRank,
          "Screen Height": sysScreenHeight,
          }, "Y0b_FoYW5d", "84b20ca8c59e295382c6feb62a736967806c9baff6c0ef9b0e7cd662813b56c8");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Weekly Highlights Popup", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Springboard Week": properties.springboardWeek,
      "Certificates Earned": properties.certificatesEarned,
      "Springboard Rank": properties.springboardRank,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Weekly Highlights Popup: When the user clicks on the weekly highlights popup, this event is fired.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ljG6Zgle_B}
   */
  function interactedWeeklyHighlightsPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Weekly Highlights Popup", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ljG6Zgle_B", "241a5ef610abc72ffe6b62225e942d2323b61a038fcf9c130cf53045479b4212", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Weekly Highlights Popup", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ljG6Zgle_B", "Interacted Weekly Highlights Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Weekly Highlights Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Weekly Highlights Popup", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "ljG6Zgle_B", "241a5ef610abc72ffe6b62225e942d2323b61a038fcf9c130cf53045479b4212");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Weekly Highlights Popup", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Tutor Lobby: Triggered when the teacher visits tutor lobby screen
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.quizName - no description
   * @param {string} properties.quizSubject - no description
   * @param {string} properties.tutorName - no description
   * @param {string} properties.quizGrade - no description
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   * @param {string} properties.sessionIdentifier - Unique Splashliv class session for user
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/EUyUckkAzl}
   */
  function viewedTutorLobby(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertQuizName(properties.quizName));
      messages = messages.concat(assertQuizSubject(properties.quizSubject));
      messages = messages.concat(assertTutorName(properties.tutorName));
      messages = messages.concat(assertQuizGrade(properties.quizGrade));
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertSessionIdentifier(properties.sessionIdentifier));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Tutor Lobby", Object.keys(properties), [
        "quizName",
        "quizSubject",
        "tutorName",
        "quizGrade",
        "quizCode",
        "quizMeetingSlug",
        "quizLiveClassId",
        "sessionIdentifier"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "EUyUckkAzl", "fd8bc574f2b18345a53aa2b8e6770252e5963517c6a08045df17b39fd65f1f8b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Tutor Lobby", {
        "Quiz Name": properties.quizName,
        "Quiz Subject": properties.quizSubject,
        "Tutor Name": properties.tutorName,
        "Quiz Grade": properties.quizGrade,
        "Quiz Code": properties.quizCode,
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "session_identifier": properties.sessionIdentifier,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("EUyUckkAzl", "Viewed Tutor Lobby", messages, [
        {id: "4uNrPBulmW", name: "session_identifier", value: properties.sessionIdentifier},
        {id: "El8KEuVMR", name: "Quiz Subject", value: properties.quizSubject},
        {id: "NS3VU6-SM", name: "Tutor Name", value: properties.tutorName},
        {id: "OdOreTGEK", name: "Quiz Grade", value: properties.quizGrade},
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "w5nsMhHyb", name: "Quiz Name", value: properties.quizName},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Tutor Lobby': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Tutor Lobby", {
          "Quiz Name": properties.quizName,
          "Quiz Subject": properties.quizSubject,
          "Tutor Name": properties.tutorName,
          "Quiz Grade": properties.quizGrade,
          "Quiz Code": properties.quizCode,
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "session_identifier": properties.sessionIdentifier,
          "Screen Height": sysScreenHeight,
          }, "EUyUckkAzl", "fd8bc574f2b18345a53aa2b8e6770252e5963517c6a08045df17b39fd65f1f8b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Tutor Lobby", {
      "Quiz Name": properties.quizName,
      "Quiz Subject": properties.quizSubject,
      "Tutor Name": properties.tutorName,
      "Quiz Grade": properties.quizGrade,
      "Quiz Code": properties.quizCode,
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "session_identifier": properties.sessionIdentifier,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Tutor Lobby: Triggered when the tutor lobby screen is interacted
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   * @param {string} properties.sessionIdentifier - Unique Splashliv class session for user
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/qKnjLecBEi}
   */
  function interactedTutorLobby(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertSessionIdentifier(properties.sessionIdentifier));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Tutor Lobby", Object.keys(properties), [
        "clickedOn",
        "quizCode",
        "quizMeetingSlug",
        "quizLiveClassId",
        "sessionIdentifier"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "qKnjLecBEi", "e72306043ed6f3e83f03e0341d357831d5759b1a56e59589616d8063e41cb054", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Tutor Lobby", {
        "Clicked On": properties.clickedOn,
        "Quiz Code": properties.quizCode,
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "session_identifier": properties.sessionIdentifier,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("qKnjLecBEi", "Interacted Tutor Lobby", messages, [
        {id: "4uNrPBulmW", name: "session_identifier", value: properties.sessionIdentifier},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Tutor Lobby': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Tutor Lobby", {
          "Clicked On": properties.clickedOn,
          "Quiz Code": properties.quizCode,
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "session_identifier": properties.sessionIdentifier,
          "Screen Height": sysScreenHeight,
          }, "qKnjLecBEi", "e72306043ed6f3e83f03e0341d357831d5759b1a56e59589616d8063e41cb054");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Tutor Lobby", {
      "Clicked On": properties.clickedOn,
      "Quiz Code": properties.quizCode,
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "session_identifier": properties.sessionIdentifier,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Class Quiz Started: Triggered when the quiz is started for everyone
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.quizName - no description
   * @param {string} properties.quizGrade - no description
   * @param {string} properties.quizSubject - no description
   * @param {string} properties.tutorName - no description
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   * @param {string} properties.sessionIdentifier - Unique Splashliv class session for user
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Cm2wspxNTM}
   */
  function classQuizStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertQuizName(properties.quizName));
      messages = messages.concat(assertQuizGrade(properties.quizGrade));
      messages = messages.concat(assertQuizSubject(properties.quizSubject));
      messages = messages.concat(assertTutorName(properties.tutorName));
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertSessionIdentifier(properties.sessionIdentifier));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Class Quiz Started", Object.keys(properties), [
        "quizName",
        "quizGrade",
        "quizSubject",
        "tutorName",
        "quizCode",
        "quizMeetingSlug",
        "quizLiveClassId",
        "sessionIdentifier"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Cm2wspxNTM", "783b3b3339d3275bb1ac1982f37798f9da938c51e7ab9bcfddff4f748e86a371", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Class Quiz Started", {
        "Quiz Name": properties.quizName,
        "Quiz Grade": properties.quizGrade,
        "Quiz Subject": properties.quizSubject,
        "Tutor Name": properties.tutorName,
        "Quiz Code": properties.quizCode,
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "session_identifier": properties.sessionIdentifier,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Cm2wspxNTM", "Class Quiz Started", messages, [
        {id: "4uNrPBulmW", name: "session_identifier", value: properties.sessionIdentifier},
        {id: "El8KEuVMR", name: "Quiz Subject", value: properties.quizSubject},
        {id: "NS3VU6-SM", name: "Tutor Name", value: properties.tutorName},
        {id: "OdOreTGEK", name: "Quiz Grade", value: properties.quizGrade},
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "w5nsMhHyb", name: "Quiz Name", value: properties.quizName},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Class Quiz Started': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Class Quiz Started", {
          "Quiz Name": properties.quizName,
          "Quiz Grade": properties.quizGrade,
          "Quiz Subject": properties.quizSubject,
          "Tutor Name": properties.tutorName,
          "Quiz Code": properties.quizCode,
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "session_identifier": properties.sessionIdentifier,
          "Screen Height": sysScreenHeight,
          }, "Cm2wspxNTM", "783b3b3339d3275bb1ac1982f37798f9da938c51e7ab9bcfddff4f748e86a371");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Class Quiz Started", {
      "Quiz Name": properties.quizName,
      "Quiz Grade": properties.quizGrade,
      "Quiz Subject": properties.quizSubject,
      "Tutor Name": properties.tutorName,
      "Quiz Code": properties.quizCode,
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "session_identifier": properties.sessionIdentifier,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Class Quiz Ended: Triggered when the class quiz is ended for everyone
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   * @param {int} properties.questionNumber - This will capture Question Serial Number.
   * @param {string} properties.sessionIdentifier - Unique Splashliv class session for user
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/KCKh1qFsSM}
   */
  function classQuizEnded(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertQuestionNumber(properties.questionNumber));
      messages = messages.concat(assertSessionIdentifier(properties.sessionIdentifier));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Class Quiz Ended", Object.keys(properties), [
        "from",
        "quizCode",
        "quizMeetingSlug",
        "quizLiveClassId",
        "questionNumber",
        "sessionIdentifier"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "KCKh1qFsSM", "bc57a30fcabe5f2374672ea8ac51fb63ab021eb17a7f5783250949dafb2bcdc3", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Class Quiz Ended", {
        "From": properties.from,
        "Quiz Code": properties.quizCode,
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "Question Number": properties.questionNumber,
        "session_identifier": properties.sessionIdentifier,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("KCKh1qFsSM", "Class Quiz Ended", messages, [
        {id: "4uNrPBulmW", name: "session_identifier", value: properties.sessionIdentifier},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "_cuCZnBI_", name: "Question Number", value: properties.questionNumber},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Class Quiz Ended': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Class Quiz Ended", {
          "From": properties.from,
          "Quiz Code": properties.quizCode,
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "Question Number": properties.questionNumber,
          "session_identifier": properties.sessionIdentifier,
          "Screen Height": sysScreenHeight,
          }, "KCKh1qFsSM", "bc57a30fcabe5f2374672ea8ac51fb63ab021eb17a7f5783250949dafb2bcdc3");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Class Quiz Ended", {
      "From": properties.from,
      "Quiz Code": properties.quizCode,
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "Question Number": properties.questionNumber,
      "session_identifier": properties.sessionIdentifier,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Tutor In Quiz Screen: Triggered when the tutor views in quiz screen
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   * @param {string} properties.sessionIdentifier - Unique Splashliv class session for user
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/k180znTnrv}
   */
  function viewedTutorInQuizScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertSessionIdentifier(properties.sessionIdentifier));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Tutor In Quiz Screen", Object.keys(properties), [
        "quizCode",
        "quizMeetingSlug",
        "quizLiveClassId",
        "sessionIdentifier"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "k180znTnrv", "a6d2417c9770b01593535f63a02ca872289fbdbd805d47cf0a0607c9b6f2720c", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Tutor In Quiz Screen", {
        "Quiz Code": properties.quizCode,
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "session_identifier": properties.sessionIdentifier,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("k180znTnrv", "Viewed Tutor In Quiz Screen", messages, [
        {id: "4uNrPBulmW", name: "session_identifier", value: properties.sessionIdentifier},
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Tutor In Quiz Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Tutor In Quiz Screen", {
          "Quiz Code": properties.quizCode,
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "session_identifier": properties.sessionIdentifier,
          "Screen Height": sysScreenHeight,
          }, "k180znTnrv", "a6d2417c9770b01593535f63a02ca872289fbdbd805d47cf0a0607c9b6f2720c");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Tutor In Quiz Screen", {
      "Quiz Code": properties.quizCode,
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "session_identifier": properties.sessionIdentifier,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Tutor in Quiz Screen: Interacted on the in quiz screens
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   * @param {string} properties.questionCode - This will capture unique question code.
   * @param {int} properties.questionNumber - This will capture Question Serial Number.
   * @param {int} [properties.roundNumber] - Store round info for Mashup Quiz 
   * @param {string} properties.sessionIdentifier - Unique Splashliv class session for user
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/IvWGaK-szK}
   */
  function interactedTutorInQuizScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertQuestionCode(properties.questionCode));
      messages = messages.concat(assertQuestionNumber(properties.questionNumber));
      messages = messages.concat(assertOptionalRoundNumber(properties.roundNumber));
      messages = messages.concat(assertSessionIdentifier(properties.sessionIdentifier));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Tutor in Quiz Screen", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "clickedOn",
        "quizCode",
        "quizMeetingSlug",
        "quizLiveClassId",
        "questionCode",
        "questionNumber",
        "roundNumber",
        "sessionIdentifier"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "IvWGaK-szK", "f4fb58cfcd6cf3fd849b972c5c2a981e58b077796b9156f1986954e3c9ce2828", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Tutor in Quiz Screen", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Clicked On": properties.clickedOn,
        "Quiz Code": properties.quizCode,
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "Question Code": properties.questionCode,
        "Question Number": properties.questionNumber,
        "Round Number": properties.roundNumber,
        "session_identifier": properties.sessionIdentifier,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("IvWGaK-szK", "Interacted Tutor in Quiz Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "4uNrPBulmW", name: "session_identifier", value: properties.sessionIdentifier},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "_cuCZnBI_", name: "Question Number", value: properties.questionNumber},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "bZZvnMF1m", name: "Question Code", value: properties.questionCode},
        {id: "jw_xpal_L1", name: "Round Number", value: properties.roundNumber},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Tutor in Quiz Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Tutor in Quiz Screen", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Clicked On": properties.clickedOn,
          "Quiz Code": properties.quizCode,
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "Question Code": properties.questionCode,
          "Question Number": properties.questionNumber,
          "Round Number": properties.roundNumber,
          "session_identifier": properties.sessionIdentifier,
          "Screen Height": sysScreenHeight,
          }, "IvWGaK-szK", "f4fb58cfcd6cf3fd849b972c5c2a981e58b077796b9156f1986954e3c9ce2828");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Tutor in Quiz Screen", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Clicked On": properties.clickedOn,
      "Quiz Code": properties.quizCode,
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "Question Code": properties.questionCode,
      "Question Number": properties.questionNumber,
      "Round Number": properties.roundNumber,
      "session_identifier": properties.sessionIdentifier,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Next Question Warning Viewed: Triggered when the next question warning screen is viewed
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   * @param {string} properties.sessionIdentifier - Unique Splashliv class session for user
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/UtLlcmbSTL}
   */
  function nextQuestionWarningViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertSessionIdentifier(properties.sessionIdentifier));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Next Question Warning Viewed", Object.keys(properties), [
        "quizCode",
        "quizMeetingSlug",
        "quizLiveClassId",
        "sessionIdentifier"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "UtLlcmbSTL", "90622aed849ac065712eb6cd1ed951b8e89ab8a18e0b9c3847730efc911db02b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Next Question Warning Viewed", {
        "Quiz Code": properties.quizCode,
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "session_identifier": properties.sessionIdentifier,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("UtLlcmbSTL", "Next Question Warning Viewed", messages, [
        {id: "4uNrPBulmW", name: "session_identifier", value: properties.sessionIdentifier},
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Next Question Warning Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Next Question Warning Viewed", {
          "Quiz Code": properties.quizCode,
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "session_identifier": properties.sessionIdentifier,
          "Screen Height": sysScreenHeight,
          }, "UtLlcmbSTL", "90622aed849ac065712eb6cd1ed951b8e89ab8a18e0b9c3847730efc911db02b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Next Question Warning Viewed", {
      "Quiz Code": properties.quizCode,
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "session_identifier": properties.sessionIdentifier,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Next Question Warning Interacted: Triggered when the next question warning is interacted
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   * @param {string} properties.sessionIdentifier - Unique Splashliv class session for user
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Yfkny84ZGa}
   */
  function nextQuestionWarningInteracted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertSessionIdentifier(properties.sessionIdentifier));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Next Question Warning Interacted", Object.keys(properties), [
        "clickedOn",
        "quizCode",
        "quizMeetingSlug",
        "quizLiveClassId",
        "sessionIdentifier"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Yfkny84ZGa", "1cdd41fa5c257f4f6a2a9ed13cab763f4be2e9f8e037fb320c180946a1b7ba9b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Next Question Warning Interacted", {
        "Clicked On": properties.clickedOn,
        "Quiz Code": properties.quizCode,
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "session_identifier": properties.sessionIdentifier,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Yfkny84ZGa", "Next Question Warning Interacted", messages, [
        {id: "4uNrPBulmW", name: "session_identifier", value: properties.sessionIdentifier},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Next Question Warning Interacted': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Next Question Warning Interacted", {
          "Clicked On": properties.clickedOn,
          "Quiz Code": properties.quizCode,
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "session_identifier": properties.sessionIdentifier,
          "Screen Height": sysScreenHeight,
          }, "Yfkny84ZGa", "1cdd41fa5c257f4f6a2a9ed13cab763f4be2e9f8e037fb320c180946a1b7ba9b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Next Question Warning Interacted", {
      "Clicked On": properties.clickedOn,
      "Quiz Code": properties.quizCode,
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "session_identifier": properties.sessionIdentifier,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Tutor Quiz Timer Run Out Popup: No description
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   * @param {string} properties.sessionIdentifier - Unique Splashliv class session for user
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/_GBaUOwTAh}
   */
  function viewedTutorQuizTimerRunOutPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertSessionIdentifier(properties.sessionIdentifier));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Tutor Quiz Timer Run Out Popup", Object.keys(properties), [
        "quizCode",
        "quizMeetingSlug",
        "quizLiveClassId",
        "sessionIdentifier"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "_GBaUOwTAh", "bef1984368872d462675cf1bfede8e14b724bcc8b81effc0e81187b6cd537dc1", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Tutor Quiz Timer Run Out Popup", {
        "Quiz Code": properties.quizCode,
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "session_identifier": properties.sessionIdentifier,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("_GBaUOwTAh", "Viewed Tutor Quiz Timer Run Out Popup", messages, [
        {id: "4uNrPBulmW", name: "session_identifier", value: properties.sessionIdentifier},
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Tutor Quiz Timer Run Out Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Tutor Quiz Timer Run Out Popup", {
          "Quiz Code": properties.quizCode,
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "session_identifier": properties.sessionIdentifier,
          "Screen Height": sysScreenHeight,
          }, "_GBaUOwTAh", "bef1984368872d462675cf1bfede8e14b724bcc8b81effc0e81187b6cd537dc1");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Tutor Quiz Timer Run Out Popup", {
      "Quiz Code": properties.quizCode,
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "session_identifier": properties.sessionIdentifier,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Tutor Final Leaderboard: No description
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   * @param {string} properties.sessionIdentifier - Unique Splashliv class session for user
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/cnkDqUAqod}
   */
  function viewedTutorFinalLeaderboard(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertSessionIdentifier(properties.sessionIdentifier));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Tutor Final Leaderboard", Object.keys(properties), [
        "quizCode",
        "quizMeetingSlug",
        "quizLiveClassId",
        "sessionIdentifier"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "cnkDqUAqod", "9a57af5c43ddba26943b94431631c4dd741451a036ff5fee39495ce34b27e69c", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Tutor Final Leaderboard", {
        "Quiz Code": properties.quizCode,
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "session_identifier": properties.sessionIdentifier,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("cnkDqUAqod", "Viewed Tutor Final Leaderboard", messages, [
        {id: "4uNrPBulmW", name: "session_identifier", value: properties.sessionIdentifier},
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Tutor Final Leaderboard': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Tutor Final Leaderboard", {
          "Quiz Code": properties.quizCode,
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "session_identifier": properties.sessionIdentifier,
          "Screen Height": sysScreenHeight,
          }, "cnkDqUAqod", "9a57af5c43ddba26943b94431631c4dd741451a036ff5fee39495ce34b27e69c");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Tutor Final Leaderboard", {
      "Quiz Code": properties.quizCode,
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "session_identifier": properties.sessionIdentifier,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Student Lobby Screen: No description
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.quizName - no description
   * @param {string} properties.quizGrade - no description
   * @param {string} properties.quizSubject - no description
   * @param {string} properties.tutorName - no description
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   * @param {string} properties.sessionIdentifier - Unique Splashliv class session for user
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/9y5UviQI-P}
   */
  function viewedStudentLobbyScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertQuizName(properties.quizName));
      messages = messages.concat(assertQuizGrade(properties.quizGrade));
      messages = messages.concat(assertQuizSubject(properties.quizSubject));
      messages = messages.concat(assertTutorName(properties.tutorName));
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertSessionIdentifier(properties.sessionIdentifier));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Student Lobby Screen", Object.keys(properties), [
        "mathGrade",
        "mode",
        "quizName",
        "quizGrade",
        "quizSubject",
        "tutorName",
        "quizCode",
        "quizMeetingSlug",
        "quizLiveClassId",
        "sessionIdentifier"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "9y5UviQI-P", "37b9222b44cab31be5fd710bcf40782965c3feaf7b9eb98409a9eca92ccc9cf7", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Student Lobby Screen", {
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Quiz Name": properties.quizName,
        "Quiz Grade": properties.quizGrade,
        "Quiz Subject": properties.quizSubject,
        "Tutor Name": properties.tutorName,
        "Quiz Code": properties.quizCode,
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "session_identifier": properties.sessionIdentifier,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("9y5UviQI-P", "Viewed Student Lobby Screen", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "4uNrPBulmW", name: "session_identifier", value: properties.sessionIdentifier},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "El8KEuVMR", name: "Quiz Subject", value: properties.quizSubject},
        {id: "NS3VU6-SM", name: "Tutor Name", value: properties.tutorName},
        {id: "OdOreTGEK", name: "Quiz Grade", value: properties.quizGrade},
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "w5nsMhHyb", name: "Quiz Name", value: properties.quizName},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Student Lobby Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Student Lobby Screen", {
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Quiz Name": properties.quizName,
          "Quiz Grade": properties.quizGrade,
          "Quiz Subject": properties.quizSubject,
          "Tutor Name": properties.tutorName,
          "Quiz Code": properties.quizCode,
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "session_identifier": properties.sessionIdentifier,
          "Screen Height": sysScreenHeight,
          }, "9y5UviQI-P", "37b9222b44cab31be5fd710bcf40782965c3feaf7b9eb98409a9eca92ccc9cf7");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Student Lobby Screen", {
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Quiz Name": properties.quizName,
      "Quiz Grade": properties.quizGrade,
      "Quiz Subject": properties.quizSubject,
      "Tutor Name": properties.tutorName,
      "Quiz Code": properties.quizCode,
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "session_identifier": properties.sessionIdentifier,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Student In Quiz Screen: No description
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   * @param {string} properties.sessionIdentifier - Unique Splashliv class session for user
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/TiDRQb_Bdf}
   */
  function viewedStudentInQuizScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertSessionIdentifier(properties.sessionIdentifier));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Student In Quiz Screen", Object.keys(properties), [
        "quizCode",
        "quizMeetingSlug",
        "quizLiveClassId",
        "sessionIdentifier"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "TiDRQb_Bdf", "5c64a9017d9f63c422f447b5ead1cbcf0972a6a84bd2ad151df5a981817bd7c1", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Student In Quiz Screen", {
        "Quiz Code": properties.quizCode,
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "session_identifier": properties.sessionIdentifier,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("TiDRQb_Bdf", "Viewed Student In Quiz Screen", messages, [
        {id: "4uNrPBulmW", name: "session_identifier", value: properties.sessionIdentifier},
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Student In Quiz Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Student In Quiz Screen", {
          "Quiz Code": properties.quizCode,
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "session_identifier": properties.sessionIdentifier,
          "Screen Height": sysScreenHeight,
          }, "TiDRQb_Bdf", "5c64a9017d9f63c422f447b5ead1cbcf0972a6a84bd2ad151df5a981817bd7c1");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Student In Quiz Screen", {
      "Quiz Code": properties.quizCode,
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "session_identifier": properties.sessionIdentifier,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Student In Quiz Screen: No description
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   * @param {int} properties.questionNumber - This will capture Question Serial Number.
   * @param {string} properties.questionCode - This will capture unique question code.
   * @param {int} [properties.roundNumber] - Store round info for Mashup Quiz 
   * @param {string} properties.sessionIdentifier - Unique Splashliv class session for user
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/wwJlbRYOSh}
   */
  function interactedStudentInQuizScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertQuestionNumber(properties.questionNumber));
      messages = messages.concat(assertQuestionCode(properties.questionCode));
      messages = messages.concat(assertOptionalRoundNumber(properties.roundNumber));
      messages = messages.concat(assertSessionIdentifier(properties.sessionIdentifier));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Student In Quiz Screen", Object.keys(properties), [
        "clickedOn",
        "quizCode",
        "quizMeetingSlug",
        "quizLiveClassId",
        "questionNumber",
        "questionCode",
        "roundNumber",
        "sessionIdentifier"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "wwJlbRYOSh", "491617b08dca3a7547cbc3b205e55a154f117e9a50959af67a023b05e0e5213e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Student In Quiz Screen", {
        "Clicked On": properties.clickedOn,
        "Quiz Code": properties.quizCode,
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "Question Number": properties.questionNumber,
        "Question Code": properties.questionCode,
        "Round Number": properties.roundNumber,
        "session_identifier": properties.sessionIdentifier,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("wwJlbRYOSh", "Interacted Student In Quiz Screen", messages, [
        {id: "4uNrPBulmW", name: "session_identifier", value: properties.sessionIdentifier},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "_cuCZnBI_", name: "Question Number", value: properties.questionNumber},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "bZZvnMF1m", name: "Question Code", value: properties.questionCode},
        {id: "jw_xpal_L1", name: "Round Number", value: properties.roundNumber},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Student In Quiz Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Student In Quiz Screen", {
          "Clicked On": properties.clickedOn,
          "Quiz Code": properties.quizCode,
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "Question Number": properties.questionNumber,
          "Question Code": properties.questionCode,
          "Round Number": properties.roundNumber,
          "session_identifier": properties.sessionIdentifier,
          "Screen Height": sysScreenHeight,
          }, "wwJlbRYOSh", "491617b08dca3a7547cbc3b205e55a154f117e9a50959af67a023b05e0e5213e");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Student In Quiz Screen", {
      "Clicked On": properties.clickedOn,
      "Quiz Code": properties.quizCode,
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "Question Number": properties.questionNumber,
      "Question Code": properties.questionCode,
      "Round Number": properties.roundNumber,
      "session_identifier": properties.sessionIdentifier,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Student Pitstop Screen: No description
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   * @param {string} properties.questionCode - This will capture unique question code.
   * @param {int} properties.questionNumber - This will capture Question Serial Number.
   * @param {string} properties.sessionIdentifier - Unique Splashliv class session for user
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Ht-mV3vmhN}
   */
  function viewedStudentPitstopScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertQuestionCode(properties.questionCode));
      messages = messages.concat(assertQuestionNumber(properties.questionNumber));
      messages = messages.concat(assertSessionIdentifier(properties.sessionIdentifier));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Student Pitstop Screen", Object.keys(properties), [
        "quizCode",
        "quizMeetingSlug",
        "quizLiveClassId",
        "questionCode",
        "questionNumber",
        "sessionIdentifier"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Ht-mV3vmhN", "0e3cd134977758598d291562f568524c02bda2f45c63dd428b830ba2c46d1ed0", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Student Pitstop Screen", {
        "Quiz Code": properties.quizCode,
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "Question Code": properties.questionCode,
        "Question Number": properties.questionNumber,
        "session_identifier": properties.sessionIdentifier,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Ht-mV3vmhN", "Viewed Student Pitstop Screen", messages, [
        {id: "4uNrPBulmW", name: "session_identifier", value: properties.sessionIdentifier},
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "_cuCZnBI_", name: "Question Number", value: properties.questionNumber},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "bZZvnMF1m", name: "Question Code", value: properties.questionCode},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Student Pitstop Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Student Pitstop Screen", {
          "Quiz Code": properties.quizCode,
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "Question Code": properties.questionCode,
          "Question Number": properties.questionNumber,
          "session_identifier": properties.sessionIdentifier,
          "Screen Height": sysScreenHeight,
          }, "Ht-mV3vmhN", "0e3cd134977758598d291562f568524c02bda2f45c63dd428b830ba2c46d1ed0");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Student Pitstop Screen", {
      "Quiz Code": properties.quizCode,
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "Question Code": properties.questionCode,
      "Question Number": properties.questionNumber,
      "session_identifier": properties.sessionIdentifier,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Problems Answered: No description
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/hEcO_Dz4dt}
   */
  function problemsAnswered(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Problems Answered", Object.keys(properties), [
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "hEcO_Dz4dt", "0233341ec7b9fc57b2e6ca0e9ea36e07eca1a2335e7033808317f6f4654f9ccc", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Problems Answered", {
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("hEcO_Dz4dt", "Problems Answered", messages, [
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Problems Answered': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Problems Answered", {
          "Screen Height": sysScreenHeight,
          }, "hEcO_Dz4dt", "0233341ec7b9fc57b2e6ca0e9ea36e07eca1a2335e7033808317f6f4654f9ccc");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Problems Answered", {
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Student Quiz Timer Run Out: No description
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   * @param {int} properties.questionNumber - This will capture Question Serial Number.
   * @param {string} properties.questionCode - This will capture unique question code.
   * @param {string} properties.sessionIdentifier - Unique Splashliv class session for user
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Mf9C357VoY}
   */
  function viewedStudentQuizTimerRunOut(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertQuestionNumber(properties.questionNumber));
      messages = messages.concat(assertQuestionCode(properties.questionCode));
      messages = messages.concat(assertSessionIdentifier(properties.sessionIdentifier));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Student Quiz Timer Run Out", Object.keys(properties), [
        "quizCode",
        "quizMeetingSlug",
        "quizLiveClassId",
        "questionNumber",
        "questionCode",
        "sessionIdentifier"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Mf9C357VoY", "1c02096b5ffb87ce62a7261df20afdb5423f6b0867dd9f9d26303999a2100487", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Student Quiz Timer Run Out", {
        "Quiz Code": properties.quizCode,
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "Question Number": properties.questionNumber,
        "Question Code": properties.questionCode,
        "session_identifier": properties.sessionIdentifier,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Mf9C357VoY", "Viewed Student Quiz Timer Run Out", messages, [
        {id: "4uNrPBulmW", name: "session_identifier", value: properties.sessionIdentifier},
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "_cuCZnBI_", name: "Question Number", value: properties.questionNumber},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "bZZvnMF1m", name: "Question Code", value: properties.questionCode},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Student Quiz Timer Run Out': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Student Quiz Timer Run Out", {
          "Quiz Code": properties.quizCode,
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "Question Number": properties.questionNumber,
          "Question Code": properties.questionCode,
          "session_identifier": properties.sessionIdentifier,
          "Screen Height": sysScreenHeight,
          }, "Mf9C357VoY", "1c02096b5ffb87ce62a7261df20afdb5423f6b0867dd9f9d26303999a2100487");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Student Quiz Timer Run Out", {
      "Quiz Code": properties.quizCode,
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "Question Number": properties.questionNumber,
      "Question Code": properties.questionCode,
      "session_identifier": properties.sessionIdentifier,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Student Final Leaderboard: No description
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   * @param {string} properties.sessionIdentifier - Unique Splashliv class session for user
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/bjqqNI4ue6}
   */
  function viewedStudentFinalLeaderboard(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertSessionIdentifier(properties.sessionIdentifier));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Student Final Leaderboard", Object.keys(properties), [
        "quizCode",
        "quizMeetingSlug",
        "quizLiveClassId",
        "sessionIdentifier"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "bjqqNI4ue6", "999dae05d6b9ee1efb83e6cfae312b752164fbd25798f49f201befe4f93fe0a0", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Student Final Leaderboard", {
        "Quiz Code": properties.quizCode,
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "session_identifier": properties.sessionIdentifier,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("bjqqNI4ue6", "Viewed Student Final Leaderboard", messages, [
        {id: "4uNrPBulmW", name: "session_identifier", value: properties.sessionIdentifier},
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Student Final Leaderboard': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Student Final Leaderboard", {
          "Quiz Code": properties.quizCode,
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "session_identifier": properties.sessionIdentifier,
          "Screen Height": sysScreenHeight,
          }, "bjqqNI4ue6", "999dae05d6b9ee1efb83e6cfae312b752164fbd25798f49f201befe4f93fe0a0");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Student Final Leaderboard", {
      "Quiz Code": properties.quizCode,
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "session_identifier": properties.sessionIdentifier,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Subscribe Pop-Up on PTL: When the user interacts the Subscribe Pop-up on PTL, this event is fired. 
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.userPersonaType - User persona type at an event level is the property that highlights whether the user persona is class only or after the parent signup - it is ptl. In the school, class the persona is class only and at home the persona is ptl. If the parent is not signed up, it is class only.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/dWzCeArG29}
   */
  function interactedSubscribePopUpOnPtl(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertUserPersonaType(properties.userPersonaType));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Subscribe Pop-Up on PTL", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "userPersonaType",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "dWzCeArG29", "34a3c629d3f88e57cb53e0c36348d31fdd52d308a9227f587b4285f8996c1446", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Subscribe Pop-Up on PTL", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "User Persona Type": properties.userPersonaType,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("dWzCeArG29", "Interacted Subscribe Pop-Up on PTL", messages, [
        {id: "1z9szfE-j", name: "User Persona Type", value: properties.userPersonaType},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Subscribe Pop-Up on PTL': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Subscribe Pop-Up on PTL", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "User Persona Type": properties.userPersonaType,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "dWzCeArG29", "34a3c629d3f88e57cb53e0c36348d31fdd52d308a9227f587b4285f8996c1446");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Subscribe Pop-Up on PTL", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "User Persona Type": properties.userPersonaType,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Problems Answered in Neo Worksheets: Count of problems answered in neo worksheets
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   * @param {string} properties.questionCode - This will capture unique question code.
   * @param {int} properties.questionNumber - This will capture Question Serial Number.
   * @param {int} [properties.roundNumber] - Store round info for Mashup Quiz 
   * @param {string} properties.sessionIdentifier - Unique Splashliv class session for user
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/TadJfng_8X}
   */
  function problemsAnsweredInNeoWorksheets(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertQuestionCode(properties.questionCode));
      messages = messages.concat(assertQuestionNumber(properties.questionNumber));
      messages = messages.concat(assertOptionalRoundNumber(properties.roundNumber));
      messages = messages.concat(assertSessionIdentifier(properties.sessionIdentifier));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Problems Answered in Neo Worksheets", Object.keys(properties), [
        "quizCode",
        "quizMeetingSlug",
        "quizLiveClassId",
        "questionCode",
        "questionNumber",
        "roundNumber",
        "sessionIdentifier"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "TadJfng_8X", "7f1358340e5b5364618d320ad5194abdb7388e133d53b25a7669e3ebfb639332", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Problems Answered in Neo Worksheets", {
        "Quiz Code": properties.quizCode,
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "Question Code": properties.questionCode,
        "Question Number": properties.questionNumber,
        "Round Number": properties.roundNumber,
        "session_identifier": properties.sessionIdentifier,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("TadJfng_8X", "Problems Answered in Neo Worksheets", messages, [
        {id: "4uNrPBulmW", name: "session_identifier", value: properties.sessionIdentifier},
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "_cuCZnBI_", name: "Question Number", value: properties.questionNumber},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "bZZvnMF1m", name: "Question Code", value: properties.questionCode},
        {id: "jw_xpal_L1", name: "Round Number", value: properties.roundNumber},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Problems Answered in Neo Worksheets': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Problems Answered in Neo Worksheets", {
          "Quiz Code": properties.quizCode,
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "Question Code": properties.questionCode,
          "Question Number": properties.questionNumber,
          "Round Number": properties.roundNumber,
          "session_identifier": properties.sessionIdentifier,
          "Screen Height": sysScreenHeight,
          }, "TadJfng_8X", "7f1358340e5b5364618d320ad5194abdb7388e133d53b25a7669e3ebfb639332");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Problems Answered in Neo Worksheets", {
      "Quiz Code": properties.quizCode,
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "Question Code": properties.questionCode,
      "Question Number": properties.questionNumber,
      "Round Number": properties.roundNumber,
      "session_identifier": properties.sessionIdentifier,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Upcoming Class Tab: Triggered when a user sees the live classes upcoming class tab
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/njG3oQa5fg}
   */
  function viewedUpcomingClassTab(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Upcoming Class Tab", Object.keys(properties), [
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "njG3oQa5fg", "cc9163871d09fa8ef1ddbb05f4958f47e862cda330b09fa49d5876c43c210a94", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Upcoming Class Tab", {
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("njG3oQa5fg", "Viewed Upcoming Class Tab", messages, [
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Upcoming Class Tab': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Upcoming Class Tab", {
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "njG3oQa5fg", "cc9163871d09fa8ef1ddbb05f4958f47e862cda330b09fa49d5876c43c210a94");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Upcoming Class Tab", {
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Upcoming Class Tab: Triggered when a user interacts with the upcoming classes section
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {bool} properties.joinEnabled - This property is used to find out if the join link was enabled or not at the time of tap on live class card!
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.tabCode - Specifies the tab which has been opened in the event 'Viewed Tiled Dashboard' and Other events too
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/G-pzm4zxF3}
   */
  function interactedUpcomingClassTab(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertJoinEnabled(properties.joinEnabled));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertTabCode(properties.tabCode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Upcoming Class Tab", Object.keys(properties), [
        "mathGrade",
        "mode",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "joinEnabled",
        "elaGrade",
        "grade",
        "tabCode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "G-pzm4zxF3", "dbdee92c492209272febcf1d4b5b762be96a5384a78583fdaf3c05b2739906fe", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Upcoming Class Tab", {
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Join Enabled": properties.joinEnabled,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Tab Code": properties.tabCode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("G-pzm4zxF3", "Interacted Upcoming Class Tab", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "A-lFlAcNj", name: "Join Enabled", value: properties.joinEnabled},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "l9PbANZBu", name: "Tab Code", value: properties.tabCode},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Upcoming Class Tab': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Upcoming Class Tab", {
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Join Enabled": properties.joinEnabled,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Tab Code": properties.tabCode,
          "Screen Height": sysScreenHeight,
          }, "G-pzm4zxF3", "dbdee92c492209272febcf1d4b5b762be96a5384a78583fdaf3c05b2739906fe");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Upcoming Class Tab", {
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Join Enabled": properties.joinEnabled,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Tab Code": properties.tabCode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Live Classes Introduction Popup: Triggered with the repeat user popup is shown to the users
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/X4M2jxCMCE}
   */
  function viewedLiveClassesIntroductionPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Live Classes Introduction Popup", Object.keys(properties), [
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "X4M2jxCMCE", "f647d0b820eb23f74cebdb16d4e794e48c615f1234014b6b289210bf7c8ae215", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Live Classes Introduction Popup", {
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("X4M2jxCMCE", "Viewed Live Classes Introduction Popup", messages, [
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Live Classes Introduction Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Live Classes Introduction Popup", {
          "Screen Height": sysScreenHeight,
          }, "X4M2jxCMCE", "f647d0b820eb23f74cebdb16d4e794e48c615f1234014b6b289210bf7c8ae215");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Live Classes Introduction Popup", {
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Live Classes Introduction Popup: Triggered when a user interacts with the live classes repeat user popup
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/8tuDH4EdMz}
   */
  function interactedLiveClassesIntroductionPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Live Classes Introduction Popup", Object.keys(properties), [
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "8tuDH4EdMz", "39d4d68bd83b807d1978dbe1ceb70347e7af8126dcc81c9fc9fd633ac8a870dd", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Live Classes Introduction Popup", {
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("8tuDH4EdMz", "Interacted Live Classes Introduction Popup", messages, [
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Live Classes Introduction Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Live Classes Introduction Popup", {
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "8tuDH4EdMz", "39d4d68bd83b807d1978dbe1ceb70347e7af8126dcc81c9fc9fd633ac8a870dd");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Live Classes Introduction Popup", {
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Add Parent Emails Page: This event will be fired when the user visits the page on which she needs to enter parent emails
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/5Rf1uc4O0d}
   */
  function viewedAddParentEmailsPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Add Parent Emails Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "5Rf1uc4O0d", "4d06c4674553b0fea285a74a1df2fa390e54028e840b557ac3c610f2efe7d012", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Add Parent Emails Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("5Rf1uc4O0d", "Viewed Add Parent Emails Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Add Parent Emails Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Add Parent Emails Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "5Rf1uc4O0d", "4d06c4674553b0fea285a74a1df2fa390e54028e840b557ac3c610f2efe7d012");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Add Parent Emails Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Add Parent Emails Page: This gets fired when the user does any kind of interaction with the 'Add Parent Emails' page. This should also capture if an email is entered in the textbox as Clicked on 'Email Enter' (this is similarly implemented on the Enable Home Access Page as well)
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/9h0XuaNKkS/trigger/eq3OrDAN2
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} [properties.interactionDetails] - Stores where is the user interacting with the page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/9h0XuaNKkS}
   */
  function interactedAddParentEmailsPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertOptionalInteractionDetails(properties.interactionDetails));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Add Parent Emails Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "interactionDetails"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "9h0XuaNKkS", "1e72efca5d91e78b3b6768a06e6cb6721588c94c701fbc3f003c47b30cc8ce69", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Add Parent Emails Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Interaction Details": properties.interactionDetails,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("9h0XuaNKkS", "Interacted Add Parent Emails Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "ncdYto9gZ", name: "Interaction Details", value: properties.interactionDetails},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Add Parent Emails Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Add Parent Emails Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Interaction Details": properties.interactionDetails,
          "Screen Height": sysScreenHeight,
          }, "9h0XuaNKkS", "1e72efca5d91e78b3b6768a06e6cb6721588c94c701fbc3f003c47b30cc8ce69");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Add Parent Emails Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Interaction Details": properties.interactionDetails,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Program Selection Screen: When the user lands on the ELP/ESP selection screen
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/DGPTNxszAM/trigger/JaztsFJhV
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/DGPTNxszAM}
   */
  function viewedProgramSelectionScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Program Selection Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "DGPTNxszAM", "a4320cfa60199fc7551b2324dad609f7d6d04d784ff68b3cb52d7ef64e354dbb", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Program Selection Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Mode": properties.mode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("DGPTNxszAM", "Viewed Program Selection Screen", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Program Selection Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Program Selection Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Mode": properties.mode,
          "Screen Height": sysScreenHeight,
          }, "DGPTNxszAM", "a4320cfa60199fc7551b2324dad609f7d6d04d784ff68b3cb52d7ef64e354dbb");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Program Selection Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Mode": properties.mode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Program Selection Screen: When the user selects the program (ELP or ESP) or opts to go back
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/gII0S2fzsu/trigger/At_Jo1Jnj
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/gII0S2fzsu}
   */
  function interactedProgramSelectionScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Program Selection Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "mode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "gII0S2fzsu", "e14cb573f5744f9385c186f0bbdd5514e279345d1925ec826886b9125230cd69", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Program Selection Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Mode": properties.mode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("gII0S2fzsu", "Interacted Program Selection Screen", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Program Selection Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Program Selection Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Mode": properties.mode,
          "Screen Height": sysScreenHeight,
          }, "gII0S2fzsu", "e14cb573f5744f9385c186f0bbdd5514e279345d1925ec826886b9125230cd69");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Program Selection Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Mode": properties.mode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Age Selection Screen: When the user lands on the new age selection screen for age 2-5
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/UvTODv7l_z/trigger/1heUa10kE
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/UvTODv7l_z}
   */
  function viewedAgeSelectionScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Age Selection Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "UvTODv7l_z", "37a7d76e88839120345e875d8930f5e3da8a245b36cf725d28217ff3e5b423a3", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Age Selection Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Mode": properties.mode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("UvTODv7l_z", "Viewed Age Selection Screen", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Age Selection Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Age Selection Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Mode": properties.mode,
          "Screen Height": sysScreenHeight,
          }, "UvTODv7l_z", "37a7d76e88839120345e875d8930f5e3da8a245b36cf725d28217ff3e5b423a3");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Age Selection Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Mode": properties.mode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Age Selection Screen: When the user selects the age or goes back
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/kRMuZ6pGRW/trigger/N-r5G3314
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/kRMuZ6pGRW}
   */
  function interactedAgeSelectionScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Age Selection Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "mode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "kRMuZ6pGRW", "a557a67fb70fe8a584c840a5c731a707b382deb8998e6be329bab2e39abeb431", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Age Selection Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Mode": properties.mode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("kRMuZ6pGRW", "Interacted Age Selection Screen", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Age Selection Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Age Selection Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Mode": properties.mode,
          "Screen Height": sysScreenHeight,
          }, "kRMuZ6pGRW", "a557a67fb70fe8a584c840a5c731a707b382deb8998e6be329bab2e39abeb431");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Age Selection Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Mode": properties.mode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Program Details Screen: When the user views the screen with age-wise program details
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/hZjHxMqShj/trigger/owEjlM0HJ
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/hZjHxMqShj}
   */
  function viewedProgramDetailsScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Program Details Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "hZjHxMqShj", "779eac731ef6085c4caf402b503462dced937cc06689ce4dcf97f14aa53c153a", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Program Details Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Mode": properties.mode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("hZjHxMqShj", "Viewed Program Details Screen", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Program Details Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Program Details Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Mode": properties.mode,
          "Screen Height": sysScreenHeight,
          }, "hZjHxMqShj", "779eac731ef6085c4caf402b503462dced937cc06689ce4dcf97f14aa53c153a");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Program Details Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Mode": properties.mode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Program Details Screen: When the user clicks on the CTA or changes the age
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/HLrKJYyFBB/trigger/QFHdD0xBF
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/HLrKJYyFBB}
   */
  function interactedProgramDetailsScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Program Details Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "mode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "HLrKJYyFBB", "11e31ff5436f6eb4289365121ee9e5e95fdb0e0f99bde41299cb98eb76783f0a", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Program Details Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Mode": properties.mode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("HLrKJYyFBB", "Interacted Program Details Screen", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Program Details Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Program Details Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Mode": properties.mode,
          "Screen Height": sysScreenHeight,
          }, "HLrKJYyFBB", "11e31ff5436f6eb4289365121ee9e5e95fdb0e0f99bde41299cb98eb76783f0a");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Program Details Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Mode": properties.mode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Add Parents Email Page: This event will be fired when the user visits the page on which she needs to enter parent emails
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/LMHXVbSuX_}
   */
  function viewedAddParentsEmailPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Add Parents Email Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "LMHXVbSuX_", "1e813096a85ea4d7f1258d36bf517b8dea3008a4516ce1b848b5006b32c8c91f", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Add Parents Email Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("LMHXVbSuX_", "Viewed Add Parents Email Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Add Parents Email Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Add Parents Email Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "LMHXVbSuX_", "1e813096a85ea4d7f1258d36bf517b8dea3008a4516ce1b848b5006b32c8c91f");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Add Parents Email Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Add Parents Email Page: This gets fired when the user does any kind of interaction with the 'Add Parent Emails' page. This should also capture if an email is entered in the textbox as Clicked on 'Email Enter' (this is similarly implemented on the Enable Home Access Page as well)
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/2RmyWmerXN}
   */
  function interactedAddParentsEmailPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Add Parents Email Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "2RmyWmerXN", "6aa2645fbe3efeaa3316d5220c7d0e5db0397f4d2e1a3eb80325d880752c3484", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Add Parents Email Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("2RmyWmerXN", "Interacted Add Parents Email Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Add Parents Email Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Add Parents Email Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "2RmyWmerXN", "6aa2645fbe3efeaa3316d5220c7d0e5db0397f4d2e1a3eb80325d880752c3484");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Add Parents Email Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Locked Game: Interacted Locked Game during school hours
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {string} properties.gameName - Name of the Game being tapped (Optional)
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.gameType - Type of game/playable selected
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/hiBLfGwrcQ}
   */
  function interactedLockedGame(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertGameName(properties.gameName));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertGameType(properties.gameType));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Locked Game", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "from",
        "gameName",
        "grade",
        "gameType"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "hiBLfGwrcQ", "398bbc9fcc9b6ec0d8346dcc317cca0f7f6e84e9f72136c964d23b4b8a8ef73b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Locked Game", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "From": properties.from,
        "Game Name": properties.gameName,
        "Grade": properties.grade,
        "Game Type": properties.gameType,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("hiBLfGwrcQ", "Interacted Locked Game", messages, [
        {id: "2da5NLAEc", name: "Game Type", value: properties.gameType},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Locked Game': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Locked Game", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "From": properties.from,
          "Game Name": properties.gameName,
          "Grade": properties.grade,
          "Game Type": properties.gameType,
          "Screen Height": sysScreenHeight,
          }, "hiBLfGwrcQ", "398bbc9fcc9b6ec0d8346dcc317cca0f7f6e84e9f72136c964d23b4b8a8ef73b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Locked Game", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "From": properties.from,
      "Game Name": properties.gameName,
      "Grade": properties.grade,
      "Game Type": properties.gameType,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Play at Home Screen: Viewed play at home screen
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.gameName - Name of the Game being tapped (Optional)
   * @param {string} properties.gameType - Type of game/playable selected
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/hkfgIMdDBN}
   */
  function viewedPlayAtHomeScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGameName(properties.gameName));
      messages = messages.concat(assertGameType(properties.gameType));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Play at Home Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "gameName",
        "gameType",
        "from",
        "grade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "hkfgIMdDBN", "2e02025a468ba0f5733d56335ae173e8ac316906507599186630e57207c082e0", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Play at Home Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Game Name": properties.gameName,
        "Game Type": properties.gameType,
        "From": properties.from,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("hkfgIMdDBN", "Viewed Play at Home Screen", messages, [
        {id: "2da5NLAEc", name: "Game Type", value: properties.gameType},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Play at Home Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Play at Home Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Game Name": properties.gameName,
          "Game Type": properties.gameType,
          "From": properties.from,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "hkfgIMdDBN", "2e02025a468ba0f5733d56335ae173e8ac316906507599186630e57207c082e0");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Play at Home Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Game Name": properties.gameName,
      "Game Type": properties.gameType,
      "From": properties.from,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Play at Home Screen: Interacted Play at Home Screen
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.gameName - Name of the Game being tapped (Optional)
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {string} properties.gameType - Type of game/playable selected
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/y8-IlQJMaF}
   */
  function interactedPlayAtHomeScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGameName(properties.gameName));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertGameType(properties.gameType));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Play at Home Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "gameName",
        "grade",
        "clickedOn",
        "from",
        "gameType",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "y8-IlQJMaF", "08b634744f50fdcba3bc31235dc7749b9e0846513018d7cb514c848a58fbdf9d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Play at Home Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Game Name": properties.gameName,
        "Grade": properties.grade,
        "Clicked On": properties.clickedOn,
        "From": properties.from,
        "Game Type": properties.gameType,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("y8-IlQJMaF", "Interacted Play at Home Screen", messages, [
        {id: "2da5NLAEc", name: "Game Type", value: properties.gameType},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Play at Home Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Play at Home Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Game Name": properties.gameName,
          "Grade": properties.grade,
          "Clicked On": properties.clickedOn,
          "From": properties.from,
          "Game Type": properties.gameType,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "y8-IlQJMaF", "08b634744f50fdcba3bc31235dc7749b9e0846513018d7cb514c848a58fbdf9d");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Play at Home Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Game Name": properties.gameName,
      "Grade": properties.grade,
      "Clicked On": properties.clickedOn,
      "From": properties.from,
      "Game Type": properties.gameType,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Locked Games: When the user views the locked games, fire this event.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/DtQdokH62D}
   */
  function viewedLockedGames(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Locked Games", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "from",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "DtQdokH62D", "b365e5dd8dfbebe94780325d6ad723384322d83c9dd0d328033fe5d3a03624f9", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Locked Games", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "From": properties.from,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("DtQdokH62D", "Viewed Locked Games", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Locked Games': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Locked Games", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "From": properties.from,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "DtQdokH62D", "b365e5dd8dfbebe94780325d6ad723384322d83c9dd0d328033fe5d3a03624f9");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Locked Games", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "From": properties.from,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed COQ Opt-in Screen: When the user lands on the opt-in screen for child onboarding questions
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/3IE94Ton2w/trigger/LUXVamtx0
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/3IE94Ton2w}
   */
  function viewedCoqOptInScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed COQ Opt-in Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mode",
        "grade",
        "elaGrade",
        "mathGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "3IE94Ton2w", "683db18c46954e9e3a935a1914a038ab932bc554a925d1750eeb3dfcbbd52867", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed COQ Opt-in Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Mode": properties.mode,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("3IE94Ton2w", "Viewed COQ Opt-in Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed COQ Opt-in Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed COQ Opt-in Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Mode": properties.mode,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Screen Height": sysScreenHeight,
          }, "3IE94Ton2w", "683db18c46954e9e3a935a1914a038ab932bc554a925d1750eeb3dfcbbd52867");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed COQ Opt-in Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Mode": properties.mode,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted COQ Opt-in Screen: When user clicks on either of the CTAs on the opt-in screen
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Pq3nODzOi_/trigger/qf8U-viRI
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Pq3nODzOi_}
   */
  function interactedCoqOptInScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted COQ Opt-in Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "mode",
        "grade",
        "elaGrade",
        "mathGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Pq3nODzOi_", "ff586704ee189cea677b9c25a012e4b372a8c051d7b6ea8ac103c8310f0e1961", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted COQ Opt-in Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Mode": properties.mode,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Pq3nODzOi_", "Interacted COQ Opt-in Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted COQ Opt-in Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted COQ Opt-in Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Mode": properties.mode,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Screen Height": sysScreenHeight,
          }, "Pq3nODzOi_", "ff586704ee189cea677b9c25a012e4b372a8c051d7b6ea8ac103c8310f0e1961");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted COQ Opt-in Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Mode": properties.mode,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Class Won SpringBoard Certificate: This event will be triggered for every certificate win by a class.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.classId - This captures the Analytics ID of the class for which this event is fired.
   * @param {string} properties.certificateName - This is the name of the certificate.
   * @param {string} properties.springboardWeek - Springboard Week - Springboard is a 10 week big competition. This event property highlights which week of the Springboard. Values will be Week1, Week2, Week3, Week4 so on and so forth till Week10. 
   * @param {string} properties.url - This will capture the URL of the certificates tab on the Springboard page for that particuar class
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/IBD4E9C15k}
   */
  function classWonSpringboardCertificate(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClassID(properties.classId));
      messages = messages.concat(assertCertificateName(properties.certificateName));
      messages = messages.concat(assertSpringboardWeek(properties.springboardWeek));
      messages = messages.concat(assertUrl(properties.url));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Class Won SpringBoard Certificate", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "classId",
        "certificateName",
        "springboardWeek",
        "url"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "IBD4E9C15k", "cae50bc5d340c1a1ed41ce3c3859cc75a3bfe99ce8d68647339899d3d856e8a7", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Class Won SpringBoard Certificate", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Class ID": properties.classId,
        "Certificate Name": properties.certificateName,
        "Springboard Week": properties.springboardWeek,
        "Url": properties.url,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("IBD4E9C15k", "Class Won SpringBoard Certificate", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "MfWi2aBDZ", name: "Certificate Name", value: properties.certificateName},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "ToCgaA4KN", name: "Url", value: properties.url},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "tmoviENyM", name: "Class ID", value: properties.classId},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "wZVJV2Yc5", name: "Springboard Week", value: properties.springboardWeek},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Class Won SpringBoard Certificate': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Class Won SpringBoard Certificate", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Class ID": properties.classId,
          "Certificate Name": properties.certificateName,
          "Springboard Week": properties.springboardWeek,
          "Url": properties.url,
          "Screen Height": sysScreenHeight,
          }, "IBD4E9C15k", "cae50bc5d340c1a1ed41ce3c3859cc75a3bfe99ce8d68647339899d3d856e8a7");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Class Won SpringBoard Certificate", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Class ID": properties.classId,
      "Certificate Name": properties.certificateName,
      "Springboard Week": properties.springboardWeek,
      "Url": properties.url,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Student Won SpringBoard Certificate: Student’s class winning a certificate - This event will be triggered for every certificate win for the corresponding PTL parent. 
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.studentName - This will capture the name of the student in the corresponding certificate winning class.
The format will be <FirstName> <LastName>. Example, Tim Cook
   * @param {string} properties.classId - This captures the Analytics ID of the class for which this event is fired.
   * @param {string} properties.className - The name of the class that is kept by the teacher. 
   * @param {string} properties.certificateName - This is the name of the certificate.
   * @param {string} properties.springboardWeek - Springboard Week - Springboard is a 10 week big competition. This event property highlights which week of the Springboard. Values will be Week1, Week2, Week3, Week4 so on and so forth till Week10. 
   * @param {string} properties.url - This will capture the URL of the certificates tab on the Springboard page for that particuar class
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/XygholF2Ev}
   */
  function studentWonSpringboardCertificate(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertStudentName(properties.studentName));
      messages = messages.concat(assertClassID(properties.classId));
      messages = messages.concat(assertClassName(properties.className));
      messages = messages.concat(assertCertificateName(properties.certificateName));
      messages = messages.concat(assertSpringboardWeek(properties.springboardWeek));
      messages = messages.concat(assertUrl(properties.url));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Student Won SpringBoard Certificate", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "studentName",
        "classId",
        "className",
        "certificateName",
        "springboardWeek",
        "url"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "XygholF2Ev", "fddd4436eb40f68e291a0bc9343292c2d9cdf196b11b13cab0f5b55f9d0e2f4f", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Student Won SpringBoard Certificate", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Student Name": properties.studentName,
        "Class ID": properties.classId,
        "Class Name": properties.className,
        "Certificate Name": properties.certificateName,
        "Springboard Week": properties.springboardWeek,
        "Url": properties.url,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("XygholF2Ev", "Student Won SpringBoard Certificate", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "9dTrjsxjG", name: "Class Name", value: properties.className},
        {id: "MfWi2aBDZ", name: "Certificate Name", value: properties.certificateName},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "ToCgaA4KN", name: "Url", value: properties.url},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "ptvPVC2md", name: "Student Name", value: properties.studentName},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "tmoviENyM", name: "Class ID", value: properties.classId},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "wZVJV2Yc5", name: "Springboard Week", value: properties.springboardWeek},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Student Won SpringBoard Certificate': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Student Won SpringBoard Certificate", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Student Name": properties.studentName,
          "Class ID": properties.classId,
          "Class Name": properties.className,
          "Certificate Name": properties.certificateName,
          "Springboard Week": properties.springboardWeek,
          "Url": properties.url,
          "Screen Height": sysScreenHeight,
          }, "XygholF2Ev", "fddd4436eb40f68e291a0bc9343292c2d9cdf196b11b13cab0f5b55f9d0e2f4f");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Student Won SpringBoard Certificate", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Student Name": properties.studentName,
      "Class ID": properties.classId,
      "Class Name": properties.className,
      "Certificate Name": properties.certificateName,
      "Springboard Week": properties.springboardWeek,
      "Url": properties.url,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Class Almost Won SpringBoard Certificate: Class almost winning a certificate - This event will be triggered for every almost certificate win. 
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.classId - This captures the Analytics ID of the class for which this event is fired.
   * @param {string} properties.className - The name of the class that is kept by the teacher. 
   * @param {string} properties.certificateName - This is the name of the certificate.
   * @param {string} properties.springboardWeek - Springboard Week - Springboard is a 10 week big competition. This event property highlights which week of the Springboard. Values will be Week1, Week2, Week3, Week4 so on and so forth till Week10. 
   * @param {string} properties.url - This will capture the URL of the certificates tab on the Springboard page for that particuar class
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/EpbNem_fmV}
   */
  function classAlmostWonSpringboardCertificate(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClassID(properties.classId));
      messages = messages.concat(assertClassName(properties.className));
      messages = messages.concat(assertCertificateName(properties.certificateName));
      messages = messages.concat(assertSpringboardWeek(properties.springboardWeek));
      messages = messages.concat(assertUrl(properties.url));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Class Almost Won SpringBoard Certificate", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "classId",
        "className",
        "certificateName",
        "springboardWeek",
        "url"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "EpbNem_fmV", "c02017228c0d4bf069c6b336bca93ee64519a347a866f22d7d455a70df35fc0e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Class Almost Won SpringBoard Certificate", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Class ID": properties.classId,
        "Class Name": properties.className,
        "Certificate Name": properties.certificateName,
        "Springboard Week": properties.springboardWeek,
        "Url": properties.url,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("EpbNem_fmV", "Class Almost Won SpringBoard Certificate", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "9dTrjsxjG", name: "Class Name", value: properties.className},
        {id: "MfWi2aBDZ", name: "Certificate Name", value: properties.certificateName},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "ToCgaA4KN", name: "Url", value: properties.url},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "tmoviENyM", name: "Class ID", value: properties.classId},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "wZVJV2Yc5", name: "Springboard Week", value: properties.springboardWeek},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Class Almost Won SpringBoard Certificate': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Class Almost Won SpringBoard Certificate", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Class ID": properties.classId,
          "Class Name": properties.className,
          "Certificate Name": properties.certificateName,
          "Springboard Week": properties.springboardWeek,
          "Url": properties.url,
          "Screen Height": sysScreenHeight,
          }, "EpbNem_fmV", "c02017228c0d4bf069c6b336bca93ee64519a347a866f22d7d455a70df35fc0e");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Class Almost Won SpringBoard Certificate", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Class ID": properties.classId,
      "Class Name": properties.className,
      "Certificate Name": properties.certificateName,
      "Springboard Week": properties.springboardWeek,
      "Url": properties.url,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Student Almost Won SpringBoard Certificate: Student’s class almost winning a certificate - This event will be triggered for every almost certificate winning for the corresponding PTL parent.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.springboardWeek - Springboard Week - Springboard is a 10 week big competition. This event property highlights which week of the Springboard. Values will be Week1, Week2, Week3, Week4 so on and so forth till Week10. 
   * @param {string} properties.studentName - This will capture the name of the student in the corresponding certificate winning class.
The format will be <FirstName> <LastName>. Example, Tim Cook
   * @param {string} properties.classId - This captures the Analytics ID of the class for which this event is fired.
   * @param {string} properties.className - The name of the class that is kept by the teacher. 
   * @param {string} properties.certificateName - This is the name of the certificate.
   * @param {string} properties.url - This will capture the URL of the certificates tab on the Springboard page for that particuar class
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/dP2mhePeMZ}
   */
  function studentAlmostWonSpringboardCertificate(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertSpringboardWeek(properties.springboardWeek));
      messages = messages.concat(assertStudentName(properties.studentName));
      messages = messages.concat(assertClassID(properties.classId));
      messages = messages.concat(assertClassName(properties.className));
      messages = messages.concat(assertCertificateName(properties.certificateName));
      messages = messages.concat(assertUrl(properties.url));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Student Almost Won SpringBoard Certificate", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "springboardWeek",
        "studentName",
        "classId",
        "className",
        "certificateName",
        "url"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "dP2mhePeMZ", "e99852cac6cdd970df376f2b4318086b4fd74145220ef67ff78d1aa19f8668a2", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Student Almost Won SpringBoard Certificate", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Springboard Week": properties.springboardWeek,
        "Student Name": properties.studentName,
        "Class ID": properties.classId,
        "Class Name": properties.className,
        "Certificate Name": properties.certificateName,
        "Url": properties.url,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("dP2mhePeMZ", "Student Almost Won SpringBoard Certificate", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "9dTrjsxjG", name: "Class Name", value: properties.className},
        {id: "MfWi2aBDZ", name: "Certificate Name", value: properties.certificateName},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "ToCgaA4KN", name: "Url", value: properties.url},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "ptvPVC2md", name: "Student Name", value: properties.studentName},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "tmoviENyM", name: "Class ID", value: properties.classId},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "wZVJV2Yc5", name: "Springboard Week", value: properties.springboardWeek},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Student Almost Won SpringBoard Certificate': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Student Almost Won SpringBoard Certificate", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Springboard Week": properties.springboardWeek,
          "Student Name": properties.studentName,
          "Class ID": properties.classId,
          "Class Name": properties.className,
          "Certificate Name": properties.certificateName,
          "Url": properties.url,
          "Screen Height": sysScreenHeight,
          }, "dP2mhePeMZ", "e99852cac6cdd970df376f2b4318086b4fd74145220ef67ff78d1aa19f8668a2");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Student Almost Won SpringBoard Certificate", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Springboard Week": properties.springboardWeek,
      "Student Name": properties.studentName,
      "Class ID": properties.classId,
      "Class Name": properties.className,
      "Certificate Name": properties.certificateName,
      "Url": properties.url,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed CG Summary: When user views CG summary popup
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/fVdu6ukCiQ/trigger/pX1ug9ZeG
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.contentGroup - Code of content group user clicked/tapped on
   * @param {int} properties.milestoneSelected - Milestone selected by the user
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/fVdu6ukCiQ}
   */
  function viewedCgSummary(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertContentGroup(properties.contentGroup));
      messages = messages.concat(assertMilestoneSelected(properties.milestoneSelected));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed CG Summary", Object.keys(properties), [
        "grade",
        "contentGroup",
        "milestoneSelected",
        "platform",
        "elaGrade",
        "mathGrade",
        "mode",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "fVdu6ukCiQ", "f7c85de4d80fdac7642f3597561436be11784ea95e6b9c25ee7c9da9592af10b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed CG Summary", {
        "Grade": properties.grade,
        "Content Group": properties.contentGroup,
        "Milestone Selected": properties.milestoneSelected,
        "Platform": properties.platform,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("fVdu6ukCiQ", "Viewed CG Summary", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "Otu1r2JQW", name: "Content Group", value: properties.contentGroup},
        {id: "iMRbxEjXB", name: "Milestone Selected", value: properties.milestoneSelected},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed CG Summary': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed CG Summary", {
          "Grade": properties.grade,
          "Content Group": properties.contentGroup,
          "Milestone Selected": properties.milestoneSelected,
          "Platform": properties.platform,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "fVdu6ukCiQ", "f7c85de4d80fdac7642f3597561436be11784ea95e6b9c25ee7c9da9592af10b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed CG Summary", {
      "Grade": properties.grade,
      "Content Group": properties.contentGroup,
      "Milestone Selected": properties.milestoneSelected,
      "Platform": properties.platform,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted CG Summary: When user interacts with CG summary popup
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.contentGroup - Code of content group user clicked/tapped on
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ecuxUAM8_l}
   */
  function interactedCgSummary(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertContentGroup(properties.contentGroup));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted CG Summary", Object.keys(properties), [
        "grade",
        "contentGroup",
        "clickedOn",
        "platform",
        "elaGrade",
        "mathGrade",
        "mode",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ecuxUAM8_l", "76543c40fdb7f2503bd358d3cc7d509aa7913cb3ca068ab949c3827fc9a37b78", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted CG Summary", {
        "Grade": properties.grade,
        "Content Group": properties.contentGroup,
        "Clicked On": properties.clickedOn,
        "Platform": properties.platform,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ecuxUAM8_l", "Interacted CG Summary", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "Otu1r2JQW", name: "Content Group", value: properties.contentGroup},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted CG Summary': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted CG Summary", {
          "Grade": properties.grade,
          "Content Group": properties.contentGroup,
          "Clicked On": properties.clickedOn,
          "Platform": properties.platform,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "ecuxUAM8_l", "76543c40fdb7f2503bd358d3cc7d509aa7913cb3ca068ab949c3827fc9a37b78");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted CG Summary", {
      "Grade": properties.grade,
      "Content Group": properties.contentGroup,
      "Clicked On": properties.clickedOn,
      "Platform": properties.platform,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed CG Milestones: When user sees CG with milestone view allowing them to change the milestone
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.contentGroup - Code of content group user clicked/tapped on
   * @param {int} properties.milestoneSelected - Milestone selected by the user
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/EWDqf--wkG}
   */
  function viewedCgMilestones(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertContentGroup(properties.contentGroup));
      messages = messages.concat(assertMilestoneSelected(properties.milestoneSelected));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed CG Milestones", Object.keys(properties), [
        "grade",
        "contentGroup",
        "milestoneSelected",
        "from",
        "platform",
        "elaGrade",
        "mathGrade",
        "mode",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "EWDqf--wkG", "16480e50150f965d4eb51752578231fece5d880118171dc2d0dbcb7bb6f10f8e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed CG Milestones", {
        "Grade": properties.grade,
        "Content Group": properties.contentGroup,
        "Milestone Selected": properties.milestoneSelected,
        "From": properties.from,
        "Platform": properties.platform,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("EWDqf--wkG", "Viewed CG Milestones", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "Otu1r2JQW", name: "Content Group", value: properties.contentGroup},
        {id: "iMRbxEjXB", name: "Milestone Selected", value: properties.milestoneSelected},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed CG Milestones': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed CG Milestones", {
          "Grade": properties.grade,
          "Content Group": properties.contentGroup,
          "Milestone Selected": properties.milestoneSelected,
          "From": properties.from,
          "Platform": properties.platform,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "EWDqf--wkG", "16480e50150f965d4eb51752578231fece5d880118171dc2d0dbcb7bb6f10f8e");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed CG Milestones", {
      "Grade": properties.grade,
      "Content Group": properties.contentGroup,
      "Milestone Selected": properties.milestoneSelected,
      "From": properties.from,
      "Platform": properties.platform,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted CG Milestones: When user interacts with CG milestone page
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {int} [properties.recommendedMilestone] - The recommended milestone inside a CG
   * @param {int} [properties.selectedMilestone] - Milestone selected by user inside a CG
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.contentGroup - Code of content group user clicked/tapped on
   * @param {string} [properties.newGradeSelected] - The grade selected when user changes grade
   * @param {string} [properties.milestoneChanged] - When user changes milestone in a CG
   * @param {string} [properties.gradeChanged] - Binary property if user has changed grade - Yes/No
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/UUMDHSB3i7}
   */
  function interactedCgMilestones(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalRecommendedMilestone(properties.recommendedMilestone));
      messages = messages.concat(assertOptionalSelectedMilestone(properties.selectedMilestone));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertContentGroup(properties.contentGroup));
      messages = messages.concat(assertOptionalNewGradeSelected(properties.newGradeSelected));
      messages = messages.concat(assertOptionalMilestoneChanged(properties.milestoneChanged));
      messages = messages.concat(assertOptionalGradeChanged(properties.gradeChanged));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted CG Milestones", Object.keys(properties), [
        "recommendedMilestone",
        "selectedMilestone",
        "grade",
        "contentGroup",
        "newGradeSelected",
        "milestoneChanged",
        "gradeChanged",
        "clickedOn",
        "platform",
        "elaGrade",
        "mathGrade",
        "mode",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "UUMDHSB3i7", "03a369a428d5a665863e285f2ba7ee0340edad32fe6adccca249b889234ece19", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted CG Milestones", {
        "Recommended Milestone": properties.recommendedMilestone,
        "Selected Milestone": properties.selectedMilestone,
        "Grade": properties.grade,
        "Content Group": properties.contentGroup,
        "New Grade Selected": properties.newGradeSelected,
        "Milestone Changed": properties.milestoneChanged,
        "Grade Changed": properties.gradeChanged,
        "Clicked On": properties.clickedOn,
        "Platform": properties.platform,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("UUMDHSB3i7", "Interacted CG Milestones", messages, [
        {id: "-8NMIzT9n", name: "Milestone Changed", value: properties.milestoneChanged},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "ACsEf3MYO", name: "Recommended Milestone", value: properties.recommendedMilestone},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "J8GQmfwD7", name: "Selected Milestone", value: properties.selectedMilestone},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "Otu1r2JQW", name: "Content Group", value: properties.contentGroup},
        {id: "Tps4I1ukM", name: "New Grade Selected", value: properties.newGradeSelected},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vbOzDO_fd", name: "Grade Changed", value: properties.gradeChanged},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted CG Milestones': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted CG Milestones", {
          "Recommended Milestone": properties.recommendedMilestone,
          "Selected Milestone": properties.selectedMilestone,
          "Grade": properties.grade,
          "Content Group": properties.contentGroup,
          "New Grade Selected": properties.newGradeSelected,
          "Milestone Changed": properties.milestoneChanged,
          "Grade Changed": properties.gradeChanged,
          "Clicked On": properties.clickedOn,
          "Platform": properties.platform,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "UUMDHSB3i7", "03a369a428d5a665863e285f2ba7ee0340edad32fe6adccca249b889234ece19");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted CG Milestones", {
      "Recommended Milestone": properties.recommendedMilestone,
      "Selected Milestone": properties.selectedMilestone,
      "Grade": properties.grade,
      "Content Group": properties.contentGroup,
      "New Grade Selected": properties.newGradeSelected,
      "Milestone Changed": properties.milestoneChanged,
      "Grade Changed": properties.gradeChanged,
      "Clicked On": properties.clickedOn,
      "Platform": properties.platform,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Scrolled Student Dashboard: When user scrolls past a specific rail on category expansion dashboard. This will be fired for all tabs. For each rail this event will fire separately
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {Array<string>} properties.recommendedRail - This property will be used to store which rails were shown to the user in the HOME tab.

Where possible values are:
Rail Name = Curriculum, Game Zone, Math, Language, Logic & Thinking, Art & Creativity, General Knowledge, Motor Skills, Live Classes, Fluency, Multiplayer
This comes with Rank also with | separation
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {Array<string>} properties.recommendedRailName - This is the name of the rail viewed by the user. 
Recommended rail property comes with rail name and rail rank, pipe separated - with the introduction of this property, we intend to separate rail name to calculate CTR on Mixpanel.
   * @param {Array<int>} properties.recommendedRailRank - Recommended Rail Rank will carry the rank of the rail in integer format viewed by the user. 
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {Array<string>} properties.recommendedCategory - This property will be used to store what recommendations were shown to the user in the all tabs.
We'll be saving them in this format:
<Category Name>
where possible values are:
Category name =  MyToDo, Math_LP, ELA_LP, Math Facts, Books, Spelling, Reading Comprehension, Playzone, Activities, Learning Games
   * @param {Array<string>} [properties.recommendedTileName] - This property will store the code of the tile user has interacted with - CG code for curriculum rails and game code for non curr. rails

   * @param {Array<int>} properties.recommendedTileRank - This property will store the position of the tile on which user has clciked. Earlier this was sent as column position

   * @param {string} properties.tabCode - Specifies the tab which has been opened in the event 'Viewed Tiled Dashboard' and Other events too
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/6ZqAqPvMJn}
   */
  function scrolledStudentDashboard(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertRecommendedRail(properties.recommendedRail));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertRecommendedRailName(properties.recommendedRailName));
      messages = messages.concat(assertRecommendedRailRank(properties.recommendedRailRank));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertRecommendedCategory(properties.recommendedCategory));
      messages = messages.concat(assertOptionalRecommendedTileName(properties.recommendedTileName));
      messages = messages.concat(assertRecommendedTileRank(properties.recommendedTileRank));
      messages = messages.concat(assertTabCode(properties.tabCode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Scrolled Student Dashboard", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "recommendedRail",
        "grade",
        "recommendedRailName",
        "recommendedRailRank",
        "elaGrade",
        "recommendedCategory",
        "recommendedTileName",
        "recommendedTileRank",
        "tabCode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "6ZqAqPvMJn", "dc204248e063cfa9ec71aca731a84d7c2effa6eb6eca1fefb8d8b75f5d9ac1e8", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Scrolled Student Dashboard", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Recommended Rail": properties.recommendedRail,
        "Grade": properties.grade,
        "Recommended Rail Name": properties.recommendedRailName,
        "Recommended Rail Rank": properties.recommendedRailRank,
        "Ela Grade": properties.elaGrade,
        "Recommended Category": properties.recommendedCategory,
        "Recommended Tile Name": properties.recommendedTileName,
        "Recommended Tile Rank": properties.recommendedTileRank,
        "Tab Code": properties.tabCode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("6ZqAqPvMJn", "Scrolled Student Dashboard", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "6lrsWYY5Y", name: "Recommended Rail Name", value: properties.recommendedRailName},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "FLDtSJNKL", name: "Recommended Tile Rank", value: properties.recommendedTileRank},
        {id: "TYbmk5DQn", name: "Recommended Tile Name", value: properties.recommendedTileName},
        {id: "VdJhEU0H6s", name: "Recommended Category", value: properties.recommendedCategory},
        {id: "drNgwJn5Xg", name: "Recommended Rail", value: properties.recommendedRail},
        {id: "l9PbANZBu", name: "Tab Code", value: properties.tabCode},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "uyLgqxbg7", name: "Recommended Rail Rank", value: properties.recommendedRailRank},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Scrolled Student Dashboard': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Scrolled Student Dashboard", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Recommended Rail": properties.recommendedRail,
          "Grade": properties.grade,
          "Recommended Rail Name": properties.recommendedRailName,
          "Recommended Rail Rank": properties.recommendedRailRank,
          "Ela Grade": properties.elaGrade,
          "Recommended Category": properties.recommendedCategory,
          "Recommended Tile Name": properties.recommendedTileName,
          "Recommended Tile Rank": properties.recommendedTileRank,
          "Tab Code": properties.tabCode,
          "Screen Height": sysScreenHeight,
          }, "6ZqAqPvMJn", "dc204248e063cfa9ec71aca731a84d7c2effa6eb6eca1fefb8d8b75f5d9ac1e8");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Scrolled Student Dashboard", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Recommended Rail": properties.recommendedRail,
      "Grade": properties.grade,
      "Recommended Rail Name": properties.recommendedRailName,
      "Recommended Rail Rank": properties.recommendedRailRank,
      "Ela Grade": properties.elaGrade,
      "Recommended Category": properties.recommendedCategory,
      "Recommended Tile Name": properties.recommendedTileName,
      "Recommended Tile Rank": properties.recommendedTileRank,
      "Tab Code": properties.tabCode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Started Printables Search: When user clicks on search on worksheet tab
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.searchTerm - Term searched by the user
   * @param {string} properties.countOfSearchResults - Count of search results shown to user
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/eA30B_iObq}
   */
  function startedPrintablesSearch(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertSearchTerm(properties.searchTerm));
      messages = messages.concat(assertCountOfSearchResults(properties.countOfSearchResults));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Started Printables Search", Object.keys(properties), [
        "searchTerm",
        "countOfSearchResults",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "eA30B_iObq", "09ecb937f2a2603086c23b1bea4b4cb7b20bbe359ab0c16b216537890b9df278", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Started Printables Search", {
        "Search Term": properties.searchTerm,
        "Count of Search Results": properties.countOfSearchResults,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("eA30B_iObq", "Started Printables Search", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "5OAHrQIZt", name: "Count of Search Results", value: properties.countOfSearchResults},
        {id: "guJOTwi5T", name: "Search Term", value: properties.searchTerm},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Started Printables Search': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Started Printables Search", {
          "Search Term": properties.searchTerm,
          "Count of Search Results": properties.countOfSearchResults,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "eA30B_iObq", "09ecb937f2a2603086c23b1bea4b4cb7b20bbe359ab0c16b216537890b9df278");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Started Printables Search", {
      "Search Term": properties.searchTerm,
      "Count of Search Results": properties.countOfSearchResults,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Selected Printables Search: When user selects a search result from worksheet search opion
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.searchTerm - Term searched by the user
   * @param {string} properties.searchResultSelected - Among the search results shown, the one selected by the user
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/8RIk7EHN2G}
   */
  function selectedPrintablesSearch(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertSearchTerm(properties.searchTerm));
      messages = messages.concat(assertSearchResultSelected(properties.searchResultSelected));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Selected Printables Search", Object.keys(properties), [
        "searchTerm",
        "searchResultSelected",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "8RIk7EHN2G", "0c53c980bfbbc72b547b81a78de5c322784afbdc4fab34e10a61e0d960e50fc1", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Selected Printables Search", {
        "Search Term": properties.searchTerm,
        "Search Result Selected": properties.searchResultSelected,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("8RIk7EHN2G", "Selected Printables Search", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "guJOTwi5T", name: "Search Term", value: properties.searchTerm},
        {id: "of6hlcB4H", name: "Search Result Selected", value: properties.searchResultSelected},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Selected Printables Search': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Selected Printables Search", {
          "Search Term": properties.searchTerm,
          "Search Result Selected": properties.searchResultSelected,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "8RIk7EHN2G", "0c53c980bfbbc72b547b81a78de5c322784afbdc4fab34e10a61e0d960e50fc1");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Selected Printables Search", {
      "Search Term": properties.searchTerm,
      "Search Result Selected": properties.searchResultSelected,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Printables Filters: When user interacts with left hand side filter menu on worksheet tab
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.newTopicSelected - new topic selected by user
   * @param {string} properties.newGradeSelected - The grade selected when user changes grade
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/JW2wyw-UAW}
   */
  function interactedPrintablesFilters(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertNewTopicSelected(properties.newTopicSelected));
      messages = messages.concat(assertNewGradeSelected(properties.newGradeSelected));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Printables Filters", Object.keys(properties), [
        "grade",
        "newTopicSelected",
        "newGradeSelected",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "JW2wyw-UAW", "002d15729e39a8306ded7741c6adf8f48e2e1f2248f9a995b82f9ad73cf01a86", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Printables Filters", {
        "Grade": properties.grade,
        "New Topic Selected": properties.newTopicSelected,
        "New Grade Selected": properties.newGradeSelected,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("JW2wyw-UAW", "Interacted Printables Filters", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "HkxSt1enX", name: "New Topic Selected", value: properties.newTopicSelected},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "Tps4I1ukM", name: "New Grade Selected", value: properties.newGradeSelected},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Printables Filters': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Printables Filters", {
          "Grade": properties.grade,
          "New Topic Selected": properties.newTopicSelected,
          "New Grade Selected": properties.newGradeSelected,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "JW2wyw-UAW", "002d15729e39a8306ded7741c6adf8f48e2e1f2248f9a995b82f9ad73cf01a86");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Printables Filters", {
      "Grade": properties.grade,
      "New Topic Selected": properties.newTopicSelected,
      "New Grade Selected": properties.newGradeSelected,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Share Discount Banner: This event will be fired when the teacher views the 'Share Offer with Parents' discount banner on the Teacher Dashboard. This same event will be fired for both Old and New Dashboard.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/AdHLLMFoEj/trigger/RIuLwkiPv
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/AdHLLMFoEj}
   */
  function viewedShareDiscountBanner(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Share Discount Banner", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "AdHLLMFoEj", "2f5fcf7edc657c794c0c5669317b7e2dc707dec1f94cafafc4d6f8d92281eb49", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Share Discount Banner", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("AdHLLMFoEj", "Viewed Share Discount Banner", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Share Discount Banner': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Share Discount Banner", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "AdHLLMFoEj", "2f5fcf7edc657c794c0c5669317b7e2dc707dec1f94cafafc4d6f8d92281eb49");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Share Discount Banner", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Share Discount Banner: This event will be fired when the teacher clicks on the 'Share Offer with Parents' CTA within the discount banner on both old and new dashboard.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/mTxFf80c2L}
   */
  function interactedShareDiscountBanner(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Share Discount Banner", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "mTxFf80c2L", "90812679d925a150fa3a22e0d237d585bf817c0597ed33ad2975970bbfe41aaf", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Share Discount Banner", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("mTxFf80c2L", "Interacted Share Discount Banner", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Share Discount Banner': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Share Discount Banner", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "mTxFf80c2L", "90812679d925a150fa3a22e0d237d585bf817c0597ed33ad2975970bbfe41aaf");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Share Discount Banner", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Certificate Tab on Parent Dashboard: This event will be fired when the user views the certificate tab on the parent dashboard.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/IbVXzhz8XC}
   */
  function viewedCertificateTabOnParentDashboard(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Certificate Tab on Parent Dashboard", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "IbVXzhz8XC", "52123598f7cb68b44b7d32e747eedc79cc28f9a624562a76715c03cccccf5ab9", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Certificate Tab on Parent Dashboard", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("IbVXzhz8XC", "Viewed Certificate Tab on Parent Dashboard", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Certificate Tab on Parent Dashboard': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Certificate Tab on Parent Dashboard", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Screen Height": sysScreenHeight,
          }, "IbVXzhz8XC", "52123598f7cb68b44b7d32e747eedc79cc28f9a624562a76715c03cccccf5ab9");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Certificate Tab on Parent Dashboard", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Certificate Tab on Parent Dashboard: This event will be fired when the parent clicks anywhere within the certificate tab on parent dashboard.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Ah7JV79-nd}
   */
  function interactedCertificateTabOnParentDashboard(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Certificate Tab on Parent Dashboard", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Ah7JV79-nd", "c3a3483f5834060efb8039f1ef6816d9af48e6e848ea0e30042dc450d558b6e4", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Certificate Tab on Parent Dashboard", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Ah7JV79-nd", "Interacted Certificate Tab on Parent Dashboard", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Certificate Tab on Parent Dashboard': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Certificate Tab on Parent Dashboard", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "Ah7JV79-nd", "c3a3483f5834060efb8039f1ef6816d9af48e6e848ea0e30042dc450d558b6e4");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Certificate Tab on Parent Dashboard", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed School Home Screen: Viewed School Home Screen when the new home school screen is shown to the student post class code login
   * 
   * When to trigger this event:
   * 1. Class Code Login
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ZdYSp6a9q_/trigger/YS_WL1usG
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.enabledCta - Enabled CTA - there will be only one enabled CTA among  'Play at School' or 'Play at Home'. Please send one of these two values as per the frontend visibility of the user. 
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ZdYSp6a9q_}
   */
  function viewedSchoolHomeScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertEnabledCTA(properties.enabledCta));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed School Home Screen", Object.keys(properties), [
        "mathGrade",
        "mode",
        "platform",
        "userType",
        "signupFlow",
        "enabledCta",
        "grade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ZdYSp6a9q_", "f2bf0465f08620d2f2d9653bda1928b6a02ec554c6b9e5bdea16da9648991a7e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed School Home Screen", {
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Enabled CTA": properties.enabledCta,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ZdYSp6a9q_", "Viewed School Home Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "Nspz0JPS5", name: "Enabled CTA", value: properties.enabledCta},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed School Home Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed School Home Screen", {
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Enabled CTA": properties.enabledCta,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "ZdYSp6a9q_", "f2bf0465f08620d2f2d9653bda1928b6a02ec554c6b9e5bdea16da9648991a7e");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed School Home Screen", {
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Enabled CTA": properties.enabledCta,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted School Home Screen: When the user interacts the  School Home Screen. This event is fired.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/HrzpJtS4Xl}
   */
  function interactedSchoolHomeScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted School Home Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "clickedOn",
        "elaGrade",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "HrzpJtS4Xl", "e7d0aa577d7059801201983f70acabacab0a7b8139f17cc5ec709df82f4ddeb5", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted School Home Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Clicked On": properties.clickedOn,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("HrzpJtS4Xl", "Interacted School Home Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted School Home Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted School Home Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Clicked On": properties.clickedOn,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "HrzpJtS4Xl", "e7d0aa577d7059801201983f70acabacab0a7b8139f17cc5ec709df82f4ddeb5");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted School Home Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Clicked On": properties.clickedOn,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Summer Learning Offer Page: When the user views the summer learning offer page, this event needs to be fired. 
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/yYvNfVbULF}
   */
  function viewedSummerLearningOfferPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Summer Learning Offer Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "from"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "yYvNfVbULF", "fe186c23831554e7593ab27ed8744f8389bf7d199eaf3c23cf34ac63cda4eb55", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Summer Learning Offer Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From": properties.from,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("yYvNfVbULF", "Viewed Summer Learning Offer Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Summer Learning Offer Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Summer Learning Offer Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From": properties.from,
          "Screen Height": sysScreenHeight,
          }, "yYvNfVbULF", "fe186c23831554e7593ab27ed8744f8389bf7d199eaf3c23cf34ac63cda4eb55");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Summer Learning Offer Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From": properties.from,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Summer Learning Offer Page: When the teacher interacts with the summer learning offer page. This event needs to be fired. 
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/qORxYUaHGd}
   */
  function interactedSummerLearningOfferPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Summer Learning Offer Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "qORxYUaHGd", "64328f6ae869704045c8860837b084e0f760ba19e54cb2c67eab84f0fbd6ce75", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Summer Learning Offer Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("qORxYUaHGd", "Interacted Summer Learning Offer Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Summer Learning Offer Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Summer Learning Offer Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "qORxYUaHGd", "64328f6ae869704045c8860837b084e0f760ba19e54cb2c67eab84f0fbd6ce75");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Summer Learning Offer Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Summer Learning Pop-Up: When the user views the summer learning pop-up
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/VZVDniOWMH}
   */
  function viewedSummerLearningPopUp(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Summer Learning Pop-Up", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "VZVDniOWMH", "fdac8a87e00aa79ff5b378c1a2d9eb9f522c0255253a24715aec4f361d315cd4", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Summer Learning Pop-Up", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("VZVDniOWMH", "Viewed Summer Learning Pop-Up", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Summer Learning Pop-Up': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Summer Learning Pop-Up", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "VZVDniOWMH", "fdac8a87e00aa79ff5b378c1a2d9eb9f522c0255253a24715aec4f361d315cd4");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Summer Learning Pop-Up", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Summer Learning Pop-Up: When the teacher interacts summer learning pop-up, this event should be fired. 
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/hn6Qf1B9-I}
   */
  function interactedSummerLearningPopUp(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Summer Learning Pop-Up", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "hn6Qf1B9-I", "646063f4aaa85fd5592e13eb0a8093e8c397b96b017eb247ae2c92067d8f37b3", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Summer Learning Pop-Up", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("hn6Qf1B9-I", "Interacted Summer Learning Pop-Up", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Summer Learning Pop-Up': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Summer Learning Pop-Up", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "hn6Qf1B9-I", "646063f4aaa85fd5592e13eb0a8093e8c397b96b017eb247ae2c92067d8f37b3");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Summer Learning Pop-Up", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Parental Gate Failed: When parental gate input is incorrect (most likely a child trying to cross parental gate)
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Qmv1CkV1L}
   */
  function parentalGateFailed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Parental Gate Failed", Object.keys(properties), [
        "platform",
        "elaGrade",
        "mathGrade",
        "mode",
        "userType",
        "signupFlow",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Qmv1CkV1L", "88eb816471976c49a6af00866dda54e6337323b10d65430395401e55d7e5de91", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Parental Gate Failed", {
        "Platform": properties.platform,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Qmv1CkV1L", "Parental Gate Failed", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Parental Gate Failed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Parental Gate Failed", {
          "Platform": properties.platform,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "Qmv1CkV1L", "88eb816471976c49a6af00866dda54e6337323b10d65430395401e55d7e5de91");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Parental Gate Failed", {
      "Platform": properties.platform,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Parental Gate Closed: When user closes the parental age gate
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/l2q7UIjjd5}
   */
  function parentalGateClosed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Parental Gate Closed", Object.keys(properties), [
        "platform",
        "elaGrade",
        "mathGrade",
        "mode",
        "userType",
        "signupFlow",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "l2q7UIjjd5", "418357b5f281f60da3fd820874d3c70138ad03e9c911c423de8bf64e75c96c33", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Parental Gate Closed", {
        "Platform": properties.platform,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("l2q7UIjjd5", "Parental Gate Closed", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Parental Gate Closed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Parental Gate Closed", {
          "Platform": properties.platform,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "l2q7UIjjd5", "418357b5f281f60da3fd820874d3c70138ad03e9c911c423de8bf64e75c96c33");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Parental Gate Closed", {
      "Platform": properties.platform,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Login Screen: This will be triggered when the user interacts with the login screen. This is the common screen for both teachers and parents.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/FKR7fPjHu/trigger/WrldwVl0Z
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/FKR7fPjHu}
   */
  function interactedLoginScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Login Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "FKR7fPjHu", "eec096e94c67680d9b2517a4f652bfaa975f2b87f265a6526d14b02af3b4ae7f", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Login Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("FKR7fPjHu", "Interacted Login Screen", messages, [
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Login Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Login Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "FKR7fPjHu", "eec096e94c67680d9b2517a4f652bfaa975f2b87f265a6526d14b02af3b4ae7f");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Login Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Classroom Linked Login Screen: This event will be triggered when the parent lands on the classroom linked login screen.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/aHvXCBpU6O/trigger/7bcFj4gMW
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/aHvXCBpU6O}
   */
  function viewedClassroomLinkedLoginScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Classroom Linked Login Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "aHvXCBpU6O", "4b004970c09fab128d38aec71a1280c77478eda0839b6bf3f2bbac087c26078b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Classroom Linked Login Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("aHvXCBpU6O", "Viewed Classroom Linked Login Screen", messages, [
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Classroom Linked Login Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Classroom Linked Login Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "aHvXCBpU6O", "4b004970c09fab128d38aec71a1280c77478eda0839b6bf3f2bbac087c26078b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Classroom Linked Login Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Classroom Linked Login Screen: This event will be triggered when the parent interacts anywhere with the classroom linked login screen.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/RCKPe0105u/trigger/SIMjpPGiV
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/RCKPe0105u}
   */
  function interactedClassroomLinkedLoginScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Classroom Linked Login Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "RCKPe0105u", "5daf15a9f8ae04948ffd6d24d7515c2fc998595677cb1e147d262f9b9910a013", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Classroom Linked Login Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("RCKPe0105u", "Interacted Classroom Linked Login Screen", messages, [
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Classroom Linked Login Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Classroom Linked Login Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "RCKPe0105u", "5daf15a9f8ae04948ffd6d24d7515c2fc998595677cb1e147d262f9b9910a013");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Classroom Linked Login Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Login via OTP by Classroom Linked Parent: This event will be triggered when the parent lands on the Login via OTP screen from classroom linked login screen.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/rMZhC6EfL5/trigger/9NJGmaAI1
   * 2. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/rMZhC6EfL5/trigger/sb4f5NFKwpg2RyfoDs6L1
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.referrerPage - Shows the description of the previous page name/URL
   * @param {string} properties.invitationSource - This property returns the type of invite sent from the student roster page
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * @param {string} properties.linkedStudentCount - This property will return the count of students already linked with the PTL user attempting to signup or attempting to link new student
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/rMZhC6EfL5}
   */
  function viewedLoginViaOtpByClassroomLinkedParent(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertReferrerPage(properties.referrerPage));
      messages = messages.concat(assertInvitationSource(properties.invitationSource));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertLinkedStudentCount(properties.linkedStudentCount));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Login via OTP by Classroom Linked Parent", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "referrerPage",
        "invitationSource",
        "fromPage",
        "linkedStudentCount"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "rMZhC6EfL5", "e485f92321bda6d9e0dcdaa7640aca63bbbbf66dbb8ba18a77006e20fcef53b2", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Login via OTP by Classroom Linked Parent", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Referrer Page": properties.referrerPage,
        "Invitation Source": properties.invitationSource,
        "From Page": properties.fromPage,
        "Linked Student Count": properties.linkedStudentCount,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("rMZhC6EfL5", "Viewed Login via OTP by Classroom Linked Parent", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "cYVv-jM3n6", name: "Referrer Page", value: properties.referrerPage},
        {id: "cccDu2odc", name: "Invitation Source", value: properties.invitationSource},
        {id: "eb8RBK1CZ_91zt06w-5iv", name: "Linked Student Count", value: properties.linkedStudentCount},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Login via OTP by Classroom Linked Parent': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Login via OTP by Classroom Linked Parent", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Referrer Page": properties.referrerPage,
          "Invitation Source": properties.invitationSource,
          "From Page": properties.fromPage,
          "Linked Student Count": properties.linkedStudentCount,
          "Screen Height": sysScreenHeight,
          }, "rMZhC6EfL5", "e485f92321bda6d9e0dcdaa7640aca63bbbbf66dbb8ba18a77006e20fcef53b2");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Login via OTP by Classroom Linked Parent", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Referrer Page": properties.referrerPage,
      "Invitation Source": properties.invitationSource,
      "From Page": properties.fromPage,
      "Linked Student Count": properties.linkedStudentCount,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Login via OTP by Classroom Linked Parent: This event will be triggered when the parent interacts with the Login via OTP screen from classroom linked login screen.

   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/-ZKCbGW0PE/trigger/N2bPH_ftR
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {bool} [properties.otpEntered] - This will capture if the user has entered the OTP or not.
   * @param {string} properties.invitationSource - This property returns the type of invite sent from the student roster page
   * @param {string} properties.referrerPage - Shows the description of the previous page name/URL
   * @param {string} properties.linkedStudentCount - This property will return the count of students already linked with the PTL user attempting to signup or attempting to link new student
   * @param {string} properties.interactionDetails - Stores where is the user interacting with the page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/-ZKCbGW0PE}
   */
  function interactedLoginViaOtpByClassroomLinkedParent(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertOptionalOTPEntered(properties.otpEntered));
      messages = messages.concat(assertInvitationSource(properties.invitationSource));
      messages = messages.concat(assertReferrerPage(properties.referrerPage));
      messages = messages.concat(assertLinkedStudentCount(properties.linkedStudentCount));
      messages = messages.concat(assertInteractionDetails(properties.interactionDetails));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Login via OTP by Classroom Linked Parent", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "otpEntered",
        "invitationSource",
        "referrerPage",
        "linkedStudentCount",
        "interactionDetails"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "-ZKCbGW0PE", "732f33c9be1b9a3d7029254ec3ded7f9769304bc9139285db7b6d3e069be209b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Login via OTP by Classroom Linked Parent", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "OTP Entered": properties.otpEntered,
        "Invitation Source": properties.invitationSource,
        "Referrer Page": properties.referrerPage,
        "Linked Student Count": properties.linkedStudentCount,
        "Interaction Details": properties.interactionDetails,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("-ZKCbGW0PE", "Interacted Login via OTP by Classroom Linked Parent", messages, [
        {id: "KQDoDel93", name: "OTP Entered", value: properties.otpEntered},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "cYVv-jM3n6", name: "Referrer Page", value: properties.referrerPage},
        {id: "cccDu2odc", name: "Invitation Source", value: properties.invitationSource},
        {id: "eb8RBK1CZ_91zt06w-5iv", name: "Linked Student Count", value: properties.linkedStudentCount},
        {id: "ncdYto9gZ", name: "Interaction Details", value: properties.interactionDetails},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Login via OTP by Classroom Linked Parent': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Login via OTP by Classroom Linked Parent", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "OTP Entered": properties.otpEntered,
          "Invitation Source": properties.invitationSource,
          "Referrer Page": properties.referrerPage,
          "Linked Student Count": properties.linkedStudentCount,
          "Interaction Details": properties.interactionDetails,
          "Screen Height": sysScreenHeight,
          }, "-ZKCbGW0PE", "732f33c9be1b9a3d7029254ec3ded7f9769304bc9139285db7b6d3e069be209b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Login via OTP by Classroom Linked Parent", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "OTP Entered": properties.otpEntered,
      "Invitation Source": properties.invitationSource,
      "Referrer Page": properties.referrerPage,
      "Linked Student Count": properties.linkedStudentCount,
      "Interaction Details": properties.interactionDetails,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Profile Icon: This should get fired as soon as the user clicks on any of the menu items within the Profile icon on teacher dashboard.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/NVJNhPJMZ8/trigger/6D7XQqeWd
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/NVJNhPJMZ8}
   */
  function interactedProfileIcon(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Profile Icon", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "NVJNhPJMZ8", "9632b96419646ca9e916d94e4a886f8662c2262b9a3ac865cec7cb03950908bc", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Profile Icon", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("NVJNhPJMZ8", "Interacted Profile Icon", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Profile Icon': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Profile Icon", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "NVJNhPJMZ8", "9632b96419646ca9e916d94e4a886f8662c2262b9a3ac865cec7cb03950908bc");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Profile Icon", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Co-Teacher Coachmark: This event will be fired when the user views the co-teacher coachmark (which will appear for the first time when the user logs into Splashlearn after this feature is launched)
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/4_4PZq37WD/trigger/x_TWQs9U4
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/4_4PZq37WD}
   */
  function viewedCoTeacherCoachmark(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Co-Teacher Coachmark", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "4_4PZq37WD", "c43130c3bb57149bab09b4b3168644d633b6eb665dfe76d96813c7c199f88ff4", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Co-Teacher Coachmark", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("4_4PZq37WD", "Viewed Co-Teacher Coachmark", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Co-Teacher Coachmark': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Co-Teacher Coachmark", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "4_4PZq37WD", "c43130c3bb57149bab09b4b3168644d633b6eb665dfe76d96813c7c199f88ff4");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Co-Teacher Coachmark", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Co-Teacher Coachmark: This event will be fired when the user interacts with the co-teacher coachmark. The user has only 1 action - clicked on 'OK'
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/SIto3IxboY}
   */
  function interactedCoTeacherCoachmark(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Co-Teacher Coachmark", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "SIto3IxboY", "d5bb0ee89933d253b786b78b02aa8a735960acdbdf5f36f0cece57280995ed2c", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Co-Teacher Coachmark", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("SIto3IxboY", "Interacted Co-Teacher Coachmark", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Co-Teacher Coachmark': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Co-Teacher Coachmark", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "SIto3IxboY", "d5bb0ee89933d253b786b78b02aa8a735960acdbdf5f36f0cece57280995ed2c");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Co-Teacher Coachmark", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Manage All Classes Page: This event will be fired when the user lands on the 'Manage All Classes' page
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/0pDlwx_5V_/trigger/wnEOT7UUp
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * @param {string} properties.section - This will capture the widget name that is being viewed/interacted by the user in that viewport. For example, 'Onboarding Widget', 'Home Access Widget', 'Assignment Widget', 'Assessment Widget', 'Math Fact Widget'
The list will only have 1 value for 'Section' property for Interacted event.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/0pDlwx_5V_}
   */
  function viewedManageAllClassesPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertSection(properties.section));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Manage All Classes Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "fromPage",
        "section"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "0pDlwx_5V_", "dccd8f1b832d416e0c3feccf388cd66c1518482a874b9f52e81a2e718a742abf", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Manage All Classes Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From Page": properties.fromPage,
        "Section": properties.section,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("0pDlwx_5V_", "Viewed Manage All Classes Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "my9qL7M8w6", name: "Section", value: properties.section},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Manage All Classes Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Manage All Classes Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From Page": properties.fromPage,
          "Section": properties.section,
          "Screen Height": sysScreenHeight,
          }, "0pDlwx_5V_", "dccd8f1b832d416e0c3feccf388cd66c1518482a874b9f52e81a2e718a742abf");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Manage All Classes Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From Page": properties.fromPage,
      "Section": properties.section,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Add Co-Teacher Popup: This event will be fired when the user views the pop-up to enter the email of a co-teacher.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/UWP-jzN1JJ/trigger/-54_CE00m
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/UWP-jzN1JJ}
   */
  function viewedAddCoTeacherPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Add Co-Teacher Popup", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "UWP-jzN1JJ", "568708ec329cd7d8d7a24a125c99939cd6c1f7856dad130df88528eab3cae42f", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Add Co-Teacher Popup", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("UWP-jzN1JJ", "Viewed Add Co-Teacher Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Add Co-Teacher Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Add Co-Teacher Popup", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "UWP-jzN1JJ", "568708ec329cd7d8d7a24a125c99939cd6c1f7856dad130df88528eab3cae42f");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Add Co-Teacher Popup", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Add Co-Teacher Popup: This event will be fired when the user interacts with the add co-teacher popup
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/IpIdmr17gB/trigger/LdR9uQ0tY
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/IpIdmr17gB}
   */
  function interactedAddCoTeacherPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Add Co-Teacher Popup", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "IpIdmr17gB", "52fe69c812dc8ebe48c1a565bc2e1ca118c688a4cf906c4214153e9adebb138b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Add Co-Teacher Popup", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("IpIdmr17gB", "Interacted Add Co-Teacher Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Add Co-Teacher Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Add Co-Teacher Popup", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "IpIdmr17gB", "52fe69c812dc8ebe48c1a565bc2e1ca118c688a4cf906c4214153e9adebb138b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Add Co-Teacher Popup", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Co-Teaching Popup by Co-Teacher: This event will be fired when the co-teachers logs in to Splashlearn and views the popup that she has been added as a co-teacher 
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/yavrq7zl7r/trigger/2x4uHB0ya
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/yavrq7zl7r}
   */
  function viewedCoTeachingPopupByCoTeacher(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Co-Teaching Popup by Co-Teacher", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "yavrq7zl7r", "8c7d155d9faf483182c178d980b580ac0813d535c3e5e11e25bf12138a1d04de", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Co-Teaching Popup by Co-Teacher", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("yavrq7zl7r", "Viewed Co-Teaching Popup by Co-Teacher", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Co-Teaching Popup by Co-Teacher': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Co-Teaching Popup by Co-Teacher", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "yavrq7zl7r", "8c7d155d9faf483182c178d980b580ac0813d535c3e5e11e25bf12138a1d04de");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Co-Teaching Popup by Co-Teacher", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Co-Teaching Popup by Co-Teacher: This event will be fired when the co-teacher interacts with the popup that tells them that they have been added as a co-teacher
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/xWZaSFT-z3/trigger/vrGgCR0re
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/xWZaSFT-z3}
   */
  function interactedCoTeachingPopupByCoTeacher(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Co-Teaching Popup by Co-Teacher", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "xWZaSFT-z3", "d5a3e012f161320098105cf5291965a1b0602e1d58b55a6d1f1de59eb0926feb", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Co-Teaching Popup by Co-Teacher", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("xWZaSFT-z3", "Interacted Co-Teaching Popup by Co-Teacher", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Co-Teaching Popup by Co-Teacher': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Co-Teaching Popup by Co-Teacher", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "xWZaSFT-z3", "d5a3e012f161320098105cf5291965a1b0602e1d58b55a6d1f1de59eb0926feb");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Co-Teaching Popup by Co-Teacher", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Welcome Page by Newly Created Co-Teacher: This event will be triggered when a newly created teacher signs up on Splashlearn through the 'Add Co-Teacher' email and sees the welcome screen.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/IVdUzYlpCa/trigger/Y7KJQjcZh
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/IVdUzYlpCa}
   */
  function viewedWelcomePageByNewlyCreatedCoTeacher(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Welcome Page by Newly Created Co-Teacher", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "IVdUzYlpCa", "d8b94a8a0aa61f77afe3071c7ddc7a4a07e34219d20a1f05ffefbf0acb52c20e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Welcome Page by Newly Created Co-Teacher", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("IVdUzYlpCa", "Viewed Welcome Page by Newly Created Co-Teacher", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Welcome Page by Newly Created Co-Teacher': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Welcome Page by Newly Created Co-Teacher", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "IVdUzYlpCa", "d8b94a8a0aa61f77afe3071c7ddc7a4a07e34219d20a1f05ffefbf0acb52c20e");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Welcome Page by Newly Created Co-Teacher", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Welcome Page by Newly Created Co-Teacher: This event will be triggered when a newly created teacher signs up on Splashlearn through the 'Add Co-Teacher' email and interacts with the welcome screen.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Apma_4NY8E/trigger/oMNnkRlz_
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Apma_4NY8E}
   */
  function interactedWelcomePageByNewlyCreatedCoTeacher(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Welcome Page by Newly Created Co-Teacher", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Apma_4NY8E", "d9181d7bdd3d214ee2c4c1c3a8cec309342bf0c88bbeb54d37cc1c6eb6101400", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Welcome Page by Newly Created Co-Teacher", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Apma_4NY8E", "Interacted Welcome Page by Newly Created Co-Teacher", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Welcome Page by Newly Created Co-Teacher': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Welcome Page by Newly Created Co-Teacher", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "Apma_4NY8E", "d9181d7bdd3d214ee2c4c1c3a8cec309342bf0c88bbeb54d37cc1c6eb6101400");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Welcome Page by Newly Created Co-Teacher", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Summer Bundle Widget on Dashboard: This event will be fired when the teacher views the summer activity bundle from teacher dashboard or summer learning page.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/lZwMFD4pV/trigger/KTen6tgcw
   * 2. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/lZwMFD4pV/trigger/gIxGgeK0K
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/lZwMFD4pV}
   */
  function viewedSummerBundleWidgetOnDashboard(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Summer Bundle Widget on Dashboard", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "fromPage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "lZwMFD4pV", "29dd3b599e6f84378909929d7786044b9de7b2dcc8d75f90ad812bd546a6f6a5", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Summer Bundle Widget on Dashboard", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From Page": properties.fromPage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("lZwMFD4pV", "Viewed Summer Bundle Widget on Dashboard", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Summer Bundle Widget on Dashboard': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Summer Bundle Widget on Dashboard", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From Page": properties.fromPage,
          "Screen Height": sysScreenHeight,
          }, "lZwMFD4pV", "29dd3b599e6f84378909929d7786044b9de7b2dcc8d75f90ad812bd546a6f6a5");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Summer Bundle Widget on Dashboard", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From Page": properties.fromPage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Summer Bundle Widget on Dashboard: This event will be fired when the user clicks anywhere on the summer bundle from the Dashboard or Summer Learning Page
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/asUSLvDngp/trigger/UGKMiQTf6
   * 2. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/asUSLvDngp/trigger/uyemAmxbf
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/asUSLvDngp}
   */
  function interactedSummerBundleWidgetOnDashboard(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Summer Bundle Widget on Dashboard", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "fromPage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "asUSLvDngp", "f34128afcb32bc0eee71727f9137defaea555a7316af468aab19ca919abf8fb9", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Summer Bundle Widget on Dashboard", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "From Page": properties.fromPage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("asUSLvDngp", "Interacted Summer Bundle Widget on Dashboard", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Summer Bundle Widget on Dashboard': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Summer Bundle Widget on Dashboard", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "From Page": properties.fromPage,
          "Screen Height": sysScreenHeight,
          }, "asUSLvDngp", "f34128afcb32bc0eee71727f9137defaea555a7316af468aab19ca919abf8fb9");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Summer Bundle Widget on Dashboard", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "From Page": properties.fromPage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Clicked Support: Adding support options in the drawer after user interacts with parent button on web and menu on iphone/ipad
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/b7Fowsgevb}
   */
  function clickedSupport(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Clicked Support", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "grade",
        "elaGrade",
        "mathGrade",
        "mode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "b7Fowsgevb", "a3ddbf4e43b5be5f766b7acf3a5eaf65cc603668abd583a940328d7f825a8d64", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Clicked Support", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("b7Fowsgevb", "Clicked Support", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Clicked Support': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Clicked Support", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Screen Height": sysScreenHeight,
          }, "b7Fowsgevb", "a3ddbf4e43b5be5f766b7acf3a5eaf65cc603668abd583a940328d7f825a8d64");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Clicked Support", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Visited All Plans Page: When the user views all the plans
   * 
   * When to trigger this event:
   * 1. When the user lands on the plans page
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/b7-QDNo3YF/trigger/u_9cq7KU4
   * 2. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/b7-QDNo3YF/trigger/UyA96dpiL
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {int} properties.freeActivitiesLeftCount - Stores the number of free activities left for the user to play on a particular day, at that moment

   * @param {Array<string>} [properties.subscriptionPlansShown] - Stores which plans were shown on the plan page. 
Possible values are (Premium, Premium Live)
   * @param {Array<string>} [properties.subscriptionPlanStartsFromAmount] - Stores the 'Start from $ amount' shown to the user on each plan, on the Plan page.
   * @param {string} [properties.freeWorksheetsLeftCount] - Stores the number of free worksheets left for the user to play on a particular day, at that moment
   * @param {string} [properties.discountOfferingCodeApplied] - For users opening the plan page after clicking on a CRM campaign email link, this property stores the coupon-code which was applied for the user.
   * @param {string} [properties.discountType] - Can take the value 'First-time' or 'Perpetual' to indicate the number of cycles for which the discount is applied.
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {string} properties.tabCode - Specifies the tab which has been opened in the event 'Viewed Tiled Dashboard' and Other events too
   * @param {string} properties.purchaseClickId - Unique ID associated with each purchase flow. Gets reset when the user exits the purchase flowing (irrespective of successful or unsuccessful purchase)
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/b7-QDNo3YF}
   */
  function visitedAllPlansPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertFreeActivitiesLeftCount(properties.freeActivitiesLeftCount));
      messages = messages.concat(assertOptionalSubscriptionPlansShown(properties.subscriptionPlansShown));
      messages = messages.concat(assertOptionalSubscriptionPlanStartsFromAmount(properties.subscriptionPlanStartsFromAmount));
      messages = messages.concat(assertOptionalFreeWorksheetsLeftCount(properties.freeWorksheetsLeftCount));
      messages = messages.concat(assertOptionalDiscountOfferingCodeApplied(properties.discountOfferingCodeApplied));
      messages = messages.concat(assertOptionalDiscountType(properties.discountType));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertTabCode(properties.tabCode));
      messages = messages.concat(assertPurchaseClickID(properties.purchaseClickId));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Visited All Plans Page", Object.keys(properties), [
        "freeActivitiesLeftCount",
        "subscriptionPlansShown",
        "subscriptionPlanStartsFromAmount",
        "freeWorksheetsLeftCount",
        "discountOfferingCodeApplied",
        "discountType",
        "from",
        "tabCode",
        "purchaseClickId"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "b7-QDNo3YF", "a906aa86b5902403a9c9ff74c6a8cabec2f01b50fb179afd705b31e4cdd20207", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Visited All Plans Page", {
        "Free Activities Left Count": properties.freeActivitiesLeftCount,
        "Subscription Plans Shown": properties.subscriptionPlansShown,
        "Subscription Plan Starts From Amount": properties.subscriptionPlanStartsFromAmount,
        "Free Worksheets Left Count": properties.freeWorksheetsLeftCount,
        "Discount Offering Code Applied": properties.discountOfferingCodeApplied,
        "Discount Type": properties.discountType,
        "From": properties.from,
        "Tab Code": properties.tabCode,
        "Purchase Click ID": properties.purchaseClickId,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("b7-QDNo3YF", "Visited All Plans Page", messages, [
        {id: "1sxa4mA1P", name: "Purchase Click ID", value: properties.purchaseClickId},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "H4pP9av1w", name: "Free Worksheets Left Count", value: properties.freeWorksheetsLeftCount},
        {id: "VUkpaROVL", name: "Discount Offering Code Applied", value: properties.discountOfferingCodeApplied},
        {id: "VdxNoqe4b", name: "Discount Type", value: properties.discountType},
        {id: "XIwdg9nE7", name: "Subscription Plan Starts From Amount", value: properties.subscriptionPlanStartsFromAmount},
        {id: "l9PbANZBu", name: "Tab Code", value: properties.tabCode},
        {id: "pJEe4G1yr", name: "Subscription Plans Shown", value: properties.subscriptionPlansShown},
        {id: "zY_qKY7KjA", name: "Free Activities Left Count", value: properties.freeActivitiesLeftCount},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Visited All Plans Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Visited All Plans Page", {
          "Free Activities Left Count": properties.freeActivitiesLeftCount,
          "Subscription Plans Shown": properties.subscriptionPlansShown,
          "Subscription Plan Starts From Amount": properties.subscriptionPlanStartsFromAmount,
          "Free Worksheets Left Count": properties.freeWorksheetsLeftCount,
          "Discount Offering Code Applied": properties.discountOfferingCodeApplied,
          "Discount Type": properties.discountType,
          "From": properties.from,
          "Tab Code": properties.tabCode,
          "Purchase Click ID": properties.purchaseClickId,
          "Screen Height": sysScreenHeight,
          }, "b7-QDNo3YF", "a906aa86b5902403a9c9ff74c6a8cabec2f01b50fb179afd705b31e4cdd20207");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Visited All Plans Page", {
      "Free Activities Left Count": properties.freeActivitiesLeftCount,
      "Subscription Plans Shown": properties.subscriptionPlansShown,
      "Subscription Plan Starts From Amount": properties.subscriptionPlanStartsFromAmount,
      "Free Worksheets Left Count": properties.freeWorksheetsLeftCount,
      "Discount Offering Code Applied": properties.discountOfferingCodeApplied,
      "Discount Type": properties.discountType,
      "From": properties.from,
      "Tab Code": properties.tabCode,
      "Purchase Click ID": properties.purchaseClickId,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted All Plans Page: When the user clicks on any elements on the plan page
   * 
   * When to trigger this event:
   * 1. When the user clicks on these elements on the plan page
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/NG8X0Q79Sz/trigger/zf6jvrKds
   * 2. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/NG8X0Q79Sz/trigger/kdWlZkhbf
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} [properties.subscriptionPlanName] - Stores the plan names i.e. Premium, Premium Live
   * @param {string} properties.section - This will capture the widget name that is being viewed/interacted by the user in that viewport. For example, 'Onboarding Widget', 'Home Access Widget', 'Assignment Widget', 'Assessment Widget', 'Math Fact Widget'
The list will only have 1 value for 'Section' property for Interacted event.
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {string} properties.tabCode - Specifies the tab which has been opened in the event 'Viewed Tiled Dashboard' and Other events too
   * @param {string} properties.purchaseClickId - Unique ID associated with each purchase flow. Gets reset when the user exits the purchase flowing (irrespective of successful or unsuccessful purchase)
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/NG8X0Q79Sz}
   */
  function interactedAllPlansPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertOptionalSubscriptionPlanName(properties.subscriptionPlanName));
      messages = messages.concat(assertSection(properties.section));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertTabCode(properties.tabCode));
      messages = messages.concat(assertPurchaseClickID(properties.purchaseClickId));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted All Plans Page", Object.keys(properties), [
        "clickedOn",
        "subscriptionPlanName",
        "section",
        "from",
        "tabCode",
        "purchaseClickId"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "NG8X0Q79Sz", "217b039a9a8b4ee896f6a302e83bac81e1c3d82aa851f90dc7c57f05d76a6859", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted All Plans Page", {
        "Clicked On": properties.clickedOn,
        "Subscription Plan Name": properties.subscriptionPlanName,
        "Section": properties.section,
        "From": properties.from,
        "Tab Code": properties.tabCode,
        "Purchase Click ID": properties.purchaseClickId,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("NG8X0Q79Sz", "Interacted All Plans Page", messages, [
        {id: "1sxa4mA1P", name: "Purchase Click ID", value: properties.purchaseClickId},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "eOj3JBu_S", name: "Subscription Plan Name", value: properties.subscriptionPlanName},
        {id: "l9PbANZBu", name: "Tab Code", value: properties.tabCode},
        {id: "my9qL7M8w6", name: "Section", value: properties.section},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted All Plans Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted All Plans Page", {
          "Clicked On": properties.clickedOn,
          "Subscription Plan Name": properties.subscriptionPlanName,
          "Section": properties.section,
          "From": properties.from,
          "Tab Code": properties.tabCode,
          "Purchase Click ID": properties.purchaseClickId,
          "Screen Height": sysScreenHeight,
          }, "NG8X0Q79Sz", "217b039a9a8b4ee896f6a302e83bac81e1c3d82aa851f90dc7c57f05d76a6859");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted All Plans Page", {
      "Clicked On": properties.clickedOn,
      "Subscription Plan Name": properties.subscriptionPlanName,
      "Section": properties.section,
      "From": properties.from,
      "Tab Code": properties.tabCode,
      "Purchase Click ID": properties.purchaseClickId,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Visited Plan Purchase Combined Page: Triggers when user lands on the Plan duration selection & Purchase Summary page
   * 
   * When to trigger this event:
   * 1. Triggers when user lands on the Plan duration selection & Purchase Summary page
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/2npJbVzs2F/trigger/QR3Ijuxsy
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.googlePayButtonAvailable] - Stores whether the Google Pay button was visible to the user or not
   * @param {string} [properties.validSavedCardExists] - Stores whether there is a valid (non-expired) card (debit/credit) that is already saved in user's SplashLearn account.
When this is available, the user can just use the saved card to make the payment OR can add another payment method if she wants.
   * @param {int} [properties.planAmount] - Stores the amount/price of the plan
   * @param {string} [properties.subscriptionPlanName] - Stores the plan names i.e. Premium, Premium Live
   * @param {string} [properties.subscriptionPlan] - Stores the cycle/duration of the plan that the user is buying.
Possible values are (Yearly, Monthly, Family, Quarterly)
   * @param {string} [properties.paymentElementsRendered] - We have 3 ways of rendering the payment methods. 2 from Stripe and 1 from Paypal. This property distinguishes between those three.

Values:
- Old Credit Card Element
- New Payment Element
- Paypal Element
   * @param {string} [properties.cardType] - Stores the card type of the payment method.
   * @param {string} [properties.wallet] - Stores which wallet has the user used to make the payment for the plan.
Values = (googlePay, applePay)
   * @param {string} [properties.stripePaymentMethodInfo] - Stores the type of payment method through which the user is making a payment

Values will include:
- cards
- digital wallets
- bank debits
- bank redirects
- bank transfers
- BNPL
- cash-based vouchers
- real time payment
   * @param {string} [properties.stripePaymentMethodInfoFrontend] - Stores the type of payment method through which the user is making a payment (To be used only for the Frontend events)

Values will include:
- cards
- digital wallets
- bank debits
- bank redirects
- bank transfers
- BNPL
- cash-based vouchers
- real time payment
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {string} properties.tabCode - Specifies the tab which has been opened in the event 'Viewed Tiled Dashboard' and Other events too
   * @param {string} properties.purchaseClickId - Unique ID associated with each purchase flow. Gets reset when the user exits the purchase flowing (irrespective of successful or unsuccessful purchase)
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/2npJbVzs2F}
   */
  function visitedPlanPurchaseCombinedPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalGooglePayButtonAvailable(properties.googlePayButtonAvailable));
      messages = messages.concat(assertOptionalValidSavedCardExists(properties.validSavedCardExists));
      messages = messages.concat(assertOptionalPlanAmount(properties.planAmount));
      messages = messages.concat(assertOptionalSubscriptionPlanName(properties.subscriptionPlanName));
      messages = messages.concat(assertOptionalSubscriptionPlan(properties.subscriptionPlan));
      messages = messages.concat(assertOptionalPaymentElementsRendered(properties.paymentElementsRendered));
      messages = messages.concat(assertOptionalCardType(properties.cardType));
      messages = messages.concat(assertOptionalWallet(properties.wallet));
      messages = messages.concat(assertOptionalStripePaymentMethodInfo(properties.stripePaymentMethodInfo));
      messages = messages.concat(assertOptionalStripePaymentMethodInfoFrontend(properties.stripePaymentMethodInfoFrontend));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertTabCode(properties.tabCode));
      messages = messages.concat(assertPurchaseClickID(properties.purchaseClickId));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Visited Plan Purchase Combined Page", Object.keys(properties), [
        "googlePayButtonAvailable",
        "validSavedCardExists",
        "planAmount",
        "subscriptionPlanName",
        "subscriptionPlan",
        "paymentElementsRendered",
        "cardType",
        "wallet",
        "stripePaymentMethodInfo",
        "stripePaymentMethodInfoFrontend",
        "from",
        "tabCode",
        "purchaseClickId"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "2npJbVzs2F", "d96ec31188f3ad93a992358dfb7cf2011b2c9eb111dae9cbac30f45fbdaa79b9", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Visited Plan Purchase Combined Page", {
        "Google Pay Button Available": properties.googlePayButtonAvailable,
        "Valid Saved Card Exists": properties.validSavedCardExists,
        "Plan Amount": properties.planAmount,
        "Subscription Plan Name": properties.subscriptionPlanName,
        "Subscription Plan": properties.subscriptionPlan,
        "Payment Elements Rendered": properties.paymentElementsRendered,
        "Card Type": properties.cardType,
        "Wallet": properties.wallet,
        "Stripe Payment Method Info": properties.stripePaymentMethodInfo,
        "Stripe Payment Method Info Frontend": properties.stripePaymentMethodInfoFrontend,
        "From": properties.from,
        "Tab Code": properties.tabCode,
        "Purchase Click ID": properties.purchaseClickId,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("2npJbVzs2F", "Visited Plan Purchase Combined Page", messages, [
        {id: "1sxa4mA1P", name: "Purchase Click ID", value: properties.purchaseClickId},
        {id: "3kx20gfYw", name: "Stripe Payment Method Info", value: properties.stripePaymentMethodInfo},
        {id: "8ATWzSmrM", name: "Plan Amount", value: properties.planAmount},
        {id: "AjgnWgaBe", name: "Payment Elements Rendered", value: properties.paymentElementsRendered},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "G8FSLVPgG", name: "Wallet", value: properties.wallet},
        {id: "N8pv_Xjhj", name: "Subscription Plan", value: properties.subscriptionPlan},
        {id: "SMxi3L9R_W", name: "Stripe Payment Method Info Frontend", value: properties.stripePaymentMethodInfoFrontend},
        {id: "WZ4UUsQFg", name: "Card Type", value: properties.cardType},
        {id: "eOj3JBu_S", name: "Subscription Plan Name", value: properties.subscriptionPlanName},
        {id: "l9PbANZBu", name: "Tab Code", value: properties.tabCode},
        {id: "o_O7Lq7wz", name: "Valid Saved Card Exists", value: properties.validSavedCardExists},
        {id: "pMtnCZl-R", name: "Google Pay Button Available", value: properties.googlePayButtonAvailable},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Visited Plan Purchase Combined Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Visited Plan Purchase Combined Page", {
          "Google Pay Button Available": properties.googlePayButtonAvailable,
          "Valid Saved Card Exists": properties.validSavedCardExists,
          "Plan Amount": properties.planAmount,
          "Subscription Plan Name": properties.subscriptionPlanName,
          "Subscription Plan": properties.subscriptionPlan,
          "Payment Elements Rendered": properties.paymentElementsRendered,
          "Card Type": properties.cardType,
          "Wallet": properties.wallet,
          "Stripe Payment Method Info": properties.stripePaymentMethodInfo,
          "Stripe Payment Method Info Frontend": properties.stripePaymentMethodInfoFrontend,
          "From": properties.from,
          "Tab Code": properties.tabCode,
          "Purchase Click ID": properties.purchaseClickId,
          "Screen Height": sysScreenHeight,
          }, "2npJbVzs2F", "d96ec31188f3ad93a992358dfb7cf2011b2c9eb111dae9cbac30f45fbdaa79b9");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Visited Plan Purchase Combined Page", {
      "Google Pay Button Available": properties.googlePayButtonAvailable,
      "Valid Saved Card Exists": properties.validSavedCardExists,
      "Plan Amount": properties.planAmount,
      "Subscription Plan Name": properties.subscriptionPlanName,
      "Subscription Plan": properties.subscriptionPlan,
      "Payment Elements Rendered": properties.paymentElementsRendered,
      "Card Type": properties.cardType,
      "Wallet": properties.wallet,
      "Stripe Payment Method Info": properties.stripePaymentMethodInfo,
      "Stripe Payment Method Info Frontend": properties.stripePaymentMethodInfoFrontend,
      "From": properties.from,
      "Tab Code": properties.tabCode,
      "Purchase Click ID": properties.purchaseClickId,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Plan Purchase Combined Page: When the user clicks on Elements on th Plan Duration Selection or Purchase Summary Page
   * 
   * When to trigger this event:
   * 1. When the user clicks on Elements on th Plan Duration Selection or Purchase Summary Page
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/DDAYoIhJd0/trigger/x9tZN_auX
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} [properties.subscriptionPlanName] - Stores the plan names i.e. Premium, Premium Live
   * @param {string} [properties.subscriptionPlan] - Stores the cycle/duration of the plan that the user is buying.
Possible values are (Yearly, Monthly, Family, Quarterly)
   * @param {string} [properties.wallet] - Stores which wallet has the user used to make the payment for the plan.
Values = (googlePay, applePay)
   * @param {int} [properties.planAmount] - Stores the amount/price of the plan
   * @param {string} [properties.cardType] - Stores the card type of the payment method.
   * @param {string} [properties.interactionDetails] - Stores where is the user interacting with the page
   * @param {string} [properties.paymentMethodClicked] - This property captures the Payment method tab selected by the user
Possible value are: cards, googlePay, applePay
   * @param {string} [properties.stripePaymentMethodInfo] - Stores the type of payment method through which the user is making a payment

Values will include:
- cards
- digital wallets
- bank debits
- bank redirects
- bank transfers
- BNPL
- cash-based vouchers
- real time payment
   * @param {string} [properties.errorMessage] - Error message shown to the user.
   * @param {string} [properties.stripeCountry] - Value of country as auto-detected by Stripe
   * @param {string} [properties.stripePaymentMethodInfoFrontend] - Stores the type of payment method through which the user is making a payment (To be used only for the Frontend events)

Values will include:
- cards
- digital wallets
- bank debits
- bank redirects
- bank transfers
- BNPL
- cash-based vouchers
- real time payment
   * @param {string} [properties.paypalCountry] - Country selected by the user in PayPal's Country selection dropdown menu
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {string} properties.tabCode - Specifies the tab which has been opened in the event 'Viewed Tiled Dashboard' and Other events too
   * @param {string} properties.purchaseClickId - Unique ID associated with each purchase flow. Gets reset when the user exits the purchase flowing (irrespective of successful or unsuccessful purchase)
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/DDAYoIhJd0}
   */
  function interactedPlanPurchaseCombinedPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertOptionalSubscriptionPlanName(properties.subscriptionPlanName));
      messages = messages.concat(assertOptionalSubscriptionPlan(properties.subscriptionPlan));
      messages = messages.concat(assertOptionalWallet(properties.wallet));
      messages = messages.concat(assertOptionalPlanAmount(properties.planAmount));
      messages = messages.concat(assertOptionalCardType(properties.cardType));
      messages = messages.concat(assertOptionalInteractionDetails(properties.interactionDetails));
      messages = messages.concat(assertOptionalPaymentMethodClicked(properties.paymentMethodClicked));
      messages = messages.concat(assertOptionalStripePaymentMethodInfo(properties.stripePaymentMethodInfo));
      messages = messages.concat(assertOptionalErrorMessage(properties.errorMessage));
      messages = messages.concat(assertOptionalStripeCountry(properties.stripeCountry));
      messages = messages.concat(assertOptionalStripePaymentMethodInfoFrontend(properties.stripePaymentMethodInfoFrontend));
      messages = messages.concat(assertOptionalPaypalCountry(properties.paypalCountry));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertTabCode(properties.tabCode));
      messages = messages.concat(assertPurchaseClickID(properties.purchaseClickId));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Plan Purchase Combined Page", Object.keys(properties), [
        "clickedOn",
        "subscriptionPlanName",
        "subscriptionPlan",
        "wallet",
        "planAmount",
        "cardType",
        "interactionDetails",
        "paymentMethodClicked",
        "stripePaymentMethodInfo",
        "errorMessage",
        "stripeCountry",
        "stripePaymentMethodInfoFrontend",
        "paypalCountry",
        "from",
        "tabCode",
        "purchaseClickId"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "DDAYoIhJd0", "9b7270aa678f74f8290eb4ef07f9fda611a9489493e5e79658693c2e467235eb", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Plan Purchase Combined Page", {
        "Clicked On": properties.clickedOn,
        "Subscription Plan Name": properties.subscriptionPlanName,
        "Subscription Plan": properties.subscriptionPlan,
        "Wallet": properties.wallet,
        "Plan Amount": properties.planAmount,
        "Card Type": properties.cardType,
        "Interaction Details": properties.interactionDetails,
        "Payment Method Clicked": properties.paymentMethodClicked,
        "Stripe Payment Method Info": properties.stripePaymentMethodInfo,
        "Error Message": properties.errorMessage,
        "Stripe Country": properties.stripeCountry,
        "Stripe Payment Method Info Frontend": properties.stripePaymentMethodInfoFrontend,
        "Paypal Country": properties.paypalCountry,
        "From": properties.from,
        "Tab Code": properties.tabCode,
        "Purchase Click ID": properties.purchaseClickId,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("DDAYoIhJd0", "Interacted Plan Purchase Combined Page", messages, [
        {id: "-NRkASDdl", name: "Stripe Country", value: properties.stripeCountry},
        {id: "1n3Bq4GKWy", name: "Error Message", value: properties.errorMessage},
        {id: "1sxa4mA1P", name: "Purchase Click ID", value: properties.purchaseClickId},
        {id: "3kx20gfYw", name: "Stripe Payment Method Info", value: properties.stripePaymentMethodInfo},
        {id: "8ATWzSmrM", name: "Plan Amount", value: properties.planAmount},
        {id: "CNxDRbOnm", name: "Paypal Country", value: properties.paypalCountry},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "G8FSLVPgG", name: "Wallet", value: properties.wallet},
        {id: "N8pv_Xjhj", name: "Subscription Plan", value: properties.subscriptionPlan},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "SMxi3L9R_W", name: "Stripe Payment Method Info Frontend", value: properties.stripePaymentMethodInfoFrontend},
        {id: "WZ4UUsQFg", name: "Card Type", value: properties.cardType},
        {id: "dVRLZ1nWs", name: "Payment Method Clicked", value: properties.paymentMethodClicked},
        {id: "eOj3JBu_S", name: "Subscription Plan Name", value: properties.subscriptionPlanName},
        {id: "l9PbANZBu", name: "Tab Code", value: properties.tabCode},
        {id: "ncdYto9gZ", name: "Interaction Details", value: properties.interactionDetails},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Plan Purchase Combined Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Plan Purchase Combined Page", {
          "Clicked On": properties.clickedOn,
          "Subscription Plan Name": properties.subscriptionPlanName,
          "Subscription Plan": properties.subscriptionPlan,
          "Wallet": properties.wallet,
          "Plan Amount": properties.planAmount,
          "Card Type": properties.cardType,
          "Interaction Details": properties.interactionDetails,
          "Payment Method Clicked": properties.paymentMethodClicked,
          "Stripe Payment Method Info": properties.stripePaymentMethodInfo,
          "Error Message": properties.errorMessage,
          "Stripe Country": properties.stripeCountry,
          "Stripe Payment Method Info Frontend": properties.stripePaymentMethodInfoFrontend,
          "Paypal Country": properties.paypalCountry,
          "From": properties.from,
          "Tab Code": properties.tabCode,
          "Purchase Click ID": properties.purchaseClickId,
          "Screen Height": sysScreenHeight,
          }, "DDAYoIhJd0", "9b7270aa678f74f8290eb4ef07f9fda611a9489493e5e79658693c2e467235eb");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Plan Purchase Combined Page", {
      "Clicked On": properties.clickedOn,
      "Subscription Plan Name": properties.subscriptionPlanName,
      "Subscription Plan": properties.subscriptionPlan,
      "Wallet": properties.wallet,
      "Plan Amount": properties.planAmount,
      "Card Type": properties.cardType,
      "Interaction Details": properties.interactionDetails,
      "Payment Method Clicked": properties.paymentMethodClicked,
      "Stripe Payment Method Info": properties.stripePaymentMethodInfo,
      "Error Message": properties.errorMessage,
      "Stripe Country": properties.stripeCountry,
      "Stripe Payment Method Info Frontend": properties.stripePaymentMethodInfoFrontend,
      "Paypal Country": properties.paypalCountry,
      "From": properties.from,
      "Tab Code": properties.tabCode,
      "Purchase Click ID": properties.purchaseClickId,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Payment Form Error: Stores the errors that Stripe shares with us when the user is inputting the payment method details and clicks on CTA (Start Trial or Buy) after which the payment starts processing by Stripe.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ZSm-4GGLV8/trigger/R0yTLYkJ7
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.errorCode] - Captures the error on the Payment form
   * @param {string} [properties.paymentElementsRendered] - We have 3 ways of rendering the payment methods. 2 from Stripe and 1 from Paypal. This property distinguishes between those three.

Values:
- Old Credit Card Element
- New Payment Element
- Paypal Element
   * @param {string} [properties.errorMessage] - Error message shown to the user.
   * @param {string} [properties.errorStep] - Defines at which step did the payment journey fail. Possible values are:

1. confirm_setup_failed : there was some issue in adding payment method
2. parent_creation_failed : only PTL flow
3. set_default_payment_method_failed
4. subscribe_product_failed
   * @param {string} [properties.errorMessageFromApi] - In case of Payment Failures during the user starting a trial or paying for the subscriptions, this will capture the failure message received from APIs.
   * @param {string} [properties.setupIntentStatus] - This property will capture the status of the Payment Method Setup Intent.
Possible values are  {succeeded, requires_payment_method, canceled }
   * @param {string} [properties.setupIntentId] - This will store the unique Payment Setup Intent ID when the user adds a Payment Method to start a trial or purchase.
This will be a alphanumeric ID like 'Distinct_ID' and will mainly be used for tech debugging.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ZSm-4GGLV8}
   */
  function paymentFormError(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalErrorCode(properties.errorCode));
      messages = messages.concat(assertOptionalPaymentElementsRendered(properties.paymentElementsRendered));
      messages = messages.concat(assertOptionalErrorMessage(properties.errorMessage));
      messages = messages.concat(assertOptionalErrorStep(properties.errorStep));
      messages = messages.concat(assertOptionalErrorMessageFromApi(properties.errorMessageFromApi));
      messages = messages.concat(assertOptionalSetupIntentStatus(properties.setupIntentStatus));
      messages = messages.concat(assertOptionalSetupIntentId(properties.setupIntentId));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Payment Form Error", Object.keys(properties), [
        "errorCode",
        "paymentElementsRendered",
        "errorMessage",
        "errorStep",
        "errorMessageFromApi",
        "setupIntentStatus",
        "setupIntentId"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ZSm-4GGLV8", "050d438de3acb161a832da158d08b7687a403feae710ff08e0b6a8d469db8c01", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Payment Form Error", {
        "Error Code": properties.errorCode,
        "Payment Elements Rendered": properties.paymentElementsRendered,
        "Error Message": properties.errorMessage,
        "Error Step": properties.errorStep,
        "Error Message From Api": properties.errorMessageFromApi,
        "Setup Intent Status": properties.setupIntentStatus,
        "Setup Intent Id": properties.setupIntentId,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ZSm-4GGLV8", "Payment Form Error", messages, [
        {id: "1n3Bq4GKWy", name: "Error Message", value: properties.errorMessage},
        {id: "AjgnWgaBe", name: "Payment Elements Rendered", value: properties.paymentElementsRendered},
        {id: "CGZP6dYmm", name: "Setup Intent Status", value: properties.setupIntentStatus},
        {id: "JSl62lgk3", name: "Error Code", value: properties.errorCode},
        {id: "PFXfXOuvy", name: "Setup Intent Id", value: properties.setupIntentId},
        {id: "rbMXuJsBw", name: "Error Message From Api", value: properties.errorMessageFromApi},
        {id: "zagTegBN_", name: "Error Step", value: properties.errorStep},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Payment Form Error': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Payment Form Error", {
          "Error Code": properties.errorCode,
          "Payment Elements Rendered": properties.paymentElementsRendered,
          "Error Message": properties.errorMessage,
          "Error Step": properties.errorStep,
          "Error Message From Api": properties.errorMessageFromApi,
          "Setup Intent Status": properties.setupIntentStatus,
          "Setup Intent Id": properties.setupIntentId,
          "Screen Height": sysScreenHeight,
          }, "ZSm-4GGLV8", "050d438de3acb161a832da158d08b7687a403feae710ff08e0b6a8d469db8c01");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Payment Form Error", {
      "Error Code": properties.errorCode,
      "Payment Elements Rendered": properties.paymentElementsRendered,
      "Error Message": properties.errorMessage,
      "Error Step": properties.errorStep,
      "Error Message From Api": properties.errorMessageFromApi,
      "Setup Intent Status": properties.setupIntentStatus,
      "Setup Intent Id": properties.setupIntentId,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Completed Page Scroll: When the user scrolls to the bottom of the page (on both Plan page & Purchase Summary page).
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.pageName - Includes the name of the page (Eg: Playzone game listing page, ). This is not the URL but a easily understandable definition of what page is the user at.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/bzUwO7cozC}
   */
  function completedPageScroll(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPageName(properties.pageName));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Completed Page Scroll", Object.keys(properties), [
        "pageName"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "bzUwO7cozC", "db139d9494970b6f29b1e606e68dfe1af797da9e74f318d6ffa514ee6488b3b0", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Completed Page Scroll", {
        "Page Name": properties.pageName,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("bzUwO7cozC", "Completed Page Scroll", messages, [
        {id: "MJKSzmqfHu", name: "Page Name", value: properties.pageName},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Completed Page Scroll': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Completed Page Scroll", {
          "Page Name": properties.pageName,
          "Screen Height": sysScreenHeight,
          }, "bzUwO7cozC", "db139d9494970b6f29b1e606e68dfe1af797da9e74f318d6ffa514ee6488b3b0");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Completed Page Scroll", {
      "Page Name": properties.pageName,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Child Profile Page Interacted: When child profile page is clicked/tapped
   * 
   * When to trigger this event:
   * 1. When user interacts with the different element of this page.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/1rXIJYd5_X/trigger/54kmkckPb
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {int} properties.childLevel - This stores the level of the child
   * @param {int} properties.snCount - This stores the count of super novas a child has
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.notificationSource - This property will store the source of the notification -> if it has come from intrusive nudge or subtle nudge (will come later) for avatar items
   * @param {bool} properties.pendingNotification - This property shows if there is any notification in the closer space. Notifications will be shown in the form of numbers on the category which got some new items unlocked. Stores Yes/No
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/1rXIJYd5_X}
   */
  function childProfilePageInteracted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertChildLevel(properties.childLevel));
      messages = messages.concat(assertSnCount(properties.snCount));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertNotificationSource(properties.notificationSource));
      messages = messages.concat(assertPendingNotification(properties.pendingNotification));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Child Profile Page Interacted", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "clickedOn",
        "childLevel",
        "snCount",
        "elaGrade",
        "grade",
        "notificationSource",
        "pendingNotification"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "1rXIJYd5_X", "7c1bcdeb7cc6e5cc1be192167f6faac54e87a18cab933507f8add24795ce6704", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Child Profile Page Interacted", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Clicked On": properties.clickedOn,
        "Child Level": properties.childLevel,
        "Sn Count": properties.snCount,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Notification Source": properties.notificationSource,
        "Pending Notification": properties.pendingNotification,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("1rXIJYd5_X", "Child Profile Page Interacted", messages, [
        {id: "0zT29qODq6yxzJjbmuRzz", name: "Notification Source", value: properties.notificationSource},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "fIB6sY9mt", name: "Child Level", value: properties.childLevel},
        {id: "ggXrRwik-", name: "Sn Count", value: properties.snCount},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "zCFxLL-Ai", name: "Pending Notification", value: properties.pendingNotification},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Child Profile Page Interacted': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Child Profile Page Interacted", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Clicked On": properties.clickedOn,
          "Child Level": properties.childLevel,
          "Sn Count": properties.snCount,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Notification Source": properties.notificationSource,
          "Pending Notification": properties.pendingNotification,
          "Screen Height": sysScreenHeight,
          }, "1rXIJYd5_X", "7c1bcdeb7cc6e5cc1be192167f6faac54e87a18cab933507f8add24795ce6704");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Child Profile Page Interacted", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Clicked On": properties.clickedOn,
      "Child Level": properties.childLevel,
      "Sn Count": properties.snCount,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Notification Source": properties.notificationSource,
      "Pending Notification": properties.pendingNotification,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Coachmark [B2B]: This event will be fired when the user views the coachmark anywhere on our product.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ExitnhGuRA/trigger/96tpqdAQs
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {string} properties.section - This will capture the widget name that is being viewed/interacted by the user in that viewport. For example, 'Onboarding Widget', 'Home Access Widget', 'Assignment Widget', 'Assessment Widget', 'Math Fact Widget'
The list will only have 1 value for 'Section' property for Interacted event.
   * @param {string} properties.coachmarkText - This will capture the text of the coachmark. Example, 'Add a co-teacher to your class & get ready for a seamless class transfer through the next school year.'
   * @param {string} properties.coachmarkName - This will capture name of coachmark that appears.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ExitnhGuRA}
   */
  function viewedCoachmarkB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertSection(properties.section));
      messages = messages.concat(assertCoachmarkText(properties.coachmarkText));
      messages = messages.concat(assertCoachmarkName(properties.coachmarkName));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Coachmark [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "from",
        "section",
        "coachmarkText",
        "coachmarkName"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ExitnhGuRA", "25496d4b9af841ddfb2d551e0e6babf4535e40f6ff675f0a1acf05620bd8e094", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Coachmark [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From": properties.from,
        "Section": properties.section,
        "Coachmark Text": properties.coachmarkText,
        "Coachmark Name": properties.coachmarkName,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ExitnhGuRA", "Viewed Coachmark [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "htmKRbaew", name: "Coachmark Text", value: properties.coachmarkText},
        {id: "my9qL7M8w6", name: "Section", value: properties.section},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "rZrsY9rgC", name: "Coachmark Name", value: properties.coachmarkName},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Coachmark [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Coachmark [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From": properties.from,
          "Section": properties.section,
          "Coachmark Text": properties.coachmarkText,
          "Coachmark Name": properties.coachmarkName,
          "Screen Height": sysScreenHeight,
          }, "ExitnhGuRA", "25496d4b9af841ddfb2d551e0e6babf4535e40f6ff675f0a1acf05620bd8e094");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Coachmark [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From": properties.from,
      "Section": properties.section,
      "Coachmark Text": properties.coachmarkText,
      "Coachmark Name": properties.coachmarkName,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Coachmark [B2B]: This event will be fired when the user interacts with the coachmark anywhere on our product.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/GfMIIgbl9/trigger/M151qEtzS
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {string} properties.section - This will capture the widget name that is being viewed/interacted by the user in that viewport. For example, 'Onboarding Widget', 'Home Access Widget', 'Assignment Widget', 'Assessment Widget', 'Math Fact Widget'
The list will only have 1 value for 'Section' property for Interacted event.
   * @param {string} properties.coachmarkText - This will capture the text of the coachmark. Example, 'Add a co-teacher to your class & get ready for a seamless class transfer through the next school year.'
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.coachmarkName - This will capture name of coachmark that appears.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/GfMIIgbl9}
   */
  function interactedCoachmarkB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertSection(properties.section));
      messages = messages.concat(assertCoachmarkText(properties.coachmarkText));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertCoachmarkName(properties.coachmarkName));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Coachmark [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "from",
        "section",
        "coachmarkText",
        "clickedOn",
        "coachmarkName"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "GfMIIgbl9", "9a79e97089b23558331d8700a1d634f3a4845927f77320cb831382caa5ada613", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Coachmark [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From": properties.from,
        "Section": properties.section,
        "Coachmark Text": properties.coachmarkText,
        "Clicked On": properties.clickedOn,
        "Coachmark Name": properties.coachmarkName,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("GfMIIgbl9", "Interacted Coachmark [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "htmKRbaew", name: "Coachmark Text", value: properties.coachmarkText},
        {id: "my9qL7M8w6", name: "Section", value: properties.section},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "rZrsY9rgC", name: "Coachmark Name", value: properties.coachmarkName},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Coachmark [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Coachmark [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From": properties.from,
          "Section": properties.section,
          "Coachmark Text": properties.coachmarkText,
          "Clicked On": properties.clickedOn,
          "Coachmark Name": properties.coachmarkName,
          "Screen Height": sysScreenHeight,
          }, "GfMIIgbl9", "9a79e97089b23558331d8700a1d634f3a4845927f77320cb831382caa5ada613");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Coachmark [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From": properties.from,
      "Section": properties.section,
      "Coachmark Text": properties.coachmarkText,
      "Clicked On": properties.clickedOn,
      "Coachmark Name": properties.coachmarkName,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Live Classes Freemium Pitch: Triggered when the live classes freemium pitch screen is viewed
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/NNdvQ27RyH/trigger/TntFfRs30
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/NNdvQ27RyH}
   */
  function viewedLiveClassesFreemiumPitch(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Live Classes Freemium Pitch", Object.keys(properties), [
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "NNdvQ27RyH", "9d1a5f360c775b81f818c547fead3b6fc634de313a11b06b89c5cda7367dee3b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Live Classes Freemium Pitch", {
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("NNdvQ27RyH", "Viewed Live Classes Freemium Pitch", messages, [
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Live Classes Freemium Pitch': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Live Classes Freemium Pitch", {
          "Screen Height": sysScreenHeight,
          }, "NNdvQ27RyH", "9d1a5f360c775b81f818c547fead3b6fc634de313a11b06b89c5cda7367dee3b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Live Classes Freemium Pitch", {
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Live Classes Freemium Pitch: Triggered when the live classes freemium pitch is interacted with
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/TV3VrmtL-/trigger/e61ts0A51
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/TV3VrmtL-}
   */
  function interactedLiveClassesFreemiumPitch(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Live Classes Freemium Pitch", Object.keys(properties), [
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "TV3VrmtL-", "f52d6e4cf71971aff6eb3ab53d589d4a572410c6a22a5c66a43b945bc6e9632e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Live Classes Freemium Pitch", {
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("TV3VrmtL-", "Interacted Live Classes Freemium Pitch", messages, [
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Live Classes Freemium Pitch': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Live Classes Freemium Pitch", {
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "TV3VrmtL-", "f52d6e4cf71971aff6eb3ab53d589d4a572410c6a22a5c66a43b945bc6e9632e");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Live Classes Freemium Pitch", {
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Class Preference Screen: Triggered when the user clicks on setup class invites / save your spot on the live classes freemium pitch screen
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/1CGajfxJ76/trigger/uo_EY8foL
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/1CGajfxJ76}
   */
  function viewedClassPreferenceScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Class Preference Screen", Object.keys(properties), [
        "platform",
        "elaGrade",
        "mathGrade",
        "mode",
        "userType",
        "signupFlow",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "1CGajfxJ76", "eae22ea5a7b42975fea1a657a2bb7d544375b9c0ee31d5134657f85f964d6fbe", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Class Preference Screen", {
        "Platform": properties.platform,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("1CGajfxJ76", "Viewed Class Preference Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Class Preference Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Class Preference Screen", {
          "Platform": properties.platform,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "1CGajfxJ76", "eae22ea5a7b42975fea1a657a2bb7d544375b9c0ee31d5134657f85f964d6fbe");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Class Preference Screen", {
      "Platform": properties.platform,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Class Preference Screen: Triggered when a user interacts with the class preference screen
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/6tQBiDq1UJ/trigger/OPv-tVeVT
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/6tQBiDq1UJ}
   */
  function interactedClassPreferenceScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Class Preference Screen", Object.keys(properties), [
        "clickedOn",
        "platform",
        "elaGrade",
        "mathGrade",
        "mode",
        "userType",
        "signupFlow",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "6tQBiDq1UJ", "9606f6c7b1857a689744a715aff07d4639a7ff35cccd362856c14d9ae71681f8", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Class Preference Screen", {
        "Clicked On": properties.clickedOn,
        "Platform": properties.platform,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("6tQBiDq1UJ", "Interacted Class Preference Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Class Preference Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Class Preference Screen", {
          "Clicked On": properties.clickedOn,
          "Platform": properties.platform,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "6tQBiDq1UJ", "9606f6c7b1857a689744a715aff07d4639a7ff35cccd362856c14d9ae71681f8");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Class Preference Screen", {
      "Clicked On": properties.clickedOn,
      "Platform": properties.platform,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Interest Confirmation Screen: Viewed confirmation screen after the user shares their interest and preference
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/53H04NApfS/trigger/Zd3Nx1liy
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/53H04NApfS}
   */
  function viewedInterestConfirmationScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Interest Confirmation Screen", Object.keys(properties), [
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "53H04NApfS", "1220c15d5e0f311560e872174aad6dd92917a576c3f45849dff7272d8cb59bb6", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Interest Confirmation Screen", {
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("53H04NApfS", "Viewed Interest Confirmation Screen", messages, [
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Interest Confirmation Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Interest Confirmation Screen", {
          "Screen Height": sysScreenHeight,
          }, "53H04NApfS", "1220c15d5e0f311560e872174aad6dd92917a576c3f45849dff7272d8cb59bb6");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Interest Confirmation Screen", {
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Interest Confirmation Screen: Triggered when the user interacts with the interest confirmation screen
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/qRA-_uGxJt/trigger/1sf39RDNg
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/qRA-_uGxJt}
   */
  function interactedInterestConfirmationScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Interest Confirmation Screen", Object.keys(properties), [
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "qRA-_uGxJt", "ce2d1a1c438e245796b862a8bcac68659e4150332483df2222ba83b5546651c0", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Interest Confirmation Screen", {
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("qRA-_uGxJt", "Interacted Interest Confirmation Screen", messages, [
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Interest Confirmation Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Interest Confirmation Screen", {
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "qRA-_uGxJt", "ce2d1a1c438e245796b862a8bcac68659e4150332483df2222ba83b5546651c0");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Interest Confirmation Screen", {
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Search Icon: When user clicks/taps on search bar
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/nQioCscWdp/trigger/BkLPsq_R3
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {string} properties.pageName - Includes the name of the page (Eg: Playzone game listing page, ). This is not the URL but a easily understandable definition of what page is the user at.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/nQioCscWdp}
   */
  function interactedSearchIcon(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertPageName(properties.pageName));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Search Icon", Object.keys(properties), [
        "platform",
        "elaGrade",
        "mathGrade",
        "mode",
        "userType",
        "signupFlow",
        "grade",
        "from",
        "pageName"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "nQioCscWdp", "aac44f54674ae2e3f126890f51e7c22debc4bbe5e3f641919544de4e2d910f5d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Search Icon", {
        "Platform": properties.platform,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "From": properties.from,
        "Page Name": properties.pageName,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("nQioCscWdp", "Interacted Search Icon", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "MJKSzmqfHu", name: "Page Name", value: properties.pageName},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Search Icon': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Search Icon", {
          "Platform": properties.platform,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "From": properties.from,
          "Page Name": properties.pageName,
          "Screen Height": sysScreenHeight,
          }, "nQioCscWdp", "aac44f54674ae2e3f126890f51e7c22debc4bbe5e3f641919544de4e2d910f5d");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Search Icon", {
      "Platform": properties.platform,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "From": properties.from,
      "Page Name": properties.pageName,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Typing Started on Search Bar: When user starts typing in search bar
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/GmXo02nCqu/trigger/wzKYlLko3
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {string} properties.pageName - Includes the name of the page (Eg: Playzone game listing page, ). This is not the URL but a easily understandable definition of what page is the user at.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/GmXo02nCqu}
   */
  function typingStartedOnSearchBar(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertPageName(properties.pageName));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Typing Started on Search Bar", Object.keys(properties), [
        "platform",
        "elaGrade",
        "mathGrade",
        "mode",
        "userType",
        "signupFlow",
        "grade",
        "from",
        "pageName"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "GmXo02nCqu", "b41a46446686ee991eb9baaa2705f0eddfc107d2a97420b6453788944670f4ae", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Typing Started on Search Bar", {
        "Platform": properties.platform,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "From": properties.from,
        "Page Name": properties.pageName,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("GmXo02nCqu", "Typing Started on Search Bar", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "MJKSzmqfHu", name: "Page Name", value: properties.pageName},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Typing Started on Search Bar': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Typing Started on Search Bar", {
          "Platform": properties.platform,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "From": properties.from,
          "Page Name": properties.pageName,
          "Screen Height": sysScreenHeight,
          }, "GmXo02nCqu", "b41a46446686ee991eb9baaa2705f0eddfc107d2a97420b6453788944670f4ae");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Typing Started on Search Bar", {
      "Platform": properties.platform,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "From": properties.from,
      "Page Name": properties.pageName,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Typing Stopped on Search Bar: When search results are shown to user 
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/qJLPqWk_no/trigger/Xq63gQNcZ
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {int} properties.numberOfResults - Number of results shown for search results
   * @param {string} properties.searchTerm - Term searched by the user
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {string} properties.pageName - Includes the name of the page (Eg: Playzone game listing page, ). This is not the URL but a easily understandable definition of what page is the user at.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/qJLPqWk_no}
   */
  function typingStoppedOnSearchBar(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertNumberOfResults(properties.numberOfResults));
      messages = messages.concat(assertSearchTerm(properties.searchTerm));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertPageName(properties.pageName));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Typing Stopped on Search Bar", Object.keys(properties), [
        "numberOfResults",
        "searchTerm",
        "platform",
        "elaGrade",
        "mathGrade",
        "mode",
        "userType",
        "signupFlow",
        "grade",
        "from",
        "pageName"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "qJLPqWk_no", "5c84061b1078dddc96a166e22ae29d11ea2e2712d23f5c4bc2d5994c1d87a2ff", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Typing Stopped on Search Bar", {
        "Number of Results": properties.numberOfResults,
        "Search Term": properties.searchTerm,
        "Platform": properties.platform,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "From": properties.from,
        "Page Name": properties.pageName,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("qJLPqWk_no", "Typing Stopped on Search Bar", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "MJKSzmqfHu", name: "Page Name", value: properties.pageName},
        {id: "UtPMQu4JE", name: "Number of Results", value: properties.numberOfResults},
        {id: "guJOTwi5T", name: "Search Term", value: properties.searchTerm},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Typing Stopped on Search Bar': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Typing Stopped on Search Bar", {
          "Number of Results": properties.numberOfResults,
          "Search Term": properties.searchTerm,
          "Platform": properties.platform,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "From": properties.from,
          "Page Name": properties.pageName,
          "Screen Height": sysScreenHeight,
          }, "qJLPqWk_no", "5c84061b1078dddc96a166e22ae29d11ea2e2712d23f5c4bc2d5994c1d87a2ff");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Typing Stopped on Search Bar", {
      "Number of Results": properties.numberOfResults,
      "Search Term": properties.searchTerm,
      "Platform": properties.platform,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "From": properties.from,
      "Page Name": properties.pageName,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Search Result: When user clicks on search result
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/AlQc6-GIyA/trigger/2mFC3AO5J
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.searchTerm - Term searched by the user
   * @param {string} properties.searchResultSelected - Among the search results shown, the one selected by the user
   * @param {string} properties.searchResultType - Type of search result (CG/Milestone/LO)
   * @param {int} properties.searchResultPosition - Position of search result clicked
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/AlQc6-GIyA}
   */
  function interactedSearchResult(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertSearchTerm(properties.searchTerm));
      messages = messages.concat(assertSearchResultSelected(properties.searchResultSelected));
      messages = messages.concat(assertSearchResultType(properties.searchResultType));
      messages = messages.concat(assertSearchResultPosition(properties.searchResultPosition));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Search Result", Object.keys(properties), [
        "searchTerm",
        "searchResultSelected",
        "searchResultType",
        "searchResultPosition",
        "platform",
        "elaGrade",
        "mathGrade",
        "mode",
        "userType",
        "signupFlow",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "AlQc6-GIyA", "90445535d08f1cdb98517a0d241456d6a3ffea6ecf9797014f22b832a21ac129", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Search Result", {
        "Search Term": properties.searchTerm,
        "Search Result Selected": properties.searchResultSelected,
        "Search Result Type": properties.searchResultType,
        "Search Result Position": properties.searchResultPosition,
        "Platform": properties.platform,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("AlQc6-GIyA", "Interacted Search Result", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "AeBTQBXi0", name: "Search Result Type", value: properties.searchResultType},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "guJOTwi5T", name: "Search Term", value: properties.searchTerm},
        {id: "of6hlcB4H", name: "Search Result Selected", value: properties.searchResultSelected},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vCfnwTQU8", name: "Search Result Position", value: properties.searchResultPosition},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Search Result': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Search Result", {
          "Search Term": properties.searchTerm,
          "Search Result Selected": properties.searchResultSelected,
          "Search Result Type": properties.searchResultType,
          "Search Result Position": properties.searchResultPosition,
          "Platform": properties.platform,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "AlQc6-GIyA", "90445535d08f1cdb98517a0d241456d6a3ffea6ecf9797014f22b832a21ac129");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Search Result", {
      "Search Term": properties.searchTerm,
      "Search Result Selected": properties.searchResultSelected,
      "Search Result Type": properties.searchResultType,
      "Search Result Position": properties.searchResultPosition,
      "Platform": properties.platform,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Transfer Page [B2B]: This event will be fired when the user clicks on 'Transfer' button from 'Manage All Classes' screen and lands on the class transfer screen.
The From Page property will include the value of the page it was clicked from - 
'Manage All Classes' or 'New SY Class Creation'.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/BbH0Re7Gnw/trigger/hd9iT0_2M
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/BbH0Re7Gnw}
   */
  function viewedTransferPageB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Transfer Page [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "fromPage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "BbH0Re7Gnw", "f0720a0467c5445d080e8ff6a022addb789f111de883bd5d8655a032b01c086c", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Transfer Page [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From Page": properties.fromPage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("BbH0Re7Gnw", "Viewed Transfer Page [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Transfer Page [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Transfer Page [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From Page": properties.fromPage,
          "Screen Height": sysScreenHeight,
          }, "BbH0Re7Gnw", "f0720a0467c5445d080e8ff6a022addb789f111de883bd5d8655a032b01c086c");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Transfer Page [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From Page": properties.fromPage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Transfer Page [B2B]: This event will be fired when the user interacts with the Transfer Class Page.

   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/jim8tAXzys/trigger/YF_oB_Q_N
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/jim8tAXzys}
   */
  function interactedTransferPageB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Transfer Page [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "jim8tAXzys", "774b5aacb121c666b21434974d3caec18cb69c183654a436d24ff23a2e9bf430", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Transfer Page [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("jim8tAXzys", "Interacted Transfer Page [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Transfer Page [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Transfer Page [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "jim8tAXzys", "774b5aacb121c666b21434974d3caec18cb69c183654a436d24ff23a2e9bf430");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Transfer Page [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Feature Feedback Pop-Up [B2B]: This event will be fired whenever the user sees the feedback feature against a widget or page. The value of 'feature_name' will appear in the 'Section' property here.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/oydALTKHND/trigger/RnQNcUyfE
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.section - This will capture the widget name that is being viewed/interacted by the user in that viewport. For example, 'Onboarding Widget', 'Home Access Widget', 'Assignment Widget', 'Assessment Widget', 'Math Fact Widget'
The list will only have 1 value for 'Section' property for Interacted event.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/oydALTKHND}
   */
  function viewedFeatureFeedbackPopUpB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertSection(properties.section));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Feature Feedback Pop-Up [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "section"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "oydALTKHND", "c8098a20d935481b083d04d88660107de4cd59b6962c0cbe70d5a3c6616a7388", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Feature Feedback Pop-Up [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Section": properties.section,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("oydALTKHND", "Viewed Feature Feedback Pop-Up [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "my9qL7M8w6", name: "Section", value: properties.section},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Feature Feedback Pop-Up [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Feature Feedback Pop-Up [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Section": properties.section,
          "Screen Height": sysScreenHeight,
          }, "oydALTKHND", "c8098a20d935481b083d04d88660107de4cd59b6962c0cbe70d5a3c6616a7388");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Feature Feedback Pop-Up [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Section": properties.section,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Feature Feedback Pop-Up [B2B]: This event will be fired whenever the user interacts with the feedback feature against a widget or page. The value of 'feature_name' will appear in the 'Section' property here.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Ah1VLF0L7G/trigger/a_8R5yxl6
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.section - This will capture the widget name that is being viewed/interacted by the user in that viewport. For example, 'Onboarding Widget', 'Home Access Widget', 'Assignment Widget', 'Assessment Widget', 'Math Fact Widget'
The list will only have 1 value for 'Section' property for Interacted event.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Ah1VLF0L7G}
   */
  function interactedFeatureFeedbackPopUpB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertSection(properties.section));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Feature Feedback Pop-Up [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "section",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Ah1VLF0L7G", "ea365cf6f931016051e99f2e6c1b1cc2da5e6790bda38c83d71adb9bfffe09fa", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Feature Feedback Pop-Up [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Section": properties.section,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Ah1VLF0L7G", "Interacted Feature Feedback Pop-Up [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "my9qL7M8w6", name: "Section", value: properties.section},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Feature Feedback Pop-Up [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Feature Feedback Pop-Up [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Section": properties.section,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "Ah1VLF0L7G", "ea365cf6f931016051e99f2e6c1b1cc2da5e6790bda38c83d71adb9bfffe09fa");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Feature Feedback Pop-Up [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Section": properties.section,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Suggest Improvements Popup [B2B]: This event will be fired when the user sees the 'Suggest Improvements' popup
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/uJzutqvacz/trigger/jKxAovOt7
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.section - This will capture the widget name that is being viewed/interacted by the user in that viewport. For example, 'Onboarding Widget', 'Home Access Widget', 'Assignment Widget', 'Assessment Widget', 'Math Fact Widget'
The list will only have 1 value for 'Section' property for Interacted event.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/uJzutqvacz}
   */
  function viewedSuggestImprovementsPopupB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertSection(properties.section));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Suggest Improvements Popup [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "section"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "uJzutqvacz", "809971055cda7561a98d12546e5f0ae24220ded1d83d6a775f7e1126d0428429", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Suggest Improvements Popup [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Section": properties.section,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("uJzutqvacz", "Viewed Suggest Improvements Popup [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "my9qL7M8w6", name: "Section", value: properties.section},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Suggest Improvements Popup [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Suggest Improvements Popup [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Section": properties.section,
          "Screen Height": sysScreenHeight,
          }, "uJzutqvacz", "809971055cda7561a98d12546e5f0ae24220ded1d83d6a775f7e1126d0428429");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Suggest Improvements Popup [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Section": properties.section,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Suggest Improvements Popup [B2B]: This event will be fired when the user interacts with the 'Suggest Improvements' popup.
If the user starts to enter content, the value for Clicked on will be 'Enter suggestion'.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/XybWmVl5wN/trigger/mCSXf4WvN
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.section - This will capture the widget name that is being viewed/interacted by the user in that viewport. For example, 'Onboarding Widget', 'Home Access Widget', 'Assignment Widget', 'Assessment Widget', 'Math Fact Widget'
The list will only have 1 value for 'Section' property for Interacted event.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/XybWmVl5wN}
   */
  function interactedSuggestImprovementsPopupB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertSection(properties.section));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Suggest Improvements Popup [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "section"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "XybWmVl5wN", "a879d34165c5a4a601fe677042416033f26e1ae9ce4bc26ef5391629fadee88e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Suggest Improvements Popup [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Section": properties.section,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("XybWmVl5wN", "Interacted Suggest Improvements Popup [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "my9qL7M8w6", name: "Section", value: properties.section},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Suggest Improvements Popup [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Suggest Improvements Popup [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Section": properties.section,
          "Screen Height": sysScreenHeight,
          }, "XybWmVl5wN", "a879d34165c5a4a601fe677042416033f26e1ae9ce4bc26ef5391629fadee88e");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Suggest Improvements Popup [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Section": properties.section,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Help Icon [B2B]: This event will be fired when the user interacts with the Help icon on the Teacher Product and selects an item from the dropdown menu.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/0w--07Nt3f/trigger/UdWGtTkOp
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/0w--07Nt3f}
   */
  function interactedHelpIconB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Help Icon [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "fromPage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "0w--07Nt3f", "046fcc34b03ef7bf9ca63e10ea1f1d04f49eac5540b67911cad670faa42ff3dc", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Help Icon [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "From Page": properties.fromPage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("0w--07Nt3f", "Interacted Help Icon [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Help Icon [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Help Icon [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "From Page": properties.fromPage,
          "Screen Height": sysScreenHeight,
          }, "0w--07Nt3f", "046fcc34b03ef7bf9ca63e10ea1f1d04f49eac5540b67911cad670faa42ff3dc");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Help Icon [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "From Page": properties.fromPage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Clicked on Help Icon [B2B]: This event will be fired when the user clicks on Help icon from the top bar on the teacher product.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/kadRgNV_Q}
   */
  function clickedOnHelpIconB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Clicked on Help Icon [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "fromPage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "kadRgNV_Q", "301c8dedd38b37076b9dd817685b2f2fb0feaf38a7eaf314162f4be143993442", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Clicked on Help Icon [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From Page": properties.fromPage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("kadRgNV_Q", "Clicked on Help Icon [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Clicked on Help Icon [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Clicked on Help Icon [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From Page": properties.fromPage,
          "Screen Height": sysScreenHeight,
          }, "kadRgNV_Q", "301c8dedd38b37076b9dd817685b2f2fb0feaf38a7eaf314162f4be143993442");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Clicked on Help Icon [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From Page": properties.fromPage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Worksheet Preview: When the user clicks on the worksheet card and the preview window opens
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/LmvX08Vsj7/trigger/sS4VqzYQG
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {string} properties.freeWorksheetsLeftCount - Stores the number of free worksheets left for the user to play on a particular day, at that moment
   * @param {string} [properties.seoGradeSelected] - Grade the user selected in the SEO pages before clicking on a playable/worksheet.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/LmvX08Vsj7}
   */
  function viewedWorksheetPreview(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertFreeWorksheetsLeftCount(properties.freeWorksheetsLeftCount));
      messages = messages.concat(assertOptionalSEOGradeSelected(properties.seoGradeSelected));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Worksheet Preview", Object.keys(properties), [
        "from",
        "freeWorksheetsLeftCount",
        "seoGradeSelected"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "LmvX08Vsj7", "2ba41974ee238c753d30f97d3020f6a3423b7e565184871bda7d751d3e24b469", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Worksheet Preview", {
        "From": properties.from,
        "Free Worksheets Left Count": properties.freeWorksheetsLeftCount,
        "SEO Grade Selected": properties.seoGradeSelected,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("LmvX08Vsj7", "Viewed Worksheet Preview", messages, [
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "H4pP9av1w", name: "Free Worksheets Left Count", value: properties.freeWorksheetsLeftCount},
        {id: "zAaw21fC2", name: "SEO Grade Selected", value: properties.seoGradeSelected},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Worksheet Preview': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Worksheet Preview", {
          "From": properties.from,
          "Free Worksheets Left Count": properties.freeWorksheetsLeftCount,
          "SEO Grade Selected": properties.seoGradeSelected,
          "Screen Height": sysScreenHeight,
          }, "LmvX08Vsj7", "2ba41974ee238c753d30f97d3020f6a3423b7e565184871bda7d751d3e24b469");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Worksheet Preview", {
      "From": properties.from,
      "Free Worksheets Left Count": properties.freeWorksheetsLeftCount,
      "SEO Grade Selected": properties.seoGradeSelected,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Worksheet Preview: When the user clicks on the CTA, thumbnail or cross on the worksheet preview window
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Ysxppxsc-X/trigger/JinFOmXZm
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.freeWorksheetsLeftCount - Stores the number of free worksheets left for the user to play on a particular day, at that moment
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Ysxppxsc-X}
   */
  function interactedWorksheetPreview(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertFreeWorksheetsLeftCount(properties.freeWorksheetsLeftCount));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Worksheet Preview", Object.keys(properties), [
        "clickedOn",
        "freeWorksheetsLeftCount"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Ysxppxsc-X", "5e7e77b81ab48f9f107367720febaff44c3defc16fe2eb05472d50d6c9921def", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Worksheet Preview", {
        "Clicked On": properties.clickedOn,
        "Free Worksheets Left Count": properties.freeWorksheetsLeftCount,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Ysxppxsc-X", "Interacted Worksheet Preview", messages, [
        {id: "H4pP9av1w", name: "Free Worksheets Left Count", value: properties.freeWorksheetsLeftCount},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Worksheet Preview': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Worksheet Preview", {
          "Clicked On": properties.clickedOn,
          "Free Worksheets Left Count": properties.freeWorksheetsLeftCount,
          "Screen Height": sysScreenHeight,
          }, "Ysxppxsc-X", "5e7e77b81ab48f9f107367720febaff44c3defc16fe2eb05472d50d6c9921def");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Worksheet Preview", {
      "Clicked On": properties.clickedOn,
      "Free Worksheets Left Count": properties.freeWorksheetsLeftCount,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted FAB [B2B]: This event will be triggered when the user clicks on the items within floating action button popup.
If the user clicks on the Toggle at the top, then 'Math' or 'ELA' will get passes for Clicked on property. If the user clicks on the items in the list, then the subject name will be sent along with it. Example, 'Math Curriculum'
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/UKwBfL21rl/trigger/hTgC56k4R
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/UKwBfL21rl}
   */
  function interactedFabB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted FAB [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "UKwBfL21rl", "c1bcf4106e352eedb0409b8734fd4435ea9ce46b8e6bfa246f0e18013eaa4ec4", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted FAB [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("UKwBfL21rl", "Interacted FAB [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted FAB [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted FAB [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "UKwBfL21rl", "c1bcf4106e352eedb0409b8734fd4435ea9ce46b8e6bfa246f0e18013eaa4ec4");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted FAB [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Scrolled Plan Page: When the user scrolls to each section in the new live classes plan page
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/gxL9DVOw6U/trigger/UyX_HevCu
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.section - This will capture the widget name that is being viewed/interacted by the user in that viewport. For example, 'Onboarding Widget', 'Home Access Widget', 'Assignment Widget', 'Assessment Widget', 'Math Fact Widget'
The list will only have 1 value for 'Section' property for Interacted event.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/gxL9DVOw6U}
   */
  function scrolledPlanPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertSection(properties.section));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Scrolled Plan Page", Object.keys(properties), [
        "section"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "gxL9DVOw6U", "91ef7205b6cacd781bd15b1d0d19875bf1050fe5168ca56cc1eeffa9ae9c8fee", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Scrolled Plan Page", {
        "Section": properties.section,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("gxL9DVOw6U", "Scrolled Plan Page", messages, [
        {id: "my9qL7M8w6", name: "Section", value: properties.section},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Scrolled Plan Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Scrolled Plan Page", {
          "Section": properties.section,
          "Screen Height": sysScreenHeight,
          }, "gxL9DVOw6U", "91ef7205b6cacd781bd15b1d0d19875bf1050fe5168ca56cc1eeffa9ae9c8fee");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Scrolled Plan Page", {
      "Section": properties.section,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Promote Popup [B2B]: This event will be fired when the user clicks on 'Promote class' CTA or cross button from the Promote confirmation popup.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/D8i9x4o98/trigger/HSxCi-Cz0
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/D8i9x4o98}
   */
  function interactedPromotePopupB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Promote Popup [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "D8i9x4o98", "d803e97b303f8d574b91bec10d6c035f681b34994f1144add7aa0096b8c90d81", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Promote Popup [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("D8i9x4o98", "Interacted Promote Popup [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Promote Popup [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Promote Popup [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "D8i9x4o98", "d803e97b303f8d574b91bec10d6c035f681b34994f1144add7aa0096b8c90d81");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Promote Popup [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Continue Same Class Popup [B2B]: This event will be fired when the user clicks 'OK' or 'cross' CTA on the Continue Same Class popup.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Hd40HzR46i/trigger/_VApgCbMi
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Hd40HzR46i}
   */
  function interactedContinueSameClassPopupB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Continue Same Class Popup [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Hd40HzR46i", "934066542d92516897e5bc9f2cb3352c112310ceaeeee830df259ce15c626d02", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Continue Same Class Popup [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Hd40HzR46i", "Interacted Continue Same Class Popup [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Continue Same Class Popup [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Continue Same Class Popup [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "Hd40HzR46i", "934066542d92516897e5bc9f2cb3352c112310ceaeeee830df259ce15c626d02");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Continue Same Class Popup [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Student Login Instructions Popup [B2B]: This event will be fired when the user interacts with the Student Login Instructions popup.
The Clicked on value will capture the login mode by prefixing the login mode. Example, 'QR Code Print Instructions'.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/g0Uo5x4dkT/trigger/CK_Kc_9hd
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.section - This will capture the widget name that is being viewed/interacted by the user in that viewport. For example, 'Onboarding Widget', 'Home Access Widget', 'Assignment Widget', 'Assessment Widget', 'Math Fact Widget'
The list will only have 1 value for 'Section' property for Interacted event.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/g0Uo5x4dkT}
   */
  function interactedStudentLoginInstructionsPopupB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertSection(properties.section));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Student Login Instructions Popup [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "section"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "g0Uo5x4dkT", "834ca803de3c72ea7366a2901ef58c050b3f0871dc4bcb05b6ab4f64e21e17a6", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Student Login Instructions Popup [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Section": properties.section,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("g0Uo5x4dkT", "Interacted Student Login Instructions Popup [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "my9qL7M8w6", name: "Section", value: properties.section},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Student Login Instructions Popup [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Student Login Instructions Popup [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Section": properties.section,
          "Screen Height": sysScreenHeight,
          }, "g0Uo5x4dkT", "834ca803de3c72ea7366a2901ef58c050b3f0871dc4bcb05b6ab4f64e21e17a6");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Student Login Instructions Popup [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Section": properties.section,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Product Purchased: Triggered when the user actually starts a Trial or a direct purchase.

   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.wallet] - Stores which wallet has the user used to make the payment for the plan.
Values = (googlePay, applePay)
   * @param {string} [properties.cardType] - Stores the card type of the payment method.
   * @param {string} [properties.stripePaymentMethodInfo] - Stores the type of payment method through which the user is making a payment

Values will include:
- cards
- digital wallets
- bank debits
- bank redirects
- bank transfers
- BNPL
- cash-based vouchers
- real time payment
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/TMo5FyU21}
   */
  function productPurchased(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalWallet(properties.wallet));
      messages = messages.concat(assertOptionalCardType(properties.cardType));
      messages = messages.concat(assertOptionalStripePaymentMethodInfo(properties.stripePaymentMethodInfo));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Product Purchased", Object.keys(properties), [
        "wallet",
        "cardType",
        "stripePaymentMethodInfo"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "TMo5FyU21", "ebf62fc65904bb79d7ca0177c4b097d5e92607ec202d32c76378e1380cd55f2c", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Product Purchased", {
        "Wallet": properties.wallet,
        "Card Type": properties.cardType,
        "Stripe Payment Method Info": properties.stripePaymentMethodInfo,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("TMo5FyU21", "Product Purchased", messages, [
        {id: "3kx20gfYw", name: "Stripe Payment Method Info", value: properties.stripePaymentMethodInfo},
        {id: "G8FSLVPgG", name: "Wallet", value: properties.wallet},
        {id: "WZ4UUsQFg", name: "Card Type", value: properties.cardType},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Product Purchased': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Purchased", {
          "Wallet": properties.wallet,
          "Card Type": properties.cardType,
          "Stripe Payment Method Info": properties.stripePaymentMethodInfo,
          "Screen Height": sysScreenHeight,
          }, "TMo5FyU21", "ebf62fc65904bb79d7ca0177c4b097d5e92607ec202d32c76378e1380cd55f2c");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Product Purchased", {
      "Wallet": properties.wallet,
      "Card Type": properties.cardType,
      "Stripe Payment Method Info": properties.stripePaymentMethodInfo,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Credit Card Submitted: Fires when the user submits any payment method.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.wallet] - Stores which wallet has the user used to make the payment for the plan.
Values = (googlePay, applePay)
   * @param {string} [properties.cardType] - Stores the card type of the payment method.
   * @param {string} [properties.stripePaymentMethodInfo] - Stores the type of payment method through which the user is making a payment

Values will include:
- cards
- digital wallets
- bank debits
- bank redirects
- bank transfers
- BNPL
- cash-based vouchers
- real time payment
   * @param {string} [properties.stripePaymentMethodInfoFrontend] - Stores the type of payment method through which the user is making a payment (To be used only for the Frontend events)

Values will include:
- cards
- digital wallets
- bank debits
- bank redirects
- bank transfers
- BNPL
- cash-based vouchers
- real time payment
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/bK068U13_}
   */
  function creditCardSubmitted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalWallet(properties.wallet));
      messages = messages.concat(assertOptionalCardType(properties.cardType));
      messages = messages.concat(assertOptionalStripePaymentMethodInfo(properties.stripePaymentMethodInfo));
      messages = messages.concat(assertOptionalStripePaymentMethodInfoFrontend(properties.stripePaymentMethodInfoFrontend));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Credit Card Submitted", Object.keys(properties), [
        "wallet",
        "cardType",
        "stripePaymentMethodInfo",
        "stripePaymentMethodInfoFrontend"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "bK068U13_", "83d752d20acfcbc549605f6386c29ea45be962ee19da685b264b92d4490b4200", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Credit Card Submitted", {
        "Wallet": properties.wallet,
        "Card Type": properties.cardType,
        "Stripe Payment Method Info": properties.stripePaymentMethodInfo,
        "Stripe Payment Method Info Frontend": properties.stripePaymentMethodInfoFrontend,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("bK068U13_", "Credit Card Submitted", messages, [
        {id: "3kx20gfYw", name: "Stripe Payment Method Info", value: properties.stripePaymentMethodInfo},
        {id: "G8FSLVPgG", name: "Wallet", value: properties.wallet},
        {id: "SMxi3L9R_W", name: "Stripe Payment Method Info Frontend", value: properties.stripePaymentMethodInfoFrontend},
        {id: "WZ4UUsQFg", name: "Card Type", value: properties.cardType},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Credit Card Submitted': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Credit Card Submitted", {
          "Wallet": properties.wallet,
          "Card Type": properties.cardType,
          "Stripe Payment Method Info": properties.stripePaymentMethodInfo,
          "Stripe Payment Method Info Frontend": properties.stripePaymentMethodInfoFrontend,
          "Screen Height": sysScreenHeight,
          }, "bK068U13_", "83d752d20acfcbc549605f6386c29ea45be962ee19da685b264b92d4490b4200");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Credit Card Submitted", {
      "Wallet": properties.wallet,
      "Card Type": properties.cardType,
      "Stripe Payment Method Info": properties.stripePaymentMethodInfo,
      "Stripe Payment Method Info Frontend": properties.stripePaymentMethodInfoFrontend,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Product Purchased Frontend: Front end event for when the user starts a trial or makes a purchase.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.wallet] - Stores which wallet has the user used to make the payment for the plan.
Values = (googlePay, applePay)
   * @param {string} [properties.cardType] - Stores the card type of the payment method.
   * @param {string} [properties.stripePaymentMethodInfo] - Stores the type of payment method through which the user is making a payment

Values will include:
- cards
- digital wallets
- bank debits
- bank redirects
- bank transfers
- BNPL
- cash-based vouchers
- real time payment
   * @param {string} properties.stripePaymentMethodInfoFrontend - Stores the type of payment method through which the user is making a payment (To be used only for the Frontend events)

Values will include:
- cards
- digital wallets
- bank debits
- bank redirects
- bank transfers
- BNPL
- cash-based vouchers
- real time payment
   * @param {string} properties.purchaseClickId - Unique ID associated with each purchase flow. Gets reset when the user exits the purchase flowing (irrespective of successful or unsuccessful purchase)
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {string} properties.tabCode - Specifies the tab which has been opened in the event 'Viewed Tiled Dashboard' and Other events too
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/sGru8Rdmg}
   */
  function productPurchasedFrontend(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalWallet(properties.wallet));
      messages = messages.concat(assertOptionalCardType(properties.cardType));
      messages = messages.concat(assertOptionalStripePaymentMethodInfo(properties.stripePaymentMethodInfo));
      messages = messages.concat(assertStripePaymentMethodInfoFrontend(properties.stripePaymentMethodInfoFrontend));
      messages = messages.concat(assertPurchaseClickID(properties.purchaseClickId));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertTabCode(properties.tabCode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Product Purchased Frontend", Object.keys(properties), [
        "wallet",
        "cardType",
        "stripePaymentMethodInfo",
        "stripePaymentMethodInfoFrontend",
        "purchaseClickId",
        "from",
        "tabCode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "sGru8Rdmg", "a7eb6dccbb2846543c5de7efda9a626d8ebef145b90edf4e3afb081f43bb7833", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Product Purchased Frontend", {
        "Wallet": properties.wallet,
        "Card Type": properties.cardType,
        "Stripe Payment Method Info": properties.stripePaymentMethodInfo,
        "Stripe Payment Method Info Frontend": properties.stripePaymentMethodInfoFrontend,
        "Purchase Click ID": properties.purchaseClickId,
        "From": properties.from,
        "Tab Code": properties.tabCode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("sGru8Rdmg", "Product Purchased Frontend", messages, [
        {id: "1sxa4mA1P", name: "Purchase Click ID", value: properties.purchaseClickId},
        {id: "3kx20gfYw", name: "Stripe Payment Method Info", value: properties.stripePaymentMethodInfo},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "G8FSLVPgG", name: "Wallet", value: properties.wallet},
        {id: "SMxi3L9R_W", name: "Stripe Payment Method Info Frontend", value: properties.stripePaymentMethodInfoFrontend},
        {id: "WZ4UUsQFg", name: "Card Type", value: properties.cardType},
        {id: "l9PbANZBu", name: "Tab Code", value: properties.tabCode},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Product Purchased Frontend': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Purchased Frontend", {
          "Wallet": properties.wallet,
          "Card Type": properties.cardType,
          "Stripe Payment Method Info": properties.stripePaymentMethodInfo,
          "Stripe Payment Method Info Frontend": properties.stripePaymentMethodInfoFrontend,
          "Purchase Click ID": properties.purchaseClickId,
          "From": properties.from,
          "Tab Code": properties.tabCode,
          "Screen Height": sysScreenHeight,
          }, "sGru8Rdmg", "a7eb6dccbb2846543c5de7efda9a626d8ebef145b90edf4e3afb081f43bb7833");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Product Purchased Frontend", {
      "Wallet": properties.wallet,
      "Card Type": properties.cardType,
      "Stripe Payment Method Info": properties.stripePaymentMethodInfo,
      "Stripe Payment Method Info Frontend": properties.stripePaymentMethodInfoFrontend,
      "Purchase Click ID": properties.purchaseClickId,
      "From": properties.from,
      "Tab Code": properties.tabCode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed All Recordings Page: Triggered when the user visits the recordings page
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ubCOREr4W2/trigger/BxCOy4ytY
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.from] - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ubCOREr4W2}
   */
  function viewedAllRecordingsPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalFrom(properties.from));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed All Recordings Page", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "clickedOn",
        "elaGrade",
        "grade",
        "from"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ubCOREr4W2", "56fccf3f3c0d1d72cc18f4f33e0e579c4154df52274be4e05af570ff26f87412", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed All Recordings Page", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Clicked On": properties.clickedOn,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "From": properties.from,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ubCOREr4W2", "Viewed All Recordings Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed All Recordings Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed All Recordings Page", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Clicked On": properties.clickedOn,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "From": properties.from,
          "Screen Height": sysScreenHeight,
          }, "ubCOREr4W2", "56fccf3f3c0d1d72cc18f4f33e0e579c4154df52274be4e05af570ff26f87412");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed All Recordings Page", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Clicked On": properties.clickedOn,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "From": properties.from,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted All Recordings Page: Triggered when the user interacts anywhere on the recordings page
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ZqRR2kIpIO/trigger/IbwZ0b414
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} [properties.gradeSelected] - Grade selected by user in curriculum tab
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} [properties.from] - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ZqRR2kIpIO}
   */
  function interactedAllRecordingsPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertOptionalGradeSelected(properties.gradeSelected));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertOptionalFrom(properties.from));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted All Recordings Page", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "clickedOn",
        "gradeSelected",
        "grade",
        "elaGrade",
        "from"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ZqRR2kIpIO", "09299bee43229fce4257bb9e8ff46a6162b704cdd55d073c280f1fa1d537e8e5", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted All Recordings Page", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Clicked On": properties.clickedOn,
        "Grade Selected": properties.gradeSelected,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "From": properties.from,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ZqRR2kIpIO", "Interacted All Recordings Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "Fcl7PSdr4", name: "Grade Selected", value: properties.gradeSelected},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted All Recordings Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted All Recordings Page", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Clicked On": properties.clickedOn,
          "Grade Selected": properties.gradeSelected,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "From": properties.from,
          "Screen Height": sysScreenHeight,
          }, "ZqRR2kIpIO", "09299bee43229fce4257bb9e8ff46a6162b704cdd55d073c280f1fa1d537e8e5");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted All Recordings Page", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Clicked On": properties.clickedOn,
      "Grade Selected": properties.gradeSelected,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "From": properties.from,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Persona Question Screen: When the user lands on the screen with the persona research questions
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/abU0cA8Fx3/trigger/J82SQvPCP
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.questionNo] - This will capture the Question Serial no. as it appears in sequence
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/abU0cA8Fx3}
   */
  function viewedPersonaQuestionScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalQuestionNo(properties.questionNo));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Persona Question Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "questionNo",
        "mode",
        "grade",
        "mathGrade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "abU0cA8Fx3", "7862f2033c1ae62503c494e6b1ef8b6d33facc17421279298f653466533701a2", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Persona Question Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Question No.": properties.questionNo,
        "Mode": properties.mode,
        "Grade": properties.grade,
        "Math Grade": properties.mathGrade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("abU0cA8Fx3", "Viewed Persona Question Screen", messages, [
        {id: "1BxvMk6Nz6", name: "Question No.", value: properties.questionNo},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Persona Question Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Persona Question Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Question No.": properties.questionNo,
          "Mode": properties.mode,
          "Grade": properties.grade,
          "Math Grade": properties.mathGrade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "abU0cA8Fx3", "7862f2033c1ae62503c494e6b1ef8b6d33facc17421279298f653466533701a2");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Persona Question Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Question No.": properties.questionNo,
      "Mode": properties.mode,
      "Grade": properties.grade,
      "Math Grade": properties.mathGrade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Persona Question Screen: When the user clicks on the options, back or any of the 2 CTAs in the screen
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/yvnCL_tKho/trigger/kYvopA8ZZ
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} [properties.questionNo] - This will capture the Question Serial no. as it appears in sequence
   * @param {Array<string>} [properties.optionsSelected] - Array to save all of the options the user selects
   * @param {string} [properties.errorMessage] - Error message shown to the user.
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/yvnCL_tKho}
   */
  function interactedPersonaQuestionScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertOptionalQuestionNo(properties.questionNo));
      messages = messages.concat(assertOptionalOptionsSelected(properties.optionsSelected));
      messages = messages.concat(assertOptionalErrorMessage(properties.errorMessage));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Persona Question Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "questionNo",
        "optionsSelected",
        "errorMessage",
        "mode",
        "grade",
        "mathGrade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "yvnCL_tKho", "6e6541c89d09668fe8d43c9fba76f304c0d70174c54be79c093fbb1b13ab0910", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Persona Question Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Question No.": properties.questionNo,
        "Options Selected": properties.optionsSelected,
        "Error Message": properties.errorMessage,
        "Mode": properties.mode,
        "Grade": properties.grade,
        "Math Grade": properties.mathGrade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("yvnCL_tKho", "Interacted Persona Question Screen", messages, [
        {id: "1BxvMk6Nz6", name: "Question No.", value: properties.questionNo},
        {id: "1n3Bq4GKWy", name: "Error Message", value: properties.errorMessage},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "FZg42lPcF", name: "Options Selected", value: properties.optionsSelected},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Persona Question Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Persona Question Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Question No.": properties.questionNo,
          "Options Selected": properties.optionsSelected,
          "Error Message": properties.errorMessage,
          "Mode": properties.mode,
          "Grade": properties.grade,
          "Math Grade": properties.mathGrade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "yvnCL_tKho", "6e6541c89d09668fe8d43c9fba76f304c0d70174c54be79c093fbb1b13ab0910");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Persona Question Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Question No.": properties.questionNo,
      "Options Selected": properties.optionsSelected,
      "Error Message": properties.errorMessage,
      "Mode": properties.mode,
      "Grade": properties.grade,
      "Math Grade": properties.mathGrade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Companion: This event gets triggered when the companion state machine isswitches loadedfrom one to another.
   * 
   * When to trigger this event:
   * 1. When companion layer has successfully loaded over the dashboard.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/oSI8IVoYyf/trigger/6QxU0iaMs
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.tabCode - Specifies the tab which has been opened in the event 'Viewed Tiled Dashboard' and Other events too
   * @param {string} properties.stateMachineCode - Every state machine has its own code, so whenever state machine switches we will be able to debug any issue that may arise
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.stateMachineTid - it is a unique code, passed as string for each state machine
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/oSI8IVoYyf}
   */
  function viewedCompanion(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertTabCode(properties.tabCode));
      messages = messages.concat(assertStateMachineCode(properties.stateMachineCode));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertStateMachineTid(properties.stateMachineTid));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Companion", Object.keys(properties), [
        "tabCode",
        "stateMachineCode",
        "platform",
        "elaGrade",
        "mathGrade",
        "mode",
        "userType",
        "signupFlow",
        "grade",
        "stateMachineTid"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "oSI8IVoYyf", "6bae49d194bca76d835a6117375157738c88affbde51c92eeed30e10d6cc3181", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Companion", {
        "Tab Code": properties.tabCode,
        "State Machine Code": properties.stateMachineCode,
        "Platform": properties.platform,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "State Machine Tid": properties.stateMachineTid,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("oSI8IVoYyf", "Viewed Companion", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "D325IngkY", name: "State Machine Tid", value: properties.stateMachineTid},
        {id: "T9gjnp76o", name: "State Machine Code", value: properties.stateMachineCode},
        {id: "l9PbANZBu", name: "Tab Code", value: properties.tabCode},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Companion': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Companion", {
          "Tab Code": properties.tabCode,
          "State Machine Code": properties.stateMachineCode,
          "Platform": properties.platform,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "State Machine Tid": properties.stateMachineTid,
          "Screen Height": sysScreenHeight,
          }, "oSI8IVoYyf", "6bae49d194bca76d835a6117375157738c88affbde51c92eeed30e10d6cc3181");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Companion", {
      "Tab Code": properties.tabCode,
      "State Machine Code": properties.stateMachineCode,
      "Platform": properties.platform,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "State Machine Tid": properties.stateMachineTid,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Started Companion Animation: Whenever any companion animation is starting
   * 
   * When to trigger this event:
   * 1. This is one of the example when companion animation is started at pitstop
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/-OWrF7Hhl/trigger/JPk5KFyyh
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.flowName - This property will tell the flow of the companion - is it welcome back, or motivation, etc.
   * @param {string} properties.tabCode - Specifies the tab which has been opened in the event 'Viewed Tiled Dashboard' and Other events too
   * @param {string} properties.tid - It's a unique id associated to every new animation getting triggered.
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.stateMachineCode - Every state machine has its own code, so whenever state machine switches we will be able to debug any issue that may arise
   * @param {string} properties.stateMachineTid - it is a unique code, passed as string for each state machine
   * @param {string} [properties.playableCode] - Pass the 'Playable Code' of the Playable being started/clicked
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/-OWrF7Hhl}
   */
  function startedCompanionAnimation(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertFlowName(properties.flowName));
      messages = messages.concat(assertTabCode(properties.tabCode));
      messages = messages.concat(assertTid(properties.tid));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertStateMachineCode(properties.stateMachineCode));
      messages = messages.concat(assertStateMachineTid(properties.stateMachineTid));
      messages = messages.concat(assertOptionalPlayableCode(properties.playableCode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Started Companion Animation", Object.keys(properties), [
        "flowName",
        "tabCode",
        "tid",
        "platform",
        "elaGrade",
        "mathGrade",
        "mode",
        "userType",
        "signupFlow",
        "grade",
        "stateMachineCode",
        "stateMachineTid",
        "playableCode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "-OWrF7Hhl", "c1126e6d4a1e7a02c764e750ec740be0429fc2258af82564b53e41228b240104", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Started Companion Animation", {
        "Flow Name": properties.flowName,
        "Tab Code": properties.tabCode,
        "Tid": properties.tid,
        "Platform": properties.platform,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "State Machine Code": properties.stateMachineCode,
        "State Machine Tid": properties.stateMachineTid,
        "Playable Code": properties.playableCode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("-OWrF7Hhl", "Started Companion Animation", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "D325IngkY", name: "State Machine Tid", value: properties.stateMachineTid},
        {id: "QjCwFasvW0", name: "Playable Code", value: properties.playableCode},
        {id: "QvqHzz_24", name: "Flow Name", value: properties.flowName},
        {id: "SYGmTqa9e", name: "Tid", value: properties.tid},
        {id: "T9gjnp76o", name: "State Machine Code", value: properties.stateMachineCode},
        {id: "l9PbANZBu", name: "Tab Code", value: properties.tabCode},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Started Companion Animation': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Started Companion Animation", {
          "Flow Name": properties.flowName,
          "Tab Code": properties.tabCode,
          "Tid": properties.tid,
          "Platform": properties.platform,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "State Machine Code": properties.stateMachineCode,
          "State Machine Tid": properties.stateMachineTid,
          "Playable Code": properties.playableCode,
          "Screen Height": sysScreenHeight,
          }, "-OWrF7Hhl", "c1126e6d4a1e7a02c764e750ec740be0429fc2258af82564b53e41228b240104");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Started Companion Animation", {
      "Flow Name": properties.flowName,
      "Tab Code": properties.tabCode,
      "Tid": properties.tid,
      "Platform": properties.platform,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "State Machine Code": properties.stateMachineCode,
      "State Machine Tid": properties.stateMachineTid,
      "Playable Code": properties.playableCode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Completed Companion Animation: when companion animation is completed
   * 
   * When to trigger this event:
   * 1. This screenshot is post adding stars into level bar.. the animation is already completed.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/WuEAuDawCX/trigger/6ULDytqt2
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.flowName - This property will tell the flow of the companion - is it welcome back, or motivation, etc.
   * @param {string} properties.tabCode - Specifies the tab which has been opened in the event 'Viewed Tiled Dashboard' and Other events too
   * @param {string} properties.companionState - This property will tell if the companion has taken over full screen or is intervening from the peak view (from side)
   * @param {string} properties.animationUrl - This property will have the URL of the animation played
   * @param {Array<string>} properties.voUrl - This property will have the URL of the VO played
   * @param {string} properties.voText - This property will have the URL of the text of the VO
   * @param {bool} properties.caCompletedSuccessfully - This will be True/False. If animation completes successfully w/o the user interrupting it, the value will be True, otherwise False
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/WuEAuDawCX}
   */
  function completedCompanionAnimation(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertFlowName(properties.flowName));
      messages = messages.concat(assertTabCode(properties.tabCode));
      messages = messages.concat(assertCompanionState(properties.companionState));
      messages = messages.concat(assertAnimationURL(properties.animationUrl));
      messages = messages.concat(assertVoURL(properties.voUrl));
      messages = messages.concat(assertVoText(properties.voText));
      messages = messages.concat(assertCACompletedSuccessfully(properties.caCompletedSuccessfully));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Completed Companion Animation", Object.keys(properties), [
        "flowName",
        "tabCode",
        "companionState",
        "animationUrl",
        "voUrl",
        "voText",
        "caCompletedSuccessfully"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "WuEAuDawCX", "29d941b5255e6414054085eb814b8e15ab2fb04abc1c88f8dc7e9b1ec6aa27e3", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Completed Companion Animation", {
        "Flow Name": properties.flowName,
        "Tab Code": properties.tabCode,
        "Companion State": properties.companionState,
        "Animation URL": properties.animationUrl,
        "Vo URL": properties.voUrl,
        "Vo Text": properties.voText,
        "CA Completed Successfully": properties.caCompletedSuccessfully,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("WuEAuDawCX", "Completed Companion Animation", messages, [
        {id: "KEGhoZGvu", name: "Vo Text", value: properties.voText},
        {id: "MBcj_KFnG", name: "Companion State", value: properties.companionState},
        {id: "QvqHzz_24", name: "Flow Name", value: properties.flowName},
        {id: "_YDbEIGLh", name: "CA Completed Successfully", value: properties.caCompletedSuccessfully},
        {id: "dt9ueOw7v", name: "Animation URL", value: properties.animationUrl},
        {id: "l9PbANZBu", name: "Tab Code", value: properties.tabCode},
        {id: "yeiCDbEMb", name: "Vo URL", value: properties.voUrl},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Completed Companion Animation': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Completed Companion Animation", {
          "Flow Name": properties.flowName,
          "Tab Code": properties.tabCode,
          "Companion State": properties.companionState,
          "Animation URL": properties.animationUrl,
          "Vo URL": properties.voUrl,
          "Vo Text": properties.voText,
          "CA Completed Successfully": properties.caCompletedSuccessfully,
          "Screen Height": sysScreenHeight,
          }, "WuEAuDawCX", "29d941b5255e6414054085eb814b8e15ab2fb04abc1c88f8dc7e9b1ec6aa27e3");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Completed Companion Animation", {
      "Flow Name": properties.flowName,
      "Tab Code": properties.tabCode,
      "Companion State": properties.companionState,
      "Animation URL": properties.animationUrl,
      "Vo URL": properties.voUrl,
      "Vo Text": properties.voText,
      "CA Completed Successfully": properties.caCompletedSuccessfully,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Companion: This event will be fired if child taps/clicks on the companion
   * 
   * When to trigger this event:
   * 1. Companion is tapped or clicked upon
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/nmR1hU8sWg/trigger/Qtjymy332
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.tabCode - Specifies the tab which has been opened in the event 'Viewed Tiled Dashboard' and Other events too
   * @param {string} properties.animationUrl - This property will have the URL of the animation played
   * @param {Array<string>} properties.voUrl - This property will have the URL of the VO played
   * @param {string} properties.voText - This property will have the URL of the text of the VO
   * @param {Array<string>} properties.recommendedRail - This property will be used to store which rails were shown to the user in the HOME tab.

Where possible values are:
Rail Name = Curriculum, Game Zone, Math, Language, Logic & Thinking, Art & Creativity, General Knowledge, Motor Skills, Live Classes, Fluency, Multiplayer
This comes with Rank also with | separation
   * @param {string} properties.tapType - This property will tell if the child has tapped once or multiple time on the companion

   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/nmR1hU8sWg}
   */
  function interactedCompanion(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertTabCode(properties.tabCode));
      messages = messages.concat(assertAnimationURL(properties.animationUrl));
      messages = messages.concat(assertVoURL(properties.voUrl));
      messages = messages.concat(assertVoText(properties.voText));
      messages = messages.concat(assertRecommendedRail(properties.recommendedRail));
      messages = messages.concat(assertTapType(properties.tapType));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Companion", Object.keys(properties), [
        "tabCode",
        "animationUrl",
        "voUrl",
        "voText",
        "recommendedRail",
        "tapType"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "nmR1hU8sWg", "217a4cd84d5fc0bf80a5fdc4a1827a14cdd1c217cd484fa83a4cc01e2addf9e5", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Companion", {
        "Tab Code": properties.tabCode,
        "Animation URL": properties.animationUrl,
        "Vo URL": properties.voUrl,
        "Vo Text": properties.voText,
        "Recommended Rail": properties.recommendedRail,
        "Tap Type": properties.tapType,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("nmR1hU8sWg", "Interacted Companion", messages, [
        {id: "CG846K8Ql", name: "Tap Type", value: properties.tapType},
        {id: "KEGhoZGvu", name: "Vo Text", value: properties.voText},
        {id: "drNgwJn5Xg", name: "Recommended Rail", value: properties.recommendedRail},
        {id: "dt9ueOw7v", name: "Animation URL", value: properties.animationUrl},
        {id: "l9PbANZBu", name: "Tab Code", value: properties.tabCode},
        {id: "yeiCDbEMb", name: "Vo URL", value: properties.voUrl},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Companion': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Companion", {
          "Tab Code": properties.tabCode,
          "Animation URL": properties.animationUrl,
          "Vo URL": properties.voUrl,
          "Vo Text": properties.voText,
          "Recommended Rail": properties.recommendedRail,
          "Tap Type": properties.tapType,
          "Screen Height": sysScreenHeight,
          }, "nmR1hU8sWg", "217a4cd84d5fc0bf80a5fdc4a1827a14cdd1c217cd484fa83a4cc01e2addf9e5");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Companion", {
      "Tab Code": properties.tabCode,
      "Animation URL": properties.animationUrl,
      "Vo URL": properties.voUrl,
      "Vo Text": properties.voText,
      "Recommended Rail": properties.recommendedRail,
      "Tap Type": properties.tapType,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Dashboard Graphql Query Started: This event should trigger when a graphql query is started in flutter dashboard
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.tabCode - Specifies the tab which has been opened in the event 'Viewed Tiled Dashboard' and Other events too
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/qlZTJ15u1d}
   */
  function dashboardGraphqlQueryStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertTabCode(properties.tabCode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Dashboard Graphql Query Started", Object.keys(properties), [
        "tabCode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "qlZTJ15u1d", "d72ff13f124e71bd7df24c4cd4f719fbec759a3542cab2cab1250c81836aa5ac", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Dashboard Graphql Query Started", {
        "Tab Code": properties.tabCode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("qlZTJ15u1d", "Dashboard Graphql Query Started", messages, [
        {id: "l9PbANZBu", name: "Tab Code", value: properties.tabCode},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Dashboard Graphql Query Started': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Dashboard Graphql Query Started", {
          "Tab Code": properties.tabCode,
          "Screen Height": sysScreenHeight,
          }, "qlZTJ15u1d", "d72ff13f124e71bd7df24c4cd4f719fbec759a3542cab2cab1250c81836aa5ac");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Dashboard Graphql Query Started", {
      "Tab Code": properties.tabCode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Dashboard Graphql Query Ended: This event should trigger when a graphql query is completed.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.tabCode - Specifies the tab which has been opened in the event 'Viewed Tiled Dashboard' and Other events too
   * @param {string} properties.status - To determine if the process failed or succeeded
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/yOJB_Qth0}
   */
  function dashboardGraphqlQueryEnded(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertTabCode(properties.tabCode));
      messages = messages.concat(assertStatus(properties.status));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Dashboard Graphql Query Ended", Object.keys(properties), [
        "tabCode",
        "status"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "yOJB_Qth0", "68452485b5ce0df4476663e938a962e16b87164ea2da4a7fdac2d7547ab8c834", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Dashboard Graphql Query Ended", {
        "Tab Code": properties.tabCode,
        "Status": properties.status,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("yOJB_Qth0", "Dashboard Graphql Query Ended", messages, [
        {id: "9_Al8_kuam", name: "Status", value: properties.status},
        {id: "l9PbANZBu", name: "Tab Code", value: properties.tabCode},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Dashboard Graphql Query Ended': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Dashboard Graphql Query Ended", {
          "Tab Code": properties.tabCode,
          "Status": properties.status,
          "Screen Height": sysScreenHeight,
          }, "yOJB_Qth0", "68452485b5ce0df4476663e938a962e16b87164ea2da4a7fdac2d7547ab8c834");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Dashboard Graphql Query Ended", {
      "Tab Code": properties.tabCode,
      "Status": properties.status,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Dashboard Rendered: This event should trigger when a flutter dashboard ui is rendered
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.tabCode - Specifies the tab which has been opened in the event 'Viewed Tiled Dashboard' and Other events too
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/7TSQLU-m4}
   */
  function dashboardRendered(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertTabCode(properties.tabCode));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Dashboard Rendered", Object.keys(properties), [
        "mathGrade",
        "mode",
        "tabCode",
        "platform",
        "userType",
        "elaGrade",
        "grade",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "7TSQLU-m4", "d9950131fd5a337c716df56f8691b19bd123c7d6445b3085b9d464ae5428abca", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Dashboard Rendered", {
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Tab Code": properties.tabCode,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("7TSQLU-m4", "Dashboard Rendered", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "l9PbANZBu", name: "Tab Code", value: properties.tabCode},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Dashboard Rendered': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Dashboard Rendered", {
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Tab Code": properties.tabCode,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "7TSQLU-m4", "d9950131fd5a337c716df56f8691b19bd123c7d6445b3085b9d464ae5428abca");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Dashboard Rendered", {
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Tab Code": properties.tabCode,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Complete Topic Assignment Popup [B2B]: This event will be fired when the user clicks on 'Mark as complete' from the three dots on the right side of the Curriculum Widget and the 'Mark topic assignment as completed' popup is viewed by the user
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/boq1utIEdA/trigger/m9fEM4ypz
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/boq1utIEdA}
   */
  function viewedCompleteTopicAssignmentPopupB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Complete Topic Assignment Popup [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "boq1utIEdA", "404e3a7f7ad3a284d2b4f803662959809d269bbb1ac0d42fce34863f61d17974", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Complete Topic Assignment Popup [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("boq1utIEdA", "Viewed Complete Topic Assignment Popup [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Complete Topic Assignment Popup [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Complete Topic Assignment Popup [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "boq1utIEdA", "404e3a7f7ad3a284d2b4f803662959809d269bbb1ac0d42fce34863f61d17974");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Complete Topic Assignment Popup [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Complete Topic Assignment Popup [B2B]: This event will be fired when the user interacts with the 'Mark topic assignment as completed' popup.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/RG5hu3hbgV/trigger/wPCNeVSZD
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/RG5hu3hbgV}
   */
  function interactedCompleteTopicAssignmentPopupB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Complete Topic Assignment Popup [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "RG5hu3hbgV", "8b5c44a339976f1d369318eb33be114fc63e72f81cf35b0cd8c2b4739c4c31a2", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Complete Topic Assignment Popup [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("RG5hu3hbgV", "Interacted Complete Topic Assignment Popup [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Complete Topic Assignment Popup [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Complete Topic Assignment Popup [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "RG5hu3hbgV", "8b5c44a339976f1d369318eb33be114fc63e72f81cf35b0cd8c2b4739c4c31a2");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Complete Topic Assignment Popup [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Delete Topic Assignment Popup [B2B]: This event will be fired when the user clicks on 'Delete' from the three dots on the right side of the Curriculum Widget and the 'Delete topic assignment' popup is viewed by the user
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/HQiUZNrMh/trigger/1f3ciVYuLO
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/HQiUZNrMh}
   */
  function viewedDeleteTopicAssignmentPopupB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Delete Topic Assignment Popup [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "HQiUZNrMh", "f0ff897216167e357e71780372b64cd18e13135d09b4539ad3b1d163a845d77b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Delete Topic Assignment Popup [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("HQiUZNrMh", "Viewed Delete Topic Assignment Popup [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Delete Topic Assignment Popup [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Delete Topic Assignment Popup [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "HQiUZNrMh", "f0ff897216167e357e71780372b64cd18e13135d09b4539ad3b1d163a845d77b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Delete Topic Assignment Popup [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Delete Topic Assignment Popup [B2B]: This event will be fired when the user interacts with the 'Delete topic assignment' popup.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/gAuM0uQD0/trigger/eDeY1ZBOnf
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/gAuM0uQD0}
   */
  function interactedDeleteTopicAssignmentPopupB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Delete Topic Assignment Popup [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "gAuM0uQD0", "c3edbaaba2bb2fef4f8f7459b38142bd8631af213d2f5de6e5775f55392c1080", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Delete Topic Assignment Popup [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("gAuM0uQD0", "Interacted Delete Topic Assignment Popup [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Delete Topic Assignment Popup [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Delete Topic Assignment Popup [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "gAuM0uQD0", "c3edbaaba2bb2fef4f8f7459b38142bd8631af213d2f5de6e5775f55392c1080");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Delete Topic Assignment Popup [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Downloaded Worksheet B2C: This event contains the details of the downloaded worksheet from the printable tab on web
   * 
   * When to trigger this event:
   * 1. When user clicks on the download button
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/coq92PhrRA/trigger/exUzpF3ni
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.worksheetName - Name of the Worksheet that is downloaded, clicked or tapped. 
   * @param {string} properties.worksheetCode - Worksheet code of selected worksheet
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userCountry - Name of the country the user is from
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/coq92PhrRA}
   */
  function downloadedWorksheetB2c(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertWorksheetName(properties.worksheetName));
      messages = messages.concat(assertWorksheetCode(properties.worksheetCode));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserCountry(properties.userCountry));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Downloaded Worksheet B2C", Object.keys(properties), [
        "worksheetName",
        "worksheetCode",
        "signupFlow",
        "platform",
        "userCountry",
        "userType"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "coq92PhrRA", "b1d3b8c44f48650e87d3caa692b39ce1a6ef7a763c5efc710c5fc7c198e92213", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Downloaded Worksheet B2C", {
        "Worksheet Name": properties.worksheetName,
        "Worksheet Code": properties.worksheetCode,
        "Signup Flow": properties.signupFlow,
        "Platform": properties.platform,
        "User Country": properties.userCountry,
        "User Type": properties.userType,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("coq92PhrRA", "Downloaded Worksheet B2C", messages, [
        {id: "NRFYZYLxy", name: "Worksheet Code", value: properties.worksheetCode},
        {id: "g8uPZdwOmF", name: "Worksheet Name", value: properties.worksheetName},
        {id: "vHdXCmyiec", name: "User Country", value: properties.userCountry},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Downloaded Worksheet B2C': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Downloaded Worksheet B2C", {
          "Worksheet Name": properties.worksheetName,
          "Worksheet Code": properties.worksheetCode,
          "Signup Flow": properties.signupFlow,
          "Platform": properties.platform,
          "User Country": properties.userCountry,
          "User Type": properties.userType,
          "Screen Height": sysScreenHeight,
          }, "coq92PhrRA", "b1d3b8c44f48650e87d3caa692b39ce1a6ef7a763c5efc710c5fc7c198e92213");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Downloaded Worksheet B2C", {
      "Worksheet Name": properties.worksheetName,
      "Worksheet Code": properties.worksheetCode,
      "Signup Flow": properties.signupFlow,
      "Platform": properties.platform,
      "User Country": properties.userCountry,
      "User Type": properties.userType,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Assignment Successfully Assigned Page [B2B]: This event is triggered upon click of Download Invite/Copy Invite button after assigning assignments to whole class/selected students
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.assignmentType - This will capture the type of assignment - Manual or Auto
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/E1mCLE5rKH}
   */
  function interactedAssignmentSuccessfullyAssignedPageB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertAssignmentType(properties.assignmentType));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Assignment Successfully Assigned Page [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "assignmentType"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "E1mCLE5rKH", "010e2db9686b51702a18f1fcdb1447b812d9d4740fdd82b1aae8c55aefe97d00", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Assignment Successfully Assigned Page [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Assignment Type": properties.assignmentType,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("E1mCLE5rKH", "Interacted Assignment Successfully Assigned Page [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "Ueowl7sRb", name: "Assignment Type", value: properties.assignmentType},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Assignment Successfully Assigned Page [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Assignment Successfully Assigned Page [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Assignment Type": properties.assignmentType,
          "Screen Height": sysScreenHeight,
          }, "E1mCLE5rKH", "010e2db9686b51702a18f1fcdb1447b812d9d4740fdd82b1aae8c55aefe97d00");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Assignment Successfully Assigned Page [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Assignment Type": properties.assignmentType,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted School Selection Screen [B2B]: This event will be fired in the below cases:
1. Started typing city
2. Stopped typing city 
3. Selected city from list
4. Started typing  school
5. Stopped typing school
6. Selected school from list
7. Clicked on country selection dropdown
8. Selected country from country selection dropdown
9. Clicked on city selection dropdown
10. Selected city from city selection dropdown
11. When user selects city from suggestions after typing
12. When user selects school from suggestions after typing
13. Clicks on 'Find US schools here' or 'Find non-US schools here'

Clicked on will capture the dropdown name - 'City' or 'School' 
Value Name will capture the value selected from the dropdown or value of text typed (whichever is relevant). For example, 'I don't see my school' or 'Phoenix'. 
Interaction Details will capture the started and stopped events for city and school

The current event - Clicked School Info Added [B2B] will continue to get fired after the user clicks on 'Set your School' CTA.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/3CumscrUi6/trigger/wOSpuSOrq
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} [properties.interactionDetails] - Stores where is the user interacting with the page
   * @param {string} properties.valueName - This will capture the value/text of the field that is selected.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/3CumscrUi6}
   */
  function interactedSchoolSelectionScreenB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertOptionalInteractionDetails(properties.interactionDetails));
      messages = messages.concat(assertValueName(properties.valueName));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted School Selection Screen [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "interactionDetails",
        "valueName"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "3CumscrUi6", "508d2f7a33a71480a1cdfd9617d1ede0197ff5221f80a14abb77442c2bd6df65", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted School Selection Screen [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Interaction Details": properties.interactionDetails,
        "Value Name": properties.valueName,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("3CumscrUi6", "Interacted School Selection Screen [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "l-8JNUE0q", name: "Value Name", value: properties.valueName},
        {id: "ncdYto9gZ", name: "Interaction Details", value: properties.interactionDetails},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted School Selection Screen [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted School Selection Screen [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Interaction Details": properties.interactionDetails,
          "Value Name": properties.valueName,
          "Screen Height": sysScreenHeight,
          }, "3CumscrUi6", "508d2f7a33a71480a1cdfd9617d1ede0197ff5221f80a14abb77442c2bd6df65");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted School Selection Screen [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Interaction Details": properties.interactionDetails,
      "Value Name": properties.valueName,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Pricing Info Box: When the user hovers over the info icon on the purchase summary page to view the price breakdown. 
   * 
   * When to trigger this event:
   * 1. User hovers on the info icon (i)
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/kOTuFtT49Q/trigger/bc_hmb-Xr
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/kOTuFtT49Q}
   */
  function viewedPricingInfoBox(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Pricing Info Box", Object.keys(properties), [
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "kOTuFtT49Q", "d0a761535bc9b890f35f0e703219185c02efdc14d5746543de8440dc24193750", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Pricing Info Box", {
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("kOTuFtT49Q", "Viewed Pricing Info Box", messages, [
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Pricing Info Box': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Pricing Info Box", {
          "Screen Height": sysScreenHeight,
          }, "kOTuFtT49Q", "d0a761535bc9b890f35f0e703219185c02efdc14d5746543de8440dc24193750");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Pricing Info Box", {
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Live Class Tab Available: This event is triggered every time a user lands on the dashboard and the live classes tab is visible
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.userCountry - Name of the country the user is from
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/75smLMrncw}
   */
  function liveClassTabAvailable(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertUserCountry(properties.userCountry));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Live Class Tab Available", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "userCountry"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "75smLMrncw", "6e2d64fc0c295b39c8606d837fed67cb2d9ad03b45a95455bb83abfffed97730", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Live Class Tab Available", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "User Country": properties.userCountry,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("75smLMrncw", "Live Class Tab Available", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "vHdXCmyiec", name: "User Country", value: properties.userCountry},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Live Class Tab Available': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Live Class Tab Available", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "User Country": properties.userCountry,
          "Screen Height": sysScreenHeight,
          }, "75smLMrncw", "6e2d64fc0c295b39c8606d837fed67cb2d9ad03b45a95455bb83abfffed97730");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Live Class Tab Available", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "User Country": properties.userCountry,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Ended Companion Animation: This event will be fired as soon as an started flow is closed.
   * 
   * When to trigger this event:
   * 1. Whenever the animation is over.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/4dONJ9evNU/trigger/gsJAqXp79
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.flowName - This property will tell the flow of the companion - is it welcome back, or motivation, etc.
   * @param {string} properties.tabCode - Specifies the tab which has been opened in the event 'Viewed Tiled Dashboard' and Other events too
   * @param {bool} properties.userIntervention - This will give true / false. True will come only when user has done something to stop the animation.
   * @param {bool} properties.caCompletedSuccessfully - This will be True/False. If animation completes successfully w/o the user interrupting it, the value will be True, otherwise False
   * @param {string} properties.tid - It's a unique id associated to every new animation getting triggered.
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.stateMachineCode - Every state machine has its own code, so whenever state machine switches we will be able to debug any issue that may arise
   * @param {string} properties.stateMachineTid - it is a unique code, passed as string for each state machine
   * @param {Array<string>} [properties.voUrl] - This property will have the URL of the VO played
   * @param {string} [properties.playableCode] - Pass the 'Playable Code' of the Playable being started/clicked
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/4dONJ9evNU}
   */
  function endedCompanionAnimation(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertFlowName(properties.flowName));
      messages = messages.concat(assertTabCode(properties.tabCode));
      messages = messages.concat(assertUserIntervention(properties.userIntervention));
      messages = messages.concat(assertCACompletedSuccessfully(properties.caCompletedSuccessfully));
      messages = messages.concat(assertTid(properties.tid));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertStateMachineCode(properties.stateMachineCode));
      messages = messages.concat(assertStateMachineTid(properties.stateMachineTid));
      messages = messages.concat(assertOptionalVoURL(properties.voUrl));
      messages = messages.concat(assertOptionalPlayableCode(properties.playableCode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Ended Companion Animation", Object.keys(properties), [
        "flowName",
        "tabCode",
        "userIntervention",
        "caCompletedSuccessfully",
        "tid",
        "platform",
        "elaGrade",
        "mathGrade",
        "mode",
        "userType",
        "signupFlow",
        "grade",
        "stateMachineCode",
        "stateMachineTid",
        "voUrl",
        "playableCode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "4dONJ9evNU", "2fe7996c2dfed74e5bb1de93fca0b605320deca2c2f54efc64af2323e4fe97e8", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Ended Companion Animation", {
        "Flow Name": properties.flowName,
        "Tab Code": properties.tabCode,
        "User Intervention": properties.userIntervention,
        "CA Completed Successfully": properties.caCompletedSuccessfully,
        "Tid": properties.tid,
        "Platform": properties.platform,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "State Machine Code": properties.stateMachineCode,
        "State Machine Tid": properties.stateMachineTid,
        "Vo URL": properties.voUrl,
        "Playable Code": properties.playableCode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("4dONJ9evNU", "Ended Companion Animation", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "D325IngkY", name: "State Machine Tid", value: properties.stateMachineTid},
        {id: "NPXDMFP1_", name: "User Intervention", value: properties.userIntervention},
        {id: "QjCwFasvW0", name: "Playable Code", value: properties.playableCode},
        {id: "QvqHzz_24", name: "Flow Name", value: properties.flowName},
        {id: "SYGmTqa9e", name: "Tid", value: properties.tid},
        {id: "T9gjnp76o", name: "State Machine Code", value: properties.stateMachineCode},
        {id: "_YDbEIGLh", name: "CA Completed Successfully", value: properties.caCompletedSuccessfully},
        {id: "l9PbANZBu", name: "Tab Code", value: properties.tabCode},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "yeiCDbEMb", name: "Vo URL", value: properties.voUrl},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Ended Companion Animation': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Ended Companion Animation", {
          "Flow Name": properties.flowName,
          "Tab Code": properties.tabCode,
          "User Intervention": properties.userIntervention,
          "CA Completed Successfully": properties.caCompletedSuccessfully,
          "Tid": properties.tid,
          "Platform": properties.platform,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "State Machine Code": properties.stateMachineCode,
          "State Machine Tid": properties.stateMachineTid,
          "Vo URL": properties.voUrl,
          "Playable Code": properties.playableCode,
          "Screen Height": sysScreenHeight,
          }, "4dONJ9evNU", "2fe7996c2dfed74e5bb1de93fca0b605320deca2c2f54efc64af2323e4fe97e8");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Ended Companion Animation", {
      "Flow Name": properties.flowName,
      "Tab Code": properties.tabCode,
      "User Intervention": properties.userIntervention,
      "CA Completed Successfully": properties.caCompletedSuccessfully,
      "Tid": properties.tid,
      "Platform": properties.platform,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "State Machine Code": properties.stateMachineCode,
      "State Machine Tid": properties.stateMachineTid,
      "Vo URL": properties.voUrl,
      "Playable Code": properties.playableCode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Companion Recommendation: This event is associated to a specific flow of the companion where it recommends a playable on the basis of user inactivity.
   * 
   * When to trigger this event:
   * 1. After sometime of user inactivity, the companion recommends a playable to play. This event will be triggered when recommendations happen.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/IbAOUQNf6l/trigger/T7nhGGN9f
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.playableCode - Pass the 'Playable Code' of the Playable being started/clicked
   * @param {string} properties.playableName - Name of playable selected
   * @param {string} [properties.contentGroup] - Code of content group user clicked/tapped on
   * @param {string} properties.tabCode - Specifies the tab which has been opened in the event 'Viewed Tiled Dashboard' and Other events too
   * @param {string} properties.tid - It's a unique id associated to every new animation getting triggered.
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/IbAOUQNf6l}
   */
  function viewedCompanionRecommendation(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlayableCode(properties.playableCode));
      messages = messages.concat(assertPlayableName(properties.playableName));
      messages = messages.concat(assertOptionalContentGroup(properties.contentGroup));
      messages = messages.concat(assertTabCode(properties.tabCode));
      messages = messages.concat(assertTid(properties.tid));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Companion Recommendation", Object.keys(properties), [
        "playableCode",
        "playableName",
        "contentGroup",
        "tabCode",
        "tid",
        "platform",
        "elaGrade",
        "mathGrade",
        "mode",
        "userType",
        "signupFlow",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "IbAOUQNf6l", "461f5468d34492a6481de4df177d86f4c6347bd23adcdc50dc82184d7fac0e79", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Companion Recommendation", {
        "Playable Code": properties.playableCode,
        "Playable Name": properties.playableName,
        "Content Group": properties.contentGroup,
        "Tab Code": properties.tabCode,
        "Tid": properties.tid,
        "Platform": properties.platform,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("IbAOUQNf6l", "Viewed Companion Recommendation", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "Otu1r2JQW", name: "Content Group", value: properties.contentGroup},
        {id: "QjCwFasvW0", name: "Playable Code", value: properties.playableCode},
        {id: "SYGmTqa9e", name: "Tid", value: properties.tid},
        {id: "c2W4X05Jy", name: "Playable Name", value: properties.playableName},
        {id: "l9PbANZBu", name: "Tab Code", value: properties.tabCode},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Companion Recommendation': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Companion Recommendation", {
          "Playable Code": properties.playableCode,
          "Playable Name": properties.playableName,
          "Content Group": properties.contentGroup,
          "Tab Code": properties.tabCode,
          "Tid": properties.tid,
          "Platform": properties.platform,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "IbAOUQNf6l", "461f5468d34492a6481de4df177d86f4c6347bd23adcdc50dc82184d7fac0e79");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Companion Recommendation", {
      "Playable Code": properties.playableCode,
      "Playable Name": properties.playableName,
      "Content Group": properties.contentGroup,
      "Tab Code": properties.tabCode,
      "Tid": properties.tid,
      "Platform": properties.platform,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Companion Recommendation: Like companion recommends a playable based on user inactivity, this event is specific to interaction on that screen.
   * 
   * When to trigger this event:
   * 1. When user clicks on the recommendation screen - user can click on the playable to start, click on home or the overlay.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/wTuuHkivgt/trigger/JKQ6FTmVR
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.playableCode - Pass the 'Playable Code' of the Playable being started/clicked
   * @param {string} properties.playableName - Name of playable selected
   * @param {string} properties.tabCode - Specifies the tab which has been opened in the event 'Viewed Tiled Dashboard' and Other events too
   * @param {string} [properties.contentGroup] - Code of content group user clicked/tapped on
   * @param {string} properties.tid - It's a unique id associated to every new animation getting triggered.
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/wTuuHkivgt}
   */
  function interactedCompanionRecommendation(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertPlayableCode(properties.playableCode));
      messages = messages.concat(assertPlayableName(properties.playableName));
      messages = messages.concat(assertTabCode(properties.tabCode));
      messages = messages.concat(assertOptionalContentGroup(properties.contentGroup));
      messages = messages.concat(assertTid(properties.tid));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Companion Recommendation", Object.keys(properties), [
        "clickedOn",
        "playableCode",
        "playableName",
        "tabCode",
        "contentGroup",
        "tid",
        "platform",
        "elaGrade",
        "mathGrade",
        "mode",
        "userType",
        "signupFlow",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "wTuuHkivgt", "57c5124adb97bc9f38d87e56fdf2ab5b2c04584c24884cf0fa4a076d5cc1233d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Companion Recommendation", {
        "Clicked On": properties.clickedOn,
        "Playable Code": properties.playableCode,
        "Playable Name": properties.playableName,
        "Tab Code": properties.tabCode,
        "Content Group": properties.contentGroup,
        "Tid": properties.tid,
        "Platform": properties.platform,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("wTuuHkivgt", "Interacted Companion Recommendation", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "Otu1r2JQW", name: "Content Group", value: properties.contentGroup},
        {id: "QjCwFasvW0", name: "Playable Code", value: properties.playableCode},
        {id: "SYGmTqa9e", name: "Tid", value: properties.tid},
        {id: "c2W4X05Jy", name: "Playable Name", value: properties.playableName},
        {id: "l9PbANZBu", name: "Tab Code", value: properties.tabCode},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Companion Recommendation': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Companion Recommendation", {
          "Clicked On": properties.clickedOn,
          "Playable Code": properties.playableCode,
          "Playable Name": properties.playableName,
          "Tab Code": properties.tabCode,
          "Content Group": properties.contentGroup,
          "Tid": properties.tid,
          "Platform": properties.platform,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "wTuuHkivgt", "57c5124adb97bc9f38d87e56fdf2ab5b2c04584c24884cf0fa4a076d5cc1233d");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Companion Recommendation", {
      "Clicked On": properties.clickedOn,
      "Playable Code": properties.playableCode,
      "Playable Name": properties.playableName,
      "Tab Code": properties.tabCode,
      "Content Group": properties.contentGroup,
      "Tid": properties.tid,
      "Platform": properties.platform,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Started Pitstop Companion Animation: This event is specific to the pitstops where companion comes and collects the stars.
   * 
   * When to trigger this event:
   * 1. When user sees the pitstop after completing the playable
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/scKxG4Olr8/trigger/fzDcvCc-D
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.playableCode - Pass the 'Playable Code' of the Playable being started/clicked
   * @param {string} [properties.nextPlayableCode] - The next playable that is going to load after current if the user is playing in the autoplay.
   * @param {string} properties.tid - It's a unique id associated to every new animation getting triggered.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.playableClickId - This property will hold a unique string for the playable events.
   * @param {string} properties.gameCode - Game code of the playable selected, for example: Math learning games have multiple variations, all those variations will have one game code
   * @param {string} properties.contentGroup - Code of content group user clicked/tapped on
   * @param {Array<string>} properties.recommendedRail - This property will be used to store which rails were shown to the user in the HOME tab.

Where possible values are:
Rail Name = Curriculum, Game Zone, Math, Language, Logic & Thinking, Art & Creativity, General Knowledge, Motor Skills, Live Classes, Fluency, Multiplayer
This comes with Rank also with | separation
   * @param {Array<string>} properties.recommendedCategory - This property will be used to store what recommendations were shown to the user in the all tabs.
We'll be saving them in this format:
<Category Name>
where possible values are:
Category name =  MyToDo, Math_LP, ELA_LP, Math Facts, Books, Spelling, Reading Comprehension, Playzone, Activities, Learning Games
   * @param {Array<string>} properties.recommendedRailName - This is the name of the rail viewed by the user. 
Recommended rail property comes with rail name and rail rank, pipe separated - with the introduction of this property, we intend to separate rail name to calculate CTR on Mixpanel.
   * @param {Array<int>} properties.recommendedRailRank - Recommended Rail Rank will carry the rank of the rail in integer format viewed by the user. 
   * @param {Array<string>} [properties.recommendedTileName] - This property will store the code of the tile user has interacted with - CG code for curriculum rails and game code for non curr. rails

   * @param {Array<int>} properties.recommendedTileRank - This property will store the position of the tile on which user has clciked. Earlier this was sent as column position

   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {string} properties.tabCode - Specifies the tab which has been opened in the event 'Viewed Tiled Dashboard' and Other events too
   * @param {string} properties.pitstopType - This will store if the pitstop is just stars, stars + level up, stars + level up + tier up
   * @param {int} properties.tabStrClickedCount - Streak count of Playable Clicked from a Specific Tab in a day
   * @param {int} properties.tabStrStartedCount - Streak count of Playable Started from a Specific Tab in a day
   * @param {int} properties.railStrClickedCount - Streak count of Playable Clicked from a Specific Rail in a day
   * @param {int} properties.railStrStartedCount - Streak count of Playable Started from a Specific Rail in a day
   * @param {int} properties.tileStrClickedCount - Streak count of Playable Clicked from a Specific Tile in a day
   * @param {int} properties.tileStrStartedCount - Streak count of Playable Started from a Specific Tile in a day
   * @param {int} properties.tabStrCompletedCount - Streak count of Playable Completed from a Specific Tab in a day
   * @param {int} properties.railStrCompletedCount - Streak count of Playable Completed from a Specific Rail in a day
   * @param {int} properties.tileStrCompletedCount - Streak count of Playable Completed from a Specific Tile in a day
   * @param {int} properties.overallClickedCount - Streak count of Playable Clicked in a day from anywhere
   * @param {int} properties.overallStartedCount - Streak count of Playable Started in a day from anywhere
   * @param {int} properties.overallCompletedCount - Streak count of Playable Completed in a day from anywhere
   * @param {string} properties.tileCode - Code of the Tile: Debugging purpose by tech team
   * @param {string} properties.railCode - Code of the Rail: Debugging purpose
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/scKxG4Olr8}
   */
  function startedPitstopCompanionAnimation(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlayableCode(properties.playableCode));
      messages = messages.concat(assertOptionalNextPlayableCode(properties.nextPlayableCode));
      messages = messages.concat(assertTid(properties.tid));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertPlayableClickId(properties.playableClickId));
      messages = messages.concat(assertGameCode(properties.gameCode));
      messages = messages.concat(assertContentGroup(properties.contentGroup));
      messages = messages.concat(assertRecommendedRail(properties.recommendedRail));
      messages = messages.concat(assertRecommendedCategory(properties.recommendedCategory));
      messages = messages.concat(assertRecommendedRailName(properties.recommendedRailName));
      messages = messages.concat(assertRecommendedRailRank(properties.recommendedRailRank));
      messages = messages.concat(assertOptionalRecommendedTileName(properties.recommendedTileName));
      messages = messages.concat(assertRecommendedTileRank(properties.recommendedTileRank));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertTabCode(properties.tabCode));
      messages = messages.concat(assertPitstopType(properties.pitstopType));
      messages = messages.concat(assertTabStrClickedCount(properties.tabStrClickedCount));
      messages = messages.concat(assertTabStrStartedCount(properties.tabStrStartedCount));
      messages = messages.concat(assertRailStrClickedCount(properties.railStrClickedCount));
      messages = messages.concat(assertRailStrStartedCount(properties.railStrStartedCount));
      messages = messages.concat(assertTileStrClickedCount(properties.tileStrClickedCount));
      messages = messages.concat(assertTileStrStartedCount(properties.tileStrStartedCount));
      messages = messages.concat(assertTabStrCompletedCount(properties.tabStrCompletedCount));
      messages = messages.concat(assertRailStrCompletedCount(properties.railStrCompletedCount));
      messages = messages.concat(assertTileStrCompletedCount(properties.tileStrCompletedCount));
      messages = messages.concat(assertOverallClickedCount(properties.overallClickedCount));
      messages = messages.concat(assertOverallStartedCount(properties.overallStartedCount));
      messages = messages.concat(assertOverallCompletedCount(properties.overallCompletedCount));
      messages = messages.concat(assertTileCode(properties.tileCode));
      messages = messages.concat(assertRailCode(properties.railCode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Started Pitstop Companion Animation", Object.keys(properties), [
        "playableCode",
        "nextPlayableCode",
        "tid",
        "grade",
        "playableClickId",
        "gameCode",
        "contentGroup",
        "recommendedRail",
        "recommendedCategory",
        "recommendedRailName",
        "recommendedRailRank",
        "recommendedTileName",
        "recommendedTileRank",
        "from",
        "tabCode",
        "pitstopType",
        "tabStrClickedCount",
        "tabStrStartedCount",
        "railStrClickedCount",
        "railStrStartedCount",
        "tileStrClickedCount",
        "tileStrStartedCount",
        "tabStrCompletedCount",
        "railStrCompletedCount",
        "tileStrCompletedCount",
        "overallClickedCount",
        "overallStartedCount",
        "overallCompletedCount",
        "tileCode",
        "railCode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "scKxG4Olr8", "eba5525042ed24509406d505d8e8d1c160c608267059a29200906bb8b9b72683", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Started Pitstop Companion Animation", {
        "Playable Code": properties.playableCode,
        "Next Playable Code": properties.nextPlayableCode,
        "Tid": properties.tid,
        "Grade": properties.grade,
        "Playable Click Id": properties.playableClickId,
        "Game Code": properties.gameCode,
        "Content Group": properties.contentGroup,
        "Recommended Rail": properties.recommendedRail,
        "Recommended Category": properties.recommendedCategory,
        "Recommended Rail Name": properties.recommendedRailName,
        "Recommended Rail Rank": properties.recommendedRailRank,
        "Recommended Tile Name": properties.recommendedTileName,
        "Recommended Tile Rank": properties.recommendedTileRank,
        "From": properties.from,
        "Tab Code": properties.tabCode,
        "Pitstop Type": properties.pitstopType,
        "Tab Str Clicked Count": properties.tabStrClickedCount,
        "Tab Str Started Count": properties.tabStrStartedCount,
        "Rail Str Clicked Count": properties.railStrClickedCount,
        "Rail Str Started Count": properties.railStrStartedCount,
        "Tile Str Clicked Count": properties.tileStrClickedCount,
        "Tile Str Started Count": properties.tileStrStartedCount,
        "Tab Str Completed Count": properties.tabStrCompletedCount,
        "Rail Str Completed Count": properties.railStrCompletedCount,
        "Tile Str Completed Count": properties.tileStrCompletedCount,
        "Overall Clicked Count": properties.overallClickedCount,
        "Overall Started Count": properties.overallStartedCount,
        "Overall Completed Count": properties.overallCompletedCount,
        "Tile Code": properties.tileCode,
        "Rail Code": properties.railCode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("scKxG4Olr8", "Started Pitstop Companion Animation", messages, [
        {id: "2oZQdvXRu", name: "Game Code", value: properties.gameCode},
        {id: "33JWk0cGdkpH6MbvcXKfL", name: "Tile Str Clicked Count", value: properties.tileStrClickedCount},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "6lrsWYY5Y", name: "Recommended Rail Name", value: properties.recommendedRailName},
        {id: "72Hz7CelRpVYf1warHrRP", name: "Tile Str Started Count", value: properties.tileStrStartedCount},
        {id: "7PQh3G9ITCcMDMNeMTM8q", name: "Tab Str Clicked Count", value: properties.tabStrClickedCount},
        {id: "88sHuVDRp", name: "Next Playable Code", value: properties.nextPlayableCode},
        {id: "8Vq9HABFDQ", name: "Pitstop Type", value: properties.pitstopType},
        {id: "AFC3Xnyx0vxpH2PWZIjdO", name: "Rail Str Completed Count", value: properties.railStrCompletedCount},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "FLDtSJNKL", name: "Recommended Tile Rank", value: properties.recommendedTileRank},
        {id: "GAdbKqJ5y9HJPos5lx5qt", name: "Tab Str Completed Count", value: properties.tabStrCompletedCount},
        {id: "GJYEymipLkc1xy54AyhV8", name: "Tile Code", value: properties.tileCode},
        {id: "HFnzATNuS7GI6VZs6tZ15", name: "Tab Str Started Count", value: properties.tabStrStartedCount},
        {id: "HJUIBmGrsUmqa_TYCtwQ0", name: "Overall Started Count", value: properties.overallStartedCount},
        {id: "OHBx0fnhzlxvHhw0e87pM", name: "Overall Completed Count", value: properties.overallCompletedCount},
        {id: "Otu1r2JQW", name: "Content Group", value: properties.contentGroup},
        {id: "QDMKmRkRjbW4pFvqlGOM6", name: "Rail Code", value: properties.railCode},
        {id: "QQeu-Td4-0", name: "Playable Click Id", value: properties.playableClickId},
        {id: "QjCwFasvW0", name: "Playable Code", value: properties.playableCode},
        {id: "SYGmTqa9e", name: "Tid", value: properties.tid},
        {id: "TYbmk5DQn", name: "Recommended Tile Name", value: properties.recommendedTileName},
        {id: "VdJhEU0H6s", name: "Recommended Category", value: properties.recommendedCategory},
        {id: "X4kgAx81N5AHgcI6NaNiS", name: "Overall Clicked Count", value: properties.overallClickedCount},
        {id: "_QL92wEdpoa8wH50vOPYt", name: "Tile Str Completed Count", value: properties.tileStrCompletedCount},
        {id: "drNgwJn5Xg", name: "Recommended Rail", value: properties.recommendedRail},
        {id: "hKAJ3izCFVFH-D4_886C8", name: "Rail Str Clicked Count", value: properties.railStrClickedCount},
        {id: "l9PbANZBu", name: "Tab Code", value: properties.tabCode},
        {id: "sRPi7ITwtlHeD7HQEGzmG", name: "Rail Str Started Count", value: properties.railStrStartedCount},
        {id: "uyLgqxbg7", name: "Recommended Rail Rank", value: properties.recommendedRailRank},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Started Pitstop Companion Animation': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Started Pitstop Companion Animation", {
          "Playable Code": properties.playableCode,
          "Next Playable Code": properties.nextPlayableCode,
          "Tid": properties.tid,
          "Grade": properties.grade,
          "Playable Click Id": properties.playableClickId,
          "Game Code": properties.gameCode,
          "Content Group": properties.contentGroup,
          "Recommended Rail": properties.recommendedRail,
          "Recommended Category": properties.recommendedCategory,
          "Recommended Rail Name": properties.recommendedRailName,
          "Recommended Rail Rank": properties.recommendedRailRank,
          "Recommended Tile Name": properties.recommendedTileName,
          "Recommended Tile Rank": properties.recommendedTileRank,
          "From": properties.from,
          "Tab Code": properties.tabCode,
          "Pitstop Type": properties.pitstopType,
          "Tab Str Clicked Count": properties.tabStrClickedCount,
          "Tab Str Started Count": properties.tabStrStartedCount,
          "Rail Str Clicked Count": properties.railStrClickedCount,
          "Rail Str Started Count": properties.railStrStartedCount,
          "Tile Str Clicked Count": properties.tileStrClickedCount,
          "Tile Str Started Count": properties.tileStrStartedCount,
          "Tab Str Completed Count": properties.tabStrCompletedCount,
          "Rail Str Completed Count": properties.railStrCompletedCount,
          "Tile Str Completed Count": properties.tileStrCompletedCount,
          "Overall Clicked Count": properties.overallClickedCount,
          "Overall Started Count": properties.overallStartedCount,
          "Overall Completed Count": properties.overallCompletedCount,
          "Tile Code": properties.tileCode,
          "Rail Code": properties.railCode,
          "Screen Height": sysScreenHeight,
          }, "scKxG4Olr8", "eba5525042ed24509406d505d8e8d1c160c608267059a29200906bb8b9b72683");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Started Pitstop Companion Animation", {
      "Playable Code": properties.playableCode,
      "Next Playable Code": properties.nextPlayableCode,
      "Tid": properties.tid,
      "Grade": properties.grade,
      "Playable Click Id": properties.playableClickId,
      "Game Code": properties.gameCode,
      "Content Group": properties.contentGroup,
      "Recommended Rail": properties.recommendedRail,
      "Recommended Category": properties.recommendedCategory,
      "Recommended Rail Name": properties.recommendedRailName,
      "Recommended Rail Rank": properties.recommendedRailRank,
      "Recommended Tile Name": properties.recommendedTileName,
      "Recommended Tile Rank": properties.recommendedTileRank,
      "From": properties.from,
      "Tab Code": properties.tabCode,
      "Pitstop Type": properties.pitstopType,
      "Tab Str Clicked Count": properties.tabStrClickedCount,
      "Tab Str Started Count": properties.tabStrStartedCount,
      "Rail Str Clicked Count": properties.railStrClickedCount,
      "Rail Str Started Count": properties.railStrStartedCount,
      "Tile Str Clicked Count": properties.tileStrClickedCount,
      "Tile Str Started Count": properties.tileStrStartedCount,
      "Tab Str Completed Count": properties.tabStrCompletedCount,
      "Rail Str Completed Count": properties.railStrCompletedCount,
      "Tile Str Completed Count": properties.tileStrCompletedCount,
      "Overall Clicked Count": properties.overallClickedCount,
      "Overall Started Count": properties.overallStartedCount,
      "Overall Completed Count": properties.overallCompletedCount,
      "Tile Code": properties.tileCode,
      "Rail Code": properties.railCode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Ended Pitstop Companion Animation: This event is specific to the pitstop when the companion is done with collecting the starts and portal out has happened.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/R1oCIqeQSw/trigger/idCCh4V2l
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.playableCode - Pass the 'Playable Code' of the Playable being started/clicked
   * @param {string} [properties.nextPlayableCode] - The next playable that is going to load after current if the user is playing in the autoplay.
   * @param {string} properties.tid - It's a unique id associated to every new animation getting triggered.
   * @param {float} properties.totalMemory - This property stores the total memory allocated by the client device
   * @param {float} properties.memoryLimit - The max memory allocated by the client device
   * @param {float} properties.memoryUsagePercentage - This property stores the % used memory
   * @param {float} properties.usedMemory - This property stores the memory consumed by the website
   * @param {string} properties.gameCode - Game code of the playable selected, for example: Math learning games have multiple variations, all those variations will have one game code
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {Array<string>} properties.recommendedRailName - This is the name of the rail viewed by the user. 
Recommended rail property comes with rail name and rail rank, pipe separated - with the introduction of this property, we intend to separate rail name to calculate CTR on Mixpanel.
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {string} properties.contentGroup - Code of content group user clicked/tapped on
   * @param {Array<int>} properties.recommendedTileRank - This property will store the position of the tile on which user has clciked. Earlier this was sent as column position

   * @param {string} properties.playableClickId - This property will hold a unique string for the playable events.
   * @param {Array<string>} [properties.recommendedTileName] - This property will store the code of the tile user has interacted with - CG code for curriculum rails and game code for non curr. rails

   * @param {Array<string>} properties.recommendedCategory - This property will be used to store what recommendations were shown to the user in the all tabs.
We'll be saving them in this format:
<Category Name>
where possible values are:
Category name =  MyToDo, Math_LP, ELA_LP, Math Facts, Books, Spelling, Reading Comprehension, Playzone, Activities, Learning Games
   * @param {Array<string>} properties.recommendedRail - This property will be used to store which rails were shown to the user in the HOME tab.

Where possible values are:
Rail Name = Curriculum, Game Zone, Math, Language, Logic & Thinking, Art & Creativity, General Knowledge, Motor Skills, Live Classes, Fluency, Multiplayer
This comes with Rank also with | separation
   * @param {string} properties.tabCode - Specifies the tab which has been opened in the event 'Viewed Tiled Dashboard' and Other events too
   * @param {Array<int>} properties.recommendedRailRank - Recommended Rail Rank will carry the rank of the rail in integer format viewed by the user. 
   * @param {string} properties.pitstopType - This will store if the pitstop is just stars, stars + level up, stars + level up + tier up
   * @param {int} properties.tabStrClickedCount - Streak count of Playable Clicked from a Specific Tab in a day
   * @param {int} properties.tabStrStartedCount - Streak count of Playable Started from a Specific Tab in a day
   * @param {int} properties.railStrClickedCount - Streak count of Playable Clicked from a Specific Rail in a day
   * @param {int} properties.railStrStartedCount - Streak count of Playable Started from a Specific Rail in a day
   * @param {int} properties.tileStrClickedCount - Streak count of Playable Clicked from a Specific Tile in a day
   * @param {int} properties.tileStrStartedCount - Streak count of Playable Started from a Specific Tile in a day
   * @param {int} properties.tabStrCompletedCount - Streak count of Playable Completed from a Specific Tab in a day
   * @param {int} properties.railStrCompletedCount - Streak count of Playable Completed from a Specific Rail in a day
   * @param {int} properties.tileStrCompletedCount - Streak count of Playable Completed from a Specific Tile in a day
   * @param {int} properties.overallClickedCount - Streak count of Playable Clicked in a day from anywhere
   * @param {int} properties.overallStartedCount - Streak count of Playable Started in a day from anywhere
   * @param {int} properties.overallCompletedCount - Streak count of Playable Completed in a day from anywhere
   * @param {string} properties.tileCode - Code of the Tile: Debugging purpose by tech team
   * @param {string} properties.railCode - Code of the Rail: Debugging purpose
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/R1oCIqeQSw}
   */
  function endedPitstopCompanionAnimation(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlayableCode(properties.playableCode));
      messages = messages.concat(assertOptionalNextPlayableCode(properties.nextPlayableCode));
      messages = messages.concat(assertTid(properties.tid));
      messages = messages.concat(assertTotalMemory(properties.totalMemory));
      messages = messages.concat(assertMemoryLimit(properties.memoryLimit));
      messages = messages.concat(assertMemoryUsagePercentage(properties.memoryUsagePercentage));
      messages = messages.concat(assertUsedMemory(properties.usedMemory));
      messages = messages.concat(assertGameCode(properties.gameCode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertRecommendedRailName(properties.recommendedRailName));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertContentGroup(properties.contentGroup));
      messages = messages.concat(assertRecommendedTileRank(properties.recommendedTileRank));
      messages = messages.concat(assertPlayableClickId(properties.playableClickId));
      messages = messages.concat(assertOptionalRecommendedTileName(properties.recommendedTileName));
      messages = messages.concat(assertRecommendedCategory(properties.recommendedCategory));
      messages = messages.concat(assertRecommendedRail(properties.recommendedRail));
      messages = messages.concat(assertTabCode(properties.tabCode));
      messages = messages.concat(assertRecommendedRailRank(properties.recommendedRailRank));
      messages = messages.concat(assertPitstopType(properties.pitstopType));
      messages = messages.concat(assertTabStrClickedCount(properties.tabStrClickedCount));
      messages = messages.concat(assertTabStrStartedCount(properties.tabStrStartedCount));
      messages = messages.concat(assertRailStrClickedCount(properties.railStrClickedCount));
      messages = messages.concat(assertRailStrStartedCount(properties.railStrStartedCount));
      messages = messages.concat(assertTileStrClickedCount(properties.tileStrClickedCount));
      messages = messages.concat(assertTileStrStartedCount(properties.tileStrStartedCount));
      messages = messages.concat(assertTabStrCompletedCount(properties.tabStrCompletedCount));
      messages = messages.concat(assertRailStrCompletedCount(properties.railStrCompletedCount));
      messages = messages.concat(assertTileStrCompletedCount(properties.tileStrCompletedCount));
      messages = messages.concat(assertOverallClickedCount(properties.overallClickedCount));
      messages = messages.concat(assertOverallStartedCount(properties.overallStartedCount));
      messages = messages.concat(assertOverallCompletedCount(properties.overallCompletedCount));
      messages = messages.concat(assertTileCode(properties.tileCode));
      messages = messages.concat(assertRailCode(properties.railCode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Ended Pitstop Companion Animation", Object.keys(properties), [
        "playableCode",
        "nextPlayableCode",
        "tid",
        "totalMemory",
        "memoryLimit",
        "memoryUsagePercentage",
        "usedMemory",
        "gameCode",
        "grade",
        "recommendedRailName",
        "from",
        "contentGroup",
        "recommendedTileRank",
        "playableClickId",
        "recommendedTileName",
        "recommendedCategory",
        "recommendedRail",
        "tabCode",
        "recommendedRailRank",
        "pitstopType",
        "tabStrClickedCount",
        "tabStrStartedCount",
        "railStrClickedCount",
        "railStrStartedCount",
        "tileStrClickedCount",
        "tileStrStartedCount",
        "tabStrCompletedCount",
        "railStrCompletedCount",
        "tileStrCompletedCount",
        "overallClickedCount",
        "overallStartedCount",
        "overallCompletedCount",
        "tileCode",
        "railCode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "R1oCIqeQSw", "ee4310fd30d18c1338a73fe352c05526c38e44ea3bd27eb226d355d093ef66d3", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Ended Pitstop Companion Animation", {
        "Playable Code": properties.playableCode,
        "Next Playable Code": properties.nextPlayableCode,
        "Tid": properties.tid,
        "Total Memory": properties.totalMemory,
        "Memory Limit": properties.memoryLimit,
        "Memory Usage Percentage": properties.memoryUsagePercentage,
        "Used Memory": properties.usedMemory,
        "Game Code": properties.gameCode,
        "Grade": properties.grade,
        "Recommended Rail Name": properties.recommendedRailName,
        "From": properties.from,
        "Content Group": properties.contentGroup,
        "Recommended Tile Rank": properties.recommendedTileRank,
        "Playable Click Id": properties.playableClickId,
        "Recommended Tile Name": properties.recommendedTileName,
        "Recommended Category": properties.recommendedCategory,
        "Recommended Rail": properties.recommendedRail,
        "Tab Code": properties.tabCode,
        "Recommended Rail Rank": properties.recommendedRailRank,
        "Pitstop Type": properties.pitstopType,
        "Tab Str Clicked Count": properties.tabStrClickedCount,
        "Tab Str Started Count": properties.tabStrStartedCount,
        "Rail Str Clicked Count": properties.railStrClickedCount,
        "Rail Str Started Count": properties.railStrStartedCount,
        "Tile Str Clicked Count": properties.tileStrClickedCount,
        "Tile Str Started Count": properties.tileStrStartedCount,
        "Tab Str Completed Count": properties.tabStrCompletedCount,
        "Rail Str Completed Count": properties.railStrCompletedCount,
        "Tile Str Completed Count": properties.tileStrCompletedCount,
        "Overall Clicked Count": properties.overallClickedCount,
        "Overall Started Count": properties.overallStartedCount,
        "Overall Completed Count": properties.overallCompletedCount,
        "Tile Code": properties.tileCode,
        "Rail Code": properties.railCode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("R1oCIqeQSw", "Ended Pitstop Companion Animation", messages, [
        {id: "2hMTTBgU30", name: "Total Memory", value: properties.totalMemory},
        {id: "2oZQdvXRu", name: "Game Code", value: properties.gameCode},
        {id: "33JWk0cGdkpH6MbvcXKfL", name: "Tile Str Clicked Count", value: properties.tileStrClickedCount},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "6lrsWYY5Y", name: "Recommended Rail Name", value: properties.recommendedRailName},
        {id: "72Hz7CelRpVYf1warHrRP", name: "Tile Str Started Count", value: properties.tileStrStartedCount},
        {id: "7PQh3G9ITCcMDMNeMTM8q", name: "Tab Str Clicked Count", value: properties.tabStrClickedCount},
        {id: "88sHuVDRp", name: "Next Playable Code", value: properties.nextPlayableCode},
        {id: "8Vq9HABFDQ", name: "Pitstop Type", value: properties.pitstopType},
        {id: "ADfS21LlJH", name: "Memory Limit", value: properties.memoryLimit},
        {id: "AFC3Xnyx0vxpH2PWZIjdO", name: "Rail Str Completed Count", value: properties.railStrCompletedCount},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "FLDtSJNKL", name: "Recommended Tile Rank", value: properties.recommendedTileRank},
        {id: "GAdbKqJ5y9HJPos5lx5qt", name: "Tab Str Completed Count", value: properties.tabStrCompletedCount},
        {id: "GJYEymipLkc1xy54AyhV8", name: "Tile Code", value: properties.tileCode},
        {id: "HFnzATNuS7GI6VZs6tZ15", name: "Tab Str Started Count", value: properties.tabStrStartedCount},
        {id: "HJUIBmGrsUmqa_TYCtwQ0", name: "Overall Started Count", value: properties.overallStartedCount},
        {id: "OHBx0fnhzlxvHhw0e87pM", name: "Overall Completed Count", value: properties.overallCompletedCount},
        {id: "Otu1r2JQW", name: "Content Group", value: properties.contentGroup},
        {id: "QDMKmRkRjbW4pFvqlGOM6", name: "Rail Code", value: properties.railCode},
        {id: "QQeu-Td4-0", name: "Playable Click Id", value: properties.playableClickId},
        {id: "QjCwFasvW0", name: "Playable Code", value: properties.playableCode},
        {id: "SYGmTqa9e", name: "Tid", value: properties.tid},
        {id: "TYbmk5DQn", name: "Recommended Tile Name", value: properties.recommendedTileName},
        {id: "VdJhEU0H6s", name: "Recommended Category", value: properties.recommendedCategory},
        {id: "X4kgAx81N5AHgcI6NaNiS", name: "Overall Clicked Count", value: properties.overallClickedCount},
        {id: "_QL92wEdpoa8wH50vOPYt", name: "Tile Str Completed Count", value: properties.tileStrCompletedCount},
        {id: "drNgwJn5Xg", name: "Recommended Rail", value: properties.recommendedRail},
        {id: "fXWDPkk_PZ", name: "Memory Usage Percentage", value: properties.memoryUsagePercentage},
        {id: "gvDk2xQI4d", name: "Used Memory", value: properties.usedMemory},
        {id: "hKAJ3izCFVFH-D4_886C8", name: "Rail Str Clicked Count", value: properties.railStrClickedCount},
        {id: "l9PbANZBu", name: "Tab Code", value: properties.tabCode},
        {id: "sRPi7ITwtlHeD7HQEGzmG", name: "Rail Str Started Count", value: properties.railStrStartedCount},
        {id: "uyLgqxbg7", name: "Recommended Rail Rank", value: properties.recommendedRailRank},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Ended Pitstop Companion Animation': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Ended Pitstop Companion Animation", {
          "Playable Code": properties.playableCode,
          "Next Playable Code": properties.nextPlayableCode,
          "Tid": properties.tid,
          "Total Memory": properties.totalMemory,
          "Memory Limit": properties.memoryLimit,
          "Memory Usage Percentage": properties.memoryUsagePercentage,
          "Used Memory": properties.usedMemory,
          "Game Code": properties.gameCode,
          "Grade": properties.grade,
          "Recommended Rail Name": properties.recommendedRailName,
          "From": properties.from,
          "Content Group": properties.contentGroup,
          "Recommended Tile Rank": properties.recommendedTileRank,
          "Playable Click Id": properties.playableClickId,
          "Recommended Tile Name": properties.recommendedTileName,
          "Recommended Category": properties.recommendedCategory,
          "Recommended Rail": properties.recommendedRail,
          "Tab Code": properties.tabCode,
          "Recommended Rail Rank": properties.recommendedRailRank,
          "Pitstop Type": properties.pitstopType,
          "Tab Str Clicked Count": properties.tabStrClickedCount,
          "Tab Str Started Count": properties.tabStrStartedCount,
          "Rail Str Clicked Count": properties.railStrClickedCount,
          "Rail Str Started Count": properties.railStrStartedCount,
          "Tile Str Clicked Count": properties.tileStrClickedCount,
          "Tile Str Started Count": properties.tileStrStartedCount,
          "Tab Str Completed Count": properties.tabStrCompletedCount,
          "Rail Str Completed Count": properties.railStrCompletedCount,
          "Tile Str Completed Count": properties.tileStrCompletedCount,
          "Overall Clicked Count": properties.overallClickedCount,
          "Overall Started Count": properties.overallStartedCount,
          "Overall Completed Count": properties.overallCompletedCount,
          "Tile Code": properties.tileCode,
          "Rail Code": properties.railCode,
          "Screen Height": sysScreenHeight,
          }, "R1oCIqeQSw", "ee4310fd30d18c1338a73fe352c05526c38e44ea3bd27eb226d355d093ef66d3");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Ended Pitstop Companion Animation", {
      "Playable Code": properties.playableCode,
      "Next Playable Code": properties.nextPlayableCode,
      "Tid": properties.tid,
      "Total Memory": properties.totalMemory,
      "Memory Limit": properties.memoryLimit,
      "Memory Usage Percentage": properties.memoryUsagePercentage,
      "Used Memory": properties.usedMemory,
      "Game Code": properties.gameCode,
      "Grade": properties.grade,
      "Recommended Rail Name": properties.recommendedRailName,
      "From": properties.from,
      "Content Group": properties.contentGroup,
      "Recommended Tile Rank": properties.recommendedTileRank,
      "Playable Click Id": properties.playableClickId,
      "Recommended Tile Name": properties.recommendedTileName,
      "Recommended Category": properties.recommendedCategory,
      "Recommended Rail": properties.recommendedRail,
      "Tab Code": properties.tabCode,
      "Recommended Rail Rank": properties.recommendedRailRank,
      "Pitstop Type": properties.pitstopType,
      "Tab Str Clicked Count": properties.tabStrClickedCount,
      "Tab Str Started Count": properties.tabStrStartedCount,
      "Rail Str Clicked Count": properties.railStrClickedCount,
      "Rail Str Started Count": properties.railStrStartedCount,
      "Tile Str Clicked Count": properties.tileStrClickedCount,
      "Tile Str Started Count": properties.tileStrStartedCount,
      "Tab Str Completed Count": properties.tabStrCompletedCount,
      "Rail Str Completed Count": properties.railStrCompletedCount,
      "Tile Str Completed Count": properties.tileStrCompletedCount,
      "Overall Clicked Count": properties.overallClickedCount,
      "Overall Started Count": properties.overallStartedCount,
      "Overall Completed Count": properties.overallCompletedCount,
      "Tile Code": properties.tileCode,
      "Rail Code": properties.railCode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Received Rive File: This event will be used for debugging purpose only. 
   * 
   * When to trigger this event:
   * 1. The event gets triggered when we get events in the pending events API of splashee.
The event will be used for debugging/monitoring purpose.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/IAJ5wU1sXk/trigger/7_33H0u0V
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/IAJ5wU1sXk}
   */
  function receivedRiveFile(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Received Rive File", Object.keys(properties), [
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "IAJ5wU1sXk", "b6c54341cd1ce3892624c0ee38e0d4f0a21faa189d4fd94eadddd157c0c31e5f", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Received Rive File", {
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("IAJ5wU1sXk", "Received Rive File", messages, [
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Received Rive File': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Received Rive File", {
          "Screen Height": sysScreenHeight,
          }, "IAJ5wU1sXk", "b6c54341cd1ce3892624c0ee38e0d4f0a21faa189d4fd94eadddd157c0c31e5f");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Received Rive File", {
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Companion Events Backend: This event will be fired once the API receives the pending events from backend. It will be used purely for debugging purposes.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {Array<string>} properties.eventName - In the API response, it will show which files/events info received in response.
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/e4DuEUN6yq}
   */
  function companionEventsBackend(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertEventName(properties.eventName));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Companion Events Backend", Object.keys(properties), [
        "eventName",
        "platform",
        "elaGrade",
        "mathGrade",
        "mode",
        "userType",
        "signupFlow",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "e4DuEUN6yq", "422d63cd3c9f07dfbff01312d69a1ddd55fae15439a9b9c4f0c2f85c0818baaf", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Companion Events Backend", {
        "Event Name": properties.eventName,
        "Platform": properties.platform,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("e4DuEUN6yq", "Companion Events Backend", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "DmZydOAXd", name: "Event Name", value: properties.eventName},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Companion Events Backend': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Companion Events Backend", {
          "Event Name": properties.eventName,
          "Platform": properties.platform,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "e4DuEUN6yq", "422d63cd3c9f07dfbff01312d69a1ddd55fae15439a9b9c4f0c2f85c0818baaf");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Companion Events Backend", {
      "Event Name": properties.eventName,
      "Platform": properties.platform,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Reached Daily Limit Backend: This event needs to be fired when the user reaches the daily limit irrespective of the experiment segment. This should happen for 2 free cards or freemium of 10 minutes. 
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {string} properties.contentType - Type of content viz. Game/Learning Path/Activities/Worksheets
   * @param {string} properties.contentCode - Last content code when limit reached
   * @param {string} properties.contentName - Name of the last playable/activity/worksheet/live class etc, when limit reached
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/M-LJK1cyN}
   */
  function reachedDailyLimitBackend(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertContentType(properties.contentType));
      messages = messages.concat(assertContentCode(properties.contentCode));
      messages = messages.concat(assertContentName(properties.contentName));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Reached Daily Limit Backend", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "subject",
        "grade",
        "from",
        "contentType",
        "contentCode",
        "contentName"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "M-LJK1cyN", "fb3b0137064a35d80cc5e25c33c898d7d7d2fd5d29b560187837878f476ed970", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Reached Daily Limit Backend", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Subject": properties.subject,
        "Grade": properties.grade,
        "From": properties.from,
        "Content Type": properties.contentType,
        "Content Code": properties.contentCode,
        "Content Name": properties.contentName,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("M-LJK1cyN", "Reached Daily Limit Backend", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "Nfs9QLl8W7", name: "Content Type", value: properties.contentType},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "gwbjSWtxS", name: "Content Code", value: properties.contentCode},
        {id: "mWOBwcMoZ", name: "Content Name", value: properties.contentName},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Reached Daily Limit Backend': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Reached Daily Limit Backend", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Subject": properties.subject,
          "Grade": properties.grade,
          "From": properties.from,
          "Content Type": properties.contentType,
          "Content Code": properties.contentCode,
          "Content Name": properties.contentName,
          "Screen Height": sysScreenHeight,
          }, "M-LJK1cyN", "fb3b0137064a35d80cc5e25c33c898d7d7d2fd5d29b560187837878f476ed970");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Reached Daily Limit Backend", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Subject": properties.subject,
      "Grade": properties.grade,
      "From": properties.from,
      "Content Type": properties.contentType,
      "Content Code": properties.contentCode,
      "Content Name": properties.contentName,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Add-on Pitch Screen: Triggered when the user is seeing add-on pitch screen immediately after starting their free trial of splashlearn
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/PXFWBQ8pU3/trigger/qL0CUPN4t
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/PXFWBQ8pU3}
   */
  function viewedAddOnPitchScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Add-on Pitch Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "PXFWBQ8pU3", "ab2ef3adbde2ca0490fcc82067a606aae5ae65f8cc154ca39a3ecab1450d2ecd", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Add-on Pitch Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("PXFWBQ8pU3", "Viewed Add-on Pitch Screen", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Add-on Pitch Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Add-on Pitch Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Screen Height": sysScreenHeight,
          }, "PXFWBQ8pU3", "ab2ef3adbde2ca0490fcc82067a606aae5ae65f8cc154ca39a3ecab1450d2ecd");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Add-on Pitch Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Add-on Pitch Screen: Triggered when the user interacts with our add-on pitch screen. There are 2 CTAs where the user can click
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/H2lRb4IRCY/trigger/RokxkpiXn
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/H2lRb4IRCY}
   */
  function interactedAddOnPitchScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Add-on Pitch Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "H2lRb4IRCY", "79a959cfe7189a658cf4e966ae82df847a05cfa64e68c718ba4f55b94f6c1b8e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Add-on Pitch Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("H2lRb4IRCY", "Interacted Add-on Pitch Screen", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Add-on Pitch Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Add-on Pitch Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "H2lRb4IRCY", "79a959cfe7189a658cf4e966ae82df847a05cfa64e68c718ba4f55b94f6c1b8e");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Add-on Pitch Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Add-on Upgrade Screen: Triggered when the user is interested in live classes and moves to the next screen where they are asked to upgrade the subscription
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/dG7ayD4bTy/trigger/FwzYzj3UK
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/dG7ayD4bTy}
   */
  function viewedAddOnUpgradeScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Add-on Upgrade Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "dG7ayD4bTy", "22c20f234407cf2aeffe47ab9f10c38c46d04178a3375312115800e6df1b3ac3", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Add-on Upgrade Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("dG7ayD4bTy", "Viewed Add-on Upgrade Screen", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Add-on Upgrade Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Add-on Upgrade Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Screen Height": sysScreenHeight,
          }, "dG7ayD4bTy", "22c20f234407cf2aeffe47ab9f10c38c46d04178a3375312115800e6df1b3ac3");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Add-on Upgrade Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Add-on Upgrade Screen: Triggered when the user interacts anywhere on the add-on upgrade screen
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/jE74LAzM9W/trigger/xt8tEu8yH
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/jE74LAzM9W}
   */
  function interactedAddOnUpgradeScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Add-on Upgrade Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "jE74LAzM9W", "5950938e070ccd8c8bd0ee0d0f7a598c0edcd232dd26a758c9518f3fdc76396d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Add-on Upgrade Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("jE74LAzM9W", "Interacted Add-on Upgrade Screen", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Add-on Upgrade Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Add-on Upgrade Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "jE74LAzM9W", "5950938e070ccd8c8bd0ee0d0f7a598c0edcd232dd26a758c9518f3fdc76396d");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Add-on Upgrade Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Add-on Purchase Thank You Screen: Triggered after the user decides to upgrade their trial and purchase the add-on. The user arrives at this screen after some animation and hence tracking this event separately will be important
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/5pu5eq8KFO/trigger/08J4YyRUq
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/5pu5eq8KFO}
   */
  function viewedAddOnPurchaseThankYouScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Add-on Purchase Thank You Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "5pu5eq8KFO", "511562608ed025077da361d565f1ff7743e0881cda15f78817586560dac54f8c", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Add-on Purchase Thank You Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("5pu5eq8KFO", "Viewed Add-on Purchase Thank You Screen", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Add-on Purchase Thank You Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Add-on Purchase Thank You Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Screen Height": sysScreenHeight,
          }, "5pu5eq8KFO", "511562608ed025077da361d565f1ff7743e0881cda15f78817586560dac54f8c");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Add-on Purchase Thank You Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Add-on Purchase Thank You Screen: Triggered when the user starts interacting on the purchase thank you screen
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/QT1Zp_1x6-/trigger/prOwh0PVx
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/QT1Zp_1x6-}
   */
  function interactedAddOnPurchaseThankYouScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Add-on Purchase Thank You Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "QT1Zp_1x6-", "4d9c12218f48421b51b22e940f98c953cba74f48d0f994bac17ded5b70e2078a", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Add-on Purchase Thank You Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("QT1Zp_1x6-", "Interacted Add-on Purchase Thank You Screen", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Add-on Purchase Thank You Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Add-on Purchase Thank You Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "QT1Zp_1x6-", "4d9c12218f48421b51b22e940f98c953cba74f48d0f994bac17ded5b70e2078a");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Add-on Purchase Thank You Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Post Live Class Pitch: Triggered when a free user drops or ends the class
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/P8E8Esk3NA/trigger/u6HRYjajN
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/P8E8Esk3NA}
   */
  function viewedPostLiveClassPitch(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Post Live Class Pitch", Object.keys(properties), [
        "mathGrade",
        "mode",
        "platform",
        "userType",
        "signupFlow",
        "grade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "P8E8Esk3NA", "a9e24496438ba39ae00d3acea37114b764faa5aa188b141f04172ff2446027fa", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Post Live Class Pitch", {
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("P8E8Esk3NA", "Viewed Post Live Class Pitch", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Post Live Class Pitch': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Post Live Class Pitch", {
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "P8E8Esk3NA", "a9e24496438ba39ae00d3acea37114b764faa5aa188b141f04172ff2446027fa");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Post Live Class Pitch", {
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Post Live Class Pitch: Triggered when a user interacts with the post live class pitch
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Q_-GVIESpj/trigger/tbOdM13OS
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Q_-GVIESpj}
   */
  function interactedPostLiveClassPitch(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Post Live Class Pitch", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "clickedOn",
        "grade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Q_-GVIESpj", "01e29ea12dd25b79bd666dbab3169e44a2bd75addeda54503bbd34fd1654cb3e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Post Live Class Pitch", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Clicked On": properties.clickedOn,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Q_-GVIESpj", "Interacted Post Live Class Pitch", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Post Live Class Pitch': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Post Live Class Pitch", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Clicked On": properties.clickedOn,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "Q_-GVIESpj", "01e29ea12dd25b79bd666dbab3169e44a2bd75addeda54503bbd34fd1654cb3e");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Post Live Class Pitch", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Clicked On": properties.clickedOn,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Reinforcement at Home [B2B]: This event will be triggered when the user lands on the 'Reinforcement at Home' page.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/UmMA_mjerT/trigger/XRqrkXgSh
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/UmMA_mjerT}
   */
  function viewedReinforcementAtHomeB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Reinforcement at Home [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "UmMA_mjerT", "06f184ee5133772520e676b4e81acb74080dc314c1785f34107bfc8d9f731f8f", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Reinforcement at Home [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("UmMA_mjerT", "Viewed Reinforcement at Home [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Reinforcement at Home [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Reinforcement at Home [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "UmMA_mjerT", "06f184ee5133772520e676b4e81acb74080dc314c1785f34107bfc8d9f731f8f");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Reinforcement at Home [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Reinforcement at Home [B2B]: This event will be fired when the user interacts with the Reinforcement at Home [B2B]tab.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/De3feF0wy/trigger/I39GKLhSw
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.section - This will capture the widget name that is being viewed/interacted by the user in that viewport. For example, 'Onboarding Widget', 'Home Access Widget', 'Assignment Widget', 'Assessment Widget', 'Math Fact Widget'
The list will only have 1 value for 'Section' property for Interacted event.
   * @param {string} [properties.liveClassSubject] - This will capture the subject of the specific live class shared/clicked by teacher.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/De3feF0wy}
   */
  function interactedReinforcementAtHomeB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertSection(properties.section));
      messages = messages.concat(assertOptionalLiveClassSubject(properties.liveClassSubject));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Reinforcement at Home [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "section",
        "liveClassSubject"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "De3feF0wy", "7376ca3fff3783265488d7d4e3148b7e172c1ea66a4b83cf678e1a7b5b8982d0", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Reinforcement at Home [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Section": properties.section,
        "Live Class Subject": properties.liveClassSubject,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("De3feF0wy", "Interacted Reinforcement at Home [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "Ys_LWCV8p", name: "Live Class Subject", value: properties.liveClassSubject},
        {id: "my9qL7M8w6", name: "Section", value: properties.section},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Reinforcement at Home [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Reinforcement at Home [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Section": properties.section,
          "Live Class Subject": properties.liveClassSubject,
          "Screen Height": sysScreenHeight,
          }, "De3feF0wy", "7376ca3fff3783265488d7d4e3148b7e172c1ea66a4b83cf678e1a7b5b8982d0");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Reinforcement at Home [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Section": properties.section,
      "Live Class Subject": properties.liveClassSubject,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Live Class Page [B2B]: This event will be fired when the user lands on the live class page.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/lZZs1HRlkF/trigger/e9rmJWrNZ
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.section - This will capture the widget name that is being viewed/interacted by the user in that viewport. For example, 'Onboarding Widget', 'Home Access Widget', 'Assignment Widget', 'Assessment Widget', 'Math Fact Widget'
The list will only have 1 value for 'Section' property for Interacted event.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * @param {int} properties.daysSinceClassCreation - Self explanatory
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/lZZs1HRlkF}
   */
  function viewedLiveClassPageB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertSection(properties.section));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertDaysSinceClassCreation(properties.daysSinceClassCreation));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Live Class Page [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "section",
        "fromPage",
        "daysSinceClassCreation"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "lZZs1HRlkF", "a13ce26ad6f3b3a0ee683277ce2c17eb3601e0ba21be991abf1a1ebb4b23d020", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Live Class Page [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Section": properties.section,
        "From Page": properties.fromPage,
        "Days Since Class Creation": properties.daysSinceClassCreation,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("lZZs1HRlkF", "Viewed Live Class Page [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "TuspgTIuZ1", name: "Days Since Class Creation", value: properties.daysSinceClassCreation},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "my9qL7M8w6", name: "Section", value: properties.section},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Live Class Page [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Live Class Page [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Section": properties.section,
          "From Page": properties.fromPage,
          "Days Since Class Creation": properties.daysSinceClassCreation,
          "Screen Height": sysScreenHeight,
          }, "lZZs1HRlkF", "a13ce26ad6f3b3a0ee683277ce2c17eb3601e0ba21be991abf1a1ebb4b23d020");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Live Class Page [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Section": properties.section,
      "From Page": properties.fromPage,
      "Days Since Class Creation": properties.daysSinceClassCreation,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Live Class Page [B2B]: This event will be fired when the user interacts with the live class page.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/kJ8DpBgDY/trigger/4teYToc2T
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.section - This will capture the widget name that is being viewed/interacted by the user in that viewport. For example, 'Onboarding Widget', 'Home Access Widget', 'Assignment Widget', 'Assessment Widget', 'Math Fact Widget'
The list will only have 1 value for 'Section' property for Interacted event.
   * @param {string} [properties.liveClassName] - This will capture the title of the live class.
   * @param {string} [properties.liveClassWeek] - This will capture if the live class that was shared was from the current or next week.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} [properties.liveClassSubject] - This will capture the subject of the specific live class shared/clicked by teacher.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/kJ8DpBgDY}
   */
  function interactedLiveClassPageB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertSection(properties.section));
      messages = messages.concat(assertOptionalLiveClassName(properties.liveClassName));
      messages = messages.concat(assertOptionalLiveClassWeek(properties.liveClassWeek));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertOptionalLiveClassSubject(properties.liveClassSubject));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Live Class Page [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "section",
        "liveClassName",
        "liveClassWeek",
        "clickedOn",
        "liveClassSubject"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "kJ8DpBgDY", "d5ec5bd83e6ba5d24b66742cbbc4dfee88cec27f99a6547909f6fa8580830f66", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Live Class Page [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Section": properties.section,
        "Live Class Name": properties.liveClassName,
        "Live Class Week": properties.liveClassWeek,
        "Clicked On": properties.clickedOn,
        "Live Class Subject": properties.liveClassSubject,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("kJ8DpBgDY", "Interacted Live Class Page [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "F__odFSVZ", name: "Live Class Name", value: properties.liveClassName},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "Ys_LWCV8p", name: "Live Class Subject", value: properties.liveClassSubject},
        {id: "my9qL7M8w6", name: "Section", value: properties.section},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "spiyY6nfy", name: "Live Class Week", value: properties.liveClassWeek},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Live Class Page [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Live Class Page [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Section": properties.section,
          "Live Class Name": properties.liveClassName,
          "Live Class Week": properties.liveClassWeek,
          "Clicked On": properties.clickedOn,
          "Live Class Subject": properties.liveClassSubject,
          "Screen Height": sysScreenHeight,
          }, "kJ8DpBgDY", "d5ec5bd83e6ba5d24b66742cbbc4dfee88cec27f99a6547909f6fa8580830f66");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Live Class Page [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Section": properties.section,
      "Live Class Name": properties.liveClassName,
      "Live Class Week": properties.liveClassWeek,
      "Clicked On": properties.clickedOn,
      "Live Class Subject": properties.liveClassSubject,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Max Live Class Limit Reached Popup [B2B]: This event will be fired whenever the user will see the error for max no. of classes shared popup message.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/UIfEU7va_0/trigger/JQS4eYyg7
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/UIfEU7va_0}
   */
  function viewedMaxLiveClassLimitReachedPopupB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Max Live Class Limit Reached Popup [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "UIfEU7va_0", "52c368a479faf848f2a6c6da7265b3092a9d11000ea259fa67b46ee69e8f2d45", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Max Live Class Limit Reached Popup [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("UIfEU7va_0", "Viewed Max Live Class Limit Reached Popup [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Max Live Class Limit Reached Popup [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Max Live Class Limit Reached Popup [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "UIfEU7va_0", "52c368a479faf848f2a6c6da7265b3092a9d11000ea259fa67b46ee69e8f2d45");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Max Live Class Limit Reached Popup [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Share Live Class Popup [B2B]: This event will be fired when the user clicks on 'Share' next to a live class and the share live class popup appears.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/lQCBfZFMdk/trigger/4LdGit9TT
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/lQCBfZFMdk}
   */
  function viewedShareLiveClassPopupB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Share Live Class Popup [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "fromPage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "lQCBfZFMdk", "ebc915a9c85aa7157fd8020fbc12e4c76e204c6a4b7f3ad83391f5841d226fe9", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Share Live Class Popup [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From Page": properties.fromPage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("lQCBfZFMdk", "Viewed Share Live Class Popup [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Share Live Class Popup [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Share Live Class Popup [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From Page": properties.fromPage,
          "Screen Height": sysScreenHeight,
          }, "lQCBfZFMdk", "ebc915a9c85aa7157fd8020fbc12e4c76e204c6a4b7f3ad83391f5841d226fe9");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Share Live Class Popup [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From Page": properties.fromPage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Share Live Class Popup [B2B]: This event will be fired when the user clicks anywhere on the Share Live Class popup.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/6A5k2oC6lq/trigger/6-EUjCD-a
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {Array<string>} [properties.studentId] - This will capture the Student analytics IDs in an array.
   * @param {string} [properties.percentClassInvited] - This will capture the (percentage of invited students in that class/total students in that class)
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * @param {string} properties.liveClassName - This will capture the title of the live class.
   * @param {string} properties.liveClassSubject - This will capture the subject of the specific live class shared/clicked by teacher.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/6A5k2oC6lq}
   */
  function interactedShareLiveClassPopupB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertOptionalStudentID(properties.studentId));
      messages = messages.concat(assertOptionalPercentClassInvited(properties.percentClassInvited));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertLiveClassName(properties.liveClassName));
      messages = messages.concat(assertLiveClassSubject(properties.liveClassSubject));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Share Live Class Popup [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "studentId",
        "percentClassInvited",
        "fromPage",
        "liveClassName",
        "liveClassSubject"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "6A5k2oC6lq", "ce229bb914e54368c80aaef97e76f41a45485bd2f3be9e0c0728f607eab5d93e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Share Live Class Popup [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Student ID": properties.studentId,
        "Percent Class Invited": properties.percentClassInvited,
        "From Page": properties.fromPage,
        "Live Class Name": properties.liveClassName,
        "Live Class Subject": properties.liveClassSubject,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("6A5k2oC6lq", "Interacted Share Live Class Popup [B2B]", messages, [
        {id: "2Q7hpPm9y", name: "Percent Class Invited", value: properties.percentClassInvited},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "5IEpaITD9", name: "Student ID", value: properties.studentId},
        {id: "F__odFSVZ", name: "Live Class Name", value: properties.liveClassName},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "Ys_LWCV8p", name: "Live Class Subject", value: properties.liveClassSubject},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Share Live Class Popup [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Share Live Class Popup [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Student ID": properties.studentId,
          "Percent Class Invited": properties.percentClassInvited,
          "From Page": properties.fromPage,
          "Live Class Name": properties.liveClassName,
          "Live Class Subject": properties.liveClassSubject,
          "Screen Height": sysScreenHeight,
          }, "6A5k2oC6lq", "ce229bb914e54368c80aaef97e76f41a45485bd2f3be9e0c0728f607eab5d93e");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Share Live Class Popup [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Student ID": properties.studentId,
      "Percent Class Invited": properties.percentClassInvited,
      "From Page": properties.fromPage,
      "Live Class Name": properties.liveClassName,
      "Live Class Subject": properties.liveClassSubject,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Live Class Recommendation Popup: Triggered when the user lands on the dashboard after the class has been recommended
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/P5_R3TLrNC/trigger/dwSc2a52-
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/P5_R3TLrNC}
   */
  function viewedLiveClassRecommendationPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Live Class Recommendation Popup", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "elaGrade",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "P5_R3TLrNC", "bafab1f43e1e05c3598920a2571fd633064ee73e1c8f5d390558c3bf5994b0bf", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Live Class Recommendation Popup", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("P5_R3TLrNC", "Viewed Live Class Recommendation Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Live Class Recommendation Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Live Class Recommendation Popup", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "P5_R3TLrNC", "bafab1f43e1e05c3598920a2571fd633064ee73e1c8f5d390558c3bf5994b0bf");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Live Class Recommendation Popup", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Live Class Recommendation Popup: Triggered when the user interacts on the recommendation popup
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/cgPOoWglHB/trigger/Xd-DMS86c
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/cgPOoWglHB}
   */
  function interactedLiveClassRecommendationPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Live Class Recommendation Popup", Object.keys(properties), [
        "mathGrade",
        "mode",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "elaGrade",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "cgPOoWglHB", "5df7327d2169b82628dd9c2d0af7d0afc82349374b272fd0506344e8aad896fe", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Live Class Recommendation Popup", {
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("cgPOoWglHB", "Interacted Live Class Recommendation Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Live Class Recommendation Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Live Class Recommendation Popup", {
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "cgPOoWglHB", "5df7327d2169b82628dd9c2d0af7d0afc82349374b272fd0506344e8aad896fe");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Live Class Recommendation Popup", {
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Loaded Question for Student: Going to render question
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   * @param {int} properties.questionNumber - This will capture Question Serial Number.
   * @param {string} properties.questionCode - This will capture unique question code.
   * @param {int} [properties.roundNumber] - Store round info for Mashup Quiz 
   * @param {string} properties.sessionIdentifier - Unique Splashliv class session for user
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/sV2zKaFiHX}
   */
  function loadedQuestionForStudent(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertQuestionNumber(properties.questionNumber));
      messages = messages.concat(assertQuestionCode(properties.questionCode));
      messages = messages.concat(assertOptionalRoundNumber(properties.roundNumber));
      messages = messages.concat(assertSessionIdentifier(properties.sessionIdentifier));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Loaded Question for Student", Object.keys(properties), [
        "quizCode",
        "quizMeetingSlug",
        "quizLiveClassId",
        "questionNumber",
        "questionCode",
        "roundNumber",
        "sessionIdentifier"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "sV2zKaFiHX", "19e06c2d05be37cb5493f35b446823cad1a6ddd852c16cd4d9fe8e760e1b14c6", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Loaded Question for Student", {
        "Quiz Code": properties.quizCode,
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "Question Number": properties.questionNumber,
        "Question Code": properties.questionCode,
        "Round Number": properties.roundNumber,
        "session_identifier": properties.sessionIdentifier,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("sV2zKaFiHX", "Loaded Question for Student", messages, [
        {id: "4uNrPBulmW", name: "session_identifier", value: properties.sessionIdentifier},
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "_cuCZnBI_", name: "Question Number", value: properties.questionNumber},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "bZZvnMF1m", name: "Question Code", value: properties.questionCode},
        {id: "jw_xpal_L1", name: "Round Number", value: properties.roundNumber},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Loaded Question for Student': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Loaded Question for Student", {
          "Quiz Code": properties.quizCode,
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "Question Number": properties.questionNumber,
          "Question Code": properties.questionCode,
          "Round Number": properties.roundNumber,
          "session_identifier": properties.sessionIdentifier,
          "Screen Height": sysScreenHeight,
          }, "sV2zKaFiHX", "19e06c2d05be37cb5493f35b446823cad1a6ddd852c16cd4d9fe8e760e1b14c6");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Loaded Question for Student", {
      "Quiz Code": properties.quizCode,
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "Question Number": properties.questionNumber,
      "Question Code": properties.questionCode,
      "Round Number": properties.roundNumber,
      "session_identifier": properties.sessionIdentifier,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Loaded Question for Tutor: Going to show question
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   * @param {int} properties.questionNumber - This will capture Question Serial Number.
   * @param {string} properties.questionCode - This will capture unique question code.
   * @param {int} [properties.roundNumber] - Store round info for Mashup Quiz 
   * @param {string} properties.sessionIdentifier - Unique Splashliv class session for user
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/XqHcpUcDoU}
   */
  function loadedQuestionForTutor(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertQuestionNumber(properties.questionNumber));
      messages = messages.concat(assertQuestionCode(properties.questionCode));
      messages = messages.concat(assertOptionalRoundNumber(properties.roundNumber));
      messages = messages.concat(assertSessionIdentifier(properties.sessionIdentifier));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Loaded Question for Tutor", Object.keys(properties), [
        "quizCode",
        "quizMeetingSlug",
        "quizLiveClassId",
        "questionNumber",
        "questionCode",
        "roundNumber",
        "sessionIdentifier"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "XqHcpUcDoU", "841a3d825540f428c3b841c66cdbd0103870338e7b467e48526f774684b9433d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Loaded Question for Tutor", {
        "Quiz Code": properties.quizCode,
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "Question Number": properties.questionNumber,
        "Question Code": properties.questionCode,
        "Round Number": properties.roundNumber,
        "session_identifier": properties.sessionIdentifier,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("XqHcpUcDoU", "Loaded Question for Tutor", messages, [
        {id: "4uNrPBulmW", name: "session_identifier", value: properties.sessionIdentifier},
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "_cuCZnBI_", name: "Question Number", value: properties.questionNumber},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "bZZvnMF1m", name: "Question Code", value: properties.questionCode},
        {id: "jw_xpal_L1", name: "Round Number", value: properties.roundNumber},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Loaded Question for Tutor': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Loaded Question for Tutor", {
          "Quiz Code": properties.quizCode,
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "Question Number": properties.questionNumber,
          "Question Code": properties.questionCode,
          "Round Number": properties.roundNumber,
          "session_identifier": properties.sessionIdentifier,
          "Screen Height": sysScreenHeight,
          }, "XqHcpUcDoU", "841a3d825540f428c3b841c66cdbd0103870338e7b467e48526f774684b9433d");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Loaded Question for Tutor", {
      "Quiz Code": properties.quizCode,
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "Question Number": properties.questionNumber,
      "Question Code": properties.questionCode,
      "Round Number": properties.roundNumber,
      "session_identifier": properties.sessionIdentifier,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Tutor Quiz Timer Run Out: Triggered when the tutor interacts with the quiz timer run out screen
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   * @param {int} properties.questionNumber - This will capture Question Serial Number.
   * @param {string} properties.sessionIdentifier - Unique Splashliv class session for user
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/nVCL9Xwvl}
   */
  function interactedTutorQuizTimerRunOut(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertQuestionNumber(properties.questionNumber));
      messages = messages.concat(assertSessionIdentifier(properties.sessionIdentifier));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Tutor Quiz Timer Run Out", Object.keys(properties), [
        "quizCode",
        "quizMeetingSlug",
        "quizLiveClassId",
        "questionNumber",
        "sessionIdentifier"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "nVCL9Xwvl", "fd50feee904650985687b48885eebf4a7d7c1fdc613e58c1131094274abe3f1b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Tutor Quiz Timer Run Out", {
        "Quiz Code": properties.quizCode,
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "Question Number": properties.questionNumber,
        "session_identifier": properties.sessionIdentifier,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("nVCL9Xwvl", "Interacted Tutor Quiz Timer Run Out", messages, [
        {id: "4uNrPBulmW", name: "session_identifier", value: properties.sessionIdentifier},
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "_cuCZnBI_", name: "Question Number", value: properties.questionNumber},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Tutor Quiz Timer Run Out': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Tutor Quiz Timer Run Out", {
          "Quiz Code": properties.quizCode,
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "Question Number": properties.questionNumber,
          "session_identifier": properties.sessionIdentifier,
          "Screen Height": sysScreenHeight,
          }, "nVCL9Xwvl", "fd50feee904650985687b48885eebf4a7d7c1fdc613e58c1131094274abe3f1b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Tutor Quiz Timer Run Out", {
      "Quiz Code": properties.quizCode,
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "Question Number": properties.questionNumber,
      "session_identifier": properties.sessionIdentifier,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Google Account Selection Screen [B2B]: This event will be triggered when the user views the Google account selection screen.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/zIZY4ziJaX/trigger/AZk-ZJIlK
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/zIZY4ziJaX}
   */
  function viewedGoogleAccountSelectionScreenB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Google Account Selection Screen [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "zIZY4ziJaX", "bb43a7f1a9cee1d08f7cc2aee3f32f79301e73cb3b73930fb795977d0557eae1", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Google Account Selection Screen [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("zIZY4ziJaX", "Viewed Google Account Selection Screen [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Google Account Selection Screen [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Google Account Selection Screen [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "zIZY4ziJaX", "bb43a7f1a9cee1d08f7cc2aee3f32f79301e73cb3b73930fb795977d0557eae1");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Google Account Selection Screen [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Google/Clever Class Import Screen [B2B]: This event should fire on the page load of google/clever class import screen.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ag3WEgo0bS/trigger/OP2nBPqpB
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.classType - This Property will capture the type of class - Google Classroom or Clever or Manual
   * @param {int} properties.totalClassesCount - This property should return the count of total Google Classroom/Clever classes displayed to user
   * @param {int} properties.eligibleClassesCount - This property should return the count of eligible classes that can be imported.
Reason for ineligibility - Class already imported, Fetched class has zero students
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ag3WEgo0bS}
   */
  function viewedGooglecleverClassImportScreenB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClassType(properties.classType));
      messages = messages.concat(assertTotalClassesCount(properties.totalClassesCount));
      messages = messages.concat(assertEligibleClassesCount(properties.eligibleClassesCount));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Google/Clever Class Import Screen [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "classType",
        "totalClassesCount",
        "eligibleClassesCount"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ag3WEgo0bS", "3f15e79b35f9316d071e7633f72e0e39f21dd204f943608da31de8e8f693f89a", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Google/Clever Class Import Screen [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Class Type": properties.classType,
        "Total Classes Count": properties.totalClassesCount,
        "Eligible Classes Count": properties.eligibleClassesCount,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ag3WEgo0bS", "Viewed Google/Clever Class Import Screen [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "YARhyVGOR", name: "Eligible Classes Count", value: properties.eligibleClassesCount},
        {id: "dk2bhnFne", name: "Class Type", value: properties.classType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "tmyzDsXJ-", name: "Total Classes Count", value: properties.totalClassesCount},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Google/Clever Class Import Screen [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Google/Clever Class Import Screen [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Class Type": properties.classType,
          "Total Classes Count": properties.totalClassesCount,
          "Eligible Classes Count": properties.eligibleClassesCount,
          "Screen Height": sysScreenHeight,
          }, "ag3WEgo0bS", "3f15e79b35f9316d071e7633f72e0e39f21dd204f943608da31de8e8f693f89a");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Google/Clever Class Import Screen [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Class Type": properties.classType,
      "Total Classes Count": properties.totalClassesCount,
      "Eligible Classes Count": properties.eligibleClassesCount,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Error Message Displayed [B2B]: This event will get triggered when the user sees any error on the UI This info gets captured in the logs in DB but we need to analyse it within the Mixpanel funnel also.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.valueName - This will capture the value/text of the field that is selected.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/nZzV5gn-V9}
   */
  function errorMessageDisplayedB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertValueName(properties.valueName));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Error Message Displayed [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "valueName"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "nZzV5gn-V9", "0b1ae0ee26998d87951faab6cda236de299d56564b0657b7dca254921fc43ffb", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Error Message Displayed [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Value Name": properties.valueName,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("nZzV5gn-V9", "Error Message Displayed [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "l-8JNUE0q", name: "Value Name", value: properties.valueName},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Error Message Displayed [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Error Message Displayed [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Value Name": properties.valueName,
          "Screen Height": sysScreenHeight,
          }, "nZzV5gn-V9", "0b1ae0ee26998d87951faab6cda236de299d56564b0657b7dca254921fc43ffb");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Error Message Displayed [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Value Name": properties.valueName,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Child Name Screen: User views the screen on which they enter the name of their child
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/G_jHclsDsT/trigger/I1HsbhA7M
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/G_jHclsDsT}
   */
  function viewedChildNameScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Child Name Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "G_jHclsDsT", "941e87db985de5e5f46d50bb45bafcfae424a5575f964f00be4a2d53bf093a1d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Child Name Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Mode": properties.mode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("G_jHclsDsT", "Viewed Child Name Screen", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Child Name Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Child Name Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Mode": properties.mode,
          "Screen Height": sysScreenHeight,
          }, "G_jHclsDsT", "941e87db985de5e5f46d50bb45bafcfae424a5575f964f00be4a2d53bf093a1d");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Child Name Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Mode": properties.mode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Child Name Screen: When the user starts typing the child's name or clicks on the next button
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/VWDB4sjpeL/trigger/wwdFhpRMj
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/VWDB4sjpeL}
   */
  function interactedChildNameScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Child Name Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "mode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "VWDB4sjpeL", "1fa4afde900ce93ba3f5f7362593c5c47a23312f72cf2d05eb9980635f8fa45c", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Child Name Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Mode": properties.mode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("VWDB4sjpeL", "Interacted Child Name Screen", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Child Name Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Child Name Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Mode": properties.mode,
          "Screen Height": sysScreenHeight,
          }, "VWDB4sjpeL", "1fa4afde900ce93ba3f5f7362593c5c47a23312f72cf2d05eb9980635f8fa45c");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Child Name Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Mode": properties.mode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Grade Selection Screen: User views the grade selection screen
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/-kkf9y3eAb/trigger/9GIXQQM7H
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/-kkf9y3eAb}
   */
  function viewedGradeSelectionScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Grade Selection Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "-kkf9y3eAb", "8e1268852686a5c6020ccf4b08754008d5d2c596a0b4d2521a196462bf60dd49", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Grade Selection Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Mode": properties.mode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("-kkf9y3eAb", "Viewed Grade Selection Screen", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Grade Selection Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Grade Selection Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Mode": properties.mode,
          "Screen Height": sysScreenHeight,
          }, "-kkf9y3eAb", "8e1268852686a5c6020ccf4b08754008d5d2c596a0b4d2521a196462bf60dd49");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Grade Selection Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Mode": properties.mode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Grade Selection Screen: Selected a grade on the grade selection screen. Takes the values: PreK, K, 1 etc.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/gzaaiXgN49/trigger/EV3F--Ty-
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/gzaaiXgN49}
   */
  function interactedGradeSelectionScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Grade Selection Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "mode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "gzaaiXgN49", "b261aa18ccadedc1525cd7131e7781d075a33a7b4bfb050339a53bcd8974dac1", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Grade Selection Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Mode": properties.mode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("gzaaiXgN49", "Interacted Grade Selection Screen", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Grade Selection Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Grade Selection Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Mode": properties.mode,
          "Screen Height": sysScreenHeight,
          }, "gzaaiXgN49", "b261aa18ccadedc1525cd7131e7781d075a33a7b4bfb050339a53bcd8974dac1");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Grade Selection Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Mode": properties.mode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Subject Selection Screen: User views the screen to select which subject to personalise first for the COQs
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/kgQNRDN2BS/trigger/VlPHne9rp
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/kgQNRDN2BS}
   */
  function viewedSubjectSelectionScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Subject Selection Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mode",
        "elaGrade",
        "mathGrade",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "kgQNRDN2BS", "d7370424ca414ad7b20dffcd378f18ce96dfc6ae5556cbe39cca5b6766986d9e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Subject Selection Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Mode": properties.mode,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("kgQNRDN2BS", "Viewed Subject Selection Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Subject Selection Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Subject Selection Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Mode": properties.mode,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "kgQNRDN2BS", "d7370424ca414ad7b20dffcd378f18ce96dfc6ae5556cbe39cca5b6766986d9e");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Subject Selection Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Mode": properties.mode,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Subject Selection Screen: User selects either Math or Reading
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/YY8BVQNds7/trigger/WWpgIfBy0
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/YY8BVQNds7}
   */
  function interactedSubjectSelectionScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Subject Selection Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "mode",
        "grade",
        "elaGrade",
        "mathGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "YY8BVQNds7", "645c3e738b13c9d451757085ded4e908b46ba7cf27ed41be770ab37fd92dd60e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Subject Selection Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Mode": properties.mode,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("YY8BVQNds7", "Interacted Subject Selection Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Subject Selection Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Subject Selection Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Mode": properties.mode,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Screen Height": sysScreenHeight,
          }, "YY8BVQNds7", "645c3e738b13c9d451757085ded4e908b46ba7cf27ed41be770ab37fd92dd60e");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Subject Selection Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Mode": properties.mode,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Onboarding Question Screen: User views any of the child onboarding questions
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/5E7urWumBq/trigger/tCX0bFj2G
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {int} properties.questionIndex - Index means order of the question
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {Array<string>} properties.optionsViewed - Array of all the options the user sees on the screen for a particular question
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/5E7urWumBq}
   */
  function viewedOnboardingQuestionScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertQuestionIndex(properties.questionIndex));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertOptionsViewed(properties.optionsViewed));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Onboarding Question Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "questionIndex",
        "subject",
        "optionsViewed",
        "mode",
        "elaGrade",
        "mathGrade",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "5E7urWumBq", "ce52ea628fee43e6392820e4c39a11668ade424fb29b365fc7a446510de6849e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Onboarding Question Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Question Index": properties.questionIndex,
        "Subject": properties.subject,
        "Options Viewed": properties.optionsViewed,
        "Mode": properties.mode,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("5E7urWumBq", "Viewed Onboarding Question Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "jJNP65jPw7", name: "Question Index", value: properties.questionIndex},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xHPp8yOuv", name: "Options Viewed", value: properties.optionsViewed},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Onboarding Question Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Onboarding Question Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Question Index": properties.questionIndex,
          "Subject": properties.subject,
          "Options Viewed": properties.optionsViewed,
          "Mode": properties.mode,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "5E7urWumBq", "ce52ea628fee43e6392820e4c39a11668ade424fb29b365fc7a446510de6849e");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Onboarding Question Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Question Index": properties.questionIndex,
      "Subject": properties.subject,
      "Options Viewed": properties.optionsViewed,
      "Mode": properties.mode,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Onboarding Question Screen: User selects the answers, clicks skip or back
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/KCuPnCuUW-/trigger/dcSlTKIA8
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {Array<string>} [properties.optionsSelected] - Array to save all of the options the user selects
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {int} properties.count - numbers of times user visited, interacted.
   * @param {int} properties.questionIndex - Index means order of the question
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/KCuPnCuUW-}
   */
  function interactedOnboardingQuestionScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertOptionalOptionsSelected(properties.optionsSelected));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertCount(properties.count));
      messages = messages.concat(assertQuestionIndex(properties.questionIndex));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Onboarding Question Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "optionsSelected",
        "mode",
        "grade",
        "elaGrade",
        "mathGrade",
        "count",
        "questionIndex"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "KCuPnCuUW-", "4180ba378af8c600980399ac70ba78266c7e9a1dbecf59d20bc1923bea1b090a", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Onboarding Question Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Options Selected": properties.optionsSelected,
        "Mode": properties.mode,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Count": properties.count,
        "Question Index": properties.questionIndex,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("KCuPnCuUW-", "Interacted Onboarding Question Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "FZg42lPcF", name: "Options Selected", value: properties.optionsSelected},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "jJNP65jPw7", name: "Question Index", value: properties.questionIndex},
        {id: "k_9EFdeYQ", name: "Count", value: properties.count},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Onboarding Question Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Onboarding Question Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Options Selected": properties.optionsSelected,
          "Mode": properties.mode,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Count": properties.count,
          "Question Index": properties.questionIndex,
          "Screen Height": sysScreenHeight,
          }, "KCuPnCuUW-", "4180ba378af8c600980399ac70ba78266c7e9a1dbecf59d20bc1923bea1b090a");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Onboarding Question Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Options Selected": properties.optionsSelected,
      "Mode": properties.mode,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Count": properties.count,
      "Question Index": properties.questionIndex,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Learning Plan Screen: User views the screen on which we present the learning path for that age/grade
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/noZNYXP5Gu/trigger/89hwb7Zt2
   * 2. When this screen is shown in the onboarding journey
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/noZNYXP5Gu/trigger/2mhHZqB70
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {int} properties.numberOfLearnCards - Number of topics tagged 'Learn' in the Learning Path loadthrough
   * @param {int} properties.numberOfMasterCards - Number of topics tagged 'Master' in the Learning Path loadthrough
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {bool} properties.isPersonalised - This property stores if the plan presented is personalised with COQs or not. It takes Yes / No.
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.coqBasedPersona - This property stores the user persona based on users' answers. For example, user is at counting stage, Addition Stage, Advanced Addition Stage, etc.
   * @param {string} properties.selectedTopics - This properties stores the topics selected on the page on different screens such as Learning Plan, Pre & Post Modification, etc.

   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/noZNYXP5Gu}
   */
  function viewedLearningPlanScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertNumberOfLearnCards(properties.numberOfLearnCards));
      messages = messages.concat(assertNumberOfMasterCards(properties.numberOfMasterCards));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertIsPersonalised(properties.isPersonalised));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertCoqBasedPersona(properties.coqBasedPersona));
      messages = messages.concat(assertSelectedTopics(properties.selectedTopics));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Learning Plan Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "numberOfLearnCards",
        "numberOfMasterCards",
        "mode",
        "grade",
        "elaGrade",
        "mathGrade",
        "isPersonalised",
        "subject",
        "coqBasedPersona",
        "selectedTopics"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "noZNYXP5Gu", "0bab3aa6c94e92e64f7c3d0268af561533b94607e33fb1a21ed68f4b1e4381c8", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Learning Plan Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Number of 'Learn' Cards": properties.numberOfLearnCards,
        "Number of 'Master' Cards": properties.numberOfMasterCards,
        "Mode": properties.mode,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Is Personalised": properties.isPersonalised,
        "Subject": properties.subject,
        "Coq Based Persona": properties.coqBasedPersona,
        "Selected Topics": properties.selectedTopics,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("noZNYXP5Gu", "Viewed Learning Plan Screen", messages, [
        {id: "0zw-Zh02K", name: "Selected Topics", value: properties.selectedTopics},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "8n1iVKkl7", name: "Is Personalised", value: properties.isPersonalised},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "Bb6PCfOO6", name: "Coq Based Persona", value: properties.coqBasedPersona},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "_rbYN5Au4", name: "Number of 'Learn' Cards", value: properties.numberOfLearnCards},
        {id: "fwzqzcIZ4", name: "Number of 'Master' Cards", value: properties.numberOfMasterCards},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Learning Plan Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Learning Plan Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Number of 'Learn' Cards": properties.numberOfLearnCards,
          "Number of 'Master' Cards": properties.numberOfMasterCards,
          "Mode": properties.mode,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Is Personalised": properties.isPersonalised,
          "Subject": properties.subject,
          "Coq Based Persona": properties.coqBasedPersona,
          "Selected Topics": properties.selectedTopics,
          "Screen Height": sysScreenHeight,
          }, "noZNYXP5Gu", "0bab3aa6c94e92e64f7c3d0268af561533b94607e33fb1a21ed68f4b1e4381c8");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Learning Plan Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Number of 'Learn' Cards": properties.numberOfLearnCards,
      "Number of 'Master' Cards": properties.numberOfMasterCards,
      "Mode": properties.mode,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Is Personalised": properties.isPersonalised,
      "Subject": properties.subject,
      "Coq Based Persona": properties.coqBasedPersona,
      "Selected Topics": properties.selectedTopics,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Learning Plan Screen: Clicks on either Continue or Personalise Math/Reading
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/TO5nxyihsL/trigger/ac1XRjxiZ
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {bool} properties.isPersonalised - This property stores if the plan presented is personalised with COQs or not. It takes Yes / No.
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.coqBasedPersona - This property stores the user persona based on users' answers. For example, user is at counting stage, Addition Stage, Advanced Addition Stage, etc.
   * @param {string} properties.selectedTopics - This properties stores the topics selected on the page on different screens such as Learning Plan, Pre & Post Modification, etc.

   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/TO5nxyihsL}
   */
  function interactedLearningPlanScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertIsPersonalised(properties.isPersonalised));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertCoqBasedPersona(properties.coqBasedPersona));
      messages = messages.concat(assertSelectedTopics(properties.selectedTopics));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Learning Plan Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "mode",
        "grade",
        "elaGrade",
        "mathGrade",
        "isPersonalised",
        "subject",
        "coqBasedPersona",
        "selectedTopics"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "TO5nxyihsL", "e4bfaac86e346ba021e0952e18639dcf9946860730f883e69292a7bc0adbe20a", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Learning Plan Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Mode": properties.mode,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Is Personalised": properties.isPersonalised,
        "Subject": properties.subject,
        "Coq Based Persona": properties.coqBasedPersona,
        "Selected Topics": properties.selectedTopics,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("TO5nxyihsL", "Interacted Learning Plan Screen", messages, [
        {id: "0zw-Zh02K", name: "Selected Topics", value: properties.selectedTopics},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "8n1iVKkl7", name: "Is Personalised", value: properties.isPersonalised},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "Bb6PCfOO6", name: "Coq Based Persona", value: properties.coqBasedPersona},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Learning Plan Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Learning Plan Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Mode": properties.mode,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Is Personalised": properties.isPersonalised,
          "Subject": properties.subject,
          "Coq Based Persona": properties.coqBasedPersona,
          "Selected Topics": properties.selectedTopics,
          "Screen Height": sysScreenHeight,
          }, "TO5nxyihsL", "e4bfaac86e346ba021e0952e18639dcf9946860730f883e69292a7bc0adbe20a");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Learning Plan Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Mode": properties.mode,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Is Personalised": properties.isPersonalised,
      "Subject": properties.subject,
      "Coq Based Persona": properties.coqBasedPersona,
      "Selected Topics": properties.selectedTopics,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Weekly Goal Screen: User views the screen to set their child's weekly learning goal
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/hQcogALMS0/trigger/N8raUKsol
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/hQcogALMS0}
   */
  function viewedWeeklyGoalScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Weekly Goal Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "from",
        "mode",
        "elaGrade",
        "mathGrade",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "hQcogALMS0", "bfd5e040ffbfaa7020de5f81bc4cbf53726922c6a31680205a750d61ce2914ea", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Weekly Goal Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From": properties.from,
        "Mode": properties.mode,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("hQcogALMS0", "Viewed Weekly Goal Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Weekly Goal Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Weekly Goal Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From": properties.from,
          "Mode": properties.mode,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "hQcogALMS0", "bfd5e040ffbfaa7020de5f81bc4cbf53726922c6a31680205a750d61ce2914ea");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Weekly Goal Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From": properties.from,
      "Mode": properties.mode,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Weekly Goal Screen: User sets the day, time goals, and the reminder, or clicks on back or skip
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/6qSXwIG7YX/trigger/1upI3gWe4
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {Array<string>} [properties.daysGoal] - Days of the week on which the user wants to practice
   * @param {string} [properties.timeGoal] - Per week practice time set by the user
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {int} [properties.dailyPracticeTime] - This stores current daily play time in mins. This will store 10, 20, 30, etc.
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/6qSXwIG7YX}
   */
  function interactedWeeklyGoalScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertOptionalDaysGoal(properties.daysGoal));
      messages = messages.concat(assertOptionalTimeGoal(properties.timeGoal));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertOptionalDailyPracticeTime(properties.dailyPracticeTime));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Weekly Goal Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "daysGoal",
        "timeGoal",
        "from",
        "dailyPracticeTime",
        "mode",
        "grade",
        "elaGrade",
        "mathGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "6qSXwIG7YX", "1301d447a0e578d621398b681ce798fd33232a43253b3638673b2e418514c931", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Weekly Goal Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Days Goal": properties.daysGoal,
        "Time Goal": properties.timeGoal,
        "From": properties.from,
        "Daily Practice Time": properties.dailyPracticeTime,
        "Mode": properties.mode,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("6qSXwIG7YX", "Interacted Weekly Goal Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "nAyyn2Mnw", name: "Days Goal", value: properties.daysGoal},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "sGjYFiQA4", name: "Daily Practice Time", value: properties.dailyPracticeTime},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ypVRFOT1Z", name: "Time Goal", value: properties.timeGoal},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Weekly Goal Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Weekly Goal Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Days Goal": properties.daysGoal,
          "Time Goal": properties.timeGoal,
          "From": properties.from,
          "Daily Practice Time": properties.dailyPracticeTime,
          "Mode": properties.mode,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Screen Height": sysScreenHeight,
          }, "6qSXwIG7YX", "1301d447a0e578d621398b681ce798fd33232a43253b3638673b2e418514c931");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Weekly Goal Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Days Goal": properties.daysGoal,
      "Time Goal": properties.timeGoal,
      "From": properties.from,
      "Daily Practice Time": properties.dailyPracticeTime,
      "Mode": properties.mode,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Library Loadthrough: Users views the loadthrough which describes what their child will learn (list of subject + topics)
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/MvjcgqfHUM/trigger/GdHqdWwr5
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/MvjcgqfHUM}
   */
  function viewedLibraryLoadthrough(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Library Loadthrough", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mode",
        "elaGrade",
        "mathGrade",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "MvjcgqfHUM", "e2d3bb8be301699c1cd7f84848ec0c145ffe5445f71a7ae6607e8f20b8f11c37", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Library Loadthrough", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Mode": properties.mode,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("MvjcgqfHUM", "Viewed Library Loadthrough", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Library Loadthrough': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Library Loadthrough", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Mode": properties.mode,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "MvjcgqfHUM", "e2d3bb8be301699c1cd7f84848ec0c145ffe5445f71a7ae6607e8f20b8f11c37");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Library Loadthrough", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Mode": properties.mode,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Exciting Resources Loadthrough: User views the extra resources loadthrough
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/IMbern_Xyo/trigger/IF6_xw8as
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/IMbern_Xyo}
   */
  function viewedExcitingResourcesLoadthrough(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Exciting Resources Loadthrough", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mode",
        "grade",
        "elaGrade",
        "mathGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "IMbern_Xyo", "f21f6be0b5b85cdc1dd677b7e7285c9ba67195f258b2ead4c4cca9bbe15a655b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Exciting Resources Loadthrough", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Mode": properties.mode,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("IMbern_Xyo", "Viewed Exciting Resources Loadthrough", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Exciting Resources Loadthrough': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Exciting Resources Loadthrough", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Mode": properties.mode,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Screen Height": sysScreenHeight,
          }, "IMbern_Xyo", "f21f6be0b5b85cdc1dd677b7e7285c9ba67195f258b2ead4c4cca9bbe15a655b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Exciting Resources Loadthrough", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Mode": properties.mode,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Local Notification Prompt: User views the local prompt for allowing/denying notifications
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/d5biYuwsXI}
   */
  function viewedLocalNotificationPrompt(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Local Notification Prompt", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mode",
        "grade",
        "elaGrade",
        "mathGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "d5biYuwsXI", "5541a6c4d396896f6379f2d44ccb9eb32e024327ebe66cee5c7aebecf513fca4", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Local Notification Prompt", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Mode": properties.mode,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("d5biYuwsXI", "Viewed Local Notification Prompt", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Local Notification Prompt': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Local Notification Prompt", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Mode": properties.mode,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Screen Height": sysScreenHeight,
          }, "d5biYuwsXI", "5541a6c4d396896f6379f2d44ccb9eb32e024327ebe66cee5c7aebecf513fca4");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Local Notification Prompt", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Mode": properties.mode,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Local Notification Prompt: User clicks on yes or no on the local prompt for allowing/denying notifications
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/1-R4ITnjG}
   */
  function interactedLocalNotificationPrompt(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Local Notification Prompt", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mode",
        "grade",
        "elaGrade",
        "mathGrade",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "1-R4ITnjG", "cf7fe1decc7b5267a3498c435206a593aa2a9ad8f6eb84a86c8e9754166cd195", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Local Notification Prompt", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Mode": properties.mode,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("1-R4ITnjG", "Interacted Local Notification Prompt", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Local Notification Prompt': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Local Notification Prompt", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Mode": properties.mode,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "1-R4ITnjG", "cf7fe1decc7b5267a3498c435206a593aa2a9ad8f6eb84a86c8e9754166cd195");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Local Notification Prompt", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Mode": properties.mode,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted My to-Do Popup [B2B]: This event will be fired when the user clicks anywhere within the My to-do popup.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/-ASZ8RBaEO/trigger/1sN06x-wS
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/-ASZ8RBaEO}
   */
  function interactedMyToDoPopupB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted My to-Do Popup [B2B]", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "clickedOn",
        "grade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "-ASZ8RBaEO", "9c0806bb14eac317cc4caa61ef7d0aa17b794d379f17ea26e318dfa4e036ec9f", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted My to-Do Popup [B2B]", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Clicked On": properties.clickedOn,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("-ASZ8RBaEO", "Interacted My to-Do Popup [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted My to-Do Popup [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted My to-Do Popup [B2B]", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Clicked On": properties.clickedOn,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "-ASZ8RBaEO", "9c0806bb14eac317cc4caa61ef7d0aa17b794d379f17ea26e318dfa4e036ec9f");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted My to-Do Popup [B2B]", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Clicked On": properties.clickedOn,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Pending Activity Popup [B2B]: This event will be triggered when the user views the 'Pending Activity Popup'
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/y4wRFq9AfT/trigger/T1N5OMN8l
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/y4wRFq9AfT}
   */
  function viewedPendingActivityPopupB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Pending Activity Popup [B2B]", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "from",
        "grade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "y4wRFq9AfT", "a4083b2c619d02d330eaa5804e91a6d86baf341aa07ce65e0d7724ac5752bd93", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Pending Activity Popup [B2B]", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "From": properties.from,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("y4wRFq9AfT", "Viewed Pending Activity Popup [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Pending Activity Popup [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Pending Activity Popup [B2B]", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "From": properties.from,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "y4wRFq9AfT", "a4083b2c619d02d330eaa5804e91a6d86baf341aa07ce65e0d7724ac5752bd93");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Pending Activity Popup [B2B]", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "From": properties.from,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Student Level Bar Dropdown [B2B]: This event will be fired when the user views the student level bar dropdown.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/TUXCetk7Iw/trigger/7cKkIca7E
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/TUXCetk7Iw}
   */
  function viewedStudentLevelBarDropdownB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Student Level Bar Dropdown [B2B]", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "grade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "TUXCetk7Iw", "8f4294ed60b0c38f4eb874aa97588caf31ff5322fc7a7114c4411081df737b9f", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Student Level Bar Dropdown [B2B]", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("TUXCetk7Iw", "Viewed Student Level Bar Dropdown [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Student Level Bar Dropdown [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Student Level Bar Dropdown [B2B]", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "TUXCetk7Iw", "8f4294ed60b0c38f4eb874aa97588caf31ff5322fc7a7114c4411081df737b9f");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Student Level Bar Dropdown [B2B]", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Student Level Bar Dropdown [B2B]: This event will be fired when the user clicks on any item within the student level bar dropdown.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/jAGprzgpST/trigger/ZDXBATw1T
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/jAGprzgpST}
   */
  function interactedStudentLevelBarDropdownB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Student Level Bar Dropdown [B2B]", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "clickedOn",
        "grade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "jAGprzgpST", "68eacd816e21e89486490bccb911035dd58308766a7c7daf48f3958d6f414074", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Student Level Bar Dropdown [B2B]", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Clicked On": properties.clickedOn,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("jAGprzgpST", "Interacted Student Level Bar Dropdown [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Student Level Bar Dropdown [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Student Level Bar Dropdown [B2B]", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Clicked On": properties.clickedOn,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "jAGprzgpST", "68eacd816e21e89486490bccb911035dd58308766a7c7daf48f3958d6f414074");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Student Level Bar Dropdown [B2B]", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Clicked On": properties.clickedOn,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed MP Game Expired Popup [B2B]: This event will be fired when the game to which user is invited is expired.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/pChvfFKWLo/trigger/irHpzO0NR
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.gameName - Name of the Game being tapped (Optional)
   * @param {string} properties.gameMode - The mode of the game player is playing
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/pChvfFKWLo}
   */
  function viewedMpGameExpiredPopupB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGameName(properties.gameName));
      messages = messages.concat(assertGameMode(properties.gameMode));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed MP Game Expired Popup [B2B]", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "gameName",
        "gameMode",
        "fromPage",
        "grade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "pChvfFKWLo", "fccdd5372beb61c5f51a78f7294228dec2b8929cde3df1db090960a70578991c", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed MP Game Expired Popup [B2B]", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Game Name": properties.gameName,
        "Game Mode": properties.gameMode,
        "From Page": properties.fromPage,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("pChvfFKWLo", "Viewed MP Game Expired Popup [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "SCiKCU5kRo", name: "Game Mode", value: properties.gameMode},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed MP Game Expired Popup [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed MP Game Expired Popup [B2B]", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Game Name": properties.gameName,
          "Game Mode": properties.gameMode,
          "From Page": properties.fromPage,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "pChvfFKWLo", "fccdd5372beb61c5f51a78f7294228dec2b8929cde3df1db090960a70578991c");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed MP Game Expired Popup [B2B]", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Game Name": properties.gameName,
      "Game Mode": properties.gameMode,
      "From Page": properties.fromPage,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Classroom PTL Link Started: This event will be fired when the PTL linking of parent and teacher will start from the backend.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/wfkBJjad3N}
   */
  function classroomPtlLinkStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Classroom PTL Link Started", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "grade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "wfkBJjad3N", "996d4231dc58944c40a443cd13be25ad92f1118e6f54c51dd968c9d493b1651c", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Classroom PTL Link Started", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("wfkBJjad3N", "Classroom PTL Link Started", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Classroom PTL Link Started': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Classroom PTL Link Started", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "wfkBJjad3N", "996d4231dc58944c40a443cd13be25ad92f1118e6f54c51dd968c9d493b1651c");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Classroom PTL Link Started", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Classroom PTL Link Ended: This event will be fired when the PTL linking from backend ends (successful and unsuccessful).
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.status - To determine if the process failed or succeeded
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ihT9bkPDpk}
   */
  function classroomPtlLinkEnded(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertStatus(properties.status));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Classroom PTL Link Ended", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "status",
        "grade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ihT9bkPDpk", "57d4f044ee08541b62561a01d0b63a6a2bf02d885b9112c672ff7c5a07353712", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Classroom PTL Link Ended", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Status": properties.status,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ihT9bkPDpk", "Classroom PTL Link Ended", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "9_Al8_kuam", name: "Status", value: properties.status},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Classroom PTL Link Ended': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Classroom PTL Link Ended", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Status": properties.status,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "ihT9bkPDpk", "57d4f044ee08541b62561a01d0b63a6a2bf02d885b9112c672ff7c5a07353712");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Classroom PTL Link Ended", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Status": properties.status,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Lesson Plans Listing Page [B2B]: This event will be fired when the user lands on the lesson plan listing page.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/3borsUujFR/trigger/tT0blN2lr
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * @param {string} properties.lessonPlanSubject - This will capture the subject of the lesson plan listing/landing page. (Values: Math or English)
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/3borsUujFR}
   */
  function viewedLessonPlansListingPageB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertLessonPlanSubject(properties.lessonPlanSubject));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Lesson Plans Listing Page [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "fromPage",
        "lessonPlanSubject"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "3borsUujFR", "a11979420077e27a83d54fa224f11a8db22e80004a82172f7f90a37294a473ff", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Lesson Plans Listing Page [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From Page": properties.fromPage,
        "Lesson Plan Subject": properties.lessonPlanSubject,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("3borsUujFR", "Viewed Lesson Plans Listing Page [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "n3rBqFq3X", name: "Lesson Plan Subject", value: properties.lessonPlanSubject},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Lesson Plans Listing Page [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Lesson Plans Listing Page [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From Page": properties.fromPage,
          "Lesson Plan Subject": properties.lessonPlanSubject,
          "Screen Height": sysScreenHeight,
          }, "3borsUujFR", "a11979420077e27a83d54fa224f11a8db22e80004a82172f7f90a37294a473ff");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Lesson Plans Listing Page [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From Page": properties.fromPage,
      "Lesson Plan Subject": properties.lessonPlanSubject,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Lesson Plans Listing Page [B2B]: This event will be triggered when the user interacts with the lesson plan.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/yWSSyMcVl8/trigger/A3no25JQK
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.lessonPlanSubject - This will capture the subject of the lesson plan listing/landing page. (Values: Math or English)
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/yWSSyMcVl8}
   */
  function interactedLessonPlansListingPageB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertLessonPlanSubject(properties.lessonPlanSubject));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Lesson Plans Listing Page [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "lessonPlanSubject"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "yWSSyMcVl8", "1172d8e0a9abdb12442e9fa52bc4c60672d094c30c7922455b478a4bea128f0b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Lesson Plans Listing Page [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Lesson Plan Subject": properties.lessonPlanSubject,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("yWSSyMcVl8", "Interacted Lesson Plans Listing Page [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "n3rBqFq3X", name: "Lesson Plan Subject", value: properties.lessonPlanSubject},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Lesson Plans Listing Page [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Lesson Plans Listing Page [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Lesson Plan Subject": properties.lessonPlanSubject,
          "Screen Height": sysScreenHeight,
          }, "yWSSyMcVl8", "1172d8e0a9abdb12442e9fa52bc4c60672d094c30c7922455b478a4bea128f0b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Lesson Plans Listing Page [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Lesson Plan Subject": properties.lessonPlanSubject,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Lesson Plan Detail Page [B2B]: This event will be fired when the user lands on the detail page of any lesson plan.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/SRhLsQ1If_/trigger/T0uEzuIac
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.lessonPlanName - This will capture the name of the lesson plan.
   * @param {string} properties.lessonPlanSubject - This will capture the subject of the lesson plan listing/landing page. (Values: Math or English)
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/SRhLsQ1If_}
   */
  function viewedLessonPlanDetailPageB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertLessonPlanName(properties.lessonPlanName));
      messages = messages.concat(assertLessonPlanSubject(properties.lessonPlanSubject));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Lesson Plan Detail Page [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "lessonPlanName",
        "lessonPlanSubject"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "SRhLsQ1If_", "127d4dae66eac464613816dbd041bd396dc77bf23357834d5f12ba8f862ec62b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Lesson Plan Detail Page [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Lesson Plan Name": properties.lessonPlanName,
        "Lesson Plan Subject": properties.lessonPlanSubject,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("SRhLsQ1If_", "Viewed Lesson Plan Detail Page [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "aESgK6MlY", name: "Lesson Plan Name", value: properties.lessonPlanName},
        {id: "n3rBqFq3X", name: "Lesson Plan Subject", value: properties.lessonPlanSubject},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Lesson Plan Detail Page [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Lesson Plan Detail Page [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Lesson Plan Name": properties.lessonPlanName,
          "Lesson Plan Subject": properties.lessonPlanSubject,
          "Screen Height": sysScreenHeight,
          }, "SRhLsQ1If_", "127d4dae66eac464613816dbd041bd396dc77bf23357834d5f12ba8f862ec62b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Lesson Plan Detail Page [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Lesson Plan Name": properties.lessonPlanName,
      "Lesson Plan Subject": properties.lessonPlanSubject,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Lesson Plan Detail Page [B2B]: This event will be fired when the user interacts with the detail page of any lesson plan.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/B7zeQzKVLr/trigger/58YsIiaX-
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.lessonPlanSubject - This will capture the subject of the lesson plan listing/landing page. (Values: Math or English)
   * @param {string} properties.lessonPlanName - This will capture the name of the lesson plan.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/B7zeQzKVLr}
   */
  function interactedLessonPlanDetailPageB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertLessonPlanSubject(properties.lessonPlanSubject));
      messages = messages.concat(assertLessonPlanName(properties.lessonPlanName));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Lesson Plan Detail Page [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "lessonPlanSubject",
        "lessonPlanName"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "B7zeQzKVLr", "814e846fcaff4ddc321d3ce97076fcff9f174be8833a69eabbb6127fc16c6ce5", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Lesson Plan Detail Page [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Lesson Plan Subject": properties.lessonPlanSubject,
        "Lesson Plan Name": properties.lessonPlanName,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("B7zeQzKVLr", "Interacted Lesson Plan Detail Page [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "aESgK6MlY", name: "Lesson Plan Name", value: properties.lessonPlanName},
        {id: "n3rBqFq3X", name: "Lesson Plan Subject", value: properties.lessonPlanSubject},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Lesson Plan Detail Page [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Lesson Plan Detail Page [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Lesson Plan Subject": properties.lessonPlanSubject,
          "Lesson Plan Name": properties.lessonPlanName,
          "Screen Height": sysScreenHeight,
          }, "B7zeQzKVLr", "814e846fcaff4ddc321d3ce97076fcff9f174be8833a69eabbb6127fc16c6ce5");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Lesson Plan Detail Page [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Lesson Plan Subject": properties.lessonPlanSubject,
      "Lesson Plan Name": properties.lessonPlanName,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Student Round Intro Screen: Triggered when a student sees the round intro screen
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/wJHwzzofC3/trigger/cN1ZA63hD
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   * @param {int} properties.roundNumber - Store round info for Mashup Quiz 
   * @param {string} properties.sessionIdentifier - Unique Splashliv class session for user
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/wJHwzzofC3}
   */
  function viewedStudentRoundIntroScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertRoundNumber(properties.roundNumber));
      messages = messages.concat(assertSessionIdentifier(properties.sessionIdentifier));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Student Round Intro Screen", Object.keys(properties), [
        "quizCode",
        "quizMeetingSlug",
        "quizLiveClassId",
        "roundNumber",
        "sessionIdentifier"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "wJHwzzofC3", "3af52edc52c195e355a04d7e921fb3e9d60c7565368a1eaaa186a181c59b6674", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Student Round Intro Screen", {
        "Quiz Code": properties.quizCode,
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "Round Number": properties.roundNumber,
        "session_identifier": properties.sessionIdentifier,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("wJHwzzofC3", "Viewed Student Round Intro Screen", messages, [
        {id: "4uNrPBulmW", name: "session_identifier", value: properties.sessionIdentifier},
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "jw_xpal_L1", name: "Round Number", value: properties.roundNumber},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Student Round Intro Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Student Round Intro Screen", {
          "Quiz Code": properties.quizCode,
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "Round Number": properties.roundNumber,
          "session_identifier": properties.sessionIdentifier,
          "Screen Height": sysScreenHeight,
          }, "wJHwzzofC3", "3af52edc52c195e355a04d7e921fb3e9d60c7565368a1eaaa186a181c59b6674");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Student Round Intro Screen", {
      "Quiz Code": properties.quizCode,
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "Round Number": properties.roundNumber,
      "session_identifier": properties.sessionIdentifier,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Tutor Round Intro Screen: Triggered when a tutor sees the round intro screen
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/fdJS9nElG/trigger/mLvihS00l
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {int} properties.roundNumber - Store round info for Mashup Quiz 
   * @param {string} properties.sessionIdentifier - Unique Splashliv class session for user
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/fdJS9nElG}
   */
  function viewedTutorRoundIntroScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertRoundNumber(properties.roundNumber));
      messages = messages.concat(assertSessionIdentifier(properties.sessionIdentifier));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Tutor Round Intro Screen", Object.keys(properties), [
        "quizMeetingSlug",
        "quizLiveClassId",
        "quizCode",
        "roundNumber",
        "sessionIdentifier"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "fdJS9nElG", "5a3d27574bb3cea3dd8f5ff487585b204f4c2c13c4e0f1d64e28236c54c9154e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Tutor Round Intro Screen", {
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "Quiz Code": properties.quizCode,
        "Round Number": properties.roundNumber,
        "session_identifier": properties.sessionIdentifier,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("fdJS9nElG", "Viewed Tutor Round Intro Screen", messages, [
        {id: "4uNrPBulmW", name: "session_identifier", value: properties.sessionIdentifier},
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "jw_xpal_L1", name: "Round Number", value: properties.roundNumber},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Tutor Round Intro Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Tutor Round Intro Screen", {
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "Quiz Code": properties.quizCode,
          "Round Number": properties.roundNumber,
          "session_identifier": properties.sessionIdentifier,
          "Screen Height": sysScreenHeight,
          }, "fdJS9nElG", "5a3d27574bb3cea3dd8f5ff487585b204f4c2c13c4e0f1d64e28236c54c9154e");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Tutor Round Intro Screen", {
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "Quiz Code": properties.quizCode,
      "Round Number": properties.roundNumber,
      "session_identifier": properties.sessionIdentifier,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Tutor Round Intro Screen: Triggered when a tutor interacts on the round intro screen. Interactions possible are clicks on the Start Round button and the sound button
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/pfXUq_Iwq/trigger/HdSuxuoNWY
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {int} properties.roundNumber - Store round info for Mashup Quiz 
   * @param {string} properties.sessionIdentifier - Unique Splashliv class session for user
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/pfXUq_Iwq}
   */
  function interactedTutorRoundIntroScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertRoundNumber(properties.roundNumber));
      messages = messages.concat(assertSessionIdentifier(properties.sessionIdentifier));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Tutor Round Intro Screen", Object.keys(properties), [
        "quizCode",
        "quizMeetingSlug",
        "quizLiveClassId",
        "clickedOn",
        "roundNumber",
        "sessionIdentifier"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "pfXUq_Iwq", "a734559c29b17c87c240209fdd7118968501aca2bdef594e036306f66dff2364", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Tutor Round Intro Screen", {
        "Quiz Code": properties.quizCode,
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "Clicked On": properties.clickedOn,
        "Round Number": properties.roundNumber,
        "session_identifier": properties.sessionIdentifier,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("pfXUq_Iwq", "Interacted Tutor Round Intro Screen", messages, [
        {id: "4uNrPBulmW", name: "session_identifier", value: properties.sessionIdentifier},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "jw_xpal_L1", name: "Round Number", value: properties.roundNumber},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Tutor Round Intro Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Tutor Round Intro Screen", {
          "Quiz Code": properties.quizCode,
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "Clicked On": properties.clickedOn,
          "Round Number": properties.roundNumber,
          "session_identifier": properties.sessionIdentifier,
          "Screen Height": sysScreenHeight,
          }, "pfXUq_Iwq", "a734559c29b17c87c240209fdd7118968501aca2bdef594e036306f66dff2364");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Tutor Round Intro Screen", {
      "Quiz Code": properties.quizCode,
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "Clicked On": properties.clickedOn,
      "Round Number": properties.roundNumber,
      "session_identifier": properties.sessionIdentifier,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Badges Animation in Neo Quiz: Triggered when a student receives a badge and views the animation for it
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/vfqFAi0Fca/trigger/FsmyDbYlP
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   * @param {string} properties.sessionIdentifier - Unique Splashliv class session for user
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/vfqFAi0Fca}
   */
  function viewedBadgesAnimationInNeoQuiz(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertSessionIdentifier(properties.sessionIdentifier));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Badges Animation in Neo Quiz", Object.keys(properties), [
        "quizCode",
        "quizMeetingSlug",
        "quizLiveClassId",
        "sessionIdentifier"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "vfqFAi0Fca", "76b82070a49abcdc0f4edc9b16738693450acbc9b02fae5fdbd640d51f2290d8", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Badges Animation in Neo Quiz", {
        "Quiz Code": properties.quizCode,
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "session_identifier": properties.sessionIdentifier,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("vfqFAi0Fca", "Viewed Badges Animation in Neo Quiz", messages, [
        {id: "4uNrPBulmW", name: "session_identifier", value: properties.sessionIdentifier},
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Badges Animation in Neo Quiz': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Badges Animation in Neo Quiz", {
          "Quiz Code": properties.quizCode,
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "session_identifier": properties.sessionIdentifier,
          "Screen Height": sysScreenHeight,
          }, "vfqFAi0Fca", "76b82070a49abcdc0f4edc9b16738693450acbc9b02fae5fdbd640d51f2290d8");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Badges Animation in Neo Quiz", {
      "Quiz Code": properties.quizCode,
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "session_identifier": properties.sessionIdentifier,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Student Round Ended Screen: Triggered when student sees round specific leaderboard
   * 
   * When to trigger this event:
   * 1. Triggered When a round completed
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/BY4mBr8nrd/trigger/tern2Ysrj
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   * @param {int} properties.roundNumber - Store round info for Mashup Quiz 
   * @param {string} properties.sessionIdentifier - Unique Splashliv class session for user
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/BY4mBr8nrd}
   */
  function viewedStudentRoundEndedScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertRoundNumber(properties.roundNumber));
      messages = messages.concat(assertSessionIdentifier(properties.sessionIdentifier));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Student Round Ended Screen", Object.keys(properties), [
        "quizCode",
        "quizMeetingSlug",
        "quizLiveClassId",
        "roundNumber",
        "sessionIdentifier"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "BY4mBr8nrd", "942eee1a9e05f073e338ec96ce3d4416321bf4c1a544a2bce016240731bb5a77", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Student Round Ended Screen", {
        "Quiz Code": properties.quizCode,
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "Round Number": properties.roundNumber,
        "session_identifier": properties.sessionIdentifier,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("BY4mBr8nrd", "Viewed Student Round Ended Screen", messages, [
        {id: "4uNrPBulmW", name: "session_identifier", value: properties.sessionIdentifier},
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "jw_xpal_L1", name: "Round Number", value: properties.roundNumber},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Student Round Ended Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Student Round Ended Screen", {
          "Quiz Code": properties.quizCode,
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "Round Number": properties.roundNumber,
          "session_identifier": properties.sessionIdentifier,
          "Screen Height": sysScreenHeight,
          }, "BY4mBr8nrd", "942eee1a9e05f073e338ec96ce3d4416321bf4c1a544a2bce016240731bb5a77");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Student Round Ended Screen", {
      "Quiz Code": properties.quizCode,
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "Round Number": properties.roundNumber,
      "session_identifier": properties.sessionIdentifier,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Tutor Round Ended Screen: Triggered when tutor sees specific round leaderboard
   * 
   * When to trigger this event:
   * 1. Triggered when round completed
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/sa3WTgOLF/trigger/is9QytZ4-
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   * @param {int} properties.roundNumber - Store round info for Mashup Quiz 
   * @param {string} properties.sessionIdentifier - Unique Splashliv class session for user
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/sa3WTgOLF}
   */
  function viewedTutorRoundEndedScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertRoundNumber(properties.roundNumber));
      messages = messages.concat(assertSessionIdentifier(properties.sessionIdentifier));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Tutor Round Ended Screen", Object.keys(properties), [
        "quizCode",
        "quizMeetingSlug",
        "quizLiveClassId",
        "roundNumber",
        "sessionIdentifier"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "sa3WTgOLF", "9b3a02e1e5beb81f5070ca729e059ea5294d830dac2e3d0473bd16512a69b5f6", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Tutor Round Ended Screen", {
        "Quiz Code": properties.quizCode,
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "Round Number": properties.roundNumber,
        "session_identifier": properties.sessionIdentifier,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("sa3WTgOLF", "Viewed Tutor Round Ended Screen", messages, [
        {id: "4uNrPBulmW", name: "session_identifier", value: properties.sessionIdentifier},
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "jw_xpal_L1", name: "Round Number", value: properties.roundNumber},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Tutor Round Ended Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Tutor Round Ended Screen", {
          "Quiz Code": properties.quizCode,
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "Round Number": properties.roundNumber,
          "session_identifier": properties.sessionIdentifier,
          "Screen Height": sysScreenHeight,
          }, "sa3WTgOLF", "9b3a02e1e5beb81f5070ca729e059ea5294d830dac2e3d0473bd16512a69b5f6");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Tutor Round Ended Screen", {
      "Quiz Code": properties.quizCode,
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "Round Number": properties.roundNumber,
      "session_identifier": properties.sessionIdentifier,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Tutor Round Ended Screen: Triggered when a tutor interacts on round specific leaderboard screen. Interactions possible are clicks on the Review Questions button and the Next Round or Final Leaderboard.
   * 
   * When to trigger this event:
   * 1. Triggered when Review Question or Go To Round CTA clicked
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/5O4NMJwuc/trigger/dgxpO9ulc
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   * @param {int} properties.roundNumber - Store round info for Mashup Quiz 
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.sessionIdentifier - Unique Splashliv class session for user
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/5O4NMJwuc}
   */
  function interactedTutorRoundEndedScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertRoundNumber(properties.roundNumber));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertSessionIdentifier(properties.sessionIdentifier));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Tutor Round Ended Screen", Object.keys(properties), [
        "quizCode",
        "quizMeetingSlug",
        "quizLiveClassId",
        "roundNumber",
        "clickedOn",
        "sessionIdentifier"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "5O4NMJwuc", "f1cc22dddad0e26b64b9781003964ff81e5ce02f5db45629bafdbd85049842c8", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Tutor Round Ended Screen", {
        "Quiz Code": properties.quizCode,
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "Round Number": properties.roundNumber,
        "Clicked On": properties.clickedOn,
        "session_identifier": properties.sessionIdentifier,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("5O4NMJwuc", "Interacted Tutor Round Ended Screen", messages, [
        {id: "4uNrPBulmW", name: "session_identifier", value: properties.sessionIdentifier},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "jw_xpal_L1", name: "Round Number", value: properties.roundNumber},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Tutor Round Ended Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Tutor Round Ended Screen", {
          "Quiz Code": properties.quizCode,
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "Round Number": properties.roundNumber,
          "Clicked On": properties.clickedOn,
          "session_identifier": properties.sessionIdentifier,
          "Screen Height": sysScreenHeight,
          }, "5O4NMJwuc", "f1cc22dddad0e26b64b9781003964ff81e5ce02f5db45629bafdbd85049842c8");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Tutor Round Ended Screen", {
      "Quiz Code": properties.quizCode,
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "Round Number": properties.roundNumber,
      "Clicked On": properties.clickedOn,
      "session_identifier": properties.sessionIdentifier,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Disenrolled Class [B2B]: This event gets fired when the user disenrolls their class from Springboard.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/w1xbDmDVzm/trigger/FnhEH8dmR
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.teacherName - This captures the name of the teacher on Splashlearn
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/w1xbDmDVzm}
   */
  function disenrolledClassB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertTeacherName(properties.teacherName));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Disenrolled Class [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "teacherName"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "w1xbDmDVzm", "d185a98cac857862c04d0e6cab1ce987cc47abfd66488d58729dd720b5830514", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Disenrolled Class [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Teacher Name": properties.teacherName,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("w1xbDmDVzm", "Disenrolled Class [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "d4VuJfq-Y", name: "Teacher Name", value: properties.teacherName},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Disenrolled Class [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Disenrolled Class [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Teacher Name": properties.teacherName,
          "Screen Height": sysScreenHeight,
          }, "w1xbDmDVzm", "d185a98cac857862c04d0e6cab1ce987cc47abfd66488d58729dd720b5830514");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Disenrolled Class [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Teacher Name": properties.teacherName,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Auto-Enrolled for SpringBoard [B2B]: This event gets fired when the user logs in during the enrolment phase and gets auto-enrolled for Springboard.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.teacherName - This captures the name of the teacher on Splashlearn
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/hYj9PzZlLI}
   */
  function autoEnrolledForSpringboardB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertTeacherName(properties.teacherName));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Auto-Enrolled for SpringBoard [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "teacherName"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "hYj9PzZlLI", "98bcca19af5008c89cdc4f118f54bdc0bd5b6c280f913b6e777c68f335673a4d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Auto-Enrolled for SpringBoard [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Teacher Name": properties.teacherName,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("hYj9PzZlLI", "Auto-Enrolled for SpringBoard [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "d4VuJfq-Y", name: "Teacher Name", value: properties.teacherName},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Auto-Enrolled for SpringBoard [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Auto-Enrolled for SpringBoard [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Teacher Name": properties.teacherName,
          "Screen Height": sysScreenHeight,
          }, "hYj9PzZlLI", "98bcca19af5008c89cdc4f118f54bdc0bd5b6c280f913b6e777c68f335673a4d");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Auto-Enrolled for SpringBoard [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Teacher Name": properties.teacherName,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Enrolled Class [B2B]: This event gets fired when the user manually enrols the class after disenrolling the class from settings page.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/FJvLyr1meL/trigger/mfLVpTrMs
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.teacherName - This captures the name of the teacher on Splashlearn
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/FJvLyr1meL}
   */
  function enrolledClassB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertTeacherName(properties.teacherName));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Enrolled Class [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "teacherName"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "FJvLyr1meL", "1a5261b1df36d35e9624582808b93fe21394063d1c258bbafa623942a66904c3", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Enrolled Class [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Teacher Name": properties.teacherName,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("FJvLyr1meL", "Enrolled Class [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "d4VuJfq-Y", name: "Teacher Name", value: properties.teacherName},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Enrolled Class [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Enrolled Class [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Teacher Name": properties.teacherName,
          "Screen Height": sysScreenHeight,
          }, "FJvLyr1meL", "1a5261b1df36d35e9624582808b93fe21394063d1c258bbafa623942a66904c3");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Enrolled Class [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Teacher Name": properties.teacherName,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Springboard Tab [B2B]: This event will be fired when the user clicks anywhere within the Springboard tab.
We need to capture the clicks on -
1. Class settings
2. Send parent emails
3. Download printouts
4. Official contest rules
5. Go to dashboard
6. Facebook icon
7. Twitter icon
8. Instagram icon
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Ewq8z07r7N/trigger/y7c_q8JN7
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Ewq8z07r7N}
   */
  function interactedSpringboardTabB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Springboard Tab [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Ewq8z07r7N", "c1cab1b0ede49a679696a24e935ca1be4adfafe56d6adbd1dfdeee5533627ab8", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Springboard Tab [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Ewq8z07r7N", "Interacted Springboard Tab [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Springboard Tab [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Springboard Tab [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "Ewq8z07r7N", "c1cab1b0ede49a679696a24e935ca1be4adfafe56d6adbd1dfdeee5533627ab8");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Springboard Tab [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Download Letter [B2B]: This event will be fired when the user clicks on the Download CTA after the PDF for download letter opens up.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/jnYk2pvWir/trigger/bKCDhU5xJ
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/jnYk2pvWir}
   */
  function interactedDownloadLetterB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Download Letter [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "jnYk2pvWir", "0149e943a061d242e474e80486a1370f1b4e995710a78f6116af5574468dffb8", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Download Letter [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("jnYk2pvWir", "Interacted Download Letter [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Download Letter [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Download Letter [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "jnYk2pvWir", "0149e943a061d242e474e80486a1370f1b4e995710a78f6116af5574468dffb8");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Download Letter [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Share Assignment Popup [B2B]: This event will be fired when the user clicks on 'Share' option from dropdown on assignments page and the popup to share assignment opens up.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/aoWAaA98IV/trigger/jpgjq-t1a
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {string} properties.pageName - Includes the name of the page (Eg: Playzone game listing page, ). This is not the URL but a easily understandable definition of what page is the user at.
   * @param {string} [properties.playableCode] - Pass the 'Playable Code' of the Playable being started/clicked
   * @param {string} [properties.playableName] - Name of playable selected
   * @param {Array<string>} [properties.recommendedRailName] - This is the name of the rail viewed by the user. 
Recommended rail property comes with rail name and rail rank, pipe separated - with the introduction of this property, we intend to separate rail name to calculate CTR on Mixpanel.
   * @param {Array<int>} [properties.recommendedTileRank] - This property will store the position of the tile on which user has clciked. Earlier this was sent as column position

   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/aoWAaA98IV}
   */
  function viewedShareAssignmentPopupB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertPageName(properties.pageName));
      messages = messages.concat(assertOptionalPlayableCode(properties.playableCode));
      messages = messages.concat(assertOptionalPlayableName(properties.playableName));
      messages = messages.concat(assertOptionalRecommendedRailName(properties.recommendedRailName));
      messages = messages.concat(assertOptionalRecommendedTileRank(properties.recommendedTileRank));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Share Assignment Popup [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "from",
        "pageName",
        "playableCode",
        "playableName",
        "recommendedRailName",
        "recommendedTileRank"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "aoWAaA98IV", "d35a570957eff71815047cee99f22b6e09ca56565bf976fc1c9fc89fcbeacf7e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Share Assignment Popup [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From": properties.from,
        "Page Name": properties.pageName,
        "Playable Code": properties.playableCode,
        "Playable Name": properties.playableName,
        "Recommended Rail Name": properties.recommendedRailName,
        "Recommended Tile Rank": properties.recommendedTileRank,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("aoWAaA98IV", "Viewed Share Assignment Popup [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "6lrsWYY5Y", name: "Recommended Rail Name", value: properties.recommendedRailName},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "FLDtSJNKL", name: "Recommended Tile Rank", value: properties.recommendedTileRank},
        {id: "MJKSzmqfHu", name: "Page Name", value: properties.pageName},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "QjCwFasvW0", name: "Playable Code", value: properties.playableCode},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "c2W4X05Jy", name: "Playable Name", value: properties.playableName},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Share Assignment Popup [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Share Assignment Popup [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From": properties.from,
          "Page Name": properties.pageName,
          "Playable Code": properties.playableCode,
          "Playable Name": properties.playableName,
          "Recommended Rail Name": properties.recommendedRailName,
          "Recommended Tile Rank": properties.recommendedTileRank,
          "Screen Height": sysScreenHeight,
          }, "aoWAaA98IV", "d35a570957eff71815047cee99f22b6e09ca56565bf976fc1c9fc89fcbeacf7e");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Share Assignment Popup [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From": properties.from,
      "Page Name": properties.pageName,
      "Playable Code": properties.playableCode,
      "Playable Name": properties.playableName,
      "Recommended Rail Name": properties.recommendedRailName,
      "Recommended Tile Rank": properties.recommendedTileRank,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Share Assignment Popup [B2B]: This event will be fired when the user clicks on Download icon/Copy icon and cross from Share assignment popup from the assignment page.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/-3TN7f7yiO/trigger/g2Gs3iza9
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} [properties.playableCode] - Pass the 'Playable Code' of the Playable being started/clicked
   * @param {string} [properties.playableName] - Name of playable selected
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/-3TN7f7yiO}
   */
  function interactedShareAssignmentPopupB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertOptionalPlayableCode(properties.playableCode));
      messages = messages.concat(assertOptionalPlayableName(properties.playableName));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Share Assignment Popup [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "playableCode",
        "playableName"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "-3TN7f7yiO", "0398fc6cceb7d1b6e1118fac00a0fd2b5c88e948f479a4f73987e5dac68401ae", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Share Assignment Popup [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Playable Code": properties.playableCode,
        "Playable Name": properties.playableName,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("-3TN7f7yiO", "Interacted Share Assignment Popup [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "QjCwFasvW0", name: "Playable Code", value: properties.playableCode},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "c2W4X05Jy", name: "Playable Name", value: properties.playableName},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Share Assignment Popup [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Share Assignment Popup [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Playable Code": properties.playableCode,
          "Playable Name": properties.playableName,
          "Screen Height": sysScreenHeight,
          }, "-3TN7f7yiO", "0398fc6cceb7d1b6e1118fac00a0fd2b5c88e948f479a4f73987e5dac68401ae");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Share Assignment Popup [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Playable Code": properties.playableCode,
      "Playable Name": properties.playableName,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Skill Selection Screen [B2B]: This event will be fired when the user views the skill selection screen after selecting a topic.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/RT4VogO32p/trigger/UdIvG1uEb
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/RT4VogO32p}
   */
  function viewedSkillSelectionScreenB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Skill Selection Screen [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "RT4VogO32p", "d0a52d4a7b9bc0940f6876ae5784002540d875e71626888369071064ea59c469", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Skill Selection Screen [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("RT4VogO32p", "Viewed Skill Selection Screen [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Skill Selection Screen [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Skill Selection Screen [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "RT4VogO32p", "d0a52d4a7b9bc0940f6876ae5784002540d875e71626888369071064ea59c469");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Skill Selection Screen [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Skill Selection Screen [B2B]: This event will be fired when the user views the skill selection screen after selecting a topic.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/b1L1J24jkV/trigger/LUQhycUbS
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/b1L1J24jkV}
   */
  function interactedSkillSelectionScreenB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Skill Selection Screen [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "b1L1J24jkV", "4948ac0550cf59eaaba3cf21cbb04609c4173a8f82891ff64af3af6fd765a8e9", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Skill Selection Screen [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("b1L1J24jkV", "Interacted Skill Selection Screen [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Skill Selection Screen [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Skill Selection Screen [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "b1L1J24jkV", "4948ac0550cf59eaaba3cf21cbb04609c4173a8f82891ff64af3af6fd765a8e9");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Skill Selection Screen [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Skill Preview Screen [B2B]: This gets fired when the user clicks on 'Preview' CTA from the skill selection popup. 
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/O6Xxs7xhj/trigger/NSFTi8GTL
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/O6Xxs7xhj}
   */
  function viewedSkillPreviewScreenB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Skill Preview Screen [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "O6Xxs7xhj", "2c1f2fbbb37adcccb556d17f810bd57dd327e1a792773e1d6cfe9c775611e2d0", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Skill Preview Screen [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("O6Xxs7xhj", "Viewed Skill Preview Screen [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Skill Preview Screen [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Skill Preview Screen [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "O6Xxs7xhj", "2c1f2fbbb37adcccb556d17f810bd57dd327e1a792773e1d6cfe9c775611e2d0");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Skill Preview Screen [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Skill Preview Screen [B2B]: This gets fired when the user interacts with the 'Preview' popup that opened from the skill selection popup. 
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Yx1-UMXHwl/trigger/SJ5AeP8JL
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Yx1-UMXHwl}
   */
  function interactedSkillPreviewScreenB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Skill Preview Screen [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Yx1-UMXHwl", "20f2865bde2437839a227047676edd3780a57dea937cefe165e872e47e1b2946", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Skill Preview Screen [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Yx1-UMXHwl", "Interacted Skill Preview Screen [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Skill Preview Screen [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Skill Preview Screen [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "Yx1-UMXHwl", "20f2865bde2437839a227047676edd3780a57dea937cefe165e872e47e1b2946");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Skill Preview Screen [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Student Selection Screen for Skills [B2B]: This event gets fired when the user views the student selection screen after selecting the relevant skills.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/sW-iQOx2EV/trigger/tEKWF23Uu
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * @param {string} properties.contentType - Type of content viz. Game/Learning Path/Activities/Worksheets
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/sW-iQOx2EV}
   */
  function viewedStudentSelectionScreenForSkillsB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertContentType(properties.contentType));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Student Selection Screen for Skills [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "fromPage",
        "contentType"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "sW-iQOx2EV", "e78f6863d08ca9db64d38f13de42b9caa7f6a4e25bb4190c534130e688801eac", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Student Selection Screen for Skills [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From Page": properties.fromPage,
        "Content Type": properties.contentType,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("sW-iQOx2EV", "Viewed Student Selection Screen for Skills [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "Nfs9QLl8W7", name: "Content Type", value: properties.contentType},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Student Selection Screen for Skills [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Student Selection Screen for Skills [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From Page": properties.fromPage,
          "Content Type": properties.contentType,
          "Screen Height": sysScreenHeight,
          }, "sW-iQOx2EV", "e78f6863d08ca9db64d38f13de42b9caa7f6a4e25bb4190c534130e688801eac");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Student Selection Screen for Skills [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From Page": properties.fromPage,
      "Content Type": properties.contentType,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Student Selection Screen for Skills [B2B]: This event gets fired when the user interacts with the student selection screen after selecting the relevant skills.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/TZtKarvg1Q/trigger/5j8NnuWKg
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * @param {string} properties.contentType - Type of content viz. Game/Learning Path/Activities/Worksheets
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/TZtKarvg1Q}
   */
  function interactedStudentSelectionScreenForSkillsB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertContentType(properties.contentType));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Student Selection Screen for Skills [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "fromPage",
        "contentType"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "TZtKarvg1Q", "9188295cc210a977e85ac0dc31cd3f0517836dfdd28b33d334f0ea6482395638", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Student Selection Screen for Skills [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "From Page": properties.fromPage,
        "Content Type": properties.contentType,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("TZtKarvg1Q", "Interacted Student Selection Screen for Skills [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "Nfs9QLl8W7", name: "Content Type", value: properties.contentType},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Student Selection Screen for Skills [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Student Selection Screen for Skills [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "From Page": properties.fromPage,
          "Content Type": properties.contentType,
          "Screen Height": sysScreenHeight,
          }, "TZtKarvg1Q", "9188295cc210a977e85ac0dc31cd3f0517836dfdd28b33d334f0ea6482395638");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Student Selection Screen for Skills [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "From Page": properties.fromPage,
      "Content Type": properties.contentType,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Final Pitstop Shown: This event is associated to the final pitstop where state machine switches to the celebratory animations.
   * 
   * When to trigger this event:
   * 1. When Splashee pitstop animation is over and state machine changes to the final state machine showing chest at the centre, coin spillage, mystery card coming out of the chest.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/9UbDR5_Cpo/trigger/wzLbg7zHW
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/9UbDR5_Cpo}
   */
  function finalPitstopShown(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Final Pitstop Shown", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mode",
        "elaGrade",
        "mathGrade",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "9UbDR5_Cpo", "d40684627fae79d70e9023697c484a7eb06bb4a0a67a641aa0edb61e034f3f71", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Final Pitstop Shown", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Mode": properties.mode,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("9UbDR5_Cpo", "Final Pitstop Shown", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Final Pitstop Shown': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Final Pitstop Shown", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Mode": properties.mode,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "9UbDR5_Cpo", "d40684627fae79d70e9023697c484a7eb06bb4a0a67a641aa0edb61e034f3f71");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Final Pitstop Shown", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Mode": properties.mode,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Mystery Cards Screen: This event is associated to the final mystery cards screen where we show two cards over blue screen.
   * 
   * When to trigger this event:
   * 1. When this screen loads
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/GBk2pFX9F/trigger/xh5EjuFDA
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/GBk2pFX9F}
   */
  function viewedMysteryCardsScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Mystery Cards Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mode",
        "elaGrade",
        "mathGrade",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "GBk2pFX9F", "9e579888a467e9a1b2ff84781dcef87f94ae7ee1eafd96b373b52aa7c0614be7", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Mystery Cards Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Mode": properties.mode,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("GBk2pFX9F", "Viewed Mystery Cards Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Mystery Cards Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Mystery Cards Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Mode": properties.mode,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "GBk2pFX9F", "9e579888a467e9a1b2ff84781dcef87f94ae7ee1eafd96b373b52aa7c0614be7");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Mystery Cards Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Mode": properties.mode,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Pitstop: This event is associated to the interactions on the mystery cards screen and interacts with any pitstop screen
   * 
   * When to trigger this event:
   * 1. When user clicks on the card to unwrap or play
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/W5KpND5hgl/trigger/uCf_LFNqK
   * 2. When user interacts with the pitstop
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/W5KpND5hgl/trigger/cKtaOMksKxXDI2uJHck9d
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {string} properties.gameCode - Game code of the playable selected, for example: Math learning games have multiple variations, all those variations will have one game code
   * @param {Array<string>} properties.recommendedRailName - This is the name of the rail viewed by the user. 
Recommended rail property comes with rail name and rail rank, pipe separated - with the introduction of this property, we intend to separate rail name to calculate CTR on Mixpanel.
   * @param {string} properties.pitstopType - This will store if the pitstop is just stars, stars + level up, stars + level up + tier up
   * @param {string} properties.pendingMemory - This property stores the memory remaining at the current page. It will be used to debug the tech issues.

   * @param {Array<string>} [properties.recommendedTileName] - This property will store the code of the tile user has interacted with - CG code for curriculum rails and game code for non curr. rails

   * @param {Array<int>} properties.recommendedTileRank - This property will store the position of the tile on which user has clciked. Earlier this was sent as column position

   * @param {string} properties.contentType - Type of content viz. Game/Learning Path/Activities/Worksheets
   * @param {string} properties.contentGroup - Code of content group user clicked/tapped on
   * @param {string} properties.playableClickId - This property will hold a unique string for the playable events.
   * @param {string} properties.playableCode - Pass the 'Playable Code' of the Playable being started/clicked
   * @param {string} properties.tid - It's a unique id associated to every new animation getting triggered.
   * @param {string} properties.stateMachineCode - Every state machine has its own code, so whenever state machine switches we will be able to debug any issue that may arise
   * @param {Array<string>} properties.recommendedCategory - This property will be used to store what recommendations were shown to the user in the all tabs.
We'll be saving them in this format:
<Category Name>
where possible values are:
Category name =  MyToDo, Math_LP, ELA_LP, Math Facts, Books, Spelling, Reading Comprehension, Playzone, Activities, Learning Games
   * @param {Array<string>} properties.recommendedRail - This property will be used to store which rails were shown to the user in the HOME tab.

Where possible values are:
Rail Name = Curriculum, Game Zone, Math, Language, Logic & Thinking, Art & Creativity, General Knowledge, Motor Skills, Live Classes, Fluency, Multiplayer
This comes with Rank also with | separation
   * @param {string} properties.tabCode - Specifies the tab which has been opened in the event 'Viewed Tiled Dashboard' and Other events too
   * @param {Array<int>} properties.recommendedRailRank - Recommended Rail Rank will carry the rank of the rail in integer format viewed by the user. 
   * @param {int} properties.tabStrClickedCount - Streak count of Playable Clicked from a Specific Tab in a day
   * @param {int} properties.tabStrStartedCount - Streak count of Playable Started from a Specific Tab in a day
   * @param {int} properties.railStrClickedCount - Streak count of Playable Clicked from a Specific Rail in a day
   * @param {int} properties.railStrStartedCount - Streak count of Playable Started from a Specific Rail in a day
   * @param {int} properties.tileStrClickedCount - Streak count of Playable Clicked from a Specific Tile in a day
   * @param {int} properties.tileStrStartedCount - Streak count of Playable Started from a Specific Tile in a day
   * @param {int} properties.tabStrCompletedCount - Streak count of Playable Completed from a Specific Tab in a day
   * @param {int} properties.railStrCompletedCount - Streak count of Playable Completed from a Specific Rail in a day
   * @param {int} properties.tileStrCompletedCount - Streak count of Playable Completed from a Specific Tile in a day
   * @param {int} properties.overallClickedCount - Streak count of Playable Clicked in a day from anywhere
   * @param {int} properties.overallStartedCount - Streak count of Playable Started in a day from anywhere
   * @param {int} properties.overallCompletedCount - Streak count of Playable Completed in a day from anywhere
   * @param {string} properties.tileCode - Code of the Tile: Debugging purpose by tech team
   * @param {string} properties.railCode - Code of the Rail: Debugging purpose
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/W5KpND5hgl}
   */
  function interactedPitstop(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertGameCode(properties.gameCode));
      messages = messages.concat(assertRecommendedRailName(properties.recommendedRailName));
      messages = messages.concat(assertPitstopType(properties.pitstopType));
      messages = messages.concat(assertPendingMemory(properties.pendingMemory));
      messages = messages.concat(assertOptionalRecommendedTileName(properties.recommendedTileName));
      messages = messages.concat(assertRecommendedTileRank(properties.recommendedTileRank));
      messages = messages.concat(assertContentType(properties.contentType));
      messages = messages.concat(assertContentGroup(properties.contentGroup));
      messages = messages.concat(assertPlayableClickId(properties.playableClickId));
      messages = messages.concat(assertPlayableCode(properties.playableCode));
      messages = messages.concat(assertTid(properties.tid));
      messages = messages.concat(assertStateMachineCode(properties.stateMachineCode));
      messages = messages.concat(assertRecommendedCategory(properties.recommendedCategory));
      messages = messages.concat(assertRecommendedRail(properties.recommendedRail));
      messages = messages.concat(assertTabCode(properties.tabCode));
      messages = messages.concat(assertRecommendedRailRank(properties.recommendedRailRank));
      messages = messages.concat(assertTabStrClickedCount(properties.tabStrClickedCount));
      messages = messages.concat(assertTabStrStartedCount(properties.tabStrStartedCount));
      messages = messages.concat(assertRailStrClickedCount(properties.railStrClickedCount));
      messages = messages.concat(assertRailStrStartedCount(properties.railStrStartedCount));
      messages = messages.concat(assertTileStrClickedCount(properties.tileStrClickedCount));
      messages = messages.concat(assertTileStrStartedCount(properties.tileStrStartedCount));
      messages = messages.concat(assertTabStrCompletedCount(properties.tabStrCompletedCount));
      messages = messages.concat(assertRailStrCompletedCount(properties.railStrCompletedCount));
      messages = messages.concat(assertTileStrCompletedCount(properties.tileStrCompletedCount));
      messages = messages.concat(assertOverallClickedCount(properties.overallClickedCount));
      messages = messages.concat(assertOverallStartedCount(properties.overallStartedCount));
      messages = messages.concat(assertOverallCompletedCount(properties.overallCompletedCount));
      messages = messages.concat(assertTileCode(properties.tileCode));
      messages = messages.concat(assertRailCode(properties.railCode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Pitstop", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "mode",
        "grade",
        "elaGrade",
        "mathGrade",
        "from",
        "gameCode",
        "recommendedRailName",
        "pitstopType",
        "pendingMemory",
        "recommendedTileName",
        "recommendedTileRank",
        "contentType",
        "contentGroup",
        "playableClickId",
        "playableCode",
        "tid",
        "stateMachineCode",
        "recommendedCategory",
        "recommendedRail",
        "tabCode",
        "recommendedRailRank",
        "tabStrClickedCount",
        "tabStrStartedCount",
        "railStrClickedCount",
        "railStrStartedCount",
        "tileStrClickedCount",
        "tileStrStartedCount",
        "tabStrCompletedCount",
        "railStrCompletedCount",
        "tileStrCompletedCount",
        "overallClickedCount",
        "overallStartedCount",
        "overallCompletedCount",
        "tileCode",
        "railCode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "W5KpND5hgl", "2f185e8b3e007426932a20a47a66f10cab2464c84dd8487c2af8616e7765eea0", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Pitstop", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Mode": properties.mode,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "From": properties.from,
        "Game Code": properties.gameCode,
        "Recommended Rail Name": properties.recommendedRailName,
        "Pitstop Type": properties.pitstopType,
        "Pending Memory": properties.pendingMemory,
        "Recommended Tile Name": properties.recommendedTileName,
        "Recommended Tile Rank": properties.recommendedTileRank,
        "Content Type": properties.contentType,
        "Content Group": properties.contentGroup,
        "Playable Click Id": properties.playableClickId,
        "Playable Code": properties.playableCode,
        "Tid": properties.tid,
        "State Machine Code": properties.stateMachineCode,
        "Recommended Category": properties.recommendedCategory,
        "Recommended Rail": properties.recommendedRail,
        "Tab Code": properties.tabCode,
        "Recommended Rail Rank": properties.recommendedRailRank,
        "Tab Str Clicked Count": properties.tabStrClickedCount,
        "Tab Str Started Count": properties.tabStrStartedCount,
        "Rail Str Clicked Count": properties.railStrClickedCount,
        "Rail Str Started Count": properties.railStrStartedCount,
        "Tile Str Clicked Count": properties.tileStrClickedCount,
        "Tile Str Started Count": properties.tileStrStartedCount,
        "Tab Str Completed Count": properties.tabStrCompletedCount,
        "Rail Str Completed Count": properties.railStrCompletedCount,
        "Tile Str Completed Count": properties.tileStrCompletedCount,
        "Overall Clicked Count": properties.overallClickedCount,
        "Overall Started Count": properties.overallStartedCount,
        "Overall Completed Count": properties.overallCompletedCount,
        "Tile Code": properties.tileCode,
        "Rail Code": properties.railCode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("W5KpND5hgl", "Interacted Pitstop", messages, [
        {id: "2oZQdvXRu", name: "Game Code", value: properties.gameCode},
        {id: "33JWk0cGdkpH6MbvcXKfL", name: "Tile Str Clicked Count", value: properties.tileStrClickedCount},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "6lrsWYY5Y", name: "Recommended Rail Name", value: properties.recommendedRailName},
        {id: "72Hz7CelRpVYf1warHrRP", name: "Tile Str Started Count", value: properties.tileStrStartedCount},
        {id: "7PQh3G9ITCcMDMNeMTM8q", name: "Tab Str Clicked Count", value: properties.tabStrClickedCount},
        {id: "8Vq9HABFDQ", name: "Pitstop Type", value: properties.pitstopType},
        {id: "AFC3Xnyx0vxpH2PWZIjdO", name: "Rail Str Completed Count", value: properties.railStrCompletedCount},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "C_BFBZn2V", name: "Pending Memory", value: properties.pendingMemory},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "FLDtSJNKL", name: "Recommended Tile Rank", value: properties.recommendedTileRank},
        {id: "GAdbKqJ5y9HJPos5lx5qt", name: "Tab Str Completed Count", value: properties.tabStrCompletedCount},
        {id: "GJYEymipLkc1xy54AyhV8", name: "Tile Code", value: properties.tileCode},
        {id: "HFnzATNuS7GI6VZs6tZ15", name: "Tab Str Started Count", value: properties.tabStrStartedCount},
        {id: "HJUIBmGrsUmqa_TYCtwQ0", name: "Overall Started Count", value: properties.overallStartedCount},
        {id: "Nfs9QLl8W7", name: "Content Type", value: properties.contentType},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "OHBx0fnhzlxvHhw0e87pM", name: "Overall Completed Count", value: properties.overallCompletedCount},
        {id: "Otu1r2JQW", name: "Content Group", value: properties.contentGroup},
        {id: "QDMKmRkRjbW4pFvqlGOM6", name: "Rail Code", value: properties.railCode},
        {id: "QQeu-Td4-0", name: "Playable Click Id", value: properties.playableClickId},
        {id: "QjCwFasvW0", name: "Playable Code", value: properties.playableCode},
        {id: "SYGmTqa9e", name: "Tid", value: properties.tid},
        {id: "T9gjnp76o", name: "State Machine Code", value: properties.stateMachineCode},
        {id: "TYbmk5DQn", name: "Recommended Tile Name", value: properties.recommendedTileName},
        {id: "VdJhEU0H6s", name: "Recommended Category", value: properties.recommendedCategory},
        {id: "X4kgAx81N5AHgcI6NaNiS", name: "Overall Clicked Count", value: properties.overallClickedCount},
        {id: "_QL92wEdpoa8wH50vOPYt", name: "Tile Str Completed Count", value: properties.tileStrCompletedCount},
        {id: "drNgwJn5Xg", name: "Recommended Rail", value: properties.recommendedRail},
        {id: "hKAJ3izCFVFH-D4_886C8", name: "Rail Str Clicked Count", value: properties.railStrClickedCount},
        {id: "l9PbANZBu", name: "Tab Code", value: properties.tabCode},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "sRPi7ITwtlHeD7HQEGzmG", name: "Rail Str Started Count", value: properties.railStrStartedCount},
        {id: "uyLgqxbg7", name: "Recommended Rail Rank", value: properties.recommendedRailRank},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Pitstop': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Pitstop", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Mode": properties.mode,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "From": properties.from,
          "Game Code": properties.gameCode,
          "Recommended Rail Name": properties.recommendedRailName,
          "Pitstop Type": properties.pitstopType,
          "Pending Memory": properties.pendingMemory,
          "Recommended Tile Name": properties.recommendedTileName,
          "Recommended Tile Rank": properties.recommendedTileRank,
          "Content Type": properties.contentType,
          "Content Group": properties.contentGroup,
          "Playable Click Id": properties.playableClickId,
          "Playable Code": properties.playableCode,
          "Tid": properties.tid,
          "State Machine Code": properties.stateMachineCode,
          "Recommended Category": properties.recommendedCategory,
          "Recommended Rail": properties.recommendedRail,
          "Tab Code": properties.tabCode,
          "Recommended Rail Rank": properties.recommendedRailRank,
          "Tab Str Clicked Count": properties.tabStrClickedCount,
          "Tab Str Started Count": properties.tabStrStartedCount,
          "Rail Str Clicked Count": properties.railStrClickedCount,
          "Rail Str Started Count": properties.railStrStartedCount,
          "Tile Str Clicked Count": properties.tileStrClickedCount,
          "Tile Str Started Count": properties.tileStrStartedCount,
          "Tab Str Completed Count": properties.tabStrCompletedCount,
          "Rail Str Completed Count": properties.railStrCompletedCount,
          "Tile Str Completed Count": properties.tileStrCompletedCount,
          "Overall Clicked Count": properties.overallClickedCount,
          "Overall Started Count": properties.overallStartedCount,
          "Overall Completed Count": properties.overallCompletedCount,
          "Tile Code": properties.tileCode,
          "Rail Code": properties.railCode,
          "Screen Height": sysScreenHeight,
          }, "W5KpND5hgl", "2f185e8b3e007426932a20a47a66f10cab2464c84dd8487c2af8616e7765eea0");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Pitstop", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Mode": properties.mode,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "From": properties.from,
      "Game Code": properties.gameCode,
      "Recommended Rail Name": properties.recommendedRailName,
      "Pitstop Type": properties.pitstopType,
      "Pending Memory": properties.pendingMemory,
      "Recommended Tile Name": properties.recommendedTileName,
      "Recommended Tile Rank": properties.recommendedTileRank,
      "Content Type": properties.contentType,
      "Content Group": properties.contentGroup,
      "Playable Click Id": properties.playableClickId,
      "Playable Code": properties.playableCode,
      "Tid": properties.tid,
      "State Machine Code": properties.stateMachineCode,
      "Recommended Category": properties.recommendedCategory,
      "Recommended Rail": properties.recommendedRail,
      "Tab Code": properties.tabCode,
      "Recommended Rail Rank": properties.recommendedRailRank,
      "Tab Str Clicked Count": properties.tabStrClickedCount,
      "Tab Str Started Count": properties.tabStrStartedCount,
      "Rail Str Clicked Count": properties.railStrClickedCount,
      "Rail Str Started Count": properties.railStrStartedCount,
      "Tile Str Clicked Count": properties.tileStrClickedCount,
      "Tile Str Started Count": properties.tileStrStartedCount,
      "Tab Str Completed Count": properties.tabStrCompletedCount,
      "Rail Str Completed Count": properties.railStrCompletedCount,
      "Tile Str Completed Count": properties.tileStrCompletedCount,
      "Overall Clicked Count": properties.overallClickedCount,
      "Overall Started Count": properties.overallStartedCount,
      "Overall Completed Count": properties.overallCompletedCount,
      "Tile Code": properties.tileCode,
      "Rail Code": properties.railCode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Started Sound: This event is triggered when sound starts playing for the chest open state machine
   * 
   * When to trigger this event:
   * 1. This event is triggered when sound starts playing for the chest open state machine
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/8o4D1lKHR/trigger/UINocPzzP
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/8o4D1lKHR}
   */
  function startedSound(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Started Sound", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "elaGrade",
        "mathGrade",
        "grade",
        "mode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "8o4D1lKHR", "0f5852575c84065f2011174c6755100257e544bcd48e107f8b1710dd38c5d3b8", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Started Sound", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Grade": properties.grade,
        "Mode": properties.mode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("8o4D1lKHR", "Started Sound", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Started Sound': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Started Sound", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Grade": properties.grade,
          "Mode": properties.mode,
          "Screen Height": sysScreenHeight,
          }, "8o4D1lKHR", "0f5852575c84065f2011174c6755100257e544bcd48e107f8b1710dd38c5d3b8");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Started Sound", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Grade": properties.grade,
      "Mode": properties.mode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Learning Plan Screen 1: This event is attached with the learning plan presented to the users where we show all the goals with / without progress bar, level of the child and time to compelete.

   * 
   * When to trigger this event:
   * 1. When user sees the first subject's learning plan screen.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/OZebDpgZFk/trigger/ZaUNVrXJU
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {bool} properties.isPersonalised - This property stores if the plan presented is personalised with COQs or not. It takes Yes / No.
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/OZebDpgZFk}
   */
  function viewedLearningPlanScreen1(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertIsPersonalised(properties.isPersonalised));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Learning Plan Screen 1", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "subject",
        "isPersonalised",
        "mode",
        "grade",
        "elaGrade",
        "mathGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "OZebDpgZFk", "4e14949ab4cc77b0f2c30a7cf7c6976fb0c6fea866cbdf6644bcb4f1a66e312f", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Learning Plan Screen 1", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Subject": properties.subject,
        "Is Personalised": properties.isPersonalised,
        "Mode": properties.mode,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("OZebDpgZFk", "Viewed Learning Plan Screen 1", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "8n1iVKkl7", name: "Is Personalised", value: properties.isPersonalised},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Learning Plan Screen 1': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Learning Plan Screen 1", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Subject": properties.subject,
          "Is Personalised": properties.isPersonalised,
          "Mode": properties.mode,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Screen Height": sysScreenHeight,
          }, "OZebDpgZFk", "4e14949ab4cc77b0f2c30a7cf7c6976fb0c6fea866cbdf6644bcb4f1a66e312f");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Learning Plan Screen 1", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Subject": properties.subject,
      "Is Personalised": properties.isPersonalised,
      "Mode": properties.mode,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Learning Plan Screen 1: This event is associated with the interactions on the learning plan screen for the first subject
   * 
   * When to trigger this event:
   * 1. Click on Skip, Personalise English Next, Back, Personalise Math (in case Is Personalised No)
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/gj6I4oXkhg/trigger/IbRbkuEp6
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {bool} properties.isPersonalised - This property stores if the plan presented is personalised with COQs or not. It takes Yes / No.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/gj6I4oXkhg}
   */
  function interactedLearningPlanScreen1(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertIsPersonalised(properties.isPersonalised));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Learning Plan Screen 1", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "subject",
        "isPersonalised",
        "clickedOn",
        "mode",
        "grade",
        "elaGrade",
        "mathGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "gj6I4oXkhg", "9a6c0801744775022495e36f289bab36cd966ede962d6cfe7db0e303689828b3", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Learning Plan Screen 1", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Subject": properties.subject,
        "Is Personalised": properties.isPersonalised,
        "Clicked On": properties.clickedOn,
        "Mode": properties.mode,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("gj6I4oXkhg", "Interacted Learning Plan Screen 1", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "8n1iVKkl7", name: "Is Personalised", value: properties.isPersonalised},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Learning Plan Screen 1': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Learning Plan Screen 1", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Subject": properties.subject,
          "Is Personalised": properties.isPersonalised,
          "Clicked On": properties.clickedOn,
          "Mode": properties.mode,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Screen Height": sysScreenHeight,
          }, "gj6I4oXkhg", "9a6c0801744775022495e36f289bab36cd966ede962d6cfe7db0e303689828b3");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Learning Plan Screen 1", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Subject": properties.subject,
      "Is Personalised": properties.isPersonalised,
      "Clicked On": properties.clickedOn,
      "Mode": properties.mode,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Learning Plan Screen 2: Similar to Viewed Learning Plan Screen 1, it is associated to the learning plan screen shown for the second subject.
   * 
   * When to trigger this event:
   * 1. It is triggered when user sees this screen (second subject's learning plan screen)
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/jTdTGJSFCP/trigger/1AVB4rb-4
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {bool} properties.isPersonalised - This property stores if the plan presented is personalised with COQs or not. It takes Yes / No.
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/jTdTGJSFCP}
   */
  function viewedLearningPlanScreen2(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertIsPersonalised(properties.isPersonalised));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Learning Plan Screen 2", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "subject",
        "isPersonalised",
        "mode",
        "elaGrade",
        "mathGrade",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "jTdTGJSFCP", "c0c67f4ff64cc3411682294913666cc092fdc54b8d9f65324fc452c7e013c069", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Learning Plan Screen 2", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Subject": properties.subject,
        "Is Personalised": properties.isPersonalised,
        "Mode": properties.mode,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("jTdTGJSFCP", "Viewed Learning Plan Screen 2", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "8n1iVKkl7", name: "Is Personalised", value: properties.isPersonalised},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Learning Plan Screen 2': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Learning Plan Screen 2", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Subject": properties.subject,
          "Is Personalised": properties.isPersonalised,
          "Mode": properties.mode,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "jTdTGJSFCP", "c0c67f4ff64cc3411682294913666cc092fdc54b8d9f65324fc452c7e013c069");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Learning Plan Screen 2", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Subject": properties.subject,
      "Is Personalised": properties.isPersonalised,
      "Mode": properties.mode,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Learning Plan Screen 2: This screen is associated to the interactions with the second subject's learning Plan screen
   * 
   * When to trigger this event:
   * 1. user interacts with this screen
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/HKwSGLftNw/trigger/AEbexBRkN
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {bool} properties.isPersonalised - This property stores if the plan presented is personalised with COQs or not. It takes Yes / No.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/HKwSGLftNw}
   */
  function interactedLearningPlanScreen2(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertIsPersonalised(properties.isPersonalised));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Learning Plan Screen 2", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "subject",
        "isPersonalised",
        "clickedOn",
        "mode",
        "elaGrade",
        "mathGrade",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "HKwSGLftNw", "939d75d04e4606313a0dd534cee67c0846784b4e13c5233689c03b339efb0859", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Learning Plan Screen 2", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Subject": properties.subject,
        "Is Personalised": properties.isPersonalised,
        "Clicked On": properties.clickedOn,
        "Mode": properties.mode,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("HKwSGLftNw", "Interacted Learning Plan Screen 2", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "8n1iVKkl7", name: "Is Personalised", value: properties.isPersonalised},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Learning Plan Screen 2': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Learning Plan Screen 2", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Subject": properties.subject,
          "Is Personalised": properties.isPersonalised,
          "Clicked On": properties.clickedOn,
          "Mode": properties.mode,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "HKwSGLftNw", "939d75d04e4606313a0dd534cee67c0846784b4e13c5233689c03b339efb0859");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Learning Plan Screen 2", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Subject": properties.subject,
      "Is Personalised": properties.isPersonalised,
      "Clicked On": properties.clickedOn,
      "Mode": properties.mode,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Daily Learning Path Screen: This screen is associated with the learning path screen where the LP is presented with the 30 mins. daily messaging and cards' thumbnails

   * 
   * When to trigger this event:
   * 1. This event is triggered when this screen is rendered on user's screen
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/BvI28nCHDN/trigger/sWLmYzx8N
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/BvI28nCHDN}
   */
  function viewedDailyLearningPathScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Daily Learning Path Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mode",
        "elaGrade",
        "mathGrade",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "BvI28nCHDN", "b2b9abad800525614626dc067e39f85b3ef7c1ff49eef67db2f7571011d90efc", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Daily Learning Path Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Mode": properties.mode,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("BvI28nCHDN", "Viewed Daily Learning Path Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Daily Learning Path Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Daily Learning Path Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Mode": properties.mode,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "BvI28nCHDN", "b2b9abad800525614626dc067e39f85b3ef7c1ff49eef67db2f7571011d90efc");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Daily Learning Path Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Mode": properties.mode,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Daily Learning Path Screen: This event is associated with the interactions on the learning path screen. There is only two interactions -> Continue or Back
   * 
   * When to trigger this event:
   * 1. Click on Back or Continue on this screen.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/P2xXYWd4QM/trigger/trHBpFPlx
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/P2xXYWd4QM}
   */
  function interactedDailyLearningPathScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Daily Learning Path Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "mode",
        "elaGrade",
        "mathGrade",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "P2xXYWd4QM", "92b9c7bb0313b357a15feeeffb0074b2dfe8274954f381df9f4a4fcb01134db9", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Daily Learning Path Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Mode": properties.mode,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("P2xXYWd4QM", "Interacted Daily Learning Path Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Daily Learning Path Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Daily Learning Path Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Mode": properties.mode,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "P2xXYWd4QM", "92b9c7bb0313b357a15feeeffb0074b2dfe8274954f381df9f4a4fcb01134db9");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Daily Learning Path Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Mode": properties.mode,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Library Screen: This screen is associated with the Library screens that we already had in the form of loadthrough but now it is a page with CTA.
   * 
   * When to trigger this event:
   * 1. When this screen is rendered on the user's screen.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/7RUqCSNEb-/trigger/j3d1m3IBO
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/7RUqCSNEb-}
   */
  function viewedLibraryScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Library Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mode",
        "elaGrade",
        "mathGrade",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "7RUqCSNEb-", "2461aafe20945cb1a8a506c8e40830c50db03e8fc8deb272ba3ddc5f50c46219", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Library Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Mode": properties.mode,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("7RUqCSNEb-", "Viewed Library Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Library Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Library Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Mode": properties.mode,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "7RUqCSNEb-", "2461aafe20945cb1a8a506c8e40830c50db03e8fc8deb272ba3ddc5f50c46219");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Library Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Mode": properties.mode,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Library Screen: This event is associated to the interactions of the library screens.
   * 
   * When to trigger this event:
   * 1. Click on Continue or Back button
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/aNdJS5XYvn/trigger/yoej2nTlM
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/aNdJS5XYvn}
   */
  function interactedLibraryScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Library Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "mode",
        "elaGrade",
        "mathGrade",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "aNdJS5XYvn", "7e7540eb874259fabed6e0209aaec75cff21797922644b3093d9929ed8ec267c", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Library Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Mode": properties.mode,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("aNdJS5XYvn", "Interacted Library Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Library Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Library Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Mode": properties.mode,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "aNdJS5XYvn", "7e7540eb874259fabed6e0209aaec75cff21797922644b3093d9929ed8ec267c");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Library Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Mode": properties.mode,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Exciting Resources Screen: This event is associated to the resources screen where we had loadthroughs and now we have screen with CTA
   * 
   * When to trigger this event:
   * 1. When this screen is rendered on user's device
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/3KYbK-UvCJ/trigger/Vy_A0WaF_
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/3KYbK-UvCJ}
   */
  function viewedExcitingResourcesScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Exciting Resources Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mode",
        "elaGrade",
        "mathGrade",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "3KYbK-UvCJ", "4eb3f3db6325be2715a56797619898baa36dd45da9f951ef28092eb319811304", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Exciting Resources Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Mode": properties.mode,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("3KYbK-UvCJ", "Viewed Exciting Resources Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Exciting Resources Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Exciting Resources Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Mode": properties.mode,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "3KYbK-UvCJ", "4eb3f3db6325be2715a56797619898baa36dd45da9f951ef28092eb319811304");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Exciting Resources Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Mode": properties.mode,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Exciting Resources Screen: This event is associated to the interactions on the resources screen.
   * 
   * When to trigger this event:
   * 1. Click on continue or back
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/hLLQIGM8YG/trigger/68V3-zwa-X
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/hLLQIGM8YG}
   */
  function interactedExcitingResourcesScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Exciting Resources Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "grade",
        "elaGrade",
        "mathGrade",
        "mode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "hLLQIGM8YG", "aeb88199b8f7ad4d3803bf55811f4eba9ff1fb0348d2855012c1022265719f43", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Exciting Resources Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("hLLQIGM8YG", "Interacted Exciting Resources Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Exciting Resources Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Exciting Resources Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Screen Height": sysScreenHeight,
          }, "hLLQIGM8YG", "aeb88199b8f7ad4d3803bf55811f4eba9ff1fb0348d2855012c1022265719f43");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Exciting Resources Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Started New Learning Path: This event gets triggered when user starts the learning path and the first playable starts.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.learningPathSetting - This stores if the learning path settings is default or customised.
   * @param {string} [properties.mathGoal] - This property stores the Math's goal name active today.

Does not come if Math Goal is not available
   * @param {string} [properties.englishGoal] - This property stores the English's goal names active today
Does not come if English Goal is not available
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.activeLpSubjects - This property stores the active subjects in LP

Math, English, Both

It is only sent on Tab Code = Home
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.topicSelectionMode - This property stores the method to choose topics in the learning path. The values can be default, custom, auto.
Default - we created the LP for the users with default topics
Custom - User created their LP
Auto - we created the LP for the users based on curr. played on D0
None - when Viewed daily bundle rail event gets fired with none state (no db created)
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/XL1EOwZukX}
   */
  function startedNewLearningPath(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertLearningPathSetting(properties.learningPathSetting));
      messages = messages.concat(assertOptionalMathGoal(properties.mathGoal));
      messages = messages.concat(assertOptionalEnglishGoal(properties.englishGoal));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertActiveLpSubjects(properties.activeLpSubjects));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertTopicSelectionMode(properties.topicSelectionMode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Started New Learning Path", Object.keys(properties), [
        "mathGrade",
        "mode",
        "platform",
        "userType",
        "signupFlow",
        "learningPathSetting",
        "mathGoal",
        "englishGoal",
        "subject",
        "activeLpSubjects",
        "elaGrade",
        "grade",
        "topicSelectionMode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "XL1EOwZukX", "49e6fdf9ab4d9778c7a9b68da11f68dc0989b2e1cc84004fedfe349609e7c089", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Started New Learning Path", {
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Learning Path Setting": properties.learningPathSetting,
        "Math Goal": properties.mathGoal,
        "English Goal": properties.englishGoal,
        "Subject": properties.subject,
        "Active Lp Subjects": properties.activeLpSubjects,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Topic Selection Mode": properties.topicSelectionMode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("XL1EOwZukX", "Started New Learning Path", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "9dh_jBFOn", name: "Math Goal", value: properties.mathGoal},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "_fnvZDP5s", name: "Active Lp Subjects", value: properties.activeLpSubjects},
        {id: "iOlmdC6rO", name: "English Goal", value: properties.englishGoal},
        {id: "lRClAbIX-", name: "Learning Path Setting", value: properties.learningPathSetting},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "v2bSgov-m", name: "Topic Selection Mode", value: properties.topicSelectionMode},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Started New Learning Path': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Started New Learning Path", {
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Learning Path Setting": properties.learningPathSetting,
          "Math Goal": properties.mathGoal,
          "English Goal": properties.englishGoal,
          "Subject": properties.subject,
          "Active Lp Subjects": properties.activeLpSubjects,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Topic Selection Mode": properties.topicSelectionMode,
          "Screen Height": sysScreenHeight,
          }, "XL1EOwZukX", "49e6fdf9ab4d9778c7a9b68da11f68dc0989b2e1cc84004fedfe349609e7c089");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Started New Learning Path", {
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Learning Path Setting": properties.learningPathSetting,
      "Math Goal": properties.mathGoal,
      "English Goal": properties.englishGoal,
      "Subject": properties.subject,
      "Active Lp Subjects": properties.activeLpSubjects,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Topic Selection Mode": properties.topicSelectionMode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Completed New Learning Path: This event is fired when the Learning Path set for today is completed. 
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.learningPathSetting - This stores if the learning path settings is default or customised.
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.activeLpSubjects - This property stores the active subjects in LP

Math, English, Both

It is only sent on Tab Code = Home
   * @param {string} [properties.mathGoal] - This property stores the Math's goal name active today.

Does not come if Math Goal is not available
   * @param {string} [properties.englishGoal] - This property stores the English's goal names active today
Does not come if English Goal is not available
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.topicSelectionMode - This property stores the method to choose topics in the learning path. The values can be default, custom, auto.
Default - we created the LP for the users with default topics
Custom - User created their LP
Auto - we created the LP for the users based on curr. played on D0
None - when Viewed daily bundle rail event gets fired with none state (no db created)
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/U6O1oo6Lqx}
   */
  function completedNewLearningPath(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertLearningPathSetting(properties.learningPathSetting));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertActiveLpSubjects(properties.activeLpSubjects));
      messages = messages.concat(assertOptionalMathGoal(properties.mathGoal));
      messages = messages.concat(assertOptionalEnglishGoal(properties.englishGoal));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertTopicSelectionMode(properties.topicSelectionMode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Completed New Learning Path", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "learningPathSetting",
        "subject",
        "activeLpSubjects",
        "mathGoal",
        "englishGoal",
        "grade",
        "elaGrade",
        "topicSelectionMode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "U6O1oo6Lqx", "167145f9d000c3508aa50bed92c25c8de2a6e685cf7f020c6530d9d8e62be1a3", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Completed New Learning Path", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Learning Path Setting": properties.learningPathSetting,
        "Subject": properties.subject,
        "Active Lp Subjects": properties.activeLpSubjects,
        "Math Goal": properties.mathGoal,
        "English Goal": properties.englishGoal,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Topic Selection Mode": properties.topicSelectionMode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("U6O1oo6Lqx", "Completed New Learning Path", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "9dh_jBFOn", name: "Math Goal", value: properties.mathGoal},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "_fnvZDP5s", name: "Active Lp Subjects", value: properties.activeLpSubjects},
        {id: "iOlmdC6rO", name: "English Goal", value: properties.englishGoal},
        {id: "lRClAbIX-", name: "Learning Path Setting", value: properties.learningPathSetting},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "v2bSgov-m", name: "Topic Selection Mode", value: properties.topicSelectionMode},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Completed New Learning Path': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Completed New Learning Path", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Learning Path Setting": properties.learningPathSetting,
          "Subject": properties.subject,
          "Active Lp Subjects": properties.activeLpSubjects,
          "Math Goal": properties.mathGoal,
          "English Goal": properties.englishGoal,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Topic Selection Mode": properties.topicSelectionMode,
          "Screen Height": sysScreenHeight,
          }, "U6O1oo6Lqx", "167145f9d000c3508aa50bed92c25c8de2a6e685cf7f020c6530d9d8e62be1a3");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Completed New Learning Path", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Learning Path Setting": properties.learningPathSetting,
      "Subject": properties.subject,
      "Active Lp Subjects": properties.activeLpSubjects,
      "Math Goal": properties.mathGoal,
      "English Goal": properties.englishGoal,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Topic Selection Mode": properties.topicSelectionMode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Customisation Screen: This event is associated to the newly added Learning Path rail's customisation option. 
Click on customise loads a new page called customisation page
   * 
   * When to trigger this event:
   * 1. This event gets fired when customisation screen loads after user clicks on customise button of the LP rail.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/e0MMH8Bh2/trigger/4y13hV51l
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickId - unique id associated with distinct clicks on the home dashboard on playables
   * @param {string} properties.mathActiveGoals - Math Active Goals stores all the active goals in pipe separated format. 

1. It will come as not available if the subject is off. 
2. The first is the goal recommended today.
   * @param {string} properties.englishActiveGoals - English Active Goals stores all the active goals in pipe separated format. 

1. It will come as not available if the subject is off. 
2. The first is the goal recommended today.
   * @param {int} properties.dailyPracticeTime - This stores current daily play time in mins. This will store 10, 20, 30, etc.
   * @param {string} [properties.activeLpSubjects] - This property stores the active subjects in LP

Math, English, Both

It is only sent on Tab Code = Home
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/e0MMH8Bh2}
   */
  function viewedCustomisationScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickId(properties.clickId));
      messages = messages.concat(assertMathActiveGoals(properties.mathActiveGoals));
      messages = messages.concat(assertEnglishActiveGoals(properties.englishActiveGoals));
      messages = messages.concat(assertDailyPracticeTime(properties.dailyPracticeTime));
      messages = messages.concat(assertOptionalActiveLpSubjects(properties.activeLpSubjects));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Customisation Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "clickId",
        "mathActiveGoals",
        "englishActiveGoals",
        "dailyPracticeTime",
        "activeLpSubjects",
        "mode",
        "elaGrade",
        "mathGrade",
        "grade",
        "from"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "e0MMH8Bh2", "c245233e35d1101d1bc9099b59beafd7a8c3b69099466ca78cbf8be3ec5ef288", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Customisation Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Click Id": properties.clickId,
        "Math Active Goals": properties.mathActiveGoals,
        "English Active Goals": properties.englishActiveGoals,
        "Daily Practice Time": properties.dailyPracticeTime,
        "Active Lp Subjects": properties.activeLpSubjects,
        "Mode": properties.mode,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Grade": properties.grade,
        "From": properties.from,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("e0MMH8Bh2", "Viewed Customisation Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "_fnvZDP5s", name: "Active Lp Subjects", value: properties.activeLpSubjects},
        {id: "jVQaLzj_1", name: "Click Id", value: properties.clickId},
        {id: "l_c9W4nI2", name: "English Active Goals", value: properties.englishActiveGoals},
        {id: "o9Eq-BcYF", name: "Math Active Goals", value: properties.mathActiveGoals},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "sGjYFiQA4", name: "Daily Practice Time", value: properties.dailyPracticeTime},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Customisation Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Customisation Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Click Id": properties.clickId,
          "Math Active Goals": properties.mathActiveGoals,
          "English Active Goals": properties.englishActiveGoals,
          "Daily Practice Time": properties.dailyPracticeTime,
          "Active Lp Subjects": properties.activeLpSubjects,
          "Mode": properties.mode,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Grade": properties.grade,
          "From": properties.from,
          "Screen Height": sysScreenHeight,
          }, "e0MMH8Bh2", "c245233e35d1101d1bc9099b59beafd7a8c3b69099466ca78cbf8be3ec5ef288");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Customisation Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Click Id": properties.clickId,
      "Math Active Goals": properties.mathActiveGoals,
      "English Active Goals": properties.englishActiveGoals,
      "Daily Practice Time": properties.dailyPracticeTime,
      "Active Lp Subjects": properties.activeLpSubjects,
      "Mode": properties.mode,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Grade": properties.grade,
      "From": properties.from,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Customisation Screen: This event will be triggered if any CTA or link is clicked on the customisation page.
   * 
   * When to trigger this event:
   * 1. When CTAs or links get clicked on this page
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/9xuhsjDgRD/trigger/MWdACpzU6
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickId - unique id associated with distinct clicks on the home dashboard on playables
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {bool} properties.customisedLp - This property will be used to see if the LP is even customised? 
This will take True / False
   * @param {string} [properties.changesApplied] - This property stores only if Customised Lp is true and stores the value of the change(s) in pipe separated format

<practice time> | Math On / Off | English On / Off | Math Goals | English Goals

Example: 40 | Math Off | English Goals
Will not come if anything hasn't changed
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/9xuhsjDgRD}
   */
  function interactedCustomisationScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickId(properties.clickId));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertCustomisedLp(properties.customisedLp));
      messages = messages.concat(assertOptionalChangesApplied(properties.changesApplied));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Customisation Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "clickId",
        "clickedOn",
        "customisedLp",
        "changesApplied",
        "mode",
        "elaGrade",
        "mathGrade",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "9xuhsjDgRD", "760c884b106607aa7053c7e7549d1c938081a254288055b7241bd7501191e77e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Customisation Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Click Id": properties.clickId,
        "Clicked On": properties.clickedOn,
        "Customised Lp": properties.customisedLp,
        "Changes Applied": properties.changesApplied,
        "Mode": properties.mode,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("9xuhsjDgRD", "Interacted Customisation Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "EGScs-yrX", name: "Customised Lp", value: properties.customisedLp},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "WKUcnjiy_", name: "Changes Applied", value: properties.changesApplied},
        {id: "jVQaLzj_1", name: "Click Id", value: properties.clickId},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Customisation Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Customisation Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Click Id": properties.clickId,
          "Clicked On": properties.clickedOn,
          "Customised Lp": properties.customisedLp,
          "Changes Applied": properties.changesApplied,
          "Mode": properties.mode,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "9xuhsjDgRD", "760c884b106607aa7053c7e7549d1c938081a254288055b7241bd7501191e77e");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Customisation Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Click Id": properties.clickId,
      "Clicked On": properties.clickedOn,
      "Customised Lp": properties.customisedLp,
      "Changes Applied": properties.changesApplied,
      "Mode": properties.mode,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Goals Screen: This event is specific to the popup where we are showing all Math / English goals.

   * 
   * When to trigger this event:
   * 1. This event gets triggered when this popup loads once user clicks on Edit goal on the customisation screen
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/d4OKz8FpYo/trigger/Yf6erw3M7
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickId - unique id associated with distinct clicks on the home dashboard on playables
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.currentGoals - This goal stores currently active goals in a pipe separated format. The first goal as the today's goal.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.mathGrade - no description
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/d4OKz8FpYo}
   */
  function viewedGoalsScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickId(properties.clickId));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertCurrentGoals(properties.currentGoals));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Goals Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "clickId",
        "subject",
        "currentGoals",
        "elaGrade",
        "mode",
        "grade",
        "mathGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "d4OKz8FpYo", "6723f1b25ca993a4bd8ad97d11a26cccd1356b202e5e666bf41b2567f3e50b0c", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Goals Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Click Id": properties.clickId,
        "Subject": properties.subject,
        "Current Goals": properties.currentGoals,
        "Ela Grade": properties.elaGrade,
        "Mode": properties.mode,
        "Grade": properties.grade,
        "Math Grade": properties.mathGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("d4OKz8FpYo", "Viewed Goals Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "SO6SLa4H5", name: "Current Goals", value: properties.currentGoals},
        {id: "jVQaLzj_1", name: "Click Id", value: properties.clickId},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Goals Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Goals Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Click Id": properties.clickId,
          "Subject": properties.subject,
          "Current Goals": properties.currentGoals,
          "Ela Grade": properties.elaGrade,
          "Mode": properties.mode,
          "Grade": properties.grade,
          "Math Grade": properties.mathGrade,
          "Screen Height": sysScreenHeight,
          }, "d4OKz8FpYo", "6723f1b25ca993a4bd8ad97d11a26cccd1356b202e5e666bf41b2567f3e50b0c");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Goals Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Click Id": properties.clickId,
      "Subject": properties.subject,
      "Current Goals": properties.currentGoals,
      "Ela Grade": properties.elaGrade,
      "Mode": properties.mode,
      "Grade": properties.grade,
      "Math Grade": properties.mathGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Goals Screen: This event stores the interaction with the Goals screen
   * 
   * When to trigger this event:
   * 1. Triggered when user interacts with the CTA or cross button
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/eW_Zd1h2Bh/trigger/gdMQX_f1c
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.clickId - unique id associated with distinct clicks on the home dashboard on playables
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.currentGoals - This goal stores currently active goals in a pipe separated format. The first goal as the today's goal.
   * @param {string} [properties.newGoals] - This stores the new goals in a pipe separated format if changed from the Goals screen. It will only be sent if made any changes in goals. 

The first goal will come as the first string.
   * @param {bool} properties.changedGoal - This stores true / false based on goal changed or not.

If changed goal is false, New Goals will not be sent.
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/eW_Zd1h2Bh}
   */
  function interactedGoalsScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertClickId(properties.clickId));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertCurrentGoals(properties.currentGoals));
      messages = messages.concat(assertOptionalNewGoals(properties.newGoals));
      messages = messages.concat(assertChangedGoal(properties.changedGoal));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Goals Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "clickId",
        "subject",
        "currentGoals",
        "newGoals",
        "changedGoal",
        "mode",
        "grade",
        "elaGrade",
        "mathGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "eW_Zd1h2Bh", "17a340e9ebdd478a3da3bf01dfded38379ae81771aeebce79823c0b6ec4cd900", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Goals Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Click Id": properties.clickId,
        "Subject": properties.subject,
        "Current Goals": properties.currentGoals,
        "New Goals": properties.newGoals,
        "Changed Goal": properties.changedGoal,
        "Mode": properties.mode,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("eW_Zd1h2Bh", "Interacted Goals Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "NOQe2s5vk", name: "Changed Goal", value: properties.changedGoal},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "SO6SLa4H5", name: "Current Goals", value: properties.currentGoals},
        {id: "jVQaLzj_1", name: "Click Id", value: properties.clickId},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "s065vXrjO", name: "New Goals", value: properties.newGoals},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Goals Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Goals Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Click Id": properties.clickId,
          "Subject": properties.subject,
          "Current Goals": properties.currentGoals,
          "New Goals": properties.newGoals,
          "Changed Goal": properties.changedGoal,
          "Mode": properties.mode,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Screen Height": sysScreenHeight,
          }, "eW_Zd1h2Bh", "17a340e9ebdd478a3da3bf01dfded38379ae81771aeebce79823c0b6ec4cd900");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Goals Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Click Id": properties.clickId,
      "Subject": properties.subject,
      "Current Goals": properties.currentGoals,
      "New Goals": properties.newGoals,
      "Changed Goal": properties.changedGoal,
      "Mode": properties.mode,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed New Subscription Popup: This event is sent if user sees the new subscription popups as per the flows defined with the launch of new learning path.

With the new freemium model where we are giving LP free and locking the rest of the content, customisation options, play again on LP, play more from LP - different popups will be shown that may have different impact altogether.
   * 
   * When to trigger this event:
   * 1. User clicks on Save goals inside the customisation options
User clicks on Play next on LP after completing today's LP
User clicks on a mystery card that is already played
User clicks on the locked card on GameZone, Home, Curr. Tabs
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/FUJJvEETBp/trigger/Q5DcxsQfp
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickSource - This property will be used to identify the click that lead to this popup. The subscription popups can now be seen from various flows like play more on lp, play games again on lp, click on locked cards, save customised setting.
   * @param {string} properties.tabCode - Specifies the tab which has been opened in the event 'Viewed Tiled Dashboard' and Other events too
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/FUJJvEETBp}
   */
  function viewedNewSubscriptionPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickSource(properties.clickSource));
      messages = messages.concat(assertTabCode(properties.tabCode));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed New Subscription Popup", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "clickSource",
        "tabCode",
        "elaGrade",
        "mathGrade",
        "grade",
        "mode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "FUJJvEETBp", "c6bdf1f691b0e60df9ee01ad6e18747a7866c80361a3b3fc76d772ab06b7798c", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed New Subscription Popup", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Click Source": properties.clickSource,
        "Tab Code": properties.tabCode,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Grade": properties.grade,
        "Mode": properties.mode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("FUJJvEETBp", "Viewed New Subscription Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "l9PbANZBu", name: "Tab Code", value: properties.tabCode},
        {id: "mVqeh4I8W", name: "Click Source", value: properties.clickSource},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed New Subscription Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed New Subscription Popup", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Click Source": properties.clickSource,
          "Tab Code": properties.tabCode,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Grade": properties.grade,
          "Mode": properties.mode,
          "Screen Height": sysScreenHeight,
          }, "FUJJvEETBp", "c6bdf1f691b0e60df9ee01ad6e18747a7866c80361a3b3fc76d772ab06b7798c");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed New Subscription Popup", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Click Source": properties.clickSource,
      "Tab Code": properties.tabCode,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Grade": properties.grade,
      "Mode": properties.mode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted New Subscription Popup: This event will be triggered as user click on some CTA or cross on the subscription popup.
   * 
   * When to trigger this event:
   * 1. Click on CTA or cross
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/T_7d0izn50/trigger/8a1iAaqLt
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/T_7d0izn50}
   */
  function interactedNewSubscriptionPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted New Subscription Popup", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "elaGrade",
        "mathGrade",
        "grade",
        "mode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "T_7d0izn50", "d138f8c052537861d9b03d6bb6883ce3b4016918fc6058f398cc9b63e8b0a1b9", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted New Subscription Popup", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Grade": properties.grade,
        "Mode": properties.mode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("T_7d0izn50", "Interacted New Subscription Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted New Subscription Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted New Subscription Popup", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Grade": properties.grade,
          "Mode": properties.mode,
          "Screen Height": sysScreenHeight,
          }, "T_7d0izn50", "d138f8c052537861d9b03d6bb6883ce3b4016918fc6058f398cc9b63e8b0a1b9");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted New Subscription Popup", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Grade": properties.grade,
      "Mode": properties.mode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Popup: Whenever a popup is shown
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Iz-r-QjuNw/trigger/C8iHOLUkw
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {string} properties.popupType - Viewed popup can be a generic event with type of popup like 'Book Library Introduction' in this case
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Iz-r-QjuNw}
   */
  function viewedPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertPopupType(properties.popupType));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Popup", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "from",
        "popupType"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Iz-r-QjuNw", "9a6e0ab912677f80b8512771610345a520a507fbe01898b362304269a5c05635", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Popup", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From": properties.from,
        "Popup Type": properties.popupType,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Iz-r-QjuNw", "Viewed Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "4JcpJcKm5", name: "Popup Type", value: properties.popupType},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Popup", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From": properties.from,
          "Popup Type": properties.popupType,
          "Screen Height": sysScreenHeight,
          }, "Iz-r-QjuNw", "9a6e0ab912677f80b8512771610345a520a507fbe01898b362304269a5c05635");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Popup", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From": properties.from,
      "Popup Type": properties.popupType,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Popup: Interacted on any element within the popup
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/dwf_ABCrzZ/trigger/4OndXD5YO
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.popupType - Viewed popup can be a generic event with type of popup like 'Book Library Introduction' in this case
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/dwf_ABCrzZ}
   */
  function interactedPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertPopupType(properties.popupType));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Popup", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "popupType",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "dwf_ABCrzZ", "06a56f0357ea27bb7c9857dd2c79467295d467a49ab43631158c2118f66f0bbf", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Popup", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Popup Type": properties.popupType,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("dwf_ABCrzZ", "Interacted Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "4JcpJcKm5", name: "Popup Type", value: properties.popupType},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Popup", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Popup Type": properties.popupType,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "dwf_ABCrzZ", "06a56f0357ea27bb7c9857dd2c79467295d467a49ab43631158c2118f66f0bbf");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Popup", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Popup Type": properties.popupType,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Book Library: When the user lands on book library page
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/SdQnthIVHK/trigger/Hq-Q5XgzD
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.pageName - Includes the name of the page (Eg: Playzone game listing page, ). This is not the URL but a easily understandable definition of what page is the user at.
   * @param {object} properties.filtersApplied - All the filters that are applied for the page being viewed
   * @param {string} properties.searchTerm - Term searched by the user
   * @param {int} properties.numberOfResults - Number of results shown for search results
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {Array<string>} properties.readingLevel - Reading level like grade 2, grade 3 level, GRL A-C etc of the user
   * @param {string} properties.readingSystem - Reading system like lexile / GRL / Grade Level etc
   * @param {string} properties.tabName - Tab that the user has selected like Recommended / Audio books / Interactive books etc
   * @param {string} [properties.categoryName] - For Book Library
Category of the books like Animals, People and Culture etc

For Avatar Space
This property stores the categories within closer such as shirt, pant, goggles, hat, etc.

   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * @param {string} properties.topTab - Top horizontal tabs that user has interacted with on teacher product
   * @param {string} properties.section - This will capture the widget name that is being viewed/interacted by the user in that viewport. For example, 'Onboarding Widget', 'Home Access Widget', 'Assignment Widget', 'Assessment Widget', 'Math Fact Widget'
The list will only have 1 value for 'Section' property for Interacted event.
   * @param {string} properties.readingSkill - List of CCSS skills related to reading
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/SdQnthIVHK}
   */
  function viewedBookLibrary(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertPageName(properties.pageName));
      messages = messages.concat(assertFiltersApplied(properties.filtersApplied));
      messages = messages.concat(assertSearchTerm(properties.searchTerm));
      messages = messages.concat(assertNumberOfResults(properties.numberOfResults));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertReadingLevel(properties.readingLevel));
      messages = messages.concat(assertReadingSystem(properties.readingSystem));
      messages = messages.concat(assertTabName(properties.tabName));
      messages = messages.concat(assertOptionalCategoryName(properties.categoryName));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertTopTab(properties.topTab));
      messages = messages.concat(assertSection(properties.section));
      messages = messages.concat(assertReadingSkill(properties.readingSkill));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Book Library", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "pageName",
        "filtersApplied",
        "searchTerm",
        "numberOfResults",
        "from",
        "readingLevel",
        "readingSystem",
        "tabName",
        "categoryName",
        "fromPage",
        "topTab",
        "section",
        "readingSkill",
        "grade",
        "mathGrade",
        "elaGrade",
        "mode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "SdQnthIVHK", "88e1ab2ec5c4e563f4ba7e7888805d3830d5bb299996fce143570c820dd2e5bd", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Book Library", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Page Name": properties.pageName,
        "Filters Applied": properties.filtersApplied,
        "Search Term": properties.searchTerm,
        "Number of Results": properties.numberOfResults,
        "From": properties.from,
        "Reading Level": properties.readingLevel,
        "Reading System": properties.readingSystem,
        "Tab Name": properties.tabName,
        "Category Name": properties.categoryName,
        "From Page": properties.fromPage,
        "Top Tab": properties.topTab,
        "Section": properties.section,
        "Reading Skill": properties.readingSkill,
        "Grade": properties.grade,
        "Math Grade": properties.mathGrade,
        "Ela Grade": properties.elaGrade,
        "Mode": properties.mode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("SdQnthIVHK", "Viewed Book Library", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "8Mz1CdVTk", name: "Tab Name", value: properties.tabName},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "MJKSzmqfHu", name: "Page Name", value: properties.pageName},
        {id: "TYsaD1VcN", name: "Reading Level", value: properties.readingLevel},
        {id: "UtPMQu4JE", name: "Number of Results", value: properties.numberOfResults},
        {id: "aX1-5O7eP", name: "Filters Applied", value: properties.filtersApplied},
        {id: "bJOqfTjmu", name: "Reading System", value: properties.readingSystem},
        {id: "ctnr0D9n3", name: "Top Tab", value: properties.topTab},
        {id: "guJOTwi5T", name: "Search Term", value: properties.searchTerm},
        {id: "kZQO8-HD9", name: "Category Name", value: properties.categoryName},
        {id: "my9qL7M8w6", name: "Section", value: properties.section},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "tt7EpUhgU", name: "Reading Skill", value: properties.readingSkill},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Book Library': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Book Library", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Page Name": properties.pageName,
          "Filters Applied": properties.filtersApplied,
          "Search Term": properties.searchTerm,
          "Number of Results": properties.numberOfResults,
          "From": properties.from,
          "Reading Level": properties.readingLevel,
          "Reading System": properties.readingSystem,
          "Tab Name": properties.tabName,
          "Category Name": properties.categoryName,
          "From Page": properties.fromPage,
          "Top Tab": properties.topTab,
          "Section": properties.section,
          "Reading Skill": properties.readingSkill,
          "Grade": properties.grade,
          "Math Grade": properties.mathGrade,
          "Ela Grade": properties.elaGrade,
          "Mode": properties.mode,
          "Screen Height": sysScreenHeight,
          }, "SdQnthIVHK", "88e1ab2ec5c4e563f4ba7e7888805d3830d5bb299996fce143570c820dd2e5bd");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Book Library", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Page Name": properties.pageName,
      "Filters Applied": properties.filtersApplied,
      "Search Term": properties.searchTerm,
      "Number of Results": properties.numberOfResults,
      "From": properties.from,
      "Reading Level": properties.readingLevel,
      "Reading System": properties.readingSystem,
      "Tab Name": properties.tabName,
      "Category Name": properties.categoryName,
      "From Page": properties.fromPage,
      "Top Tab": properties.topTab,
      "Section": properties.section,
      "Reading Skill": properties.readingSkill,
      "Grade": properties.grade,
      "Math Grade": properties.mathGrade,
      "Ela Grade": properties.elaGrade,
      "Mode": properties.mode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Book Library: When the user clicks/taps on anything in the book library page
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/SjejqVzzJ1/trigger/YinmZDKMK
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {Array<string>} [properties.recommendedRailName] - This is the name of the rail viewed by the user. 
Recommended rail property comes with rail name and rail rank, pipe separated - with the introduction of this property, we intend to separate rail name to calculate CTR on Mixpanel.
   * @param {string} [properties.readingSystem] - Reading system like lexile / GRL / Grade Level etc
   * @param {string} [properties.valueName] - This will capture the value/text of the field that is selected.
   * @param {string} [properties.tabName] - Tab that the user has selected like Recommended / Audio books / Interactive books etc
   * @param {string} [properties.pageName] - Includes the name of the page (Eg: Playzone game listing page, ). This is not the URL but a easily understandable definition of what page is the user at.
   * @param {string} [properties.categoryName] - For Book Library
Category of the books like Animals, People and Culture etc

For Avatar Space
This property stores the categories within closer such as shirt, pant, goggles, hat, etc.

   * @param {string} [properties.searchTerm] - Term searched by the user
   * @param {int} [properties.numberOfResults] - Number of results shown for search results
   * @param {object} [properties.filtersApplied] - All the filters that are applied for the page being viewed
   * @param {string} [properties.filterName] - Name of the filter that is clicked, eg. theme, fiction/Non-fiction in book library 
   * @param {Array<string>} [properties.readingLevel] - Reading level like grade 2, grade 3 level, GRL A-C etc of the user
   * @param {string} properties.topTab - Top horizontal tabs that user has interacted with on teacher product
   * @param {string} properties.readingSkill - List of CCSS skills related to reading
   * @param {string} [properties.clickSource] - This property will be used to identify the click that lead to this popup. The subscription popups can now be seen from various flows like play more on lp, play games again on lp, click on locked cards, save customised setting.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/SjejqVzzJ1}
   */
  function interactedBookLibrary(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertOptionalRecommendedRailName(properties.recommendedRailName));
      messages = messages.concat(assertOptionalReadingSystem(properties.readingSystem));
      messages = messages.concat(assertOptionalValueName(properties.valueName));
      messages = messages.concat(assertOptionalTabName(properties.tabName));
      messages = messages.concat(assertOptionalPageName(properties.pageName));
      messages = messages.concat(assertOptionalCategoryName(properties.categoryName));
      messages = messages.concat(assertOptionalSearchTerm(properties.searchTerm));
      messages = messages.concat(assertOptionalNumberOfResults(properties.numberOfResults));
      messages = messages.concat(assertOptionalFiltersApplied(properties.filtersApplied));
      messages = messages.concat(assertOptionalFilterName(properties.filterName));
      messages = messages.concat(assertOptionalReadingLevel(properties.readingLevel));
      messages = messages.concat(assertTopTab(properties.topTab));
      messages = messages.concat(assertReadingSkill(properties.readingSkill));
      messages = messages.concat(assertOptionalClickSource(properties.clickSource));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Book Library", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "recommendedRailName",
        "readingSystem",
        "valueName",
        "tabName",
        "pageName",
        "categoryName",
        "searchTerm",
        "numberOfResults",
        "filtersApplied",
        "filterName",
        "readingLevel",
        "topTab",
        "readingSkill",
        "clickSource",
        "grade",
        "elaGrade",
        "mathGrade",
        "mode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "SjejqVzzJ1", "7ec0d59e960130b0407a820e3d6f2df7782056c1bf2d371000b081a5ca7c2a25", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Book Library", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Recommended Rail Name": properties.recommendedRailName,
        "Reading System": properties.readingSystem,
        "Value Name": properties.valueName,
        "Tab Name": properties.tabName,
        "Page Name": properties.pageName,
        "Category Name": properties.categoryName,
        "Search Term": properties.searchTerm,
        "Number of Results": properties.numberOfResults,
        "Filters Applied": properties.filtersApplied,
        "Filter Name": properties.filterName,
        "Reading Level": properties.readingLevel,
        "Top Tab": properties.topTab,
        "Reading Skill": properties.readingSkill,
        "Click Source": properties.clickSource,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("SjejqVzzJ1", "Interacted Book Library", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "6lrsWYY5Y", name: "Recommended Rail Name", value: properties.recommendedRailName},
        {id: "8Mz1CdVTk", name: "Tab Name", value: properties.tabName},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "MJKSzmqfHu", name: "Page Name", value: properties.pageName},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "TYsaD1VcN", name: "Reading Level", value: properties.readingLevel},
        {id: "UtPMQu4JE", name: "Number of Results", value: properties.numberOfResults},
        {id: "aX1-5O7eP", name: "Filters Applied", value: properties.filtersApplied},
        {id: "bJOqfTjmu", name: "Reading System", value: properties.readingSystem},
        {id: "ctnr0D9n3", name: "Top Tab", value: properties.topTab},
        {id: "guJOTwi5T", name: "Search Term", value: properties.searchTerm},
        {id: "kZQO8-HD9", name: "Category Name", value: properties.categoryName},
        {id: "l-8JNUE0q", name: "Value Name", value: properties.valueName},
        {id: "mVqeh4I8W", name: "Click Source", value: properties.clickSource},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "tt7EpUhgU", name: "Reading Skill", value: properties.readingSkill},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xU_rUr8u6", name: "Filter Name", value: properties.filterName},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Book Library': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Book Library", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Recommended Rail Name": properties.recommendedRailName,
          "Reading System": properties.readingSystem,
          "Value Name": properties.valueName,
          "Tab Name": properties.tabName,
          "Page Name": properties.pageName,
          "Category Name": properties.categoryName,
          "Search Term": properties.searchTerm,
          "Number of Results": properties.numberOfResults,
          "Filters Applied": properties.filtersApplied,
          "Filter Name": properties.filterName,
          "Reading Level": properties.readingLevel,
          "Top Tab": properties.topTab,
          "Reading Skill": properties.readingSkill,
          "Click Source": properties.clickSource,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Screen Height": sysScreenHeight,
          }, "SjejqVzzJ1", "7ec0d59e960130b0407a820e3d6f2df7782056c1bf2d371000b081a5ca7c2a25");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Book Library", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Recommended Rail Name": properties.recommendedRailName,
      "Reading System": properties.readingSystem,
      "Value Name": properties.valueName,
      "Tab Name": properties.tabName,
      "Page Name": properties.pageName,
      "Category Name": properties.categoryName,
      "Search Term": properties.searchTerm,
      "Number of Results": properties.numberOfResults,
      "Filters Applied": properties.filtersApplied,
      "Filter Name": properties.filterName,
      "Reading Level": properties.readingLevel,
      "Top Tab": properties.topTab,
      "Reading Skill": properties.readingSkill,
      "Click Source": properties.clickSource,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Scrolled Dashboard: Capture how  much is the user scrolling on the page. Similar to Scrolled Student Dashboard event on B2C
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/60Kuq2zIth/trigger/7DPKpiCIX
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.pageName - Includes the name of the page (Eg: Playzone game listing page, ). This is not the URL but a easily understandable definition of what page is the user at.
   * @param {Array<string>} properties.recommendedRail - This property will be used to store which rails were shown to the user in the HOME tab.

Where possible values are:
Rail Name = Curriculum, Game Zone, Math, Language, Logic & Thinking, Art & Creativity, General Knowledge, Motor Skills, Live Classes, Fluency, Multiplayer
This comes with Rank also with | separation
   * @param {Array<string>} properties.recommendedRailName - This is the name of the rail viewed by the user. 
Recommended rail property comes with rail name and rail rank, pipe separated - with the introduction of this property, we intend to separate rail name to calculate CTR on Mixpanel.
   * @param {Array<int>} properties.recommendedRailRank - Recommended Rail Rank will carry the rank of the rail in integer format viewed by the user. 
   * @param {string} properties.recommendationRailCode - This property will capture the code for recommended rails driven by algorithm
   * @param {string} properties.recommendationVersionName - Parent code for different versions of AB test
   * @param {string} properties.recommendationSubVersionName - It is a code that defines different version of different rail on book library dashboard
   * @param {int} properties.recommendationAlgorithmFlag - If a rail is driven by recommendation version then flag will be 1 else 0
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/60Kuq2zIth}
   */
  function scrolledDashboard(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertPageName(properties.pageName));
      messages = messages.concat(assertRecommendedRail(properties.recommendedRail));
      messages = messages.concat(assertRecommendedRailName(properties.recommendedRailName));
      messages = messages.concat(assertRecommendedRailRank(properties.recommendedRailRank));
      messages = messages.concat(assertRecommendationRailCode(properties.recommendationRailCode));
      messages = messages.concat(assertRecommendationVersionName(properties.recommendationVersionName));
      messages = messages.concat(assertRecommendationSubVersionName(properties.recommendationSubVersionName));
      messages = messages.concat(assertRecommendationAlgorithmFlag(properties.recommendationAlgorithmFlag));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Scrolled Dashboard", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "pageName",
        "recommendedRail",
        "recommendedRailName",
        "recommendedRailRank",
        "recommendationRailCode",
        "recommendationVersionName",
        "recommendationSubVersionName",
        "recommendationAlgorithmFlag",
        "from"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "60Kuq2zIth", "7b92cdfd0de158e37732d3c7c45b68d527a6d08a7421546f7d88f7ca7b795851", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Scrolled Dashboard", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Page Name": properties.pageName,
        "Recommended Rail": properties.recommendedRail,
        "Recommended Rail Name": properties.recommendedRailName,
        "Recommended Rail Rank": properties.recommendedRailRank,
        "Recommendation Rail Code": properties.recommendationRailCode,
        "Recommendation Version Name": properties.recommendationVersionName,
        "Recommendation Sub Version Name": properties.recommendationSubVersionName,
        "Recommendation Algorithm Flag": properties.recommendationAlgorithmFlag,
        "From": properties.from,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("60Kuq2zIth", "Scrolled Dashboard", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "6lrsWYY5Y", name: "Recommended Rail Name", value: properties.recommendedRailName},
        {id: "BchWbNpV0WYRnYxTnBQ-c", name: "Recommendation Sub Version Name", value: properties.recommendationSubVersionName},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "FH6REXldlxqxCPK0pvsML", name: "Recommendation Version Name", value: properties.recommendationVersionName},
        {id: "MJKSzmqfHu", name: "Page Name", value: properties.pageName},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "Q2q6j4dEnjH8uo-MY-mr7", name: "Recommendation Algorithm Flag", value: properties.recommendationAlgorithmFlag},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "Qwa4E7UWbmonbiv7JbciC", name: "Recommendation Rail Code", value: properties.recommendationRailCode},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "drNgwJn5Xg", name: "Recommended Rail", value: properties.recommendedRail},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "uyLgqxbg7", name: "Recommended Rail Rank", value: properties.recommendedRailRank},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Scrolled Dashboard': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Scrolled Dashboard", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Page Name": properties.pageName,
          "Recommended Rail": properties.recommendedRail,
          "Recommended Rail Name": properties.recommendedRailName,
          "Recommended Rail Rank": properties.recommendedRailRank,
          "Recommendation Rail Code": properties.recommendationRailCode,
          "Recommendation Version Name": properties.recommendationVersionName,
          "Recommendation Sub Version Name": properties.recommendationSubVersionName,
          "Recommendation Algorithm Flag": properties.recommendationAlgorithmFlag,
          "From": properties.from,
          "Screen Height": sysScreenHeight,
          }, "60Kuq2zIth", "7b92cdfd0de158e37732d3c7c45b68d527a6d08a7421546f7d88f7ca7b795851");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Scrolled Dashboard", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Page Name": properties.pageName,
      "Recommended Rail": properties.recommendedRail,
      "Recommended Rail Name": properties.recommendedRailName,
      "Recommended Rail Rank": properties.recommendedRailRank,
      "Recommendation Rail Code": properties.recommendationRailCode,
      "Recommendation Version Name": properties.recommendationVersionName,
      "Recommendation Sub Version Name": properties.recommendationSubVersionName,
      "Recommendation Algorithm Flag": properties.recommendationAlgorithmFlag,
      "From": properties.from,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Completed Book Dashboard Scroll [Teacher]: When the user has reached the end of page where they would see no more results or see show more button

   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/eUt7qBVlEi/trigger/qF2cE5ctT
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {Array<string>} properties.recommendedRail - This property will be used to store which rails were shown to the user in the HOME tab.

Where possible values are:
Rail Name = Curriculum, Game Zone, Math, Language, Logic & Thinking, Art & Creativity, General Knowledge, Motor Skills, Live Classes, Fluency, Multiplayer
This comes with Rank also with | separation
   * @param {Array<string>} properties.recommendedRailName - This is the name of the rail viewed by the user. 
Recommended rail property comes with rail name and rail rank, pipe separated - with the introduction of this property, we intend to separate rail name to calculate CTR on Mixpanel.
   * @param {Array<int>} properties.recommendedRailRank - Recommended Rail Rank will carry the rank of the rail in integer format viewed by the user. 
   * @param {string} properties.pageName - Includes the name of the page (Eg: Playzone game listing page, ). This is not the URL but a easily understandable definition of what page is the user at.
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/eUt7qBVlEi}
   */
  function completedBookDashboardScrollTeacher(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertRecommendedRail(properties.recommendedRail));
      messages = messages.concat(assertRecommendedRailName(properties.recommendedRailName));
      messages = messages.concat(assertRecommendedRailRank(properties.recommendedRailRank));
      messages = messages.concat(assertPageName(properties.pageName));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Completed Book Dashboard Scroll [Teacher]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "recommendedRail",
        "recommendedRailName",
        "recommendedRailRank",
        "pageName",
        "from"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "eUt7qBVlEi", "fcadafaf31e1ae06e097b8e1ed44508fdcec1236bbe3e415372371486d10831b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Completed Book Dashboard Scroll [Teacher]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Recommended Rail": properties.recommendedRail,
        "Recommended Rail Name": properties.recommendedRailName,
        "Recommended Rail Rank": properties.recommendedRailRank,
        "Page Name": properties.pageName,
        "From": properties.from,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("eUt7qBVlEi", "Completed Book Dashboard Scroll [Teacher]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "6lrsWYY5Y", name: "Recommended Rail Name", value: properties.recommendedRailName},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "MJKSzmqfHu", name: "Page Name", value: properties.pageName},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "drNgwJn5Xg", name: "Recommended Rail", value: properties.recommendedRail},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "uyLgqxbg7", name: "Recommended Rail Rank", value: properties.recommendedRailRank},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Completed Book Dashboard Scroll [Teacher]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Completed Book Dashboard Scroll [Teacher]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Recommended Rail": properties.recommendedRail,
          "Recommended Rail Name": properties.recommendedRailName,
          "Recommended Rail Rank": properties.recommendedRailRank,
          "Page Name": properties.pageName,
          "From": properties.from,
          "Screen Height": sysScreenHeight,
          }, "eUt7qBVlEi", "fcadafaf31e1ae06e097b8e1ed44508fdcec1236bbe3e415372371486d10831b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Completed Book Dashboard Scroll [Teacher]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Recommended Rail": properties.recommendedRail,
      "Recommended Rail Name": properties.recommendedRailName,
      "Recommended Rail Rank": properties.recommendedRailRank,
      "Page Name": properties.pageName,
      "From": properties.from,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Booking Confirmation Popup: This popup comes after the user clicks on Book Now on a particular class card
   * 
   * When to trigger this event:
   * 1. This popup comes after the user clicks on Book Now on a particular class card
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/lf3gSJVGxw/trigger/3dejV6cRV
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/lf3gSJVGxw}
   */
  function viewedBookingConfirmationPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Booking Confirmation Popup", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "elaGrade",
        "mathGrade",
        "grade",
        "mode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "lf3gSJVGxw", "05091b0e1750214287d83fb1c6401153e42c4dca039da6c71dde26ae1a97d54e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Booking Confirmation Popup", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Grade": properties.grade,
        "Mode": properties.mode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("lf3gSJVGxw", "Viewed Booking Confirmation Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Booking Confirmation Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Booking Confirmation Popup", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Grade": properties.grade,
          "Mode": properties.mode,
          "Screen Height": sysScreenHeight,
          }, "lf3gSJVGxw", "05091b0e1750214287d83fb1c6401153e42c4dca039da6c71dde26ae1a97d54e");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Booking Confirmation Popup", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Grade": properties.grade,
      "Mode": properties.mode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Booking Confirmation Popup: This event will be triggered when a user clicks on the booking confirmation popup
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/TfVQIu_zon/trigger/sdyJGsR7g
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/TfVQIu_zon}
   */
  function interactedBookingConfirmationPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Booking Confirmation Popup", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "grade",
        "elaGrade",
        "mathGrade",
        "mode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "TfVQIu_zon", "cfe21a21e77119a1d6039af686e76d9287830cd259c0ecf909d05df25d9efb73", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Booking Confirmation Popup", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("TfVQIu_zon", "Interacted Booking Confirmation Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Booking Confirmation Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Booking Confirmation Popup", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Screen Height": sysScreenHeight,
          }, "TfVQIu_zon", "cfe21a21e77119a1d6039af686e76d9287830cd259c0ecf909d05df25d9efb73");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Booking Confirmation Popup", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Class Details Popup: This event triggers when the class detail popup opens after clicking on the class card
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/UOogF1p2-K/trigger/ejyl0a4Bi
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/UOogF1p2-K}
   */
  function viewedClassDetailsPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Class Details Popup", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "elaGrade",
        "grade",
        "mathGrade",
        "mode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "UOogF1p2-K", "c7fde5c12c5355f50a25965a1aa8c20a215652e84138b6b66272cbcaef8226b2", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Class Details Popup", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("UOogF1p2-K", "Viewed Class Details Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Class Details Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Class Details Popup", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Screen Height": sysScreenHeight,
          }, "UOogF1p2-K", "c7fde5c12c5355f50a25965a1aa8c20a215652e84138b6b66272cbcaef8226b2");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Class Details Popup", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Class Details Popup: This event is triggered when the user interacts with the class details popup
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/f0C5apCqKE/trigger/KBk-QA-k_
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/f0C5apCqKE}
   */
  function interactedClassDetailsPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Class Details Popup", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "elaGrade",
        "grade",
        "mathGrade",
        "mode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "f0C5apCqKE", "e82c185e150cb5b5994ef8146f1fa2a530f44d2b9f0fae47677570b64ddf87d5", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Class Details Popup", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("f0C5apCqKE", "Interacted Class Details Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Class Details Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Class Details Popup", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Screen Height": sysScreenHeight,
          }, "f0C5apCqKE", "e82c185e150cb5b5994ef8146f1fa2a530f44d2b9f0fae47677570b64ddf87d5");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Class Details Popup", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Daily Bundle Rail: When user lands on the dashboard and views daily bundle rail, will not get fired if the daily bundle rail is turned off by the user.
   * 
   * When to trigger this event:
   * 1. When user lands on the dashboard, along with viewed tiled dashboard for home page, it will be fired, only if Daily Bundle Rail is active
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/z4gcZim-V/trigger/1WqblK3PP
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.activeLpSubjects - This property stores the active subjects in LP

Math, English, Both

It is only sent on Tab Code = Home
   * @param {int} properties.railPosition - This property stores the position of the daily bundle rail, if it is at number 1 or 2.
   * @param {string} properties.railState - This property stores if the rail is in default state or expanded state or no state i.e. none (d0 trialing users with coq = no)
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/z4gcZim-V}
   */
  function viewedDailyBundleRail(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertActiveLpSubjects(properties.activeLpSubjects));
      messages = messages.concat(assertRailPosition(properties.railPosition));
      messages = messages.concat(assertRailState(properties.railState));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Daily Bundle Rail", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "activeLpSubjects",
        "railPosition",
        "railState",
        "elaGrade",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "z4gcZim-V", "cefb60823c0a85b91ef4a63d02b34c6f58803461fa987f510b7bd8cb1ab947b3", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Daily Bundle Rail", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Active Lp Subjects": properties.activeLpSubjects,
        "Rail Position": properties.railPosition,
        "Rail State": properties.railState,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("z4gcZim-V", "Viewed Daily Bundle Rail", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "8kx_PUpkb", name: "Rail Position", value: properties.railPosition},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "_fnvZDP5s", name: "Active Lp Subjects", value: properties.activeLpSubjects},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "yPuqeki21", name: "Rail State", value: properties.railState},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Daily Bundle Rail': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Daily Bundle Rail", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Active Lp Subjects": properties.activeLpSubjects,
          "Rail Position": properties.railPosition,
          "Rail State": properties.railState,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "z4gcZim-V", "cefb60823c0a85b91ef4a63d02b34c6f58803461fa987f510b7bd8cb1ab947b3");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Daily Bundle Rail", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Active Lp Subjects": properties.activeLpSubjects,
      "Rail Position": properties.railPosition,
      "Rail State": properties.railState,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Daily Bundle Rail: This event is fired for interactions with the daily bundle rail
   * 
   * When to trigger this event:
   * 1. As soon as user interacts with the daily bundle rail
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/RdQptjJ95-/trigger/oTClXPqMX
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/RdQptjJ95-}
   */
  function interactedDailyBundleRail(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Daily Bundle Rail", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "clickedOn",
        "elaGrade",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "RdQptjJ95-", "37d854074e6295e01d97bce7996a69a84370963cbd0fc82b3054ce77bf42a20d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Daily Bundle Rail", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Clicked On": properties.clickedOn,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("RdQptjJ95-", "Interacted Daily Bundle Rail", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Daily Bundle Rail': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Daily Bundle Rail", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Clicked On": properties.clickedOn,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "RdQptjJ95-", "37d854074e6295e01d97bce7996a69a84370963cbd0fc82b3054ce77bf42a20d");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Daily Bundle Rail", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Clicked On": properties.clickedOn,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Book Assigned: Whenever a book is assigned by a teacher
   * 
   * When to trigger this event:
   * 1. when user clicks on the 'assign' cta
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Az4yfwxkKx/trigger/-RRcgETxi
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.playableCode - Pass the 'Playable Code' of the Playable being started/clicked
   * @param {string} properties.playableName - Name of playable selected
   * @param {Array<string>} [properties.recommendedRailName] - This is the name of the rail viewed by the user. 
Recommended rail property comes with rail name and rail rank, pipe separated - with the introduction of this property, we intend to separate rail name to calculate CTR on Mixpanel.
   * @param {Array<int>} [properties.recommendedTileRank] - This property will store the position of the tile on which user has clciked. Earlier this was sent as column position

   * @param {string} properties.pageName - Includes the name of the page (Eg: Playzone game listing page, ). This is not the URL but a easily understandable definition of what page is the user at.
   * @param {int} properties.studentsAssignedTo - This will capture the no. of students to whom the assignment is assigned.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Az4yfwxkKx}
   */
  function bookAssigned(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlayableCode(properties.playableCode));
      messages = messages.concat(assertPlayableName(properties.playableName));
      messages = messages.concat(assertOptionalRecommendedRailName(properties.recommendedRailName));
      messages = messages.concat(assertOptionalRecommendedTileRank(properties.recommendedTileRank));
      messages = messages.concat(assertPageName(properties.pageName));
      messages = messages.concat(assertStudentsAssignedTo(properties.studentsAssignedTo));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Book Assigned", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "playableCode",
        "playableName",
        "recommendedRailName",
        "recommendedTileRank",
        "pageName",
        "studentsAssignedTo"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Az4yfwxkKx", "bc69ddb317493d9e0bfde3082a0815f11277d0b3f29a1c51c03734227ac4367d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Book Assigned", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Playable Code": properties.playableCode,
        "Playable Name": properties.playableName,
        "Recommended Rail Name": properties.recommendedRailName,
        "Recommended Tile Rank": properties.recommendedTileRank,
        "Page Name": properties.pageName,
        "Students Assigned To": properties.studentsAssignedTo,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Az4yfwxkKx", "Book Assigned", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "6lrsWYY5Y", name: "Recommended Rail Name", value: properties.recommendedRailName},
        {id: "FLDtSJNKL", name: "Recommended Tile Rank", value: properties.recommendedTileRank},
        {id: "MJKSzmqfHu", name: "Page Name", value: properties.pageName},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "QjCwFasvW0", name: "Playable Code", value: properties.playableCode},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "c2W4X05Jy", name: "Playable Name", value: properties.playableName},
        {id: "mvOIacTNl", name: "Students Assigned To", value: properties.studentsAssignedTo},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Book Assigned': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Book Assigned", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Playable Code": properties.playableCode,
          "Playable Name": properties.playableName,
          "Recommended Rail Name": properties.recommendedRailName,
          "Recommended Tile Rank": properties.recommendedTileRank,
          "Page Name": properties.pageName,
          "Students Assigned To": properties.studentsAssignedTo,
          "Screen Height": sysScreenHeight,
          }, "Az4yfwxkKx", "bc69ddb317493d9e0bfde3082a0815f11277d0b3f29a1c51c03734227ac4367d");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Book Assigned", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Playable Code": properties.playableCode,
      "Playable Name": properties.playableName,
      "Recommended Rail Name": properties.recommendedRailName,
      "Recommended Tile Rank": properties.recommendedTileRank,
      "Page Name": properties.pageName,
      "Students Assigned To": properties.studentsAssignedTo,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Book Library Reading Log: when a user lands on a reading log page
   * 
   * When to trigger this event:
   * 1. When a user lands on this page
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ODmQ9pFmQf/trigger/VuyhPAxrD
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {int} properties.numberOfResults - Number of results shown for search results
   * @param {int} properties.daysSinceClassCreation - Self explanatory
   * @param {string} properties.source - Click source
   * @param {string} properties.weeksSinceLatestReportingWeek - Difference in first date of current week  - first date of selected week
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ODmQ9pFmQf}
   */
  function viewedBookLibraryReadingLog(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertNumberOfResults(properties.numberOfResults));
      messages = messages.concat(assertDaysSinceClassCreation(properties.daysSinceClassCreation));
      messages = messages.concat(assertSource(properties.source));
      messages = messages.concat(assertWeeksSinceLatestReportingWeek(properties.weeksSinceLatestReportingWeek));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Book Library Reading Log", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "numberOfResults",
        "daysSinceClassCreation",
        "source",
        "weeksSinceLatestReportingWeek"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ODmQ9pFmQf", "66b901e631cc2fc6b43c7b086e281434aba71d70f336f02a568fa50c1c9edf0e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Book Library Reading Log", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Number of Results": properties.numberOfResults,
        "Days Since Class Creation": properties.daysSinceClassCreation,
        "Source": properties.source,
        "Weeks Since Latest Reporting Week": properties.weeksSinceLatestReportingWeek,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ODmQ9pFmQf", "Viewed Book Library Reading Log", messages, [
        {id: "293juZE8KT", name: "Source", value: properties.source},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "AdKRXxQJd", name: "Weeks Since Latest Reporting Week", value: properties.weeksSinceLatestReportingWeek},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "TuspgTIuZ1", name: "Days Since Class Creation", value: properties.daysSinceClassCreation},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "UtPMQu4JE", name: "Number of Results", value: properties.numberOfResults},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Book Library Reading Log': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Book Library Reading Log", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Number of Results": properties.numberOfResults,
          "Days Since Class Creation": properties.daysSinceClassCreation,
          "Source": properties.source,
          "Weeks Since Latest Reporting Week": properties.weeksSinceLatestReportingWeek,
          "Screen Height": sysScreenHeight,
          }, "ODmQ9pFmQf", "66b901e631cc2fc6b43c7b086e281434aba71d70f336f02a568fa50c1c9edf0e");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Book Library Reading Log", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Number of Results": properties.numberOfResults,
      "Days Since Class Creation": properties.daysSinceClassCreation,
      "Click Source": properties.source,
      "Weeks Since Latest Reporting Week": properties.weeksSinceLatestReportingWeek,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Book Library Reading Log: Whenever a user click/taps on any clickable elements within a reading log page
   * 
   * When to trigger this event:
   * 1. when user clicks on the any of the clickable elements on this page
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/sLvkfK0nE3/trigger/OcHjMDryw
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.fromDate - Start date of the week mentioned
   * @param {int} properties.daysSinceClassCreation - Self explanatory
   * @param {string} properties.weeksSinceLatestReportingWeek - Difference in first date of current week  - first date of selected week
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/sLvkfK0nE3}
   */
  function interactedBookLibraryReadingLog(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertFromDate(properties.fromDate));
      messages = messages.concat(assertDaysSinceClassCreation(properties.daysSinceClassCreation));
      messages = messages.concat(assertWeeksSinceLatestReportingWeek(properties.weeksSinceLatestReportingWeek));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Book Library Reading Log", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "fromDate",
        "daysSinceClassCreation",
        "weeksSinceLatestReportingWeek"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "sLvkfK0nE3", "60e5dfdc5948d497cb3641ed6f3a39f5185935e0463fd2cabfcb9896360feb67", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Book Library Reading Log", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "From Date": properties.fromDate,
        "Days Since Class Creation": properties.daysSinceClassCreation,
        "Weeks Since Latest Reporting Week": properties.weeksSinceLatestReportingWeek,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("sLvkfK0nE3", "Interacted Book Library Reading Log", messages, [
        {id: "0U9QBn95C", name: "From Date", value: properties.fromDate},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "AdKRXxQJd", name: "Weeks Since Latest Reporting Week", value: properties.weeksSinceLatestReportingWeek},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "TuspgTIuZ1", name: "Days Since Class Creation", value: properties.daysSinceClassCreation},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Book Library Reading Log': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Book Library Reading Log", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "From Date": properties.fromDate,
          "Days Since Class Creation": properties.daysSinceClassCreation,
          "Weeks Since Latest Reporting Week": properties.weeksSinceLatestReportingWeek,
          "Screen Height": sysScreenHeight,
          }, "sLvkfK0nE3", "60e5dfdc5948d497cb3641ed6f3a39f5185935e0463fd2cabfcb9896360feb67");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Book Library Reading Log", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "From Date": properties.fromDate,
      "Days Since Class Creation": properties.daysSinceClassCreation,
      "Weeks Since Latest Reporting Week": properties.weeksSinceLatestReportingWeek,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Book Library Student Report: When user lands on student report page
   * 
   * When to trigger this event:
   * 1. When user lands on this page
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/V-eQjP9T7F/trigger/rSOs60ENt
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {int} properties.numberOfResults - Number of results shown for search results
   * @param {int} properties.daysSinceClassCreation - Self explanatory
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/V-eQjP9T7F}
   */
  function viewedBookLibraryStudentReport(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertNumberOfResults(properties.numberOfResults));
      messages = messages.concat(assertDaysSinceClassCreation(properties.daysSinceClassCreation));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Book Library Student Report", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "numberOfResults",
        "daysSinceClassCreation"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "V-eQjP9T7F", "9e3886eee087b32bb2ad813ce85aba3914b262fe72d0c5f981c1dafc93b7f4e5", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Book Library Student Report", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Number of Results": properties.numberOfResults,
        "Days Since Class Creation": properties.daysSinceClassCreation,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("V-eQjP9T7F", "Viewed Book Library Student Report", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "TuspgTIuZ1", name: "Days Since Class Creation", value: properties.daysSinceClassCreation},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "UtPMQu4JE", name: "Number of Results", value: properties.numberOfResults},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Book Library Student Report': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Book Library Student Report", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Number of Results": properties.numberOfResults,
          "Days Since Class Creation": properties.daysSinceClassCreation,
          "Screen Height": sysScreenHeight,
          }, "V-eQjP9T7F", "9e3886eee087b32bb2ad813ce85aba3914b262fe72d0c5f981c1dafc93b7f4e5");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Book Library Student Report", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Number of Results": properties.numberOfResults,
      "Days Since Class Creation": properties.daysSinceClassCreation,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Book Library Student Report: Whenever a user click/taps on any clickable elements within student report page
   * 
   * When to trigger this event:
   * 1. when user clicks on any of the clickable elements on this page
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/c1ujM6kFq1/trigger/RMtLYhWXo
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} [properties.fromDate] - Start date of the week mentioned
   * @param {int} properties.daysSinceClassCreation - Self explanatory
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/c1ujM6kFq1}
   */
  function interactedBookLibraryStudentReport(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertOptionalFromDate(properties.fromDate));
      messages = messages.concat(assertDaysSinceClassCreation(properties.daysSinceClassCreation));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Book Library Student Report", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "clickedOn",
        "fromDate",
        "daysSinceClassCreation"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "c1ujM6kFq1", "3f737694996746b0ef2aaea2b37048c72bb5ed965cbe299053126a13acfd8786", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Book Library Student Report", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Clicked On": properties.clickedOn,
        "From Date": properties.fromDate,
        "Days Since Class Creation": properties.daysSinceClassCreation,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("c1ujM6kFq1", "Interacted Book Library Student Report", messages, [
        {id: "0U9QBn95C", name: "From Date", value: properties.fromDate},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "TuspgTIuZ1", name: "Days Since Class Creation", value: properties.daysSinceClassCreation},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Book Library Student Report': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Book Library Student Report", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Clicked On": properties.clickedOn,
          "From Date": properties.fromDate,
          "Days Since Class Creation": properties.daysSinceClassCreation,
          "Screen Height": sysScreenHeight,
          }, "c1ujM6kFq1", "3f737694996746b0ef2aaea2b37048c72bb5ed965cbe299053126a13acfd8786");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Book Library Student Report", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Clicked On": properties.clickedOn,
      "From Date": properties.fromDate,
      "Days Since Class Creation": properties.daysSinceClassCreation,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Book Library Assignment Report: When a user lands on the assignment report page pf book library
   * 
   * When to trigger this event:
   * 1. when user lands on this page
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/H2PbWM0vI9/trigger/3Cyr9ZYk-
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {int} properties.numberOfResults - Number of results shown for search results
   * @param {int} properties.daysSinceClassCreation - Self explanatory
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/H2PbWM0vI9}
   */
  function viewedBookLibraryAssignmentReport(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertNumberOfResults(properties.numberOfResults));
      messages = messages.concat(assertDaysSinceClassCreation(properties.daysSinceClassCreation));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Book Library Assignment Report", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "numberOfResults",
        "daysSinceClassCreation",
        "fromPage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "H2PbWM0vI9", "fca38a4d0f5b3fe5273b6ab81d6730f82912f9426b619a32a1b9ee6be44f6ee6", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Book Library Assignment Report", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Number of Results": properties.numberOfResults,
        "Days Since Class Creation": properties.daysSinceClassCreation,
        "From Page": properties.fromPage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("H2PbWM0vI9", "Viewed Book Library Assignment Report", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "TuspgTIuZ1", name: "Days Since Class Creation", value: properties.daysSinceClassCreation},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "UtPMQu4JE", name: "Number of Results", value: properties.numberOfResults},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Book Library Assignment Report': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Book Library Assignment Report", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Number of Results": properties.numberOfResults,
          "Days Since Class Creation": properties.daysSinceClassCreation,
          "From Page": properties.fromPage,
          "Screen Height": sysScreenHeight,
          }, "H2PbWM0vI9", "fca38a4d0f5b3fe5273b6ab81d6730f82912f9426b619a32a1b9ee6be44f6ee6");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Book Library Assignment Report", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Number of Results": properties.numberOfResults,
      "Days Since Class Creation": properties.daysSinceClassCreation,
      "From Page": properties.fromPage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Book Library Assignment Report: When a user clicks on any of the actions provided on the assignment report screen
   * 
   * When to trigger this event:
   * 1. Click on any of the clickable elements
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/-MzsMKrz_X/trigger/xWvkT18O5
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} [properties.assignmentName] - title of the assignment card - could be books or collections
   * @param {int} properties.daysSinceClassCreation - Self explanatory
   * @param {string} [properties.cardStatus] - Assignment card status. - open, finished etc 
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.assignmentType - This will capture the type of assignment - Manual or Auto
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/-MzsMKrz_X}
   */
  function interactedBookLibraryAssignmentReport(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertOptionalAssignmentName(properties.assignmentName));
      messages = messages.concat(assertDaysSinceClassCreation(properties.daysSinceClassCreation));
      messages = messages.concat(assertOptionalCardStatus(properties.cardStatus));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertAssignmentType(properties.assignmentType));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Book Library Assignment Report", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "assignmentName",
        "daysSinceClassCreation",
        "cardStatus",
        "clickedOn",
        "assignmentType"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "-MzsMKrz_X", "e93096d77d60d6f466c6cf81641e89bf53240d940771720e47a4889cf2f61833", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Book Library Assignment Report", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Assignment Name": properties.assignmentName,
        "Days Since Class Creation": properties.daysSinceClassCreation,
        "Card Status": properties.cardStatus,
        "Clicked On": properties.clickedOn,
        "Assignment Type": properties.assignmentType,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("-MzsMKrz_X", "Interacted Book Library Assignment Report", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "9q8Cz_SQv", name: "Card Status", value: properties.cardStatus},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "TuspgTIuZ1", name: "Days Since Class Creation", value: properties.daysSinceClassCreation},
        {id: "Ueowl7sRb", name: "Assignment Type", value: properties.assignmentType},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "a1f6ssVyg", name: "Assignment Name", value: properties.assignmentName},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Book Library Assignment Report': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Book Library Assignment Report", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Assignment Name": properties.assignmentName,
          "Days Since Class Creation": properties.daysSinceClassCreation,
          "Card Status": properties.cardStatus,
          "Clicked On": properties.clickedOn,
          "Assignment Type": properties.assignmentType,
          "Screen Height": sysScreenHeight,
          }, "-MzsMKrz_X", "e93096d77d60d6f466c6cf81641e89bf53240d940771720e47a4889cf2f61833");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Book Library Assignment Report", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Assignment Name": properties.assignmentName,
      "Days Since Class Creation": properties.daysSinceClassCreation,
      "Card Status": properties.cardStatus,
      "Clicked On": properties.clickedOn,
      "Assignment Type": properties.assignmentType,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Book Library Assignment Card: when a user lands on assignment card details page in book library
   * 
   * When to trigger this event:
   * 1. When user lands on this page
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/9jK5_9bObq/trigger/ByTSN_av9
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {int} properties.numberOfResults - Number of results shown for search results
   * @param {int} properties.daysSinceClassCreation - Self explanatory
   * @param {string} properties.assignmentType - This will capture the type of assignment - Manual or Auto
   * @param {string} properties.bookName - Self Explanatory
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/9jK5_9bObq}
   */
  function viewedBookLibraryAssignmentCard(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertNumberOfResults(properties.numberOfResults));
      messages = messages.concat(assertDaysSinceClassCreation(properties.daysSinceClassCreation));
      messages = messages.concat(assertAssignmentType(properties.assignmentType));
      messages = messages.concat(assertBookName(properties.bookName));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Book Library Assignment Card", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "numberOfResults",
        "daysSinceClassCreation",
        "assignmentType",
        "bookName"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "9jK5_9bObq", "78a509fdb1bdb24d1cad53616ad9087ca6ae7c520f2af52eb512c14edf189e02", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Book Library Assignment Card", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Number of Results": properties.numberOfResults,
        "Days Since Class Creation": properties.daysSinceClassCreation,
        "Assignment Type": properties.assignmentType,
        "Book Name": properties.bookName,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("9jK5_9bObq", "Viewed Book Library Assignment Card", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "TuspgTIuZ1", name: "Days Since Class Creation", value: properties.daysSinceClassCreation},
        {id: "UPVjvJlbS", name: "Book Name", value: properties.bookName},
        {id: "Ueowl7sRb", name: "Assignment Type", value: properties.assignmentType},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "UtPMQu4JE", name: "Number of Results", value: properties.numberOfResults},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Book Library Assignment Card': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Book Library Assignment Card", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Number of Results": properties.numberOfResults,
          "Days Since Class Creation": properties.daysSinceClassCreation,
          "Assignment Type": properties.assignmentType,
          "Book Name": properties.bookName,
          "Screen Height": sysScreenHeight,
          }, "9jK5_9bObq", "78a509fdb1bdb24d1cad53616ad9087ca6ae7c520f2af52eb512c14edf189e02");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Book Library Assignment Card", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Number of Results": properties.numberOfResults,
      "Days Since Class Creation": properties.daysSinceClassCreation,
      "Assignment Type": properties.assignmentType,
      "Book Name": properties.bookName,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Book Library Assignment Card: Whenever a user click/taps on any clickable elements within a assignment card
   * 
   * When to trigger this event:
   * 1. when user clicks on any of the clickable elements on this page
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/_kGdnbBf-l/trigger/h1PZrJqDK
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/_kGdnbBf-l}
   */
  function interactedBookLibraryAssignmentCard(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Book Library Assignment Card", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "_kGdnbBf-l", "efd3d28195354ccb90a4535ffb254d2c350d30aee1effea7754eed7723119e3a", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Book Library Assignment Card", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("_kGdnbBf-l", "Interacted Book Library Assignment Card", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Book Library Assignment Card': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Book Library Assignment Card", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "_kGdnbBf-l", "efd3d28195354ccb90a4535ffb254d2c350d30aee1effea7754eed7723119e3a");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Book Library Assignment Card", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Visited YOB [B2B]: This event is fired when teacher signs up via Google or Clever.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/i926iEQALn/trigger/ynIZgDlrN
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/i926iEQALn}
   */
  function visitedYobB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Visited YOB [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "i926iEQALn", "52b27ad4c00fd0b5d880a8a6b12668e272901a85a53d5eb5e04c851a9ac95735", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Visited YOB [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("i926iEQALn", "Visited YOB [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Visited YOB [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Visited YOB [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "i926iEQALn", "52b27ad4c00fd0b5d880a8a6b12668e272901a85a53d5eb5e04c851a9ac95735");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Visited YOB [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Privacy Notice: This event is fired when user signs up via Google or Clever
   * 
   * When to trigger this event:
   * 1. When user clicks on the 'Continue' button
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/4620Z_xXBT/trigger/fQ2_DEN7I
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/4620Z_xXBT}
   */
  function interactedPrivacyNotice(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Privacy Notice", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "4620Z_xXBT", "27449eb96329a511d2dec7bc2cba9f8dbe1519270157587a9126ddd01b8c39a7", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Privacy Notice", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("4620Z_xXBT", "Interacted Privacy Notice", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Privacy Notice': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Privacy Notice", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "4620Z_xXBT", "27449eb96329a511d2dec7bc2cba9f8dbe1519270157587a9126ddd01b8c39a7");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Privacy Notice", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Visited Teacher Onboarding Question [B2B]: This event is fired when user is displayed any of the onboarding question
   * 
   * When to trigger this event:
   * 1. Event should be fired on page load of every onboarding question
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/X9hKOV92Sm/trigger/f6RJtOoR-
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.question - This will capture the Question in full. For example, 'How big is your class?'
   * @param {string} properties.questionType - This will capture the type of question such as multi-select, single-select etc.
   * @param {string} [properties.questionNo] - This will capture the Question Serial no. as it appears in sequence
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/X9hKOV92Sm}
   */
  function visitedTeacherOnboardingQuestionB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertQuestion(properties.question));
      messages = messages.concat(assertQuestionType(properties.questionType));
      messages = messages.concat(assertOptionalQuestionNo(properties.questionNo));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Visited Teacher Onboarding Question [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "question",
        "questionType",
        "questionNo"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "X9hKOV92Sm", "7b52006a3e559862f6f46f4c74d9e929374f8d84970c97fa1a87fe9080f6ba4a", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Visited Teacher Onboarding Question [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Question": properties.question,
        "Question Type": properties.questionType,
        "Question No.": properties.questionNo,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("X9hKOV92Sm", "Visited Teacher Onboarding Question [B2B]", messages, [
        {id: "1BxvMk6Nz6", name: "Question No.", value: properties.questionNo},
        {id: "2pLBcf4Iyi", name: "Question Type", value: properties.questionType},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "EsalTilTi7", name: "Question", value: properties.question},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Visited Teacher Onboarding Question [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Visited Teacher Onboarding Question [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Question": properties.question,
          "Question Type": properties.questionType,
          "Question No.": properties.questionNo,
          "Screen Height": sysScreenHeight,
          }, "X9hKOV92Sm", "7b52006a3e559862f6f46f4c74d9e929374f8d84970c97fa1a87fe9080f6ba4a");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Visited Teacher Onboarding Question [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Question": properties.question,
      "Question Type": properties.questionType,
      "Question No.": properties.questionNo,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Visited Onboarding End Loadthrough [B2B]: This event will be fired when user is displayed the "You are almost ready" screen after user has answered the last onboarding question
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ZQy2a9B8r/trigger/xWa7eUL-F
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ZQy2a9B8r}
   */
  function visitedOnboardingEndLoadthroughB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Visited Onboarding End Loadthrough [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ZQy2a9B8r", "29d502264c207b923db0225f7f8660661b6e249690659a9ead72c4340aa9a619", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Visited Onboarding End Loadthrough [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ZQy2a9B8r", "Visited Onboarding End Loadthrough [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Visited Onboarding End Loadthrough [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Visited Onboarding End Loadthrough [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "ZQy2a9B8r", "29d502264c207b923db0225f7f8660661b6e249690659a9ead72c4340aa9a619");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Visited Onboarding End Loadthrough [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Add Students Page [B2B]: This event will capture below interactions on the student addition page

1. When user uses CSV to upload students
2. CSV upload status
3. Student names input box interactions - uploaded student names from csv, copy pasted student names, typed student names
4. Clicked on add students and other CTAs
   * 
   * When to trigger this event:
   * 1. When user interacts with this page
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/WcXx7xQQ0-/trigger/Gt2oYp0Ps
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} [properties.interactionDetails] - Stores where is the user interacting with the page
   * @param {string} [properties.csvUploadStatus] - This property describes status of csv upload when teacher adds student details via csv/excel template
   * @param {string} [properties.percentClassInvited] - This will capture the (percentage of invited students in that class/total students in that class)
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/WcXx7xQQ0-}
   */
  function interactedAddStudentsPageB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertOptionalInteractionDetails(properties.interactionDetails));
      messages = messages.concat(assertOptionalCSVUploadStatus(properties.csvUploadStatus));
      messages = messages.concat(assertOptionalPercentClassInvited(properties.percentClassInvited));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Add Students Page [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "interactionDetails",
        "csvUploadStatus",
        "percentClassInvited"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "WcXx7xQQ0-", "762e012f3552b2b20d069d2de503850a1c77f085d2cbfaf876c4030009460bfa", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Add Students Page [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Interaction Details": properties.interactionDetails,
        "CSV Upload Status": properties.csvUploadStatus,
        "Percent Class Invited": properties.percentClassInvited,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("WcXx7xQQ0-", "Interacted Add Students Page [B2B]", messages, [
        {id: "2Q7hpPm9y", name: "Percent Class Invited", value: properties.percentClassInvited},
        {id: "35LO2FVxA", name: "CSV Upload Status", value: properties.csvUploadStatus},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "ncdYto9gZ", name: "Interaction Details", value: properties.interactionDetails},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Add Students Page [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Add Students Page [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Interaction Details": properties.interactionDetails,
          "CSV Upload Status": properties.csvUploadStatus,
          "Percent Class Invited": properties.percentClassInvited,
          "Screen Height": sysScreenHeight,
          }, "WcXx7xQQ0-", "762e012f3552b2b20d069d2de503850a1c77f085d2cbfaf876c4030009460bfa");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Add Students Page [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Interaction Details": properties.interactionDetails,
      "CSV Upload Status": properties.csvUploadStatus,
      "Percent Class Invited": properties.percentClassInvited,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Visited OTP Screen: This event is fired in the teacher signup flow when user lands on the OTP screen after email signup
   * 
   * When to trigger this event:
   * 1. On page load
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ZG814ao6GH/trigger/J5tcnxeJW
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ZG814ao6GH}
   */
  function visitedOtpScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Visited OTP Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ZG814ao6GH", "a26474cbaeedad8072dcbe888ac5ed43fc7940740cc87eac8ae0f298d47a2b14", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Visited OTP Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ZG814ao6GH", "Visited OTP Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Visited OTP Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Visited OTP Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Screen Height": sysScreenHeight,
          }, "ZG814ao6GH", "a26474cbaeedad8072dcbe888ac5ed43fc7940740cc87eac8ae0f298d47a2b14");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Visited OTP Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Clicked Students Created: This event will fire when user adds students from add students page
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/hoysUf43ec/trigger/OEUe8_f20
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {int} properties.studentsAddedCount - This property counts the number of students added at a time in the class
   * @param {string} properties.percentClassInvited - This will capture the (percentage of invited students in that class/total students in that class)
   * @param {int} properties.emailCount - This returns the count of parent emails added during student addition
   * @param {int} properties.daysSinceClassCreation - Self explanatory
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/hoysUf43ec}
   */
  function clickedStudentsCreated(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertStudentsAddedCount(properties.studentsAddedCount));
      messages = messages.concat(assertPercentClassInvited(properties.percentClassInvited));
      messages = messages.concat(assertEmailCount(properties.emailCount));
      messages = messages.concat(assertDaysSinceClassCreation(properties.daysSinceClassCreation));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Clicked Students Created", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "studentsAddedCount",
        "percentClassInvited",
        "emailCount",
        "daysSinceClassCreation"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "hoysUf43ec", "c66d3d8d33a0fa6b2a6509772ee7306b92b84fc64156e5a15409363e1dbba76a", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Clicked Students Created", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Students Added Count": properties.studentsAddedCount,
        "Percent Class Invited": properties.percentClassInvited,
        "Email Count": properties.emailCount,
        "Days Since Class Creation": properties.daysSinceClassCreation,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("hoysUf43ec", "Clicked Students Created", messages, [
        {id: "2Q7hpPm9y", name: "Percent Class Invited", value: properties.percentClassInvited},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "TuspgTIuZ1", name: "Days Since Class Creation", value: properties.daysSinceClassCreation},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qw-3rdTO7", name: "Email Count", value: properties.emailCount},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "zE5EQnQZc", name: "Students Added Count", value: properties.studentsAddedCount},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Clicked Students Created': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Clicked Students Created", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Students Added Count": properties.studentsAddedCount,
          "Percent Class Invited": properties.percentClassInvited,
          "Email Count": properties.emailCount,
          "Days Since Class Creation": properties.daysSinceClassCreation,
          "Screen Height": sysScreenHeight,
          }, "hoysUf43ec", "c66d3d8d33a0fa6b2a6509772ee7306b92b84fc64156e5a15409363e1dbba76a");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Clicked Students Created", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Students Added Count": properties.studentsAddedCount,
      "Percent Class Invited": properties.percentClassInvited,
      "Email Count": properties.emailCount,
      "Days Since Class Creation": properties.daysSinceClassCreation,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Google Classroom/Clever Class Import Unsuccessful [B2B]: This is a logging event that will trigger when GC/Clever class is not imported successfully
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.classType - This Property will capture the type of class - Google Classroom or Clever or Manual
   * @param {string} properties.reasonForImportUnsuccessful - Describes the reason for import unsuccessful of Clever/Google Classroom
   * @param {string} properties.apiUrl - The API which was called for this event
   * @param {string} properties.apiStatus - API status
   * @param {string} properties.apiSource - This property returns if API is called from BE or FE
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/L1hFOPxHXs}
   */
  function googleClassroomcleverClassImportUnsuccessfulB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClassType(properties.classType));
      messages = messages.concat(assertReasonForImportUnsuccessful(properties.reasonForImportUnsuccessful));
      messages = messages.concat(assertAPIUrl(properties.apiUrl));
      messages = messages.concat(assertAPIStatus(properties.apiStatus));
      messages = messages.concat(assertAPISource(properties.apiSource));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Google Classroom/Clever Class Import Unsuccessful [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "classType",
        "reasonForImportUnsuccessful",
        "apiUrl",
        "apiStatus",
        "apiSource"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "L1hFOPxHXs", "75c3d8ad7a8133d4d5aad631b76aeb0fe33140f89e1601a7cd35dfef733d5a89", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Google Classroom/Clever Class Import Unsuccessful [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Class Type": properties.classType,
        "Reason for Import Unsuccessful": properties.reasonForImportUnsuccessful,
        "API Url": properties.apiUrl,
        "API Status": properties.apiStatus,
        "API Source": properties.apiSource,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("L1hFOPxHXs", "Google Classroom/Clever Class Import Unsuccessful [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "7e4uFkiW6", name: "API Status", value: properties.apiStatus},
        {id: "KgDSWGuTz", name: "API Source", value: properties.apiSource},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "bBX3FEBN-", name: "Reason for Import Unsuccessful", value: properties.reasonForImportUnsuccessful},
        {id: "dk2bhnFne", name: "Class Type", value: properties.classType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "u9ncLCjsR", name: "API Url", value: properties.apiUrl},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Google Classroom/Clever Class Import Unsuccessful [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Google Classroom/Clever Class Import Unsuccessful [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Class Type": properties.classType,
          "Reason for Import Unsuccessful": properties.reasonForImportUnsuccessful,
          "API Url": properties.apiUrl,
          "API Status": properties.apiStatus,
          "API Source": properties.apiSource,
          "Screen Height": sysScreenHeight,
          }, "L1hFOPxHXs", "75c3d8ad7a8133d4d5aad631b76aeb0fe33140f89e1601a7cd35dfef733d5a89");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Google Classroom/Clever Class Import Unsuccessful [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Class Type": properties.classType,
      "Reason for Import Unsuccessful": properties.reasonForImportUnsuccessful,
      "API Url": properties.apiUrl,
      "API Status": properties.apiStatus,
      "API Source": properties.apiSource,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted OTP Page: This event is fired when user interacts with the OTP page
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/uFRhwUsGu7/trigger/iOkm2uaJ9
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/uFRhwUsGu7}
   */
  function interactedOtpPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted OTP Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "uFRhwUsGu7", "afb103a6a0ce6e086a468df9acba3cf642916bfc3c2a34dc381f29f80286df92", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted OTP Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("uFRhwUsGu7", "Interacted OTP Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted OTP Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted OTP Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "uFRhwUsGu7", "afb103a6a0ce6e086a468df9acba3cf642916bfc3c2a34dc381f29f80286df92");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted OTP Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Privacy Notice: This event should be fired on the Privacy notice page load which comes after user signs up via Google or Clever
   * 
   * When to trigger this event:
   * 1. On page load
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/pEVvC6rhQt/trigger/GhUTsMJlS
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/pEVvC6rhQt}
   */
  function viewedPrivacyNotice(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Privacy Notice", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "pEVvC6rhQt", "bf58356f8ae5c9016d9acab19648ed502f82b3081ca4b2ab4dd11bec2a1ac541", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Privacy Notice", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("pEVvC6rhQt", "Viewed Privacy Notice", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Privacy Notice': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Privacy Notice", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "pEVvC6rhQt", "bf58356f8ae5c9016d9acab19648ed502f82b3081ca4b2ab4dd11bec2a1ac541");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Privacy Notice", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Provided YOB: This event will be fired when user submits his YOB on the provide YOB popup
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/oWK0oPqCEZ/trigger/095Klxj7T
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/oWK0oPqCEZ}
   */
  function providedYob(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Provided YOB", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "oWK0oPqCEZ", "b860a1e442610aa60ab81b7d477a46e6247e48926cd514538197265f6486e306", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Provided YOB", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("oWK0oPqCEZ", "Provided YOB", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Provided YOB': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Provided YOB", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "oWK0oPqCEZ", "b860a1e442610aa60ab81b7d477a46e6247e48926cd514538197265f6486e306");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Provided YOB", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Visited Teacher Welcome: This event is fired on school selection screen page load
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/CuCkxopcLt/trigger/n_Z8xFd4_
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.schoolFormType - This will report the type of school form (US/Non US) displayed to the user on landing on the page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/CuCkxopcLt}
   */
  function visitedTeacherWelcome(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertSchoolFormType(properties.schoolFormType));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Visited Teacher Welcome", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "schoolFormType"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "CuCkxopcLt", "e3ca5ca469bf938f733eac178e0025f35242ac329a82e4575fd21e1ca899e903", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Visited Teacher Welcome", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "School Form Type": properties.schoolFormType,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("CuCkxopcLt", "Visited Teacher Welcome", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "XVqfVlPwm", name: "School Form Type", value: properties.schoolFormType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Visited Teacher Welcome': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Visited Teacher Welcome", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "School Form Type": properties.schoolFormType,
          "Screen Height": sysScreenHeight,
          }, "CuCkxopcLt", "e3ca5ca469bf938f733eac178e0025f35242ac329a82e4575fd21e1ca899e903");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Visited Teacher Welcome", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "School Form Type": properties.schoolFormType,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Parent Dashboard: When a parent lands on parent dashboard
   * 
   * When to trigger this event:
   * 1. When a Parent lands on Parent Reporting Dashboard
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/QgmosmbMpz/trigger/DGazLEqxZ
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {int} properties.numberOfResults - Number of results shown for search results
   * @param {string} properties.daysSinceSignup - Days since parent or teacher signs up on the product
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/QgmosmbMpz}
   */
  function viewedParentDashboard(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertNumberOfResults(properties.numberOfResults));
      messages = messages.concat(assertDaysSinceSignup(properties.daysSinceSignup));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Parent Dashboard", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "numberOfResults",
        "daysSinceSignup"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "QgmosmbMpz", "526203c4e3477788a9e002273665ca3853c9ea4c3001804710f67a02ebc79993", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Parent Dashboard", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Number of Results": properties.numberOfResults,
        "Days Since Signup": properties.daysSinceSignup,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("QgmosmbMpz", "Viewed Parent Dashboard", messages, [
        {id: "UtPMQu4JE", name: "Number of Results", value: properties.numberOfResults},
        {id: "e4g1zZQCJ", name: "Days Since Signup", value: properties.daysSinceSignup},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Parent Dashboard': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Parent Dashboard", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Number of Results": properties.numberOfResults,
          "Days Since Signup": properties.daysSinceSignup,
          "Screen Height": sysScreenHeight,
          }, "QgmosmbMpz", "526203c4e3477788a9e002273665ca3853c9ea4c3001804710f67a02ebc79993");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Parent Dashboard", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Number of Results": properties.numberOfResults,
      "Days Since Signup": properties.daysSinceSignup,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Parent Dashboard: When use clicks on any clickable elements on Parent Dashboard
   * 
   * When to trigger this event:
   * 1. When user clicks on any of the of the clickable elements on this screen
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/7MPYSY8ARM/trigger/JnmWNox9G
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} [properties.clickedSpecificallyOn] - Specific value with in subject, topic, etc
   * @param {string} properties.daysSinceSignup - Days since parent or teacher signs up on the product
   * @param {string} properties.fromDate - Start date of the week mentioned
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/7MPYSY8ARM}
   */
  function interactedParentDashboard(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertOptionalClickedSpecificallyOn(properties.clickedSpecificallyOn));
      messages = messages.concat(assertDaysSinceSignup(properties.daysSinceSignup));
      messages = messages.concat(assertFromDate(properties.fromDate));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Parent Dashboard", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "clickedSpecificallyOn",
        "daysSinceSignup",
        "fromDate"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "7MPYSY8ARM", "f1dd3bb294ea9fa5d793f6f8bbb6a3c2c0dc2c92d2cda89ba8d97a40af33722a", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Parent Dashboard", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Clicked Specifically On": properties.clickedSpecificallyOn,
        "Days Since Signup": properties.daysSinceSignup,
        "From Date": properties.fromDate,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("7MPYSY8ARM", "Interacted Parent Dashboard", messages, [
        {id: "0U9QBn95C", name: "From Date", value: properties.fromDate},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "V61EIIAa1", name: "Clicked Specifically On", value: properties.clickedSpecificallyOn},
        {id: "e4g1zZQCJ", name: "Days Since Signup", value: properties.daysSinceSignup},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Parent Dashboard': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Parent Dashboard", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Clicked Specifically On": properties.clickedSpecificallyOn,
          "Days Since Signup": properties.daysSinceSignup,
          "From Date": properties.fromDate,
          "Screen Height": sysScreenHeight,
          }, "7MPYSY8ARM", "f1dd3bb294ea9fa5d793f6f8bbb6a3c2c0dc2c92d2cda89ba8d97a40af33722a");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Parent Dashboard", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Clicked Specifically On": properties.clickedSpecificallyOn,
      "Days Since Signup": properties.daysSinceSignup,
      "From Date": properties.fromDate,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Clicked on Book Assign: Appears when a teacher clicks on the Assign CTA
   * 
   * When to trigger this event:
   * 1. Click on the Assign CTA
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/I3PACTN3c9/trigger/1hExkiERo
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.playableCode - Pass the 'Playable Code' of the Playable being started/clicked
   * @param {string} properties.playableName - Name of playable selected
   * @param {Array<string>} properties.recommendedRailName - This is the name of the rail viewed by the user. 
Recommended rail property comes with rail name and rail rank, pipe separated - with the introduction of this property, we intend to separate rail name to calculate CTR on Mixpanel.
   * @param {Array<int>} [properties.recommendedTileRank] - This property will store the position of the tile on which user has clciked. Earlier this was sent as column position

   * @param {string} properties.pageName - Includes the name of the page (Eg: Playzone game listing page, ). This is not the URL but a easily understandable definition of what page is the user at.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/I3PACTN3c9}
   */
  function clickedOnBookAssign(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlayableCode(properties.playableCode));
      messages = messages.concat(assertPlayableName(properties.playableName));
      messages = messages.concat(assertRecommendedRailName(properties.recommendedRailName));
      messages = messages.concat(assertOptionalRecommendedTileRank(properties.recommendedTileRank));
      messages = messages.concat(assertPageName(properties.pageName));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Clicked on Book Assign", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "playableCode",
        "playableName",
        "recommendedRailName",
        "recommendedTileRank",
        "pageName",
        "fromPage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "I3PACTN3c9", "a0970d8bca3954b69725cb110ae3175cae5199b83c79c86519316d3804facb0d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Clicked on Book Assign", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Playable Code": properties.playableCode,
        "Playable Name": properties.playableName,
        "Recommended Rail Name": properties.recommendedRailName,
        "Recommended Tile Rank": properties.recommendedTileRank,
        "Page Name": properties.pageName,
        "From Page": properties.fromPage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("I3PACTN3c9", "Clicked on Book Assign", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "6lrsWYY5Y", name: "Recommended Rail Name", value: properties.recommendedRailName},
        {id: "FLDtSJNKL", name: "Recommended Tile Rank", value: properties.recommendedTileRank},
        {id: "MJKSzmqfHu", name: "Page Name", value: properties.pageName},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "QjCwFasvW0", name: "Playable Code", value: properties.playableCode},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "c2W4X05Jy", name: "Playable Name", value: properties.playableName},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Clicked on Book Assign': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Clicked on Book Assign", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Playable Code": properties.playableCode,
          "Playable Name": properties.playableName,
          "Recommended Rail Name": properties.recommendedRailName,
          "Recommended Tile Rank": properties.recommendedTileRank,
          "Page Name": properties.pageName,
          "From Page": properties.fromPage,
          "Screen Height": sysScreenHeight,
          }, "I3PACTN3c9", "a0970d8bca3954b69725cb110ae3175cae5199b83c79c86519316d3804facb0d");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Clicked on Book Assign", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Playable Code": properties.playableCode,
      "Playable Name": properties.playableName,
      "Recommended Rail Name": properties.recommendedRailName,
      "Recommended Tile Rank": properties.recommendedTileRank,
      "Page Name": properties.pageName,
      "From Page": properties.fromPage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Visited New Class: This event is fired when user visits the new class creation page
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/gJYQi_FWyB/trigger/QTWJBUPli
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {int} properties.cleverClassesFetchCount - This property returns the count of eligible classes for import found on Clever
   * @param {int} properties.daysSinceClassCreation - Self explanatory
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/gJYQi_FWyB}
   */
  function visitedNewClass(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertCleverClassesFetchCount(properties.cleverClassesFetchCount));
      messages = messages.concat(assertDaysSinceClassCreation(properties.daysSinceClassCreation));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Visited New Class", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "cleverClassesFetchCount",
        "daysSinceClassCreation"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "gJYQi_FWyB", "d65fb123e3abe3d671bd7415ab59f875b7533b4087fa7fe83be08a93596c0dde", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Visited New Class", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clever Classes Fetch Count": properties.cleverClassesFetchCount,
        "Days Since Class Creation": properties.daysSinceClassCreation,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("gJYQi_FWyB", "Visited New Class", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "TuspgTIuZ1", name: "Days Since Class Creation", value: properties.daysSinceClassCreation},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "kCQhGPMSr", name: "Clever Classes Fetch Count", value: properties.cleverClassesFetchCount},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Visited New Class': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Visited New Class", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clever Classes Fetch Count": properties.cleverClassesFetchCount,
          "Days Since Class Creation": properties.daysSinceClassCreation,
          "Screen Height": sysScreenHeight,
          }, "gJYQi_FWyB", "d65fb123e3abe3d671bd7415ab59f875b7533b4087fa7fe83be08a93596c0dde");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Visited New Class", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clever Classes Fetch Count": properties.cleverClassesFetchCount,
      "Days Since Class Creation": properties.daysSinceClassCreation,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Visited Add Students/Parent Email Page [B2B]: This event will be fired on page load of Add students/Parent emails screen 
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/TvCxxeE-S/trigger/xVlNBDnNB
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.classType - This Property will capture the type of class - Google Classroom or Clever or Manual
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/TvCxxeE-S}
   */
  function visitedAddStudentsparentEmailPageB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClassType(properties.classType));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Visited Add Students/Parent Email Page [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "classType"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "TvCxxeE-S", "a1ab5a80dc163763abfd0866b364f286cf41946f4195f7fbee9207414583d4ea", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Visited Add Students/Parent Email Page [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Class Type": properties.classType,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("TvCxxeE-S", "Visited Add Students/Parent Email Page [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "dk2bhnFne", name: "Class Type", value: properties.classType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Visited Add Students/Parent Email Page [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Visited Add Students/Parent Email Page [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Class Type": properties.classType,
          "Screen Height": sysScreenHeight,
          }, "TvCxxeE-S", "a1ab5a80dc163763abfd0866b364f286cf41946f4195f7fbee9207414583d4ea");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Visited Add Students/Parent Email Page [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Class Type": properties.classType,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Add Students/Parent Email Page [B2B]: This event will capture all the interactions on the Add Students/Parent Email Page
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/H4NbEmRUVx/trigger/qHSgH7ZzF
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} [properties.interactionDetails] - Stores where is the user interacting with the page
   * @param {int} [properties.cellPosition] - This returns the starting row number from where student names/parent email are copy pasted in the data table
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/H4NbEmRUVx}
   */
  function interactedAddStudentsparentEmailPageB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertOptionalInteractionDetails(properties.interactionDetails));
      messages = messages.concat(assertOptionalCellPosition(properties.cellPosition));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Add Students/Parent Email Page [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "interactionDetails",
        "cellPosition"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "H4NbEmRUVx", "bdae54a061cc3399cc6b7225563967c6c46015373eafa50fab875dbc76807bb7", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Add Students/Parent Email Page [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Interaction Details": properties.interactionDetails,
        "Cell Position": properties.cellPosition,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("H4NbEmRUVx", "Interacted Add Students/Parent Email Page [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "Q2tHPdj30", name: "Cell Position", value: properties.cellPosition},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "ncdYto9gZ", name: "Interaction Details", value: properties.interactionDetails},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Add Students/Parent Email Page [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Add Students/Parent Email Page [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Interaction Details": properties.interactionDetails,
          "Cell Position": properties.cellPosition,
          "Screen Height": sysScreenHeight,
          }, "H4NbEmRUVx", "bdae54a061cc3399cc6b7225563967c6c46015373eafa50fab875dbc76807bb7");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Add Students/Parent Email Page [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Interaction Details": properties.interactionDetails,
      "Cell Position": properties.cellPosition,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Class Created: This event should be fired on class creation
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.classType - This Property will capture the type of class - Google Classroom or Clever or Manual
   * @param {string} properties.className - The name of the class that is kept by the teacher. 
   * @param {string} properties.daysSinceSignup - Days since parent or teacher signs up on the product
   * @param {int} properties.classImportedBefore - This returns 1 if teacher selects an already imported class and 0 otherwise
   * @param {int} properties.importCount - This should return the number of times a class is imported as a new class from Clever/GC
   * @param {int} properties.studentsAddedCount - This property counts the number of students added at a time in the class
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/zEAMv9CWiZ}
   */
  function classCreated(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClassType(properties.classType));
      messages = messages.concat(assertClassName(properties.className));
      messages = messages.concat(assertDaysSinceSignup(properties.daysSinceSignup));
      messages = messages.concat(assertClassImportedBefore(properties.classImportedBefore));
      messages = messages.concat(assertImportCount(properties.importCount));
      messages = messages.concat(assertStudentsAddedCount(properties.studentsAddedCount));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Class Created", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "classType",
        "className",
        "daysSinceSignup",
        "classImportedBefore",
        "importCount",
        "studentsAddedCount"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "zEAMv9CWiZ", "c61fa849796228bcd02e413bbcafec6fbb020d597054e161d7698b5a472ff4e1", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Class Created", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Class Type": properties.classType,
        "Class Name": properties.className,
        "Days Since Signup": properties.daysSinceSignup,
        "Class Imported Before": properties.classImportedBefore,
        "Import Count": properties.importCount,
        "Students Added Count": properties.studentsAddedCount,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("zEAMv9CWiZ", "Class Created", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "9dTrjsxjG", name: "Class Name", value: properties.className},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "YkNoE278N", name: "Import Count", value: properties.importCount},
        {id: "axwj3awcZ", name: "Class Imported Before", value: properties.classImportedBefore},
        {id: "dk2bhnFne", name: "Class Type", value: properties.classType},
        {id: "e4g1zZQCJ", name: "Days Since Signup", value: properties.daysSinceSignup},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "zE5EQnQZc", name: "Students Added Count", value: properties.studentsAddedCount},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Class Created': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Class Created", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Class Type": properties.classType,
          "Class Name": properties.className,
          "Days Since Signup": properties.daysSinceSignup,
          "Class Imported Before": properties.classImportedBefore,
          "Import Count": properties.importCount,
          "Students Added Count": properties.studentsAddedCount,
          "Screen Height": sysScreenHeight,
          }, "zEAMv9CWiZ", "c61fa849796228bcd02e413bbcafec6fbb020d597054e161d7698b5a472ff4e1");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Class Created", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Class Type": properties.classType,
      "Class Name": properties.className,
      "Days Since Signup": properties.daysSinceSignup,
      "Class Imported Before": properties.classImportedBefore,
      "Import Count": properties.importCount,
      "Students Added Count": properties.studentsAddedCount,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Add Reimported Class Name Page [B2B]: This event will get fired on page load of add class name screen after teacher chooses to reimport an already imported class
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/o0SroWCzSh/trigger/Au-jlc9EP
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.classType - This Property will capture the type of class - Google Classroom or Clever or Manual
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/o0SroWCzSh}
   */
  function viewedAddReimportedClassNamePageB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClassType(properties.classType));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Add Reimported Class Name Page [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "classType"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "o0SroWCzSh", "c3a2129c52eff89c85fad852d6c041538c4b3ba4c60d5d011a9a307cdbdcecca", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Add Reimported Class Name Page [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Class Type": properties.classType,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("o0SroWCzSh", "Viewed Add Reimported Class Name Page [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "dk2bhnFne", name: "Class Type", value: properties.classType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Add Reimported Class Name Page [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Add Reimported Class Name Page [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Class Type": properties.classType,
          "Screen Height": sysScreenHeight,
          }, "o0SroWCzSh", "c3a2129c52eff89c85fad852d6c041538c4b3ba4c60d5d011a9a307cdbdcecca");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Add Reimported Class Name Page [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Class Type": properties.classType,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Add Reimported Class Name Page [B2B]: This event will get fired when user interacts with the add class name page
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/R3bDzhuq5Y/trigger/HQsNaiu87
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} [properties.interactionDetails] - Stores where is the user interacting with the page
   * @param {string} properties.classType - This Property will capture the type of class - Google Classroom or Clever or Manual
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/R3bDzhuq5Y}
   */
  function interactedAddReimportedClassNamePageB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertOptionalInteractionDetails(properties.interactionDetails));
      messages = messages.concat(assertClassType(properties.classType));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Add Reimported Class Name Page [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "interactionDetails",
        "classType"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "R3bDzhuq5Y", "620dc11471876734af395ec34400e711ef3249052b7e80607a76cb84e3e73bb0", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Add Reimported Class Name Page [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Interaction Details": properties.interactionDetails,
        "Class Type": properties.classType,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("R3bDzhuq5Y", "Interacted Add Reimported Class Name Page [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "dk2bhnFne", name: "Class Type", value: properties.classType},
        {id: "ncdYto9gZ", name: "Interaction Details", value: properties.interactionDetails},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Add Reimported Class Name Page [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Add Reimported Class Name Page [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Interaction Details": properties.interactionDetails,
          "Class Type": properties.classType,
          "Screen Height": sysScreenHeight,
          }, "R3bDzhuq5Y", "620dc11471876734af395ec34400e711ef3249052b7e80607a76cb84e3e73bb0");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Add Reimported Class Name Page [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Interaction Details": properties.interactionDetails,
      "Class Type": properties.classType,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Sync Confirmation Popup [B2B]: This event will trigger when user is displayed the sync confirmation popup on choosing to sync class from roster page, new class creation page, manage all classes page
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/9dk922UxHK/trigger/TnkfNXK4G
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * @param {string} properties.classType - This Property will capture the type of class - Google Classroom or Clever or Manual
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/9dk922UxHK}
   */
  function viewedSyncConfirmationPopupB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertClassType(properties.classType));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Sync Confirmation Popup [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "fromPage",
        "classType"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "9dk922UxHK", "c552c2c42d2a36143b829a126cbaedb5a0bba3e1e14792059fe31fabf3b0f528", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Sync Confirmation Popup [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From Page": properties.fromPage,
        "Class Type": properties.classType,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("9dk922UxHK", "Viewed Sync Confirmation Popup [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "dk2bhnFne", name: "Class Type", value: properties.classType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Sync Confirmation Popup [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Sync Confirmation Popup [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From Page": properties.fromPage,
          "Class Type": properties.classType,
          "Screen Height": sysScreenHeight,
          }, "9dk922UxHK", "c552c2c42d2a36143b829a126cbaedb5a0bba3e1e14792059fe31fabf3b0f528");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Sync Confirmation Popup [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From Page": properties.fromPage,
      "Class Type": properties.classType,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Post Class Sync Popup [B2B]: This event will trigger when user closes the post class sync popup
   * 
   * When to trigger this event:
   * 1. When user clicks "Okay, got it"
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Lv_10G4_Z7/trigger/-PFntDCsJ
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.classType - This Property will capture the type of class - Google Classroom or Clever or Manual
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Lv_10G4_Z7}
   */
  function interactedPostClassSyncPopupB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClassType(properties.classType));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Post Class Sync Popup [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "classType"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Lv_10G4_Z7", "e3897be0d8a53ced824a3aa1ad074cbe417ae30a3420e89ea813707ee5bd5122", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Post Class Sync Popup [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Class Type": properties.classType,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Lv_10G4_Z7", "Interacted Post Class Sync Popup [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "dk2bhnFne", name: "Class Type", value: properties.classType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Post Class Sync Popup [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Post Class Sync Popup [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Class Type": properties.classType,
          "Screen Height": sysScreenHeight,
          }, "Lv_10G4_Z7", "e3897be0d8a53ced824a3aa1ad074cbe417ae30a3420e89ea813707ee5bd5122");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Post Class Sync Popup [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Class Type": properties.classType,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Sync Confirmation Popup [B2B]: This event will trigger when user clicks 'Sync' or clicks 'Cancel' on the class sync confirmation popup
   * 
   * When to trigger this event:
   * 1. When user clicks "Sync" or "Cancel" button
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/HwOSViBbPr/trigger/llIWU-KgX
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.classType - This Property will capture the type of class - Google Classroom or Clever or Manual
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/HwOSViBbPr}
   */
  function interactedSyncConfirmationPopupB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClassType(properties.classType));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Sync Confirmation Popup [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "classType",
        "clickedOn",
        "fromPage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "HwOSViBbPr", "5c7cb8e65b2f1eb55bd87bffa260be0d8b3b0c6fc2291801c018d4a4acd88906", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Sync Confirmation Popup [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Class Type": properties.classType,
        "Clicked On": properties.clickedOn,
        "From Page": properties.fromPage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("HwOSViBbPr", "Interacted Sync Confirmation Popup [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "dk2bhnFne", name: "Class Type", value: properties.classType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Sync Confirmation Popup [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Sync Confirmation Popup [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Class Type": properties.classType,
          "Clicked On": properties.clickedOn,
          "From Page": properties.fromPage,
          "Screen Height": sysScreenHeight,
          }, "HwOSViBbPr", "5c7cb8e65b2f1eb55bd87bffa260be0d8b3b0c6fc2291801c018d4a4acd88906");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Sync Confirmation Popup [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Class Type": properties.classType,
      "Clicked On": properties.clickedOn,
      "From Page": properties.fromPage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Post Class Sync Popup [B2B]: This event will trigger when user is displayed the informational popup after sync operation
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/0d2PTYSAYN/trigger/-ifDygjTB
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.classType - This Property will capture the type of class - Google Classroom or Clever or Manual
   * @param {int} properties.studentsAddedCount - This property counts the number of students added at a time in the class
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/0d2PTYSAYN}
   */
  function viewedPostClassSyncPopupB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClassType(properties.classType));
      messages = messages.concat(assertStudentsAddedCount(properties.studentsAddedCount));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Post Class Sync Popup [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "classType",
        "studentsAddedCount",
        "fromPage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "0d2PTYSAYN", "9e85999eb652c20c5ce297a0b4e892858225c1e28bc378e922746cc7d3b3bc2f", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Post Class Sync Popup [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Class Type": properties.classType,
        "Students Added Count": properties.studentsAddedCount,
        "From Page": properties.fromPage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("0d2PTYSAYN", "Viewed Post Class Sync Popup [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "dk2bhnFne", name: "Class Type", value: properties.classType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "zE5EQnQZc", name: "Students Added Count", value: properties.studentsAddedCount},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Post Class Sync Popup [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Post Class Sync Popup [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Class Type": properties.classType,
          "Students Added Count": properties.studentsAddedCount,
          "From Page": properties.fromPage,
          "Screen Height": sysScreenHeight,
          }, "0d2PTYSAYN", "9e85999eb652c20c5ce297a0b4e892858225c1e28bc378e922746cc7d3b3bc2f");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Post Class Sync Popup [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Class Type": properties.classType,
      "Students Added Count": properties.studentsAddedCount,
      "From Page": properties.fromPage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Sync Google Classroom: This event will trigger when user syncs Google Classroom class from the confirmation popup
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/h7BPgn3E8X/trigger/qp2lp4HN3
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.status - To determine if the process failed or succeeded
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * @param {int} properties.studentsAddedCount - This property counts the number of students added at a time in the class
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/h7BPgn3E8X}
   */
  function syncGoogleClassroom(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertStatus(properties.status));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertStudentsAddedCount(properties.studentsAddedCount));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Sync Google Classroom", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "status",
        "fromPage",
        "studentsAddedCount"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "h7BPgn3E8X", "43acbb1f6db2a16387510491780ae09e7ae386a4abf92f172b7995831de46588", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Sync Google Classroom", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Status": properties.status,
        "From Page": properties.fromPage,
        "Students Added Count": properties.studentsAddedCount,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("h7BPgn3E8X", "Sync Google Classroom", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "9_Al8_kuam", name: "Status", value: properties.status},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "zE5EQnQZc", name: "Students Added Count", value: properties.studentsAddedCount},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Sync Google Classroom': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Sync Google Classroom", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Status": properties.status,
          "From Page": properties.fromPage,
          "Students Added Count": properties.studentsAddedCount,
          "Screen Height": sysScreenHeight,
          }, "h7BPgn3E8X", "43acbb1f6db2a16387510491780ae09e7ae386a4abf92f172b7995831de46588");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Sync Google Classroom", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Status": properties.status,
      "From Page": properties.fromPage,
      "Students Added Count": properties.studentsAddedCount,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Sync Clever Classes: This event will trigger when user syncs Clever class from the confirmation popup
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/kz0DZXnXi_/trigger/eORGvvwoe
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.status - To determine if the process failed or succeeded
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * @param {int} properties.studentsAddedCount - This property counts the number of students added at a time in the class
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/kz0DZXnXi_}
   */
  function syncCleverClasses(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertStatus(properties.status));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertStudentsAddedCount(properties.studentsAddedCount));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Sync Clever Classes", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "status",
        "fromPage",
        "studentsAddedCount"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "kz0DZXnXi_", "37d9fb5f0e65df60ce4a13ac0f69d389639825a358b13801ba97264b823b92f1", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Sync Clever Classes", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Status": properties.status,
        "From Page": properties.fromPage,
        "Students Added Count": properties.studentsAddedCount,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("kz0DZXnXi_", "Sync Clever Classes", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "9_Al8_kuam", name: "Status", value: properties.status},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "zE5EQnQZc", name: "Students Added Count", value: properties.studentsAddedCount},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Sync Clever Classes': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Sync Clever Classes", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Status": properties.status,
          "From Page": properties.fromPage,
          "Students Added Count": properties.studentsAddedCount,
          "Screen Height": sysScreenHeight,
          }, "kz0DZXnXi_", "37d9fb5f0e65df60ce4a13ac0f69d389639825a358b13801ba97264b823b92f1");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Sync Clever Classes", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Status": properties.status,
      "From Page": properties.fromPage,
      "Students Added Count": properties.studentsAddedCount,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Reimported Classes Selection Screen [B2B]: This event will be fired when user wants to sync a Clever class which has been reimported more than once previously
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/rjWz38EkAO/trigger/LEekIKEjP
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.classType - This Property will capture the type of class - Google Classroom or Clever or Manual
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/rjWz38EkAO}
   */
  function viewedReimportedClassesSelectionScreenB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClassType(properties.classType));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Reimported Classes Selection Screen [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "classType"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "rjWz38EkAO", "cee02f62859256404bcb8337390cc3919c336e373c29146c2ac4664b88ef063e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Reimported Classes Selection Screen [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Class Type": properties.classType,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("rjWz38EkAO", "Viewed Reimported Classes Selection Screen [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "dk2bhnFne", name: "Class Type", value: properties.classType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Reimported Classes Selection Screen [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Reimported Classes Selection Screen [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Class Type": properties.classType,
          "Screen Height": sysScreenHeight,
          }, "rjWz38EkAO", "cee02f62859256404bcb8337390cc3919c336e373c29146c2ac4664b88ef063e");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Reimported Classes Selection Screen [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Class Type": properties.classType,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Reimported Classes Selection Screen [B2B]: This event will be fired when user interacts with this page
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/9yCfRdqdJh/trigger/78Am3GwLr
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.interactionDetails] - Stores where is the user interacting with the page
   * @param {string} properties.classType - This Property will capture the type of class - Google Classroom or Clever or Manual
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.valueName - This will capture the value/text of the field that is selected.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/9yCfRdqdJh}
   */
  function interactedReimportedClassesSelectionScreenB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalInteractionDetails(properties.interactionDetails));
      messages = messages.concat(assertClassType(properties.classType));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertValueName(properties.valueName));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Reimported Classes Selection Screen [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "interactionDetails",
        "classType",
        "clickedOn",
        "valueName"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "9yCfRdqdJh", "9883aaadbc0fec8cb6aeaf04feb602e6a2bf3a71f9db5856afa60fa32db6a85c", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Reimported Classes Selection Screen [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Interaction Details": properties.interactionDetails,
        "Class Type": properties.classType,
        "Clicked On": properties.clickedOn,
        "Value Name": properties.valueName,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("9yCfRdqdJh", "Interacted Reimported Classes Selection Screen [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "dk2bhnFne", name: "Class Type", value: properties.classType},
        {id: "l-8JNUE0q", name: "Value Name", value: properties.valueName},
        {id: "ncdYto9gZ", name: "Interaction Details", value: properties.interactionDetails},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Reimported Classes Selection Screen [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Reimported Classes Selection Screen [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Interaction Details": properties.interactionDetails,
          "Class Type": properties.classType,
          "Clicked On": properties.clickedOn,
          "Value Name": properties.valueName,
          "Screen Height": sysScreenHeight,
          }, "9yCfRdqdJh", "9883aaadbc0fec8cb6aeaf04feb602e6a2bf3a71f9db5856afa60fa32db6a85c");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Reimported Classes Selection Screen [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Interaction Details": properties.interactionDetails,
      "Class Type": properties.classType,
      "Clicked On": properties.clickedOn,
      "Value Name": properties.valueName,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Roster Page: This event will trigger when user interacts with the Student roster page
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/XwZXRMGEyy/trigger/MrRymW_AK
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.classType - This Property will capture the type of class - Google Classroom or Clever or Manual
   * @param {string} [properties.interactionDetails] - Stores where is the user interacting with the page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/XwZXRMGEyy}
   */
  function interactedRosterPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertClassType(properties.classType));
      messages = messages.concat(assertOptionalInteractionDetails(properties.interactionDetails));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Roster Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "classType",
        "interactionDetails"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "XwZXRMGEyy", "0b8e8dffef40046b2dcbf42daf653b7e8e5a080ac01189b7fba123d252577983", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Roster Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Class Type": properties.classType,
        "Interaction Details": properties.interactionDetails,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("XwZXRMGEyy", "Interacted Roster Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "dk2bhnFne", name: "Class Type", value: properties.classType},
        {id: "ncdYto9gZ", name: "Interaction Details", value: properties.interactionDetails},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Roster Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Roster Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Class Type": properties.classType,
          "Interaction Details": properties.interactionDetails,
          "Screen Height": sysScreenHeight,
          }, "XwZXRMGEyy", "0b8e8dffef40046b2dcbf42daf653b7e8e5a080ac01189b7fba123d252577983");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Roster Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Class Type": properties.classType,
      "Interaction Details": properties.interactionDetails,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Selected classes for import: This event will be fired when user clicks on import button from the google classroom/clever class import screen
   * 
   * When to trigger this event:
   * 1. On click of Import button
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/00YEABbHd9/trigger/YkqvNbi2f
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {int} properties.selectedClassesForImporting - This property returns the count of classes user selected for importing to SplashLearn
   * @param {int} properties.eligibleClassesCount - This property should return the count of eligible classes that can be imported.
Reason for ineligibility - Class already imported, Fetched class has zero students
   * @param {string} properties.classType - This Property will capture the type of class - Google Classroom or Clever or Manual
   * @param {Array<int>} properties.studentCountImportedClasses - This property returns an array consisting of student count for each imported class
   * @param {int} properties.classImportedBefore - This returns 1 if teacher selects an already imported class and 0 otherwise
   * @param {int} properties.importCount - This should return the number of times a class is imported as a new class from Clever/GC
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/00YEABbHd9}
   */
  function selectedClassesForImport(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertSelectedClassesForImporting(properties.selectedClassesForImporting));
      messages = messages.concat(assertEligibleClassesCount(properties.eligibleClassesCount));
      messages = messages.concat(assertClassType(properties.classType));
      messages = messages.concat(assertStudentCountImportedClasses(properties.studentCountImportedClasses));
      messages = messages.concat(assertClassImportedBefore(properties.classImportedBefore));
      messages = messages.concat(assertImportCount(properties.importCount));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Selected classes for import", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "selectedClassesForImporting",
        "eligibleClassesCount",
        "classType",
        "studentCountImportedClasses",
        "classImportedBefore",
        "importCount"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "00YEABbHd9", "c69d32568f0e15a3805310d75e46797204fbf03caaafbfa3103bc48a133263fc", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Selected classes for import", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Selected Classes for Importing": properties.selectedClassesForImporting,
        "Eligible Classes Count": properties.eligibleClassesCount,
        "Class Type": properties.classType,
        "Student Count Imported Classes": properties.studentCountImportedClasses,
        "Class Imported Before": properties.classImportedBefore,
        "Import Count": properties.importCount,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("00YEABbHd9", "Selected classes for import", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "YARhyVGOR", name: "Eligible Classes Count", value: properties.eligibleClassesCount},
        {id: "YkNoE278N", name: "Import Count", value: properties.importCount},
        {id: "axwj3awcZ", name: "Class Imported Before", value: properties.classImportedBefore},
        {id: "dk2bhnFne", name: "Class Type", value: properties.classType},
        {id: "oZoIifrMw", name: "Student Count Imported Classes", value: properties.studentCountImportedClasses},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xTv8S7XAS", name: "Selected Classes for Importing", value: properties.selectedClassesForImporting},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Selected classes for import': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Selected classes for import", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Selected Classes for Importing": properties.selectedClassesForImporting,
          "Eligible Classes Count": properties.eligibleClassesCount,
          "Class Type": properties.classType,
          "Student Count Imported Classes": properties.studentCountImportedClasses,
          "Class Imported Before": properties.classImportedBefore,
          "Import Count": properties.importCount,
          "Screen Height": sysScreenHeight,
          }, "00YEABbHd9", "c69d32568f0e15a3805310d75e46797204fbf03caaafbfa3103bc48a133263fc");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Selected classes for import", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Selected Classes for Importing": properties.selectedClassesForImporting,
      "Eligible Classes Count": properties.eligibleClassesCount,
      "Class Type": properties.classType,
      "Student Count Imported Classes": properties.studentCountImportedClasses,
      "Class Imported Before": properties.classImportedBefore,
      "Import Count": properties.importCount,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Google/Clever Class Import Screen [B2B]: This event gets fired when the user interacts with the google/clever class import screen.
This should not get fired when Import button is clicked because in that case, 'Selected classes for import' event already gets fired. That'll continue.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/XUUDmQ8Oaj/trigger/RKI9LoFGy
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.classType - This Property will capture the type of class - Google Classroom or Clever or Manual
   * @param {string} [properties.interactionDetails] - Stores where is the user interacting with the page
   * @param {int} properties.classImportedBefore - This returns 1 if teacher selects an already imported class and 0 otherwise
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/XUUDmQ8Oaj}
   */
  function interactedGooglecleverClassImportScreenB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertClassType(properties.classType));
      messages = messages.concat(assertOptionalInteractionDetails(properties.interactionDetails));
      messages = messages.concat(assertClassImportedBefore(properties.classImportedBefore));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Google/Clever Class Import Screen [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "classType",
        "interactionDetails",
        "classImportedBefore"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "XUUDmQ8Oaj", "1171ea8afa1b0aefcebd4020388ccc8567e663aa414cb3013442f46784d0ff0d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Google/Clever Class Import Screen [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Class Type": properties.classType,
        "Interaction Details": properties.interactionDetails,
        "Class Imported Before": properties.classImportedBefore,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("XUUDmQ8Oaj", "Interacted Google/Clever Class Import Screen [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "axwj3awcZ", name: "Class Imported Before", value: properties.classImportedBefore},
        {id: "dk2bhnFne", name: "Class Type", value: properties.classType},
        {id: "ncdYto9gZ", name: "Interaction Details", value: properties.interactionDetails},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Google/Clever Class Import Screen [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Google/Clever Class Import Screen [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Class Type": properties.classType,
          "Interaction Details": properties.interactionDetails,
          "Class Imported Before": properties.classImportedBefore,
          "Screen Height": sysScreenHeight,
          }, "XUUDmQ8Oaj", "1171ea8afa1b0aefcebd4020388ccc8567e663aa414cb3013442f46784d0ff0d");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Google/Clever Class Import Screen [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Class Type": properties.classType,
      "Interaction Details": properties.interactionDetails,
      "Class Imported Before": properties.classImportedBefore,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Manage All Classes Page: This event will trigger when user interacts with the manage all classes page
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/sWVoXolDme/trigger/nb-O_TLBh
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} [properties.classType] - This Property will capture the type of class - Google Classroom or Clever or Manual
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/sWVoXolDme}
   */
  function interactedManageAllClassesPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertOptionalClassType(properties.classType));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Manage All Classes Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "classType"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "sWVoXolDme", "e4f3379d1217f5f50855aab0aac600ad35033b3c74df9fa10deb7c936c4b3ec0", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Manage All Classes Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Class Type": properties.classType,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("sWVoXolDme", "Interacted Manage All Classes Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "dk2bhnFne", name: "Class Type", value: properties.classType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Manage All Classes Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Manage All Classes Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Class Type": properties.classType,
          "Screen Height": sysScreenHeight,
          }, "sWVoXolDme", "e4f3379d1217f5f50855aab0aac600ad35033b3c74df9fa10deb7c936c4b3ec0");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Manage All Classes Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Class Type": properties.classType,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Class Sync Unsuccessful [B2B]: This is a logging event that will fire when GC/Clever sync is not successful
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.classType - This Property will capture the type of class - Google Classroom or Clever or Manual
   * @param {string} properties.reasonForSyncFailure - This property will return the reason for GC or Clever class sync failure
   * @param {string} properties.apiUrl - The API which was called for this event
   * @param {string} properties.apiStatus - API status
   * @param {string} properties.apiSource - This property returns if API is called from BE or FE
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/bxwEhA7xEo}
   */
  function classSyncUnsuccessfulB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClassType(properties.classType));
      messages = messages.concat(assertReasonForSyncFailure(properties.reasonForSyncFailure));
      messages = messages.concat(assertAPIUrl(properties.apiUrl));
      messages = messages.concat(assertAPIStatus(properties.apiStatus));
      messages = messages.concat(assertAPISource(properties.apiSource));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Class Sync Unsuccessful [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "classType",
        "reasonForSyncFailure",
        "apiUrl",
        "apiStatus",
        "apiSource"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "bxwEhA7xEo", "ab842ab301b093bb1e0a5aaa92c670bacf4584ab08c10d8e6c40507328b48556", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Class Sync Unsuccessful [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Class Type": properties.classType,
        "Reason for Sync Failure": properties.reasonForSyncFailure,
        "API Url": properties.apiUrl,
        "API Status": properties.apiStatus,
        "API Source": properties.apiSource,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("bxwEhA7xEo", "Class Sync Unsuccessful [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "7e4uFkiW6", name: "API Status", value: properties.apiStatus},
        {id: "KgDSWGuTz", name: "API Source", value: properties.apiSource},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "dk2bhnFne", name: "Class Type", value: properties.classType},
        {id: "iFDeKMBSm", name: "Reason for Sync Failure", value: properties.reasonForSyncFailure},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "u9ncLCjsR", name: "API Url", value: properties.apiUrl},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Class Sync Unsuccessful [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Class Sync Unsuccessful [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Class Type": properties.classType,
          "Reason for Sync Failure": properties.reasonForSyncFailure,
          "API Url": properties.apiUrl,
          "API Status": properties.apiStatus,
          "API Source": properties.apiSource,
          "Screen Height": sysScreenHeight,
          }, "bxwEhA7xEo", "ab842ab301b093bb1e0a5aaa92c670bacf4584ab08c10d8e6c40507328b48556");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Class Sync Unsuccessful [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Class Type": properties.classType,
      "Reason for Sync Failure": properties.reasonForSyncFailure,
      "API Url": properties.apiUrl,
      "API Status": properties.apiStatus,
      "API Source": properties.apiSource,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Class Sync Successful [B2B]: This event will trigger when Google or Clever class is synced successfully from any page
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/unewY4_oe/trigger/PaeLyC_Sr6
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.classType - This Property will capture the type of class - Google Classroom or Clever or Manual
   * @param {int} properties.studentsAddedCount - This property counts the number of students added at a time in the class
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/unewY4_oe}
   */
  function classSyncSuccessfulB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClassType(properties.classType));
      messages = messages.concat(assertStudentsAddedCount(properties.studentsAddedCount));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Class Sync Successful [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "classType",
        "studentsAddedCount",
        "fromPage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "unewY4_oe", "ec64d710c354209c4e8e7e5d482821da0a441264e64d4ebc92d58971064d9251", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Class Sync Successful [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Class Type": properties.classType,
        "Students Added Count": properties.studentsAddedCount,
        "From Page": properties.fromPage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("unewY4_oe", "Class Sync Successful [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "dk2bhnFne", name: "Class Type", value: properties.classType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "zE5EQnQZc", name: "Students Added Count", value: properties.studentsAddedCount},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Class Sync Successful [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Class Sync Successful [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Class Type": properties.classType,
          "Students Added Count": properties.studentsAddedCount,
          "From Page": properties.fromPage,
          "Screen Height": sysScreenHeight,
          }, "unewY4_oe", "ec64d710c354209c4e8e7e5d482821da0a441264e64d4ebc92d58971064d9251");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Class Sync Successful [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Class Type": properties.classType,
      "Students Added Count": properties.studentsAddedCount,
      "From Page": properties.fromPage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Preferred Time Input Popup: Triggered when a user clicks on remind me, and the user views preferred input screen popup
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/PQNnXQKH91/trigger/PPs8Pcwws
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.tabCode - Specifies the tab which has been opened in the event 'Viewed Tiled Dashboard' and Other events too
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/PQNnXQKH91}
   */
  function viewedPreferredTimeInputPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertTabCode(properties.tabCode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Preferred Time Input Popup", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "elaGrade",
        "grade",
        "tabCode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "PQNnXQKH91", "a785cd19e47b557dd656d2c14690056f8c29fafd7df1408924683be5143d6f37", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Preferred Time Input Popup", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Tab Code": properties.tabCode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("PQNnXQKH91", "Viewed Preferred Time Input Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "l9PbANZBu", name: "Tab Code", value: properties.tabCode},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Preferred Time Input Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Preferred Time Input Popup", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Tab Code": properties.tabCode,
          "Screen Height": sysScreenHeight,
          }, "PQNnXQKH91", "a785cd19e47b557dd656d2c14690056f8c29fafd7df1408924683be5143d6f37");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Preferred Time Input Popup", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Tab Code": properties.tabCode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Preferred Time Input Popup: Triggered when a user clicks on any of the elements of preferred time input screen
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/OWG9RBLJsc/trigger/EGbH3B-Z_
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/OWG9RBLJsc}
   */
  function interactedPreferredTimeInputPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Preferred Time Input Popup", Object.keys(properties), [
        "mathGrade",
        "mode",
        "platform",
        "userType",
        "signupFlow",
        "elaGrade",
        "grade",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "OWG9RBLJsc", "acc9af534015c53599e9e5236ac694813467b98a375a8ce9b6f7484b91296d35", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Preferred Time Input Popup", {
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("OWG9RBLJsc", "Interacted Preferred Time Input Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Preferred Time Input Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Preferred Time Input Popup", {
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "OWG9RBLJsc", "acc9af534015c53599e9e5236ac694813467b98a375a8ce9b6f7484b91296d35");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Preferred Time Input Popup", {
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Preferred Time Confirmation Popup: Triggered when a user interacts with the input screen and decides to set a preferred time
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/_PS2YhVGvh/trigger/QAoCBb1xo
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.tabCode - Specifies the tab which has been opened in the event 'Viewed Tiled Dashboard' and Other events too
   * @param {int} properties.attendanceCount - Count of classes attended by the user till date
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/_PS2YhVGvh}
   */
  function viewedPreferredTimeConfirmationPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertTabCode(properties.tabCode));
      messages = messages.concat(assertAttendanceCount(properties.attendanceCount));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Preferred Time Confirmation Popup", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "elaGrade",
        "grade",
        "tabCode",
        "attendanceCount"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "_PS2YhVGvh", "791cae19891a10d85db96d7cc03463e22650efa94282a370b8d40331a97daf29", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Preferred Time Confirmation Popup", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Tab Code": properties.tabCode,
        "Attendance Count": properties.attendanceCount,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("_PS2YhVGvh", "Viewed Preferred Time Confirmation Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "WIwN37Vje", name: "Attendance Count", value: properties.attendanceCount},
        {id: "l9PbANZBu", name: "Tab Code", value: properties.tabCode},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Preferred Time Confirmation Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Preferred Time Confirmation Popup", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Tab Code": properties.tabCode,
          "Attendance Count": properties.attendanceCount,
          "Screen Height": sysScreenHeight,
          }, "_PS2YhVGvh", "791cae19891a10d85db96d7cc03463e22650efa94282a370b8d40331a97daf29");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Preferred Time Confirmation Popup", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Tab Code": properties.tabCode,
      "Attendance Count": properties.attendanceCount,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Preferred Time Confirmation Popup: Triggered when a user interacts with the preferred time confirmation popup
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/sYvgEb5isI/trigger/8Itu459Iv
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {int} properties.attendanceCount - Count of classes attended by the user till date
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/sYvgEb5isI}
   */
  function interactedPreferredTimeConfirmationPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertAttendanceCount(properties.attendanceCount));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Preferred Time Confirmation Popup", Object.keys(properties), [
        "mathGrade",
        "mode",
        "platform",
        "userType",
        "signupFlow",
        "elaGrade",
        "grade",
        "clickedOn",
        "attendanceCount"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "sYvgEb5isI", "aa87ed132c8d56f38755804ef4803347de45b6c6ffdccc6a5fe267b346bbba78", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Preferred Time Confirmation Popup", {
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Clicked On": properties.clickedOn,
        "Attendance Count": properties.attendanceCount,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("sYvgEb5isI", "Interacted Preferred Time Confirmation Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "WIwN37Vje", name: "Attendance Count", value: properties.attendanceCount},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Preferred Time Confirmation Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Preferred Time Confirmation Popup", {
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Clicked On": properties.clickedOn,
          "Attendance Count": properties.attendanceCount,
          "Screen Height": sysScreenHeight,
          }, "sYvgEb5isI", "aa87ed132c8d56f38755804ef4803347de45b6c6ffdccc6a5fe267b346bbba78");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Preferred Time Confirmation Popup", {
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Clicked On": properties.clickedOn,
      "Attendance Count": properties.attendanceCount,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Today Class Popup: Triggered when a user interacts with the today class popup
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/WvDUe5kQIB/trigger/fUD95oCYg
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/WvDUe5kQIB}
   */
  function interactedTodayClassPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Today Class Popup", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "elaGrade",
        "grade",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "WvDUe5kQIB", "50baae229102455c63d82241e0573a24dd12e69e691c1cf54fb9982f447d6f33", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Today Class Popup", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("WvDUe5kQIB", "Interacted Today Class Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Today Class Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Today Class Popup", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "WvDUe5kQIB", "50baae229102455c63d82241e0573a24dd12e69e691c1cf54fb9982f447d6f33");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Today Class Popup", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Today Class Popup: Triggered when a user views the today class popup after D0
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/W1c67TtQrW/trigger/D0pCj3gKu
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/W1c67TtQrW}
   */
  function viewedTodayClassPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Today Class Popup", Object.keys(properties), [
        "mathGrade",
        "mode",
        "platform",
        "userType",
        "signupFlow",
        "elaGrade",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "W1c67TtQrW", "0bf9c4c2713c7028e87a0739c1015b7bbef9ac95605d3045141550d4ba6e6004", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Today Class Popup", {
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("W1c67TtQrW", "Viewed Today Class Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Today Class Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Today Class Popup", {
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "W1c67TtQrW", "0bf9c4c2713c7028e87a0739c1015b7bbef9ac95605d3045141550d4ba6e6004");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Today Class Popup", {
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Paypal Payment Button Rendered: PayPal CTA is displayed after selecting paypal as payment method
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/JXqCMOZ6jv/trigger/UzvPQd3EQ
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/JXqCMOZ6jv}
   */
  function paypalPaymentButtonRendered(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Paypal Payment Button Rendered", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "grade",
        "elaGrade",
        "mathGrade",
        "mode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "JXqCMOZ6jv", "867e504e876914de974f4dfe71a4e478c875814dc0468686becafcfa2976c0c3", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Paypal Payment Button Rendered", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("JXqCMOZ6jv", "Paypal Payment Button Rendered", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Paypal Payment Button Rendered': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Paypal Payment Button Rendered", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Screen Height": sysScreenHeight,
          }, "JXqCMOZ6jv", "867e504e876914de974f4dfe71a4e478c875814dc0468686becafcfa2976c0c3");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Paypal Payment Button Rendered", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Product Selection [B2B]: Event get fired when product selection page loads successfully.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/gPhwNJPPfA/trigger/6hEnQiniW
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.productSelectionFlow - User views product selection page from onboarding, login flow, and left nav
   * @param {int} properties.count - numbers of times user visited, interacted.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/gPhwNJPPfA}
   */
  function viewedProductSelectionB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertProductSelectionFlow(properties.productSelectionFlow));
      messages = messages.concat(assertCount(properties.count));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Product Selection [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "productSelectionFlow",
        "count"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "gPhwNJPPfA", "22a23ccbc06ded2d13f3b8052466e0354167f07da8225f887671e90d2f28239a", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Product Selection [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Product Selection Flow": properties.productSelectionFlow,
        "Count": properties.count,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("gPhwNJPPfA", "Viewed Product Selection [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "66B3Sc44X", name: "Product Selection Flow", value: properties.productSelectionFlow},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "k_9EFdeYQ", name: "Count", value: properties.count},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Product Selection [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Product Selection [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Product Selection Flow": properties.productSelectionFlow,
          "Count": properties.count,
          "Screen Height": sysScreenHeight,
          }, "gPhwNJPPfA", "22a23ccbc06ded2d13f3b8052466e0354167f07da8225f887671e90d2f28239a");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Product Selection [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Product Selection Flow": properties.productSelectionFlow,
      "Count": properties.count,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Product Selection [B2B]: Event gets fired when user takes an action on product selection screen.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/jgB-UWNSR7/trigger/m8A20PNZn
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.productSelectionFlow - User views product selection page from onboarding, login flow, and left nav
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {int} properties.count - numbers of times user visited, interacted.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/jgB-UWNSR7}
   */
  function interactedProductSelectionB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertProductSelectionFlow(properties.productSelectionFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertCount(properties.count));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Product Selection [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "productSelectionFlow",
        "clickedOn",
        "count"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "jgB-UWNSR7", "1f5ae18cce541c9098e16a3a20c37cb41dbf5d13d702770966df665146800321", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Product Selection [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Product Selection Flow": properties.productSelectionFlow,
        "Clicked On": properties.clickedOn,
        "Count": properties.count,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("jgB-UWNSR7", "Interacted Product Selection [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "66B3Sc44X", name: "Product Selection Flow", value: properties.productSelectionFlow},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "k_9EFdeYQ", name: "Count", value: properties.count},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Product Selection [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Product Selection [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Product Selection Flow": properties.productSelectionFlow,
          "Clicked On": properties.clickedOn,
          "Count": properties.count,
          "Screen Height": sysScreenHeight,
          }, "jgB-UWNSR7", "1f5ae18cce541c9098e16a3a20c37cb41dbf5d13d702770966df665146800321");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Product Selection [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Product Selection Flow": properties.productSelectionFlow,
      "Clicked On": properties.clickedOn,
      "Count": properties.count,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Clicked Product Selection [B2B]: Event gets fired when user selects the product.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/C7OYOzBy-j/trigger/TGA4uudCI
   * 2. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/C7OYOzBy-j/trigger/eOjlpgHFT
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.productSelectionFlow - User views product selection page from onboarding, login flow, and left nav
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/C7OYOzBy-j}
   */
  function clickedProductSelectionB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertProductSelectionFlow(properties.productSelectionFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Clicked Product Selection [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "productSelectionFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "C7OYOzBy-j", "3c2a8b386682bd3adddce31861c941c8f11297690ef8830425088f7850d71427", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Clicked Product Selection [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Product Selection Flow": properties.productSelectionFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("C7OYOzBy-j", "Clicked Product Selection [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "66B3Sc44X", name: "Product Selection Flow", value: properties.productSelectionFlow},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Clicked Product Selection [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Clicked Product Selection [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Product Selection Flow": properties.productSelectionFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "C7OYOzBy-j", "3c2a8b386682bd3adddce31861c941c8f11297690ef8830425088f7850d71427");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Clicked Product Selection [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Product Selection Flow": properties.productSelectionFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Visited Curriculum Tab: User reaches math or english curriculum default screen
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/GcA7KX-m5g/trigger/DbYQbixDV
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/GcA7KX-m5g}
   */
  function visitedCurriculumTab(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Visited Curriculum Tab", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "fromPage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "GcA7KX-m5g", "a284bd2a8145654d4d5a4760b4a2fd2e896bce8baa83b3411380d50576db7915", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Visited Curriculum Tab", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From Page": properties.fromPage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("GcA7KX-m5g", "Visited Curriculum Tab", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Visited Curriculum Tab': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Visited Curriculum Tab", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From Page": properties.fromPage,
          "Screen Height": sysScreenHeight,
          }, "GcA7KX-m5g", "a284bd2a8145654d4d5a4760b4a2fd2e896bce8baa83b3411380d50576db7915");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Visited Curriculum Tab", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From Page": properties.fromPage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Screen Curriculum Rendered: Default screen of curriculum loads successfully from either of subject math/ english
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/9snkNi_wDg/trigger/1xw6ym7K8
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/9snkNi_wDg}
   */
  function screenCurriculumRendered(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Screen Curriculum Rendered", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "9snkNi_wDg", "c0a1d45a000d67c4ed2f4beddd6a6d6ddf8199f4f08d9383c4fbcedf81cb1891", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Screen Curriculum Rendered", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("9snkNi_wDg", "Screen Curriculum Rendered", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Screen Curriculum Rendered': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Screen Curriculum Rendered", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "9snkNi_wDg", "c0a1d45a000d67c4ed2f4beddd6a6d6ddf8199f4f08d9383c4fbcedf81cb1891");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Screen Curriculum Rendered", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Clicked Class Assessments: Event gets fired when user clicks on assessment tab
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/tjyWsRcYA/trigger/CjIrfEUmh
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/tjyWsRcYA}
   */
  function clickedClassAssessments(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Clicked Class Assessments", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "fromPage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "tjyWsRcYA", "1b41db2ed906d208f41f945783d9b83c55861c4d937255189a343c1b66905a06", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Clicked Class Assessments", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From Page": properties.fromPage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("tjyWsRcYA", "Clicked Class Assessments", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Clicked Class Assessments': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Clicked Class Assessments", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From Page": properties.fromPage,
          "Screen Height": sysScreenHeight,
          }, "tjyWsRcYA", "1b41db2ed906d208f41f945783d9b83c55861c4d937255189a343c1b66905a06");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Clicked Class Assessments", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From Page": properties.fromPage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Screen Assessment Rendered: event gets fired when assessment screen loads completely (assigning, track)
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/-Depqw3G35/trigger/rGzHZW8oH
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/-Depqw3G35}
   */
  function screenAssessmentRendered(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Screen Assessment Rendered", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "-Depqw3G35", "fca461c9321e95051cc18f09836b255d3c326fd09b781382104703b6f1ed662b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Screen Assessment Rendered", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("-Depqw3G35", "Screen Assessment Rendered", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Screen Assessment Rendered': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Screen Assessment Rendered", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "-Depqw3G35", "fca461c9321e95051cc18f09836b255d3c326fd09b781382104703b6f1ed662b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Screen Assessment Rendered", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Visited Assignment Tab: event gets fired when user visits the report default - track curriculum assignment from math or english
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/kYJf2tk2d1/trigger/sbCk9unMD
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/kYJf2tk2d1}
   */
  function visitedAssignmentTab(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Visited Assignment Tab", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "fromPage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "kYJf2tk2d1", "f3983eeaf1d85cbdfcb6c1af6dd5e4298437f7423a0b84de6065009fd4aed63b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Visited Assignment Tab", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From Page": properties.fromPage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("kYJf2tk2d1", "Visited Assignment Tab", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Visited Assignment Tab': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Visited Assignment Tab", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From Page": properties.fromPage,
          "Screen Height": sysScreenHeight,
          }, "kYJf2tk2d1", "f3983eeaf1d85cbdfcb6c1af6dd5e4298437f7423a0b84de6065009fd4aed63b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Visited Assignment Tab", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From Page": properties.fromPage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Screen Assignment Rendered: Track curriculum assignment screen loads successfully on click
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/CAMe4UKNuS/trigger/4aBw0mNlF
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/CAMe4UKNuS}
   */
  function screenAssignmentRendered(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Screen Assignment Rendered", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "CAMe4UKNuS", "ab069200157ad73b4a1f691b9a21916546bd28371e6ee9ce56f3b12851487671", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Screen Assignment Rendered", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("CAMe4UKNuS", "Screen Assignment Rendered", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Screen Assignment Rendered': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Screen Assignment Rendered", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "CAMe4UKNuS", "ab069200157ad73b4a1f691b9a21916546bd28371e6ee9ce56f3b12851487671");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Screen Assignment Rendered", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Clicked Assessment Reports: Event gets fired when user clicks on track assessment
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/zjK72JlvsM/trigger/vAWQ9wD9m
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/zjK72JlvsM}
   */
  function clickedAssessmentReports(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Clicked Assessment Reports", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "fromPage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "zjK72JlvsM", "e66c1a0fb7bef0c9c3651676c61a8c7965bf27c1c15f0ec896f0fdf7506c39fb", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Clicked Assessment Reports", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From Page": properties.fromPage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("zjK72JlvsM", "Clicked Assessment Reports", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Clicked Assessment Reports': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Clicked Assessment Reports", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From Page": properties.fromPage,
          "Screen Height": sysScreenHeight,
          }, "zjK72JlvsM", "e66c1a0fb7bef0c9c3651676c61a8c7965bf27c1c15f0ec896f0fdf7506c39fb");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Clicked Assessment Reports", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From Page": properties.fromPage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Visited Reports Tab: user reaches curriculum student report and page loads successfully.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/loRU3m17_W/trigger/BFgZDCEt8
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/loRU3m17_W}
   */
  function visitedReportsTab(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Visited Reports Tab", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "fromPage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "loRU3m17_W", "493205e0a0c165fc90ce40cc435af50346cbe8b0b6b81bcfcb5bce741a9740c6", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Visited Reports Tab", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From Page": properties.fromPage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("loRU3m17_W", "Visited Reports Tab", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Visited Reports Tab': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Visited Reports Tab", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From Page": properties.fromPage,
          "Screen Height": sysScreenHeight,
          }, "loRU3m17_W", "493205e0a0c165fc90ce40cc435af50346cbe8b0b6b81bcfcb5bce741a9740c6");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Visited Reports Tab", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From Page": properties.fromPage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Visited Grid Report: event gets fired when class progress - curriculum report loads successfully
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/GdzQacpU_K/trigger/CgmY3z0jw
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/GdzQacpU_K}
   */
  function visitedGridReport(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Visited Grid Report", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "fromPage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "GdzQacpU_K", "c829d998e62268e0e44374b936d32729ea9c61b87aca17a2e58797630e564d8f", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Visited Grid Report", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From Page": properties.fromPage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("GdzQacpU_K", "Visited Grid Report", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Visited Grid Report': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Visited Grid Report", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From Page": properties.fromPage,
          "Screen Height": sysScreenHeight,
          }, "GdzQacpU_K", "c829d998e62268e0e44374b936d32729ea9c61b87aca17a2e58797630e564d8f");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Visited Grid Report", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From Page": properties.fromPage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Visited Daily Activity Report Tab: User sees the daily activity reports page
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/XBeJ9F-na-/trigger/g_SS79ukK
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * @param {int} properties.daysSinceClassCreation - Self explanatory
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/XBeJ9F-na-}
   */
  function visitedDailyActivityReportTab(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertDaysSinceClassCreation(properties.daysSinceClassCreation));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Visited Daily Activity Report Tab", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "fromPage",
        "daysSinceClassCreation"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "XBeJ9F-na-", "d28d410f97be4269161463534bfd3c829af03f32e1b6961423342938a64b1d93", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Visited Daily Activity Report Tab", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From Page": properties.fromPage,
        "Days Since Class Creation": properties.daysSinceClassCreation,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("XBeJ9F-na-", "Visited Daily Activity Report Tab", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "TuspgTIuZ1", name: "Days Since Class Creation", value: properties.daysSinceClassCreation},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Visited Daily Activity Report Tab': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Visited Daily Activity Report Tab", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From Page": properties.fromPage,
          "Days Since Class Creation": properties.daysSinceClassCreation,
          "Screen Height": sysScreenHeight,
          }, "XBeJ9F-na-", "d28d410f97be4269161463534bfd3c829af03f32e1b6961423342938a64b1d93");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Visited Daily Activity Report Tab", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From Page": properties.fromPage,
      "Days Since Class Creation": properties.daysSinceClassCreation,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Visited Student Center: User reaches student center page.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/8hUSeBEQ-8/trigger/dQG9i3PE-
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.section - This will capture the widget name that is being viewed/interacted by the user in that viewport. For example, 'Onboarding Widget', 'Home Access Widget', 'Assignment Widget', 'Assessment Widget', 'Math Fact Widget'
The list will only have 1 value for 'Section' property for Interacted event.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/8hUSeBEQ-8}
   */
  function visitedStudentCenter(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertSection(properties.section));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Visited Student Center", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "section"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "8hUSeBEQ-8", "f321d8f857b46fa250a11d52d2911b718f1f2a9951256e8e96eab5ce68bb460b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Visited Student Center", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Section": properties.section,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("8hUSeBEQ-8", "Visited Student Center", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "my9qL7M8w6", name: "Section", value: properties.section},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Visited Student Center': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Visited Student Center", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Section": properties.section,
          "Screen Height": sysScreenHeight,
          }, "8hUSeBEQ-8", "f321d8f857b46fa250a11d52d2911b718f1f2a9951256e8e96eab5ce68bb460b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Visited Student Center", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Section": properties.section,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Clicked on Profile Icon: User clicks on teacher space.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/-Fu5ZgPsP6/trigger/AY7suT-1M
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/-Fu5ZgPsP6}
   */
  function clickedOnProfileIcon(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Clicked on Profile Icon", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "-Fu5ZgPsP6", "f283ea3fe3f4be018c6a1ad88e67e59b47f0423de62c5f7388c08f33531e0d08", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Clicked on Profile Icon", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("-Fu5ZgPsP6", "Clicked on Profile Icon", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Clicked on Profile Icon': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Clicked on Profile Icon", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "-Fu5ZgPsP6", "f283ea3fe3f4be018c6a1ad88e67e59b47f0423de62c5f7388c08f33531e0d08");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Clicked on Profile Icon", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Edit Profile Page [B2B]: User reaches on and views edit profile page
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/SL44_ks8w4/trigger/vL5ZAtK0g
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/SL44_ks8w4}
   */
  function viewedEditProfilePageB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Edit Profile Page [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "SL44_ks8w4", "9a728d89d9a011887892172eab5b02012b743440c3a3a996227628eb20c9a8b1", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Edit Profile Page [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("SL44_ks8w4", "Viewed Edit Profile Page [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Edit Profile Page [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Edit Profile Page [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "SL44_ks8w4", "9a728d89d9a011887892172eab5b02012b743440c3a3a996227628eb20c9a8b1");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Edit Profile Page [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Refer Splashlearn Page [B2B]: User reaches on and views refer Splashlearn page
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/xGaNPdqNAQ/trigger/xsrYf76Mq
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/xGaNPdqNAQ}
   */
  function viewedReferSplashlearnPageB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Refer Splashlearn Page [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "fromPage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "xGaNPdqNAQ", "6b69d3035c3f51f8d44ad621d5a00a842ee63f4bcd545cede69ec441adbfc0fb", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Refer Splashlearn Page [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From Page": properties.fromPage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("xGaNPdqNAQ", "Viewed Refer Splashlearn Page [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Refer Splashlearn Page [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Refer Splashlearn Page [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From Page": properties.fromPage,
          "Screen Height": sysScreenHeight,
          }, "xGaNPdqNAQ", "6b69d3035c3f51f8d44ad621d5a00a842ee63f4bcd545cede69ec441adbfc0fb");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Refer Splashlearn Page [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From Page": properties.fromPage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Community [B2B]: User reaches on and views community page
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/j7daluF66u/trigger/1Xm-y_WJQ
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/j7daluF66u}
   */
  function viewedCommunityB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Community [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "j7daluF66u", "cf8eb317aebbda93d38a9cc9fabe011eaae57435ef7439330ecb59d55cbdf54e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Community [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("j7daluF66u", "Viewed Community [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Community [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Community [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "j7daluF66u", "cf8eb317aebbda93d38a9cc9fabe011eaae57435ef7439330ecb59d55cbdf54e");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Community [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Manage Roster Page [B2B]: event gets fired when manage roster page loads successfully.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/NUQXq8YiC/trigger/o2fCZSt3l
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/NUQXq8YiC}
   */
  function viewedManageRosterPageB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Manage Roster Page [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "fromPage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "NUQXq8YiC", "9fdec6f1ba7b564571cdeec34b1000e90df0db88ffa519165098a70e639e3e1a", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Manage Roster Page [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From Page": properties.fromPage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("NUQXq8YiC", "Viewed Manage Roster Page [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Manage Roster Page [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Manage Roster Page [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From Page": properties.fromPage,
          "Screen Height": sysScreenHeight,
          }, "NUQXq8YiC", "9fdec6f1ba7b564571cdeec34b1000e90df0db88ffa519165098a70e639e3e1a");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Manage Roster Page [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From Page": properties.fromPage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Clicked Manage Roster: User clicks on student roster action. 
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/zlq2XDRBQc/trigger/kbGrWYkTm
   * 2. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/zlq2XDRBQc/trigger/LRvgqmcnN
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/zlq2XDRBQc}
   */
  function clickedManageRoster(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Clicked Manage Roster", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "zlq2XDRBQc", "9f23df1036f1aa64fafb8cb1767f953e2fe08067cefd6a7b9eedf006293894d5", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Clicked Manage Roster", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("zlq2XDRBQc", "Clicked Manage Roster", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Clicked Manage Roster': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Clicked Manage Roster", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "zlq2XDRBQc", "9f23df1036f1aa64fafb8cb1767f953e2fe08067cefd6a7b9eedf006293894d5");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Clicked Manage Roster", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Edit Profile Page [B2B]: User takes any action on edit profile page
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/U5jIGNbBn/trigger/VUDRQRsR_
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/U5jIGNbBn}
   */
  function interactedEditProfilePageB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Edit Profile Page [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "U5jIGNbBn", "8b740e02a823cbf1436162f7e88c3af73b589cd9735016b437689d42db8bae58", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Edit Profile Page [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("U5jIGNbBn", "Interacted Edit Profile Page [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Edit Profile Page [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Edit Profile Page [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "U5jIGNbBn", "8b740e02a823cbf1436162f7e88c3af73b589cd9735016b437689d42db8bae58");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Edit Profile Page [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Refer Splashlearn Page [B2B]: User takes any action on referral page
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Enh4btUNxs/trigger/NvwtJipWT
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Enh4btUNxs}
   */
  function interactedReferSplashlearnPageB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Refer Splashlearn Page [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Enh4btUNxs", "8aff3c66934647fb48b1c07720ed39480918af2c3414ad98fa4915cce0f7829d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Refer Splashlearn Page [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Enh4btUNxs", "Interacted Refer Splashlearn Page [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Refer Splashlearn Page [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Refer Splashlearn Page [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "Enh4btUNxs", "8aff3c66934647fb48b1c07720ed39480918af2c3414ad98fa4915cce0f7829d");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Refer Splashlearn Page [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Clicked Classroom Settings: When user clicks on class settings page
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/qSPX64ftMh/trigger/K7y9yZiAx
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/qSPX64ftMh}
   */
  function clickedClassroomSettings(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Clicked Classroom Settings", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "qSPX64ftMh", "c1cb427d19115d4de2bbecb5208606471d68f98da81161c1ec8d65fab27c4a23", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Clicked Classroom Settings", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("qSPX64ftMh", "Clicked Classroom Settings", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Clicked Classroom Settings': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Clicked Classroom Settings", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "qSPX64ftMh", "c1cb427d19115d4de2bbecb5208606471d68f98da81161c1ec8d65fab27c4a23");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Clicked Classroom Settings", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Classroom Settings: When user lands on class settings page
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/a7TnWdS2fd/trigger/mpgodasbQ
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/a7TnWdS2fd}
   */
  function viewedClassroomSettings(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Classroom Settings", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "a7TnWdS2fd", "7f4656f1773d521dd07ce54a5d4927d2b28282285e90de1879854a6b7af93eca", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Classroom Settings", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("a7TnWdS2fd", "Viewed Classroom Settings", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Classroom Settings': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Classroom Settings", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "a7TnWdS2fd", "7f4656f1773d521dd07ce54a5d4927d2b28282285e90de1879854a6b7af93eca");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Classroom Settings", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Student Login Instructions Popup: events gets fired when user views student login instructions pop-up
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/DGhURmCM_1/trigger/fyb7UDTkH
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * @param {string} properties.section - This will capture the widget name that is being viewed/interacted by the user in that viewport. For example, 'Onboarding Widget', 'Home Access Widget', 'Assignment Widget', 'Assessment Widget', 'Math Fact Widget'
The list will only have 1 value for 'Section' property for Interacted event.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/DGhURmCM_1}
   */
  function viewedStudentLoginInstructionsPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertSection(properties.section));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Student Login Instructions Popup", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "fromPage",
        "section"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "DGhURmCM_1", "fdad7dac8dcffc6c686e49ea75879ec40d69a49cb6ed476414e9bb355224259a", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Student Login Instructions Popup", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From Page": properties.fromPage,
        "Section": properties.section,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("DGhURmCM_1", "Viewed Student Login Instructions Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "my9qL7M8w6", name: "Section", value: properties.section},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Student Login Instructions Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Student Login Instructions Popup", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From Page": properties.fromPage,
          "Section": properties.section,
          "Screen Height": sysScreenHeight,
          }, "DGhURmCM_1", "fdad7dac8dcffc6c686e49ea75879ec40d69a49cb6ed476414e9bb355224259a");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Student Login Instructions Popup", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From Page": properties.fromPage,
      "Section": properties.section,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Visited Home Access: event gets fired when user views the home access page
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/phd0URxGqy/trigger/heIRz-DCM
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/phd0URxGqy}
   */
  function visitedHomeAccess(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Visited Home Access", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "fromPage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "phd0URxGqy", "d6d46fd08baf11eb2304e44e9437b66ad19e92564a7bcad16e14925e41f30642", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Visited Home Access", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From Page": properties.fromPage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("phd0URxGqy", "Visited Home Access", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Visited Home Access': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Visited Home Access", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From Page": properties.fromPage,
          "Screen Height": sysScreenHeight,
          }, "phd0URxGqy", "d6d46fd08baf11eb2304e44e9437b66ad19e92564a7bcad16e14925e41f30642");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Visited Home Access", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From Page": properties.fromPage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Home Access Page: Event gets fired when user click on any action on home access page
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/auKooakVFX/trigger/1SFbPJ0Jq
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/auKooakVFX}
   */
  function interactedHomeAccessPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Home Access Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "auKooakVFX", "089920fdf2c76b21411772409c1005b96bc6a1edfc5f92523bde98349b21b14e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Home Access Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("auKooakVFX", "Interacted Home Access Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Home Access Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Home Access Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "auKooakVFX", "089920fdf2c76b21411772409c1005b96bc6a1edfc5f92523bde98349b21b14e");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Home Access Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Avatar Changing Room: With the new gamification project, we are introducing avatar flow where children can create there avatar. It starts with Avatar changing room and then they have multiple options for personalising avatar & purchase stuffs.
   * 
   * When to trigger this event:
   * 1. When user lands on the avatar changing room
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/sqUocVLzqB/trigger/KAi2Q_T32
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {int} properties.snCount - This stores the count of super novas a child has
   * @param {int} properties.childLevel - This stores the level of the child
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.pendingMemory - This property stores the memory remaining at the current page. It will be used to debug the tech issues.

   * @param {float} properties.totalMemory - This property stores the total memory allocated by the client device
   * @param {float} properties.memoryLimit - The max memory allocated by the client device
   * @param {float} properties.memoryUsagePercentage - This property stores the % used memory
   * @param {float} properties.usedMemory - This property stores the memory consumed by the website
   * @param {string} properties.notificationSource - This property will store the source of the notification -> if it has come from intrusive nudge or subtle nudge (will come later) for avatar items
   * @param {bool} properties.pendingNotification - This property shows if there is any notification in the closer space. Notifications will be shown in the form of numbers on the category which got some new items unlocked. Stores Yes/No
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/sqUocVLzqB}
   */
  function viewedAvatarChangingRoom(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertSnCount(properties.snCount));
      messages = messages.concat(assertChildLevel(properties.childLevel));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertPendingMemory(properties.pendingMemory));
      messages = messages.concat(assertTotalMemory(properties.totalMemory));
      messages = messages.concat(assertMemoryLimit(properties.memoryLimit));
      messages = messages.concat(assertMemoryUsagePercentage(properties.memoryUsagePercentage));
      messages = messages.concat(assertUsedMemory(properties.usedMemory));
      messages = messages.concat(assertNotificationSource(properties.notificationSource));
      messages = messages.concat(assertPendingNotification(properties.pendingNotification));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Avatar Changing Room", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "snCount",
        "childLevel",
        "from",
        "grade",
        "elaGrade",
        "pendingMemory",
        "totalMemory",
        "memoryLimit",
        "memoryUsagePercentage",
        "usedMemory",
        "notificationSource",
        "pendingNotification"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "sqUocVLzqB", "65669b8162628e05a8a11599b94f28d6ca05c231474ce5773514633f6b992178", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Avatar Changing Room", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Sn Count": properties.snCount,
        "Child Level": properties.childLevel,
        "From": properties.from,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Pending Memory": properties.pendingMemory,
        "Total Memory": properties.totalMemory,
        "Memory Limit": properties.memoryLimit,
        "Memory Usage Percentage": properties.memoryUsagePercentage,
        "Used Memory": properties.usedMemory,
        "Notification Source": properties.notificationSource,
        "Pending Notification": properties.pendingNotification,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("sqUocVLzqB", "Viewed Avatar Changing Room", messages, [
        {id: "0zT29qODq6yxzJjbmuRzz", name: "Notification Source", value: properties.notificationSource},
        {id: "2hMTTBgU30", name: "Total Memory", value: properties.totalMemory},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "ADfS21LlJH", name: "Memory Limit", value: properties.memoryLimit},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "C_BFBZn2V", name: "Pending Memory", value: properties.pendingMemory},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "fIB6sY9mt", name: "Child Level", value: properties.childLevel},
        {id: "fXWDPkk_PZ", name: "Memory Usage Percentage", value: properties.memoryUsagePercentage},
        {id: "ggXrRwik-", name: "Sn Count", value: properties.snCount},
        {id: "gvDk2xQI4d", name: "Used Memory", value: properties.usedMemory},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "zCFxLL-Ai", name: "Pending Notification", value: properties.pendingNotification},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Avatar Changing Room': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Avatar Changing Room", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Sn Count": properties.snCount,
          "Child Level": properties.childLevel,
          "From": properties.from,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Pending Memory": properties.pendingMemory,
          "Total Memory": properties.totalMemory,
          "Memory Limit": properties.memoryLimit,
          "Memory Usage Percentage": properties.memoryUsagePercentage,
          "Used Memory": properties.usedMemory,
          "Notification Source": properties.notificationSource,
          "Pending Notification": properties.pendingNotification,
          "Screen Height": sysScreenHeight,
          }, "sqUocVLzqB", "65669b8162628e05a8a11599b94f28d6ca05c231474ce5773514633f6b992178");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Avatar Changing Room", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Sn Count": properties.snCount,
      "Child Level": properties.childLevel,
      "From": properties.from,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Pending Memory": properties.pendingMemory,
      "Total Memory": properties.totalMemory,
      "Memory Limit": properties.memoryLimit,
      "Memory Usage Percentage": properties.memoryUsagePercentage,
      "Used Memory": properties.usedMemory,
      "Notification Source": properties.notificationSource,
      "Pending Notification": properties.pendingNotification,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Avatar Changing Room: This event is being created to track the interactions on the avatar changing room.
   * 
   * When to trigger this event:
   * 1. When user clicks on anything on the avatar changing room.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/0ieUNJgi4p/trigger/83dJ7HkLJ
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {int} properties.childLevel - This stores the level of the child
   * @param {int} properties.snCount - This stores the count of super novas a child has
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} [properties.pendingMemory] - This property stores the memory remaining at the current page. It will be used to debug the tech issues.

   * @param {string} properties.notificationSource - This property will store the source of the notification -> if it has come from intrusive nudge or subtle nudge (will come later) for avatar items
   * @param {bool} properties.pendingNotification - This property shows if there is any notification in the closer space. Notifications will be shown in the form of numbers on the category which got some new items unlocked. Stores Yes/No
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/0ieUNJgi4p}
   */
  function interactedAvatarChangingRoom(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertChildLevel(properties.childLevel));
      messages = messages.concat(assertSnCount(properties.snCount));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertOptionalPendingMemory(properties.pendingMemory));
      messages = messages.concat(assertNotificationSource(properties.notificationSource));
      messages = messages.concat(assertPendingNotification(properties.pendingNotification));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Avatar Changing Room", Object.keys(properties), [
        "mathGrade",
        "mode",
        "platform",
        "userType",
        "signupFlow",
        "childLevel",
        "snCount",
        "clickedOn",
        "grade",
        "elaGrade",
        "pendingMemory",
        "notificationSource",
        "pendingNotification"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "0ieUNJgi4p", "95058dc5693ae82aeb67b7dc2a22a6fd4f28bf6f76d538a112b81b69fefd1300", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Avatar Changing Room", {
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Child Level": properties.childLevel,
        "Sn Count": properties.snCount,
        "Clicked On": properties.clickedOn,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Pending Memory": properties.pendingMemory,
        "Notification Source": properties.notificationSource,
        "Pending Notification": properties.pendingNotification,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("0ieUNJgi4p", "Interacted Avatar Changing Room", messages, [
        {id: "0zT29qODq6yxzJjbmuRzz", name: "Notification Source", value: properties.notificationSource},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "C_BFBZn2V", name: "Pending Memory", value: properties.pendingMemory},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "fIB6sY9mt", name: "Child Level", value: properties.childLevel},
        {id: "ggXrRwik-", name: "Sn Count", value: properties.snCount},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "zCFxLL-Ai", name: "Pending Notification", value: properties.pendingNotification},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Avatar Changing Room': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Avatar Changing Room", {
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Child Level": properties.childLevel,
          "Sn Count": properties.snCount,
          "Clicked On": properties.clickedOn,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Pending Memory": properties.pendingMemory,
          "Notification Source": properties.notificationSource,
          "Pending Notification": properties.pendingNotification,
          "Screen Height": sysScreenHeight,
          }, "0ieUNJgi4p", "95058dc5693ae82aeb67b7dc2a22a6fd4f28bf6f76d538a112b81b69fefd1300");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Avatar Changing Room", {
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Child Level": properties.childLevel,
      "Sn Count": properties.snCount,
      "Clicked On": properties.clickedOn,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Pending Memory": properties.pendingMemory,
      "Notification Source": properties.notificationSource,
      "Pending Notification": properties.pendingNotification,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Avatar Features Space: This event is associated to the view of the avatar features selection page
   * 
   * When to trigger this event:
   * 1. User lands on the avatar feature selection page
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/q605D8CRMq/trigger/GZ5Cu3iIs
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {int} properties.snCount - This stores the count of super novas a child has
   * @param {int} properties.childLevel - This stores the level of the child
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.pendingMemory - This property stores the memory remaining at the current page. It will be used to debug the tech issues.

   * @param {float} properties.totalMemory - This property stores the total memory allocated by the client device
   * @param {float} properties.memoryLimit - The max memory allocated by the client device
   * @param {float} properties.memoryUsagePercentage - This property stores the % used memory
   * @param {float} properties.usedMemory - This property stores the memory consumed by the website
   * @param {bool} properties.isFtue - This stores yes/no if the user is experiencing FTUE flow
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/q605D8CRMq}
   */
  function viewedAvatarFeaturesSpace(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertSnCount(properties.snCount));
      messages = messages.concat(assertChildLevel(properties.childLevel));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertPendingMemory(properties.pendingMemory));
      messages = messages.concat(assertTotalMemory(properties.totalMemory));
      messages = messages.concat(assertMemoryLimit(properties.memoryLimit));
      messages = messages.concat(assertMemoryUsagePercentage(properties.memoryUsagePercentage));
      messages = messages.concat(assertUsedMemory(properties.usedMemory));
      messages = messages.concat(assertIsFtue(properties.isFtue));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Avatar Features Space", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "from",
        "snCount",
        "childLevel",
        "grade",
        "elaGrade",
        "pendingMemory",
        "totalMemory",
        "memoryLimit",
        "memoryUsagePercentage",
        "usedMemory",
        "isFtue"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "q605D8CRMq", "63ec92eabd47a0c78002083e02707ebeef4dfd9fe97e35fcf7b98b02aafcb18d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Avatar Features Space", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "From": properties.from,
        "Sn Count": properties.snCount,
        "Child Level": properties.childLevel,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Pending Memory": properties.pendingMemory,
        "Total Memory": properties.totalMemory,
        "Memory Limit": properties.memoryLimit,
        "Memory Usage Percentage": properties.memoryUsagePercentage,
        "Used Memory": properties.usedMemory,
        "Is Ftue": properties.isFtue,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("q605D8CRMq", "Viewed Avatar Features Space", messages, [
        {id: "2hMTTBgU30", name: "Total Memory", value: properties.totalMemory},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "ADfS21LlJH", name: "Memory Limit", value: properties.memoryLimit},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "C_BFBZn2V", name: "Pending Memory", value: properties.pendingMemory},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "SGNPV5nP-", name: "Is Ftue", value: properties.isFtue},
        {id: "fIB6sY9mt", name: "Child Level", value: properties.childLevel},
        {id: "fXWDPkk_PZ", name: "Memory Usage Percentage", value: properties.memoryUsagePercentage},
        {id: "ggXrRwik-", name: "Sn Count", value: properties.snCount},
        {id: "gvDk2xQI4d", name: "Used Memory", value: properties.usedMemory},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Avatar Features Space': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Avatar Features Space", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "From": properties.from,
          "Sn Count": properties.snCount,
          "Child Level": properties.childLevel,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Pending Memory": properties.pendingMemory,
          "Total Memory": properties.totalMemory,
          "Memory Limit": properties.memoryLimit,
          "Memory Usage Percentage": properties.memoryUsagePercentage,
          "Used Memory": properties.usedMemory,
          "Is Ftue": properties.isFtue,
          "Screen Height": sysScreenHeight,
          }, "q605D8CRMq", "63ec92eabd47a0c78002083e02707ebeef4dfd9fe97e35fcf7b98b02aafcb18d");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Avatar Features Space", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "From": properties.from,
      "Sn Count": properties.snCount,
      "Child Level": properties.childLevel,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Pending Memory": properties.pendingMemory,
      "Total Memory": properties.totalMemory,
      "Memory Limit": properties.memoryLimit,
      "Memory Usage Percentage": properties.memoryUsagePercentage,
      "Used Memory": properties.usedMemory,
      "Is Ftue": properties.isFtue,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Avatar Features Space: This event is associated to the interactions of the avatar features space
   * 
   * When to trigger this event:
   * 1. User interacts with the elements of this page
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/MKzpm95EH0/trigger/HoWM5stYU
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.featureSelected - This property stores the clicks on the feature of the avatar like hair, blushes, eyes, etc.
   * @param {int} properties.snCount - This stores the count of super novas a child has
   * @param {int} properties.childLevel - This stores the level of the child
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.pendingMemory - This property stores the memory remaining at the current page. It will be used to debug the tech issues.

   * @param {bool} properties.isFtue - This stores yes/no if the user is experiencing FTUE flow
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/MKzpm95EH0}
   */
  function interactedAvatarFeaturesSpace(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertFeatureSelected(properties.featureSelected));
      messages = messages.concat(assertSnCount(properties.snCount));
      messages = messages.concat(assertChildLevel(properties.childLevel));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertPendingMemory(properties.pendingMemory));
      messages = messages.concat(assertIsFtue(properties.isFtue));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Avatar Features Space", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "clickedOn",
        "featureSelected",
        "snCount",
        "childLevel",
        "elaGrade",
        "grade",
        "pendingMemory",
        "isFtue"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "MKzpm95EH0", "4f2e57639cf0848ecfd5de95e0029ba1cd4235c99f64ac46e3268c8717e8d2e5", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Avatar Features Space", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Clicked On": properties.clickedOn,
        "Feature Selected": properties.featureSelected,
        "Sn Count": properties.snCount,
        "Child Level": properties.childLevel,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Pending Memory": properties.pendingMemory,
        "Is Ftue": properties.isFtue,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("MKzpm95EH0", "Interacted Avatar Features Space", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "C_BFBZn2V", name: "Pending Memory", value: properties.pendingMemory},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "SGNPV5nP-", name: "Is Ftue", value: properties.isFtue},
        {id: "fIB6sY9mt", name: "Child Level", value: properties.childLevel},
        {id: "ggXrRwik-", name: "Sn Count", value: properties.snCount},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "xrO01pNoi", name: "Feature Selected", value: properties.featureSelected},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Avatar Features Space': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Avatar Features Space", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Clicked On": properties.clickedOn,
          "Feature Selected": properties.featureSelected,
          "Sn Count": properties.snCount,
          "Child Level": properties.childLevel,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Pending Memory": properties.pendingMemory,
          "Is Ftue": properties.isFtue,
          "Screen Height": sysScreenHeight,
          }, "MKzpm95EH0", "4f2e57639cf0848ecfd5de95e0029ba1cd4235c99f64ac46e3268c8717e8d2e5");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Avatar Features Space", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Clicked On": properties.clickedOn,
      "Feature Selected": properties.featureSelected,
      "Sn Count": properties.snCount,
      "Child Level": properties.childLevel,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Pending Memory": properties.pendingMemory,
      "Is Ftue": properties.isFtue,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Updated Avatar: This event is associated to the Avatar updation - could be first time or updating it later.
   * 
   * When to trigger this event:
   * 1. User hits the All done or save button after making change sin the avatar
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/wIyiRWQRTg/trigger/YJZi9Zm2H
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.hairStyle - Saves the style as per seed
   * @param {string} properties.hairColour - Saves the style as per seed
   * @param {string} properties.faceShape - Saves the style as per seed
   * @param {string} properties.skinColour - Saves the style as per seed
   * @param {string} properties.eyeShape - Saves the style as per seed
   * @param {string} properties.eyeColour - Saves the style as per seed
   * @param {string} properties.blushStyle - Saves the style as per seed
   * @param {string} properties.frameColour - Saves the style as per seed
   * @param {int} properties.childLevel - This stores the level of the child
   * @param {int} properties.snCount - This stores the count of super novas a child has
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {bool} properties.firstTime - This will store yes / no. Yes if user created avatar for the first time. No when user just updated the avatar.
   * @param {string} properties.pendingMemory - This property stores the memory remaining at the current page. It will be used to debug the tech issues.

   * @param {float} properties.totalMemory - This property stores the total memory allocated by the client device
   * @param {float} properties.memoryLimit - The max memory allocated by the client device
   * @param {float} properties.memoryUsagePercentage - This property stores the % used memory
   * @param {float} properties.usedMemory - This property stores the memory consumed by the website
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/wIyiRWQRTg}
   */
  function updatedAvatar(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertHairStyle(properties.hairStyle));
      messages = messages.concat(assertHairColour(properties.hairColour));
      messages = messages.concat(assertFaceShape(properties.faceShape));
      messages = messages.concat(assertSkinColour(properties.skinColour));
      messages = messages.concat(assertEyeShape(properties.eyeShape));
      messages = messages.concat(assertEyeColour(properties.eyeColour));
      messages = messages.concat(assertBlushStyle(properties.blushStyle));
      messages = messages.concat(assertFrameColour(properties.frameColour));
      messages = messages.concat(assertChildLevel(properties.childLevel));
      messages = messages.concat(assertSnCount(properties.snCount));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertFirstTime(properties.firstTime));
      messages = messages.concat(assertPendingMemory(properties.pendingMemory));
      messages = messages.concat(assertTotalMemory(properties.totalMemory));
      messages = messages.concat(assertMemoryLimit(properties.memoryLimit));
      messages = messages.concat(assertMemoryUsagePercentage(properties.memoryUsagePercentage));
      messages = messages.concat(assertUsedMemory(properties.usedMemory));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Updated Avatar", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "hairStyle",
        "hairColour",
        "faceShape",
        "skinColour",
        "eyeShape",
        "eyeColour",
        "blushStyle",
        "frameColour",
        "childLevel",
        "snCount",
        "elaGrade",
        "grade",
        "firstTime",
        "pendingMemory",
        "totalMemory",
        "memoryLimit",
        "memoryUsagePercentage",
        "usedMemory"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "wIyiRWQRTg", "ebd26e739021328a4a3c42a8fd3167a8c64dbb954379b88695eb895696302b54", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Updated Avatar", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Hair Style": properties.hairStyle,
        "Hair Colour": properties.hairColour,
        "Face Shape": properties.faceShape,
        "Skin Colour": properties.skinColour,
        "Eye Shape": properties.eyeShape,
        "Eye Colour": properties.eyeColour,
        "Blush Style": properties.blushStyle,
        "Frame Colour": properties.frameColour,
        "Child Level": properties.childLevel,
        "Sn Count": properties.snCount,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "First Time": properties.firstTime,
        "Pending Memory": properties.pendingMemory,
        "Total Memory": properties.totalMemory,
        "Memory Limit": properties.memoryLimit,
        "Memory Usage Percentage": properties.memoryUsagePercentage,
        "Used Memory": properties.usedMemory,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("wIyiRWQRTg", "Updated Avatar", messages, [
        {id: "2hMTTBgU30", name: "Total Memory", value: properties.totalMemory},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3o26B0SjY", name: "Hair Colour", value: properties.hairColour},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "7HDxveLB0", name: "Frame Colour", value: properties.frameColour},
        {id: "ADfS21LlJH", name: "Memory Limit", value: properties.memoryLimit},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "C_BFBZn2V", name: "Pending Memory", value: properties.pendingMemory},
        {id: "EKclsunCv", name: "Eye Shape", value: properties.eyeShape},
        {id: "FCvVNF6GY", name: "Blush Style", value: properties.blushStyle},
        {id: "GlA8jAx3H", name: "Hair Style", value: properties.hairStyle},
        {id: "PXb4BjQrg", name: "Eye Colour", value: properties.eyeColour},
        {id: "T446VyHk1", name: "Face Shape", value: properties.faceShape},
        {id: "fIB6sY9mt", name: "Child Level", value: properties.childLevel},
        {id: "fXWDPkk_PZ", name: "Memory Usage Percentage", value: properties.memoryUsagePercentage},
        {id: "ggXrRwik-", name: "Sn Count", value: properties.snCount},
        {id: "gvDk2xQI4d", name: "Used Memory", value: properties.usedMemory},
        {id: "hApb_Iria", name: "First Time", value: properties.firstTime},
        {id: "hlzuuiCIe", name: "Skin Colour", value: properties.skinColour},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Updated Avatar': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Updated Avatar", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Hair Style": properties.hairStyle,
          "Hair Colour": properties.hairColour,
          "Face Shape": properties.faceShape,
          "Skin Colour": properties.skinColour,
          "Eye Shape": properties.eyeShape,
          "Eye Colour": properties.eyeColour,
          "Blush Style": properties.blushStyle,
          "Frame Colour": properties.frameColour,
          "Child Level": properties.childLevel,
          "Sn Count": properties.snCount,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "First Time": properties.firstTime,
          "Pending Memory": properties.pendingMemory,
          "Total Memory": properties.totalMemory,
          "Memory Limit": properties.memoryLimit,
          "Memory Usage Percentage": properties.memoryUsagePercentage,
          "Used Memory": properties.usedMemory,
          "Screen Height": sysScreenHeight,
          }, "wIyiRWQRTg", "ebd26e739021328a4a3c42a8fd3167a8c64dbb954379b88695eb895696302b54");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Updated Avatar", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Hair Style": properties.hairStyle,
      "Hair Colour": properties.hairColour,
      "Face Shape": properties.faceShape,
      "Skin Colour": properties.skinColour,
      "Eye Shape": properties.eyeShape,
      "Eye Colour": properties.eyeColour,
      "Blush Style": properties.blushStyle,
      "Frame Colour": properties.frameColour,
      "Child Level": properties.childLevel,
      "Sn Count": properties.snCount,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "First Time": properties.firstTime,
      "Pending Memory": properties.pendingMemory,
      "Total Memory": properties.totalMemory,
      "Memory Limit": properties.memoryLimit,
      "Memory Usage Percentage": properties.memoryUsagePercentage,
      "Used Memory": properties.usedMemory,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Closet Space: This event is associated to the views of the closet space
   * 
   * When to trigger this event:
   * 1. When this page loads for the user
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/04Uge8tkF7/trigger/OYx8intGS
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {bool} properties.pendingNotification - This property shows if there is any notification in the closer space. Notifications will be shown in the form of numbers on the category which got some new items unlocked. Stores Yes/No
   * @param {int} properties.snCount - This stores the count of super novas a child has
   * @param {int} properties.childLevel - This stores the level of the child
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {int} properties.countOfForSaleItems - This property stores number of items available for sale. That means total items - locked items - already purchased items.

This could be 0 as well if everything available has already been purchased.
   * @param {string} properties.availableCategories - This property stores the categories to which for sale items belong. For example if there are 3 for sale items and one of them is Hat & 2 are from shirts. Then it will show
hat | shirt
   * @param {string} [properties.pendingMemory] - This property stores the memory remaining at the current page. It will be used to debug the tech issues.

   * @param {float} properties.totalMemory - This property stores the total memory allocated by the client device
   * @param {float} properties.memoryLimit - The max memory allocated by the client device
   * @param {float} properties.memoryUsagePercentage - This property stores the % used memory
   * @param {float} properties.usedMemory - This property stores the memory consumed by the website
   * @param {bool} properties.isFtue - This stores yes/no if the user is experiencing FTUE flow
   * @param {string} properties.notificationSource - This property will store the source of the notification -> if it has come from intrusive nudge or subtle nudge (will come later) for avatar items
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/04Uge8tkF7}
   */
  function viewedClosetSpace(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertPendingNotification(properties.pendingNotification));
      messages = messages.concat(assertSnCount(properties.snCount));
      messages = messages.concat(assertChildLevel(properties.childLevel));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertCountOfForSaleItems(properties.countOfForSaleItems));
      messages = messages.concat(assertAvailableCategories(properties.availableCategories));
      messages = messages.concat(assertOptionalPendingMemory(properties.pendingMemory));
      messages = messages.concat(assertTotalMemory(properties.totalMemory));
      messages = messages.concat(assertMemoryLimit(properties.memoryLimit));
      messages = messages.concat(assertMemoryUsagePercentage(properties.memoryUsagePercentage));
      messages = messages.concat(assertUsedMemory(properties.usedMemory));
      messages = messages.concat(assertIsFtue(properties.isFtue));
      messages = messages.concat(assertNotificationSource(properties.notificationSource));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Closet Space", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "elaGrade",
        "grade",
        "pendingNotification",
        "snCount",
        "childLevel",
        "from",
        "countOfForSaleItems",
        "availableCategories",
        "pendingMemory",
        "totalMemory",
        "memoryLimit",
        "memoryUsagePercentage",
        "usedMemory",
        "isFtue",
        "notificationSource"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "04Uge8tkF7", "86524d40efe2fb031b857ba4c78181b5234b4a9590f92a4224668957330fb4be", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Closet Space", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Pending Notification": properties.pendingNotification,
        "Sn Count": properties.snCount,
        "Child Level": properties.childLevel,
        "From": properties.from,
        "Count of for Sale Items": properties.countOfForSaleItems,
        "Available Categories": properties.availableCategories,
        "Pending Memory": properties.pendingMemory,
        "Total Memory": properties.totalMemory,
        "Memory Limit": properties.memoryLimit,
        "Memory Usage Percentage": properties.memoryUsagePercentage,
        "Used Memory": properties.usedMemory,
        "Is Ftue": properties.isFtue,
        "Notification Source": properties.notificationSource,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("04Uge8tkF7", "Viewed Closet Space", messages, [
        {id: "0zT29qODq6yxzJjbmuRzz", name: "Notification Source", value: properties.notificationSource},
        {id: "2hMTTBgU30", name: "Total Memory", value: properties.totalMemory},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "7TW4Q4Izl", name: "Count of for Sale Items", value: properties.countOfForSaleItems},
        {id: "ADfS21LlJH", name: "Memory Limit", value: properties.memoryLimit},
        {id: "AyInbeAyU", name: "Available Categories", value: properties.availableCategories},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "C_BFBZn2V", name: "Pending Memory", value: properties.pendingMemory},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "SGNPV5nP-", name: "Is Ftue", value: properties.isFtue},
        {id: "fIB6sY9mt", name: "Child Level", value: properties.childLevel},
        {id: "fXWDPkk_PZ", name: "Memory Usage Percentage", value: properties.memoryUsagePercentage},
        {id: "ggXrRwik-", name: "Sn Count", value: properties.snCount},
        {id: "gvDk2xQI4d", name: "Used Memory", value: properties.usedMemory},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "zCFxLL-Ai", name: "Pending Notification", value: properties.pendingNotification},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Closet Space': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Closet Space", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Pending Notification": properties.pendingNotification,
          "Sn Count": properties.snCount,
          "Child Level": properties.childLevel,
          "From": properties.from,
          "Count of for Sale Items": properties.countOfForSaleItems,
          "Available Categories": properties.availableCategories,
          "Pending Memory": properties.pendingMemory,
          "Total Memory": properties.totalMemory,
          "Memory Limit": properties.memoryLimit,
          "Memory Usage Percentage": properties.memoryUsagePercentage,
          "Used Memory": properties.usedMemory,
          "Is Ftue": properties.isFtue,
          "Notification Source": properties.notificationSource,
          "Screen Height": sysScreenHeight,
          }, "04Uge8tkF7", "86524d40efe2fb031b857ba4c78181b5234b4a9590f92a4224668957330fb4be");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Closet Space", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Pending Notification": properties.pendingNotification,
      "Sn Count": properties.snCount,
      "Child Level": properties.childLevel,
      "From": properties.from,
      "Count of for Sale Items": properties.countOfForSaleItems,
      "Available Categories": properties.availableCategories,
      "Pending Memory": properties.pendingMemory,
      "Total Memory": properties.totalMemory,
      "Memory Limit": properties.memoryLimit,
      "Memory Usage Percentage": properties.memoryUsagePercentage,
      "Used Memory": properties.usedMemory,
      "Is Ftue": properties.isFtue,
      "Notification Source": properties.notificationSource,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Closet Space: This event is associated to the interactions in the closet space.
   * 
   * When to trigger this event:
   * 1. The event gets fired when user clicks / taps on the elements of this page.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/6zrX2QgbHe/trigger/5TVza1m89
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {int} properties.snCount - This stores the count of super novas a child has
   * @param {int} properties.childLevel - This stores the level of the child
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.categoryName - For Book Library
Category of the books like Animals, People and Culture etc

For Avatar Space
This property stores the categories within closer such as shirt, pant, goggles, hat, etc.

   * @param {int} properties.countOfForSaleItems - This property stores number of items available for sale. That means total items - locked items - already purchased items.

This could be 0 as well if everything available has already been purchased.
   * @param {string} properties.pendingMemory - This property stores the memory remaining at the current page. It will be used to debug the tech issues.

   * @param {string} properties.itemStyle - This property will store the style codes of the items purchased in pipe separated format.
   * @param {string} properties.notificationSource - This property will store the source of the notification -> if it has come from intrusive nudge or subtle nudge (will come later) for avatar items
   * @param {bool} properties.pendingNotification - This property shows if there is any notification in the closer space. Notifications will be shown in the form of numbers on the category which got some new items unlocked. Stores Yes/No
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/6zrX2QgbHe}
   */
  function interactedClosetSpace(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertSnCount(properties.snCount));
      messages = messages.concat(assertChildLevel(properties.childLevel));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertCategoryName(properties.categoryName));
      messages = messages.concat(assertCountOfForSaleItems(properties.countOfForSaleItems));
      messages = messages.concat(assertPendingMemory(properties.pendingMemory));
      messages = messages.concat(assertItemStyle(properties.itemStyle));
      messages = messages.concat(assertNotificationSource(properties.notificationSource));
      messages = messages.concat(assertPendingNotification(properties.pendingNotification));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Closet Space", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "elaGrade",
        "grade",
        "snCount",
        "childLevel",
        "clickedOn",
        "categoryName",
        "countOfForSaleItems",
        "pendingMemory",
        "itemStyle",
        "notificationSource",
        "pendingNotification"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "6zrX2QgbHe", "ca28b51d889e76211ef9ae4621c6f03a447ea1bdfc56cc69efe13a06ae7d2219", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Closet Space", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Sn Count": properties.snCount,
        "Child Level": properties.childLevel,
        "Clicked On": properties.clickedOn,
        "Category Name": properties.categoryName,
        "Count of for Sale Items": properties.countOfForSaleItems,
        "Pending Memory": properties.pendingMemory,
        "Item Style": properties.itemStyle,
        "Notification Source": properties.notificationSource,
        "Pending Notification": properties.pendingNotification,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("6zrX2QgbHe", "Interacted Closet Space", messages, [
        {id: "0zT29qODq6yxzJjbmuRzz", name: "Notification Source", value: properties.notificationSource},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "7TW4Q4Izl", name: "Count of for Sale Items", value: properties.countOfForSaleItems},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "C_BFBZn2V", name: "Pending Memory", value: properties.pendingMemory},
        {id: "FkHymvGjK", name: "Item Style", value: properties.itemStyle},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "fIB6sY9mt", name: "Child Level", value: properties.childLevel},
        {id: "ggXrRwik-", name: "Sn Count", value: properties.snCount},
        {id: "kZQO8-HD9", name: "Category Name", value: properties.categoryName},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "zCFxLL-Ai", name: "Pending Notification", value: properties.pendingNotification},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Closet Space': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Closet Space", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Sn Count": properties.snCount,
          "Child Level": properties.childLevel,
          "Clicked On": properties.clickedOn,
          "Category Name": properties.categoryName,
          "Count of for Sale Items": properties.countOfForSaleItems,
          "Pending Memory": properties.pendingMemory,
          "Item Style": properties.itemStyle,
          "Notification Source": properties.notificationSource,
          "Pending Notification": properties.pendingNotification,
          "Screen Height": sysScreenHeight,
          }, "6zrX2QgbHe", "ca28b51d889e76211ef9ae4621c6f03a447ea1bdfc56cc69efe13a06ae7d2219");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Closet Space", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Sn Count": properties.snCount,
      "Child Level": properties.childLevel,
      "Clicked On": properties.clickedOn,
      "Category Name": properties.categoryName,
      "Count of for Sale Items": properties.countOfForSaleItems,
      "Pending Memory": properties.pendingMemory,
      "Item Style": properties.itemStyle,
      "Notification Source": properties.notificationSource,
      "Pending Notification": properties.pendingNotification,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Gadget Space: This event is associated to the views of the gadget space.
   * 
   * When to trigger this event:
   * 1. This event gets fired when user lands on this page.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/1vHQkDavRu/trigger/khXjldNY0
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {int} properties.snCount - This stores the count of super novas a child has
   * @param {int} properties.childLevel - This stores the level of the child
   * @param {int} properties.countOfForSaleItems - This property stores number of items available for sale. That means total items - locked items - already purchased items.

This could be 0 as well if everything available has already been purchased.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.pendingMemory] - This property stores the memory remaining at the current page. It will be used to debug the tech issues.

   * @param {float} properties.totalMemory - This property stores the total memory allocated by the client device
   * @param {float} properties.memoryLimit - The max memory allocated by the client device
   * @param {float} properties.memoryUsagePercentage - This property stores the % used memory
   * @param {float} properties.usedMemory - This property stores the memory consumed by the website
   * @param {string} properties.notificationSource - This property will store the source of the notification -> if it has come from intrusive nudge or subtle nudge (will come later) for avatar items
   * @param {bool} properties.pendingNotification - This property shows if there is any notification in the closer space. Notifications will be shown in the form of numbers on the category which got some new items unlocked. Stores Yes/No
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/1vHQkDavRu}
   */
  function viewedGadgetSpace(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertSnCount(properties.snCount));
      messages = messages.concat(assertChildLevel(properties.childLevel));
      messages = messages.concat(assertCountOfForSaleItems(properties.countOfForSaleItems));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalPendingMemory(properties.pendingMemory));
      messages = messages.concat(assertTotalMemory(properties.totalMemory));
      messages = messages.concat(assertMemoryLimit(properties.memoryLimit));
      messages = messages.concat(assertMemoryUsagePercentage(properties.memoryUsagePercentage));
      messages = messages.concat(assertUsedMemory(properties.usedMemory));
      messages = messages.concat(assertNotificationSource(properties.notificationSource));
      messages = messages.concat(assertPendingNotification(properties.pendingNotification));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Gadget Space", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "snCount",
        "childLevel",
        "countOfForSaleItems",
        "elaGrade",
        "grade",
        "pendingMemory",
        "totalMemory",
        "memoryLimit",
        "memoryUsagePercentage",
        "usedMemory",
        "notificationSource",
        "pendingNotification"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "1vHQkDavRu", "0cfa9caf9c3ec9f68a87fa59cae8406fa07f41819eb85c33a9bd08c8a7dbc94a", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Gadget Space", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Sn Count": properties.snCount,
        "Child Level": properties.childLevel,
        "Count of for Sale Items": properties.countOfForSaleItems,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Pending Memory": properties.pendingMemory,
        "Total Memory": properties.totalMemory,
        "Memory Limit": properties.memoryLimit,
        "Memory Usage Percentage": properties.memoryUsagePercentage,
        "Used Memory": properties.usedMemory,
        "Notification Source": properties.notificationSource,
        "Pending Notification": properties.pendingNotification,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("1vHQkDavRu", "Viewed Gadget Space", messages, [
        {id: "0zT29qODq6yxzJjbmuRzz", name: "Notification Source", value: properties.notificationSource},
        {id: "2hMTTBgU30", name: "Total Memory", value: properties.totalMemory},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "7TW4Q4Izl", name: "Count of for Sale Items", value: properties.countOfForSaleItems},
        {id: "ADfS21LlJH", name: "Memory Limit", value: properties.memoryLimit},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "C_BFBZn2V", name: "Pending Memory", value: properties.pendingMemory},
        {id: "fIB6sY9mt", name: "Child Level", value: properties.childLevel},
        {id: "fXWDPkk_PZ", name: "Memory Usage Percentage", value: properties.memoryUsagePercentage},
        {id: "ggXrRwik-", name: "Sn Count", value: properties.snCount},
        {id: "gvDk2xQI4d", name: "Used Memory", value: properties.usedMemory},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "zCFxLL-Ai", name: "Pending Notification", value: properties.pendingNotification},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Gadget Space': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Gadget Space", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Sn Count": properties.snCount,
          "Child Level": properties.childLevel,
          "Count of for Sale Items": properties.countOfForSaleItems,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Pending Memory": properties.pendingMemory,
          "Total Memory": properties.totalMemory,
          "Memory Limit": properties.memoryLimit,
          "Memory Usage Percentage": properties.memoryUsagePercentage,
          "Used Memory": properties.usedMemory,
          "Notification Source": properties.notificationSource,
          "Pending Notification": properties.pendingNotification,
          "Screen Height": sysScreenHeight,
          }, "1vHQkDavRu", "0cfa9caf9c3ec9f68a87fa59cae8406fa07f41819eb85c33a9bd08c8a7dbc94a");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Gadget Space", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Sn Count": properties.snCount,
      "Child Level": properties.childLevel,
      "Count of for Sale Items": properties.countOfForSaleItems,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Pending Memory": properties.pendingMemory,
      "Total Memory": properties.totalMemory,
      "Memory Limit": properties.memoryLimit,
      "Memory Usage Percentage": properties.memoryUsagePercentage,
      "Used Memory": properties.usedMemory,
      "Notification Source": properties.notificationSource,
      "Pending Notification": properties.pendingNotification,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Gadget Space: This event is associated to the interactions at the gadget space.
   * 
   * When to trigger this event:
   * 1. User interacts with the different elements of this page.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/reSCoEugCk/trigger/YzQoCmnEv
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {int} properties.snCount - This stores the count of super novas a child has
   * @param {int} properties.childLevel - This stores the level of the child
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {int} properties.countOfForSaleItems - This property stores number of items available for sale. That means total items - locked items - already purchased items.

This could be 0 as well if everything available has already been purchased.
   * @param {string} properties.itemName - This property stores the item names clicked / purcahsed by the user. This can also store values in a pipe separated format if user purchases multiple items.
   * @param {string} properties.pendingMemory - This property stores the memory remaining at the current page. It will be used to debug the tech issues.

   * @param {string} properties.notificationSource - This property will store the source of the notification -> if it has come from intrusive nudge or subtle nudge (will come later) for avatar items
   * @param {bool} properties.pendingNotification - This property shows if there is any notification in the closer space. Notifications will be shown in the form of numbers on the category which got some new items unlocked. Stores Yes/No
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/reSCoEugCk}
   */
  function interactedGadgetSpace(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertSnCount(properties.snCount));
      messages = messages.concat(assertChildLevel(properties.childLevel));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertCountOfForSaleItems(properties.countOfForSaleItems));
      messages = messages.concat(assertItemName(properties.itemName));
      messages = messages.concat(assertPendingMemory(properties.pendingMemory));
      messages = messages.concat(assertNotificationSource(properties.notificationSource));
      messages = messages.concat(assertPendingNotification(properties.pendingNotification));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Gadget Space", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "elaGrade",
        "grade",
        "snCount",
        "childLevel",
        "clickedOn",
        "countOfForSaleItems",
        "itemName",
        "pendingMemory",
        "notificationSource",
        "pendingNotification"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "reSCoEugCk", "95c4a6aaa1d7f6f6e0a99f56641ab1406904c778dcc0fc8019b69491234a6cbf", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Gadget Space", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Sn Count": properties.snCount,
        "Child Level": properties.childLevel,
        "Clicked On": properties.clickedOn,
        "Count of for Sale Items": properties.countOfForSaleItems,
        "Item Name": properties.itemName,
        "Pending Memory": properties.pendingMemory,
        "Notification Source": properties.notificationSource,
        "Pending Notification": properties.pendingNotification,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("reSCoEugCk", "Interacted Gadget Space", messages, [
        {id: "0zT29qODq6yxzJjbmuRzz", name: "Notification Source", value: properties.notificationSource},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "7TW4Q4Izl", name: "Count of for Sale Items", value: properties.countOfForSaleItems},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "C_BFBZn2V", name: "Pending Memory", value: properties.pendingMemory},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "fIB6sY9mt", name: "Child Level", value: properties.childLevel},
        {id: "ggXrRwik-", name: "Sn Count", value: properties.snCount},
        {id: "nSZ12H8zV", name: "Item Name", value: properties.itemName},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "zCFxLL-Ai", name: "Pending Notification", value: properties.pendingNotification},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Gadget Space': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Gadget Space", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Sn Count": properties.snCount,
          "Child Level": properties.childLevel,
          "Clicked On": properties.clickedOn,
          "Count of for Sale Items": properties.countOfForSaleItems,
          "Item Name": properties.itemName,
          "Pending Memory": properties.pendingMemory,
          "Notification Source": properties.notificationSource,
          "Pending Notification": properties.pendingNotification,
          "Screen Height": sysScreenHeight,
          }, "reSCoEugCk", "95c4a6aaa1d7f6f6e0a99f56641ab1406904c778dcc0fc8019b69491234a6cbf");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Gadget Space", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Sn Count": properties.snCount,
      "Child Level": properties.childLevel,
      "Clicked On": properties.clickedOn,
      "Count of for Sale Items": properties.countOfForSaleItems,
      "Item Name": properties.itemName,
      "Pending Memory": properties.pendingMemory,
      "Notification Source": properties.notificationSource,
      "Pending Notification": properties.pendingNotification,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Locked Item Popup: This event is associated to the popups fired when user clicks on the locked items in Closet & Gadget space.
   * 
   * When to trigger this event:
   * 1. This event is triggered when the locked item popup is shown to the users after they click on the locked items in closet & gadget
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/M0_7qx8lqm/trigger/6KjmZ-e_8
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {int} properties.snCount - This stores the count of super novas a child has
   * @param {int} properties.childLevel - This stores the level of the child
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {string} properties.itemStyle - This property will store the style codes of the items purchased in pipe separated format.
   * @param {string} properties.categoryName - For Book Library
Category of the books like Animals, People and Culture etc

For Avatar Space
This property stores the categories within closer such as shirt, pant, goggles, hat, etc.

   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/M0_7qx8lqm}
   */
  function viewedLockedItemPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertSnCount(properties.snCount));
      messages = messages.concat(assertChildLevel(properties.childLevel));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertItemStyle(properties.itemStyle));
      messages = messages.concat(assertCategoryName(properties.categoryName));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Locked Item Popup", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "elaGrade",
        "grade",
        "snCount",
        "childLevel",
        "from",
        "itemStyle",
        "categoryName"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "M0_7qx8lqm", "bc59225ef9c074a3a829b4af39ac71f8b9ab332d86eeeca182d7a79e71ef9729", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Locked Item Popup", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Sn Count": properties.snCount,
        "Child Level": properties.childLevel,
        "From": properties.from,
        "Item Style": properties.itemStyle,
        "Category Name": properties.categoryName,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("M0_7qx8lqm", "Viewed Locked Item Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "FkHymvGjK", name: "Item Style", value: properties.itemStyle},
        {id: "fIB6sY9mt", name: "Child Level", value: properties.childLevel},
        {id: "ggXrRwik-", name: "Sn Count", value: properties.snCount},
        {id: "kZQO8-HD9", name: "Category Name", value: properties.categoryName},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Locked Item Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Locked Item Popup", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Sn Count": properties.snCount,
          "Child Level": properties.childLevel,
          "From": properties.from,
          "Item Style": properties.itemStyle,
          "Category Name": properties.categoryName,
          "Screen Height": sysScreenHeight,
          }, "M0_7qx8lqm", "bc59225ef9c074a3a829b4af39ac71f8b9ab332d86eeeca182d7a79e71ef9729");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Locked Item Popup", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Sn Count": properties.snCount,
      "Child Level": properties.childLevel,
      "From": properties.from,
      "Item Style": properties.itemStyle,
      "Category Name": properties.categoryName,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Locked Item Popup: This event is associated to the interactions to the popup shown when user clicks on the locked item.
   * 
   * When to trigger this event:
   * 1. when user clicks on CTA or the cross. This can happen on the gadget space or closet space.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/62nLPZMArk/trigger/eFN3Vx3mX
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {int} properties.childLevel - This stores the level of the child
   * @param {int} properties.snCount - This stores the count of super novas a child has
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.itemStyle - This property will store the style codes of the items purchased in pipe separated format.
   * @param {string} properties.categoryName - For Book Library
Category of the books like Animals, People and Culture etc

For Avatar Space
This property stores the categories within closer such as shirt, pant, goggles, hat, etc.

   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/62nLPZMArk}
   */
  function interactedLockedItemPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertChildLevel(properties.childLevel));
      messages = messages.concat(assertSnCount(properties.snCount));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertItemStyle(properties.itemStyle));
      messages = messages.concat(assertCategoryName(properties.categoryName));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Locked Item Popup", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "grade",
        "elaGrade",
        "childLevel",
        "snCount",
        "clickedOn",
        "itemStyle",
        "categoryName"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "62nLPZMArk", "9959cdd49d1a600657b7b0d37c3d77a53f9d3cb5bff9f9c939e0af4b3c92be1e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Locked Item Popup", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Child Level": properties.childLevel,
        "Sn Count": properties.snCount,
        "Clicked On": properties.clickedOn,
        "Item Style": properties.itemStyle,
        "Category Name": properties.categoryName,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("62nLPZMArk", "Interacted Locked Item Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "FkHymvGjK", name: "Item Style", value: properties.itemStyle},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "fIB6sY9mt", name: "Child Level", value: properties.childLevel},
        {id: "ggXrRwik-", name: "Sn Count", value: properties.snCount},
        {id: "kZQO8-HD9", name: "Category Name", value: properties.categoryName},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Locked Item Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Locked Item Popup", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Child Level": properties.childLevel,
          "Sn Count": properties.snCount,
          "Clicked On": properties.clickedOn,
          "Item Style": properties.itemStyle,
          "Category Name": properties.categoryName,
          "Screen Height": sysScreenHeight,
          }, "62nLPZMArk", "9959cdd49d1a600657b7b0d37c3d77a53f9d3cb5bff9f9c939e0af4b3c92be1e");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Locked Item Popup", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Child Level": properties.childLevel,
      "Sn Count": properties.snCount,
      "Clicked On": properties.clickedOn,
      "Item Style": properties.itemStyle,
      "Category Name": properties.categoryName,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Not Enough Sn Popup: This event is associated to the popup that shows up when user clicks on the item in the gadget or closet costs more than their super nova (coins) count.
   * 
   * When to trigger this event:
   * 1. User sees the popup of not enough coins.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/KpK7aQzMEW/trigger/XL9JXQ5td
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {int} properties.childLevel - This stores the level of the child
   * @param {int} properties.snCount - This stores the count of super novas a child has
   * @param {string} properties.itemStyle - This property will store the style codes of the items purchased in pipe separated format.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/KpK7aQzMEW}
   */
  function viewedNotEnoughSnPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertChildLevel(properties.childLevel));
      messages = messages.concat(assertSnCount(properties.snCount));
      messages = messages.concat(assertItemStyle(properties.itemStyle));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Not Enough Sn Popup", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "elaGrade",
        "grade",
        "from",
        "childLevel",
        "snCount",
        "itemStyle"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "KpK7aQzMEW", "3db2c38e678521842efd903c8ddc764b9a0b8e97e625febc8f9d407d90aaee26", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Not Enough Sn Popup", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "From": properties.from,
        "Child Level": properties.childLevel,
        "Sn Count": properties.snCount,
        "Item Style": properties.itemStyle,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("KpK7aQzMEW", "Viewed Not Enough Sn Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "FkHymvGjK", name: "Item Style", value: properties.itemStyle},
        {id: "fIB6sY9mt", name: "Child Level", value: properties.childLevel},
        {id: "ggXrRwik-", name: "Sn Count", value: properties.snCount},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Not Enough Sn Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Not Enough Sn Popup", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "From": properties.from,
          "Child Level": properties.childLevel,
          "Sn Count": properties.snCount,
          "Item Style": properties.itemStyle,
          "Screen Height": sysScreenHeight,
          }, "KpK7aQzMEW", "3db2c38e678521842efd903c8ddc764b9a0b8e97e625febc8f9d407d90aaee26");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Not Enough Sn Popup", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "From": properties.from,
      "Child Level": properties.childLevel,
      "Sn Count": properties.snCount,
      "Item Style": properties.itemStyle,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Not Enough Sn Popup: This event is associated to the interactions on the popup shown when user clicks on item costing more than their supernova count.
   * 
   * When to trigger this event:
   * 1. When user clicks on the CTA or the cross.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/JmoiyAHTen/trigger/13pJF5wHd
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {int} properties.childLevel - This stores the level of the child
   * @param {int} properties.snCount - This stores the count of super novas a child has
   * @param {string} properties.itemStyle - This property will store the style codes of the items purchased in pipe separated format.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/JmoiyAHTen}
   */
  function interactedNotEnoughSnPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertChildLevel(properties.childLevel));
      messages = messages.concat(assertSnCount(properties.snCount));
      messages = messages.concat(assertItemStyle(properties.itemStyle));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Not Enough Sn Popup", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "elaGrade",
        "grade",
        "clickedOn",
        "childLevel",
        "snCount",
        "itemStyle"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "JmoiyAHTen", "72a5e7f09da03daad552634807bd057a0600f07d88410aff672800b6d0d8d9c7", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Not Enough Sn Popup", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Clicked On": properties.clickedOn,
        "Child Level": properties.childLevel,
        "Sn Count": properties.snCount,
        "Item Style": properties.itemStyle,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("JmoiyAHTen", "Interacted Not Enough Sn Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "FkHymvGjK", name: "Item Style", value: properties.itemStyle},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "fIB6sY9mt", name: "Child Level", value: properties.childLevel},
        {id: "ggXrRwik-", name: "Sn Count", value: properties.snCount},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Not Enough Sn Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Not Enough Sn Popup", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Clicked On": properties.clickedOn,
          "Child Level": properties.childLevel,
          "Sn Count": properties.snCount,
          "Item Style": properties.itemStyle,
          "Screen Height": sysScreenHeight,
          }, "JmoiyAHTen", "72a5e7f09da03daad552634807bd057a0600f07d88410aff672800b6d0d8d9c7");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Not Enough Sn Popup", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Clicked On": properties.clickedOn,
      "Child Level": properties.childLevel,
      "Sn Count": properties.snCount,
      "Item Style": properties.itemStyle,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Completed State Machine Loading: This event is created to track / debug the tech issues. 
   * 
   * When to trigger this event:
   * 1. This event will be fired after any page is loaded. This will pass values that helps identify whether state machine loaded correctly & timely.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/QZjyXTFiKP/trigger/FDcOEQwoK
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.pendingMemory - This property stores the memory remaining at the current page. It will be used to debug the tech issues.

   * @param {bool} properties.smLoadedSuccessfully - This will store true/false. True when state machine is successfully loaded on a page and false when error is shown.
   * @param {string} properties.stateMachineCode - Every state machine has its own code, so whenever state machine switches we will be able to debug any issue that may arise
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/QZjyXTFiKP}
   */
  function completedStateMachineLoading(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertPendingMemory(properties.pendingMemory));
      messages = messages.concat(assertSmLoadedSuccessfully(properties.smLoadedSuccessfully));
      messages = messages.concat(assertStateMachineCode(properties.stateMachineCode));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Completed State Machine Loading", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "pendingMemory",
        "smLoadedSuccessfully",
        "stateMachineCode",
        "elaGrade",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "QZjyXTFiKP", "872a6266c888d705d97a7932fb971eb0bb65b318f9dc4ef7ed3cc5ff5e454141", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Completed State Machine Loading", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Pending Memory": properties.pendingMemory,
        "Sm Loaded Successfully": properties.smLoadedSuccessfully,
        "State Machine Code": properties.stateMachineCode,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("QZjyXTFiKP", "Completed State Machine Loading", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "5z8RzmY9J", name: "Sm Loaded Successfully", value: properties.smLoadedSuccessfully},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "C_BFBZn2V", name: "Pending Memory", value: properties.pendingMemory},
        {id: "T9gjnp76o", name: "State Machine Code", value: properties.stateMachineCode},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Completed State Machine Loading': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Completed State Machine Loading", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Pending Memory": properties.pendingMemory,
          "Sm Loaded Successfully": properties.smLoadedSuccessfully,
          "State Machine Code": properties.stateMachineCode,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "QZjyXTFiKP", "872a6266c888d705d97a7932fb971eb0bb65b318f9dc4ef7ed3cc5ff5e454141");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Completed State Machine Loading", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Pending Memory": properties.pendingMemory,
      "Sm Loaded Successfully": properties.smLoadedSuccessfully,
      "State Machine Code": properties.stateMachineCode,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Purchased Avatar Item: This event is fired when items are purchased for the avatar.
   * 
   * When to trigger this event:
   * 1. When user clicks on the buy CTA on closet or gadget space.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/mpmWh33Msb/trigger/r5KLsofPh
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.itemName - This property stores the item names clicked / purcahsed by the user. This can also store values in a pipe separated format if user purchases multiple items.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.itemStyle - This property will store the style codes of the items purchased in pipe separated format.
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {string} properties.snSpent - Sn spent to make this purchase.
   * @param {int} properties.snCount - This stores the count of super novas a child has
   * @param {int} properties.childLevel - This stores the level of the child
   * @param {string} properties.pendingMemory - This property stores the memory remaining at the current page. It will be used to debug the tech issues.

   * @param {float} properties.totalMemory - This property stores the total memory allocated by the client device
   * @param {float} properties.memoryLimit - The max memory allocated by the client device
   * @param {float} properties.memoryUsagePercentage - This property stores the % used memory
   * @param {float} properties.usedMemory - This property stores the memory consumed by the website
   * @param {string} properties.purchaseSource - This event stores if items are purchased when user came inside from the primary cta on intrusive nudge, notification trail or naturally i.e. no pending notification was there on child profile and has not also come from the nudge
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/mpmWh33Msb}
   */
  function purchasedAvatarItem(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertItemName(properties.itemName));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertItemStyle(properties.itemStyle));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertSnSpent(properties.snSpent));
      messages = messages.concat(assertSnCount(properties.snCount));
      messages = messages.concat(assertChildLevel(properties.childLevel));
      messages = messages.concat(assertPendingMemory(properties.pendingMemory));
      messages = messages.concat(assertTotalMemory(properties.totalMemory));
      messages = messages.concat(assertMemoryLimit(properties.memoryLimit));
      messages = messages.concat(assertMemoryUsagePercentage(properties.memoryUsagePercentage));
      messages = messages.concat(assertUsedMemory(properties.usedMemory));
      messages = messages.concat(assertPurchaseSource(properties.purchaseSource));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Purchased Avatar Item", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "itemName",
        "grade",
        "elaGrade",
        "itemStyle",
        "from",
        "snSpent",
        "snCount",
        "childLevel",
        "pendingMemory",
        "totalMemory",
        "memoryLimit",
        "memoryUsagePercentage",
        "usedMemory",
        "purchaseSource"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "mpmWh33Msb", "a043a55d0bdc84519ce3c0ec7e3c0281628fccbfd74c1b8ca88da62d0c05a356", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Purchased Avatar Item", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Item Name": properties.itemName,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Item Style": properties.itemStyle,
        "From": properties.from,
        "Sn Spent": properties.snSpent,
        "Sn Count": properties.snCount,
        "Child Level": properties.childLevel,
        "Pending Memory": properties.pendingMemory,
        "Total Memory": properties.totalMemory,
        "Memory Limit": properties.memoryLimit,
        "Memory Usage Percentage": properties.memoryUsagePercentage,
        "Used Memory": properties.usedMemory,
        "Purchase Source": properties.purchaseSource,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("mpmWh33Msb", "Purchased Avatar Item", messages, [
        {id: "2hMTTBgU30", name: "Total Memory", value: properties.totalMemory},
        {id: "2rctRWE0j", name: "Sn Spent", value: properties.snSpent},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "7J3z9wrkRMnQgFFbo9-g-", name: "Purchase Source", value: properties.purchaseSource},
        {id: "ADfS21LlJH", name: "Memory Limit", value: properties.memoryLimit},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "C_BFBZn2V", name: "Pending Memory", value: properties.pendingMemory},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "FkHymvGjK", name: "Item Style", value: properties.itemStyle},
        {id: "fIB6sY9mt", name: "Child Level", value: properties.childLevel},
        {id: "fXWDPkk_PZ", name: "Memory Usage Percentage", value: properties.memoryUsagePercentage},
        {id: "ggXrRwik-", name: "Sn Count", value: properties.snCount},
        {id: "gvDk2xQI4d", name: "Used Memory", value: properties.usedMemory},
        {id: "nSZ12H8zV", name: "Item Name", value: properties.itemName},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Purchased Avatar Item': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Purchased Avatar Item", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Item Name": properties.itemName,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Item Style": properties.itemStyle,
          "From": properties.from,
          "Sn Spent": properties.snSpent,
          "Sn Count": properties.snCount,
          "Child Level": properties.childLevel,
          "Pending Memory": properties.pendingMemory,
          "Total Memory": properties.totalMemory,
          "Memory Limit": properties.memoryLimit,
          "Memory Usage Percentage": properties.memoryUsagePercentage,
          "Used Memory": properties.usedMemory,
          "Purchase Source": properties.purchaseSource,
          "Screen Height": sysScreenHeight,
          }, "mpmWh33Msb", "a043a55d0bdc84519ce3c0ec7e3c0281628fccbfd74c1b8ca88da62d0c05a356");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Purchased Avatar Item", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Item Name": properties.itemName,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Item Style": properties.itemStyle,
      "From": properties.from,
      "Sn Spent": properties.snSpent,
      "Sn Count": properties.snCount,
      "Child Level": properties.childLevel,
      "Pending Memory": properties.pendingMemory,
      "Total Memory": properties.totalMemory,
      "Memory Limit": properties.memoryLimit,
      "Memory Usage Percentage": properties.memoryUsagePercentage,
      "Used Memory": properties.usedMemory,
      "Purchase Source": properties.purchaseSource,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Curriculum [B2B]: User views the sub-pages on the curriculum tab.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/LkUg0CUm32/trigger/fkeGtmaN_
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * @param {int} properties.daysSinceClassCreation - Self explanatory
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/LkUg0CUm32}
   */
  function viewedCurriculumB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertDaysSinceClassCreation(properties.daysSinceClassCreation));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Curriculum [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "fromPage",
        "daysSinceClassCreation"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "LkUg0CUm32", "80d5296ff17456f0a2f95f1b9651315c7aa65d73bf0191192003ae09dc143d1c", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Curriculum [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From Page": properties.fromPage,
        "Days Since Class Creation": properties.daysSinceClassCreation,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("LkUg0CUm32", "Viewed Curriculum [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "TuspgTIuZ1", name: "Days Since Class Creation", value: properties.daysSinceClassCreation},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Curriculum [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Curriculum [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From Page": properties.fromPage,
          "Days Since Class Creation": properties.daysSinceClassCreation,
          "Screen Height": sysScreenHeight,
          }, "LkUg0CUm32", "80d5296ff17456f0a2f95f1b9651315c7aa65d73bf0191192003ae09dc143d1c");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Curriculum [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From Page": properties.fromPage,
      "Days Since Class Creation": properties.daysSinceClassCreation,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Curriculum [B2B]: User interacts with tabs in curriculum page (curriculum assignment/ math facts/ live classes/ assessment/ teacher resource
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/_Fb4OpmTZ/trigger/QPL_tAiLO
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {int} properties.daysSinceClassCreation - Self explanatory
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/_Fb4OpmTZ}
   */
  function interactedCurriculumB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertDaysSinceClassCreation(properties.daysSinceClassCreation));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Curriculum [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "daysSinceClassCreation"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "_Fb4OpmTZ", "bf089a8c8a51f20288f11d9bc817b40c04821dfd724e716ee4bac5dcd5ad767b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Curriculum [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Days Since Class Creation": properties.daysSinceClassCreation,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("_Fb4OpmTZ", "Interacted Curriculum [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "TuspgTIuZ1", name: "Days Since Class Creation", value: properties.daysSinceClassCreation},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Curriculum [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Curriculum [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Days Since Class Creation": properties.daysSinceClassCreation,
          "Screen Height": sysScreenHeight,
          }, "_Fb4OpmTZ", "bf089a8c8a51f20288f11d9bc817b40c04821dfd724e716ee4bac5dcd5ad767b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Curriculum [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Days Since Class Creation": properties.daysSinceClassCreation,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Teacher Resources Tab [B2B]: User lands on teacher resources page.

   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/JzDdnTyepF/trigger/EefeMYO69
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * @param {int} properties.daysSinceClassCreation - Self explanatory
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/JzDdnTyepF}
   */
  function viewedTeacherResourcesTabB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertDaysSinceClassCreation(properties.daysSinceClassCreation));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Teacher Resources Tab [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "fromPage",
        "daysSinceClassCreation"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "JzDdnTyepF", "80f2db4c9dff2b7709139f3dea3175953ca73aa82dbaddb335c9ff98ebf4bf35", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Teacher Resources Tab [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From Page": properties.fromPage,
        "Days Since Class Creation": properties.daysSinceClassCreation,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("JzDdnTyepF", "Viewed Teacher Resources Tab [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "TuspgTIuZ1", name: "Days Since Class Creation", value: properties.daysSinceClassCreation},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Teacher Resources Tab [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Teacher Resources Tab [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From Page": properties.fromPage,
          "Days Since Class Creation": properties.daysSinceClassCreation,
          "Screen Height": sysScreenHeight,
          }, "JzDdnTyepF", "80f2db4c9dff2b7709139f3dea3175953ca73aa82dbaddb335c9ff98ebf4bf35");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Teacher Resources Tab [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From Page": properties.fromPage,
      "Days Since Class Creation": properties.daysSinceClassCreation,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Teacher Resources Tab [B2B]: User clicks on any action on teacher resources page back, grade, subject, header tabs.


   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/169P2Jos26/trigger/Lh18dOBl2
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {int} properties.daysSinceClassCreation - Self explanatory
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/169P2Jos26}
   */
  function interactedTeacherResourcesTabB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertDaysSinceClassCreation(properties.daysSinceClassCreation));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Teacher Resources Tab [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "daysSinceClassCreation"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "169P2Jos26", "e8c48596ed43966074ee2292f787586bd2e674279c3dd281af95d8ef905c9678", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Teacher Resources Tab [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Days Since Class Creation": properties.daysSinceClassCreation,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("169P2Jos26", "Interacted Teacher Resources Tab [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "TuspgTIuZ1", name: "Days Since Class Creation", value: properties.daysSinceClassCreation},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Teacher Resources Tab [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Teacher Resources Tab [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Days Since Class Creation": properties.daysSinceClassCreation,
          "Screen Height": sysScreenHeight,
          }, "169P2Jos26", "e8c48596ed43966074ee2292f787586bd2e674279c3dd281af95d8ef905c9678");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Teacher Resources Tab [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Days Since Class Creation": properties.daysSinceClassCreation,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Curriculum Assignment Report Page [B2B]: User selects the subject and lands on curriculum assignment reports page
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/NuBO0EXtBb/trigger/uncWK-rzN
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * @param {int} properties.daysSinceClassCreation - Self explanatory
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/NuBO0EXtBb}
   */
  function viewedCurriculumAssignmentReportPageB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertDaysSinceClassCreation(properties.daysSinceClassCreation));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Curriculum Assignment Report Page [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "fromPage",
        "daysSinceClassCreation"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "NuBO0EXtBb", "62d61e1342986324078dd10f6f4220fb265707c3ab73f770b0cfe9a1eda0297f", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Curriculum Assignment Report Page [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From Page": properties.fromPage,
        "Days Since Class Creation": properties.daysSinceClassCreation,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("NuBO0EXtBb", "Viewed Curriculum Assignment Report Page [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "TuspgTIuZ1", name: "Days Since Class Creation", value: properties.daysSinceClassCreation},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Curriculum Assignment Report Page [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Curriculum Assignment Report Page [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From Page": properties.fromPage,
          "Days Since Class Creation": properties.daysSinceClassCreation,
          "Screen Height": sysScreenHeight,
          }, "NuBO0EXtBb", "62d61e1342986324078dd10f6f4220fb265707c3ab73f770b0cfe9a1eda0297f");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Curriculum Assignment Report Page [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From Page": properties.fromPage,
      "Days Since Class Creation": properties.daysSinceClassCreation,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Curriculum Report Tab [B2B]: User clicks on top tabs on curriculum reports tab
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/yDFidUnfk-/trigger/uz3cHg635
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {int} properties.daysSinceClassCreation - Self explanatory
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/yDFidUnfk-}
   */
  function interactedCurriculumReportTabB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertDaysSinceClassCreation(properties.daysSinceClassCreation));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Curriculum Report Tab [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "daysSinceClassCreation"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "yDFidUnfk-", "175d16c50401af82856f03d799e827f3865b407f30e2e0aec62be694fa11edd3", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Curriculum Report Tab [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Days Since Class Creation": properties.daysSinceClassCreation,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("yDFidUnfk-", "Interacted Curriculum Report Tab [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "TuspgTIuZ1", name: "Days Since Class Creation", value: properties.daysSinceClassCreation},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Curriculum Report Tab [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Curriculum Report Tab [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Days Since Class Creation": properties.daysSinceClassCreation,
          "Screen Height": sysScreenHeight,
          }, "yDFidUnfk-", "175d16c50401af82856f03d799e827f3865b407f30e2e0aec62be694fa11edd3");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Curriculum Report Tab [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Days Since Class Creation": properties.daysSinceClassCreation,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Book Library Report Tab  [B2B]: User views the sub-pages of Book Library report 
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/iaLrefsmw_/trigger/o1zW8cNfF
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * @param {int} properties.daysSinceClassCreation - Self explanatory
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/iaLrefsmw_}
   */
  function viewedBookLibraryReportTabB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertDaysSinceClassCreation(properties.daysSinceClassCreation));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Book Library Report Tab  [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "fromPage",
        "daysSinceClassCreation"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "iaLrefsmw_", "44bc3d0dd5c37379525e3464092375e36fb5c38aab2c2a39376165f8fb14c682", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Book Library Report Tab  [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From Page": properties.fromPage,
        "Days Since Class Creation": properties.daysSinceClassCreation,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("iaLrefsmw_", "Viewed Book Library Report Tab  [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "TuspgTIuZ1", name: "Days Since Class Creation", value: properties.daysSinceClassCreation},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Book Library Report Tab  [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Book Library Report Tab  [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From Page": properties.fromPage,
          "Days Since Class Creation": properties.daysSinceClassCreation,
          "Screen Height": sysScreenHeight,
          }, "iaLrefsmw_", "44bc3d0dd5c37379525e3464092375e36fb5c38aab2c2a39376165f8fb14c682");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Book Library Report Tab  [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From Page": properties.fromPage,
      "Days Since Class Creation": properties.daysSinceClassCreation,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Book Library Report Tab  [B2B]: User clicks on top tabs in book library reports
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/XsT-3SF_ep/trigger/i6EJJYtN7
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {int} properties.daysSinceClassCreation - Self explanatory
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/XsT-3SF_ep}
   */
  function interactedBookLibraryReportTabB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertDaysSinceClassCreation(properties.daysSinceClassCreation));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Book Library Report Tab  [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "daysSinceClassCreation"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "XsT-3SF_ep", "7de998a1f00c44ed7961deeeb48a1f93a027970739c018768723c850b13fc9df", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Book Library Report Tab  [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Days Since Class Creation": properties.daysSinceClassCreation,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("XsT-3SF_ep", "Interacted Book Library Report Tab  [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "TuspgTIuZ1", name: "Days Since Class Creation", value: properties.daysSinceClassCreation},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Book Library Report Tab  [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Book Library Report Tab  [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Days Since Class Creation": properties.daysSinceClassCreation,
          "Screen Height": sysScreenHeight,
          }, "XsT-3SF_ep", "7de998a1f00c44ed7961deeeb48a1f93a027970739c018768723c850b13fc9df");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Book Library Report Tab  [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Days Since Class Creation": properties.daysSinceClassCreation,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Promote/Continue Class Popup [B2B]: This event will be fired when user is displayed the promote/continue using class popup from manage all classes page
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/6nHqP6WyOU/trigger/CCLj5pR8A
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.classType - This Property will capture the type of class - Google Classroom or Clever or Manual
   * @param {string} properties.classSchoolYear - This property returns the current school year of the class
   * @param {int} properties.classSize - Total students in the class at the time this event was triggered.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/6nHqP6WyOU}
   */
  function viewedPromotecontinueClassPopupB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClassType(properties.classType));
      messages = messages.concat(assertClassSchoolYear(properties.classSchoolYear));
      messages = messages.concat(assertClassSize(properties.classSize));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Promote/Continue Class Popup [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "classType",
        "classSchoolYear",
        "classSize"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "6nHqP6WyOU", "8ee0d29847b7770ea1a4cddf5dc7ac9c5b61558cc1fba313d31e19d898aec9b7", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Promote/Continue Class Popup [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Class Type": properties.classType,
        "Class School Year": properties.classSchoolYear,
        "Class Size": properties.classSize,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("6nHqP6WyOU", "Viewed Promote/Continue Class Popup [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "DFN7pb5A8", name: "Class School Year", value: properties.classSchoolYear},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "dk2bhnFne", name: "Class Type", value: properties.classType},
        {id: "erbI-IRpim", name: "Class Size", value: properties.classSize},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Promote/Continue Class Popup [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Promote/Continue Class Popup [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Class Type": properties.classType,
          "Class School Year": properties.classSchoolYear,
          "Class Size": properties.classSize,
          "Screen Height": sysScreenHeight,
          }, "6nHqP6WyOU", "8ee0d29847b7770ea1a4cddf5dc7ac9c5b61558cc1fba313d31e19d898aec9b7");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Promote/Continue Class Popup [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Class Type": properties.classType,
      "Class School Year": properties.classSchoolYear,
      "Class Size": properties.classSize,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Promote/Continue Class Popup [B2B]: This event will be fired when user interacts with the promote/Continue class popup
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/TCeJgR4GD7/trigger/raiMdPGG1
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.classType - This Property will capture the type of class - Google Classroom or Clever or Manual
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} [properties.interactionDetails] - Stores where is the user interacting with the page
   * @param {string} [properties.valueName] - This will capture the value/text of the field that is selected.
   * @param {string} [properties.classStatusInNewSchoolYear] - This property returns the class status based on grade selected by the teacher on the Promote/Continue Class Popup in the new school year
   * @param {int} [properties.isClassNameUpdated] - This property returns 1 if class name is update by the teacher when promoting or continuing the same class in new school year and 0 otherwise
   * @param {string} properties.classSchoolYear - This property returns the current school year of the class
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/TCeJgR4GD7}
   */
  function interactedPromotecontinueClassPopupB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClassType(properties.classType));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertOptionalInteractionDetails(properties.interactionDetails));
      messages = messages.concat(assertOptionalValueName(properties.valueName));
      messages = messages.concat(assertOptionalClassStatusInNewSchoolYear(properties.classStatusInNewSchoolYear));
      messages = messages.concat(assertOptionalIsClassNameUpdated(properties.isClassNameUpdated));
      messages = messages.concat(assertClassSchoolYear(properties.classSchoolYear));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Promote/Continue Class Popup [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "classType",
        "clickedOn",
        "interactionDetails",
        "valueName",
        "classStatusInNewSchoolYear",
        "isClassNameUpdated",
        "classSchoolYear"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "TCeJgR4GD7", "3621493fb0d65368afae5d66844e02ba3a088fd308694bc8651881e23c100bb8", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Promote/Continue Class Popup [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Class Type": properties.classType,
        "Clicked On": properties.clickedOn,
        "Interaction Details": properties.interactionDetails,
        "Value Name": properties.valueName,
        "Class Status in New School Year": properties.classStatusInNewSchoolYear,
        "Is Class Name Updated": properties.isClassNameUpdated,
        "Class School Year": properties.classSchoolYear,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("TCeJgR4GD7", "Interacted Promote/Continue Class Popup [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "DFN7pb5A8", name: "Class School Year", value: properties.classSchoolYear},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "U5iz3PtWf", name: "Class Status in New School Year", value: properties.classStatusInNewSchoolYear},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "Z4R_4lCL0", name: "Is Class Name Updated", value: properties.isClassNameUpdated},
        {id: "dk2bhnFne", name: "Class Type", value: properties.classType},
        {id: "l-8JNUE0q", name: "Value Name", value: properties.valueName},
        {id: "ncdYto9gZ", name: "Interaction Details", value: properties.interactionDetails},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Promote/Continue Class Popup [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Promote/Continue Class Popup [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Class Type": properties.classType,
          "Clicked On": properties.clickedOn,
          "Interaction Details": properties.interactionDetails,
          "Value Name": properties.valueName,
          "Class Status in New School Year": properties.classStatusInNewSchoolYear,
          "Is Class Name Updated": properties.isClassNameUpdated,
          "Class School Year": properties.classSchoolYear,
          "Screen Height": sysScreenHeight,
          }, "TCeJgR4GD7", "3621493fb0d65368afae5d66844e02ba3a088fd308694bc8651881e23c100bb8");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Promote/Continue Class Popup [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Class Type": properties.classType,
      "Clicked On": properties.clickedOn,
      "Interaction Details": properties.interactionDetails,
      "Value Name": properties.valueName,
      "Class Status in New School Year": properties.classStatusInNewSchoolYear,
      "Is Class Name Updated": properties.isClassNameUpdated,
      "Class School Year": properties.classSchoolYear,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Transfer Popup [B2B]: This event will be fired when user is displayed the class transfer popup
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Pso6lmPM1O/trigger/wJqdU_P9c
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.classType - This Property will capture the type of class - Google Classroom or Clever or Manual
   * @param {string} properties.classSchoolYear - This property returns the current school year of the class
   * @param {int} properties.classSize - Total students in the class at the time this event was triggered.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Pso6lmPM1O}
   */
  function viewedTransferPopupB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClassType(properties.classType));
      messages = messages.concat(assertClassSchoolYear(properties.classSchoolYear));
      messages = messages.concat(assertClassSize(properties.classSize));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Transfer Popup [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "classType",
        "classSchoolYear",
        "classSize"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Pso6lmPM1O", "707a61d19f531864a0f2b5761363f534840e5877f6cf8fa82f4d670c9f87f2b4", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Transfer Popup [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Class Type": properties.classType,
        "Class School Year": properties.classSchoolYear,
        "Class Size": properties.classSize,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Pso6lmPM1O", "Viewed Transfer Popup [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "DFN7pb5A8", name: "Class School Year", value: properties.classSchoolYear},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "dk2bhnFne", name: "Class Type", value: properties.classType},
        {id: "erbI-IRpim", name: "Class Size", value: properties.classSize},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Transfer Popup [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Transfer Popup [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Class Type": properties.classType,
          "Class School Year": properties.classSchoolYear,
          "Class Size": properties.classSize,
          "Screen Height": sysScreenHeight,
          }, "Pso6lmPM1O", "707a61d19f531864a0f2b5761363f534840e5877f6cf8fa82f4d670c9f87f2b4");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Transfer Popup [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Class Type": properties.classType,
      "Class School Year": properties.classSchoolYear,
      "Class Size": properties.classSize,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Transfer Popup [B2B]: This event will get fired when user interacts with the class transfer popup
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/da_ROpBj8D/trigger/niOcjvBqK
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.interactionDetails] - Stores where is the user interacting with the page
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.classType - This Property will capture the type of class - Google Classroom or Clever or Manual
   * @param {string} [properties.valueName] - This will capture the value/text of the field that is selected.
   * @param {string} properties.classSchoolYear - This property returns the current school year of the class
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/da_ROpBj8D}
   */
  function interactedTransferPopupB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalInteractionDetails(properties.interactionDetails));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertClassType(properties.classType));
      messages = messages.concat(assertOptionalValueName(properties.valueName));
      messages = messages.concat(assertClassSchoolYear(properties.classSchoolYear));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Transfer Popup [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "interactionDetails",
        "clickedOn",
        "classType",
        "valueName",
        "classSchoolYear"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "da_ROpBj8D", "e4392c463e763109abd9570e2fc4a0569cafd06005993558e59d9c597810da63", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Transfer Popup [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Interaction Details": properties.interactionDetails,
        "Clicked On": properties.clickedOn,
        "Class Type": properties.classType,
        "Value Name": properties.valueName,
        "Class School Year": properties.classSchoolYear,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("da_ROpBj8D", "Interacted Transfer Popup [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "DFN7pb5A8", name: "Class School Year", value: properties.classSchoolYear},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "dk2bhnFne", name: "Class Type", value: properties.classType},
        {id: "l-8JNUE0q", name: "Value Name", value: properties.valueName},
        {id: "ncdYto9gZ", name: "Interaction Details", value: properties.interactionDetails},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Transfer Popup [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Transfer Popup [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Interaction Details": properties.interactionDetails,
          "Clicked On": properties.clickedOn,
          "Class Type": properties.classType,
          "Value Name": properties.valueName,
          "Class School Year": properties.classSchoolYear,
          "Screen Height": sysScreenHeight,
          }, "da_ROpBj8D", "e4392c463e763109abd9570e2fc4a0569cafd06005993558e59d9c597810da63");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Transfer Popup [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Interaction Details": properties.interactionDetails,
      "Clicked On": properties.clickedOn,
      "Class Type": properties.classType,
      "Value Name": properties.valueName,
      "Class School Year": properties.classSchoolYear,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Delete Class Popup [B2B]: This event will be fired when user is displayed the delete class popup
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/QfYeXbYgIB/trigger/VtfCvMXGo
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.classType - This Property will capture the type of class - Google Classroom or Clever or Manual
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * @param {string} properties.classSchoolYear - This property returns the current school year of the class
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/QfYeXbYgIB}
   */
  function viewedDeleteClassPopupB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClassType(properties.classType));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertClassSchoolYear(properties.classSchoolYear));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Delete Class Popup [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "classType",
        "fromPage",
        "classSchoolYear"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "QfYeXbYgIB", "414e5ee33a100a92fab996b260105caac367eff9812b7377b72aca0060bce622", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Delete Class Popup [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Class Type": properties.classType,
        "From Page": properties.fromPage,
        "Class School Year": properties.classSchoolYear,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("QfYeXbYgIB", "Viewed Delete Class Popup [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "DFN7pb5A8", name: "Class School Year", value: properties.classSchoolYear},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "dk2bhnFne", name: "Class Type", value: properties.classType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Delete Class Popup [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Delete Class Popup [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Class Type": properties.classType,
          "From Page": properties.fromPage,
          "Class School Year": properties.classSchoolYear,
          "Screen Height": sysScreenHeight,
          }, "QfYeXbYgIB", "414e5ee33a100a92fab996b260105caac367eff9812b7377b72aca0060bce622");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Delete Class Popup [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Class Type": properties.classType,
      "From Page": properties.fromPage,
      "Class School Year": properties.classSchoolYear,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Delete Class Popup [B2B]: This event will be fired when user interacts with delete class popup
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Ptc2zcz-t1/trigger/c6aTE_t9I
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.classType - This Property will capture the type of class - Google Classroom or Clever or Manual
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.classSchoolYear - This property returns the current school year of the class
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Ptc2zcz-t1}
   */
  function interactedDeleteClassPopupB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClassType(properties.classType));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertClassSchoolYear(properties.classSchoolYear));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Delete Class Popup [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "classType",
        "clickedOn",
        "classSchoolYear"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Ptc2zcz-t1", "d0fa77daaa00df82fc332f961d8a4f1d62106a9753c5ba62882282248c6de9ee", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Delete Class Popup [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Class Type": properties.classType,
        "Clicked On": properties.clickedOn,
        "Class School Year": properties.classSchoolYear,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Ptc2zcz-t1", "Interacted Delete Class Popup [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "DFN7pb5A8", name: "Class School Year", value: properties.classSchoolYear},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "dk2bhnFne", name: "Class Type", value: properties.classType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Delete Class Popup [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Delete Class Popup [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Class Type": properties.classType,
          "Clicked On": properties.clickedOn,
          "Class School Year": properties.classSchoolYear,
          "Screen Height": sysScreenHeight,
          }, "Ptc2zcz-t1", "d0fa77daaa00df82fc332f961d8a4f1d62106a9753c5ba62882282248c6de9ee");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Delete Class Popup [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Class Type": properties.classType,
      "Clicked On": properties.clickedOn,
      "Class School Year": properties.classSchoolYear,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Transfer Request Sent Popup [B2B]: This event will be fired when user is displayed transfer request sent successfully popup
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/EJ0q5Vd4Ed/trigger/X-iTxf852
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.classType - This Property will capture the type of class - Google Classroom or Clever or Manual
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/EJ0q5Vd4Ed}
   */
  function viewedTransferRequestSentPopupB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClassType(properties.classType));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Transfer Request Sent Popup [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "classType"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "EJ0q5Vd4Ed", "d0bf026791d8dd9de02e41a48ca11428ed5f1e367c4a33f7608a25ebc9723280", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Transfer Request Sent Popup [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Class Type": properties.classType,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("EJ0q5Vd4Ed", "Viewed Transfer Request Sent Popup [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "dk2bhnFne", name: "Class Type", value: properties.classType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Transfer Request Sent Popup [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Transfer Request Sent Popup [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Class Type": properties.classType,
          "Screen Height": sysScreenHeight,
          }, "EJ0q5Vd4Ed", "d0bf026791d8dd9de02e41a48ca11428ed5f1e367c4a33f7608a25ebc9723280");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Transfer Request Sent Popup [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Class Type": properties.classType,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Class Continued Successfully Popup [B2B]: This event will be fired when user is displayed class moved to new school year successfully popup
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/yrquKkTWg/trigger/G1QMhjGiC5
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.classType - This Property will capture the type of class - Google Classroom or Clever or Manual
   * @param {string} properties.classStatusInNewSchoolYear - This property returns the class status based on grade selected by the teacher on the Promote/Continue Class Popup in the new school year
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/yrquKkTWg}
   */
  function viewedClassContinuedSuccessfullyPopupB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClassType(properties.classType));
      messages = messages.concat(assertClassStatusInNewSchoolYear(properties.classStatusInNewSchoolYear));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Class Continued Successfully Popup [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "classType",
        "classStatusInNewSchoolYear"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "yrquKkTWg", "a985435ec79d6405f49353312005f1222ba903461c6c98b7c98471edc129e8e3", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Class Continued Successfully Popup [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Class Type": properties.classType,
        "Class Status in New School Year": properties.classStatusInNewSchoolYear,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("yrquKkTWg", "Viewed Class Continued Successfully Popup [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "U5iz3PtWf", name: "Class Status in New School Year", value: properties.classStatusInNewSchoolYear},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "dk2bhnFne", name: "Class Type", value: properties.classType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Class Continued Successfully Popup [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Class Continued Successfully Popup [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Class Type": properties.classType,
          "Class Status in New School Year": properties.classStatusInNewSchoolYear,
          "Screen Height": sysScreenHeight,
          }, "yrquKkTWg", "a985435ec79d6405f49353312005f1222ba903461c6c98b7c98471edc129e8e3");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Class Continued Successfully Popup [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Class Type": properties.classType,
      "Class Status in New School Year": properties.classStatusInNewSchoolYear,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Clicked Add to Collection: triggered when a user clicks on 'add to collection' icon on book
   * 
   * When to trigger this event:
   * 1. when a user clicks on 'add to collection' icon on book
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/JzHfslxFgI/trigger/UJ64cudCt
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.playableCode - Pass the 'Playable Code' of the Playable being started/clicked
   * @param {string} properties.playableName - Name of playable selected
   * @param {Array<string>} properties.recommendedRailName - This is the name of the rail viewed by the user. 
Recommended rail property comes with rail name and rail rank, pipe separated - with the introduction of this property, we intend to separate rail name to calculate CTR on Mixpanel.
   * @param {Array<int>} [properties.recommendedTileRank] - This property will store the position of the tile on which user has clciked. Earlier this was sent as column position

   * @param {string} properties.pageName - Includes the name of the page (Eg: Playzone game listing page, ). This is not the URL but a easily understandable definition of what page is the user at.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/JzHfslxFgI}
   */
  function clickedAddToCollection(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertPlayableCode(properties.playableCode));
      messages = messages.concat(assertPlayableName(properties.playableName));
      messages = messages.concat(assertRecommendedRailName(properties.recommendedRailName));
      messages = messages.concat(assertOptionalRecommendedTileRank(properties.recommendedTileRank));
      messages = messages.concat(assertPageName(properties.pageName));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Clicked Add to Collection", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "playableCode",
        "playableName",
        "recommendedRailName",
        "recommendedTileRank",
        "pageName",
        "fromPage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "JzHfslxFgI", "96bb2a63415b5a30df996358c42386cba5b9008b219cfb7367fadffccc935a27", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Clicked Add to Collection", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Playable Code": properties.playableCode,
        "Playable Name": properties.playableName,
        "Recommended Rail Name": properties.recommendedRailName,
        "Recommended Tile Rank": properties.recommendedTileRank,
        "Page Name": properties.pageName,
        "From Page": properties.fromPage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("JzHfslxFgI", "Clicked Add to Collection", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "6lrsWYY5Y", name: "Recommended Rail Name", value: properties.recommendedRailName},
        {id: "FLDtSJNKL", name: "Recommended Tile Rank", value: properties.recommendedTileRank},
        {id: "MJKSzmqfHu", name: "Page Name", value: properties.pageName},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "QjCwFasvW0", name: "Playable Code", value: properties.playableCode},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "c2W4X05Jy", name: "Playable Name", value: properties.playableName},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Clicked Add to Collection': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Clicked Add to Collection", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Playable Code": properties.playableCode,
          "Playable Name": properties.playableName,
          "Recommended Rail Name": properties.recommendedRailName,
          "Recommended Tile Rank": properties.recommendedTileRank,
          "Page Name": properties.pageName,
          "From Page": properties.fromPage,
          "Screen Height": sysScreenHeight,
          }, "JzHfslxFgI", "96bb2a63415b5a30df996358c42386cba5b9008b219cfb7367fadffccc935a27");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Clicked Add to Collection", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Playable Code": properties.playableCode,
      "Playable Name": properties.playableName,
      "Recommended Rail Name": properties.recommendedRailName,
      "Recommended Tile Rank": properties.recommendedTileRank,
      "Page Name": properties.pageName,
      "From Page": properties.fromPage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Add to Collection Screen: when user sees Add to Collection Pop-up
   * 
   * When to trigger this event:
   * 1. User sees Add to Collection Pop-up
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Mzo63rFHs8/trigger/UtdHenMbn
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {int} properties.numberOfResults - Number of results shown for search results
   * @param {int} properties.daysSinceClassCreation - Self explanatory
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Mzo63rFHs8}
   */
  function viewedAddToCollectionScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertNumberOfResults(properties.numberOfResults));
      messages = messages.concat(assertDaysSinceClassCreation(properties.daysSinceClassCreation));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Add to Collection Screen", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "numberOfResults",
        "daysSinceClassCreation",
        "fromPage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Mzo63rFHs8", "09a8295a1b5e1804ddd0f6c4bcf9b5ee6bc2230a7745fa971564c0a040ee2bcb", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Add to Collection Screen", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Number of Results": properties.numberOfResults,
        "Days Since Class Creation": properties.daysSinceClassCreation,
        "From Page": properties.fromPage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Mzo63rFHs8", "Viewed Add to Collection Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "TuspgTIuZ1", name: "Days Since Class Creation", value: properties.daysSinceClassCreation},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "UtPMQu4JE", name: "Number of Results", value: properties.numberOfResults},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Add to Collection Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Add to Collection Screen", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Number of Results": properties.numberOfResults,
          "Days Since Class Creation": properties.daysSinceClassCreation,
          "From Page": properties.fromPage,
          "Screen Height": sysScreenHeight,
          }, "Mzo63rFHs8", "09a8295a1b5e1804ddd0f6c4bcf9b5ee6bc2230a7745fa971564c0a040ee2bcb");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Add to Collection Screen", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Number of Results": properties.numberOfResults,
      "Days Since Class Creation": properties.daysSinceClassCreation,
      "From Page": properties.fromPage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Add to Collection Screen: User interacts with Add to Collection Pop-up
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/j_IREvAbDb/trigger/nK_sIqY-l
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {int} [properties.numberOfCollectionsSelected] - Count of collections user selected to add the book
   * @param {int} [properties.numberOfCollectionsDeSelected] - Count of collections user de-selected to remove the book
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/j_IREvAbDb}
   */
  function interactedAddToCollectionScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertOptionalNumberOfCollectionsSelected(properties.numberOfCollectionsSelected));
      messages = messages.concat(assertOptionalNumberOfCollectionsDeSelected(properties.numberOfCollectionsDeSelected));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Add to Collection Screen", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "numberOfCollectionsSelected",
        "numberOfCollectionsDeSelected"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "j_IREvAbDb", "c1a7d5a62e6e902a4da483bc755ebb10b5b45b66d3c6a77ff25950185b1a4fc4", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Add to Collection Screen", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Number of Collections Selected": properties.numberOfCollectionsSelected,
        "Number of Collections De-Selected": properties.numberOfCollectionsDeSelected,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("j_IREvAbDb", "Interacted Add to Collection Screen", messages, [
        {id: "13ZQ1yCAS", name: "Number of Collections Selected", value: properties.numberOfCollectionsSelected},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ytpuP_rkW", name: "Number of Collections De-Selected", value: properties.numberOfCollectionsDeSelected},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Add to Collection Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Add to Collection Screen", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Number of Collections Selected": properties.numberOfCollectionsSelected,
          "Number of Collections De-Selected": properties.numberOfCollectionsDeSelected,
          "Screen Height": sysScreenHeight,
          }, "j_IREvAbDb", "c1a7d5a62e6e902a4da483bc755ebb10b5b45b66d3c6a77ff25950185b1a4fc4");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Add to Collection Screen", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Number of Collections Selected": properties.numberOfCollectionsSelected,
      "Number of Collections De-Selected": properties.numberOfCollectionsDeSelected,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Create a New Collection Screen: User clicks on 'create new collection' CTA inside the pop-up
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/gv1vVpghB9/trigger/fN3JGMBVw
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/gv1vVpghB9}
   */
  function viewedCreateANewCollectionScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Create a New Collection Screen", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "gv1vVpghB9", "ef687628e896be14f37db32ac48151c6977d0cd022822189b1e010a7bc352a2e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Create a New Collection Screen", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("gv1vVpghB9", "Viewed Create a New Collection Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Create a New Collection Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Create a New Collection Screen", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "gv1vVpghB9", "ef687628e896be14f37db32ac48151c6977d0cd022822189b1e010a7bc352a2e");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Create a New Collection Screen", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Create a New Collection Screen: User interacts with create a new collection pop-up
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/3m0c5t96a1/trigger/GPIkvjrjv
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/3m0c5t96a1}
   */
  function interactedCreateANewCollectionScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Create a New Collection Screen", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "3m0c5t96a1", "1e2a9a91ba73d1109a0a3c82998dd1c20a40fe28f3873868c7554d539e582ef2", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Create a New Collection Screen", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("3m0c5t96a1", "Interacted Create a New Collection Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Create a New Collection Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Create a New Collection Screen", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "3m0c5t96a1", "1e2a9a91ba73d1109a0a3c82998dd1c20a40fe28f3873868c7554d539e582ef2");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Create a New Collection Screen", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Collection Toast Message: User add a book/remove a book from the collection then user gets a toast message confirming the action
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/yEPPEXfcP7/trigger/HfeZo4Kr-
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.messageType - Have values such as Added, Removed, Updated depending on if a book was added / removed from the collection
   * @param {Array<string>} properties.collectionName - Name of the collection to which book was added/removed
   * @param {string} [properties.collectionDescription] - Self Explanatory
   * @param {string} properties.collectionType - Have value: Favourite, New, Existing depending on if the book was added to favourites, to an existing collection or new collection
   * @param {string} properties.playableCode - Pass the 'Playable Code' of the Playable being started/clicked
   * @param {string} properties.playableName - Name of playable selected
   * @param {Array<string>} properties.collectionCode - Self Explanatory
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/yEPPEXfcP7}
   */
  function viewedCollectionToastMessage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertMessageType(properties.messageType));
      messages = messages.concat(assertCollectionName(properties.collectionName));
      messages = messages.concat(assertOptionalCollectionDescription(properties.collectionDescription));
      messages = messages.concat(assertCollectionType(properties.collectionType));
      messages = messages.concat(assertPlayableCode(properties.playableCode));
      messages = messages.concat(assertPlayableName(properties.playableName));
      messages = messages.concat(assertCollectionCode(properties.collectionCode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Collection Toast Message", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "messageType",
        "collectionName",
        "collectionDescription",
        "collectionType",
        "playableCode",
        "playableName",
        "collectionCode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "yEPPEXfcP7", "89579cbe55980413eb07268b3f6f79f8e2cf73ea149aee234d7521cad6015a4a", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Collection Toast Message", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Message Type": properties.messageType,
        "Collection Name": properties.collectionName,
        "Collection Description": properties.collectionDescription,
        "Collection Type": properties.collectionType,
        "Playable Code": properties.playableCode,
        "Playable Name": properties.playableName,
        "Collection Code": properties.collectionCode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("yEPPEXfcP7", "Viewed Collection Toast Message", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "QjCwFasvW0", name: "Playable Code", value: properties.playableCode},
        {id: "THmuig1mn", name: "Message Type", value: properties.messageType},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "b8Fx1iSZI", name: "Collection Name", value: properties.collectionName},
        {id: "bof7IBLkA", name: "Collection Type", value: properties.collectionType},
        {id: "c2W4X05Jy", name: "Playable Name", value: properties.playableName},
        {id: "eMtEG5HBc", name: "Collection Code", value: properties.collectionCode},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "v02OnlI5e", name: "Collection Description", value: properties.collectionDescription},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Collection Toast Message': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Collection Toast Message", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Message Type": properties.messageType,
          "Collection Name": properties.collectionName,
          "Collection Description": properties.collectionDescription,
          "Collection Type": properties.collectionType,
          "Playable Code": properties.playableCode,
          "Playable Name": properties.playableName,
          "Collection Code": properties.collectionCode,
          "Screen Height": sysScreenHeight,
          }, "yEPPEXfcP7", "89579cbe55980413eb07268b3f6f79f8e2cf73ea149aee234d7521cad6015a4a");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Collection Toast Message", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Message Type": properties.messageType,
      "Collection Name": properties.collectionName,
      "Collection Description": properties.collectionDescription,
      "Collection Type": properties.collectionType,
      "Playable Code": properties.playableCode,
      "Playable Name": properties.playableName,
      "Collection Code": properties.collectionCode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Collection Toast Message: when a user interacts with the toast message
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/PdTFeksdlT/trigger/4YIHjZtgQ
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/PdTFeksdlT}
   */
  function interactedCollectionToastMessage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Collection Toast Message", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "PdTFeksdlT", "d35c7ef70e7e7eb35e43bf2cc205392c551dcd0c76824a26c68df6203331460d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Collection Toast Message", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("PdTFeksdlT", "Interacted Collection Toast Message", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Collection Toast Message': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Collection Toast Message", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "PdTFeksdlT", "d35c7ef70e7e7eb35e43bf2cc205392c551dcd0c76824a26c68df6203331460d");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Collection Toast Message", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed My Library: When user lands on My Library page
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/YPAHSHc8sJ/trigger/GuBJS6yy1
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {int} properties.numberOfResults - Number of results shown for search results
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/YPAHSHc8sJ}
   */
  function viewedMyLibrary(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertNumberOfResults(properties.numberOfResults));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed My Library", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "numberOfResults",
        "fromPage",
        "from"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "YPAHSHc8sJ", "5e729b2f8434737148c7b62aae050d13f27b382d65a5d6595118e9a413abf1d0", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed My Library", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Number of Results": properties.numberOfResults,
        "From Page": properties.fromPage,
        "From": properties.from,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("YPAHSHc8sJ", "Viewed My Library", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "UtPMQu4JE", name: "Number of Results", value: properties.numberOfResults},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed My Library': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed My Library", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Number of Results": properties.numberOfResults,
          "From Page": properties.fromPage,
          "From": properties.from,
          "Screen Height": sysScreenHeight,
          }, "YPAHSHc8sJ", "5e729b2f8434737148c7b62aae050d13f27b382d65a5d6595118e9a413abf1d0");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed My Library", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Number of Results": properties.numberOfResults,
      "From Page": properties.fromPage,
      "From": properties.from,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted My Library: When user interacts with My Library page
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/bF9Cn0o48u/trigger/7bBJQY50C
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} [properties.sortBy] - Self Explanatory. Values such as Most Recent, A-Z, Z-A, etc
   * @param {string} [properties.collectionType] - Have value: Favourite, New, Existing depending on if the book was added to favourites, to an existing collection or new collection
   * @param {Array<string>} [properties.collectionName] - Name of the collection to which book was added/removed
   * @param {Array<int>} [properties.recommendedTileRank] - This property will store the position of the tile on which user has clciked. Earlier this was sent as column position

   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/bF9Cn0o48u}
   */
  function interactedMyLibrary(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertOptionalSortBy(properties.sortBy));
      messages = messages.concat(assertOptionalCollectionType(properties.collectionType));
      messages = messages.concat(assertOptionalCollectionName(properties.collectionName));
      messages = messages.concat(assertOptionalRecommendedTileRank(properties.recommendedTileRank));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted My Library", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "sortBy",
        "collectionType",
        "collectionName",
        "recommendedTileRank"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "bF9Cn0o48u", "28e43487092650efaa23452022705caf5e34be3a641f12e131a2619b29916210", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted My Library", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Sort By": properties.sortBy,
        "Collection Type": properties.collectionType,
        "Collection Name": properties.collectionName,
        "Recommended Tile Rank": properties.recommendedTileRank,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("bF9Cn0o48u", "Interacted My Library", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "FLDtSJNKL", name: "Recommended Tile Rank", value: properties.recommendedTileRank},
        {id: "IIQJLClTN", name: "Sort By", value: properties.sortBy},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "b8Fx1iSZI", name: "Collection Name", value: properties.collectionName},
        {id: "bof7IBLkA", name: "Collection Type", value: properties.collectionType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted My Library': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted My Library", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Sort By": properties.sortBy,
          "Collection Type": properties.collectionType,
          "Collection Name": properties.collectionName,
          "Recommended Tile Rank": properties.recommendedTileRank,
          "Screen Height": sysScreenHeight,
          }, "bF9Cn0o48u", "28e43487092650efaa23452022705caf5e34be3a641f12e131a2619b29916210");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted My Library", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Sort By": properties.sortBy,
      "Collection Type": properties.collectionType,
      "Collection Name": properties.collectionName,
      "Recommended Tile Rank": properties.recommendedTileRank,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Collection: when a user interacts with elements inside a collection
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/95OpmzS7NY/trigger/u_aq_FwMd
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/95OpmzS7NY}
   */
  function interactedCollection(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Collection", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "95OpmzS7NY", "ebc136764a1b8dbc47bd6149dc13a71f286cff21aeb1aecd30a0dc204c1f4962", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Collection", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("95OpmzS7NY", "Interacted Collection", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Collection': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Collection", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "95OpmzS7NY", "ebc136764a1b8dbc47bd6149dc13a71f286cff21aeb1aecd30a0dc204c1f4962");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Collection", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Clicked on Remove: when user clicks on red cross button to remove a book from the collection
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/qm2bd6OmQm/trigger/ilSrZsABU
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.contentType - Type of content viz. Game/Learning Path/Activities/Worksheets
   * @param {string} properties.playableCode - Pass the 'Playable Code' of the Playable being started/clicked
   * @param {string} properties.playableName - Name of playable selected
   * @param {Array<int>} properties.recommendedTileRank - This property will store the position of the tile on which user has clciked. Earlier this was sent as column position

   * @param {string} properties.pageName - Includes the name of the page (Eg: Playzone game listing page, ). This is not the URL but a easily understandable definition of what page is the user at.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/qm2bd6OmQm}
   */
  function clickedOnRemove(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertContentType(properties.contentType));
      messages = messages.concat(assertPlayableCode(properties.playableCode));
      messages = messages.concat(assertPlayableName(properties.playableName));
      messages = messages.concat(assertRecommendedTileRank(properties.recommendedTileRank));
      messages = messages.concat(assertPageName(properties.pageName));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Clicked on Remove", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "contentType",
        "playableCode",
        "playableName",
        "recommendedTileRank",
        "pageName",
        "fromPage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "qm2bd6OmQm", "d224af1143604ac49eb7cc29862589607f4e3e12a26498f60ac51bb5925b0361", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Clicked on Remove", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Content Type": properties.contentType,
        "Playable Code": properties.playableCode,
        "Playable Name": properties.playableName,
        "Recommended Tile Rank": properties.recommendedTileRank,
        "Page Name": properties.pageName,
        "From Page": properties.fromPage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("qm2bd6OmQm", "Clicked on Remove", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "FLDtSJNKL", name: "Recommended Tile Rank", value: properties.recommendedTileRank},
        {id: "MJKSzmqfHu", name: "Page Name", value: properties.pageName},
        {id: "Nfs9QLl8W7", name: "Content Type", value: properties.contentType},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "QjCwFasvW0", name: "Playable Code", value: properties.playableCode},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "c2W4X05Jy", name: "Playable Name", value: properties.playableName},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Clicked on Remove': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Clicked on Remove", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Content Type": properties.contentType,
          "Playable Code": properties.playableCode,
          "Playable Name": properties.playableName,
          "Recommended Tile Rank": properties.recommendedTileRank,
          "Page Name": properties.pageName,
          "From Page": properties.fromPage,
          "Screen Height": sysScreenHeight,
          }, "qm2bd6OmQm", "d224af1143604ac49eb7cc29862589607f4e3e12a26498f60ac51bb5925b0361");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Clicked on Remove", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Content Type": properties.contentType,
      "Playable Code": properties.playableCode,
      "Playable Name": properties.playableName,
      "Recommended Tile Rank": properties.recommendedTileRank,
      "Page Name": properties.pageName,
      "From Page": properties.fromPage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Edit Collection Details: when a user views the collection details pop-up
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/xCwq2HVV-/trigger/-bOI3qLo7
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/xCwq2HVV-}
   */
  function viewedEditCollectionDetails(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Edit Collection Details", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "xCwq2HVV-", "40e9d0016dbd8b8956c40a6127461df3bb2e0d329611a5eb600e7e661675f1e9", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Edit Collection Details", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("xCwq2HVV-", "Viewed Edit Collection Details", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Edit Collection Details': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Edit Collection Details", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "xCwq2HVV-", "40e9d0016dbd8b8956c40a6127461df3bb2e0d329611a5eb600e7e661675f1e9");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Edit Collection Details", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Edit Collection Details: when a user interacts with the collection details pop-up
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/SzCymC_n4D/trigger/EQEimlICC
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/SzCymC_n4D}
   */
  function interactedEditCollectionDetails(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Edit Collection Details", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "SzCymC_n4D", "4619a0e980da9da19db6b24db74b23e70c40401ce4b6aa2830037d3e2d47ee69", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Edit Collection Details", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("SzCymC_n4D", "Interacted Edit Collection Details", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Edit Collection Details': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Edit Collection Details", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "SzCymC_n4D", "4619a0e980da9da19db6b24db74b23e70c40401ce4b6aa2830037d3e2d47ee69");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Edit Collection Details", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Delete Collection: when a user views the delete collection pop-up
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/2drUQMsR59/trigger/8YS9Aj2Ly
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/2drUQMsR59}
   */
  function viewedDeleteCollection(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Delete Collection", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "2drUQMsR59", "13b94674a39a32a924b88bd34f43d1874453cdb3169ecf0d8397f803b057b29b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Delete Collection", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("2drUQMsR59", "Viewed Delete Collection", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Delete Collection': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Delete Collection", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "2drUQMsR59", "13b94674a39a32a924b88bd34f43d1874453cdb3169ecf0d8397f803b057b29b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Delete Collection", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Delete Collection: when a user interacts with the delete collection pop-up
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/O0rliE37FK/trigger/i6qrYBgAO
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/O0rliE37FK}
   */
  function interactedDeleteCollection(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Delete Collection", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "O0rliE37FK", "cf33100cf276bf159105514ed90335ac4ebdf0f1675db9d426ee633ae979aa1f", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Delete Collection", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("O0rliE37FK", "Interacted Delete Collection", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Delete Collection': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Delete Collection", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "O0rliE37FK", "cf33100cf276bf159105514ed90335ac4ebdf0f1675db9d426ee633ae979aa1f");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Delete Collection", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Create a New Assignment: when a user views create a collection assignment pop-up
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/CeFXTzhudB/trigger/Uk-S_ngdt
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.assignmentType - This will capture the type of assignment - Manual or Auto
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/CeFXTzhudB}
   */
  function viewedCreateANewAssignment(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertAssignmentType(properties.assignmentType));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Create a New Assignment", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "assignmentType"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "CeFXTzhudB", "484a8a304930e211008e29f7f4eb556b99d41b423f71674d771da35dc8adcb1b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Create a New Assignment", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Assignment Type": properties.assignmentType,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("CeFXTzhudB", "Viewed Create a New Assignment", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "Ueowl7sRb", name: "Assignment Type", value: properties.assignmentType},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Create a New Assignment': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Create a New Assignment", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Assignment Type": properties.assignmentType,
          "Screen Height": sysScreenHeight,
          }, "CeFXTzhudB", "484a8a304930e211008e29f7f4eb556b99d41b423f71674d771da35dc8adcb1b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Create a New Assignment", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Assignment Type": properties.assignmentType,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Create a New Assignment: when a user interacts with create a collection assignment pop-up
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/5B8Z7u4TGn/trigger/F-XlOmJLx
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.assignmentType - This will capture the type of assignment - Manual or Auto
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/5B8Z7u4TGn}
   */
  function interactedCreateANewAssignment(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertAssignmentType(properties.assignmentType));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Create a New Assignment", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "assignmentType"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "5B8Z7u4TGn", "2ce80da878128beb7f1ba66690fa1e5115aa23d6099e043510386181ca6b0634", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Create a New Assignment", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Assignment Type": properties.assignmentType,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("5B8Z7u4TGn", "Interacted Create a New Assignment", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "Ueowl7sRb", name: "Assignment Type", value: properties.assignmentType},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Create a New Assignment': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Create a New Assignment", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Assignment Type": properties.assignmentType,
          "Screen Height": sysScreenHeight,
          }, "5B8Z7u4TGn", "2ce80da878128beb7f1ba66690fa1e5115aa23d6099e043510386181ca6b0634");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Create a New Assignment", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Assignment Type": properties.assignmentType,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Clicked Collection: when a user clicks on a collection
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/edZw5L-cxw/trigger/bjup0AYDc
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {Array<string>} properties.collectionCode - Self Explanatory
   * @param {Array<string>} properties.collectionName - Name of the collection to which book was added/removed
   * @param {Array<string>} properties.recommendedRailName - This is the name of the rail viewed by the user. 
Recommended rail property comes with rail name and rail rank, pipe separated - with the introduction of this property, we intend to separate rail name to calculate CTR on Mixpanel.
   * @param {Array<int>} properties.recommendedTileRank - This property will store the position of the tile on which user has clciked. Earlier this was sent as column position

   * @param {string} properties.pageName - Includes the name of the page (Eg: Playzone game listing page, ). This is not the URL but a easily understandable definition of what page is the user at.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/edZw5L-cxw}
   */
  function clickedCollection(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertCollectionCode(properties.collectionCode));
      messages = messages.concat(assertCollectionName(properties.collectionName));
      messages = messages.concat(assertRecommendedRailName(properties.recommendedRailName));
      messages = messages.concat(assertRecommendedTileRank(properties.recommendedTileRank));
      messages = messages.concat(assertPageName(properties.pageName));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Clicked Collection", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "collectionCode",
        "collectionName",
        "recommendedRailName",
        "recommendedTileRank",
        "pageName",
        "fromPage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "edZw5L-cxw", "12673757c81c3d6aa91d6c107ce995f734f78cfb8409128f373798c43cd69506", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Clicked Collection", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Collection Code": properties.collectionCode,
        "Collection Name": properties.collectionName,
        "Recommended Rail Name": properties.recommendedRailName,
        "Recommended Tile Rank": properties.recommendedTileRank,
        "Page Name": properties.pageName,
        "From Page": properties.fromPage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("edZw5L-cxw", "Clicked Collection", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "6lrsWYY5Y", name: "Recommended Rail Name", value: properties.recommendedRailName},
        {id: "FLDtSJNKL", name: "Recommended Tile Rank", value: properties.recommendedTileRank},
        {id: "MJKSzmqfHu", name: "Page Name", value: properties.pageName},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "b8Fx1iSZI", name: "Collection Name", value: properties.collectionName},
        {id: "eMtEG5HBc", name: "Collection Code", value: properties.collectionCode},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Clicked Collection': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Clicked Collection", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Collection Code": properties.collectionCode,
          "Collection Name": properties.collectionName,
          "Recommended Rail Name": properties.recommendedRailName,
          "Recommended Tile Rank": properties.recommendedTileRank,
          "Page Name": properties.pageName,
          "From Page": properties.fromPage,
          "Screen Height": sysScreenHeight,
          }, "edZw5L-cxw", "12673757c81c3d6aa91d6c107ce995f734f78cfb8409128f373798c43cd69506");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Clicked Collection", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Collection Code": properties.collectionCode,
      "Collection Name": properties.collectionName,
      "Recommended Rail Name": properties.recommendedRailName,
      "Recommended Tile Rank": properties.recommendedTileRank,
      "Page Name": properties.pageName,
      "From Page": properties.fromPage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Math Facts Page [B2B]: User lands on math facts page.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/UEROdBnHWh/trigger/_vTKpFKRQ
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * @param {int} properties.daysSinceClassCreation - Self explanatory
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/UEROdBnHWh}
   */
  function viewedMathFactsPageB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertDaysSinceClassCreation(properties.daysSinceClassCreation));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Math Facts Page [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "fromPage",
        "daysSinceClassCreation"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "UEROdBnHWh", "b6427564fe8a52a7275f44f35d332ee27ce1a41f7ec59b41f25fc65fcedc9bd5", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Math Facts Page [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From Page": properties.fromPage,
        "Days Since Class Creation": properties.daysSinceClassCreation,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("UEROdBnHWh", "Viewed Math Facts Page [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "TuspgTIuZ1", name: "Days Since Class Creation", value: properties.daysSinceClassCreation},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Math Facts Page [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Math Facts Page [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From Page": properties.fromPage,
          "Days Since Class Creation": properties.daysSinceClassCreation,
          "Screen Height": sysScreenHeight,
          }, "UEROdBnHWh", "b6427564fe8a52a7275f44f35d332ee27ce1a41f7ec59b41f25fc65fcedc9bd5");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Math Facts Page [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From Page": properties.fromPage,
      "Days Since Class Creation": properties.daysSinceClassCreation,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Assessments Page [B2B]: User lands on assessment page
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/u-A0a6_ITi/trigger/pRatT7zwq
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * @param {int} properties.daysSinceClassCreation - Self explanatory
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/u-A0a6_ITi}
   */
  function viewedAssessmentsPageB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertDaysSinceClassCreation(properties.daysSinceClassCreation));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Assessments Page [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "fromPage",
        "daysSinceClassCreation"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "u-A0a6_ITi", "6f48836083d5836ba4c03587b0bee1097543e6c0c4e32615fc5e0271de109f8b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Assessments Page [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From Page": properties.fromPage,
        "Days Since Class Creation": properties.daysSinceClassCreation,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("u-A0a6_ITi", "Viewed Assessments Page [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "TuspgTIuZ1", name: "Days Since Class Creation", value: properties.daysSinceClassCreation},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Assessments Page [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Assessments Page [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From Page": properties.fromPage,
          "Days Since Class Creation": properties.daysSinceClassCreation,
          "Screen Height": sysScreenHeight,
          }, "u-A0a6_ITi", "6f48836083d5836ba4c03587b0bee1097543e6c0c4e32615fc5e0271de109f8b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Assessments Page [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From Page": properties.fromPage,
      "Days Since Class Creation": properties.daysSinceClassCreation,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Math Facts Report Page [B2B]: user lands on math facts reports page
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/qjHrFsv14O/trigger/QYLvV6RCL
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * @param {int} properties.daysSinceClassCreation - Self explanatory
   * @param {string} properties.pageName - Includes the name of the page (Eg: Playzone game listing page, ). This is not the URL but a easily understandable definition of what page is the user at.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/qjHrFsv14O}
   */
  function viewedMathFactsReportPageB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertDaysSinceClassCreation(properties.daysSinceClassCreation));
      messages = messages.concat(assertPageName(properties.pageName));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Math Facts Report Page [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "fromPage",
        "daysSinceClassCreation",
        "pageName"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "qjHrFsv14O", "72d6b8f86dfcd0be3c88e1a3c17da148c06b96a059088b28f3af61a22ee7df43", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Math Facts Report Page [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From Page": properties.fromPage,
        "Days Since Class Creation": properties.daysSinceClassCreation,
        "Page Name": properties.pageName,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("qjHrFsv14O", "Viewed Math Facts Report Page [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "MJKSzmqfHu", name: "Page Name", value: properties.pageName},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "TuspgTIuZ1", name: "Days Since Class Creation", value: properties.daysSinceClassCreation},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Math Facts Report Page [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Math Facts Report Page [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From Page": properties.fromPage,
          "Days Since Class Creation": properties.daysSinceClassCreation,
          "Page Name": properties.pageName,
          "Screen Height": sysScreenHeight,
          }, "qjHrFsv14O", "72d6b8f86dfcd0be3c88e1a3c17da148c06b96a059088b28f3af61a22ee7df43");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Math Facts Report Page [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From Page": properties.fromPage,
      "Days Since Class Creation": properties.daysSinceClassCreation,
      "Page Name": properties.pageName,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Assessments Report Page [B2B]: user lands on assessment reports page
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/GICD1DcI2X/trigger/iXzyka7jo
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * @param {int} properties.daysSinceClassCreation - Self explanatory
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/GICD1DcI2X}
   */
  function viewedAssessmentsReportPageB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertDaysSinceClassCreation(properties.daysSinceClassCreation));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Assessments Report Page [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "fromPage",
        "daysSinceClassCreation"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "GICD1DcI2X", "70b7159532cb03b965dee74a3602b9c1a2752a070e1a5c5417236fc557099dd0", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Assessments Report Page [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From Page": properties.fromPage,
        "Days Since Class Creation": properties.daysSinceClassCreation,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("GICD1DcI2X", "Viewed Assessments Report Page [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "TuspgTIuZ1", name: "Days Since Class Creation", value: properties.daysSinceClassCreation},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Assessments Report Page [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Assessments Report Page [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From Page": properties.fromPage,
          "Days Since Class Creation": properties.daysSinceClassCreation,
          "Screen Height": sysScreenHeight,
          }, "GICD1DcI2X", "70b7159532cb03b965dee74a3602b9c1a2752a070e1a5c5417236fc557099dd0");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Assessments Report Page [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From Page": properties.fromPage,
      "Days Since Class Creation": properties.daysSinceClassCreation,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Class Report Page [B2B]: user lands on class report page - curriculum/ facts
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/XEGkQ7GZSj/trigger/-AdRCQKkD
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.pageName - Includes the name of the page (Eg: Playzone game listing page, ). This is not the URL but a easily understandable definition of what page is the user at.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * @param {int} properties.daysSinceClassCreation - Self explanatory
   * @param {string} properties.curriculumType - type of curriculum - Common Core Standards / milestone
   * @param {string} properties.gradeSelected - Grade selected by user in curriculum tab
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/XEGkQ7GZSj}
   */
  function viewedClassReportPageB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertPageName(properties.pageName));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertDaysSinceClassCreation(properties.daysSinceClassCreation));
      messages = messages.concat(assertCurriculumType(properties.curriculumType));
      messages = messages.concat(assertGradeSelected(properties.gradeSelected));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Class Report Page [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "pageName",
        "fromPage",
        "daysSinceClassCreation",
        "curriculumType",
        "gradeSelected"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "XEGkQ7GZSj", "292a3737743f8f86d07d5d713f1eac1b1c2352df8663d343eed0c6623fbd375c", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Class Report Page [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Page Name": properties.pageName,
        "From Page": properties.fromPage,
        "Days Since Class Creation": properties.daysSinceClassCreation,
        "Curriculum Type": properties.curriculumType,
        "Grade Selected": properties.gradeSelected,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("XEGkQ7GZSj", "Viewed Class Report Page [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "Fcl7PSdr4", name: "Grade Selected", value: properties.gradeSelected},
        {id: "MJKSzmqfHu", name: "Page Name", value: properties.pageName},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "TuspgTIuZ1", name: "Days Since Class Creation", value: properties.daysSinceClassCreation},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "Xvxho3cru", name: "Curriculum Type", value: properties.curriculumType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Class Report Page [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Class Report Page [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Page Name": properties.pageName,
          "From Page": properties.fromPage,
          "Days Since Class Creation": properties.daysSinceClassCreation,
          "Curriculum Type": properties.curriculumType,
          "Grade Selected": properties.gradeSelected,
          "Screen Height": sysScreenHeight,
          }, "XEGkQ7GZSj", "292a3737743f8f86d07d5d713f1eac1b1c2352df8663d343eed0c6623fbd375c");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Class Report Page [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Page Name": properties.pageName,
      "From Page": properties.fromPage,
      "Days Since Class Creation": properties.daysSinceClassCreation,
      "Curriculum Type": properties.curriculumType,
      "Grade Selected": properties.gradeSelected,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Student Report Page [B2B]: user lands on student report page - curriculum/ facts
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/deAMZV7usY/trigger/mVagQSWcF
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.pageName - Includes the name of the page (Eg: Playzone game listing page, ). This is not the URL but a easily understandable definition of what page is the user at.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * @param {int} properties.daysSinceClassCreation - Self explanatory
   * @param {string} properties.curriculumType - type of curriculum - Common Core Standards / milestone
   * @param {string} properties.gradeSelected - Grade selected by user in curriculum tab
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/deAMZV7usY}
   */
  function viewedStudentReportPageB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertPageName(properties.pageName));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertDaysSinceClassCreation(properties.daysSinceClassCreation));
      messages = messages.concat(assertCurriculumType(properties.curriculumType));
      messages = messages.concat(assertGradeSelected(properties.gradeSelected));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Student Report Page [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "pageName",
        "fromPage",
        "daysSinceClassCreation",
        "curriculumType",
        "gradeSelected"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "deAMZV7usY", "a4605b6b640235f06c3733175f0c740fe00caefad4bc2f157d1aba1ff8910955", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Student Report Page [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Page Name": properties.pageName,
        "From Page": properties.fromPage,
        "Days Since Class Creation": properties.daysSinceClassCreation,
        "Curriculum Type": properties.curriculumType,
        "Grade Selected": properties.gradeSelected,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("deAMZV7usY", "Viewed Student Report Page [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "Fcl7PSdr4", name: "Grade Selected", value: properties.gradeSelected},
        {id: "MJKSzmqfHu", name: "Page Name", value: properties.pageName},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "TuspgTIuZ1", name: "Days Since Class Creation", value: properties.daysSinceClassCreation},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "Xvxho3cru", name: "Curriculum Type", value: properties.curriculumType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Student Report Page [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Student Report Page [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Page Name": properties.pageName,
          "From Page": properties.fromPage,
          "Days Since Class Creation": properties.daysSinceClassCreation,
          "Curriculum Type": properties.curriculumType,
          "Grade Selected": properties.gradeSelected,
          "Screen Height": sysScreenHeight,
          }, "deAMZV7usY", "a4605b6b640235f06c3733175f0c740fe00caefad4bc2f157d1aba1ff8910955");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Student Report Page [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Page Name": properties.pageName,
      "From Page": properties.fromPage,
      "Days Since Class Creation": properties.daysSinceClassCreation,
      "Curriculum Type": properties.curriculumType,
      "Grade Selected": properties.gradeSelected,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Curriculum Tab: User takes an action on curriculum page/ skill selection screen
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/NR6PoIs9ST/trigger/2nQjcC-fa
   * 2. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/NR6PoIs9ST/trigger/-jPeBBeY9
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.contentGroup - Code of content group user clicked/tapped on
   * @param {string} properties.curriculumType - type of curriculum - Common Core Standards / milestone
   * @param {string} properties.contentGroupName - Name of content group user clicked/tapped on
   * @param {string} properties.loName - Highlights for which LO event has triggered.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * @param {string} properties.clickSource - This property will be used to identify the click that lead to this popup. The subscription popups can now be seen from various flows like play more on lp, play games again on lp, click on locked cards, save customised setting.
   * @param {string} [properties.valueName] - This will capture the value/text of the field that is selected.
   * @param {string} properties.gradeSelected - Grade selected by user in curriculum tab
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/NR6PoIs9ST}
   */
  function interactedCurriculumTab(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertContentGroup(properties.contentGroup));
      messages = messages.concat(assertCurriculumType(properties.curriculumType));
      messages = messages.concat(assertContentGroupName(properties.contentGroupName));
      messages = messages.concat(assertLOName(properties.loName));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertClickSource(properties.clickSource));
      messages = messages.concat(assertOptionalValueName(properties.valueName));
      messages = messages.concat(assertGradeSelected(properties.gradeSelected));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Curriculum Tab", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "contentGroup",
        "curriculumType",
        "contentGroupName",
        "loName",
        "fromPage",
        "clickSource",
        "valueName",
        "gradeSelected"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "NR6PoIs9ST", "793cd5844517d8492503b387a308f6fe4d10aeec0986884661b43b64326a75fa", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Curriculum Tab", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Content Group": properties.contentGroup,
        "Curriculum Type": properties.curriculumType,
        "Content Group Name": properties.contentGroupName,
        "LO Name": properties.loName,
        "From Page": properties.fromPage,
        "Click Source": properties.clickSource,
        "Value Name": properties.valueName,
        "Grade Selected": properties.gradeSelected,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("NR6PoIs9ST", "Interacted Curriculum Tab", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "CdbCi-2yB", name: "LO Name", value: properties.loName},
        {id: "Fcl7PSdr4", name: "Grade Selected", value: properties.gradeSelected},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "Otu1r2JQW", name: "Content Group", value: properties.contentGroup},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "TfrlXL1gV", name: "Content Group Name", value: properties.contentGroupName},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "Xvxho3cru", name: "Curriculum Type", value: properties.curriculumType},
        {id: "l-8JNUE0q", name: "Value Name", value: properties.valueName},
        {id: "mVqeh4I8W", name: "Click Source", value: properties.clickSource},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Curriculum Tab': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Curriculum Tab", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Content Group": properties.contentGroup,
          "Curriculum Type": properties.curriculumType,
          "Content Group Name": properties.contentGroupName,
          "LO Name": properties.loName,
          "From Page": properties.fromPage,
          "Click Source": properties.clickSource,
          "Value Name": properties.valueName,
          "Grade Selected": properties.gradeSelected,
          "Screen Height": sysScreenHeight,
          }, "NR6PoIs9ST", "793cd5844517d8492503b387a308f6fe4d10aeec0986884661b43b64326a75fa");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Curriculum Tab", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Content Group": properties.contentGroup,
      "Curriculum Type": properties.curriculumType,
      "Content Group Name": properties.contentGroupName,
      "LO Name": properties.loName,
      "From Page": properties.fromPage,
      "Click Source": properties.clickSource,
      "Value Name": properties.valueName,
      "Grade Selected": properties.gradeSelected,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Curriculum Report Tab [B2B]: user views the sub pages of curriculum report tab
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/l6cKnBe_OD/trigger/qIGfm9rCJ
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * @param {int} properties.daysSinceClassCreation - Self explanatory
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/l6cKnBe_OD}
   */
  function viewedCurriculumReportTabB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertDaysSinceClassCreation(properties.daysSinceClassCreation));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Curriculum Report Tab [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "fromPage",
        "daysSinceClassCreation"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "l6cKnBe_OD", "1e1d46f0b87bed7a60df56b245f0e815ba87d7cb18cbae56d24744cd88948728", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Curriculum Report Tab [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From Page": properties.fromPage,
        "Days Since Class Creation": properties.daysSinceClassCreation,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("l6cKnBe_OD", "Viewed Curriculum Report Tab [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "TuspgTIuZ1", name: "Days Since Class Creation", value: properties.daysSinceClassCreation},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Curriculum Report Tab [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Curriculum Report Tab [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From Page": properties.fromPage,
          "Days Since Class Creation": properties.daysSinceClassCreation,
          "Screen Height": sysScreenHeight,
          }, "l6cKnBe_OD", "1e1d46f0b87bed7a60df56b245f0e815ba87d7cb18cbae56d24744cd88948728");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Curriculum Report Tab [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From Page": properties.fromPage,
      "Days Since Class Creation": properties.daysSinceClassCreation,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Book Library Tab  [B2B]: user views the sub-pages of book library tab
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/NN5U21otfX/trigger/saTj-TESQ
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * @param {int} properties.daysSinceClassCreation - Self explanatory
   * @param {string} properties.section - This will capture the widget name that is being viewed/interacted by the user in that viewport. For example, 'Onboarding Widget', 'Home Access Widget', 'Assignment Widget', 'Assessment Widget', 'Math Fact Widget'
The list will only have 1 value for 'Section' property for Interacted event.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/NN5U21otfX}
   */
  function viewedBookLibraryTabB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertDaysSinceClassCreation(properties.daysSinceClassCreation));
      messages = messages.concat(assertSection(properties.section));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Book Library Tab  [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "fromPage",
        "daysSinceClassCreation",
        "section"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "NN5U21otfX", "3b96fc728dbc590fecfbcf1f7a98242106dc56a0a2854d7592b063dd1f63aee6", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Book Library Tab  [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From Page": properties.fromPage,
        "Days Since Class Creation": properties.daysSinceClassCreation,
        "Section": properties.section,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("NN5U21otfX", "Viewed Book Library Tab  [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "TuspgTIuZ1", name: "Days Since Class Creation", value: properties.daysSinceClassCreation},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "my9qL7M8w6", name: "Section", value: properties.section},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Book Library Tab  [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Book Library Tab  [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From Page": properties.fromPage,
          "Days Since Class Creation": properties.daysSinceClassCreation,
          "Section": properties.section,
          "Screen Height": sysScreenHeight,
          }, "NN5U21otfX", "3b96fc728dbc590fecfbcf1f7a98242106dc56a0a2854d7592b063dd1f63aee6");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Book Library Tab  [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From Page": properties.fromPage,
      "Days Since Class Creation": properties.daysSinceClassCreation,
      "Section": properties.section,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Curriculum Tab [B2B]: user views the curriculum assignment page
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/685K_QAcyW/trigger/TcD69olfR
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {int} properties.daysSinceClassCreation - Self explanatory
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * @param {string} properties.curriculumType - type of curriculum - Common Core Standards / milestone
   * @param {string} properties.gradeSelected - Grade selected by user in curriculum tab
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/685K_QAcyW}
   */
  function viewedCurriculumTabB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertDaysSinceClassCreation(properties.daysSinceClassCreation));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertCurriculumType(properties.curriculumType));
      messages = messages.concat(assertGradeSelected(properties.gradeSelected));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Curriculum Tab [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "daysSinceClassCreation",
        "fromPage",
        "curriculumType",
        "gradeSelected"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "685K_QAcyW", "d528c1d00e52419ef84aed0cbf739b88d9fb5d6b707340854e1677a64178b5c4", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Curriculum Tab [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Days Since Class Creation": properties.daysSinceClassCreation,
        "From Page": properties.fromPage,
        "Curriculum Type": properties.curriculumType,
        "Grade Selected": properties.gradeSelected,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("685K_QAcyW", "Viewed Curriculum Tab [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "Fcl7PSdr4", name: "Grade Selected", value: properties.gradeSelected},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "TuspgTIuZ1", name: "Days Since Class Creation", value: properties.daysSinceClassCreation},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "Xvxho3cru", name: "Curriculum Type", value: properties.curriculumType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Curriculum Tab [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Curriculum Tab [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Days Since Class Creation": properties.daysSinceClassCreation,
          "From Page": properties.fromPage,
          "Curriculum Type": properties.curriculumType,
          "Grade Selected": properties.gradeSelected,
          "Screen Height": sysScreenHeight,
          }, "685K_QAcyW", "d528c1d00e52419ef84aed0cbf739b88d9fb5d6b707340854e1677a64178b5c4");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Curriculum Tab [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Days Since Class Creation": properties.daysSinceClassCreation,
      "From Page": properties.fromPage,
      "Curriculum Type": properties.curriculumType,
      "Grade Selected": properties.gradeSelected,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Book Library Tab [B2B]: user interacts with top tab of book library
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/dAWhGjLZcA/trigger/29-kh8End
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {int} properties.daysSinceClassCreation - Self explanatory
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/dAWhGjLZcA}
   */
  function interactedBookLibraryTabB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertDaysSinceClassCreation(properties.daysSinceClassCreation));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Book Library Tab [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "daysSinceClassCreation"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "dAWhGjLZcA", "be0ccb897b9332c78cae78eb9fe97c0dc24a3c2436726da4d4eff185f5bf63d3", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Book Library Tab [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Days Since Class Creation": properties.daysSinceClassCreation,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("dAWhGjLZcA", "Interacted Book Library Tab [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "TuspgTIuZ1", name: "Days Since Class Creation", value: properties.daysSinceClassCreation},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Book Library Tab [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Book Library Tab [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Days Since Class Creation": properties.daysSinceClassCreation,
          "Screen Height": sysScreenHeight,
          }, "dAWhGjLZcA", "be0ccb897b9332c78cae78eb9fe97c0dc24a3c2436726da4d4eff185f5bf63d3");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Book Library Tab [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Days Since Class Creation": properties.daysSinceClassCreation,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Child Profile Page Viewed: This event is associated to the child profile
   * 
   * When to trigger this event:
   * 1. When user gets inside the child profile, i.e. this page is loaded.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/FoGJNpkyXN/trigger/Lb_E2sNdl
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {int} properties.snCount - This stores the count of super novas a child has
   * @param {int} properties.childLevel - This stores the level of the child
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {float} properties.totalMemory - This property stores the total memory allocated by the client device
   * @param {float} properties.memoryLimit - The max memory allocated by the client device
   * @param {float} properties.memoryUsagePercentage - This property stores the % used memory
   * @param {float} properties.usedMemory - This property stores the memory consumed by the website
   * @param {bool} properties.pendingNotification - This property shows if there is any notification in the closer space. Notifications will be shown in the form of numbers on the category which got some new items unlocked. Stores Yes/No
   * @param {string} properties.notificationSource - This property will store the source of the notification -> if it has come from intrusive nudge or subtle nudge (will come later) for avatar items
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/FoGJNpkyXN}
   */
  function childProfilePageViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertSnCount(properties.snCount));
      messages = messages.concat(assertChildLevel(properties.childLevel));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertTotalMemory(properties.totalMemory));
      messages = messages.concat(assertMemoryLimit(properties.memoryLimit));
      messages = messages.concat(assertMemoryUsagePercentage(properties.memoryUsagePercentage));
      messages = messages.concat(assertUsedMemory(properties.usedMemory));
      messages = messages.concat(assertPendingNotification(properties.pendingNotification));
      messages = messages.concat(assertNotificationSource(properties.notificationSource));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Child Profile Page Viewed", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "snCount",
        "childLevel",
        "elaGrade",
        "grade",
        "totalMemory",
        "memoryLimit",
        "memoryUsagePercentage",
        "usedMemory",
        "pendingNotification",
        "notificationSource"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "FoGJNpkyXN", "dc316a9bb7c4d58e4b1b9f61a046fe3183eb4123563f097ada2d7f1aa1c49174", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Child Profile Page Viewed", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Sn Count": properties.snCount,
        "Child Level": properties.childLevel,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Total Memory": properties.totalMemory,
        "Memory Limit": properties.memoryLimit,
        "Memory Usage Percentage": properties.memoryUsagePercentage,
        "Used Memory": properties.usedMemory,
        "Pending Notification": properties.pendingNotification,
        "Notification Source": properties.notificationSource,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("FoGJNpkyXN", "Child Profile Page Viewed", messages, [
        {id: "0zT29qODq6yxzJjbmuRzz", name: "Notification Source", value: properties.notificationSource},
        {id: "2hMTTBgU30", name: "Total Memory", value: properties.totalMemory},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "ADfS21LlJH", name: "Memory Limit", value: properties.memoryLimit},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "fIB6sY9mt", name: "Child Level", value: properties.childLevel},
        {id: "fXWDPkk_PZ", name: "Memory Usage Percentage", value: properties.memoryUsagePercentage},
        {id: "ggXrRwik-", name: "Sn Count", value: properties.snCount},
        {id: "gvDk2xQI4d", name: "Used Memory", value: properties.usedMemory},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "zCFxLL-Ai", name: "Pending Notification", value: properties.pendingNotification},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Child Profile Page Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Child Profile Page Viewed", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Sn Count": properties.snCount,
          "Child Level": properties.childLevel,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Total Memory": properties.totalMemory,
          "Memory Limit": properties.memoryLimit,
          "Memory Usage Percentage": properties.memoryUsagePercentage,
          "Used Memory": properties.usedMemory,
          "Pending Notification": properties.pendingNotification,
          "Notification Source": properties.notificationSource,
          "Screen Height": sysScreenHeight,
          }, "FoGJNpkyXN", "dc316a9bb7c4d58e4b1b9f61a046fe3183eb4123563f097ada2d7f1aa1c49174");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Child Profile Page Viewed", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Sn Count": properties.snCount,
      "Child Level": properties.childLevel,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Total Memory": properties.totalMemory,
      "Memory Limit": properties.memoryLimit,
      "Memory Usage Percentage": properties.memoryUsagePercentage,
      "Used Memory": properties.usedMemory,
      "Pending Notification": properties.pendingNotification,
      "Notification Source": properties.notificationSource,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed All Profiles Pages: This event is associated to the page where all users profiles' reside within child profile.
   * 
   * When to trigger this event:
   * 1. When the switch player / add player page loads for the user.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/1hZek1PIEj/trigger/FZtvD1EWc
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {int} properties.profilesAvailable - This property stores the number of child profiles already created.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/1hZek1PIEj}
   */
  function viewedAllProfilesPages(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertProfilesAvailable(properties.profilesAvailable));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed All Profiles Pages", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "profilesAvailable",
        "elaGrade",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "1hZek1PIEj", "8d4317f42ce5d21c5cbcafd6d90e64604991946a5d50c4df43efbba657b78301", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed All Profiles Pages", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Profiles Available": properties.profilesAvailable,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("1hZek1PIEj", "Viewed All Profiles Pages", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "g7JB969zv", name: "Profiles Available", value: properties.profilesAvailable},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed All Profiles Pages': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed All Profiles Pages", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Profiles Available": properties.profilesAvailable,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "1hZek1PIEj", "8d4317f42ce5d21c5cbcafd6d90e64604991946a5d50c4df43efbba657b78301");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed All Profiles Pages", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Profiles Available": properties.profilesAvailable,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted All Profiles Page: This event is associated to the interactions at the all profiles page.
   * 
   * When to trigger this event:
   * 1. This event is triggered when user interacts with the add profile button, back or any of the profile
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/XZDkHWraoJ/trigger/szgXfcBNC
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {int} properties.profilesAvailable - This property stores the number of child profiles already created.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/XZDkHWraoJ}
   */
  function interactedAllProfilesPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertProfilesAvailable(properties.profilesAvailable));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted All Profiles Page", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "clickedOn",
        "elaGrade",
        "grade",
        "profilesAvailable"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "XZDkHWraoJ", "5f99e2265c2a3d4708fe2b7076248b5aa17c5fdd3c8b455ad14030d5432eb611", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted All Profiles Page", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Clicked On": properties.clickedOn,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Profiles Available": properties.profilesAvailable,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("XZDkHWraoJ", "Interacted All Profiles Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "g7JB969zv", name: "Profiles Available", value: properties.profilesAvailable},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted All Profiles Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted All Profiles Page", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Clicked On": properties.clickedOn,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Profiles Available": properties.profilesAvailable,
          "Screen Height": sysScreenHeight,
          }, "XZDkHWraoJ", "5f99e2265c2a3d4708fe2b7076248b5aa17c5fdd3c8b455ad14030d5432eb611");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted All Profiles Page", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Clicked On": properties.clickedOn,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Profiles Available": properties.profilesAvailable,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Dashboard Nudge: This event is associated to the nudges shown to the users on the dashboard.
   * 
   * When to trigger this event:
   * 1. When any of the dashboard nudge is shown
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/eMoYeOsDtZ/trigger/eseHfU8ft
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.nudgeType - This property stores the type of nudge if it is shown for Avatar Creation or Close Items.
   * @param {int} properties.childLevel - This stores the level of the child
   * @param {int} properties.snCount - This stores the count of super novas a child has
   * @param {string} properties.pendingMemory - This property stores the memory remaining at the current page. It will be used to debug the tech issues.

   * @param {string} properties.categoryName - For Book Library
Category of the books like Animals, People and Culture etc

For Avatar Space
This property stores the categories within closer such as shirt, pant, goggles, hat, etc.

   * @param {string} properties.itemStyle - This property will store the style codes of the items purchased in pipe separated format.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/eMoYeOsDtZ}
   */
  function viewedDashboardNudge(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertNudgeType(properties.nudgeType));
      messages = messages.concat(assertChildLevel(properties.childLevel));
      messages = messages.concat(assertSnCount(properties.snCount));
      messages = messages.concat(assertPendingMemory(properties.pendingMemory));
      messages = messages.concat(assertCategoryName(properties.categoryName));
      messages = messages.concat(assertItemStyle(properties.itemStyle));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Dashboard Nudge", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "elaGrade",
        "grade",
        "nudgeType",
        "childLevel",
        "snCount",
        "pendingMemory",
        "categoryName",
        "itemStyle"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "eMoYeOsDtZ", "8030213b4d9b963361e9b6f1f9496897e53fa900dc6e2077fbbcc717ddb8e6c2", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Dashboard Nudge", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Nudge Type": properties.nudgeType,
        "Child Level": properties.childLevel,
        "Sn Count": properties.snCount,
        "Pending Memory": properties.pendingMemory,
        "Category Name": properties.categoryName,
        "Item Style": properties.itemStyle,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("eMoYeOsDtZ", "Viewed Dashboard Nudge", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "C_BFBZn2V", name: "Pending Memory", value: properties.pendingMemory},
        {id: "FkHymvGjK", name: "Item Style", value: properties.itemStyle},
        {id: "VPMGzU0YX", name: "Nudge Type", value: properties.nudgeType},
        {id: "fIB6sY9mt", name: "Child Level", value: properties.childLevel},
        {id: "ggXrRwik-", name: "Sn Count", value: properties.snCount},
        {id: "kZQO8-HD9", name: "Category Name", value: properties.categoryName},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Dashboard Nudge': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Dashboard Nudge", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Nudge Type": properties.nudgeType,
          "Child Level": properties.childLevel,
          "Sn Count": properties.snCount,
          "Pending Memory": properties.pendingMemory,
          "Category Name": properties.categoryName,
          "Item Style": properties.itemStyle,
          "Screen Height": sysScreenHeight,
          }, "eMoYeOsDtZ", "8030213b4d9b963361e9b6f1f9496897e53fa900dc6e2077fbbcc717ddb8e6c2");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Dashboard Nudge", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Nudge Type": properties.nudgeType,
      "Child Level": properties.childLevel,
      "Sn Count": properties.snCount,
      "Pending Memory": properties.pendingMemory,
      "Category Name": properties.categoryName,
      "Item Style": properties.itemStyle,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Dashboard Nudge: This event is associated to the interactions on the nudge
   * 
   * When to trigger this event:
   * 1. Click on skip or the main CTA
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/DnwAc2u7aX/trigger/tSha8M71k
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.nudgeType - This property stores the type of nudge if it is shown for Avatar Creation or Close Items.
   * @param {int} properties.childLevel - This stores the level of the child
   * @param {int} properties.snCount - This stores the count of super novas a child has
   * @param {string} properties.pendingMemory - This property stores the memory remaining at the current page. It will be used to debug the tech issues.

   * @param {string} properties.categoryName - For Book Library
Category of the books like Animals, People and Culture etc

For Avatar Space
This property stores the categories within closer such as shirt, pant, goggles, hat, etc.

   * @param {string} properties.itemStyle - This property will store the style codes of the items purchased in pipe separated format.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/DnwAc2u7aX}
   */
  function interactedDashboardNudge(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertNudgeType(properties.nudgeType));
      messages = messages.concat(assertChildLevel(properties.childLevel));
      messages = messages.concat(assertSnCount(properties.snCount));
      messages = messages.concat(assertPendingMemory(properties.pendingMemory));
      messages = messages.concat(assertCategoryName(properties.categoryName));
      messages = messages.concat(assertItemStyle(properties.itemStyle));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Dashboard Nudge", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "elaGrade",
        "grade",
        "clickedOn",
        "nudgeType",
        "childLevel",
        "snCount",
        "pendingMemory",
        "categoryName",
        "itemStyle"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "DnwAc2u7aX", "f47f66f70a4da684cc8580cf13f28f6a4f7d7a1833f4d367db5f3c28a3e524a0", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Dashboard Nudge", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Clicked On": properties.clickedOn,
        "Nudge Type": properties.nudgeType,
        "Child Level": properties.childLevel,
        "Sn Count": properties.snCount,
        "Pending Memory": properties.pendingMemory,
        "Category Name": properties.categoryName,
        "Item Style": properties.itemStyle,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("DnwAc2u7aX", "Interacted Dashboard Nudge", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "C_BFBZn2V", name: "Pending Memory", value: properties.pendingMemory},
        {id: "FkHymvGjK", name: "Item Style", value: properties.itemStyle},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "VPMGzU0YX", name: "Nudge Type", value: properties.nudgeType},
        {id: "fIB6sY9mt", name: "Child Level", value: properties.childLevel},
        {id: "ggXrRwik-", name: "Sn Count", value: properties.snCount},
        {id: "kZQO8-HD9", name: "Category Name", value: properties.categoryName},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Dashboard Nudge': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Dashboard Nudge", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Clicked On": properties.clickedOn,
          "Nudge Type": properties.nudgeType,
          "Child Level": properties.childLevel,
          "Sn Count": properties.snCount,
          "Pending Memory": properties.pendingMemory,
          "Category Name": properties.categoryName,
          "Item Style": properties.itemStyle,
          "Screen Height": sysScreenHeight,
          }, "DnwAc2u7aX", "f47f66f70a4da684cc8580cf13f28f6a4f7d7a1833f4d367db5f3c28a3e524a0");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Dashboard Nudge", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Clicked On": properties.clickedOn,
      "Nudge Type": properties.nudgeType,
      "Child Level": properties.childLevel,
      "Sn Count": properties.snCount,
      "Pending Memory": properties.pendingMemory,
      "Category Name": properties.categoryName,
      "Item Style": properties.itemStyle,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Triggered Nudge: This event is associated to the triggering a nudge, i.e. when user meets the criteria for a nudge.
   * 
   * When to trigger this event:
   * 1. When user qualifies for the dashboard nudge
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/dKGcP5E9pz/trigger/Z5Vr18qBX
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.nudgeType - This property stores the type of nudge if it is shown for Avatar Creation or Close Items.
   * @param {string} properties.categoryName - For Book Library
Category of the books like Animals, People and Culture etc

For Avatar Space
This property stores the categories within closer such as shirt, pant, goggles, hat, etc.

   * @param {string} properties.itemStyle - This property will store the style codes of the items purchased in pipe separated format.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/dKGcP5E9pz}
   */
  function triggeredNudge(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertNudgeType(properties.nudgeType));
      messages = messages.concat(assertCategoryName(properties.categoryName));
      messages = messages.concat(assertItemStyle(properties.itemStyle));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Triggered Nudge", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "elaGrade",
        "grade",
        "nudgeType",
        "categoryName",
        "itemStyle"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "dKGcP5E9pz", "66e0715203ce5913e4ba0f49650f736ebe36a1a082bbafcebab872ae24b44157", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Triggered Nudge", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Nudge Type": properties.nudgeType,
        "Category Name": properties.categoryName,
        "Item Style": properties.itemStyle,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("dKGcP5E9pz", "Triggered Nudge", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "FkHymvGjK", name: "Item Style", value: properties.itemStyle},
        {id: "VPMGzU0YX", name: "Nudge Type", value: properties.nudgeType},
        {id: "kZQO8-HD9", name: "Category Name", value: properties.categoryName},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Triggered Nudge': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Triggered Nudge", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Nudge Type": properties.nudgeType,
          "Category Name": properties.categoryName,
          "Item Style": properties.itemStyle,
          "Screen Height": sysScreenHeight,
          }, "dKGcP5E9pz", "66e0715203ce5913e4ba0f49650f736ebe36a1a082bbafcebab872ae24b44157");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Triggered Nudge", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Nudge Type": properties.nudgeType,
      "Category Name": properties.categoryName,
      "Item Style": properties.itemStyle,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Started Pitstop Animation: This event is associated to the newly made pitstops within the gamification project, where we are giving stars, celebrating level ups & tier ups.
   * 
   * When to trigger this event:
   * 1. Triggered when the playable is finished and pitstop animation starts
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/pgZvf5b83k/trigger/Mu4sm9sva
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.tid - It's a unique id associated to every new animation getting triggered.
   * @param {string} properties.stateMachineCode - Every state machine has its own code, so whenever state machine switches we will be able to debug any issue that may arise
   * @param {string} properties.playableCode - Pass the 'Playable Code' of the Playable being started/clicked
   * @param {string} properties.contentType - Type of content viz. Game/Learning Path/Activities/Worksheets
   * @param {string} properties.tabCode - Specifies the tab which has been opened in the event 'Viewed Tiled Dashboard' and Other events too
   * @param {string} properties.pendingMemory - This property stores the memory remaining at the current page. It will be used to debug the tech issues.

   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.pitstopType - This will store if the pitstop is just stars, stars + level up, stars + level up + tier up
   * @param {Array<string>} properties.recommendedRail - This property will be used to store which rails were shown to the user in the HOME tab.

Where possible values are:
Rail Name = Curriculum, Game Zone, Math, Language, Logic & Thinking, Art & Creativity, General Knowledge, Motor Skills, Live Classes, Fluency, Multiplayer
This comes with Rank also with | separation
   * @param {Array<string>} properties.recommendedCategory - This property will be used to store what recommendations were shown to the user in the all tabs.
We'll be saving them in this format:
<Category Name>
where possible values are:
Category name =  MyToDo, Math_LP, ELA_LP, Math Facts, Books, Spelling, Reading Comprehension, Playzone, Activities, Learning Games
   * @param {Array<string>} properties.recommendedRailName - This is the name of the rail viewed by the user. 
Recommended rail property comes with rail name and rail rank, pipe separated - with the introduction of this property, we intend to separate rail name to calculate CTR on Mixpanel.
   * @param {Array<int>} properties.recommendedRailRank - Recommended Rail Rank will carry the rank of the rail in integer format viewed by the user. 
   * @param {Array<string>} [properties.recommendedTileName] - This property will store the code of the tile user has interacted with - CG code for curriculum rails and game code for non curr. rails

   * @param {Array<int>} properties.recommendedTileRank - This property will store the position of the tile on which user has clciked. Earlier this was sent as column position

   * @param {string} properties.contentGroup - Code of content group user clicked/tapped on
   * @param {string} properties.playableClickId - This property will hold a unique string for the playable events.
   * @param {string} properties.gameCode - Game code of the playable selected, for example: Math learning games have multiple variations, all those variations will have one game code
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {int} properties.tabStrClickedCount - Streak count of Playable Clicked from a Specific Tab in a day
   * @param {int} properties.tabStrStartedCount - Streak count of Playable Started from a Specific Tab in a day
   * @param {int} properties.railStrClickedCount - Streak count of Playable Clicked from a Specific Rail in a day
   * @param {int} properties.railStrStartedCount - Streak count of Playable Started from a Specific Rail in a day
   * @param {int} properties.tileStrClickedCount - Streak count of Playable Clicked from a Specific Tile in a day
   * @param {int} properties.tileStrStartedCount - Streak count of Playable Started from a Specific Tile in a day
   * @param {int} properties.tabStrCompletedCount - Streak count of Playable Completed from a Specific Tab in a day
   * @param {int} properties.railStrCompletedCount - Streak count of Playable Completed from a Specific Rail in a day
   * @param {int} properties.tileStrCompletedCount - Streak count of Playable Completed from a Specific Tile in a day
   * @param {int} properties.overallClickedCount - Streak count of Playable Clicked in a day from anywhere
   * @param {int} properties.overallStartedCount - Streak count of Playable Started in a day from anywhere
   * @param {int} properties.overallCompletedCount - Streak count of Playable Completed in a day from anywhere
   * @param {string} properties.tileCode - Code of the Tile: Debugging purpose by tech team
   * @param {string} properties.railCode - Code of the Rail: Debugging purpose
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/pgZvf5b83k}
   */
  function startedPitstopAnimation(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertTid(properties.tid));
      messages = messages.concat(assertStateMachineCode(properties.stateMachineCode));
      messages = messages.concat(assertPlayableCode(properties.playableCode));
      messages = messages.concat(assertContentType(properties.contentType));
      messages = messages.concat(assertTabCode(properties.tabCode));
      messages = messages.concat(assertPendingMemory(properties.pendingMemory));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertPitstopType(properties.pitstopType));
      messages = messages.concat(assertRecommendedRail(properties.recommendedRail));
      messages = messages.concat(assertRecommendedCategory(properties.recommendedCategory));
      messages = messages.concat(assertRecommendedRailName(properties.recommendedRailName));
      messages = messages.concat(assertRecommendedRailRank(properties.recommendedRailRank));
      messages = messages.concat(assertOptionalRecommendedTileName(properties.recommendedTileName));
      messages = messages.concat(assertRecommendedTileRank(properties.recommendedTileRank));
      messages = messages.concat(assertContentGroup(properties.contentGroup));
      messages = messages.concat(assertPlayableClickId(properties.playableClickId));
      messages = messages.concat(assertGameCode(properties.gameCode));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertTabStrClickedCount(properties.tabStrClickedCount));
      messages = messages.concat(assertTabStrStartedCount(properties.tabStrStartedCount));
      messages = messages.concat(assertRailStrClickedCount(properties.railStrClickedCount));
      messages = messages.concat(assertRailStrStartedCount(properties.railStrStartedCount));
      messages = messages.concat(assertTileStrClickedCount(properties.tileStrClickedCount));
      messages = messages.concat(assertTileStrStartedCount(properties.tileStrStartedCount));
      messages = messages.concat(assertTabStrCompletedCount(properties.tabStrCompletedCount));
      messages = messages.concat(assertRailStrCompletedCount(properties.railStrCompletedCount));
      messages = messages.concat(assertTileStrCompletedCount(properties.tileStrCompletedCount));
      messages = messages.concat(assertOverallClickedCount(properties.overallClickedCount));
      messages = messages.concat(assertOverallStartedCount(properties.overallStartedCount));
      messages = messages.concat(assertOverallCompletedCount(properties.overallCompletedCount));
      messages = messages.concat(assertTileCode(properties.tileCode));
      messages = messages.concat(assertRailCode(properties.railCode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Started Pitstop Animation", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "tid",
        "stateMachineCode",
        "playableCode",
        "contentType",
        "tabCode",
        "pendingMemory",
        "elaGrade",
        "grade",
        "pitstopType",
        "recommendedRail",
        "recommendedCategory",
        "recommendedRailName",
        "recommendedRailRank",
        "recommendedTileName",
        "recommendedTileRank",
        "contentGroup",
        "playableClickId",
        "gameCode",
        "from",
        "tabStrClickedCount",
        "tabStrStartedCount",
        "railStrClickedCount",
        "railStrStartedCount",
        "tileStrClickedCount",
        "tileStrStartedCount",
        "tabStrCompletedCount",
        "railStrCompletedCount",
        "tileStrCompletedCount",
        "overallClickedCount",
        "overallStartedCount",
        "overallCompletedCount",
        "tileCode",
        "railCode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "pgZvf5b83k", "b972e39bdf8768dd6b13be9bf48ec89f935b78aa98dad251e33a7e848a68e583", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Started Pitstop Animation", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Tid": properties.tid,
        "State Machine Code": properties.stateMachineCode,
        "Playable Code": properties.playableCode,
        "Content Type": properties.contentType,
        "Tab Code": properties.tabCode,
        "Pending Memory": properties.pendingMemory,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Pitstop Type": properties.pitstopType,
        "Recommended Rail": properties.recommendedRail,
        "Recommended Category": properties.recommendedCategory,
        "Recommended Rail Name": properties.recommendedRailName,
        "Recommended Rail Rank": properties.recommendedRailRank,
        "Recommended Tile Name": properties.recommendedTileName,
        "Recommended Tile Rank": properties.recommendedTileRank,
        "Content Group": properties.contentGroup,
        "Playable Click Id": properties.playableClickId,
        "Game Code": properties.gameCode,
        "From": properties.from,
        "Tab Str Clicked Count": properties.tabStrClickedCount,
        "Tab Str Started Count": properties.tabStrStartedCount,
        "Rail Str Clicked Count": properties.railStrClickedCount,
        "Rail Str Started Count": properties.railStrStartedCount,
        "Tile Str Clicked Count": properties.tileStrClickedCount,
        "Tile Str Started Count": properties.tileStrStartedCount,
        "Tab Str Completed Count": properties.tabStrCompletedCount,
        "Rail Str Completed Count": properties.railStrCompletedCount,
        "Tile Str Completed Count": properties.tileStrCompletedCount,
        "Overall Clicked Count": properties.overallClickedCount,
        "Overall Started Count": properties.overallStartedCount,
        "Overall Completed Count": properties.overallCompletedCount,
        "Tile Code": properties.tileCode,
        "Rail Code": properties.railCode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("pgZvf5b83k", "Started Pitstop Animation", messages, [
        {id: "2oZQdvXRu", name: "Game Code", value: properties.gameCode},
        {id: "33JWk0cGdkpH6MbvcXKfL", name: "Tile Str Clicked Count", value: properties.tileStrClickedCount},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "6lrsWYY5Y", name: "Recommended Rail Name", value: properties.recommendedRailName},
        {id: "72Hz7CelRpVYf1warHrRP", name: "Tile Str Started Count", value: properties.tileStrStartedCount},
        {id: "7PQh3G9ITCcMDMNeMTM8q", name: "Tab Str Clicked Count", value: properties.tabStrClickedCount},
        {id: "8Vq9HABFDQ", name: "Pitstop Type", value: properties.pitstopType},
        {id: "AFC3Xnyx0vxpH2PWZIjdO", name: "Rail Str Completed Count", value: properties.railStrCompletedCount},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "C_BFBZn2V", name: "Pending Memory", value: properties.pendingMemory},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "FLDtSJNKL", name: "Recommended Tile Rank", value: properties.recommendedTileRank},
        {id: "GAdbKqJ5y9HJPos5lx5qt", name: "Tab Str Completed Count", value: properties.tabStrCompletedCount},
        {id: "GJYEymipLkc1xy54AyhV8", name: "Tile Code", value: properties.tileCode},
        {id: "HFnzATNuS7GI6VZs6tZ15", name: "Tab Str Started Count", value: properties.tabStrStartedCount},
        {id: "HJUIBmGrsUmqa_TYCtwQ0", name: "Overall Started Count", value: properties.overallStartedCount},
        {id: "Nfs9QLl8W7", name: "Content Type", value: properties.contentType},
        {id: "OHBx0fnhzlxvHhw0e87pM", name: "Overall Completed Count", value: properties.overallCompletedCount},
        {id: "Otu1r2JQW", name: "Content Group", value: properties.contentGroup},
        {id: "QDMKmRkRjbW4pFvqlGOM6", name: "Rail Code", value: properties.railCode},
        {id: "QQeu-Td4-0", name: "Playable Click Id", value: properties.playableClickId},
        {id: "QjCwFasvW0", name: "Playable Code", value: properties.playableCode},
        {id: "SYGmTqa9e", name: "Tid", value: properties.tid},
        {id: "T9gjnp76o", name: "State Machine Code", value: properties.stateMachineCode},
        {id: "TYbmk5DQn", name: "Recommended Tile Name", value: properties.recommendedTileName},
        {id: "VdJhEU0H6s", name: "Recommended Category", value: properties.recommendedCategory},
        {id: "X4kgAx81N5AHgcI6NaNiS", name: "Overall Clicked Count", value: properties.overallClickedCount},
        {id: "_QL92wEdpoa8wH50vOPYt", name: "Tile Str Completed Count", value: properties.tileStrCompletedCount},
        {id: "drNgwJn5Xg", name: "Recommended Rail", value: properties.recommendedRail},
        {id: "hKAJ3izCFVFH-D4_886C8", name: "Rail Str Clicked Count", value: properties.railStrClickedCount},
        {id: "l9PbANZBu", name: "Tab Code", value: properties.tabCode},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "sRPi7ITwtlHeD7HQEGzmG", name: "Rail Str Started Count", value: properties.railStrStartedCount},
        {id: "uyLgqxbg7", name: "Recommended Rail Rank", value: properties.recommendedRailRank},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Started Pitstop Animation': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Started Pitstop Animation", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Tid": properties.tid,
          "State Machine Code": properties.stateMachineCode,
          "Playable Code": properties.playableCode,
          "Content Type": properties.contentType,
          "Tab Code": properties.tabCode,
          "Pending Memory": properties.pendingMemory,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Pitstop Type": properties.pitstopType,
          "Recommended Rail": properties.recommendedRail,
          "Recommended Category": properties.recommendedCategory,
          "Recommended Rail Name": properties.recommendedRailName,
          "Recommended Rail Rank": properties.recommendedRailRank,
          "Recommended Tile Name": properties.recommendedTileName,
          "Recommended Tile Rank": properties.recommendedTileRank,
          "Content Group": properties.contentGroup,
          "Playable Click Id": properties.playableClickId,
          "Game Code": properties.gameCode,
          "From": properties.from,
          "Tab Str Clicked Count": properties.tabStrClickedCount,
          "Tab Str Started Count": properties.tabStrStartedCount,
          "Rail Str Clicked Count": properties.railStrClickedCount,
          "Rail Str Started Count": properties.railStrStartedCount,
          "Tile Str Clicked Count": properties.tileStrClickedCount,
          "Tile Str Started Count": properties.tileStrStartedCount,
          "Tab Str Completed Count": properties.tabStrCompletedCount,
          "Rail Str Completed Count": properties.railStrCompletedCount,
          "Tile Str Completed Count": properties.tileStrCompletedCount,
          "Overall Clicked Count": properties.overallClickedCount,
          "Overall Started Count": properties.overallStartedCount,
          "Overall Completed Count": properties.overallCompletedCount,
          "Tile Code": properties.tileCode,
          "Rail Code": properties.railCode,
          "Screen Height": sysScreenHeight,
          }, "pgZvf5b83k", "b972e39bdf8768dd6b13be9bf48ec89f935b78aa98dad251e33a7e848a68e583");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Started Pitstop Animation", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Tid": properties.tid,
      "State Machine Code": properties.stateMachineCode,
      "Playable Code": properties.playableCode,
      "Content Type": properties.contentType,
      "Tab Code": properties.tabCode,
      "Pending Memory": properties.pendingMemory,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Pitstop Type": properties.pitstopType,
      "Recommended Rail": properties.recommendedRail,
      "Recommended Category": properties.recommendedCategory,
      "Recommended Rail Name": properties.recommendedRailName,
      "Recommended Rail Rank": properties.recommendedRailRank,
      "Recommended Tile Name": properties.recommendedTileName,
      "Recommended Tile Rank": properties.recommendedTileRank,
      "Content Group": properties.contentGroup,
      "Playable Click Id": properties.playableClickId,
      "Game Code": properties.gameCode,
      "From": properties.from,
      "Tab Str Clicked Count": properties.tabStrClickedCount,
      "Tab Str Started Count": properties.tabStrStartedCount,
      "Rail Str Clicked Count": properties.railStrClickedCount,
      "Rail Str Started Count": properties.railStrStartedCount,
      "Tile Str Clicked Count": properties.tileStrClickedCount,
      "Tile Str Started Count": properties.tileStrStartedCount,
      "Tab Str Completed Count": properties.tabStrCompletedCount,
      "Rail Str Completed Count": properties.railStrCompletedCount,
      "Tile Str Completed Count": properties.tileStrCompletedCount,
      "Overall Clicked Count": properties.overallClickedCount,
      "Overall Started Count": properties.overallStartedCount,
      "Overall Completed Count": properties.overallCompletedCount,
      "Tile Code": properties.tileCode,
      "Rail Code": properties.railCode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Completed Pitstop Animation: This event is associated to the new pitstops introduced in the scope of gamification project. Essentially with the completion of the animation.
   * 
   * When to trigger this event:
   * 1. This animation is triggered when the animation is completed at pitstop. Before the start of next playable timer.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/DVNrhKMfSV/trigger/Njn9s5Nsz
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.playableCode - Pass the 'Playable Code' of the Playable being started/clicked
   * @param {string} properties.contentType - Type of content viz. Game/Learning Path/Activities/Worksheets
   * @param {string} properties.tabCode - Specifies the tab which has been opened in the event 'Viewed Tiled Dashboard' and Other events too
   * @param {string} properties.tid - It's a unique id associated to every new animation getting triggered.
   * @param {string} properties.stateMachineCode - Every state machine has its own code, so whenever state machine switches we will be able to debug any issue that may arise
   * @param {string} properties.pendingMemory - This property stores the memory remaining at the current page. It will be used to debug the tech issues.

   * @param {string} properties.pitstopType - This will store if the pitstop is just stars, stars + level up, stars + level up + tier up
   * @param {Array<string>} properties.recommendedRail - This property will be used to store which rails were shown to the user in the HOME tab.

Where possible values are:
Rail Name = Curriculum, Game Zone, Math, Language, Logic & Thinking, Art & Creativity, General Knowledge, Motor Skills, Live Classes, Fluency, Multiplayer
This comes with Rank also with | separation
   * @param {Array<string>} properties.recommendedCategory - This property will be used to store what recommendations were shown to the user in the all tabs.
We'll be saving them in this format:
<Category Name>
where possible values are:
Category name =  MyToDo, Math_LP, ELA_LP, Math Facts, Books, Spelling, Reading Comprehension, Playzone, Activities, Learning Games
   * @param {Array<string>} properties.recommendedRailName - This is the name of the rail viewed by the user. 
Recommended rail property comes with rail name and rail rank, pipe separated - with the introduction of this property, we intend to separate rail name to calculate CTR on Mixpanel.
   * @param {Array<int>} properties.recommendedRailRank - Recommended Rail Rank will carry the rank of the rail in integer format viewed by the user. 
   * @param {Array<string>} [properties.recommendedTileName] - This property will store the code of the tile user has interacted with - CG code for curriculum rails and game code for non curr. rails

   * @param {Array<int>} properties.recommendedTileRank - This property will store the position of the tile on which user has clciked. Earlier this was sent as column position

   * @param {string} properties.contentGroup - Code of content group user clicked/tapped on
   * @param {string} properties.playableClickId - This property will hold a unique string for the playable events.
   * @param {string} properties.gameCode - Game code of the playable selected, for example: Math learning games have multiple variations, all those variations will have one game code
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {int} properties.tabStrClickedCount - Streak count of Playable Clicked from a Specific Tab in a day
   * @param {int} properties.tabStrStartedCount - Streak count of Playable Started from a Specific Tab in a day
   * @param {int} properties.railStrClickedCount - Streak count of Playable Clicked from a Specific Rail in a day
   * @param {int} properties.railStrStartedCount - Streak count of Playable Started from a Specific Rail in a day
   * @param {int} properties.tileStrClickedCount - Streak count of Playable Clicked from a Specific Tile in a day
   * @param {int} properties.tileStrStartedCount - Streak count of Playable Started from a Specific Tile in a day
   * @param {int} properties.tabStrCompletedCount - Streak count of Playable Completed from a Specific Tab in a day
   * @param {int} properties.railStrCompletedCount - Streak count of Playable Completed from a Specific Rail in a day
   * @param {int} properties.tileStrCompletedCount - Streak count of Playable Completed from a Specific Tile in a day
   * @param {int} properties.overallClickedCount - Streak count of Playable Clicked in a day from anywhere
   * @param {int} properties.overallStartedCount - Streak count of Playable Started in a day from anywhere
   * @param {int} properties.overallCompletedCount - Streak count of Playable Completed in a day from anywhere
   * @param {string} properties.tileCode - Code of the Tile: Debugging purpose by tech team
   * @param {string} properties.railCode - Code of the Rail: Debugging purpose
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/DVNrhKMfSV}
   */
  function completedPitstopAnimation(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertPlayableCode(properties.playableCode));
      messages = messages.concat(assertContentType(properties.contentType));
      messages = messages.concat(assertTabCode(properties.tabCode));
      messages = messages.concat(assertTid(properties.tid));
      messages = messages.concat(assertStateMachineCode(properties.stateMachineCode));
      messages = messages.concat(assertPendingMemory(properties.pendingMemory));
      messages = messages.concat(assertPitstopType(properties.pitstopType));
      messages = messages.concat(assertRecommendedRail(properties.recommendedRail));
      messages = messages.concat(assertRecommendedCategory(properties.recommendedCategory));
      messages = messages.concat(assertRecommendedRailName(properties.recommendedRailName));
      messages = messages.concat(assertRecommendedRailRank(properties.recommendedRailRank));
      messages = messages.concat(assertOptionalRecommendedTileName(properties.recommendedTileName));
      messages = messages.concat(assertRecommendedTileRank(properties.recommendedTileRank));
      messages = messages.concat(assertContentGroup(properties.contentGroup));
      messages = messages.concat(assertPlayableClickId(properties.playableClickId));
      messages = messages.concat(assertGameCode(properties.gameCode));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertTabStrClickedCount(properties.tabStrClickedCount));
      messages = messages.concat(assertTabStrStartedCount(properties.tabStrStartedCount));
      messages = messages.concat(assertRailStrClickedCount(properties.railStrClickedCount));
      messages = messages.concat(assertRailStrStartedCount(properties.railStrStartedCount));
      messages = messages.concat(assertTileStrClickedCount(properties.tileStrClickedCount));
      messages = messages.concat(assertTileStrStartedCount(properties.tileStrStartedCount));
      messages = messages.concat(assertTabStrCompletedCount(properties.tabStrCompletedCount));
      messages = messages.concat(assertRailStrCompletedCount(properties.railStrCompletedCount));
      messages = messages.concat(assertTileStrCompletedCount(properties.tileStrCompletedCount));
      messages = messages.concat(assertOverallClickedCount(properties.overallClickedCount));
      messages = messages.concat(assertOverallStartedCount(properties.overallStartedCount));
      messages = messages.concat(assertOverallCompletedCount(properties.overallCompletedCount));
      messages = messages.concat(assertTileCode(properties.tileCode));
      messages = messages.concat(assertRailCode(properties.railCode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Completed Pitstop Animation", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "grade",
        "elaGrade",
        "playableCode",
        "contentType",
        "tabCode",
        "tid",
        "stateMachineCode",
        "pendingMemory",
        "pitstopType",
        "recommendedRail",
        "recommendedCategory",
        "recommendedRailName",
        "recommendedRailRank",
        "recommendedTileName",
        "recommendedTileRank",
        "contentGroup",
        "playableClickId",
        "gameCode",
        "from",
        "tabStrClickedCount",
        "tabStrStartedCount",
        "railStrClickedCount",
        "railStrStartedCount",
        "tileStrClickedCount",
        "tileStrStartedCount",
        "tabStrCompletedCount",
        "railStrCompletedCount",
        "tileStrCompletedCount",
        "overallClickedCount",
        "overallStartedCount",
        "overallCompletedCount",
        "tileCode",
        "railCode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "DVNrhKMfSV", "b4191097ac68af6ede5945d9370d39377b0eab76f5495911850ee9145ffb3225", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Completed Pitstop Animation", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Playable Code": properties.playableCode,
        "Content Type": properties.contentType,
        "Tab Code": properties.tabCode,
        "Tid": properties.tid,
        "State Machine Code": properties.stateMachineCode,
        "Pending Memory": properties.pendingMemory,
        "Pitstop Type": properties.pitstopType,
        "Recommended Rail": properties.recommendedRail,
        "Recommended Category": properties.recommendedCategory,
        "Recommended Rail Name": properties.recommendedRailName,
        "Recommended Rail Rank": properties.recommendedRailRank,
        "Recommended Tile Name": properties.recommendedTileName,
        "Recommended Tile Rank": properties.recommendedTileRank,
        "Content Group": properties.contentGroup,
        "Playable Click Id": properties.playableClickId,
        "Game Code": properties.gameCode,
        "From": properties.from,
        "Tab Str Clicked Count": properties.tabStrClickedCount,
        "Tab Str Started Count": properties.tabStrStartedCount,
        "Rail Str Clicked Count": properties.railStrClickedCount,
        "Rail Str Started Count": properties.railStrStartedCount,
        "Tile Str Clicked Count": properties.tileStrClickedCount,
        "Tile Str Started Count": properties.tileStrStartedCount,
        "Tab Str Completed Count": properties.tabStrCompletedCount,
        "Rail Str Completed Count": properties.railStrCompletedCount,
        "Tile Str Completed Count": properties.tileStrCompletedCount,
        "Overall Clicked Count": properties.overallClickedCount,
        "Overall Started Count": properties.overallStartedCount,
        "Overall Completed Count": properties.overallCompletedCount,
        "Tile Code": properties.tileCode,
        "Rail Code": properties.railCode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("DVNrhKMfSV", "Completed Pitstop Animation", messages, [
        {id: "2oZQdvXRu", name: "Game Code", value: properties.gameCode},
        {id: "33JWk0cGdkpH6MbvcXKfL", name: "Tile Str Clicked Count", value: properties.tileStrClickedCount},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "6lrsWYY5Y", name: "Recommended Rail Name", value: properties.recommendedRailName},
        {id: "72Hz7CelRpVYf1warHrRP", name: "Tile Str Started Count", value: properties.tileStrStartedCount},
        {id: "7PQh3G9ITCcMDMNeMTM8q", name: "Tab Str Clicked Count", value: properties.tabStrClickedCount},
        {id: "8Vq9HABFDQ", name: "Pitstop Type", value: properties.pitstopType},
        {id: "AFC3Xnyx0vxpH2PWZIjdO", name: "Rail Str Completed Count", value: properties.railStrCompletedCount},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "C_BFBZn2V", name: "Pending Memory", value: properties.pendingMemory},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "FLDtSJNKL", name: "Recommended Tile Rank", value: properties.recommendedTileRank},
        {id: "GAdbKqJ5y9HJPos5lx5qt", name: "Tab Str Completed Count", value: properties.tabStrCompletedCount},
        {id: "GJYEymipLkc1xy54AyhV8", name: "Tile Code", value: properties.tileCode},
        {id: "HFnzATNuS7GI6VZs6tZ15", name: "Tab Str Started Count", value: properties.tabStrStartedCount},
        {id: "HJUIBmGrsUmqa_TYCtwQ0", name: "Overall Started Count", value: properties.overallStartedCount},
        {id: "Nfs9QLl8W7", name: "Content Type", value: properties.contentType},
        {id: "OHBx0fnhzlxvHhw0e87pM", name: "Overall Completed Count", value: properties.overallCompletedCount},
        {id: "Otu1r2JQW", name: "Content Group", value: properties.contentGroup},
        {id: "QDMKmRkRjbW4pFvqlGOM6", name: "Rail Code", value: properties.railCode},
        {id: "QQeu-Td4-0", name: "Playable Click Id", value: properties.playableClickId},
        {id: "QjCwFasvW0", name: "Playable Code", value: properties.playableCode},
        {id: "SYGmTqa9e", name: "Tid", value: properties.tid},
        {id: "T9gjnp76o", name: "State Machine Code", value: properties.stateMachineCode},
        {id: "TYbmk5DQn", name: "Recommended Tile Name", value: properties.recommendedTileName},
        {id: "VdJhEU0H6s", name: "Recommended Category", value: properties.recommendedCategory},
        {id: "X4kgAx81N5AHgcI6NaNiS", name: "Overall Clicked Count", value: properties.overallClickedCount},
        {id: "_QL92wEdpoa8wH50vOPYt", name: "Tile Str Completed Count", value: properties.tileStrCompletedCount},
        {id: "drNgwJn5Xg", name: "Recommended Rail", value: properties.recommendedRail},
        {id: "hKAJ3izCFVFH-D4_886C8", name: "Rail Str Clicked Count", value: properties.railStrClickedCount},
        {id: "l9PbANZBu", name: "Tab Code", value: properties.tabCode},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "sRPi7ITwtlHeD7HQEGzmG", name: "Rail Str Started Count", value: properties.railStrStartedCount},
        {id: "uyLgqxbg7", name: "Recommended Rail Rank", value: properties.recommendedRailRank},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Completed Pitstop Animation': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Completed Pitstop Animation", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Playable Code": properties.playableCode,
          "Content Type": properties.contentType,
          "Tab Code": properties.tabCode,
          "Tid": properties.tid,
          "State Machine Code": properties.stateMachineCode,
          "Pending Memory": properties.pendingMemory,
          "Pitstop Type": properties.pitstopType,
          "Recommended Rail": properties.recommendedRail,
          "Recommended Category": properties.recommendedCategory,
          "Recommended Rail Name": properties.recommendedRailName,
          "Recommended Rail Rank": properties.recommendedRailRank,
          "Recommended Tile Name": properties.recommendedTileName,
          "Recommended Tile Rank": properties.recommendedTileRank,
          "Content Group": properties.contentGroup,
          "Playable Click Id": properties.playableClickId,
          "Game Code": properties.gameCode,
          "From": properties.from,
          "Tab Str Clicked Count": properties.tabStrClickedCount,
          "Tab Str Started Count": properties.tabStrStartedCount,
          "Rail Str Clicked Count": properties.railStrClickedCount,
          "Rail Str Started Count": properties.railStrStartedCount,
          "Tile Str Clicked Count": properties.tileStrClickedCount,
          "Tile Str Started Count": properties.tileStrStartedCount,
          "Tab Str Completed Count": properties.tabStrCompletedCount,
          "Rail Str Completed Count": properties.railStrCompletedCount,
          "Tile Str Completed Count": properties.tileStrCompletedCount,
          "Overall Clicked Count": properties.overallClickedCount,
          "Overall Started Count": properties.overallStartedCount,
          "Overall Completed Count": properties.overallCompletedCount,
          "Tile Code": properties.tileCode,
          "Rail Code": properties.railCode,
          "Screen Height": sysScreenHeight,
          }, "DVNrhKMfSV", "b4191097ac68af6ede5945d9370d39377b0eab76f5495911850ee9145ffb3225");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Completed Pitstop Animation", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Playable Code": properties.playableCode,
      "Content Type": properties.contentType,
      "Tab Code": properties.tabCode,
      "Tid": properties.tid,
      "State Machine Code": properties.stateMachineCode,
      "Pending Memory": properties.pendingMemory,
      "Pitstop Type": properties.pitstopType,
      "Recommended Rail": properties.recommendedRail,
      "Recommended Category": properties.recommendedCategory,
      "Recommended Rail Name": properties.recommendedRailName,
      "Recommended Rail Rank": properties.recommendedRailRank,
      "Recommended Tile Name": properties.recommendedTileName,
      "Recommended Tile Rank": properties.recommendedTileRank,
      "Content Group": properties.contentGroup,
      "Playable Click Id": properties.playableClickId,
      "Game Code": properties.gameCode,
      "From": properties.from,
      "Tab Str Clicked Count": properties.tabStrClickedCount,
      "Tab Str Started Count": properties.tabStrStartedCount,
      "Rail Str Clicked Count": properties.railStrClickedCount,
      "Rail Str Started Count": properties.railStrStartedCount,
      "Tile Str Clicked Count": properties.tileStrClickedCount,
      "Tile Str Started Count": properties.tileStrStartedCount,
      "Tab Str Completed Count": properties.tabStrCompletedCount,
      "Rail Str Completed Count": properties.railStrCompletedCount,
      "Tile Str Completed Count": properties.tileStrCompletedCount,
      "Overall Clicked Count": properties.overallClickedCount,
      "Overall Started Count": properties.overallStartedCount,
      "Overall Completed Count": properties.overallCompletedCount,
      "Tile Code": properties.tileCode,
      "Rail Code": properties.railCode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Topics Modification Screen: This event is associated to the modification screen of the learning plan screen shown in the o/b journey for COQ Yes users. From this screen, users can modify the topics in the daily bundle.
   * 
   * When to trigger this event:
   * 1. When user hits the modify button on learning plan screen and lands here.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/5v11mOsvxr/trigger/N1KmMRGlg
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.coqBasedPersona - This property stores the user persona based on users' answers. For example, user is at counting stage, Addition Stage, Advanced Addition Stage, etc.
   * @param {string} properties.selectedTopics - This properties stores the topics selected on the page on different screens such as Learning Plan, Pre & Post Modification, etc.

   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/5v11mOsvxr}
   */
  function viewedTopicsModificationScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertCoqBasedPersona(properties.coqBasedPersona));
      messages = messages.concat(assertSelectedTopics(properties.selectedTopics));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Topics Modification Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "grade",
        "elaGrade",
        "subject",
        "coqBasedPersona",
        "selectedTopics"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "5v11mOsvxr", "39e898afdb2d094554223a8234da07c65030525a2cf719fd3efb1275881f847e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Topics Modification Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Subject": properties.subject,
        "Coq Based Persona": properties.coqBasedPersona,
        "Selected Topics": properties.selectedTopics,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("5v11mOsvxr", "Viewed Topics Modification Screen", messages, [
        {id: "0zw-Zh02K", name: "Selected Topics", value: properties.selectedTopics},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "Bb6PCfOO6", name: "Coq Based Persona", value: properties.coqBasedPersona},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Topics Modification Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Topics Modification Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Subject": properties.subject,
          "Coq Based Persona": properties.coqBasedPersona,
          "Selected Topics": properties.selectedTopics,
          "Screen Height": sysScreenHeight,
          }, "5v11mOsvxr", "39e898afdb2d094554223a8234da07c65030525a2cf719fd3efb1275881f847e");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Topics Modification Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Subject": properties.subject,
      "Coq Based Persona": properties.coqBasedPersona,
      "Selected Topics": properties.selectedTopics,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Topics Modification Screen: This event is associated to the interactions on this page. Essentially they can change the recommended topics in the learning path/daily bundle
   * 
   * When to trigger this event:
   * 1. When user clicks on the CTAs. Reset/Back/Looks good, continue
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Z4gMTBDOj_/trigger/eEmi8jQuz
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.coqBasedPersona - This property stores the user persona based on users' answers. For example, user is at counting stage, Addition Stage, Advanced Addition Stage, etc.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.selectedTopics - This properties stores the topics selected on the page on different screens such as Learning Plan, Pre & Post Modification, etc.

   * @param {bool} properties.modifiedTopics - This property stores yes/no. If user modifies the recommendations, it stores yes else no.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Z4gMTBDOj_}
   */
  function interactedTopicsModificationScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertCoqBasedPersona(properties.coqBasedPersona));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertSelectedTopics(properties.selectedTopics));
      messages = messages.concat(assertModifiedTopics(properties.modifiedTopics));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Topics Modification Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "grade",
        "elaGrade",
        "coqBasedPersona",
        "clickedOn",
        "selectedTopics",
        "modifiedTopics"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Z4gMTBDOj_", "d2f2a5c514c31737750dc1a3cda6cc50382ffc90e3f0aed1f63e8a691a50d954", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Topics Modification Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Coq Based Persona": properties.coqBasedPersona,
        "Clicked On": properties.clickedOn,
        "Selected Topics": properties.selectedTopics,
        "Modified Topics": properties.modifiedTopics,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Z4gMTBDOj_", "Interacted Topics Modification Screen", messages, [
        {id: "0zw-Zh02K", name: "Selected Topics", value: properties.selectedTopics},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "Bb6PCfOO6", name: "Coq Based Persona", value: properties.coqBasedPersona},
        {id: "L6Gb3dOJ3", name: "Modified Topics", value: properties.modifiedTopics},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Topics Modification Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Topics Modification Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Coq Based Persona": properties.coqBasedPersona,
          "Clicked On": properties.clickedOn,
          "Selected Topics": properties.selectedTopics,
          "Modified Topics": properties.modifiedTopics,
          "Screen Height": sysScreenHeight,
          }, "Z4gMTBDOj_", "d2f2a5c514c31737750dc1a3cda6cc50382ffc90e3f0aed1f63e8a691a50d954");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Topics Modification Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Coq Based Persona": properties.coqBasedPersona,
      "Clicked On": properties.clickedOn,
      "Selected Topics": properties.selectedTopics,
      "Modified Topics": properties.modifiedTopics,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Welcome Page by Transferred Teacher[B2B]: This event will be triggered when a newly created teacher signs up on SplashLearn through the 'accept Transfer request' email OR through the normal signup flow and views the welcome screen.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/2m1aWOiyA1/trigger/D9IsLRcyL
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {int} properties.transferredClassesCount - This property will return the number of transferred classes displayed to teacher on the class transfer welcome page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/2m1aWOiyA1}
   */
  function viewedWelcomePageByTransferredTeacherb2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertTransferredClassesCount(properties.transferredClassesCount));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Welcome Page by Transferred Teacher[B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "transferredClassesCount"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "2m1aWOiyA1", "d3db478ad186550c881b325d440de7a24a39a36d1438e15cf71386b96a59bafc", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Welcome Page by Transferred Teacher[B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Transferred Classes Count": properties.transferredClassesCount,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("2m1aWOiyA1", "Viewed Welcome Page by Transferred Teacher[B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "b9faRmp_O", name: "Transferred Classes Count", value: properties.transferredClassesCount},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Welcome Page by Transferred Teacher[B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Welcome Page by Transferred Teacher[B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Transferred Classes Count": properties.transferredClassesCount,
          "Screen Height": sysScreenHeight,
          }, "2m1aWOiyA1", "d3db478ad186550c881b325d440de7a24a39a36d1438e15cf71386b96a59bafc");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Welcome Page by Transferred Teacher[B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Transferred Classes Count": properties.transferredClassesCount,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Welcome Page by Transferred Teacher[B2B]: This event will be triggered when a newly created teacher who has been transferred class interacts with the the welcome screen after signing up
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/cQZnikQSnl/trigger/HrvfE_fm-
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/cQZnikQSnl}
   */
  function interactedWelcomePageByTransferredTeacherb2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Welcome Page by Transferred Teacher[B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "cQZnikQSnl", "68eaa649a0be559f046f1b28a58e19319a2ddd9f5f36fd0031c6decadef96c6c", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Welcome Page by Transferred Teacher[B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("cQZnikQSnl", "Interacted Welcome Page by Transferred Teacher[B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Welcome Page by Transferred Teacher[B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Welcome Page by Transferred Teacher[B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "cQZnikQSnl", "68eaa649a0be559f046f1b28a58e19319a2ddd9f5f36fd0031c6decadef96c6c");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Welcome Page by Transferred Teacher[B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Class Transfer Popup by Transferred Teacher[B2B]: This event will be fired when the teacher to whom class is transferred logs in to Splashlearn and views the popup that she has been transferred a class by another teacher
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/jCNJHipw58/trigger/KvA4LsAX9
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {int} properties.transferredClassesCount - This property will return the number of transferred classes displayed to teacher on the class transfer welcome page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/jCNJHipw58}
   */
  function viewedClassTransferPopupByTransferredTeacherb2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertTransferredClassesCount(properties.transferredClassesCount));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Class Transfer Popup by Transferred Teacher[B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "transferredClassesCount"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "jCNJHipw58", "87a9579fcd812c547af46744274140335dc8a82279761dbe0dde72aa1194f9f1", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Class Transfer Popup by Transferred Teacher[B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Transferred Classes Count": properties.transferredClassesCount,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("jCNJHipw58", "Viewed Class Transfer Popup by Transferred Teacher[B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "b9faRmp_O", name: "Transferred Classes Count", value: properties.transferredClassesCount},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Class Transfer Popup by Transferred Teacher[B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Class Transfer Popup by Transferred Teacher[B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Transferred Classes Count": properties.transferredClassesCount,
          "Screen Height": sysScreenHeight,
          }, "jCNJHipw58", "87a9579fcd812c547af46744274140335dc8a82279761dbe0dde72aa1194f9f1");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Class Transfer Popup by Transferred Teacher[B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Transferred Classes Count": properties.transferredClassesCount,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Class Transfer Popup by Transferred Teacher [B2B]: This event will be fired when the teacher to whom class has been transferred interacts with the popup that tells them that they have been transferred class(es)
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/o-eI84ZZ9a/trigger/PtWyOsfQV
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/o-eI84ZZ9a}
   */
  function interactedClassTransferPopupByTransferredTeacherB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Class Transfer Popup by Transferred Teacher [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "o-eI84ZZ9a", "238183cf7134ccd4118a1727f2a00e3bcea354a70c7ace37cdaa268598be73c2", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Class Transfer Popup by Transferred Teacher [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("o-eI84ZZ9a", "Interacted Class Transfer Popup by Transferred Teacher [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Class Transfer Popup by Transferred Teacher [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Class Transfer Popup by Transferred Teacher [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "o-eI84ZZ9a", "238183cf7134ccd4118a1727f2a00e3bcea354a70c7ace37cdaa268598be73c2");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Class Transfer Popup by Transferred Teacher [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Transfer Successful Popup by Transferring Teacher [B2B]: This event will fire when teacher who transferred the class is displayed the popup that other class has been transferred to other teacher successfully
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/_jAtEaWJqt/trigger/YKxAHXgvZ
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/_jAtEaWJqt}
   */
  function viewedTransferSuccessfulPopupByTransferringTeacherB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Transfer Successful Popup by Transferring Teacher [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "_jAtEaWJqt", "98cf52c7f1232e1a322d9b509945354ee095740f0fa63adaa5d49700e8497854", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Transfer Successful Popup by Transferring Teacher [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("_jAtEaWJqt", "Viewed Transfer Successful Popup by Transferring Teacher [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Transfer Successful Popup by Transferring Teacher [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Transfer Successful Popup by Transferring Teacher [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "_jAtEaWJqt", "98cf52c7f1232e1a322d9b509945354ee095740f0fa63adaa5d49700e8497854");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Transfer Successful Popup by Transferring Teacher [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Transfer Successful Popup by Transferring Teacher [B2B]: This event will fire when teacher who had transferred class clicks OK on the class transfer successfully completed popup
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/su3ZlDmGeO/trigger/4RP1NCdiX
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/su3ZlDmGeO}
   */
  function interactedTransferSuccessfulPopupByTransferringTeacherB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Transfer Successful Popup by Transferring Teacher [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "su3ZlDmGeO", "9a41a2af497753b4db788e185cdd743bdc79b353c50404f36cdbddcf2bf27d4b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Transfer Successful Popup by Transferring Teacher [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("su3ZlDmGeO", "Interacted Transfer Successful Popup by Transferring Teacher [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Transfer Successful Popup by Transferring Teacher [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Transfer Successful Popup by Transferring Teacher [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "su3ZlDmGeO", "9a41a2af497753b4db788e185cdd743bdc79b353c50404f36cdbddcf2bf27d4b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Transfer Successful Popup by Transferring Teacher [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Class Transfer Failed Popup by Transferring Teacher [B2B]: This event will fire when teacher who has transferred class views the transfer request failed popup
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/TgV34GiQpj/trigger/Fl_o3KDcf
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.errorMessage - Error message shown to the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/TgV34GiQpj}
   */
  function viewedClassTransferFailedPopupByTransferringTeacherB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertErrorMessage(properties.errorMessage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Class Transfer Failed Popup by Transferring Teacher [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "errorMessage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "TgV34GiQpj", "5076379e38c1457ecc87f34a2dd2be107dfd3722af94aa4e311429414aa203f8", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Class Transfer Failed Popup by Transferring Teacher [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Error Message": properties.errorMessage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("TgV34GiQpj", "Viewed Class Transfer Failed Popup by Transferring Teacher [B2B]", messages, [
        {id: "1n3Bq4GKWy", name: "Error Message", value: properties.errorMessage},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Class Transfer Failed Popup by Transferring Teacher [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Class Transfer Failed Popup by Transferring Teacher [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Error Message": properties.errorMessage,
          "Screen Height": sysScreenHeight,
          }, "TgV34GiQpj", "5076379e38c1457ecc87f34a2dd2be107dfd3722af94aa4e311429414aa203f8");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Class Transfer Failed Popup by Transferring Teacher [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Error Message": properties.errorMessage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Class Transfer Failed by Transferring Teacher [B2B]: This event will fire when teacher who had transferred the class clicks okay on the transfer request failed intimation popup
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/F7gUAw_Yp5/trigger/voZ7HAgU3
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/F7gUAw_Yp5}
   */
  function interactedClassTransferFailedByTransferringTeacherB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Class Transfer Failed by Transferring Teacher [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "F7gUAw_Yp5", "ca0c416e2014963bb030ac1e015bc82aab971191d965fbcb14334bb7af6e913b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Class Transfer Failed by Transferring Teacher [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("F7gUAw_Yp5", "Interacted Class Transfer Failed by Transferring Teacher [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Class Transfer Failed by Transferring Teacher [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Class Transfer Failed by Transferring Teacher [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "F7gUAw_Yp5", "ca0c416e2014963bb030ac1e015bc82aab971191d965fbcb14334bb7af6e913b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Class Transfer Failed by Transferring Teacher [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Class Transfer Failed Popup by Transferred Teacher [B2B]: This event will fire when teacher who has been transferred class views the transfer request failed popup
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/RpkZe8ZPGb/trigger/mXj7PdHhv
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.errorMessage - Error message shown to the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/RpkZe8ZPGb}
   */
  function viewedClassTransferFailedPopupByTransferredTeacherB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertErrorMessage(properties.errorMessage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Class Transfer Failed Popup by Transferred Teacher [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "errorMessage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "RpkZe8ZPGb", "48a11d0c647f7bf21800b646ba1f342f31e16dfd6ac1306313711aeaf904e863", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Class Transfer Failed Popup by Transferred Teacher [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Error Message": properties.errorMessage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("RpkZe8ZPGb", "Viewed Class Transfer Failed Popup by Transferred Teacher [B2B]", messages, [
        {id: "1n3Bq4GKWy", name: "Error Message", value: properties.errorMessage},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Class Transfer Failed Popup by Transferred Teacher [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Class Transfer Failed Popup by Transferred Teacher [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Error Message": properties.errorMessage,
          "Screen Height": sysScreenHeight,
          }, "RpkZe8ZPGb", "48a11d0c647f7bf21800b646ba1f342f31e16dfd6ac1306313711aeaf904e863");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Class Transfer Failed Popup by Transferred Teacher [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Error Message": properties.errorMessage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Class Transfer Failed by Transferred Teacher [B2B]: This event will fire when teacher who had transferred the class clicks okay on the transfer request failed intimation popup
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/GDe85aGdJd/trigger/VMTgEVZU0
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/GDe85aGdJd}
   */
  function interactedClassTransferFailedByTransferredTeacherB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Class Transfer Failed by Transferred Teacher [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "GDe85aGdJd", "5bd1af18dd8a83a255e17c210ffe0fc1e114365be8df66d395a68c43722e9654", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Class Transfer Failed by Transferred Teacher [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("GDe85aGdJd", "Interacted Class Transfer Failed by Transferred Teacher [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Class Transfer Failed by Transferred Teacher [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Class Transfer Failed by Transferred Teacher [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "GDe85aGdJd", "5bd1af18dd8a83a255e17c210ffe0fc1e114365be8df66d395a68c43722e9654");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Class Transfer Failed by Transferred Teacher [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Classroom Report: This event will get fired when user interacts with the class reports tab under reports section
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/GJNLnu01E2/trigger/xSym_Y2ge
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.valueName - This will capture the value/text of the field that is selected.
   * @param {string} properties.contentGroupName - Name of content group user clicked/tapped on
   * @param {string} properties.curriculumType - type of curriculum - Common Core Standards / milestone
   * @param {string} properties.gradeSelected - Grade selected by user in curriculum tab
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/GJNLnu01E2}
   */
  function interactedClassroomReport(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertValueName(properties.valueName));
      messages = messages.concat(assertContentGroupName(properties.contentGroupName));
      messages = messages.concat(assertCurriculumType(properties.curriculumType));
      messages = messages.concat(assertGradeSelected(properties.gradeSelected));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Classroom Report", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "valueName",
        "contentGroupName",
        "curriculumType",
        "gradeSelected"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "GJNLnu01E2", "0fe2e689175ba2f778a1216a06925bcda227e0f11b3fe496899b115e506f8d66", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Classroom Report", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Value Name": properties.valueName,
        "Content Group Name": properties.contentGroupName,
        "Curriculum Type": properties.curriculumType,
        "Grade Selected": properties.gradeSelected,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("GJNLnu01E2", "Interacted Classroom Report", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "Fcl7PSdr4", name: "Grade Selected", value: properties.gradeSelected},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "TfrlXL1gV", name: "Content Group Name", value: properties.contentGroupName},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "Xvxho3cru", name: "Curriculum Type", value: properties.curriculumType},
        {id: "l-8JNUE0q", name: "Value Name", value: properties.valueName},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Classroom Report': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Classroom Report", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Value Name": properties.valueName,
          "Content Group Name": properties.contentGroupName,
          "Curriculum Type": properties.curriculumType,
          "Grade Selected": properties.gradeSelected,
          "Screen Height": sysScreenHeight,
          }, "GJNLnu01E2", "0fe2e689175ba2f778a1216a06925bcda227e0f11b3fe496899b115e506f8d66");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Classroom Report", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Value Name": properties.valueName,
      "Content Group Name": properties.contentGroupName,
      "Curriculum Type": properties.curriculumType,
      "Grade Selected": properties.gradeSelected,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Student Report: This event will get fired when user interacts with the student report tab under reports section
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/0dJSXfO4xE/trigger/f3rBiQZOH
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.valueName - This will capture the value/text of the field that is selected.
   * @param {string} properties.contentGroupName - Name of content group user clicked/tapped on
   * @param {string} properties.curriculumType - type of curriculum - Common Core Standards / milestone
   * @param {string} properties.gradeSelected - Grade selected by user in curriculum tab
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/0dJSXfO4xE}
   */
  function interactedStudentReport(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertValueName(properties.valueName));
      messages = messages.concat(assertContentGroupName(properties.contentGroupName));
      messages = messages.concat(assertCurriculumType(properties.curriculumType));
      messages = messages.concat(assertGradeSelected(properties.gradeSelected));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Student Report", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "valueName",
        "contentGroupName",
        "curriculumType",
        "gradeSelected"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "0dJSXfO4xE", "d3ee7a8adddc7710dcf3190b2ecd3684e7ea102f8c8f2d575797ac86b08e6c12", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Student Report", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Value Name": properties.valueName,
        "Content Group Name": properties.contentGroupName,
        "Curriculum Type": properties.curriculumType,
        "Grade Selected": properties.gradeSelected,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("0dJSXfO4xE", "Interacted Student Report", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "Fcl7PSdr4", name: "Grade Selected", value: properties.gradeSelected},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "TfrlXL1gV", name: "Content Group Name", value: properties.contentGroupName},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "Xvxho3cru", name: "Curriculum Type", value: properties.curriculumType},
        {id: "l-8JNUE0q", name: "Value Name", value: properties.valueName},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Student Report': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Student Report", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Value Name": properties.valueName,
          "Content Group Name": properties.contentGroupName,
          "Curriculum Type": properties.curriculumType,
          "Grade Selected": properties.gradeSelected,
          "Screen Height": sysScreenHeight,
          }, "0dJSXfO4xE", "d3ee7a8adddc7710dcf3190b2ecd3684e7ea102f8c8f2d575797ac86b08e6c12");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Student Report", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Value Name": properties.valueName,
      "Content Group Name": properties.contentGroupName,
      "Curriculum Type": properties.curriculumType,
      "Grade Selected": properties.gradeSelected,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Get started widget visibility: This event will get fired whenever user is displayed the onboarding widget on dashboard
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/f12ztuh7kw/trigger/TF3mhXd9f
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {int} properties.step - This property returns the next onboarding step in order that the teacher has to complete. Example - If the teacher has completed first 2 onboarding steps, this property would return value as '3'
   * @param {string} properties.classType - This Property will capture the type of class - Google Classroom or Clever or Manual
   * @param {string} properties.stepValue - This property returns the text on the CTA of the next onboarding step to be completed in the teacher onboarding widget
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/f12ztuh7kw}
   */
  function getStartedWidgetVisibility(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertStep(properties.step));
      messages = messages.concat(assertClassType(properties.classType));
      messages = messages.concat(assertStepValue(properties.stepValue));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Get started widget visibility", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "step",
        "classType",
        "stepValue"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "f12ztuh7kw", "46e1765fb79b9f79e659f1b5d0ecb40f745e302d427c40007d6bee9f2cb37050", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Get started widget visibility", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Step": properties.step,
        "Class Type": properties.classType,
        "Step value": properties.stepValue,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("f12ztuh7kw", "Get started widget visibility", messages, [
        {id: "1kYllRnFw", name: "Step value", value: properties.stepValue},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "dk2bhnFne", name: "Class Type", value: properties.classType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "srWUcoAhJ", name: "Step", value: properties.step},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Get started widget visibility': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Get started widget visibility", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Step": properties.step,
          "Class Type": properties.classType,
          "Step value": properties.stepValue,
          "Screen Height": sysScreenHeight,
          }, "f12ztuh7kw", "46e1765fb79b9f79e659f1b5d0ecb40f745e302d427c40007d6bee9f2cb37050");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Get started widget visibility", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Step": properties.step,
      "Class Type": properties.classType,
      "Step value": properties.stepValue,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Get Started Widget: This event will get fired when teacher clicks on the CTA of any step of the onboaridng widget
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ysD51PdnS/trigger/whyFCqeo7
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {int} properties.clickedOnStep - This property returns the order of the onboarding step whose CTA teacher has clicked
   * @param {int} properties.step - This property returns the next onboarding step in order that the teacher has to complete. Example - If the teacher has completed first 2 onboarding steps, this property would return value as '3'
   * @param {string} properties.stepValue - This property returns the text on the CTA of the next onboarding step to be completed in the teacher onboarding widget
   * @param {string} properties.classType - This Property will capture the type of class - Google Classroom or Clever or Manual
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ysD51PdnS}
   */
  function interactedGetStartedWidget(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertClickedOnStep(properties.clickedOnStep));
      messages = messages.concat(assertStep(properties.step));
      messages = messages.concat(assertStepValue(properties.stepValue));
      messages = messages.concat(assertClassType(properties.classType));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Get Started Widget", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "clickedOnStep",
        "step",
        "stepValue",
        "classType"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ysD51PdnS", "8ea71924e7929dd40790a768a43f6aaf0831cf13bb7dd7f464cc3a998415ac4c", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Get Started Widget", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Clicked on Step": properties.clickedOnStep,
        "Step": properties.step,
        "Step value": properties.stepValue,
        "Class Type": properties.classType,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ysD51PdnS", "Interacted Get Started Widget", messages, [
        {id: "1kYllRnFw", name: "Step value", value: properties.stepValue},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "6k1AQb1jR", name: "Clicked on Step", value: properties.clickedOnStep},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "dk2bhnFne", name: "Class Type", value: properties.classType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "srWUcoAhJ", name: "Step", value: properties.step},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Get Started Widget': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Get Started Widget", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Clicked on Step": properties.clickedOnStep,
          "Step": properties.step,
          "Step value": properties.stepValue,
          "Class Type": properties.classType,
          "Screen Height": sysScreenHeight,
          }, "ysD51PdnS", "8ea71924e7929dd40790a768a43f6aaf0831cf13bb7dd7f464cc3a998415ac4c");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Get Started Widget", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Clicked on Step": properties.clickedOnStep,
      "Step": properties.step,
      "Step value": properties.stepValue,
      "Class Type": properties.classType,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Daily Bundle Generated BE: This event is associated to the daily bundle generation. It will be a BE event and will be used to identify the generation of the daily bundle.
   * 
   * When to trigger this event:
   * 1. Daily Bundle is generated
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/OQuzOaWgJP/trigger/97S69V-Zv
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.dailyBundleCourse - It will store the course code
   * @param {string} properties.topicSelectionMode - This property stores the method to choose topics in the learning path. The values can be default, custom, auto.
Default - we created the LP for the users with default topics
Custom - User created their LP
Auto - we created the LP for the users based on curr. played on D0
None - when Viewed daily bundle rail event gets fired with none state (no db created)
   * @param {string} properties.dbGenerationSource - This property will store if db was created by user or created by default
   * @param {bool} properties.dbDayZero - This stores if the DB is created on D0
   * @param {bool} properties.dbPaidUser - This property stores if DB created user is paid or not
   * @param {bool} properties.dbCoqAnswered - This property stores if user has answered COQs
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/OQuzOaWgJP}
   */
  function dailyBundleGeneratedBe(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertDailyBundleCourse(properties.dailyBundleCourse));
      messages = messages.concat(assertTopicSelectionMode(properties.topicSelectionMode));
      messages = messages.concat(assertDBGenerationSource(properties.dbGenerationSource));
      messages = messages.concat(assertDBDayZero(properties.dbDayZero));
      messages = messages.concat(assertDBPaidUser(properties.dbPaidUser));
      messages = messages.concat(assertDBCOQAnswered(properties.dbCoqAnswered));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Daily Bundle Generated BE", Object.keys(properties), [
        "dailyBundleCourse",
        "topicSelectionMode",
        "dbGenerationSource",
        "dbDayZero",
        "dbPaidUser",
        "dbCoqAnswered"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "OQuzOaWgJP", "b6b23f9f652a8eb440a3c1eacf061e9262c8eb68f3a535ca9ce1963181d2861d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Daily Bundle Generated BE", {
        "Daily Bundle Course": properties.dailyBundleCourse,
        "Topic Selection Mode": properties.topicSelectionMode,
        "DB Generation Source": properties.dbGenerationSource,
        "DB Day Zero": properties.dbDayZero,
        "DB Paid User": properties.dbPaidUser,
        "DB COQ Answered": properties.dbCoqAnswered,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("OQuzOaWgJP", "Daily Bundle Generated BE", messages, [
        {id: "2j7_L0vfh", name: "DB Paid User", value: properties.dbPaidUser},
        {id: "5AVoY71YG", name: "DB Generation Source", value: properties.dbGenerationSource},
        {id: "NaQMaElOq", name: "DB Day Zero", value: properties.dbDayZero},
        {id: "Vw8Hds8A5", name: "Daily Bundle Course", value: properties.dailyBundleCourse},
        {id: "YcZvlYnV3", name: "DB COQ Answered", value: properties.dbCoqAnswered},
        {id: "v2bSgov-m", name: "Topic Selection Mode", value: properties.topicSelectionMode},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Daily Bundle Generated BE': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Daily Bundle Generated BE", {
          "Daily Bundle Course": properties.dailyBundleCourse,
          "Topic Selection Mode": properties.topicSelectionMode,
          "DB Generation Source": properties.dbGenerationSource,
          "DB Day Zero": properties.dbDayZero,
          "DB Paid User": properties.dbPaidUser,
          "DB COQ Answered": properties.dbCoqAnswered,
          "Screen Height": sysScreenHeight,
          }, "OQuzOaWgJP", "b6b23f9f652a8eb440a3c1eacf061e9262c8eb68f3a535ca9ce1963181d2861d");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Daily Bundle Generated BE", {
      "Daily Bundle Course": properties.dailyBundleCourse,
      "Topic Selection Mode": properties.topicSelectionMode,
      "DB Generation Source": properties.dbGenerationSource,
      "DB Day Zero": properties.dbDayZero,
      "DB Paid User": properties.dbPaidUser,
      "DB COQ Answered": properties.dbCoqAnswered,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Api Failure: This is a generic event that can be sent when any API fails.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.apiName - Name of the Api
   * @param {string} properties.apiStatus - API status
   * @param {string} properties.errorMessage - Error message shown to the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/lgHeVLbkNS}
   */
  function apiFailure(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertAPIName(properties.apiName));
      messages = messages.concat(assertAPIStatus(properties.apiStatus));
      messages = messages.concat(assertErrorMessage(properties.errorMessage));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Api Failure", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "apiName",
        "apiStatus",
        "errorMessage",
        "grade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "lgHeVLbkNS", "7489e2b22b436d5f4df0205aec180851b6bb43872c7e7cd796137938bd31dfc7", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Api Failure", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "API Name": properties.apiName,
        "API Status": properties.apiStatus,
        "Error Message": properties.errorMessage,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("lgHeVLbkNS", "Api Failure", messages, [
        {id: "1n3Bq4GKWy", name: "Error Message", value: properties.errorMessage},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "7e4uFkiW6", name: "API Status", value: properties.apiStatus},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "Y6EoEtXpW", name: "API Name", value: properties.apiName},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Api Failure': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Api Failure", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "API Name": properties.apiName,
          "API Status": properties.apiStatus,
          "Error Message": properties.errorMessage,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "lgHeVLbkNS", "7489e2b22b436d5f4df0205aec180851b6bb43872c7e7cd796137938bd31dfc7");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Api Failure", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "API Name": properties.apiName,
      "API Status": properties.apiStatus,
      "Error Message": properties.errorMessage,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Tap Event Skipped: Will be fired when any tap event is skipped intentionally, due to multiple taps in short time
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.screenName - Screen name on which event occured
   * @param {string} properties.tappedOn - UI element that user tapped on - used in conjunction with the event name which identifies the screen name
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/lDK-XGNmdY}
   */
  function tapEventSkipped(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertScreenName(properties.screenName));
      messages = messages.concat(assertTappedOn(properties.tappedOn));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Tap Event Skipped", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "screenName",
        "tappedOn",
        "grade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "lDK-XGNmdY", "3bc099f10ea5b545208333216f7bdb2a3b5852960341743c0074f2408b5302c5", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Tap Event Skipped", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Screen Name": properties.screenName,
        "Tapped On": properties.tappedOn,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("lDK-XGNmdY", "Tap Event Skipped", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "cfvmMqWft", name: "Tapped On", value: properties.tappedOn},
        {id: "qfHzr0Pfa", name: "Screen Name", value: properties.screenName},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Tap Event Skipped': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Tap Event Skipped", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Screen Name": properties.screenName,
          "Tapped On": properties.tappedOn,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "lDK-XGNmdY", "3bc099f10ea5b545208333216f7bdb2a3b5852960341743c0074f2408b5302c5");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Tap Event Skipped", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Screen Name": properties.screenName,
      "Tapped On": properties.tappedOn,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Subject Personalisation Consent Screen: This event is assocaited to the onboarding screen where we take the consent for the second subject personalisation.
   * 
   * When to trigger this event:
   * 1. When user lands on this screen. It comes after user has personalised the first subject and hit continue on the learning plan screen.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Jvr1Flqwx5/trigger/bmVO4ocgL
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Jvr1Flqwx5}
   */
  function viewedSubjectPersonalisationConsentScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Subject Personalisation Consent Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "grade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Jvr1Flqwx5", "06b01664121d4ccf5fa40c61ca13496fcebb3727b9bffc381df97cd1307d2cd0", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Subject Personalisation Consent Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Jvr1Flqwx5", "Viewed Subject Personalisation Consent Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Subject Personalisation Consent Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Subject Personalisation Consent Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "Jvr1Flqwx5", "06b01664121d4ccf5fa40c61ca13496fcebb3727b9bffc381df97cd1307d2cd0");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Subject Personalisation Consent Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Subject Personalisation Consent Screen: This event is associated to the consent screen for the second subject personalisation in the onboarding.
   * 
   * When to trigger this event:
   * 1. When user interacts on this screen, click on No, yes or back.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/27hjTGj4_b/trigger/P-90ueyF4
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/27hjTGj4_b}
   */
  function interactedSubjectPersonalisationConsentScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Subject Personalisation Consent Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "grade",
        "elaGrade",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "27hjTGj4_b", "aabf2ffab6d0c665e475e3b8e65753f38069ea6f3148a1b657d4a5c82c959e54", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Subject Personalisation Consent Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("27hjTGj4_b", "Interacted Subject Personalisation Consent Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Subject Personalisation Consent Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Subject Personalisation Consent Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "27hjTGj4_b", "aabf2ffab6d0c665e475e3b8e65753f38069ea6f3148a1b657d4a5c82c959e54");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Subject Personalisation Consent Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Page Interacted: When a user interacted with any CTA on a book page
   * 
   * When to trigger this event:
   * 1. when a user takes any action on the book page other than page turn
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/7ZBoT48yVa/trigger/DoeJRbhaY1
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.gameType - Type of game/playable selected
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.zoom - Scale the which book page has been zoomed -in/out
   * @param {string} properties.readingMode - Reading Mode in which the book starts
   * @param {string} properties.playableCode - Pass the 'Playable Code' of the Playable being started/clicked
   * @param {string} properties.playableName - Name of playable selected
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/7ZBoT48yVa}
   */
  function pageInteracted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGameType(properties.gameType));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertZoom(properties.zoom));
      messages = messages.concat(assertReadingMode(properties.readingMode));
      messages = messages.concat(assertPlayableCode(properties.playableCode));
      messages = messages.concat(assertPlayableName(properties.playableName));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Page Interacted", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "gameType",
        "clickedOn",
        "zoom",
        "readingMode",
        "playableCode",
        "playableName"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "7ZBoT48yVa", "0aae83d447c473e847d1dc70d94f4320da19fdab652eb91153862be9dece22c6", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Page Interacted", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Game Type": properties.gameType,
        "Clicked On": properties.clickedOn,
        "Zoom": properties.zoom,
        "Reading Mode": properties.readingMode,
        "Playable Code": properties.playableCode,
        "Playable Name": properties.playableName,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("7ZBoT48yVa", "Page Interacted", messages, [
        {id: "2da5NLAEc", name: "Game Type", value: properties.gameType},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "AWdUIbzg1", name: "Reading Mode", value: properties.readingMode},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "QjCwFasvW0", name: "Playable Code", value: properties.playableCode},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "c2W4X05Jy", name: "Playable Name", value: properties.playableName},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "rNJ9tqfNc", name: "Zoom", value: properties.zoom},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Page Interacted': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Page Interacted", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Game Type": properties.gameType,
          "Clicked On": properties.clickedOn,
          "Zoom": properties.zoom,
          "Reading Mode": properties.readingMode,
          "Playable Code": properties.playableCode,
          "Playable Name": properties.playableName,
          "Screen Height": sysScreenHeight,
          }, "7ZBoT48yVa", "0aae83d447c473e847d1dc70d94f4320da19fdab652eb91153862be9dece22c6");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Page Interacted", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Game Type": properties.gameType,
      "Clicked On": properties.clickedOn,
      "Zoom": properties.zoom,
      "Reading Mode": properties.readingMode,
      "Playable Code": properties.playableCode,
      "Playable Name": properties.playableName,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Book Feedback Submitted: When user submits/skips feedback after the book gets completed
   * 
   * When to trigger this event:
   * 1. When user submits/skips feedback after the book gets completed
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/nvy4KgbVPy/trigger/g2lreE_LMB
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.playableCode - Pass the 'Playable Code' of the Playable being started/clicked
   * @param {string} properties.playableName - Name of playable selected
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/nvy4KgbVPy}
   */
  function bookFeedbackSubmitted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertPlayableCode(properties.playableCode));
      messages = messages.concat(assertPlayableName(properties.playableName));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Book Feedback Submitted", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "playableCode",
        "playableName"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "nvy4KgbVPy", "7e73bab31b4d2077d76ce7a152c7ae40cdf33169ec5d120a445635524605a0fb", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Book Feedback Submitted", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Playable Code": properties.playableCode,
        "Playable Name": properties.playableName,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("nvy4KgbVPy", "Book Feedback Submitted", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "QjCwFasvW0", name: "Playable Code", value: properties.playableCode},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "c2W4X05Jy", name: "Playable Name", value: properties.playableName},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Book Feedback Submitted': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Book Feedback Submitted", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Playable Code": properties.playableCode,
          "Playable Name": properties.playableName,
          "Screen Height": sysScreenHeight,
          }, "nvy4KgbVPy", "7e73bab31b4d2077d76ce7a152c7ae40cdf33169ec5d120a445635524605a0fb");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Book Feedback Submitted", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Playable Code": properties.playableCode,
      "Playable Name": properties.playableName,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Date Picker Calendar [B2B]: This event will get fired in the assignment assigning/editing flow when user clicks default due date to open date picker on the student selection screen 
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/CMUTz0rD8JW/trigger/6LzPlffhZ9y
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.currentDatePickerView - This property returns the current view of the date picker displayed to the user (Out of Date selection OR Month/Year selection)
   * @param {string} properties.contentType - Type of content viz. Game/Learning Path/Activities/Worksheets
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/CMUTz0rD8JW}
   */
  function viewedDatePickerCalendarB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertCurrentDatePickerView(properties.currentDatePickerView));
      messages = messages.concat(assertContentType(properties.contentType));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Date Picker Calendar [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "currentDatePickerView",
        "contentType",
        "fromPage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "CMUTz0rD8JW", "a71f40f75710aa4d748ae4bf7bb93d086849d4ef8552ef609c19bfe05029b99d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Date Picker Calendar [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Current Date Picker View": properties.currentDatePickerView,
        "Content Type": properties.contentType,
        "From Page": properties.fromPage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("CMUTz0rD8JW", "Viewed Date Picker Calendar [B2B]", messages, [
        {id: "0S4aBLQG_", name: "Current Date Picker View", value: properties.currentDatePickerView},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "Nfs9QLl8W7", name: "Content Type", value: properties.contentType},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Date Picker Calendar [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Date Picker Calendar [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Current Date Picker View": properties.currentDatePickerView,
          "Content Type": properties.contentType,
          "From Page": properties.fromPage,
          "Screen Height": sysScreenHeight,
          }, "CMUTz0rD8JW", "a71f40f75710aa4d748ae4bf7bb93d086849d4ef8552ef609c19bfe05029b99d");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Date Picker Calendar [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Current Date Picker View": properties.currentDatePickerView,
      "Content Type": properties.contentType,
      "From Page": properties.fromPage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Date Picker Calendar [B2B]: This event will get fired when user interacts the date picker calendar input on the student selection screen when assigning OR editing (due date) of curriculum assignment
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/VI8hvKrcoq0/trigger/KLNS6KsIDio
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.currentDatePickerView - This property returns the current view of the date picker displayed to the user (Out of Date selection OR Month/Year selection)
   * @param {string} properties.contentType - Type of content viz. Game/Learning Path/Activities/Worksheets
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/VI8hvKrcoq0}
   */
  function interactedDatePickerCalendarB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertCurrentDatePickerView(properties.currentDatePickerView));
      messages = messages.concat(assertContentType(properties.contentType));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Date Picker Calendar [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "currentDatePickerView",
        "contentType"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "VI8hvKrcoq0", "9b571ba8614fd20fbc80008045a51d1c4904ead870ecee468708ccc27f6339b4", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Date Picker Calendar [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Current Date Picker View": properties.currentDatePickerView,
        "Content Type": properties.contentType,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("VI8hvKrcoq0", "Interacted Date Picker Calendar [B2B]", messages, [
        {id: "0S4aBLQG_", name: "Current Date Picker View", value: properties.currentDatePickerView},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "Nfs9QLl8W7", name: "Content Type", value: properties.contentType},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Date Picker Calendar [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Date Picker Calendar [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Current Date Picker View": properties.currentDatePickerView,
          "Content Type": properties.contentType,
          "Screen Height": sysScreenHeight,
          }, "VI8hvKrcoq0", "9b571ba8614fd20fbc80008045a51d1c4904ead870ecee468708ccc27f6339b4");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Date Picker Calendar [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Current Date Picker View": properties.currentDatePickerView,
      "Content Type": properties.contentType,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Selected Assignment Due Date [B2B]: This event will get fired when user selects due date from the calendar input date picker in the assigning/editing due date flow for curriculum assignments.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/kO9nFCIqc2H/trigger/oSoyu-uKFvy
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * @param {string} properties.contentType - Type of content viz. Game/Learning Path/Activities/Worksheets
   * @param {string} properties.assignmentDueInDays - This property returns the difference between assignment assigning date and the assignment due date set by the teacher. In case of editing the assignment due date, the difference will be counted between the date of updating due date and the new due date.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/kO9nFCIqc2H}
   */
  function selectedAssignmentDueDateB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertContentType(properties.contentType));
      messages = messages.concat(assertAssignmentDueInDays(properties.assignmentDueInDays));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Selected Assignment Due Date [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "fromPage",
        "contentType",
        "assignmentDueInDays"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "kO9nFCIqc2H", "b0a0242dcf28ef47d8b7011a8a0169a61847d3645dac2591cc27a184abf43c30", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Selected Assignment Due Date [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From Page": properties.fromPage,
        "Content Type": properties.contentType,
        "Assignment Due in Days": properties.assignmentDueInDays,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("kO9nFCIqc2H", "Selected Assignment Due Date [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "4M0W7L2cW", name: "Assignment Due in Days", value: properties.assignmentDueInDays},
        {id: "Nfs9QLl8W7", name: "Content Type", value: properties.contentType},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Selected Assignment Due Date [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Selected Assignment Due Date [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From Page": properties.fromPage,
          "Content Type": properties.contentType,
          "Assignment Due in Days": properties.assignmentDueInDays,
          "Screen Height": sysScreenHeight,
          }, "kO9nFCIqc2H", "b0a0242dcf28ef47d8b7011a8a0169a61847d3645dac2591cc27a184abf43c30");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Selected Assignment Due Date [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From Page": properties.fromPage,
      "Content Type": properties.contentType,
      "Assignment Due in Days": properties.assignmentDueInDays,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Visited Upgrade Pitch Page: User views the teacher referral discount pitch
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/v1bv_5F-kc/trigger/vcK1_Vj46B
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.userPersonaType - User persona type at an event level is the property that highlights whether the user persona is class only or after the parent signup - it is ptl. In the school, class the persona is class only and at home the persona is ptl. If the parent is not signed up, it is class only.
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {string} properties.tabCode - Specifies the tab which has been opened in the event 'Viewed Tiled Dashboard' and Other events too
   * @param {string} properties.purchaseClickId - Unique ID associated with each purchase flow. Gets reset when the user exits the purchase flowing (irrespective of successful or unsuccessful purchase)
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/v1bv_5F-kc}
   */
  function visitedUpgradePitchPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertUserPersonaType(properties.userPersonaType));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertTabCode(properties.tabCode));
      messages = messages.concat(assertPurchaseClickID(properties.purchaseClickId));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Visited Upgrade Pitch Page", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "grade",
        "elaGrade",
        "mathGrade",
        "mode",
        "userPersonaType",
        "from",
        "tabCode",
        "purchaseClickId"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "v1bv_5F-kc", "f4ff31bbf505225fbf88635627e52c9531f1cc12d7d4b27e6db0b57066ed5eac", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Visited Upgrade Pitch Page", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "User Persona Type": properties.userPersonaType,
        "From": properties.from,
        "Tab Code": properties.tabCode,
        "Purchase Click ID": properties.purchaseClickId,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("v1bv_5F-kc", "Visited Upgrade Pitch Page", messages, [
        {id: "1sxa4mA1P", name: "Purchase Click ID", value: properties.purchaseClickId},
        {id: "1z9szfE-j", name: "User Persona Type", value: properties.userPersonaType},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "l9PbANZBu", name: "Tab Code", value: properties.tabCode},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Visited Upgrade Pitch Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Visited Upgrade Pitch Page", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "User Persona Type": properties.userPersonaType,
          "From": properties.from,
          "Tab Code": properties.tabCode,
          "Purchase Click ID": properties.purchaseClickId,
          "Screen Height": sysScreenHeight,
          }, "v1bv_5F-kc", "f4ff31bbf505225fbf88635627e52c9531f1cc12d7d4b27e6db0b57066ed5eac");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Visited Upgrade Pitch Page", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "User Persona Type": properties.userPersonaType,
      "From": properties.from,
      "Tab Code": properties.tabCode,
      "Purchase Click ID": properties.purchaseClickId,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Upgrade Pitch Page: User interacts with the teacher referral discount pitch - either on the start trial cta or the limited access cta
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/-yeZ2mT04/trigger/wpINqiylTB
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.userPersonaType - User persona type at an event level is the property that highlights whether the user persona is class only or after the parent signup - it is ptl. In the school, class the persona is class only and at home the persona is ptl. If the parent is not signed up, it is class only.
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {string} properties.tabCode - Specifies the tab which has been opened in the event 'Viewed Tiled Dashboard' and Other events too
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.purchaseClickId - Unique ID associated with each purchase flow. Gets reset when the user exits the purchase flowing (irrespective of successful or unsuccessful purchase)
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/-yeZ2mT04}
   */
  function interactedUpgradePitchPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertUserPersonaType(properties.userPersonaType));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertTabCode(properties.tabCode));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertPurchaseClickID(properties.purchaseClickId));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Upgrade Pitch Page", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "grade",
        "elaGrade",
        "mathGrade",
        "mode",
        "userPersonaType",
        "from",
        "tabCode",
        "clickedOn",
        "purchaseClickId"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "-yeZ2mT04", "fe6b0f9d8886ebfe53eb7968ddba7ac13730b9f569555594865ea444f5783e6d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Upgrade Pitch Page", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "User Persona Type": properties.userPersonaType,
        "From": properties.from,
        "Tab Code": properties.tabCode,
        "Clicked On": properties.clickedOn,
        "Purchase Click ID": properties.purchaseClickId,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("-yeZ2mT04", "Interacted Upgrade Pitch Page", messages, [
        {id: "1sxa4mA1P", name: "Purchase Click ID", value: properties.purchaseClickId},
        {id: "1z9szfE-j", name: "User Persona Type", value: properties.userPersonaType},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "l9PbANZBu", name: "Tab Code", value: properties.tabCode},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Upgrade Pitch Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Upgrade Pitch Page", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "User Persona Type": properties.userPersonaType,
          "From": properties.from,
          "Tab Code": properties.tabCode,
          "Clicked On": properties.clickedOn,
          "Purchase Click ID": properties.purchaseClickId,
          "Screen Height": sysScreenHeight,
          }, "-yeZ2mT04", "fe6b0f9d8886ebfe53eb7968ddba7ac13730b9f569555594865ea444f5783e6d");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Upgrade Pitch Page", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "User Persona Type": properties.userPersonaType,
      "From": properties.from,
      "Tab Code": properties.tabCode,
      "Clicked On": properties.clickedOn,
      "Purchase Click ID": properties.purchaseClickId,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Adaptive Algo Activated: This event is associated to the activation of the adaptive algorithm. It will be a backend event.
   * 
   * When to trigger this event:
   * 1. When user fulfils any one criteria of activating adaptive algorithm
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/VNWEKeQEMH/trigger/fkKMtcRxm-
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.contentGroup - Code of content group user clicked/tapped on
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.adaptiveSwitchReason - This property stores the reason for activation and deactivation of the algo

   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/VNWEKeQEMH}
   */
  function adaptiveAlgoActivated(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertContentGroup(properties.contentGroup));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertAdaptiveSwitchReason(properties.adaptiveSwitchReason));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Adaptive Algo Activated", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "contentGroup",
        "grade",
        "elaGrade",
        "adaptiveSwitchReason"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "VNWEKeQEMH", "a5ca2e1128d81e7fd768bdb0c9f1e328612380696c96cd7c64189b344e5c8c07", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Adaptive Algo Activated", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Content Group": properties.contentGroup,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Adaptive Switch Reason": properties.adaptiveSwitchReason,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("VNWEKeQEMH", "Adaptive Algo Activated", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "Otu1r2JQW", name: "Content Group", value: properties.contentGroup},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "rPcVX3AW0ohpa4UMeGcFG", name: "Adaptive Switch Reason", value: properties.adaptiveSwitchReason},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Adaptive Algo Activated': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Adaptive Algo Activated", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Content Group": properties.contentGroup,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Adaptive Switch Reason": properties.adaptiveSwitchReason,
          "Screen Height": sysScreenHeight,
          }, "VNWEKeQEMH", "a5ca2e1128d81e7fd768bdb0c9f1e328612380696c96cd7c64189b344e5c8c07");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Adaptive Algo Activated", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Content Group": properties.contentGroup,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Adaptive Switch Reason": properties.adaptiveSwitchReason,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Adaptive Algo Deactivated: This event is associated to the deactivation of the adaptive path
   * 
   * When to trigger this event:
   * 1. When user hits the criteria of the deactivation of the algo
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/cIExuOKa2u/trigger/smG3eDeXxz
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.contentGroup - Code of content group user clicked/tapped on
   * @param {string} properties.adaptiveSwitchReason - This property stores the reason for activation and deactivation of the algo

   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/cIExuOKa2u}
   */
  function adaptiveAlgoDeactivated(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertContentGroup(properties.contentGroup));
      messages = messages.concat(assertAdaptiveSwitchReason(properties.adaptiveSwitchReason));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Adaptive Algo Deactivated", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "grade",
        "elaGrade",
        "contentGroup",
        "adaptiveSwitchReason"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "cIExuOKa2u", "6f6f9fcb35f02807b70f908e81fa27f94c4015f349052faa873859a2bd0392d2", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Adaptive Algo Deactivated", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Content Group": properties.contentGroup,
        "Adaptive Switch Reason": properties.adaptiveSwitchReason,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("cIExuOKa2u", "Adaptive Algo Deactivated", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "Otu1r2JQW", name: "Content Group", value: properties.contentGroup},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "rPcVX3AW0ohpa4UMeGcFG", name: "Adaptive Switch Reason", value: properties.adaptiveSwitchReason},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Adaptive Algo Deactivated': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Adaptive Algo Deactivated", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Content Group": properties.contentGroup,
          "Adaptive Switch Reason": properties.adaptiveSwitchReason,
          "Screen Height": sysScreenHeight,
          }, "cIExuOKa2u", "6f6f9fcb35f02807b70f908e81fa27f94c4015f349052faa873859a2bd0392d2");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Adaptive Algo Deactivated", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Content Group": properties.contentGroup,
      "Adaptive Switch Reason": properties.adaptiveSwitchReason,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Game Loading Started: This event is related to the game loading start at client device
   * 
   * When to trigger this event:
   * 1. Game starts loading on the users' device
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/B1f3V1Yiu/trigger/28MEMtaDwz
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.playableClickId - This property will hold a unique string for the playable events.
   * @param {string} properties.playableCode - Pass the 'Playable Code' of the Playable being started/clicked
   * @param {string} properties.gameEngine - This property will contain the name of the game engine - unity, phaser, cocos, creator or worksheet

   * @param {string} properties.gameCode - Game code of the playable selected, for example: Math learning games have multiple variations, all those variations will have one game code
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.contentType - Type of content viz. Game/Learning Path/Activities/Worksheets
   * @param {Array<string>} properties.recommendedRailName - This is the name of the rail viewed by the user. 
Recommended rail property comes with rail name and rail rank, pipe separated - with the introduction of this property, we intend to separate rail name to calculate CTR on Mixpanel.
   * @param {Array<int>} properties.recommendedRailRank - Recommended Rail Rank will carry the rank of the rail in integer format viewed by the user. 
   * @param {Array<string>} [properties.recommendedTileName] - This property will store the code of the tile user has interacted with - CG code for curriculum rails and game code for non curr. rails

   * @param {Array<int>} properties.recommendedTileRank - This property will store the position of the tile on which user has clciked. Earlier this was sent as column position

   * @param {string} properties.tabCode - Specifies the tab which has been opened in the event 'Viewed Tiled Dashboard' and Other events too
   * @param {Array<string>} properties.recommendedRail - This property will be used to store which rails were shown to the user in the HOME tab.

Where possible values are:
Rail Name = Curriculum, Game Zone, Math, Language, Logic & Thinking, Art & Creativity, General Knowledge, Motor Skills, Live Classes, Fluency, Multiplayer
This comes with Rank also with | separation
   * @param {Array<string>} properties.recommendedCategory - This property will be used to store what recommendations were shown to the user in the all tabs.
We'll be saving them in this format:
<Category Name>
where possible values are:
Category name =  MyToDo, Math_LP, ELA_LP, Math Facts, Books, Spelling, Reading Comprehension, Playzone, Activities, Learning Games
   * @param {string} properties.contentGroup - Code of content group user clicked/tapped on
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {int} properties.tabStrClickedCount - Streak count of Playable Clicked from a Specific Tab in a day
   * @param {int} properties.tabStrStartedCount - Streak count of Playable Started from a Specific Tab in a day
   * @param {int} properties.tabStrCompletedCount - Streak count of Playable Completed from a Specific Tab in a day
   * @param {int} properties.tileStrClickedCount - Streak count of Playable Clicked from a Specific Tile in a day
   * @param {int} properties.tileStrStartedCount - Streak count of Playable Started from a Specific Tile in a day
   * @param {int} properties.tileStrCompletedCount - Streak count of Playable Completed from a Specific Tile in a day
   * @param {int} properties.railStrClickedCount - Streak count of Playable Clicked from a Specific Rail in a day
   * @param {int} properties.railStrStartedCount - Streak count of Playable Started from a Specific Rail in a day
   * @param {int} properties.railStrCompletedCount - Streak count of Playable Completed from a Specific Rail in a day
   * @param {int} properties.overallClickedCount - Streak count of Playable Clicked in a day from anywhere
   * @param {int} properties.overallStartedCount - Streak count of Playable Started in a day from anywhere
   * @param {int} properties.overallCompletedCount - Streak count of Playable Completed in a day from anywhere
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/B1f3V1Yiu}
   */
  function gameLoadingStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlayableClickId(properties.playableClickId));
      messages = messages.concat(assertPlayableCode(properties.playableCode));
      messages = messages.concat(assertGameEngine(properties.gameEngine));
      messages = messages.concat(assertGameCode(properties.gameCode));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertContentType(properties.contentType));
      messages = messages.concat(assertRecommendedRailName(properties.recommendedRailName));
      messages = messages.concat(assertRecommendedRailRank(properties.recommendedRailRank));
      messages = messages.concat(assertOptionalRecommendedTileName(properties.recommendedTileName));
      messages = messages.concat(assertRecommendedTileRank(properties.recommendedTileRank));
      messages = messages.concat(assertTabCode(properties.tabCode));
      messages = messages.concat(assertRecommendedRail(properties.recommendedRail));
      messages = messages.concat(assertRecommendedCategory(properties.recommendedCategory));
      messages = messages.concat(assertContentGroup(properties.contentGroup));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertTabStrClickedCount(properties.tabStrClickedCount));
      messages = messages.concat(assertTabStrStartedCount(properties.tabStrStartedCount));
      messages = messages.concat(assertTabStrCompletedCount(properties.tabStrCompletedCount));
      messages = messages.concat(assertTileStrClickedCount(properties.tileStrClickedCount));
      messages = messages.concat(assertTileStrStartedCount(properties.tileStrStartedCount));
      messages = messages.concat(assertTileStrCompletedCount(properties.tileStrCompletedCount));
      messages = messages.concat(assertRailStrClickedCount(properties.railStrClickedCount));
      messages = messages.concat(assertRailStrStartedCount(properties.railStrStartedCount));
      messages = messages.concat(assertRailStrCompletedCount(properties.railStrCompletedCount));
      messages = messages.concat(assertOverallClickedCount(properties.overallClickedCount));
      messages = messages.concat(assertOverallStartedCount(properties.overallStartedCount));
      messages = messages.concat(assertOverallCompletedCount(properties.overallCompletedCount));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Game Loading Started", Object.keys(properties), [
        "playableClickId",
        "playableCode",
        "gameEngine",
        "gameCode",
        "platform",
        "contentType",
        "recommendedRailName",
        "recommendedRailRank",
        "recommendedTileName",
        "recommendedTileRank",
        "tabCode",
        "recommendedRail",
        "recommendedCategory",
        "contentGroup",
        "from",
        "grade",
        "tabStrClickedCount",
        "tabStrStartedCount",
        "tabStrCompletedCount",
        "tileStrClickedCount",
        "tileStrStartedCount",
        "tileStrCompletedCount",
        "railStrClickedCount",
        "railStrStartedCount",
        "railStrCompletedCount",
        "overallClickedCount",
        "overallStartedCount",
        "overallCompletedCount"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "B1f3V1Yiu", "ae0a111e9e44e23541f159b2c20001286d3ffedce611efdb1e4a2f377c534de1", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Game Loading Started", {
        "Playable Click Id": properties.playableClickId,
        "Playable Code": properties.playableCode,
        "Game Engine": properties.gameEngine,
        "Game Code": properties.gameCode,
        "Platform": properties.platform,
        "Content Type": properties.contentType,
        "Recommended Rail Name": properties.recommendedRailName,
        "Recommended Rail Rank": properties.recommendedRailRank,
        "Recommended Tile Name": properties.recommendedTileName,
        "Recommended Tile Rank": properties.recommendedTileRank,
        "Tab Code": properties.tabCode,
        "Recommended Rail": properties.recommendedRail,
        "Recommended Category": properties.recommendedCategory,
        "Content Group": properties.contentGroup,
        "From": properties.from,
        "Grade": properties.grade,
        "Tab Str Clicked Count": properties.tabStrClickedCount,
        "Tab Str Started Count": properties.tabStrStartedCount,
        "Tab Str Completed Count": properties.tabStrCompletedCount,
        "Tile Str Clicked Count": properties.tileStrClickedCount,
        "Tile Str Started Count": properties.tileStrStartedCount,
        "Tile Str Completed Count": properties.tileStrCompletedCount,
        "Rail Str Clicked Count": properties.railStrClickedCount,
        "Rail Str Started Count": properties.railStrStartedCount,
        "Rail Str Completed Count": properties.railStrCompletedCount,
        "Overall Clicked Count": properties.overallClickedCount,
        "Overall Started Count": properties.overallStartedCount,
        "Overall Completed Count": properties.overallCompletedCount,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("B1f3V1Yiu", "Game Loading Started", messages, [
        {id: "2oZQdvXRu", name: "Game Code", value: properties.gameCode},
        {id: "33JWk0cGdkpH6MbvcXKfL", name: "Tile Str Clicked Count", value: properties.tileStrClickedCount},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "6lrsWYY5Y", name: "Recommended Rail Name", value: properties.recommendedRailName},
        {id: "72Hz7CelRpVYf1warHrRP", name: "Tile Str Started Count", value: properties.tileStrStartedCount},
        {id: "7PQh3G9ITCcMDMNeMTM8q", name: "Tab Str Clicked Count", value: properties.tabStrClickedCount},
        {id: "AFC3Xnyx0vxpH2PWZIjdO", name: "Rail Str Completed Count", value: properties.railStrCompletedCount},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "FLDtSJNKL", name: "Recommended Tile Rank", value: properties.recommendedTileRank},
        {id: "GAdbKqJ5y9HJPos5lx5qt", name: "Tab Str Completed Count", value: properties.tabStrCompletedCount},
        {id: "HFnzATNuS7GI6VZs6tZ15", name: "Tab Str Started Count", value: properties.tabStrStartedCount},
        {id: "HJUIBmGrsUmqa_TYCtwQ0", name: "Overall Started Count", value: properties.overallStartedCount},
        {id: "JVkBdMN1_", name: "Game Engine", value: properties.gameEngine},
        {id: "Nfs9QLl8W7", name: "Content Type", value: properties.contentType},
        {id: "OHBx0fnhzlxvHhw0e87pM", name: "Overall Completed Count", value: properties.overallCompletedCount},
        {id: "Otu1r2JQW", name: "Content Group", value: properties.contentGroup},
        {id: "QQeu-Td4-0", name: "Playable Click Id", value: properties.playableClickId},
        {id: "QjCwFasvW0", name: "Playable Code", value: properties.playableCode},
        {id: "TYbmk5DQn", name: "Recommended Tile Name", value: properties.recommendedTileName},
        {id: "VdJhEU0H6s", name: "Recommended Category", value: properties.recommendedCategory},
        {id: "X4kgAx81N5AHgcI6NaNiS", name: "Overall Clicked Count", value: properties.overallClickedCount},
        {id: "_QL92wEdpoa8wH50vOPYt", name: "Tile Str Completed Count", value: properties.tileStrCompletedCount},
        {id: "drNgwJn5Xg", name: "Recommended Rail", value: properties.recommendedRail},
        {id: "hKAJ3izCFVFH-D4_886C8", name: "Rail Str Clicked Count", value: properties.railStrClickedCount},
        {id: "l9PbANZBu", name: "Tab Code", value: properties.tabCode},
        {id: "sRPi7ITwtlHeD7HQEGzmG", name: "Rail Str Started Count", value: properties.railStrStartedCount},
        {id: "uyLgqxbg7", name: "Recommended Rail Rank", value: properties.recommendedRailRank},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Game Loading Started': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Game Loading Started", {
          "Playable Click Id": properties.playableClickId,
          "Playable Code": properties.playableCode,
          "Game Engine": properties.gameEngine,
          "Game Code": properties.gameCode,
          "Platform": properties.platform,
          "Content Type": properties.contentType,
          "Recommended Rail Name": properties.recommendedRailName,
          "Recommended Rail Rank": properties.recommendedRailRank,
          "Recommended Tile Name": properties.recommendedTileName,
          "Recommended Tile Rank": properties.recommendedTileRank,
          "Tab Code": properties.tabCode,
          "Recommended Rail": properties.recommendedRail,
          "Recommended Category": properties.recommendedCategory,
          "Content Group": properties.contentGroup,
          "From": properties.from,
          "Grade": properties.grade,
          "Tab Str Clicked Count": properties.tabStrClickedCount,
          "Tab Str Started Count": properties.tabStrStartedCount,
          "Tab Str Completed Count": properties.tabStrCompletedCount,
          "Tile Str Clicked Count": properties.tileStrClickedCount,
          "Tile Str Started Count": properties.tileStrStartedCount,
          "Tile Str Completed Count": properties.tileStrCompletedCount,
          "Rail Str Clicked Count": properties.railStrClickedCount,
          "Rail Str Started Count": properties.railStrStartedCount,
          "Rail Str Completed Count": properties.railStrCompletedCount,
          "Overall Clicked Count": properties.overallClickedCount,
          "Overall Started Count": properties.overallStartedCount,
          "Overall Completed Count": properties.overallCompletedCount,
          "Screen Height": sysScreenHeight,
          }, "B1f3V1Yiu", "ae0a111e9e44e23541f159b2c20001286d3ffedce611efdb1e4a2f377c534de1");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Game Loading Started", {
      "Playable Click Id": properties.playableClickId,
      "Playable Code": properties.playableCode,
      "Game Engine": properties.gameEngine,
      "Game Code": properties.gameCode,
      "Platform": properties.platform,
      "Content Type": properties.contentType,
      "Recommended Rail Name": properties.recommendedRailName,
      "Recommended Rail Rank": properties.recommendedRailRank,
      "Recommended Tile Name": properties.recommendedTileName,
      "Recommended Tile Rank": properties.recommendedTileRank,
      "Tab Code": properties.tabCode,
      "Recommended Rail": properties.recommendedRail,
      "Recommended Category": properties.recommendedCategory,
      "Content Group": properties.contentGroup,
      "From": properties.from,
      "Grade": properties.grade,
      "Tab Str Clicked Count": properties.tabStrClickedCount,
      "Tab Str Started Count": properties.tabStrStartedCount,
      "Tab Str Completed Count": properties.tabStrCompletedCount,
      "Tile Str Clicked Count": properties.tileStrClickedCount,
      "Tile Str Started Count": properties.tileStrStartedCount,
      "Tile Str Completed Count": properties.tileStrCompletedCount,
      "Rail Str Clicked Count": properties.railStrClickedCount,
      "Rail Str Started Count": properties.railStrStartedCount,
      "Rail Str Completed Count": properties.railStrCompletedCount,
      "Overall Clicked Count": properties.overallClickedCount,
      "Overall Started Count": properties.overallStartedCount,
      "Overall Completed Count": properties.overallCompletedCount,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Game Loading Completed: This event is related to the game loading completion at client device
   * 
   * When to trigger this event:
   * 1. When game is completely loaded on the users' device and user sees the first problem
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/EcC0LyRWr/trigger/QPpJbrk8sk0
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.playableClickId - This property will hold a unique string for the playable events.
   * @param {string} properties.playableCode - Pass the 'Playable Code' of the Playable being started/clicked
   * @param {string} properties.gameCode - Game code of the playable selected, for example: Math learning games have multiple variations, all those variations will have one game code
   * @param {string} properties.gameEngine - This property will contain the name of the game engine - unity, phaser, cocos, creator or worksheet

   * @param {string} properties.contentType - Type of content viz. Game/Learning Path/Activities/Worksheets
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {Array<string>} properties.recommendedRailName - This is the name of the rail viewed by the user. 
Recommended rail property comes with rail name and rail rank, pipe separated - with the introduction of this property, we intend to separate rail name to calculate CTR on Mixpanel.
   * @param {Array<int>} properties.recommendedRailRank - Recommended Rail Rank will carry the rank of the rail in integer format viewed by the user. 
   * @param {Array<string>} [properties.recommendedTileName] - This property will store the code of the tile user has interacted with - CG code for curriculum rails and game code for non curr. rails

   * @param {Array<int>} properties.recommendedTileRank - This property will store the position of the tile on which user has clciked. Earlier this was sent as column position

   * @param {Array<string>} properties.recommendedRail - This property will be used to store which rails were shown to the user in the HOME tab.

Where possible values are:
Rail Name = Curriculum, Game Zone, Math, Language, Logic & Thinking, Art & Creativity, General Knowledge, Motor Skills, Live Classes, Fluency, Multiplayer
This comes with Rank also with | separation
   * @param {Array<string>} properties.recommendedCategory - This property will be used to store what recommendations were shown to the user in the all tabs.
We'll be saving them in this format:
<Category Name>
where possible values are:
Category name =  MyToDo, Math_LP, ELA_LP, Math Facts, Books, Spelling, Reading Comprehension, Playzone, Activities, Learning Games
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.contentGroup - Code of content group user clicked/tapped on
   * @param {string} properties.tabCode - Specifies the tab which has been opened in the event 'Viewed Tiled Dashboard' and Other events too
   * @param {int} properties.tabStrClickedCount - Streak count of Playable Clicked from a Specific Tab in a day
   * @param {int} properties.tabStrStartedCount - Streak count of Playable Started from a Specific Tab in a day
   * @param {int} properties.railStrClickedCount - Streak count of Playable Clicked from a Specific Rail in a day
   * @param {int} properties.railStrStartedCount - Streak count of Playable Started from a Specific Rail in a day
   * @param {int} properties.tileStrClickedCount - Streak count of Playable Clicked from a Specific Tile in a day
   * @param {int} properties.tileStrStartedCount - Streak count of Playable Started from a Specific Tile in a day
   * @param {int} properties.tabStrCompletedCount - Streak count of Playable Completed from a Specific Tab in a day
   * @param {int} properties.railStrCompletedCount - Streak count of Playable Completed from a Specific Rail in a day
   * @param {int} properties.tileStrCompletedCount - Streak count of Playable Completed from a Specific Tile in a day
   * @param {int} properties.overallClickedCount - Streak count of Playable Clicked in a day from anywhere
   * @param {int} properties.overallStartedCount - Streak count of Playable Started in a day from anywhere
   * @param {int} properties.overallCompletedCount - Streak count of Playable Completed in a day from anywhere
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/EcC0LyRWr}
   */
  function gameLoadingCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlayableClickId(properties.playableClickId));
      messages = messages.concat(assertPlayableCode(properties.playableCode));
      messages = messages.concat(assertGameCode(properties.gameCode));
      messages = messages.concat(assertGameEngine(properties.gameEngine));
      messages = messages.concat(assertContentType(properties.contentType));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertRecommendedRailName(properties.recommendedRailName));
      messages = messages.concat(assertRecommendedRailRank(properties.recommendedRailRank));
      messages = messages.concat(assertOptionalRecommendedTileName(properties.recommendedTileName));
      messages = messages.concat(assertRecommendedTileRank(properties.recommendedTileRank));
      messages = messages.concat(assertRecommendedRail(properties.recommendedRail));
      messages = messages.concat(assertRecommendedCategory(properties.recommendedCategory));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertContentGroup(properties.contentGroup));
      messages = messages.concat(assertTabCode(properties.tabCode));
      messages = messages.concat(assertTabStrClickedCount(properties.tabStrClickedCount));
      messages = messages.concat(assertTabStrStartedCount(properties.tabStrStartedCount));
      messages = messages.concat(assertRailStrClickedCount(properties.railStrClickedCount));
      messages = messages.concat(assertRailStrStartedCount(properties.railStrStartedCount));
      messages = messages.concat(assertTileStrClickedCount(properties.tileStrClickedCount));
      messages = messages.concat(assertTileStrStartedCount(properties.tileStrStartedCount));
      messages = messages.concat(assertTabStrCompletedCount(properties.tabStrCompletedCount));
      messages = messages.concat(assertRailStrCompletedCount(properties.railStrCompletedCount));
      messages = messages.concat(assertTileStrCompletedCount(properties.tileStrCompletedCount));
      messages = messages.concat(assertOverallClickedCount(properties.overallClickedCount));
      messages = messages.concat(assertOverallStartedCount(properties.overallStartedCount));
      messages = messages.concat(assertOverallCompletedCount(properties.overallCompletedCount));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Game Loading Completed", Object.keys(properties), [
        "playableClickId",
        "playableCode",
        "gameCode",
        "gameEngine",
        "contentType",
        "platform",
        "recommendedRailName",
        "recommendedRailRank",
        "recommendedTileName",
        "recommendedTileRank",
        "recommendedRail",
        "recommendedCategory",
        "from",
        "grade",
        "contentGroup",
        "tabCode",
        "tabStrClickedCount",
        "tabStrStartedCount",
        "railStrClickedCount",
        "railStrStartedCount",
        "tileStrClickedCount",
        "tileStrStartedCount",
        "tabStrCompletedCount",
        "railStrCompletedCount",
        "tileStrCompletedCount",
        "overallClickedCount",
        "overallStartedCount",
        "overallCompletedCount"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "EcC0LyRWr", "20fb1a2f0498b07e05a9af0bc1ef9fef724917b608bb0ae545bcc73218c70cd7", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Game Loading Completed", {
        "Playable Click Id": properties.playableClickId,
        "Playable Code": properties.playableCode,
        "Game Code": properties.gameCode,
        "Game Engine": properties.gameEngine,
        "Content Type": properties.contentType,
        "Platform": properties.platform,
        "Recommended Rail Name": properties.recommendedRailName,
        "Recommended Rail Rank": properties.recommendedRailRank,
        "Recommended Tile Name": properties.recommendedTileName,
        "Recommended Tile Rank": properties.recommendedTileRank,
        "Recommended Rail": properties.recommendedRail,
        "Recommended Category": properties.recommendedCategory,
        "From": properties.from,
        "Grade": properties.grade,
        "Content Group": properties.contentGroup,
        "Tab Code": properties.tabCode,
        "Tab Str Clicked Count": properties.tabStrClickedCount,
        "Tab Str Started Count": properties.tabStrStartedCount,
        "Rail Str Clicked Count": properties.railStrClickedCount,
        "Rail Str Started Count": properties.railStrStartedCount,
        "Tile Str Clicked Count": properties.tileStrClickedCount,
        "Tile Str Started Count": properties.tileStrStartedCount,
        "Tab Str Completed Count": properties.tabStrCompletedCount,
        "Rail Str Completed Count": properties.railStrCompletedCount,
        "Tile Str Completed Count": properties.tileStrCompletedCount,
        "Overall Clicked Count": properties.overallClickedCount,
        "Overall Started Count": properties.overallStartedCount,
        "Overall Completed Count": properties.overallCompletedCount,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("EcC0LyRWr", "Game Loading Completed", messages, [
        {id: "2oZQdvXRu", name: "Game Code", value: properties.gameCode},
        {id: "33JWk0cGdkpH6MbvcXKfL", name: "Tile Str Clicked Count", value: properties.tileStrClickedCount},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "6lrsWYY5Y", name: "Recommended Rail Name", value: properties.recommendedRailName},
        {id: "72Hz7CelRpVYf1warHrRP", name: "Tile Str Started Count", value: properties.tileStrStartedCount},
        {id: "7PQh3G9ITCcMDMNeMTM8q", name: "Tab Str Clicked Count", value: properties.tabStrClickedCount},
        {id: "AFC3Xnyx0vxpH2PWZIjdO", name: "Rail Str Completed Count", value: properties.railStrCompletedCount},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "FLDtSJNKL", name: "Recommended Tile Rank", value: properties.recommendedTileRank},
        {id: "GAdbKqJ5y9HJPos5lx5qt", name: "Tab Str Completed Count", value: properties.tabStrCompletedCount},
        {id: "HFnzATNuS7GI6VZs6tZ15", name: "Tab Str Started Count", value: properties.tabStrStartedCount},
        {id: "HJUIBmGrsUmqa_TYCtwQ0", name: "Overall Started Count", value: properties.overallStartedCount},
        {id: "JVkBdMN1_", name: "Game Engine", value: properties.gameEngine},
        {id: "Nfs9QLl8W7", name: "Content Type", value: properties.contentType},
        {id: "OHBx0fnhzlxvHhw0e87pM", name: "Overall Completed Count", value: properties.overallCompletedCount},
        {id: "Otu1r2JQW", name: "Content Group", value: properties.contentGroup},
        {id: "QQeu-Td4-0", name: "Playable Click Id", value: properties.playableClickId},
        {id: "QjCwFasvW0", name: "Playable Code", value: properties.playableCode},
        {id: "TYbmk5DQn", name: "Recommended Tile Name", value: properties.recommendedTileName},
        {id: "VdJhEU0H6s", name: "Recommended Category", value: properties.recommendedCategory},
        {id: "X4kgAx81N5AHgcI6NaNiS", name: "Overall Clicked Count", value: properties.overallClickedCount},
        {id: "_QL92wEdpoa8wH50vOPYt", name: "Tile Str Completed Count", value: properties.tileStrCompletedCount},
        {id: "drNgwJn5Xg", name: "Recommended Rail", value: properties.recommendedRail},
        {id: "hKAJ3izCFVFH-D4_886C8", name: "Rail Str Clicked Count", value: properties.railStrClickedCount},
        {id: "l9PbANZBu", name: "Tab Code", value: properties.tabCode},
        {id: "sRPi7ITwtlHeD7HQEGzmG", name: "Rail Str Started Count", value: properties.railStrStartedCount},
        {id: "uyLgqxbg7", name: "Recommended Rail Rank", value: properties.recommendedRailRank},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Game Loading Completed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Game Loading Completed", {
          "Playable Click Id": properties.playableClickId,
          "Playable Code": properties.playableCode,
          "Game Code": properties.gameCode,
          "Game Engine": properties.gameEngine,
          "Content Type": properties.contentType,
          "Platform": properties.platform,
          "Recommended Rail Name": properties.recommendedRailName,
          "Recommended Rail Rank": properties.recommendedRailRank,
          "Recommended Tile Name": properties.recommendedTileName,
          "Recommended Tile Rank": properties.recommendedTileRank,
          "Recommended Rail": properties.recommendedRail,
          "Recommended Category": properties.recommendedCategory,
          "From": properties.from,
          "Grade": properties.grade,
          "Content Group": properties.contentGroup,
          "Tab Code": properties.tabCode,
          "Tab Str Clicked Count": properties.tabStrClickedCount,
          "Tab Str Started Count": properties.tabStrStartedCount,
          "Rail Str Clicked Count": properties.railStrClickedCount,
          "Rail Str Started Count": properties.railStrStartedCount,
          "Tile Str Clicked Count": properties.tileStrClickedCount,
          "Tile Str Started Count": properties.tileStrStartedCount,
          "Tab Str Completed Count": properties.tabStrCompletedCount,
          "Rail Str Completed Count": properties.railStrCompletedCount,
          "Tile Str Completed Count": properties.tileStrCompletedCount,
          "Overall Clicked Count": properties.overallClickedCount,
          "Overall Started Count": properties.overallStartedCount,
          "Overall Completed Count": properties.overallCompletedCount,
          "Screen Height": sysScreenHeight,
          }, "EcC0LyRWr", "20fb1a2f0498b07e05a9af0bc1ef9fef724917b608bb0ae545bcc73218c70cd7");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Game Loading Completed", {
      "Playable Click Id": properties.playableClickId,
      "Playable Code": properties.playableCode,
      "Game Code": properties.gameCode,
      "Game Engine": properties.gameEngine,
      "Content Type": properties.contentType,
      "Platform": properties.platform,
      "Recommended Rail Name": properties.recommendedRailName,
      "Recommended Rail Rank": properties.recommendedRailRank,
      "Recommended Tile Name": properties.recommendedTileName,
      "Recommended Tile Rank": properties.recommendedTileRank,
      "Recommended Rail": properties.recommendedRail,
      "Recommended Category": properties.recommendedCategory,
      "From": properties.from,
      "Grade": properties.grade,
      "Content Group": properties.contentGroup,
      "Tab Code": properties.tabCode,
      "Tab Str Clicked Count": properties.tabStrClickedCount,
      "Tab Str Started Count": properties.tabStrStartedCount,
      "Rail Str Clicked Count": properties.railStrClickedCount,
      "Rail Str Started Count": properties.railStrStartedCount,
      "Tile Str Clicked Count": properties.tileStrClickedCount,
      "Tile Str Started Count": properties.tileStrStartedCount,
      "Tab Str Completed Count": properties.tabStrCompletedCount,
      "Rail Str Completed Count": properties.railStrCompletedCount,
      "Tile Str Completed Count": properties.tileStrCompletedCount,
      "Overall Clicked Count": properties.overallClickedCount,
      "Overall Started Count": properties.overallStartedCount,
      "Overall Completed Count": properties.overallCompletedCount,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Next Button Shown: This event is associated to the gamification FTUE, where after some selection we show a Next button.
   * 
   * When to trigger this event:
   * 1. Showing Next button on UI
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/iZclrWMb1TX/trigger/fvKSJ9xK-GRb
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.featureSource - This property will store the origin of the Next button - Hair or Face for now
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/iZclrWMb1TX}
   */
  function nextButtonShown(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertFeatureSource(properties.featureSource));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Next Button Shown", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "featureSource",
        "elaGrade",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "iZclrWMb1TX", "cbeeaf1808b64056cbadef53b99307b9ab9294a149387f038cf159bb6ad744e8", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Next Button Shown", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Feature Source": properties.featureSource,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("iZclrWMb1TX", "Next Button Shown", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ogGTBAdVa", name: "Feature Source", value: properties.featureSource},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Next Button Shown': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Next Button Shown", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Feature Source": properties.featureSource,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "iZclrWMb1TX", "cbeeaf1808b64056cbadef53b99307b9ab9294a149387f038cf159bb6ad744e8");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Next Button Shown", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Feature Source": properties.featureSource,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Clicked Next Button: When user clicks on the next button
   * 
   * When to trigger this event:
   * 1. When user taps on the next button
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/wcOVh3-ueeG/trigger/nXRuYZ_rv4L
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.featureSource - This property will store the origin of the Next button - Hair or Face for now
   * @param {bool} properties.rail1Interacted - This stores yes /no to pass if user interacted with the Rail 1
   * @param {bool} properties.rail2Interacted - This property stores yes/no if user interacted with the inner rail.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/wcOVh3-ueeG}
   */
  function clickedNextButton(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertFeatureSource(properties.featureSource));
      messages = messages.concat(assertRail1Interacted(properties.rail1Interacted));
      messages = messages.concat(assertRail2Interacted(properties.rail2Interacted));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Clicked Next Button", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "featureSource",
        "rail1Interacted",
        "rail2Interacted",
        "elaGrade",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "wcOVh3-ueeG", "d1a0ad08f0746fbcc45914ae425b5ed2c5cbde95363c97023747bedf98e87a78", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Clicked Next Button", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Feature Source": properties.featureSource,
        "Rail 1 Interacted": properties.rail1Interacted,
        "Rail 2 Interacted": properties.rail2Interacted,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("wcOVh3-ueeG", "Clicked Next Button", messages, [
        {id: "1Hjsl9j-e", name: "Rail 2 Interacted", value: properties.rail2Interacted},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "ArTZFw0C7", name: "Rail 1 Interacted", value: properties.rail1Interacted},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ogGTBAdVa", name: "Feature Source", value: properties.featureSource},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Clicked Next Button': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Clicked Next Button", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Feature Source": properties.featureSource,
          "Rail 1 Interacted": properties.rail1Interacted,
          "Rail 2 Interacted": properties.rail2Interacted,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "wcOVh3-ueeG", "d1a0ad08f0746fbcc45914ae425b5ed2c5cbde95363c97023747bedf98e87a78");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Clicked Next Button", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Feature Source": properties.featureSource,
      "Rail 1 Interacted": properties.rail1Interacted,
      "Rail 2 Interacted": properties.rail2Interacted,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Avatar Celebration Screen: This event is associated to a one time screen which appears during avatar creation FTUE.
   * 
   * When to trigger this event:
   * 1. When this screen is presented
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/8K6L6fmxibl/trigger/eJlxxB6mQzH
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/8K6L6fmxibl}
   */
  function viewedAvatarCelebrationScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Avatar Celebration Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "elaGrade",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "8K6L6fmxibl", "823160c4c4fdac8dce6eaf40ecba48e6e794b1790dd17e247d4f98bfbb84d0ce", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Avatar Celebration Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("8K6L6fmxibl", "Viewed Avatar Celebration Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Avatar Celebration Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Avatar Celebration Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "8K6L6fmxibl", "823160c4c4fdac8dce6eaf40ecba48e6e794b1790dd17e247d4f98bfbb84d0ce");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Avatar Celebration Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Avatar Celebration Screen: This event is associated to the interactions with the celebration screen
   * 
   * When to trigger this event:
   * 1. When user interacts with this screen.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/H1THLcBXsIX/trigger/sbe4tiGhqt_K
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/H1THLcBXsIX}
   */
  function interactedAvatarCelebrationScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Avatar Celebration Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "clickedOn",
        "elaGrade",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "H1THLcBXsIX", "4e4ae8c812662924390384220ec15f21781a86f6c4d05f7f2a78f263b3cc5515", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Avatar Celebration Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Clicked On": properties.clickedOn,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("H1THLcBXsIX", "Interacted Avatar Celebration Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Avatar Celebration Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Avatar Celebration Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Clicked On": properties.clickedOn,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "H1THLcBXsIX", "4e4ae8c812662924390384220ec15f21781a86f6c4d05f7f2a78f263b3cc5515");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Avatar Celebration Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Clicked On": properties.clickedOn,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Curriculum Screen: This event is associated with the topics page / milestone view / internal curriculum page
   * 
   * When to trigger this event:
   * 1. When user lands on this screen
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/W_uVXKnIhe/trigger/adqu8jP89P
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.contentGroup - Code of content group user clicked/tapped on
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/W_uVXKnIhe}
   */
  function viewedCurriculumScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertContentGroup(properties.contentGroup));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Curriculum Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "subject",
        "contentGroup",
        "elaGrade",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "W_uVXKnIhe", "c9a190892988ad7a056ae0f2fa65ad077081b8a51f76976af3f00fbab7d59802", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Curriculum Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Subject": properties.subject,
        "Content Group": properties.contentGroup,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("W_uVXKnIhe", "Viewed Curriculum Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "Otu1r2JQW", name: "Content Group", value: properties.contentGroup},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Curriculum Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Curriculum Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Subject": properties.subject,
          "Content Group": properties.contentGroup,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "W_uVXKnIhe", "c9a190892988ad7a056ae0f2fa65ad077081b8a51f76976af3f00fbab7d59802");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Curriculum Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Subject": properties.subject,
      "Content Group": properties.contentGroup,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Lo Started: This event gets fired when a LO is started, i.e. first playable of that LO is started
   * 
   * When to trigger this event:
   * 1. When users starts a LO
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/xhqIrZBdPN/trigger/pJqgk6prsJt
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.loName - Highlights for which LO event has triggered.
   * @param {string} properties.loCode - stores the code of the LO for which this event got triggered
   * @param {string} properties.contentGroup - Code of content group user clicked/tapped on
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/xhqIrZBdPN}
   */
  function loStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertLOName(properties.loName));
      messages = messages.concat(assertLOCode(properties.loCode));
      messages = messages.concat(assertContentGroup(properties.contentGroup));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Lo Started", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "loName",
        "loCode",
        "contentGroup",
        "subject",
        "elaGrade",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "xhqIrZBdPN", "ed8d2bb1df98240ff781a895f0954f46fa19737a3b4dd19110f6c4e923e4cd04", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Lo Started", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "LO Name": properties.loName,
        "LO Code": properties.loCode,
        "Content Group": properties.contentGroup,
        "Subject": properties.subject,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("xhqIrZBdPN", "Lo Started", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "CdbCi-2yB", name: "LO Name", value: properties.loName},
        {id: "Otu1r2JQW", name: "Content Group", value: properties.contentGroup},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "gT0JuYf2B", name: "LO Code", value: properties.loCode},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Lo Started': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lo Started", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "LO Name": properties.loName,
          "LO Code": properties.loCode,
          "Content Group": properties.contentGroup,
          "Subject": properties.subject,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "xhqIrZBdPN", "ed8d2bb1df98240ff781a895f0954f46fa19737a3b4dd19110f6c4e923e4cd04");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Lo Started", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "LO Name": properties.loName,
      "LO Code": properties.loCode,
      "Content Group": properties.contentGroup,
      "Subject": properties.subject,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Lo Completed: When LO is completed
   * 
   * When to trigger this event:
   * 1. At completion of an LO
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/e7I8ae-Xgd/trigger/3qYzEqur4e
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.loCode - stores the code of the LO for which this event got triggered
   * @param {string} properties.loName - Highlights for which LO event has triggered.
   * @param {string} properties.contentGroup - Code of content group user clicked/tapped on
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.loStatus - This stores whether the LO is completed or mastered
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/e7I8ae-Xgd}
   */
  function loCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertLOCode(properties.loCode));
      messages = messages.concat(assertLOName(properties.loName));
      messages = messages.concat(assertContentGroup(properties.contentGroup));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertLOStatus(properties.loStatus));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Lo Completed", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "loCode",
        "loName",
        "contentGroup",
        "grade",
        "elaGrade",
        "subject",
        "loStatus"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "e7I8ae-Xgd", "fe8d690029e3ce7eb8aae0389f80fb9e727fcd80e24d00f1adc592debce157c9", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Lo Completed", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "LO Code": properties.loCode,
        "LO Name": properties.loName,
        "Content Group": properties.contentGroup,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Subject": properties.subject,
        "LO Status": properties.loStatus,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("e7I8ae-Xgd", "Lo Completed", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "CdbCi-2yB", name: "LO Name", value: properties.loName},
        {id: "Otu1r2JQW", name: "Content Group", value: properties.contentGroup},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "a7Ojd0Pzt", name: "LO Status", value: properties.loStatus},
        {id: "gT0JuYf2B", name: "LO Code", value: properties.loCode},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Lo Completed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lo Completed", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "LO Code": properties.loCode,
          "LO Name": properties.loName,
          "Content Group": properties.contentGroup,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Subject": properties.subject,
          "LO Status": properties.loStatus,
          "Screen Height": sysScreenHeight,
          }, "e7I8ae-Xgd", "fe8d690029e3ce7eb8aae0389f80fb9e727fcd80e24d00f1adc592debce157c9");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Lo Completed", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "LO Code": properties.loCode,
      "LO Name": properties.loName,
      "Content Group": properties.contentGroup,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Subject": properties.subject,
      "LO Status": properties.loStatus,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Milestone Completed: This event fires when milestone is also completed
   * 
   * When to trigger this event:
   * 1. At the completion of a milestone
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/wHvveZWndo/trigger/P8GJwwvuRd
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.milestoneName - This property stores the name of the milestone
   * @param {string} properties.milestoneCode - This property stores the code of the milestone
   * @param {string} properties.contentGroup - Code of content group user clicked/tapped on
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/wHvveZWndo}
   */
  function milestoneCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertMilestoneName(properties.milestoneName));
      messages = messages.concat(assertMilestoneCode(properties.milestoneCode));
      messages = messages.concat(assertContentGroup(properties.contentGroup));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Milestone Completed", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "milestoneName",
        "milestoneCode",
        "contentGroup",
        "elaGrade",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "wHvveZWndo", "749596a69e5e268c0b29d9779753580bbef2e61025d7c76ac9bbb0711938e130", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Milestone Completed", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Milestone Name": properties.milestoneName,
        "Milestone Code": properties.milestoneCode,
        "Content Group": properties.contentGroup,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("wHvveZWndo", "Milestone Completed", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "Bx_g6ZB1b", name: "Milestone Code", value: properties.milestoneCode},
        {id: "Otu1r2JQW", name: "Content Group", value: properties.contentGroup},
        {id: "ky5tzfihY", name: "Milestone Name", value: properties.milestoneName},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Milestone Completed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Milestone Completed", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Milestone Name": properties.milestoneName,
          "Milestone Code": properties.milestoneCode,
          "Content Group": properties.contentGroup,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "wHvveZWndo", "749596a69e5e268c0b29d9779753580bbef2e61025d7c76ac9bbb0711938e130");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Milestone Completed", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Milestone Name": properties.milestoneName,
      "Milestone Code": properties.milestoneCode,
      "Content Group": properties.contentGroup,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Curriculum Screen: When users interacts with the curriculum screen (topic screen)
   * 
   * When to trigger this event:
   * 1. User interacts with the elements of this screen
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/4CeF2wWG0Q/trigger/iKusWpmttY
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.milestoneName - This property stores the name of the milestone
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/4CeF2wWG0Q}
   */
  function interactedCurriculumScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertMilestoneName(properties.milestoneName));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Curriculum Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "clickedOn",
        "milestoneName",
        "elaGrade",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "4CeF2wWG0Q", "e1cdca48ec212c48a42422a00701befc8e5a92bbe85c843d8b699813940dd23a", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Curriculum Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Clicked On": properties.clickedOn,
        "Milestone Name": properties.milestoneName,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("4CeF2wWG0Q", "Interacted Curriculum Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "ky5tzfihY", name: "Milestone Name", value: properties.milestoneName},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Curriculum Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Curriculum Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Clicked On": properties.clickedOn,
          "Milestone Name": properties.milestoneName,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "4CeF2wWG0Q", "e1cdca48ec212c48a42422a00701befc8e5a92bbe85c843d8b699813940dd23a");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Curriculum Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Clicked On": properties.clickedOn,
      "Milestone Name": properties.milestoneName,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Collection Assigned: When the book collection is assigned
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {Array<string>} properties.collectionName - Name of the collection to which book was added/removed
   * @param {Array<string>} properties.collectionCode - Self Explanatory
   * @param {string} properties.collectionDescription - Self Explanatory
   * @param {int} properties.studentsAssignedTo - This will capture the no. of students to whom the assignment is assigned.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/M-xeOg_mIng}
   */
  function collectionAssigned(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertCollectionName(properties.collectionName));
      messages = messages.concat(assertCollectionCode(properties.collectionCode));
      messages = messages.concat(assertCollectionDescription(properties.collectionDescription));
      messages = messages.concat(assertStudentsAssignedTo(properties.studentsAssignedTo));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Collection Assigned", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "collectionName",
        "collectionCode",
        "collectionDescription",
        "studentsAssignedTo"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "M-xeOg_mIng", "6e158bb5567c444b417b6f1a03c7693a9b21adef109361bf50bcaa1fe3f32cd9", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Collection Assigned", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Collection Name": properties.collectionName,
        "Collection Code": properties.collectionCode,
        "Collection Description": properties.collectionDescription,
        "Students Assigned To": properties.studentsAssignedTo,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("M-xeOg_mIng", "Collection Assigned", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "b8Fx1iSZI", name: "Collection Name", value: properties.collectionName},
        {id: "eMtEG5HBc", name: "Collection Code", value: properties.collectionCode},
        {id: "mvOIacTNl", name: "Students Assigned To", value: properties.studentsAssignedTo},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "v02OnlI5e", name: "Collection Description", value: properties.collectionDescription},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Collection Assigned': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Collection Assigned", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Collection Name": properties.collectionName,
          "Collection Code": properties.collectionCode,
          "Collection Description": properties.collectionDescription,
          "Students Assigned To": properties.studentsAssignedTo,
          "Screen Height": sysScreenHeight,
          }, "M-xeOg_mIng", "6e158bb5567c444b417b6f1a03c7693a9b21adef109361bf50bcaa1fe3f32cd9");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Collection Assigned", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Collection Name": properties.collectionName,
      "Collection Code": properties.collectionCode,
      "Collection Description": properties.collectionDescription,
      "Students Assigned To": properties.studentsAssignedTo,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed PTL Parent Signup Screen: This event will fire when user is displayed the landing page for setting up home access on clicking the home access link shared by teacher.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/YqX3fAUxn9MifS5XIPyaz/trigger/R1i-HyNHrvYyzwISWMM1c
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.invitationSource - This property returns the type of invite sent from the student roster page
   * @param {string} properties.referrerPage - Shows the description of the previous page name/URL
   * @param {string} properties.ptlSignupFlowSegmentName - This property will differentiate between control and variant version of teacher invited PTL signup/login flow. Expected values will be 'Variant' or 'Control'
   * @param {string} properties.teacherSignupDate - This property will return the date teacher has signed up on the product
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/YqX3fAUxn9MifS5XIPyaz}
   */
  function viewedPtlParentSignupScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertInvitationSource(properties.invitationSource));
      messages = messages.concat(assertReferrerPage(properties.referrerPage));
      messages = messages.concat(assertPTLSignupFlowSegmentName(properties.ptlSignupFlowSegmentName));
      messages = messages.concat(assertTeacherSignupDate(properties.teacherSignupDate));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed PTL Parent Signup Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "invitationSource",
        "referrerPage",
        "ptlSignupFlowSegmentName",
        "teacherSignupDate"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "YqX3fAUxn9MifS5XIPyaz", "f2f600fcc36a32ee5a19d80a120f9f021892e44804e905081d5cb9f603b226fe", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed PTL Parent Signup Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Invitation Source": properties.invitationSource,
        "Referrer Page": properties.referrerPage,
        "PTL Signup Flow Segment Name": properties.ptlSignupFlowSegmentName,
        "Teacher Signup Date": properties.teacherSignupDate,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("YqX3fAUxn9MifS5XIPyaz", "Viewed PTL Parent Signup Screen", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "L3Bn5aQc2GJb6e2NuVU3C", name: "Teacher Signup Date", value: properties.teacherSignupDate},
        {id: "bD4JrEqtTf4IACKroNfTR", name: "PTL Signup Flow Segment Name", value: properties.ptlSignupFlowSegmentName},
        {id: "cYVv-jM3n6", name: "Referrer Page", value: properties.referrerPage},
        {id: "cccDu2odc", name: "Invitation Source", value: properties.invitationSource},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed PTL Parent Signup Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed PTL Parent Signup Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Invitation Source": properties.invitationSource,
          "Referrer Page": properties.referrerPage,
          "PTL Signup Flow Segment Name": properties.ptlSignupFlowSegmentName,
          "Teacher Signup Date": properties.teacherSignupDate,
          "Screen Height": sysScreenHeight,
          }, "YqX3fAUxn9MifS5XIPyaz", "f2f600fcc36a32ee5a19d80a120f9f021892e44804e905081d5cb9f603b226fe");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed PTL Parent Signup Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Invitation Source": properties.invitationSource,
      "Referrer Page": properties.referrerPage,
      "PTL Signup Flow Segment Name": properties.ptlSignupFlowSegmentName,
      "Teacher Signup Date": properties.teacherSignupDate,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted PTL Parent Signup Screen: This event will fire when user interacts with the landing page for setting up home access displayed on clicking the home access link shared by teacher.
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/QXlNIHpS6lSQxyI_OTJiH/trigger/oC6Zx0UjmftJO_xf-vf9Z
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.invitationSource - This property returns the type of invite sent from the student roster page
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.referrerPage - Shows the description of the previous page name/URL
   * @param {string} properties.interactionDetails - Stores where is the user interacting with the page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/QXlNIHpS6lSQxyI_OTJiH}
   */
  function interactedPtlParentSignupScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertInvitationSource(properties.invitationSource));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertReferrerPage(properties.referrerPage));
      messages = messages.concat(assertInteractionDetails(properties.interactionDetails));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted PTL Parent Signup Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "invitationSource",
        "clickedOn",
        "referrerPage",
        "interactionDetails"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "QXlNIHpS6lSQxyI_OTJiH", "c0ddd86f2cb4adec319e1e121d7fce46331e6aac3382256f195014d71a430971", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted PTL Parent Signup Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Invitation Source": properties.invitationSource,
        "Clicked On": properties.clickedOn,
        "Referrer Page": properties.referrerPage,
        "Interaction Details": properties.interactionDetails,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("QXlNIHpS6lSQxyI_OTJiH", "Interacted PTL Parent Signup Screen", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "cYVv-jM3n6", name: "Referrer Page", value: properties.referrerPage},
        {id: "cccDu2odc", name: "Invitation Source", value: properties.invitationSource},
        {id: "ncdYto9gZ", name: "Interaction Details", value: properties.interactionDetails},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted PTL Parent Signup Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted PTL Parent Signup Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Invitation Source": properties.invitationSource,
          "Clicked On": properties.clickedOn,
          "Referrer Page": properties.referrerPage,
          "Interaction Details": properties.interactionDetails,
          "Screen Height": sysScreenHeight,
          }, "QXlNIHpS6lSQxyI_OTJiH", "c0ddd86f2cb4adec319e1e121d7fce46331e6aac3382256f195014d71a430971");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted PTL Parent Signup Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Invitation Source": properties.invitationSource,
      "Clicked On": properties.clickedOn,
      "Referrer Page": properties.referrerPage,
      "Interaction Details": properties.interactionDetails,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * PTL Linking Attempted: This event will be fired when student linking api is called by the backend post email verification
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/_pFKvqVOs_4C_0p4FeZDt/trigger/ceRAF33ZANpREV7d2f-k0
   * 2. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/_pFKvqVOs_4C_0p4FeZDt/trigger/U6H9wFPyw2vNm3d95HEVE
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.invitationSource - This property returns the type of invite sent from the student roster page
   * @param {string} properties.ptlFlow - This will identify if the user is signing up for a PTL account/ Linking new student to their existing PTL account/ logging in for connected student
   * @param {string} properties.linkedStudentCount - This property will return the count of students already linked with the PTL user attempting to signup or attempting to link new student
   * @param {string} properties.referrerPage - Shows the description of the previous page name/URL
   * @param {Array<string>} properties.optionsSelected - Array to save all of the options the user selects
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/_pFKvqVOs_4C_0p4FeZDt}
   */
  function ptlLinkingAttempted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertInvitationSource(properties.invitationSource));
      messages = messages.concat(assertPTLFlow(properties.ptlFlow));
      messages = messages.concat(assertLinkedStudentCount(properties.linkedStudentCount));
      messages = messages.concat(assertReferrerPage(properties.referrerPage));
      messages = messages.concat(assertOptionsSelected(properties.optionsSelected));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("PTL Linking Attempted", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "invitationSource",
        "ptlFlow",
        "linkedStudentCount",
        "referrerPage",
        "optionsSelected"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "_pFKvqVOs_4C_0p4FeZDt", "00ebaf2f4d70ce09dc6c06834eb45389911a17a22938eb0d1499ac993c4cf30c", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("PTL Linking Attempted", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Invitation Source": properties.invitationSource,
        "PTL Flow": properties.ptlFlow,
        "Linked Student Count": properties.linkedStudentCount,
        "Referrer Page": properties.referrerPage,
        "Options Selected": properties.optionsSelected,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("_pFKvqVOs_4C_0p4FeZDt", "PTL Linking Attempted", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "FZg42lPcF", name: "Options Selected", value: properties.optionsSelected},
        {id: "LKpPivRaqhv1iRgHvCBQE", name: "PTL Flow", value: properties.ptlFlow},
        {id: "cYVv-jM3n6", name: "Referrer Page", value: properties.referrerPage},
        {id: "cccDu2odc", name: "Invitation Source", value: properties.invitationSource},
        {id: "eb8RBK1CZ_91zt06w-5iv", name: "Linked Student Count", value: properties.linkedStudentCount},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'PTL Linking Attempted': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("PTL Linking Attempted", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Invitation Source": properties.invitationSource,
          "PTL Flow": properties.ptlFlow,
          "Linked Student Count": properties.linkedStudentCount,
          "Referrer Page": properties.referrerPage,
          "Options Selected": properties.optionsSelected,
          "Screen Height": sysScreenHeight,
          }, "_pFKvqVOs_4C_0p4FeZDt", "00ebaf2f4d70ce09dc6c06834eb45389911a17a22938eb0d1499ac993c4cf30c");
      }
      // destination CustomDestination
      CustomDestination.logEvent("PTL Linking Attempted", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Invitation Source": properties.invitationSource,
      "PTL Flow": properties.ptlFlow,
      "Linked Student Count": properties.linkedStudentCount,
      "Referrer Page": properties.referrerPage,
      "Options Selected": properties.optionsSelected,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * PTL Linking Successful: This event will be fired when student is linked successfully from backend
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.invitationSource - This property returns the type of invite sent from the student roster page
   * @param {string} properties.linkedStudentCount - This property will return the count of students already linked with the PTL user attempting to signup or attempting to link new student
   * @param {string} properties.ptlFlow - This will identify if the user is signing up for a PTL account/ Linking new student to their existing PTL account/ logging in for connected student
   * @param {string} properties.referrerPage - Shows the description of the previous page name/URL
   * @param {Array<string>} properties.optionsSelected - Array to save all of the options the user selects
   * @param {string} properties.ptlSignupFlowSegmentName - This property will differentiate between control and variant version of teacher invited PTL signup/login flow. Expected values will be 'Variant' or 'Control'
   * @param {string} properties.teacherSignupDate - This property will return the date teacher has signed up on the product
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/3-_C1he3stcZ6aNYeC5TL}
   */
  function ptlLinkingSuccessful(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertInvitationSource(properties.invitationSource));
      messages = messages.concat(assertLinkedStudentCount(properties.linkedStudentCount));
      messages = messages.concat(assertPTLFlow(properties.ptlFlow));
      messages = messages.concat(assertReferrerPage(properties.referrerPage));
      messages = messages.concat(assertOptionsSelected(properties.optionsSelected));
      messages = messages.concat(assertPTLSignupFlowSegmentName(properties.ptlSignupFlowSegmentName));
      messages = messages.concat(assertTeacherSignupDate(properties.teacherSignupDate));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("PTL Linking Successful", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "invitationSource",
        "linkedStudentCount",
        "ptlFlow",
        "referrerPage",
        "optionsSelected",
        "ptlSignupFlowSegmentName",
        "teacherSignupDate"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "3-_C1he3stcZ6aNYeC5TL", "5785aed19664733981dd717fe2ed6403a18a048a0979d66667b11e537b781c17", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("PTL Linking Successful", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Invitation Source": properties.invitationSource,
        "Linked Student Count": properties.linkedStudentCount,
        "PTL Flow": properties.ptlFlow,
        "Referrer Page": properties.referrerPage,
        "Options Selected": properties.optionsSelected,
        "PTL Signup Flow Segment Name": properties.ptlSignupFlowSegmentName,
        "Teacher Signup Date": properties.teacherSignupDate,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("3-_C1he3stcZ6aNYeC5TL", "PTL Linking Successful", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "FZg42lPcF", name: "Options Selected", value: properties.optionsSelected},
        {id: "L3Bn5aQc2GJb6e2NuVU3C", name: "Teacher Signup Date", value: properties.teacherSignupDate},
        {id: "LKpPivRaqhv1iRgHvCBQE", name: "PTL Flow", value: properties.ptlFlow},
        {id: "bD4JrEqtTf4IACKroNfTR", name: "PTL Signup Flow Segment Name", value: properties.ptlSignupFlowSegmentName},
        {id: "cYVv-jM3n6", name: "Referrer Page", value: properties.referrerPage},
        {id: "cccDu2odc", name: "Invitation Source", value: properties.invitationSource},
        {id: "eb8RBK1CZ_91zt06w-5iv", name: "Linked Student Count", value: properties.linkedStudentCount},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'PTL Linking Successful': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("PTL Linking Successful", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Invitation Source": properties.invitationSource,
          "Linked Student Count": properties.linkedStudentCount,
          "PTL Flow": properties.ptlFlow,
          "Referrer Page": properties.referrerPage,
          "Options Selected": properties.optionsSelected,
          "PTL Signup Flow Segment Name": properties.ptlSignupFlowSegmentName,
          "Teacher Signup Date": properties.teacherSignupDate,
          "Screen Height": sysScreenHeight,
          }, "3-_C1he3stcZ6aNYeC5TL", "5785aed19664733981dd717fe2ed6403a18a048a0979d66667b11e537b781c17");
      }
      // destination CustomDestination
      CustomDestination.logEvent("PTL Linking Successful", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Invitation Source": properties.invitationSource,
      "Linked Student Count": properties.linkedStudentCount,
      "PTL Flow": properties.ptlFlow,
      "Referrer Page": properties.referrerPage,
      "Options Selected": properties.optionsSelected,
      "PTL Signup Flow Segment Name": properties.ptlSignupFlowSegmentName,
      "Teacher Signup Date": properties.teacherSignupDate,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * PTL Linking Failed: This event will be fired when classroom student linking is unsuccessful and will return the reason for failure 
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.invitationSource - This property returns the type of invite sent from the student roster page
   * @param {string} properties.linkedStudentCount - This property will return the count of students already linked with the PTL user attempting to signup or attempting to link new student
   * @param {string} properties.ptlFlow - This will identify if the user is signing up for a PTL account/ Linking new student to their existing PTL account/ logging in for connected student
   * @param {string} properties.referrerPage - Shows the description of the previous page name/URL
   * @param {string} properties.errorMessage - Error message shown to the user.
   * @param {Array<string>} properties.optionsSelected - Array to save all of the options the user selects
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/SIkpErtjiF7xnuBC3kZmf}
   */
  function ptlLinkingFailed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertInvitationSource(properties.invitationSource));
      messages = messages.concat(assertLinkedStudentCount(properties.linkedStudentCount));
      messages = messages.concat(assertPTLFlow(properties.ptlFlow));
      messages = messages.concat(assertReferrerPage(properties.referrerPage));
      messages = messages.concat(assertErrorMessage(properties.errorMessage));
      messages = messages.concat(assertOptionsSelected(properties.optionsSelected));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("PTL Linking Failed", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "invitationSource",
        "linkedStudentCount",
        "ptlFlow",
        "referrerPage",
        "errorMessage",
        "optionsSelected"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "SIkpErtjiF7xnuBC3kZmf", "3d80d834b2c834dd41f9d91169f91735a6b3709fea45285aa178df8e05a32de4", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("PTL Linking Failed", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Invitation Source": properties.invitationSource,
        "Linked Student Count": properties.linkedStudentCount,
        "PTL Flow": properties.ptlFlow,
        "Referrer Page": properties.referrerPage,
        "Error Message": properties.errorMessage,
        "Options Selected": properties.optionsSelected,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("SIkpErtjiF7xnuBC3kZmf", "PTL Linking Failed", messages, [
        {id: "1n3Bq4GKWy", name: "Error Message", value: properties.errorMessage},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "FZg42lPcF", name: "Options Selected", value: properties.optionsSelected},
        {id: "LKpPivRaqhv1iRgHvCBQE", name: "PTL Flow", value: properties.ptlFlow},
        {id: "cYVv-jM3n6", name: "Referrer Page", value: properties.referrerPage},
        {id: "cccDu2odc", name: "Invitation Source", value: properties.invitationSource},
        {id: "eb8RBK1CZ_91zt06w-5iv", name: "Linked Student Count", value: properties.linkedStudentCount},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'PTL Linking Failed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("PTL Linking Failed", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Invitation Source": properties.invitationSource,
          "Linked Student Count": properties.linkedStudentCount,
          "PTL Flow": properties.ptlFlow,
          "Referrer Page": properties.referrerPage,
          "Error Message": properties.errorMessage,
          "Options Selected": properties.optionsSelected,
          "Screen Height": sysScreenHeight,
          }, "SIkpErtjiF7xnuBC3kZmf", "3d80d834b2c834dd41f9d91169f91735a6b3709fea45285aa178df8e05a32de4");
      }
      // destination CustomDestination
      CustomDestination.logEvent("PTL Linking Failed", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Invitation Source": properties.invitationSource,
      "Linked Student Count": properties.linkedStudentCount,
      "PTL Flow": properties.ptlFlow,
      "Referrer Page": properties.referrerPage,
      "Error Message": properties.errorMessage,
      "Options Selected": properties.optionsSelected,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Student Selection Screen: This event will fire when user is displayed student profile selection screen during class login or during copy link signup flow
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/75QXuBFAOvpOckRrNDkrP/trigger/cMg8z1Y6VdAfJrc287K6h
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.invitationSource - This property returns the type of invite sent from the student roster page
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * @param {string} properties.loginMethod - Returns the login method used by the ptl teacher/parent/student to login
   * @param {string} properties.referrerPage - Shows the description of the previous page name/URL
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/75QXuBFAOvpOckRrNDkrP}
   */
  function viewedStudentSelectionScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertInvitationSource(properties.invitationSource));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertLoginMethod(properties.loginMethod));
      messages = messages.concat(assertReferrerPage(properties.referrerPage));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Student Selection Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "invitationSource",
        "fromPage",
        "loginMethod",
        "referrerPage",
        "mode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "75QXuBFAOvpOckRrNDkrP", "cdcf01afa3a8925cf31543390729db261aae67826d79f1edd4eae9143716765a", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Student Selection Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Invitation Source": properties.invitationSource,
        "From Page": properties.fromPage,
        "Login Method": properties.loginMethod,
        "Referrer Page": properties.referrerPage,
        "Mode": properties.mode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("75QXuBFAOvpOckRrNDkrP", "Viewed Student Selection Screen", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "RzhjpWea8R6s1FWo1fgS4", name: "Login Method", value: properties.loginMethod},
        {id: "cYVv-jM3n6", name: "Referrer Page", value: properties.referrerPage},
        {id: "cccDu2odc", name: "Invitation Source", value: properties.invitationSource},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Student Selection Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Student Selection Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Invitation Source": properties.invitationSource,
          "From Page": properties.fromPage,
          "Login Method": properties.loginMethod,
          "Referrer Page": properties.referrerPage,
          "Mode": properties.mode,
          "Screen Height": sysScreenHeight,
          }, "75QXuBFAOvpOckRrNDkrP", "cdcf01afa3a8925cf31543390729db261aae67826d79f1edd4eae9143716765a");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Student Selection Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Invitation Source": properties.invitationSource,
      "From Page": properties.fromPage,
      "Login Method": properties.loginMethod,
      "Referrer Page": properties.referrerPage,
      "Mode": properties.mode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Student Selection Screen: This event will get fired when user interacts with the student profile selection page during class login or when linking student via copy invite method
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/llYXmDO_yo-oimDZkPSHI/trigger/ezF31ELKeMC-bLpX0ue1m
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.invitationSource - This property returns the type of invite sent from the student roster page
   * @param {string} properties.referrerPage - Shows the description of the previous page name/URL
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/llYXmDO_yo-oimDZkPSHI}
   */
  function interactedStudentSelectionScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertInvitationSource(properties.invitationSource));
      messages = messages.concat(assertReferrerPage(properties.referrerPage));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Student Selection Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "invitationSource",
        "referrerPage",
        "mode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "llYXmDO_yo-oimDZkPSHI", "f189215ab8c656ebd98fb35575b24393a2048b83cc6a2b991647f82988b8dc51", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Student Selection Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Invitation Source": properties.invitationSource,
        "Referrer Page": properties.referrerPage,
        "Mode": properties.mode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("llYXmDO_yo-oimDZkPSHI", "Interacted Student Selection Screen", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "cYVv-jM3n6", name: "Referrer Page", value: properties.referrerPage},
        {id: "cccDu2odc", name: "Invitation Source", value: properties.invitationSource},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Student Selection Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Student Selection Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Invitation Source": properties.invitationSource,
          "Referrer Page": properties.referrerPage,
          "Mode": properties.mode,
          "Screen Height": sysScreenHeight,
          }, "llYXmDO_yo-oimDZkPSHI", "f189215ab8c656ebd98fb35575b24393a2048b83cc6a2b991647f82988b8dc51");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Student Selection Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Invitation Source": properties.invitationSource,
      "Referrer Page": properties.referrerPage,
      "Mode": properties.mode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Student Password Screen: This event will be fired when user is displayed password input page after selecting classroom student profile to login
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/9y8dsXm1w1LRra4cO7zmi/trigger/lbNMYbD3h2Dy3Q6bQjMlL
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.invitationSource - This property returns the type of invite sent from the student roster page
   * @param {string} properties.loginMethod - Returns the login method used by the ptl teacher/parent/student to login
   * @param {string} properties.passwordType - This property returns the class password type set by the teacher for student login. Value can be text or picture.
   * @param {string} properties.referrerPage - Shows the description of the previous page name/URL
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/9y8dsXm1w1LRra4cO7zmi}
   */
  function viewedStudentPasswordScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertInvitationSource(properties.invitationSource));
      messages = messages.concat(assertLoginMethod(properties.loginMethod));
      messages = messages.concat(assertPasswordType(properties.passwordType));
      messages = messages.concat(assertReferrerPage(properties.referrerPage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Student Password Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "invitationSource",
        "loginMethod",
        "passwordType",
        "referrerPage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "9y8dsXm1w1LRra4cO7zmi", "ae6e678c14bebaa89334790ef8ece04657e83b090a34c51ad1939f7f36024d02", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Student Password Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Invitation Source": properties.invitationSource,
        "Login Method": properties.loginMethod,
        "Password Type": properties.passwordType,
        "Referrer Page": properties.referrerPage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("9y8dsXm1w1LRra4cO7zmi", "Viewed Student Password Screen", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "RzhjpWea8R6s1FWo1fgS4", name: "Login Method", value: properties.loginMethod},
        {id: "cYVv-jM3n6", name: "Referrer Page", value: properties.referrerPage},
        {id: "cccDu2odc", name: "Invitation Source", value: properties.invitationSource},
        {id: "ltdeD9kflSPTHD993aqQW", name: "Password Type", value: properties.passwordType},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Student Password Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Student Password Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Invitation Source": properties.invitationSource,
          "Login Method": properties.loginMethod,
          "Password Type": properties.passwordType,
          "Referrer Page": properties.referrerPage,
          "Screen Height": sysScreenHeight,
          }, "9y8dsXm1w1LRra4cO7zmi", "ae6e678c14bebaa89334790ef8ece04657e83b090a34c51ad1939f7f36024d02");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Student Password Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Invitation Source": properties.invitationSource,
      "Login Method": properties.loginMethod,
      "Password Type": properties.passwordType,
      "Referrer Page": properties.referrerPage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Student Password Screen: This event will get fired when user interacts with the student password input screen
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/T60YokGM9bSZSfJfWBfB_/trigger/dqhwPTxP01AMefBAGDjMv
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} [properties.interactionDetails] - Stores where is the user interacting with the page
   * @param {string} properties.invitationSource - This property returns the type of invite sent from the student roster page
   * @param {string} properties.passwordType - This property returns the class password type set by the teacher for student login. Value can be text or picture.
   * @param {string} properties.referrerPage - Shows the description of the previous page name/URL
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/T60YokGM9bSZSfJfWBfB_}
   */
  function interactedStudentPasswordScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertOptionalInteractionDetails(properties.interactionDetails));
      messages = messages.concat(assertInvitationSource(properties.invitationSource));
      messages = messages.concat(assertPasswordType(properties.passwordType));
      messages = messages.concat(assertReferrerPage(properties.referrerPage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Student Password Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "clickedOn",
        "interactionDetails",
        "invitationSource",
        "passwordType",
        "referrerPage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "T60YokGM9bSZSfJfWBfB_", "ed0614c17481e4c356021d019645e6643d271dc6ddfd7c9e212090ac479263ef", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Student Password Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Clicked On": properties.clickedOn,
        "Interaction Details": properties.interactionDetails,
        "Invitation Source": properties.invitationSource,
        "Password Type": properties.passwordType,
        "Referrer Page": properties.referrerPage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("T60YokGM9bSZSfJfWBfB_", "Interacted Student Password Screen", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "cYVv-jM3n6", name: "Referrer Page", value: properties.referrerPage},
        {id: "cccDu2odc", name: "Invitation Source", value: properties.invitationSource},
        {id: "ltdeD9kflSPTHD993aqQW", name: "Password Type", value: properties.passwordType},
        {id: "ncdYto9gZ", name: "Interaction Details", value: properties.interactionDetails},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Student Password Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Student Password Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Clicked On": properties.clickedOn,
          "Interaction Details": properties.interactionDetails,
          "Invitation Source": properties.invitationSource,
          "Password Type": properties.passwordType,
          "Referrer Page": properties.referrerPage,
          "Screen Height": sysScreenHeight,
          }, "T60YokGM9bSZSfJfWBfB_", "ed0614c17481e4c356021d019645e6643d271dc6ddfd7c9e212090ac479263ef");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Student Password Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Clicked On": properties.clickedOn,
      "Interaction Details": properties.interactionDetails,
      "Invitation Source": properties.invitationSource,
      "Password Type": properties.passwordType,
      "Referrer Page": properties.referrerPage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Guest Student Login Successful: This event will get fired when classroom student logs in successfully to their account
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/VTS1R-aZ7rWPuDlDnfkRV/trigger/CpSEhi58Fzocu8Rfgm3Ot
   * 2. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/VTS1R-aZ7rWPuDlDnfkRV/trigger/4BI3JMj2vEavlzgDdHjeH
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.loginMethod - Returns the login method used by the ptl teacher/parent/student to login
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/VTS1R-aZ7rWPuDlDnfkRV}
   */
  function guestStudentLoginSuccessful(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertLoginMethod(properties.loginMethod));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Guest Student Login Successful", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "loginMethod"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "VTS1R-aZ7rWPuDlDnfkRV", "63b8c720e75145fdd5bf5df4d62db4bd58d4da82e32d5e8bf07a48b7f45030bb", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Guest Student Login Successful", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Login Method": properties.loginMethod,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("VTS1R-aZ7rWPuDlDnfkRV", "Guest Student Login Successful", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "RzhjpWea8R6s1FWo1fgS4", name: "Login Method", value: properties.loginMethod},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Guest Student Login Successful': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Guest Student Login Successful", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Login Method": properties.loginMethod,
          "Screen Height": sysScreenHeight,
          }, "VTS1R-aZ7rWPuDlDnfkRV", "63b8c720e75145fdd5bf5df4d62db4bd58d4da82e32d5e8bf07a48b7f45030bb");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Guest Student Login Successful", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Login Method": properties.loginMethod,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Guest Student Login Failed: This event will get fired when student is unable to login
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.loginMethod - Returns the login method used by the ptl teacher/parent/student to login
   * @param {string} properties.errorMessage - Error message shown to the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/416ryJkyFYkiI6CX5NLEj}
   */
  function guestStudentLoginFailed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertLoginMethod(properties.loginMethod));
      messages = messages.concat(assertErrorMessage(properties.errorMessage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Guest Student Login Failed", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "loginMethod",
        "errorMessage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "416ryJkyFYkiI6CX5NLEj", "56cff903033ddb9e106a97ed8b224f7912d432265acbe9ea784d5e9543005d8a", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Guest Student Login Failed", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Login Method": properties.loginMethod,
        "Error Message": properties.errorMessage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("416ryJkyFYkiI6CX5NLEj", "Guest Student Login Failed", messages, [
        {id: "1n3Bq4GKWy", name: "Error Message", value: properties.errorMessage},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "RzhjpWea8R6s1FWo1fgS4", name: "Login Method", value: properties.loginMethod},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Guest Student Login Failed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Guest Student Login Failed", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Login Method": properties.loginMethod,
          "Error Message": properties.errorMessage,
          "Screen Height": sysScreenHeight,
          }, "416ryJkyFYkiI6CX5NLEj", "56cff903033ddb9e106a97ed8b224f7912d432265acbe9ea784d5e9543005d8a");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Guest Student Login Failed", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Login Method": properties.loginMethod,
      "Error Message": properties.errorMessage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed PTL Parent Login Screen: This event will be fired when ptl parent is displayed the login screen on accessing home access setup link shared by the teacher
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/iEl8VXCEXU2a7YjWibxzp/trigger/2iinvkViDFfnpNPgSCX9x
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * @param {string} properties.ptlFlow - This will identify if the user is signing up for a PTL account/ Linking new student to their existing PTL account/ logging in for connected student
   * @param {string} properties.referrerPage - Shows the description of the previous page name/URL
   * @param {string} properties.invitationSource - This property returns the type of invite sent from the student roster page
   * @param {string} properties.linkedStudentCount - This property will return the count of students already linked with the PTL user attempting to signup or attempting to link new student
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/iEl8VXCEXU2a7YjWibxzp}
   */
  function viewedPtlParentLoginScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertPTLFlow(properties.ptlFlow));
      messages = messages.concat(assertReferrerPage(properties.referrerPage));
      messages = messages.concat(assertInvitationSource(properties.invitationSource));
      messages = messages.concat(assertLinkedStudentCount(properties.linkedStudentCount));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed PTL Parent Login Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "fromPage",
        "ptlFlow",
        "referrerPage",
        "invitationSource",
        "linkedStudentCount"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "iEl8VXCEXU2a7YjWibxzp", "5480643db5b06c0ed91379c26b6605cc601db76de50bd57ca66550315dd1260e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed PTL Parent Login Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "From Page": properties.fromPage,
        "PTL Flow": properties.ptlFlow,
        "Referrer Page": properties.referrerPage,
        "Invitation Source": properties.invitationSource,
        "Linked Student Count": properties.linkedStudentCount,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("iEl8VXCEXU2a7YjWibxzp", "Viewed PTL Parent Login Screen", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "LKpPivRaqhv1iRgHvCBQE", name: "PTL Flow", value: properties.ptlFlow},
        {id: "cYVv-jM3n6", name: "Referrer Page", value: properties.referrerPage},
        {id: "cccDu2odc", name: "Invitation Source", value: properties.invitationSource},
        {id: "eb8RBK1CZ_91zt06w-5iv", name: "Linked Student Count", value: properties.linkedStudentCount},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed PTL Parent Login Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed PTL Parent Login Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "From Page": properties.fromPage,
          "PTL Flow": properties.ptlFlow,
          "Referrer Page": properties.referrerPage,
          "Invitation Source": properties.invitationSource,
          "Linked Student Count": properties.linkedStudentCount,
          "Screen Height": sysScreenHeight,
          }, "iEl8VXCEXU2a7YjWibxzp", "5480643db5b06c0ed91379c26b6605cc601db76de50bd57ca66550315dd1260e");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed PTL Parent Login Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "From Page": properties.fromPage,
      "PTL Flow": properties.ptlFlow,
      "Referrer Page": properties.referrerPage,
      "Invitation Source": properties.invitationSource,
      "Linked Student Count": properties.linkedStudentCount,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted PTL Parent Login Screen: This event will be fired when ptl parent interacts with the login screen displayed on accessing home access setup link shared by the teacher
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/haMfV5i6Xulw68gpye2Hs/trigger/xh-IKWYqKxx8qR0PKxzDR
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} [properties.interactionDetails] - Stores where is the user interacting with the page
   * @param {string} properties.invitationSource - This property returns the type of invite sent from the student roster page
   * @param {string} properties.referrerPage - Shows the description of the previous page name/URL
   * @param {string} properties.linkedStudentCount - This property will return the count of students already linked with the PTL user attempting to signup or attempting to link new student
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/haMfV5i6Xulw68gpye2Hs}
   */
  function interactedPtlParentLoginScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertOptionalInteractionDetails(properties.interactionDetails));
      messages = messages.concat(assertInvitationSource(properties.invitationSource));
      messages = messages.concat(assertReferrerPage(properties.referrerPage));
      messages = messages.concat(assertLinkedStudentCount(properties.linkedStudentCount));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted PTL Parent Login Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "clickedOn",
        "interactionDetails",
        "invitationSource",
        "referrerPage",
        "linkedStudentCount"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "haMfV5i6Xulw68gpye2Hs", "5746d93b6bd0a1925afbff58649c6d95a7fb2209945e7a47ad91d0f455ab73b2", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted PTL Parent Login Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Clicked On": properties.clickedOn,
        "Interaction Details": properties.interactionDetails,
        "Invitation Source": properties.invitationSource,
        "Referrer Page": properties.referrerPage,
        "Linked Student Count": properties.linkedStudentCount,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("haMfV5i6Xulw68gpye2Hs", "Interacted PTL Parent Login Screen", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "cYVv-jM3n6", name: "Referrer Page", value: properties.referrerPage},
        {id: "cccDu2odc", name: "Invitation Source", value: properties.invitationSource},
        {id: "eb8RBK1CZ_91zt06w-5iv", name: "Linked Student Count", value: properties.linkedStudentCount},
        {id: "ncdYto9gZ", name: "Interaction Details", value: properties.interactionDetails},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted PTL Parent Login Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted PTL Parent Login Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Clicked On": properties.clickedOn,
          "Interaction Details": properties.interactionDetails,
          "Invitation Source": properties.invitationSource,
          "Referrer Page": properties.referrerPage,
          "Linked Student Count": properties.linkedStudentCount,
          "Screen Height": sysScreenHeight,
          }, "haMfV5i6Xulw68gpye2Hs", "5746d93b6bd0a1925afbff58649c6d95a7fb2209945e7a47ad91d0f455ab73b2");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted PTL Parent Login Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Clicked On": properties.clickedOn,
      "Interaction Details": properties.interactionDetails,
      "Invitation Source": properties.invitationSource,
      "Referrer Page": properties.referrerPage,
      "Linked Student Count": properties.linkedStudentCount,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * PTL Parent Login Attempted: This event will get fired when user clicks on the login button on parent login screen/submit button on login via OTP screen/ 'Login with OTP' button on control flow
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/c9fc0hmHiE6wiZZjrIgKR/trigger/Zqag0OwxKmGHu01IvDLOe
   * 2. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/c9fc0hmHiE6wiZZjrIgKR/trigger/EzVkZzJnvDwzTCiF82d7u
   * 3. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/c9fc0hmHiE6wiZZjrIgKR/trigger/6CwzPcqGbf0to6TxzXzOn
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.referrerPage - Shows the description of the previous page name/URL
   * @param {string} properties.invitationSource - This property returns the type of invite sent from the student roster page
   * @param {string} properties.linkedStudentCount - This property will return the count of students already linked with the PTL user attempting to signup or attempting to link new student
   * @param {string} properties.loginMethod - Returns the login method used by the ptl teacher/parent/student to login
   * @param {string} properties.isEmailUpdated - This property will return 1 if ptl parent updates email on the login screen or the reset password screen and 0 otherwise
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/c9fc0hmHiE6wiZZjrIgKR}
   */
  function ptlParentLoginAttempted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertReferrerPage(properties.referrerPage));
      messages = messages.concat(assertInvitationSource(properties.invitationSource));
      messages = messages.concat(assertLinkedStudentCount(properties.linkedStudentCount));
      messages = messages.concat(assertLoginMethod(properties.loginMethod));
      messages = messages.concat(assertIsEmailUpdated(properties.isEmailUpdated));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("PTL Parent Login Attempted", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "referrerPage",
        "invitationSource",
        "linkedStudentCount",
        "loginMethod",
        "isEmailUpdated"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "c9fc0hmHiE6wiZZjrIgKR", "7a5f6337ce4e17df4e045a325baaa71ce4bd0905e37f3fec85f5b5dfbd8473f9", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("PTL Parent Login Attempted", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Referrer Page": properties.referrerPage,
        "Invitation Source": properties.invitationSource,
        "Linked Student Count": properties.linkedStudentCount,
        "Login Method": properties.loginMethod,
        "Is Email Updated": properties.isEmailUpdated,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("c9fc0hmHiE6wiZZjrIgKR", "PTL Parent Login Attempted", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "RzhjpWea8R6s1FWo1fgS4", name: "Login Method", value: properties.loginMethod},
        {id: "UgsrIrCRxEEZ_LjtRRk8N", name: "Is Email Updated", value: properties.isEmailUpdated},
        {id: "cYVv-jM3n6", name: "Referrer Page", value: properties.referrerPage},
        {id: "cccDu2odc", name: "Invitation Source", value: properties.invitationSource},
        {id: "eb8RBK1CZ_91zt06w-5iv", name: "Linked Student Count", value: properties.linkedStudentCount},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'PTL Parent Login Attempted': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("PTL Parent Login Attempted", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Referrer Page": properties.referrerPage,
          "Invitation Source": properties.invitationSource,
          "Linked Student Count": properties.linkedStudentCount,
          "Login Method": properties.loginMethod,
          "Is Email Updated": properties.isEmailUpdated,
          "Screen Height": sysScreenHeight,
          }, "c9fc0hmHiE6wiZZjrIgKR", "7a5f6337ce4e17df4e045a325baaa71ce4bd0905e37f3fec85f5b5dfbd8473f9");
      }
      // destination CustomDestination
      CustomDestination.logEvent("PTL Parent Login Attempted", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Referrer Page": properties.referrerPage,
      "Invitation Source": properties.invitationSource,
      "Linked Student Count": properties.linkedStudentCount,
      "Login Method": properties.loginMethod,
      "Is Email Updated": properties.isEmailUpdated,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * PTL Parent Login Successful: This event will get fired only when existing PTL parent's login attempt from the teacher shared set up home access link is successful
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/wZsU3UCs4NnOS8gIOrUIj/trigger/LqDmkp1Kp6sJWvEn4VNcb
   * 2. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/wZsU3UCs4NnOS8gIOrUIj/trigger/vy790bjtY9pwVOEGcDANE
   * 3. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/wZsU3UCs4NnOS8gIOrUIj/trigger/A4TaAPo1Lj7vryocDFOVQ
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.referrerPage - Shows the description of the previous page name/URL
   * @param {string} properties.invitationSource - This property returns the type of invite sent from the student roster page
   * @param {string} properties.linkedStudentCount - This property will return the count of students already linked with the PTL user attempting to signup or attempting to link new student
   * @param {string} properties.loginMethod - Returns the login method used by the ptl teacher/parent/student to login
   * @param {string} properties.isEmailUpdated - This property will return 1 if ptl parent updates email on the login screen or the reset password screen and 0 otherwise
   * @param {string} properties.ptlSignupFlowSegmentName - This property will differentiate between control and variant version of teacher invited PTL signup/login flow. Expected values will be 'Variant' or 'Control'
   * @param {string} properties.teacherSignupDate - This property will return the date teacher has signed up on the product
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/wZsU3UCs4NnOS8gIOrUIj}
   */
  function ptlParentLoginSuccessful(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertReferrerPage(properties.referrerPage));
      messages = messages.concat(assertInvitationSource(properties.invitationSource));
      messages = messages.concat(assertLinkedStudentCount(properties.linkedStudentCount));
      messages = messages.concat(assertLoginMethod(properties.loginMethod));
      messages = messages.concat(assertIsEmailUpdated(properties.isEmailUpdated));
      messages = messages.concat(assertPTLSignupFlowSegmentName(properties.ptlSignupFlowSegmentName));
      messages = messages.concat(assertTeacherSignupDate(properties.teacherSignupDate));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("PTL Parent Login Successful", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "referrerPage",
        "invitationSource",
        "linkedStudentCount",
        "loginMethod",
        "isEmailUpdated",
        "ptlSignupFlowSegmentName",
        "teacherSignupDate"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "wZsU3UCs4NnOS8gIOrUIj", "09a9da5e75783ddbcfb055ce52bfa64ffc35b193ca3ab6cadb2d20c527cde5db", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("PTL Parent Login Successful", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Referrer Page": properties.referrerPage,
        "Invitation Source": properties.invitationSource,
        "Linked Student Count": properties.linkedStudentCount,
        "Login Method": properties.loginMethod,
        "Is Email Updated": properties.isEmailUpdated,
        "PTL Signup Flow Segment Name": properties.ptlSignupFlowSegmentName,
        "Teacher Signup Date": properties.teacherSignupDate,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("wZsU3UCs4NnOS8gIOrUIj", "PTL Parent Login Successful", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "L3Bn5aQc2GJb6e2NuVU3C", name: "Teacher Signup Date", value: properties.teacherSignupDate},
        {id: "RzhjpWea8R6s1FWo1fgS4", name: "Login Method", value: properties.loginMethod},
        {id: "UgsrIrCRxEEZ_LjtRRk8N", name: "Is Email Updated", value: properties.isEmailUpdated},
        {id: "bD4JrEqtTf4IACKroNfTR", name: "PTL Signup Flow Segment Name", value: properties.ptlSignupFlowSegmentName},
        {id: "cYVv-jM3n6", name: "Referrer Page", value: properties.referrerPage},
        {id: "cccDu2odc", name: "Invitation Source", value: properties.invitationSource},
        {id: "eb8RBK1CZ_91zt06w-5iv", name: "Linked Student Count", value: properties.linkedStudentCount},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'PTL Parent Login Successful': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("PTL Parent Login Successful", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Referrer Page": properties.referrerPage,
          "Invitation Source": properties.invitationSource,
          "Linked Student Count": properties.linkedStudentCount,
          "Login Method": properties.loginMethod,
          "Is Email Updated": properties.isEmailUpdated,
          "PTL Signup Flow Segment Name": properties.ptlSignupFlowSegmentName,
          "Teacher Signup Date": properties.teacherSignupDate,
          "Screen Height": sysScreenHeight,
          }, "wZsU3UCs4NnOS8gIOrUIj", "09a9da5e75783ddbcfb055ce52bfa64ffc35b193ca3ab6cadb2d20c527cde5db");
      }
      // destination CustomDestination
      CustomDestination.logEvent("PTL Parent Login Successful", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Referrer Page": properties.referrerPage,
      "Invitation Source": properties.invitationSource,
      "Linked Student Count": properties.linkedStudentCount,
      "Login Method": properties.loginMethod,
      "Is Email Updated": properties.isEmailUpdated,
      "PTL Signup Flow Segment Name": properties.ptlSignupFlowSegmentName,
      "Teacher Signup Date": properties.teacherSignupDate,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * PTL Parent Login Failed: This event will get fired when user inputs incorrect password or OTP when attempting to login via teacher shared home access setup links
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/nGD0nuGxxUVgxpUomduW1/trigger/IhyM7vdciXOZJQLEnHn3j
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.invitationSource - This property returns the type of invite sent from the student roster page
   * @param {string} properties.referrerPage - Shows the description of the previous page name/URL
   * @param {string} properties.linkedStudentCount - This property will return the count of students already linked with the PTL user attempting to signup or attempting to link new student
   * @param {string} properties.loginMethod - Returns the login method used by the ptl teacher/parent/student to login
   * @param {string} properties.isEmailUpdated - This property will return 1 if ptl parent updates email on the login screen or the reset password screen and 0 otherwise
   * @param {string} properties.errorMessage - Error message shown to the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/nGD0nuGxxUVgxpUomduW1}
   */
  function ptlParentLoginFailed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertInvitationSource(properties.invitationSource));
      messages = messages.concat(assertReferrerPage(properties.referrerPage));
      messages = messages.concat(assertLinkedStudentCount(properties.linkedStudentCount));
      messages = messages.concat(assertLoginMethod(properties.loginMethod));
      messages = messages.concat(assertIsEmailUpdated(properties.isEmailUpdated));
      messages = messages.concat(assertErrorMessage(properties.errorMessage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("PTL Parent Login Failed", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "invitationSource",
        "referrerPage",
        "linkedStudentCount",
        "loginMethod",
        "isEmailUpdated",
        "errorMessage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "nGD0nuGxxUVgxpUomduW1", "952c556c4191fce51cbd797b10d5f4c1281c0d1591e8291eb5c94b968a669103", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("PTL Parent Login Failed", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Invitation Source": properties.invitationSource,
        "Referrer Page": properties.referrerPage,
        "Linked Student Count": properties.linkedStudentCount,
        "Login Method": properties.loginMethod,
        "Is Email Updated": properties.isEmailUpdated,
        "Error Message": properties.errorMessage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("nGD0nuGxxUVgxpUomduW1", "PTL Parent Login Failed", messages, [
        {id: "1n3Bq4GKWy", name: "Error Message", value: properties.errorMessage},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "RzhjpWea8R6s1FWo1fgS4", name: "Login Method", value: properties.loginMethod},
        {id: "UgsrIrCRxEEZ_LjtRRk8N", name: "Is Email Updated", value: properties.isEmailUpdated},
        {id: "cYVv-jM3n6", name: "Referrer Page", value: properties.referrerPage},
        {id: "cccDu2odc", name: "Invitation Source", value: properties.invitationSource},
        {id: "eb8RBK1CZ_91zt06w-5iv", name: "Linked Student Count", value: properties.linkedStudentCount},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'PTL Parent Login Failed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("PTL Parent Login Failed", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Invitation Source": properties.invitationSource,
          "Referrer Page": properties.referrerPage,
          "Linked Student Count": properties.linkedStudentCount,
          "Login Method": properties.loginMethod,
          "Is Email Updated": properties.isEmailUpdated,
          "Error Message": properties.errorMessage,
          "Screen Height": sysScreenHeight,
          }, "nGD0nuGxxUVgxpUomduW1", "952c556c4191fce51cbd797b10d5f4c1281c0d1591e8291eb5c94b968a669103");
      }
      // destination CustomDestination
      CustomDestination.logEvent("PTL Parent Login Failed", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Invitation Source": properties.invitationSource,
      "Referrer Page": properties.referrerPage,
      "Linked Student Count": properties.linkedStudentCount,
      "Login Method": properties.loginMethod,
      "Is Email Updated": properties.isEmailUpdated,
      "Error Message": properties.errorMessage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Reset Password Screen: This event will get fired when user is displayed the forgot password screen
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/2lZdUgHrS40fmfdZ1qWjv/trigger/eIt8ALN5BtwGc4YqOGDWR
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.invitationSource - This property returns the type of invite sent from the student roster page
   * @param {string} properties.referrerPage - Shows the description of the previous page name/URL
   * @param {string} properties.linkedStudentCount - This property will return the count of students already linked with the PTL user attempting to signup or attempting to link new student
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/2lZdUgHrS40fmfdZ1qWjv}
   */
  function viewedResetPasswordScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertInvitationSource(properties.invitationSource));
      messages = messages.concat(assertReferrerPage(properties.referrerPage));
      messages = messages.concat(assertLinkedStudentCount(properties.linkedStudentCount));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Reset Password Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "invitationSource",
        "referrerPage",
        "linkedStudentCount"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "2lZdUgHrS40fmfdZ1qWjv", "7de52741a806d44abaa18732856f2656d65ee8bca30ce3b66262c08426b396cb", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Reset Password Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Invitation Source": properties.invitationSource,
        "Referrer Page": properties.referrerPage,
        "Linked Student Count": properties.linkedStudentCount,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("2lZdUgHrS40fmfdZ1qWjv", "Viewed Reset Password Screen", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "cYVv-jM3n6", name: "Referrer Page", value: properties.referrerPage},
        {id: "cccDu2odc", name: "Invitation Source", value: properties.invitationSource},
        {id: "eb8RBK1CZ_91zt06w-5iv", name: "Linked Student Count", value: properties.linkedStudentCount},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Reset Password Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Reset Password Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Invitation Source": properties.invitationSource,
          "Referrer Page": properties.referrerPage,
          "Linked Student Count": properties.linkedStudentCount,
          "Screen Height": sysScreenHeight,
          }, "2lZdUgHrS40fmfdZ1qWjv", "7de52741a806d44abaa18732856f2656d65ee8bca30ce3b66262c08426b396cb");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Reset Password Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Invitation Source": properties.invitationSource,
      "Referrer Page": properties.referrerPage,
      "Linked Student Count": properties.linkedStudentCount,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Reset Password Screen: This event will get fired when user interacts with the reset password page 
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/8TN3f0K5e-M2FV2bHjSG3/trigger/kXhsecEcxki-vScEN9-76
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.isEmailUpdated - This property will return 1 if ptl parent updates email on the login screen or the reset password screen and 0 otherwise
   * @param {string} properties.interactionDetails - Stores where is the user interacting with the page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/8TN3f0K5e-M2FV2bHjSG3}
   */
  function interactedResetPasswordScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertIsEmailUpdated(properties.isEmailUpdated));
      messages = messages.concat(assertInteractionDetails(properties.interactionDetails));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Reset Password Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "clickedOn",
        "isEmailUpdated",
        "interactionDetails"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "8TN3f0K5e-M2FV2bHjSG3", "e463d5d6a6289e1229a57335bef3cd500c2504d094f3f6f9144dce00f6da5a10", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Reset Password Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Clicked On": properties.clickedOn,
        "Is Email Updated": properties.isEmailUpdated,
        "Interaction Details": properties.interactionDetails,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("8TN3f0K5e-M2FV2bHjSG3", "Interacted Reset Password Screen", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "UgsrIrCRxEEZ_LjtRRk8N", name: "Is Email Updated", value: properties.isEmailUpdated},
        {id: "ncdYto9gZ", name: "Interaction Details", value: properties.interactionDetails},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Reset Password Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Reset Password Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Clicked On": properties.clickedOn,
          "Is Email Updated": properties.isEmailUpdated,
          "Interaction Details": properties.interactionDetails,
          "Screen Height": sysScreenHeight,
          }, "8TN3f0K5e-M2FV2bHjSG3", "e463d5d6a6289e1229a57335bef3cd500c2504d094f3f6f9144dce00f6da5a10");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Reset Password Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Clicked On": properties.clickedOn,
      "Is Email Updated": properties.isEmailUpdated,
      "Interaction Details": properties.interactionDetails,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Change Password Screen: This event will get fired when user reaches the change password screen after email verification via otp
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/KjwFH-NAQ_KfQ0bCDOoDk/trigger/nQz1fUCRwDHxtL5kwmzLb
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.referrerPage - Shows the description of the previous page name/URL
   * @param {string} properties.invitationSource - This property returns the type of invite sent from the student roster page
   * @param {string} properties.linkedStudentCount - This property will return the count of students already linked with the PTL user attempting to signup or attempting to link new student
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/KjwFH-NAQ_KfQ0bCDOoDk}
   */
  function viewedChangePasswordScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertReferrerPage(properties.referrerPage));
      messages = messages.concat(assertInvitationSource(properties.invitationSource));
      messages = messages.concat(assertLinkedStudentCount(properties.linkedStudentCount));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Change Password Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "referrerPage",
        "invitationSource",
        "linkedStudentCount"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "KjwFH-NAQ_KfQ0bCDOoDk", "39475934c26d8203ed8acbd8f44afdba67a3e0ac97118950b72179882a39431e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Change Password Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Referrer Page": properties.referrerPage,
        "Invitation Source": properties.invitationSource,
        "Linked Student Count": properties.linkedStudentCount,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("KjwFH-NAQ_KfQ0bCDOoDk", "Viewed Change Password Screen", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "cYVv-jM3n6", name: "Referrer Page", value: properties.referrerPage},
        {id: "cccDu2odc", name: "Invitation Source", value: properties.invitationSource},
        {id: "eb8RBK1CZ_91zt06w-5iv", name: "Linked Student Count", value: properties.linkedStudentCount},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Change Password Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Change Password Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Referrer Page": properties.referrerPage,
          "Invitation Source": properties.invitationSource,
          "Linked Student Count": properties.linkedStudentCount,
          "Screen Height": sysScreenHeight,
          }, "KjwFH-NAQ_KfQ0bCDOoDk", "39475934c26d8203ed8acbd8f44afdba67a3e0ac97118950b72179882a39431e");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Change Password Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Referrer Page": properties.referrerPage,
      "Invitation Source": properties.invitationSource,
      "Linked Student Count": properties.linkedStudentCount,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Change Password Screen: This event will get fired when user interacts with the change password screen
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/hdw3HPnu2bPPhEwbXT22H/trigger/0oMDQeVbSe_FAgX4zzhcl
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.interactionDetails - Stores where is the user interacting with the page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/hdw3HPnu2bPPhEwbXT22H}
   */
  function interactedChangePasswordScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertInteractionDetails(properties.interactionDetails));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Change Password Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "clickedOn",
        "interactionDetails"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "hdw3HPnu2bPPhEwbXT22H", "2b98cac5cc9d984b895edf7c97fd53dffbc5693388ac2dd0f151dfaa0910f0e0", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Change Password Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Clicked On": properties.clickedOn,
        "Interaction Details": properties.interactionDetails,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("hdw3HPnu2bPPhEwbXT22H", "Interacted Change Password Screen", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "ncdYto9gZ", name: "Interaction Details", value: properties.interactionDetails},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Change Password Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Change Password Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Clicked On": properties.clickedOn,
          "Interaction Details": properties.interactionDetails,
          "Screen Height": sysScreenHeight,
          }, "hdw3HPnu2bPPhEwbXT22H", "2b98cac5cc9d984b895edf7c97fd53dffbc5693388ac2dd0f151dfaa0910f0e0");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Change Password Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Clicked On": properties.clickedOn,
      "Interaction Details": properties.interactionDetails,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Password Reset Successful Popup: This event will get fired when user is displayed the password reset successful popup when ptl parent succesfully updates their password via the teacher invited login flow
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/V6OgbUcltJz1MjPRLU0lB/trigger/4Ld0wJpOd5Xbncpt1vUpG
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.linkedStudentCount - This property will return the count of students already linked with the PTL user attempting to signup or attempting to link new student
   * @param {string} properties.invitationSource - This property returns the type of invite sent from the student roster page
   * @param {string} properties.referrerPage - Shows the description of the previous page name/URL
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/V6OgbUcltJz1MjPRLU0lB}
   */
  function viewedPasswordResetSuccessfulPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertLinkedStudentCount(properties.linkedStudentCount));
      messages = messages.concat(assertInvitationSource(properties.invitationSource));
      messages = messages.concat(assertReferrerPage(properties.referrerPage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Password Reset Successful Popup", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "linkedStudentCount",
        "invitationSource",
        "referrerPage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "V6OgbUcltJz1MjPRLU0lB", "761e77603c0f8ebbfe8706a091179255671443c3c5ed5d16fb6abb97959b0a9b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Password Reset Successful Popup", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Linked Student Count": properties.linkedStudentCount,
        "Invitation Source": properties.invitationSource,
        "Referrer Page": properties.referrerPage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("V6OgbUcltJz1MjPRLU0lB", "Viewed Password Reset Successful Popup", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "cYVv-jM3n6", name: "Referrer Page", value: properties.referrerPage},
        {id: "cccDu2odc", name: "Invitation Source", value: properties.invitationSource},
        {id: "eb8RBK1CZ_91zt06w-5iv", name: "Linked Student Count", value: properties.linkedStudentCount},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Password Reset Successful Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Password Reset Successful Popup", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Linked Student Count": properties.linkedStudentCount,
          "Invitation Source": properties.invitationSource,
          "Referrer Page": properties.referrerPage,
          "Screen Height": sysScreenHeight,
          }, "V6OgbUcltJz1MjPRLU0lB", "761e77603c0f8ebbfe8706a091179255671443c3c5ed5d16fb6abb97959b0a9b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Password Reset Successful Popup", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Linked Student Count": properties.linkedStudentCount,
      "Invitation Source": properties.invitationSource,
      "Referrer Page": properties.referrerPage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Add/Replace Student Profile Screen: This event will get fired when a parent reaches the add student as new profile/replace student profile screen
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/xFCDViwXga3KtbjcMPsB8/trigger/r0jd1Sd_A4CeT_jFFDuXf
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.linkedStudentCount - This property will return the count of students already linked with the PTL user attempting to signup or attempting to link new student
   * @param {string} properties.invitationSource - This property returns the type of invite sent from the student roster page
   * @param {string} properties.referrerPage - Shows the description of the previous page name/URL
   * @param {Array<string>} properties.optionsViewed - Array of all the options the user sees on the screen for a particular question
   * @param {string} properties.ptlSignupFlowSegmentName - This property will differentiate between control and variant version of teacher invited PTL signup/login flow. Expected values will be 'Variant' or 'Control'
   * @param {string} properties.teacherSignupDate - This property will return the date teacher has signed up on the product
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/xFCDViwXga3KtbjcMPsB8}
   */
  function viewedAddreplaceStudentProfileScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertLinkedStudentCount(properties.linkedStudentCount));
      messages = messages.concat(assertInvitationSource(properties.invitationSource));
      messages = messages.concat(assertReferrerPage(properties.referrerPage));
      messages = messages.concat(assertOptionsViewed(properties.optionsViewed));
      messages = messages.concat(assertPTLSignupFlowSegmentName(properties.ptlSignupFlowSegmentName));
      messages = messages.concat(assertTeacherSignupDate(properties.teacherSignupDate));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Add/Replace Student Profile Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "linkedStudentCount",
        "invitationSource",
        "referrerPage",
        "optionsViewed",
        "ptlSignupFlowSegmentName",
        "teacherSignupDate"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "xFCDViwXga3KtbjcMPsB8", "cb3022d14862ec6f78b4ee03e9fa1478ce47e362e4f6277a9cfdac0154c2360f", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Add/Replace Student Profile Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Linked Student Count": properties.linkedStudentCount,
        "Invitation Source": properties.invitationSource,
        "Referrer Page": properties.referrerPage,
        "Options Viewed": properties.optionsViewed,
        "PTL Signup Flow Segment Name": properties.ptlSignupFlowSegmentName,
        "Teacher Signup Date": properties.teacherSignupDate,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("xFCDViwXga3KtbjcMPsB8", "Viewed Add/Replace Student Profile Screen", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "L3Bn5aQc2GJb6e2NuVU3C", name: "Teacher Signup Date", value: properties.teacherSignupDate},
        {id: "bD4JrEqtTf4IACKroNfTR", name: "PTL Signup Flow Segment Name", value: properties.ptlSignupFlowSegmentName},
        {id: "cYVv-jM3n6", name: "Referrer Page", value: properties.referrerPage},
        {id: "cccDu2odc", name: "Invitation Source", value: properties.invitationSource},
        {id: "eb8RBK1CZ_91zt06w-5iv", name: "Linked Student Count", value: properties.linkedStudentCount},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xHPp8yOuv", name: "Options Viewed", value: properties.optionsViewed},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Add/Replace Student Profile Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Add/Replace Student Profile Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Linked Student Count": properties.linkedStudentCount,
          "Invitation Source": properties.invitationSource,
          "Referrer Page": properties.referrerPage,
          "Options Viewed": properties.optionsViewed,
          "PTL Signup Flow Segment Name": properties.ptlSignupFlowSegmentName,
          "Teacher Signup Date": properties.teacherSignupDate,
          "Screen Height": sysScreenHeight,
          }, "xFCDViwXga3KtbjcMPsB8", "cb3022d14862ec6f78b4ee03e9fa1478ce47e362e4f6277a9cfdac0154c2360f");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Add/Replace Student Profile Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Linked Student Count": properties.linkedStudentCount,
      "Invitation Source": properties.invitationSource,
      "Referrer Page": properties.referrerPage,
      "Options Viewed": properties.optionsViewed,
      "PTL Signup Flow Segment Name": properties.ptlSignupFlowSegmentName,
      "Teacher Signup Date": properties.teacherSignupDate,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Add/Replace Student Profile Screen: This event will get fired when user interacts with the options available on this screen
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/OvpSigj6kkNrF36s52p6o/trigger/jhzSr2TGmIdNEDWBEHvV1
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.invitationSource - This property returns the type of invite sent from the student roster page
   * @param {string} properties.referrerPage - Shows the description of the previous page name/URL
   * @param {string} properties.linkedStudentCount - This property will return the count of students already linked with the PTL user attempting to signup or attempting to link new student
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/OvpSigj6kkNrF36s52p6o}
   */
  function interactedAddreplaceStudentProfileScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertInvitationSource(properties.invitationSource));
      messages = messages.concat(assertReferrerPage(properties.referrerPage));
      messages = messages.concat(assertLinkedStudentCount(properties.linkedStudentCount));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Add/Replace Student Profile Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "clickedOn",
        "invitationSource",
        "referrerPage",
        "linkedStudentCount"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "OvpSigj6kkNrF36s52p6o", "cb7cbd4fb216f97e22e86addcb879f0eb9751a2ba2eaaf04b80ae426ee48af08", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Add/Replace Student Profile Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Clicked On": properties.clickedOn,
        "Invitation Source": properties.invitationSource,
        "Referrer Page": properties.referrerPage,
        "Linked Student Count": properties.linkedStudentCount,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("OvpSigj6kkNrF36s52p6o", "Interacted Add/Replace Student Profile Screen", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "cYVv-jM3n6", name: "Referrer Page", value: properties.referrerPage},
        {id: "cccDu2odc", name: "Invitation Source", value: properties.invitationSource},
        {id: "eb8RBK1CZ_91zt06w-5iv", name: "Linked Student Count", value: properties.linkedStudentCount},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Add/Replace Student Profile Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Add/Replace Student Profile Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Clicked On": properties.clickedOn,
          "Invitation Source": properties.invitationSource,
          "Referrer Page": properties.referrerPage,
          "Linked Student Count": properties.linkedStudentCount,
          "Screen Height": sysScreenHeight,
          }, "OvpSigj6kkNrF36s52p6o", "cb7cbd4fb216f97e22e86addcb879f0eb9751a2ba2eaaf04b80ae426ee48af08");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Add/Replace Student Profile Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Clicked On": properties.clickedOn,
      "Invitation Source": properties.invitationSource,
      "Referrer Page": properties.referrerPage,
      "Linked Student Count": properties.linkedStudentCount,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed PTL Student Linked Successfully Popup: This event will get fired when user is displayed the student linked successfully popup
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Jx998aCidfKQn8F4Q-hbW/trigger/DJlMNAcxtAVoY-p_-CWnF
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.invitationSource - This property returns the type of invite sent from the student roster page
   * @param {string} properties.referrerPage - Shows the description of the previous page name/URL
   * @param {string} properties.linkedStudentCount - This property will return the count of students already linked with the PTL user attempting to signup or attempting to link new student
   * @param {Array<string>} properties.optionsSelected - Array to save all of the options the user selects
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Jx998aCidfKQn8F4Q-hbW}
   */
  function viewedPtlStudentLinkedSuccessfullyPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertInvitationSource(properties.invitationSource));
      messages = messages.concat(assertReferrerPage(properties.referrerPage));
      messages = messages.concat(assertLinkedStudentCount(properties.linkedStudentCount));
      messages = messages.concat(assertOptionsSelected(properties.optionsSelected));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed PTL Student Linked Successfully Popup", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "invitationSource",
        "referrerPage",
        "linkedStudentCount",
        "optionsSelected"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Jx998aCidfKQn8F4Q-hbW", "a5e94918c1ab5fc2ab2e7e77ed758b5075d2c5925a72fefcbc4dd5637c518f98", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed PTL Student Linked Successfully Popup", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Invitation Source": properties.invitationSource,
        "Referrer Page": properties.referrerPage,
        "Linked Student Count": properties.linkedStudentCount,
        "Options Selected": properties.optionsSelected,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Jx998aCidfKQn8F4Q-hbW", "Viewed PTL Student Linked Successfully Popup", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "FZg42lPcF", name: "Options Selected", value: properties.optionsSelected},
        {id: "cYVv-jM3n6", name: "Referrer Page", value: properties.referrerPage},
        {id: "cccDu2odc", name: "Invitation Source", value: properties.invitationSource},
        {id: "eb8RBK1CZ_91zt06w-5iv", name: "Linked Student Count", value: properties.linkedStudentCount},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed PTL Student Linked Successfully Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed PTL Student Linked Successfully Popup", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Invitation Source": properties.invitationSource,
          "Referrer Page": properties.referrerPage,
          "Linked Student Count": properties.linkedStudentCount,
          "Options Selected": properties.optionsSelected,
          "Screen Height": sysScreenHeight,
          }, "Jx998aCidfKQn8F4Q-hbW", "a5e94918c1ab5fc2ab2e7e77ed758b5075d2c5925a72fefcbc4dd5637c518f98");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed PTL Student Linked Successfully Popup", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Invitation Source": properties.invitationSource,
      "Referrer Page": properties.referrerPage,
      "Linked Student Count": properties.linkedStudentCount,
      "Options Selected": properties.optionsSelected,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Account Exists Intimation Screen: This event will get fired when an existing parent logs in successfully via the copy link invite flow and lands on account exists intimation screen
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/KEDJmoFj_rPFzlVml85Mj/trigger/4hxFZhEpy9zaxMCE9IBDK
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.invitationSource - This property returns the type of invite sent from the student roster page
   * @param {string} properties.referrerPage - Shows the description of the previous page name/URL
   * @param {string} properties.linkedStudentCount - This property will return the count of students already linked with the PTL user attempting to signup or attempting to link new student
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/KEDJmoFj_rPFzlVml85Mj}
   */
  function viewedAccountExistsIntimationScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertInvitationSource(properties.invitationSource));
      messages = messages.concat(assertReferrerPage(properties.referrerPage));
      messages = messages.concat(assertLinkedStudentCount(properties.linkedStudentCount));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Account Exists Intimation Screen", Object.keys(properties), [
        "mathGrade",
        "mode",
        "platform",
        "userType",
        "signupFlow",
        "invitationSource",
        "referrerPage",
        "linkedStudentCount"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "KEDJmoFj_rPFzlVml85Mj", "e67e91b21f45272421a6de233cb6cfe207e0bbe832d02b3db63bfb3e62a4d162", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Account Exists Intimation Screen", {
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Invitation Source": properties.invitationSource,
        "Referrer Page": properties.referrerPage,
        "Linked Student Count": properties.linkedStudentCount,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("KEDJmoFj_rPFzlVml85Mj", "Viewed Account Exists Intimation Screen", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "cYVv-jM3n6", name: "Referrer Page", value: properties.referrerPage},
        {id: "cccDu2odc", name: "Invitation Source", value: properties.invitationSource},
        {id: "eb8RBK1CZ_91zt06w-5iv", name: "Linked Student Count", value: properties.linkedStudentCount},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Account Exists Intimation Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Account Exists Intimation Screen", {
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Invitation Source": properties.invitationSource,
          "Referrer Page": properties.referrerPage,
          "Linked Student Count": properties.linkedStudentCount,
          "Screen Height": sysScreenHeight,
          }, "KEDJmoFj_rPFzlVml85Mj", "e67e91b21f45272421a6de233cb6cfe207e0bbe832d02b3db63bfb3e62a4d162");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Account Exists Intimation Screen", {
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Invitation Source": properties.invitationSource,
      "Referrer Page": properties.referrerPage,
      "Linked Student Count": properties.linkedStudentCount,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted PTL Account Exists Intimation Screen: This event will get fired when parent clicks continue or create new account on the ptl accounts exists screen
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/6JgPuwyCbSegsccvQolgs/trigger/DR0ojyqhZNfoGscI9_df9
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.invitationSource - This property returns the type of invite sent from the student roster page
   * @param {string} properties.referrerPage - Shows the description of the previous page name/URL
   * @param {string} properties.linkedStudentCount - This property will return the count of students already linked with the PTL user attempting to signup or attempting to link new student
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/6JgPuwyCbSegsccvQolgs}
   */
  function interactedPtlAccountExistsIntimationScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertInvitationSource(properties.invitationSource));
      messages = messages.concat(assertReferrerPage(properties.referrerPage));
      messages = messages.concat(assertLinkedStudentCount(properties.linkedStudentCount));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted PTL Account Exists Intimation Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "invitationSource",
        "referrerPage",
        "linkedStudentCount",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "6JgPuwyCbSegsccvQolgs", "23e9e41df46aff726a101913c831aa49466eba494f67ef934aa2262a32fec08b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted PTL Account Exists Intimation Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Invitation Source": properties.invitationSource,
        "Referrer Page": properties.referrerPage,
        "Linked Student Count": properties.linkedStudentCount,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("6JgPuwyCbSegsccvQolgs", "Interacted PTL Account Exists Intimation Screen", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "cYVv-jM3n6", name: "Referrer Page", value: properties.referrerPage},
        {id: "cccDu2odc", name: "Invitation Source", value: properties.invitationSource},
        {id: "eb8RBK1CZ_91zt06w-5iv", name: "Linked Student Count", value: properties.linkedStudentCount},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted PTL Account Exists Intimation Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted PTL Account Exists Intimation Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Invitation Source": properties.invitationSource,
          "Referrer Page": properties.referrerPage,
          "Linked Student Count": properties.linkedStudentCount,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "6JgPuwyCbSegsccvQolgs", "23e9e41df46aff726a101913c831aa49466eba494f67ef934aa2262a32fec08b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted PTL Account Exists Intimation Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Invitation Source": properties.invitationSource,
      "Referrer Page": properties.referrerPage,
      "Linked Student Count": properties.linkedStudentCount,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Payment Method Screen: User lands on the m-web specific screen where they select the payment method
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/tUE8xiKqy3_Yn-Wefk-Yy/trigger/VoZfXLsAwmvamV9zBwzmT
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {string} properties.tabCode - Specifies the tab which has been opened in the event 'Viewed Tiled Dashboard' and Other events too
   * @param {string} properties.purchaseClickId - Unique ID associated with each purchase flow. Gets reset when the user exits the purchase flowing (irrespective of successful or unsuccessful purchase)
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/tUE8xiKqy3_Yn-Wefk-Yy}
   */
  function viewedPaymentMethodScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertTabCode(properties.tabCode));
      messages = messages.concat(assertPurchaseClickID(properties.purchaseClickId));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Payment Method Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "grade",
        "elaGrade",
        "mathGrade",
        "mode",
        "from",
        "tabCode",
        "purchaseClickId"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "tUE8xiKqy3_Yn-Wefk-Yy", "92c88318588e61a6c8b74733a6a82993c20ffdbb174d82b3b30ee5e56bbc495c", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Payment Method Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "From": properties.from,
        "Tab Code": properties.tabCode,
        "Purchase Click ID": properties.purchaseClickId,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("tUE8xiKqy3_Yn-Wefk-Yy", "Viewed Payment Method Screen", messages, [
        {id: "1sxa4mA1P", name: "Purchase Click ID", value: properties.purchaseClickId},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "l9PbANZBu", name: "Tab Code", value: properties.tabCode},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Payment Method Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Payment Method Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "From": properties.from,
          "Tab Code": properties.tabCode,
          "Purchase Click ID": properties.purchaseClickId,
          "Screen Height": sysScreenHeight,
          }, "tUE8xiKqy3_Yn-Wefk-Yy", "92c88318588e61a6c8b74733a6a82993c20ffdbb174d82b3b30ee5e56bbc495c");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Payment Method Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "From": properties.from,
      "Tab Code": properties.tabCode,
      "Purchase Click ID": properties.purchaseClickId,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Db Intermediate Screen: This event will be fired when user sees the intermediate screen
   * 
   * When to trigger this event:
   * 1. When user sees this screen
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Z0rZG3HiARCeCRCBX9ft4/trigger/6E53d0mx6IukXrZXVINye
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.cgPack - This stores the CG pack name of the respective intermedaite screen
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Z0rZG3HiARCeCRCBX9ft4}
   */
  function viewedDbIntermediateScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertCgPack(properties.cgPack));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Db Intermediate Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "elaGrade",
        "grade",
        "cgPack"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Z0rZG3HiARCeCRCBX9ft4", "cd9fd6a108a4b8915c64962548c01485ea105a5a359e3c7f99cadc0b2fb2a6cd", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Db Intermediate Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Cg Pack": properties.cgPack,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Z0rZG3HiARCeCRCBX9ft4", "Viewed Db Intermediate Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BTWKtfoSCfAut3FUrYeuT", name: "Cg Pack", value: properties.cgPack},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Db Intermediate Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Db Intermediate Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Cg Pack": properties.cgPack,
          "Screen Height": sysScreenHeight,
          }, "Z0rZG3HiARCeCRCBX9ft4", "cd9fd6a108a4b8915c64962548c01485ea105a5a359e3c7f99cadc0b2fb2a6cd");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Db Intermediate Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Cg Pack": properties.cgPack,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Db Intermediate Screen: This event is associated with the interactions on the intermediate screen
   * 
   * When to trigger this event:
   * 1. User interacts with the element of this page - the thumbnail, change focus area or home icon
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/wTRnlad_F9uC3thohUWnA/trigger/TfgyYFHFCGSFGwlpQY4et
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.cgPack - This stores the CG pack name of the respective intermedaite screen
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/wTRnlad_F9uC3thohUWnA}
   */
  function interactedDbIntermediateScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertCgPack(properties.cgPack));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Db Intermediate Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "grade",
        "elaGrade",
        "clickedOn",
        "cgPack"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "wTRnlad_F9uC3thohUWnA", "fc52e531cf2454747c599297af8b641f2ad23c9f4e8cc600bc99b2856efb8cdc", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Db Intermediate Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Clicked On": properties.clickedOn,
        "Cg Pack": properties.cgPack,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("wTRnlad_F9uC3thohUWnA", "Interacted Db Intermediate Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BTWKtfoSCfAut3FUrYeuT", name: "Cg Pack", value: properties.cgPack},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Db Intermediate Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Db Intermediate Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Clicked On": properties.clickedOn,
          "Cg Pack": properties.cgPack,
          "Screen Height": sysScreenHeight,
          }, "wTRnlad_F9uC3thohUWnA", "fc52e531cf2454747c599297af8b641f2ad23c9f4e8cc600bc99b2856efb8cdc");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Db Intermediate Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Clicked On": properties.clickedOn,
      "Cg Pack": properties.cgPack,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Started Db Ftue: This event gets fired when FTUE starts
   * 
   * When to trigger this event:
   * 1. When FTUE starts
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/_hdUBJrG1gD-LX-FG2e20/trigger/N3U-ehlgf9mpCN9_tgrwt
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.subject - Subject Selected during onboarding

   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/_hdUBJrG1gD-LX-FG2e20}
   */
  function startedDbFtue(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Started Db Ftue", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "grade",
        "elaGrade",
        "subject"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "_hdUBJrG1gD-LX-FG2e20", "e7cb206219323eb16e2491516d1939f8d0ca4263f6372cf3e3eee3fa8e8e0845", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Started Db Ftue", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Subject": properties.subject,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("_hdUBJrG1gD-LX-FG2e20", "Started Db Ftue", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Started Db Ftue': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Started Db Ftue", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Subject": properties.subject,
          "Screen Height": sysScreenHeight,
          }, "_hdUBJrG1gD-LX-FG2e20", "e7cb206219323eb16e2491516d1939f8d0ca4263f6372cf3e3eee3fa8e8e0845");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Started Db Ftue", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Subject": properties.subject,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Error on PTL Parent Signup Screen: This event will get fired when user is displayed error on the PTL parent setup home access page
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/gmdO7EnAAxa_V29Dp_j-L/trigger/TzQlWXHCCk7CgIpEMwQET
   * 2. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/gmdO7EnAAxa_V29Dp_j-L/trigger/zXc1HmE4wYxRlA0OErRWF
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.invitationSource - This property returns the type of invite sent from the student roster page
   * @param {string} properties.referrerPage - Shows the description of the previous page name/URL
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.errorMessage - Error message shown to the user.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/gmdO7EnAAxa_V29Dp_j-L}
   */
  function viewedErrorOnPtlParentSignupScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertInvitationSource(properties.invitationSource));
      messages = messages.concat(assertReferrerPage(properties.referrerPage));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertErrorMessage(properties.errorMessage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Error on PTL Parent Signup Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "invitationSource",
        "referrerPage",
        "mode",
        "errorMessage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "gmdO7EnAAxa_V29Dp_j-L", "59957e97d2649dda17146887140551ee6d0034a038c77b86981a84f6ad576c28", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Error on PTL Parent Signup Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Invitation Source": properties.invitationSource,
        "Referrer Page": properties.referrerPage,
        "Mode": properties.mode,
        "Error Message": properties.errorMessage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("gmdO7EnAAxa_V29Dp_j-L", "Viewed Error on PTL Parent Signup Screen", messages, [
        {id: "1n3Bq4GKWy", name: "Error Message", value: properties.errorMessage},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "cYVv-jM3n6", name: "Referrer Page", value: properties.referrerPage},
        {id: "cccDu2odc", name: "Invitation Source", value: properties.invitationSource},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Error on PTL Parent Signup Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Error on PTL Parent Signup Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Invitation Source": properties.invitationSource,
          "Referrer Page": properties.referrerPage,
          "Mode": properties.mode,
          "Error Message": properties.errorMessage,
          "Screen Height": sysScreenHeight,
          }, "gmdO7EnAAxa_V29Dp_j-L", "59957e97d2649dda17146887140551ee6d0034a038c77b86981a84f6ad576c28");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Error on PTL Parent Signup Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Invitation Source": properties.invitationSource,
      "Referrer Page": properties.referrerPage,
      "Mode": properties.mode,
      "Error Message": properties.errorMessage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Playable Interacted: When a book is loaded and user has interacted with any action on the book cover page
   * 
   * When to trigger this event:
   * 1. when a user clicks on any of the CTA on the book cover page
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/if4_QuobyT7mNnJZedT80/trigger/qVT6QTm0uLbk84zDfDioh
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.readingMode - Reading Mode in which the book starts
   * @param {string} properties.playableCode - Pass the 'Playable Code' of the Playable being started/clicked
   * @param {string} properties.playableName - Name of playable selected
   * @param {string} properties.interaction - The type of interaction that occurs
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {Array<string>} properties.recommendedRailName - This is the name of the rail viewed by the user. 
Recommended rail property comes with rail name and rail rank, pipe separated - with the introduction of this property, we intend to separate rail name to calculate CTR on Mixpanel.
   * @param {Array<int>} properties.recommendedRailRank - Recommended Rail Rank will carry the rank of the rail in integer format viewed by the user. 
   * @param {string} properties.recommendationRailCode - This property will capture the code for recommended rails driven by algorithm
   * @param {string} properties.recommendationVersionName - Parent code for different versions of AB test
   * @param {string} properties.recommendationSubVersionName - It is a code that defines different version of different rail on book library dashboard
   * @param {int} properties.recommendationAlgorithmFlag - If a rail is driven by recommendation version then flag will be 1 else 0
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/if4_QuobyT7mNnJZedT80}
   */
  function playableInteracted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertReadingMode(properties.readingMode));
      messages = messages.concat(assertPlayableCode(properties.playableCode));
      messages = messages.concat(assertPlayableName(properties.playableName));
      messages = messages.concat(assertInteraction(properties.interaction));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertRecommendedRailName(properties.recommendedRailName));
      messages = messages.concat(assertRecommendedRailRank(properties.recommendedRailRank));
      messages = messages.concat(assertRecommendationRailCode(properties.recommendationRailCode));
      messages = messages.concat(assertRecommendationVersionName(properties.recommendationVersionName));
      messages = messages.concat(assertRecommendationSubVersionName(properties.recommendationSubVersionName));
      messages = messages.concat(assertRecommendationAlgorithmFlag(properties.recommendationAlgorithmFlag));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Playable Interacted", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "clickedOn",
        "readingMode",
        "playableCode",
        "playableName",
        "interaction",
        "from",
        "recommendedRailName",
        "recommendedRailRank",
        "recommendationRailCode",
        "recommendationVersionName",
        "recommendationSubVersionName",
        "recommendationAlgorithmFlag"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "if4_QuobyT7mNnJZedT80", "25804cee83d612c0f6a0202e75d6412816ac7e5cde67421eefeb42ffabfa08fa", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Playable Interacted", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Clicked On": properties.clickedOn,
        "Reading Mode": properties.readingMode,
        "Playable Code": properties.playableCode,
        "Playable Name": properties.playableName,
        "Interaction": properties.interaction,
        "From": properties.from,
        "Recommended Rail Name": properties.recommendedRailName,
        "Recommended Rail Rank": properties.recommendedRailRank,
        "Recommendation Rail Code": properties.recommendationRailCode,
        "Recommendation Version Name": properties.recommendationVersionName,
        "Recommendation Sub Version Name": properties.recommendationSubVersionName,
        "Recommendation Algorithm Flag": properties.recommendationAlgorithmFlag,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("if4_QuobyT7mNnJZedT80", "Playable Interacted", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "6lrsWYY5Y", name: "Recommended Rail Name", value: properties.recommendedRailName},
        {id: "AWdUIbzg1", name: "Reading Mode", value: properties.readingMode},
        {id: "BchWbNpV0WYRnYxTnBQ-c", name: "Recommendation Sub Version Name", value: properties.recommendationSubVersionName},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "FH6REXldlxqxCPK0pvsML", name: "Recommendation Version Name", value: properties.recommendationVersionName},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "Q2q6j4dEnjH8uo-MY-mr7", name: "Recommendation Algorithm Flag", value: properties.recommendationAlgorithmFlag},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "QjCwFasvW0", name: "Playable Code", value: properties.playableCode},
        {id: "Qwa4E7UWbmonbiv7JbciC", name: "Recommendation Rail Code", value: properties.recommendationRailCode},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "c2W4X05Jy", name: "Playable Name", value: properties.playableName},
        {id: "kwwJ5LAMqN", name: "Interaction", value: properties.interaction},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "uyLgqxbg7", name: "Recommended Rail Rank", value: properties.recommendedRailRank},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Playable Interacted': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Playable Interacted", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Clicked On": properties.clickedOn,
          "Reading Mode": properties.readingMode,
          "Playable Code": properties.playableCode,
          "Playable Name": properties.playableName,
          "Interaction": properties.interaction,
          "From": properties.from,
          "Recommended Rail Name": properties.recommendedRailName,
          "Recommended Rail Rank": properties.recommendedRailRank,
          "Recommendation Rail Code": properties.recommendationRailCode,
          "Recommendation Version Name": properties.recommendationVersionName,
          "Recommendation Sub Version Name": properties.recommendationSubVersionName,
          "Recommendation Algorithm Flag": properties.recommendationAlgorithmFlag,
          "Screen Height": sysScreenHeight,
          }, "if4_QuobyT7mNnJZedT80", "25804cee83d612c0f6a0202e75d6412816ac7e5cde67421eefeb42ffabfa08fa");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Playable Interacted", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Clicked On": properties.clickedOn,
      "Reading Mode": properties.readingMode,
      "Playable Code": properties.playableCode,
      "Playable Name": properties.playableName,
      "Interaction": properties.interaction,
      "From": properties.from,
      "Recommended Rail Name": properties.recommendedRailName,
      "Recommended Rail Rank": properties.recommendedRailRank,
      "Recommendation Rail Code": properties.recommendationRailCode,
      "Recommendation Version Name": properties.recommendationVersionName,
      "Recommendation Sub Version Name": properties.recommendationSubVersionName,
      "Recommendation Algorithm Flag": properties.recommendationAlgorithmFlag,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Page Turned: When a book page is turned either based on user action for read by myself mode or self turned during read-to-me mode
   * 
   * When to trigger this event:
   * 1. When a book page is turned either based on user action for read by myself mode or self turned during read-to-me mode
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/sfzJOA0T3z5HwUVoi4ppT/trigger/4-7owSoXkDdrkKwPRBjBB
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.interaction - The type of interaction that occurs
   * @param {int} properties.pagesRead - Number of pages read in the book
   * @param {string} properties.percent - Book progress is tracked through this metric 'percent' completed 
   * @param {string} properties.interactionType - Defines the type of interaction (click, scroll, hover etc)
   * @param {int} properties.currentPage - the current reading page of the book
   * @param {string} properties.playableCode - Pass the 'Playable Code' of the Playable being started/clicked
   * @param {string} properties.playableName - Name of playable selected
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/sfzJOA0T3z5HwUVoi4ppT}
   */
  function pageTurned(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertInteraction(properties.interaction));
      messages = messages.concat(assertPagesRead(properties.pagesRead));
      messages = messages.concat(assertPercent(properties.percent));
      messages = messages.concat(assertInteractionType(properties.interactionType));
      messages = messages.concat(assertCurrentPage(properties.currentPage));
      messages = messages.concat(assertPlayableCode(properties.playableCode));
      messages = messages.concat(assertPlayableName(properties.playableName));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Page Turned", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "interaction",
        "pagesRead",
        "percent",
        "interactionType",
        "currentPage",
        "playableCode",
        "playableName"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "sfzJOA0T3z5HwUVoi4ppT", "c575463582d2b79c62ed71648ec425c83ca8c1c2f458caae3fb9d447d761dfb7", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Page Turned", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Interaction": properties.interaction,
        "Pages Read": properties.pagesRead,
        "Percent": properties.percent,
        "Interaction Type": properties.interactionType,
        "Current Page": properties.currentPage,
        "Playable Code": properties.playableCode,
        "Playable Name": properties.playableName,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("sfzJOA0T3z5HwUVoi4ppT", "Page Turned", messages, [
        {id: "09yl86H3gLOygFRleu5dh", name: "Pages Read", value: properties.pagesRead},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "NB48F50R-rZtUyefpnEti", name: "Current Page", value: properties.currentPage},
        {id: "PokUqOLpg8", name: "Interaction Type", value: properties.interactionType},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "QjCwFasvW0", name: "Playable Code", value: properties.playableCode},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "YQmfn3FNosNNeMxSmOsXJ", name: "Percent", value: properties.percent},
        {id: "c2W4X05Jy", name: "Playable Name", value: properties.playableName},
        {id: "kwwJ5LAMqN", name: "Interaction", value: properties.interaction},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Page Turned': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Page Turned", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Interaction": properties.interaction,
          "Pages Read": properties.pagesRead,
          "Percent": properties.percent,
          "Interaction Type": properties.interactionType,
          "Current Page": properties.currentPage,
          "Playable Code": properties.playableCode,
          "Playable Name": properties.playableName,
          "Screen Height": sysScreenHeight,
          }, "sfzJOA0T3z5HwUVoi4ppT", "c575463582d2b79c62ed71648ec425c83ca8c1c2f458caae3fb9d447d761dfb7");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Page Turned", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Interaction": properties.interaction,
      "Pages Read": properties.pagesRead,
      "Percent": properties.percent,
      "Interaction Type": properties.interactionType,
      "Current Page": properties.currentPage,
      "Playable Code": properties.playableCode,
      "Playable Name": properties.playableName,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Pitstop: This event will be fired when user sees a pitstop, could be in game or the common pitstop.
   * 
   * When to trigger this event:
   * 1. When user sees the pitstop
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/FjYgqF-DStkJJwJ4Q8aJY/trigger/gPSpD5C_siz-drUnUs1GL
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.playableCode - Pass the 'Playable Code' of the Playable being started/clicked
   * @param {string} properties.contentType - Type of content viz. Game/Learning Path/Activities/Worksheets
   * @param {string} properties.tabCode - Specifies the tab which has been opened in the event 'Viewed Tiled Dashboard' and Other events too
   * @param {string} properties.tid - It's a unique id associated to every new animation getting triggered.
   * @param {string} properties.stateMachineCode - Every state machine has its own code, so whenever state machine switches we will be able to debug any issue that may arise
   * @param {string} properties.pendingMemory - This property stores the memory remaining at the current page. It will be used to debug the tech issues.

   * @param {string} properties.pitstopType - This will store if the pitstop is just stars, stars + level up, stars + level up + tier up
   * @param {Array<string>} properties.recommendedRail - This property will be used to store which rails were shown to the user in the HOME tab.

Where possible values are:
Rail Name = Curriculum, Game Zone, Math, Language, Logic & Thinking, Art & Creativity, General Knowledge, Motor Skills, Live Classes, Fluency, Multiplayer
This comes with Rank also with | separation
   * @param {Array<string>} properties.recommendedCategory - This property will be used to store what recommendations were shown to the user in the all tabs.
We'll be saving them in this format:
<Category Name>
where possible values are:
Category name =  MyToDo, Math_LP, ELA_LP, Math Facts, Books, Spelling, Reading Comprehension, Playzone, Activities, Learning Games
   * @param {Array<string>} properties.recommendedRailName - This is the name of the rail viewed by the user. 
Recommended rail property comes with rail name and rail rank, pipe separated - with the introduction of this property, we intend to separate rail name to calculate CTR on Mixpanel.
   * @param {Array<int>} properties.recommendedRailRank - Recommended Rail Rank will carry the rank of the rail in integer format viewed by the user. 
   * @param {Array<string>} [properties.recommendedTileName] - This property will store the code of the tile user has interacted with - CG code for curriculum rails and game code for non curr. rails

   * @param {Array<int>} properties.recommendedTileRank - This property will store the position of the tile on which user has clciked. Earlier this was sent as column position

   * @param {string} properties.contentGroup - Code of content group user clicked/tapped on
   * @param {string} properties.playableClickId - This property will hold a unique string for the playable events.
   * @param {string} properties.gameCode - Game code of the playable selected, for example: Math learning games have multiple variations, all those variations will have one game code
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {int} properties.tabStrClickedCount - Streak count of Playable Clicked from a Specific Tab in a day
   * @param {int} properties.tabStrStartedCount - Streak count of Playable Started from a Specific Tab in a day
   * @param {int} properties.railStrClickedCount - Streak count of Playable Clicked from a Specific Rail in a day
   * @param {int} properties.railStrStartedCount - Streak count of Playable Started from a Specific Rail in a day
   * @param {int} properties.tileStrClickedCount - Streak count of Playable Clicked from a Specific Tile in a day
   * @param {int} properties.tileStrStartedCount - Streak count of Playable Started from a Specific Tile in a day
   * @param {int} properties.tabStrCompletedCount - Streak count of Playable Completed from a Specific Tab in a day
   * @param {int} properties.railStrCompletedCount - Streak count of Playable Completed from a Specific Rail in a day
   * @param {int} properties.tileStrCompletedCount - Streak count of Playable Completed from a Specific Tile in a day
   * @param {int} properties.overallClickedCount - Streak count of Playable Clicked in a day from anywhere
   * @param {int} properties.overallStartedCount - Streak count of Playable Started in a day from anywhere
   * @param {int} properties.overallCompletedCount - Streak count of Playable Completed in a day from anywhere
   * @param {string} properties.tileCode - Code of the Tile: Debugging purpose by tech team
   * @param {string} properties.railCode - Code of the Rail: Debugging purpose
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/FjYgqF-DStkJJwJ4Q8aJY}
   */
  function viewedPitstop(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertPlayableCode(properties.playableCode));
      messages = messages.concat(assertContentType(properties.contentType));
      messages = messages.concat(assertTabCode(properties.tabCode));
      messages = messages.concat(assertTid(properties.tid));
      messages = messages.concat(assertStateMachineCode(properties.stateMachineCode));
      messages = messages.concat(assertPendingMemory(properties.pendingMemory));
      messages = messages.concat(assertPitstopType(properties.pitstopType));
      messages = messages.concat(assertRecommendedRail(properties.recommendedRail));
      messages = messages.concat(assertRecommendedCategory(properties.recommendedCategory));
      messages = messages.concat(assertRecommendedRailName(properties.recommendedRailName));
      messages = messages.concat(assertRecommendedRailRank(properties.recommendedRailRank));
      messages = messages.concat(assertOptionalRecommendedTileName(properties.recommendedTileName));
      messages = messages.concat(assertRecommendedTileRank(properties.recommendedTileRank));
      messages = messages.concat(assertContentGroup(properties.contentGroup));
      messages = messages.concat(assertPlayableClickId(properties.playableClickId));
      messages = messages.concat(assertGameCode(properties.gameCode));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertTabStrClickedCount(properties.tabStrClickedCount));
      messages = messages.concat(assertTabStrStartedCount(properties.tabStrStartedCount));
      messages = messages.concat(assertRailStrClickedCount(properties.railStrClickedCount));
      messages = messages.concat(assertRailStrStartedCount(properties.railStrStartedCount));
      messages = messages.concat(assertTileStrClickedCount(properties.tileStrClickedCount));
      messages = messages.concat(assertTileStrStartedCount(properties.tileStrStartedCount));
      messages = messages.concat(assertTabStrCompletedCount(properties.tabStrCompletedCount));
      messages = messages.concat(assertRailStrCompletedCount(properties.railStrCompletedCount));
      messages = messages.concat(assertTileStrCompletedCount(properties.tileStrCompletedCount));
      messages = messages.concat(assertOverallClickedCount(properties.overallClickedCount));
      messages = messages.concat(assertOverallStartedCount(properties.overallStartedCount));
      messages = messages.concat(assertOverallCompletedCount(properties.overallCompletedCount));
      messages = messages.concat(assertTileCode(properties.tileCode));
      messages = messages.concat(assertRailCode(properties.railCode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Pitstop", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "grade",
        "elaGrade",
        "playableCode",
        "contentType",
        "tabCode",
        "tid",
        "stateMachineCode",
        "pendingMemory",
        "pitstopType",
        "recommendedRail",
        "recommendedCategory",
        "recommendedRailName",
        "recommendedRailRank",
        "recommendedTileName",
        "recommendedTileRank",
        "contentGroup",
        "playableClickId",
        "gameCode",
        "from",
        "tabStrClickedCount",
        "tabStrStartedCount",
        "railStrClickedCount",
        "railStrStartedCount",
        "tileStrClickedCount",
        "tileStrStartedCount",
        "tabStrCompletedCount",
        "railStrCompletedCount",
        "tileStrCompletedCount",
        "overallClickedCount",
        "overallStartedCount",
        "overallCompletedCount",
        "tileCode",
        "railCode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "FjYgqF-DStkJJwJ4Q8aJY", "df8a04e20145305b7cbfaada7e37cfc33ffbc435a462853d04eae33232fbfe13", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Pitstop", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Playable Code": properties.playableCode,
        "Content Type": properties.contentType,
        "Tab Code": properties.tabCode,
        "Tid": properties.tid,
        "State Machine Code": properties.stateMachineCode,
        "Pending Memory": properties.pendingMemory,
        "Pitstop Type": properties.pitstopType,
        "Recommended Rail": properties.recommendedRail,
        "Recommended Category": properties.recommendedCategory,
        "Recommended Rail Name": properties.recommendedRailName,
        "Recommended Rail Rank": properties.recommendedRailRank,
        "Recommended Tile Name": properties.recommendedTileName,
        "Recommended Tile Rank": properties.recommendedTileRank,
        "Content Group": properties.contentGroup,
        "Playable Click Id": properties.playableClickId,
        "Game Code": properties.gameCode,
        "From": properties.from,
        "Tab Str Clicked Count": properties.tabStrClickedCount,
        "Tab Str Started Count": properties.tabStrStartedCount,
        "Rail Str Clicked Count": properties.railStrClickedCount,
        "Rail Str Started Count": properties.railStrStartedCount,
        "Tile Str Clicked Count": properties.tileStrClickedCount,
        "Tile Str Started Count": properties.tileStrStartedCount,
        "Tab Str Completed Count": properties.tabStrCompletedCount,
        "Rail Str Completed Count": properties.railStrCompletedCount,
        "Tile Str Completed Count": properties.tileStrCompletedCount,
        "Overall Clicked Count": properties.overallClickedCount,
        "Overall Started Count": properties.overallStartedCount,
        "Overall Completed Count": properties.overallCompletedCount,
        "Tile Code": properties.tileCode,
        "Rail Code": properties.railCode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("FjYgqF-DStkJJwJ4Q8aJY", "Viewed Pitstop", messages, [
        {id: "2oZQdvXRu", name: "Game Code", value: properties.gameCode},
        {id: "33JWk0cGdkpH6MbvcXKfL", name: "Tile Str Clicked Count", value: properties.tileStrClickedCount},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "6lrsWYY5Y", name: "Recommended Rail Name", value: properties.recommendedRailName},
        {id: "72Hz7CelRpVYf1warHrRP", name: "Tile Str Started Count", value: properties.tileStrStartedCount},
        {id: "7PQh3G9ITCcMDMNeMTM8q", name: "Tab Str Clicked Count", value: properties.tabStrClickedCount},
        {id: "8Vq9HABFDQ", name: "Pitstop Type", value: properties.pitstopType},
        {id: "AFC3Xnyx0vxpH2PWZIjdO", name: "Rail Str Completed Count", value: properties.railStrCompletedCount},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "C_BFBZn2V", name: "Pending Memory", value: properties.pendingMemory},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "FLDtSJNKL", name: "Recommended Tile Rank", value: properties.recommendedTileRank},
        {id: "GAdbKqJ5y9HJPos5lx5qt", name: "Tab Str Completed Count", value: properties.tabStrCompletedCount},
        {id: "GJYEymipLkc1xy54AyhV8", name: "Tile Code", value: properties.tileCode},
        {id: "HFnzATNuS7GI6VZs6tZ15", name: "Tab Str Started Count", value: properties.tabStrStartedCount},
        {id: "HJUIBmGrsUmqa_TYCtwQ0", name: "Overall Started Count", value: properties.overallStartedCount},
        {id: "Nfs9QLl8W7", name: "Content Type", value: properties.contentType},
        {id: "OHBx0fnhzlxvHhw0e87pM", name: "Overall Completed Count", value: properties.overallCompletedCount},
        {id: "Otu1r2JQW", name: "Content Group", value: properties.contentGroup},
        {id: "QDMKmRkRjbW4pFvqlGOM6", name: "Rail Code", value: properties.railCode},
        {id: "QQeu-Td4-0", name: "Playable Click Id", value: properties.playableClickId},
        {id: "QjCwFasvW0", name: "Playable Code", value: properties.playableCode},
        {id: "SYGmTqa9e", name: "Tid", value: properties.tid},
        {id: "T9gjnp76o", name: "State Machine Code", value: properties.stateMachineCode},
        {id: "TYbmk5DQn", name: "Recommended Tile Name", value: properties.recommendedTileName},
        {id: "VdJhEU0H6s", name: "Recommended Category", value: properties.recommendedCategory},
        {id: "X4kgAx81N5AHgcI6NaNiS", name: "Overall Clicked Count", value: properties.overallClickedCount},
        {id: "_QL92wEdpoa8wH50vOPYt", name: "Tile Str Completed Count", value: properties.tileStrCompletedCount},
        {id: "drNgwJn5Xg", name: "Recommended Rail", value: properties.recommendedRail},
        {id: "hKAJ3izCFVFH-D4_886C8", name: "Rail Str Clicked Count", value: properties.railStrClickedCount},
        {id: "l9PbANZBu", name: "Tab Code", value: properties.tabCode},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "sRPi7ITwtlHeD7HQEGzmG", name: "Rail Str Started Count", value: properties.railStrStartedCount},
        {id: "uyLgqxbg7", name: "Recommended Rail Rank", value: properties.recommendedRailRank},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Pitstop': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Pitstop", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Playable Code": properties.playableCode,
          "Content Type": properties.contentType,
          "Tab Code": properties.tabCode,
          "Tid": properties.tid,
          "State Machine Code": properties.stateMachineCode,
          "Pending Memory": properties.pendingMemory,
          "Pitstop Type": properties.pitstopType,
          "Recommended Rail": properties.recommendedRail,
          "Recommended Category": properties.recommendedCategory,
          "Recommended Rail Name": properties.recommendedRailName,
          "Recommended Rail Rank": properties.recommendedRailRank,
          "Recommended Tile Name": properties.recommendedTileName,
          "Recommended Tile Rank": properties.recommendedTileRank,
          "Content Group": properties.contentGroup,
          "Playable Click Id": properties.playableClickId,
          "Game Code": properties.gameCode,
          "From": properties.from,
          "Tab Str Clicked Count": properties.tabStrClickedCount,
          "Tab Str Started Count": properties.tabStrStartedCount,
          "Rail Str Clicked Count": properties.railStrClickedCount,
          "Rail Str Started Count": properties.railStrStartedCount,
          "Tile Str Clicked Count": properties.tileStrClickedCount,
          "Tile Str Started Count": properties.tileStrStartedCount,
          "Tab Str Completed Count": properties.tabStrCompletedCount,
          "Rail Str Completed Count": properties.railStrCompletedCount,
          "Tile Str Completed Count": properties.tileStrCompletedCount,
          "Overall Clicked Count": properties.overallClickedCount,
          "Overall Started Count": properties.overallStartedCount,
          "Overall Completed Count": properties.overallCompletedCount,
          "Tile Code": properties.tileCode,
          "Rail Code": properties.railCode,
          "Screen Height": sysScreenHeight,
          }, "FjYgqF-DStkJJwJ4Q8aJY", "df8a04e20145305b7cbfaada7e37cfc33ffbc435a462853d04eae33232fbfe13");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Pitstop", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Playable Code": properties.playableCode,
      "Content Type": properties.contentType,
      "Tab Code": properties.tabCode,
      "Tid": properties.tid,
      "State Machine Code": properties.stateMachineCode,
      "Pending Memory": properties.pendingMemory,
      "Pitstop Type": properties.pitstopType,
      "Recommended Rail": properties.recommendedRail,
      "Recommended Category": properties.recommendedCategory,
      "Recommended Rail Name": properties.recommendedRailName,
      "Recommended Rail Rank": properties.recommendedRailRank,
      "Recommended Tile Name": properties.recommendedTileName,
      "Recommended Tile Rank": properties.recommendedTileRank,
      "Content Group": properties.contentGroup,
      "Playable Click Id": properties.playableClickId,
      "Game Code": properties.gameCode,
      "From": properties.from,
      "Tab Str Clicked Count": properties.tabStrClickedCount,
      "Tab Str Started Count": properties.tabStrStartedCount,
      "Rail Str Clicked Count": properties.railStrClickedCount,
      "Rail Str Started Count": properties.railStrStartedCount,
      "Tile Str Clicked Count": properties.tileStrClickedCount,
      "Tile Str Started Count": properties.tileStrStartedCount,
      "Tab Str Completed Count": properties.tabStrCompletedCount,
      "Rail Str Completed Count": properties.railStrCompletedCount,
      "Tile Str Completed Count": properties.tileStrCompletedCount,
      "Overall Clicked Count": properties.overallClickedCount,
      "Overall Started Count": properties.overallStartedCount,
      "Overall Completed Count": properties.overallCompletedCount,
      "Tile Code": properties.tileCode,
      "Rail Code": properties.railCode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Game Exited: When User Exits the game / worksheet [For all Content Type]
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.gameCode - Game code of the playable selected, for example: Math learning games have multiple variations, all those variations will have one game code
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.to - Where user lands after interaction
   * @param {Array<string>} properties.recommendedRailName - This is the name of the rail viewed by the user. 
Recommended rail property comes with rail name and rail rank, pipe separated - with the introduction of this property, we intend to separate rail name to calculate CTR on Mixpanel.
   * @param {Array<string>} [properties.recommendedTileName] - This property will store the code of the tile user has interacted with - CG code for curriculum rails and game code for non curr. rails

   * @param {Array<int>} properties.recommendedTileRank - This property will store the position of the tile on which user has clciked. Earlier this was sent as column position

   * @param {string} properties.contentGroup - Code of content group user clicked/tapped on
   * @param {string} properties.contentType - Type of content viz. Game/Learning Path/Activities/Worksheets
   * @param {string} properties.playableClickId - This property will hold a unique string for the playable events.
   * @param {string} properties.playableCode - Pass the 'Playable Code' of the Playable being started/clicked
   * @param {string} properties.tid - It's a unique id associated to every new animation getting triggered.
   * @param {string} properties.stateMachineCode - Every state machine has its own code, so whenever state machine switches we will be able to debug any issue that may arise
   * @param {Array<string>} properties.recommendedCategory - This property will be used to store what recommendations were shown to the user in the all tabs.
We'll be saving them in this format:
<Category Name>
where possible values are:
Category name =  MyToDo, Math_LP, ELA_LP, Math Facts, Books, Spelling, Reading Comprehension, Playzone, Activities, Learning Games
   * @param {Array<string>} properties.recommendedRail - This property will be used to store which rails were shown to the user in the HOME tab.

Where possible values are:
Rail Name = Curriculum, Game Zone, Math, Language, Logic & Thinking, Art & Creativity, General Knowledge, Motor Skills, Live Classes, Fluency, Multiplayer
This comes with Rank also with | separation
   * @param {string} properties.tabCode - Specifies the tab which has been opened in the event 'Viewed Tiled Dashboard' and Other events too
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {Array<int>} properties.recommendedRailRank - Recommended Rail Rank will carry the rank of the rail in integer format viewed by the user. 
   * @param {int} properties.tabStrClickedCount - Streak count of Playable Clicked from a Specific Tab in a day
   * @param {int} properties.tabStrStartedCount - Streak count of Playable Started from a Specific Tab in a day
   * @param {int} properties.tabStrCompletedCount - Streak count of Playable Completed from a Specific Tab in a day
   * @param {int} properties.tileStrClickedCount - Streak count of Playable Clicked from a Specific Tile in a day
   * @param {int} properties.tileStrStartedCount - Streak count of Playable Started from a Specific Tile in a day
   * @param {int} properties.tileStrCompletedCount - Streak count of Playable Completed from a Specific Tile in a day
   * @param {int} properties.railStrClickedCount - Streak count of Playable Clicked from a Specific Rail in a day
   * @param {int} properties.railStrStartedCount - Streak count of Playable Started from a Specific Rail in a day
   * @param {int} properties.railStrCompletedCount - Streak count of Playable Completed from a Specific Rail in a day
   * @param {int} properties.overallClickedCount - Streak count of Playable Clicked in a day from anywhere
   * @param {int} properties.overallStartedCount - Streak count of Playable Started in a day from anywhere
   * @param {int} properties.overallCompletedCount - Streak count of Playable Completed in a day from anywhere
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/9WuFp7XMjaXfx12hKvspR}
   */
  function gameExited(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGameCode(properties.gameCode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertTo(properties.to));
      messages = messages.concat(assertRecommendedRailName(properties.recommendedRailName));
      messages = messages.concat(assertOptionalRecommendedTileName(properties.recommendedTileName));
      messages = messages.concat(assertRecommendedTileRank(properties.recommendedTileRank));
      messages = messages.concat(assertContentGroup(properties.contentGroup));
      messages = messages.concat(assertContentType(properties.contentType));
      messages = messages.concat(assertPlayableClickId(properties.playableClickId));
      messages = messages.concat(assertPlayableCode(properties.playableCode));
      messages = messages.concat(assertTid(properties.tid));
      messages = messages.concat(assertStateMachineCode(properties.stateMachineCode));
      messages = messages.concat(assertRecommendedCategory(properties.recommendedCategory));
      messages = messages.concat(assertRecommendedRail(properties.recommendedRail));
      messages = messages.concat(assertTabCode(properties.tabCode));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertRecommendedRailRank(properties.recommendedRailRank));
      messages = messages.concat(assertTabStrClickedCount(properties.tabStrClickedCount));
      messages = messages.concat(assertTabStrStartedCount(properties.tabStrStartedCount));
      messages = messages.concat(assertTabStrCompletedCount(properties.tabStrCompletedCount));
      messages = messages.concat(assertTileStrClickedCount(properties.tileStrClickedCount));
      messages = messages.concat(assertTileStrStartedCount(properties.tileStrStartedCount));
      messages = messages.concat(assertTileStrCompletedCount(properties.tileStrCompletedCount));
      messages = messages.concat(assertRailStrClickedCount(properties.railStrClickedCount));
      messages = messages.concat(assertRailStrStartedCount(properties.railStrStartedCount));
      messages = messages.concat(assertRailStrCompletedCount(properties.railStrCompletedCount));
      messages = messages.concat(assertOverallClickedCount(properties.overallClickedCount));
      messages = messages.concat(assertOverallStartedCount(properties.overallStartedCount));
      messages = messages.concat(assertOverallCompletedCount(properties.overallCompletedCount));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Game Exited", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "gameCode",
        "grade",
        "from",
        "clickedOn",
        "to",
        "recommendedRailName",
        "recommendedTileName",
        "recommendedTileRank",
        "contentGroup",
        "contentType",
        "playableClickId",
        "playableCode",
        "tid",
        "stateMachineCode",
        "recommendedCategory",
        "recommendedRail",
        "tabCode",
        "elaGrade",
        "recommendedRailRank",
        "tabStrClickedCount",
        "tabStrStartedCount",
        "tabStrCompletedCount",
        "tileStrClickedCount",
        "tileStrStartedCount",
        "tileStrCompletedCount",
        "railStrClickedCount",
        "railStrStartedCount",
        "railStrCompletedCount",
        "overallClickedCount",
        "overallStartedCount",
        "overallCompletedCount"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "9WuFp7XMjaXfx12hKvspR", "8b02d8c8d3d49982dbf34125f161b6bd71765a96aa9c748a0637128122a31a7d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Game Exited", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Game Code": properties.gameCode,
        "Grade": properties.grade,
        "From": properties.from,
        "Clicked On": properties.clickedOn,
        "To": properties.to,
        "Recommended Rail Name": properties.recommendedRailName,
        "Recommended Tile Name": properties.recommendedTileName,
        "Recommended Tile Rank": properties.recommendedTileRank,
        "Content Group": properties.contentGroup,
        "Content Type": properties.contentType,
        "Playable Click Id": properties.playableClickId,
        "Playable Code": properties.playableCode,
        "Tid": properties.tid,
        "State Machine Code": properties.stateMachineCode,
        "Recommended Category": properties.recommendedCategory,
        "Recommended Rail": properties.recommendedRail,
        "Tab Code": properties.tabCode,
        "Ela Grade": properties.elaGrade,
        "Recommended Rail Rank": properties.recommendedRailRank,
        "Tab Str Clicked Count": properties.tabStrClickedCount,
        "Tab Str Started Count": properties.tabStrStartedCount,
        "Tab Str Completed Count": properties.tabStrCompletedCount,
        "Tile Str Clicked Count": properties.tileStrClickedCount,
        "Tile Str Started Count": properties.tileStrStartedCount,
        "Tile Str Completed Count": properties.tileStrCompletedCount,
        "Rail Str Clicked Count": properties.railStrClickedCount,
        "Rail Str Started Count": properties.railStrStartedCount,
        "Rail Str Completed Count": properties.railStrCompletedCount,
        "Overall Clicked Count": properties.overallClickedCount,
        "Overall Started Count": properties.overallStartedCount,
        "Overall Completed Count": properties.overallCompletedCount,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("9WuFp7XMjaXfx12hKvspR", "Game Exited", messages, [
        {id: "2oZQdvXRu", name: "Game Code", value: properties.gameCode},
        {id: "33JWk0cGdkpH6MbvcXKfL", name: "Tile Str Clicked Count", value: properties.tileStrClickedCount},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "6lrsWYY5Y", name: "Recommended Rail Name", value: properties.recommendedRailName},
        {id: "72Hz7CelRpVYf1warHrRP", name: "Tile Str Started Count", value: properties.tileStrStartedCount},
        {id: "7PQh3G9ITCcMDMNeMTM8q", name: "Tab Str Clicked Count", value: properties.tabStrClickedCount},
        {id: "AFC3Xnyx0vxpH2PWZIjdO", name: "Rail Str Completed Count", value: properties.railStrCompletedCount},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "FLDtSJNKL", name: "Recommended Tile Rank", value: properties.recommendedTileRank},
        {id: "GAdbKqJ5y9HJPos5lx5qt", name: "Tab Str Completed Count", value: properties.tabStrCompletedCount},
        {id: "HFnzATNuS7GI6VZs6tZ15", name: "Tab Str Started Count", value: properties.tabStrStartedCount},
        {id: "HJUIBmGrsUmqa_TYCtwQ0", name: "Overall Started Count", value: properties.overallStartedCount},
        {id: "Nfs9QLl8W7", name: "Content Type", value: properties.contentType},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "OHBx0fnhzlxvHhw0e87pM", name: "Overall Completed Count", value: properties.overallCompletedCount},
        {id: "Otu1r2JQW", name: "Content Group", value: properties.contentGroup},
        {id: "QQeu-Td4-0", name: "Playable Click Id", value: properties.playableClickId},
        {id: "QjCwFasvW0", name: "Playable Code", value: properties.playableCode},
        {id: "SYGmTqa9e", name: "Tid", value: properties.tid},
        {id: "T9gjnp76o", name: "State Machine Code", value: properties.stateMachineCode},
        {id: "TYbmk5DQn", name: "Recommended Tile Name", value: properties.recommendedTileName},
        {id: "VdJhEU0H6s", name: "Recommended Category", value: properties.recommendedCategory},
        {id: "X4kgAx81N5AHgcI6NaNiS", name: "Overall Clicked Count", value: properties.overallClickedCount},
        {id: "_QL92wEdpoa8wH50vOPYt", name: "Tile Str Completed Count", value: properties.tileStrCompletedCount},
        {id: "drNgwJn5Xg", name: "Recommended Rail", value: properties.recommendedRail},
        {id: "hKAJ3izCFVFH-D4_886C8", name: "Rail Str Clicked Count", value: properties.railStrClickedCount},
        {id: "kz8nJYHNvkhWPcSeERcL2", name: "To", value: properties.to},
        {id: "l9PbANZBu", name: "Tab Code", value: properties.tabCode},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "sRPi7ITwtlHeD7HQEGzmG", name: "Rail Str Started Count", value: properties.railStrStartedCount},
        {id: "uyLgqxbg7", name: "Recommended Rail Rank", value: properties.recommendedRailRank},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Game Exited': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Game Exited", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Game Code": properties.gameCode,
          "Grade": properties.grade,
          "From": properties.from,
          "Clicked On": properties.clickedOn,
          "To": properties.to,
          "Recommended Rail Name": properties.recommendedRailName,
          "Recommended Tile Name": properties.recommendedTileName,
          "Recommended Tile Rank": properties.recommendedTileRank,
          "Content Group": properties.contentGroup,
          "Content Type": properties.contentType,
          "Playable Click Id": properties.playableClickId,
          "Playable Code": properties.playableCode,
          "Tid": properties.tid,
          "State Machine Code": properties.stateMachineCode,
          "Recommended Category": properties.recommendedCategory,
          "Recommended Rail": properties.recommendedRail,
          "Tab Code": properties.tabCode,
          "Ela Grade": properties.elaGrade,
          "Recommended Rail Rank": properties.recommendedRailRank,
          "Tab Str Clicked Count": properties.tabStrClickedCount,
          "Tab Str Started Count": properties.tabStrStartedCount,
          "Tab Str Completed Count": properties.tabStrCompletedCount,
          "Tile Str Clicked Count": properties.tileStrClickedCount,
          "Tile Str Started Count": properties.tileStrStartedCount,
          "Tile Str Completed Count": properties.tileStrCompletedCount,
          "Rail Str Clicked Count": properties.railStrClickedCount,
          "Rail Str Started Count": properties.railStrStartedCount,
          "Rail Str Completed Count": properties.railStrCompletedCount,
          "Overall Clicked Count": properties.overallClickedCount,
          "Overall Started Count": properties.overallStartedCount,
          "Overall Completed Count": properties.overallCompletedCount,
          "Screen Height": sysScreenHeight,
          }, "9WuFp7XMjaXfx12hKvspR", "8b02d8c8d3d49982dbf34125f161b6bd71765a96aa9c748a0637128122a31a7d");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Game Exited", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Game Code": properties.gameCode,
      "Grade": properties.grade,
      "From": properties.from,
      "Clicked On": properties.clickedOn,
      "To": properties.to,
      "Recommended Rail Name": properties.recommendedRailName,
      "Recommended Tile Name": properties.recommendedTileName,
      "Recommended Tile Rank": properties.recommendedTileRank,
      "Content Group": properties.contentGroup,
      "Content Type": properties.contentType,
      "Playable Click Id": properties.playableClickId,
      "Playable Code": properties.playableCode,
      "Tid": properties.tid,
      "State Machine Code": properties.stateMachineCode,
      "Recommended Category": properties.recommendedCategory,
      "Recommended Rail": properties.recommendedRail,
      "Tab Code": properties.tabCode,
      "Ela Grade": properties.elaGrade,
      "Recommended Rail Rank": properties.recommendedRailRank,
      "Tab Str Clicked Count": properties.tabStrClickedCount,
      "Tab Str Started Count": properties.tabStrStartedCount,
      "Tab Str Completed Count": properties.tabStrCompletedCount,
      "Tile Str Clicked Count": properties.tileStrClickedCount,
      "Tile Str Started Count": properties.tileStrStartedCount,
      "Tile Str Completed Count": properties.tileStrCompletedCount,
      "Rail Str Clicked Count": properties.railStrClickedCount,
      "Rail Str Started Count": properties.railStrStartedCount,
      "Rail Str Completed Count": properties.railStrCompletedCount,
      "Overall Clicked Count": properties.overallClickedCount,
      "Overall Started Count": properties.overallStartedCount,
      "Overall Completed Count": properties.overallCompletedCount,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Student Login Password Settings Page [B2B]: This event will get fired when teacher is displayed the Password settings popup on clicking the student login instructions
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/1tbwFDGHiH9vdRgwBv3-s/trigger/ZBPzQXON4lysXNsd4BuLv
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * @param {string} properties.section - This will capture the widget name that is being viewed/interacted by the user in that viewport. For example, 'Onboarding Widget', 'Home Access Widget', 'Assignment Widget', 'Assessment Widget', 'Math Fact Widget'
The list will only have 1 value for 'Section' property for Interacted event.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/1tbwFDGHiH9vdRgwBv3-s}
   */
  function viewedStudentLoginPasswordSettingsPageB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertSection(properties.section));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Student Login Password Settings Page [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "fromPage",
        "section"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "1tbwFDGHiH9vdRgwBv3-s", "687ae85f7cf158a5e46de00699bea397685a39c410be7c6a31af945867a0910c", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Student Login Password Settings Page [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From Page": properties.fromPage,
        "Section": properties.section,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("1tbwFDGHiH9vdRgwBv3-s", "Viewed Student Login Password Settings Page [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "my9qL7M8w6", name: "Section", value: properties.section},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Student Login Password Settings Page [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Student Login Password Settings Page [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From Page": properties.fromPage,
          "Section": properties.section,
          "Screen Height": sysScreenHeight,
          }, "1tbwFDGHiH9vdRgwBv3-s", "687ae85f7cf158a5e46de00699bea397685a39c410be7c6a31af945867a0910c");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Student Login Password Settings Page [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From Page": properties.fromPage,
      "Section": properties.section,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Student Login Password Settings Page [B2B]: This event will get fired when user interacts with the Student Login Password settings page
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/mSKiagEw47cnRi-N5WG2D/trigger/kzW2s87woma6i5I-PMsts
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/mSKiagEw47cnRi-N5WG2D}
   */
  function interactedStudentLoginPasswordSettingsPageB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Student Login Password Settings Page [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "mSKiagEw47cnRi-N5WG2D", "3e4bef627e28a2ca2e36bd6c6be12fc0651df69e0f39848495c9be596019c501", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Student Login Password Settings Page [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("mSKiagEw47cnRi-N5WG2D", "Interacted Student Login Password Settings Page [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Student Login Password Settings Page [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Student Login Password Settings Page [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "mSKiagEw47cnRi-N5WG2D", "3e4bef627e28a2ca2e36bd6c6be12fc0651df69e0f39848495c9be596019c501");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Student Login Password Settings Page [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Saved Student Login Password Setting [B2B]: This event will get fired when teacher saves/updates Login mode (no password/common password/individual password) for student login
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/O8Im7DGoOdnYdv_UEiT8i/trigger/T5AfsQQLpJo-rzMH8rfHD
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.valueName - This will capture the value/text of the field that is selected.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * @param {string} properties.section - This will capture the widget name that is being viewed/interacted by the user in that viewport. For example, 'Onboarding Widget', 'Home Access Widget', 'Assignment Widget', 'Assessment Widget', 'Math Fact Widget'
The list will only have 1 value for 'Section' property for Interacted event.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/O8Im7DGoOdnYdv_UEiT8i}
   */
  function savedStudentLoginPasswordSettingB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertValueName(properties.valueName));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertSection(properties.section));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Saved Student Login Password Setting [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "valueName",
        "fromPage",
        "section"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "O8Im7DGoOdnYdv_UEiT8i", "b8c4f700df93c1c0610da24e446777e5ca984f7f590308a367321be36a100769", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Saved Student Login Password Setting [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Value Name": properties.valueName,
        "From Page": properties.fromPage,
        "Section": properties.section,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("O8Im7DGoOdnYdv_UEiT8i", "Saved Student Login Password Setting [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "l-8JNUE0q", name: "Value Name", value: properties.valueName},
        {id: "my9qL7M8w6", name: "Section", value: properties.section},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Saved Student Login Password Setting [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Saved Student Login Password Setting [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Value Name": properties.valueName,
          "From Page": properties.fromPage,
          "Section": properties.section,
          "Screen Height": sysScreenHeight,
          }, "O8Im7DGoOdnYdv_UEiT8i", "b8c4f700df93c1c0610da24e446777e5ca984f7f590308a367321be36a100769");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Saved Student Login Password Setting [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Value Name": properties.valueName,
      "From Page": properties.fromPage,
      "Section": properties.section,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Thank You Screen: Screen shown to user post successful trial purchase/upgrade from onboarding or inside the dashboard
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/YsKbbPfMkbh2VFwGszsDT/trigger/m56ztgK1CRBA2o-MPiOLQ
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/YsKbbPfMkbh2VFwGszsDT}
   */
  function viewedThankYouScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Thank You Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "grade",
        "elaGrade",
        "mathGrade",
        "mode",
        "from"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "YsKbbPfMkbh2VFwGszsDT", "5a23ec373afc9359ec01d06c45aef9831e2ce2f303310b25ef3f9035e56df91f", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Thank You Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "From": properties.from,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("YsKbbPfMkbh2VFwGszsDT", "Viewed Thank You Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Thank You Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Thank You Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "From": properties.from,
          "Screen Height": sysScreenHeight,
          }, "YsKbbPfMkbh2VFwGszsDT", "5a23ec373afc9359ec01d06c45aef9831e2ce2f303310b25ef3f9035e56df91f");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Thank You Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "From": properties.from,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Thank You Screen: Triggered when user interacts with thank you screen
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/thXaGRWoEplnY82GO6jcd/trigger/KZZOTeZbJ1noqXYy881wX
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/thXaGRWoEplnY82GO6jcd}
   */
  function interactedThankYouScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Thank You Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "grade",
        "elaGrade",
        "mathGrade",
        "mode",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "thXaGRWoEplnY82GO6jcd", "831cd36bf67ebcedc47ad3d32094c152cf88ee6ce171e60dcb7a31b7f8b0669d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Thank You Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("thXaGRWoEplnY82GO6jcd", "Interacted Thank You Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Thank You Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Thank You Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "thXaGRWoEplnY82GO6jcd", "831cd36bf67ebcedc47ad3d32094c152cf88ee6ce171e60dcb7a31b7f8b0669d");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Thank You Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed App Download Redirect Screen: Fired on proxy redirection screen when QR code is scanned by the user
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/_YFKT5lpAa7_w4uhl_5fi}
   */
  function viewedAppDownloadRedirectScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed App Download Redirect Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "from",
        "grade",
        "elaGrade",
        "mathGrade",
        "mode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "_YFKT5lpAa7_w4uhl_5fi", "52f4810176d57d0b8d793602b52a5c6ee05281652801de3b8d061747141a1df7", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed App Download Redirect Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From": properties.from,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("_YFKT5lpAa7_w4uhl_5fi", "Viewed App Download Redirect Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed App Download Redirect Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed App Download Redirect Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From": properties.from,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Screen Height": sysScreenHeight,
          }, "_YFKT5lpAa7_w4uhl_5fi", "52f4810176d57d0b8d793602b52a5c6ee05281652801de3b8d061747141a1df7");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed App Download Redirect Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From": properties.from,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * CrossUsage email trigger: This will be triggered when user select "Get link on the email" button on cross-app thank you screen
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/p-vjERubJyn4Xw3Rg0ORz}
   */
  function crossusageEmailTrigger(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("CrossUsage email trigger", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mode",
        "grade",
        "elaGrade",
        "mathGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "p-vjERubJyn4Xw3Rg0ORz", "24fc4b0cb5a74d2b723e237c7a9d7b9b43e51f8b402f141ac88289fc94b3be9d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("CrossUsage email trigger", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Mode": properties.mode,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("p-vjERubJyn4Xw3Rg0ORz", "CrossUsage email trigger", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'CrossUsage email trigger': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("CrossUsage email trigger", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Mode": properties.mode,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Screen Height": sysScreenHeight,
          }, "p-vjERubJyn4Xw3Rg0ORz", "24fc4b0cb5a74d2b723e237c7a9d7b9b43e51f8b402f141ac88289fc94b3be9d");
      }
      // destination CustomDestination
      CustomDestination.logEvent("CrossUsage email trigger", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Mode": properties.mode,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Visited OTP Screen Guest: This event will get fired on guest profile when ptl parent user is displayed email verification page after successful signup
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/LWEfPLxgbSyEwAN6wRQ6c/trigger/Z7qImrfm6LBlBGKb9RQ0V
   * 2. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/LWEfPLxgbSyEwAN6wRQ6c/trigger/fH9rjDlMOsHSHh05IPI5P
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.invitationSource - This property returns the type of invite sent from the student roster page
   * @param {string} properties.referrerPage - Shows the description of the previous page name/URL
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/LWEfPLxgbSyEwAN6wRQ6c}
   */
  function visitedOtpScreenGuest(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertInvitationSource(properties.invitationSource));
      messages = messages.concat(assertReferrerPage(properties.referrerPage));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Visited OTP Screen Guest", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "invitationSource",
        "referrerPage",
        "mode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "LWEfPLxgbSyEwAN6wRQ6c", "180a4590199c7dce7b3b8a875865a4e42c42ea0b627cc0ec5c4aa924a6ab64e3", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Visited OTP Screen Guest", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Invitation Source": properties.invitationSource,
        "Referrer Page": properties.referrerPage,
        "Mode": properties.mode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("LWEfPLxgbSyEwAN6wRQ6c", "Visited OTP Screen Guest", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "cYVv-jM3n6", name: "Referrer Page", value: properties.referrerPage},
        {id: "cccDu2odc", name: "Invitation Source", value: properties.invitationSource},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Visited OTP Screen Guest': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Visited OTP Screen Guest", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Invitation Source": properties.invitationSource,
          "Referrer Page": properties.referrerPage,
          "Mode": properties.mode,
          "Screen Height": sysScreenHeight,
          }, "LWEfPLxgbSyEwAN6wRQ6c", "180a4590199c7dce7b3b8a875865a4e42c42ea0b627cc0ec5c4aa924a6ab64e3");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Visited OTP Screen Guest", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Invitation Source": properties.invitationSource,
      "Referrer Page": properties.referrerPage,
      "Mode": properties.mode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted OTP Page Guest: This event will get fired on guest profile when user clicks on resend email/Change email/Submit button on the OTP password page
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/u6-Em0HdqUqDzmIgTFAXN/trigger/tTj4ARQ5LE6waKXHqgFKc
   * 2. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/u6-Em0HdqUqDzmIgTFAXN/trigger/UO3h7dDxE7BLzREtE9KWm
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.invitationSource - This property returns the type of invite sent from the student roster page
   * @param {string} properties.referrerPage - Shows the description of the previous page name/URL
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/u6-Em0HdqUqDzmIgTFAXN}
   */
  function interactedOtpPageGuest(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertInvitationSource(properties.invitationSource));
      messages = messages.concat(assertReferrerPage(properties.referrerPage));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted OTP Page Guest", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "invitationSource",
        "referrerPage",
        "clickedOn",
        "mode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "u6-Em0HdqUqDzmIgTFAXN", "95fa7b2991055edcc0c4eb941b5f4d06179a2b594098a98c261ee6aa3c766037", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted OTP Page Guest", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Invitation Source": properties.invitationSource,
        "Referrer Page": properties.referrerPage,
        "Clicked On": properties.clickedOn,
        "Mode": properties.mode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("u6-Em0HdqUqDzmIgTFAXN", "Interacted OTP Page Guest", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "cYVv-jM3n6", name: "Referrer Page", value: properties.referrerPage},
        {id: "cccDu2odc", name: "Invitation Source", value: properties.invitationSource},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted OTP Page Guest': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted OTP Page Guest", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Invitation Source": properties.invitationSource,
          "Referrer Page": properties.referrerPage,
          "Clicked On": properties.clickedOn,
          "Mode": properties.mode,
          "Screen Height": sysScreenHeight,
          }, "u6-Em0HdqUqDzmIgTFAXN", "95fa7b2991055edcc0c4eb941b5f4d06179a2b594098a98c261ee6aa3c766037");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted OTP Page Guest", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Invitation Source": properties.invitationSource,
      "Referrer Page": properties.referrerPage,
      "Clicked On": properties.clickedOn,
      "Mode": properties.mode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Class Selection via Student Experience : user views class selection screen via student exp flow
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/46cdebac-37b4-4d69-a16f-353cc93726ac/trigger/KSVicOOP-wAz-DOqWh24a
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * @param {string} properties.section - This will capture the widget name that is being viewed/interacted by the user in that viewport. For example, 'Onboarding Widget', 'Home Access Widget', 'Assignment Widget', 'Assessment Widget', 'Math Fact Widget'
The list will only have 1 value for 'Section' property for Interacted event.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/46cdebac-37b4-4d69-a16f-353cc93726ac}
   */
  function viewedClassSelectionViaStudentExperience(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertSection(properties.section));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Class Selection via Student Experience ", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "fromPage",
        "section"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "46cdebac-37b4-4d69-a16f-353cc93726ac", "21d2ec20eb030d29599142818d9d14a24586948c140cb0d452c8b85f558bfc82", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Class Selection via Student Experience ", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From Page": properties.fromPage,
        "Section": properties.section,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("46cdebac-37b4-4d69-a16f-353cc93726ac", "Viewed Class Selection via Student Experience ", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "my9qL7M8w6", name: "Section", value: properties.section},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Class Selection via Student Experience ': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Class Selection via Student Experience ", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From Page": properties.fromPage,
          "Section": properties.section,
          "Screen Height": sysScreenHeight,
          }, "46cdebac-37b4-4d69-a16f-353cc93726ac", "21d2ec20eb030d29599142818d9d14a24586948c140cb0d452c8b85f558bfc82");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Class Selection via Student Experience ", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From Page": properties.fromPage,
      "Section": properties.section,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Student Selection via Student Experience: user views student selection screen via student exp flow
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/t146PVHKD_Sg85NhK7-Fv/trigger/pecfNs4R6jn6maNdhSVDP
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.section - This will capture the widget name that is being viewed/interacted by the user in that viewport. For example, 'Onboarding Widget', 'Home Access Widget', 'Assignment Widget', 'Assessment Widget', 'Math Fact Widget'
The list will only have 1 value for 'Section' property for Interacted event.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/t146PVHKD_Sg85NhK7-Fv}
   */
  function viewedStudentSelectionViaStudentExperience(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertSection(properties.section));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Student Selection via Student Experience", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "section",
        "fromPage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "t146PVHKD_Sg85NhK7-Fv", "1b7f9ac29e08c858bf071624790d2aa40cc0c91966426ee82dec25c67d1fd99c", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Student Selection via Student Experience", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Section": properties.section,
        "From Page": properties.fromPage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("t146PVHKD_Sg85NhK7-Fv", "Viewed Student Selection via Student Experience", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "my9qL7M8w6", name: "Section", value: properties.section},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Student Selection via Student Experience': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Student Selection via Student Experience", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Section": properties.section,
          "From Page": properties.fromPage,
          "Screen Height": sysScreenHeight,
          }, "t146PVHKD_Sg85NhK7-Fv", "1b7f9ac29e08c858bf071624790d2aa40cc0c91966426ee82dec25c67d1fd99c");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Student Selection via Student Experience", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Section": properties.section,
      "From Page": properties.fromPage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Student Selection via Student Experience: user clicks on any action from student selection screen via student exp flow
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/5mteQu-7duYZqEbOCFcRF/trigger/bd3XaOFfDL6_IQCt0NTH-
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.section - This will capture the widget name that is being viewed/interacted by the user in that viewport. For example, 'Onboarding Widget', 'Home Access Widget', 'Assignment Widget', 'Assessment Widget', 'Math Fact Widget'
The list will only have 1 value for 'Section' property for Interacted event.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/5mteQu-7duYZqEbOCFcRF}
   */
  function interactedStudentSelectionViaStudentExperience(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertSection(properties.section));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Student Selection via Student Experience", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "section"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "5mteQu-7duYZqEbOCFcRF", "c2dad6005479c5f7da3b053be03049f35f61e8560e48542123df409207d0dc6c", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Student Selection via Student Experience", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Section": properties.section,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("5mteQu-7duYZqEbOCFcRF", "Interacted Student Selection via Student Experience", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "my9qL7M8w6", name: "Section", value: properties.section},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Student Selection via Student Experience': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Student Selection via Student Experience", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Section": properties.section,
          "Screen Height": sysScreenHeight,
          }, "5mteQu-7duYZqEbOCFcRF", "c2dad6005479c5f7da3b053be03049f35f61e8560e48542123df409207d0dc6c");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Student Selection via Student Experience", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Section": properties.section,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Class Selection via Student Experience: user clicks on any action from class selection screen via student exp flow
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.section - This will capture the widget name that is being viewed/interacted by the user in that viewport. For example, 'Onboarding Widget', 'Home Access Widget', 'Assignment Widget', 'Assessment Widget', 'Math Fact Widget'
The list will only have 1 value for 'Section' property for Interacted event.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/cc83fd50-a89a-4b85-aaae-b498d01f2459}
   */
  function interactedClassSelectionViaStudentExperience(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertSection(properties.section));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Class Selection via Student Experience", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "section"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "cc83fd50-a89a-4b85-aaae-b498d01f2459", "ae8367abe418ca819821ddd3266b9a26c28239a358840afc1bfe727e6fe86829", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Class Selection via Student Experience", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Section": properties.section,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("cc83fd50-a89a-4b85-aaae-b498d01f2459", "Interacted Class Selection via Student Experience", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "my9qL7M8w6", name: "Section", value: properties.section},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Class Selection via Student Experience': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Class Selection via Student Experience", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Section": properties.section,
          "Screen Height": sysScreenHeight,
          }, "cc83fd50-a89a-4b85-aaae-b498d01f2459", "ae8367abe418ca819821ddd3266b9a26c28239a358840afc1bfe727e6fe86829");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Class Selection via Student Experience", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Section": properties.section,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Tiled Dashboard via Student Expereince: teacher lands on child dashboard from student exp flow
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/sQpmkEEW21qez5YuiKd9j/trigger/g4ntZcHV1euH1m4inyMFW
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.section - This will capture the widget name that is being viewed/interacted by the user in that viewport. For example, 'Onboarding Widget', 'Home Access Widget', 'Assignment Widget', 'Assessment Widget', 'Math Fact Widget'
The list will only have 1 value for 'Section' property for Interacted event.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/sQpmkEEW21qez5YuiKd9j}
   */
  function viewedTiledDashboardViaStudentExpereince(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertSection(properties.section));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Tiled Dashboard via Student Expereince", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "section"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "sQpmkEEW21qez5YuiKd9j", "cf1474b2c94d60ad1981cc7d1df6adc282682507bb53023bb739f792f11ad360", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Tiled Dashboard via Student Expereince", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Section": properties.section,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("sQpmkEEW21qez5YuiKd9j", "Viewed Tiled Dashboard via Student Expereince", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "my9qL7M8w6", name: "Section", value: properties.section},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Tiled Dashboard via Student Expereince': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Tiled Dashboard via Student Expereince", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Section": properties.section,
          "Screen Height": sysScreenHeight,
          }, "sQpmkEEW21qez5YuiKd9j", "cf1474b2c94d60ad1981cc7d1df6adc282682507bb53023bb739f792f11ad360");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Tiled Dashboard via Student Expereince", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Section": properties.section,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Welcome Screen: This event gets fired when user lands on the Welcome screen where Splashee introduces the quest.
   * 
   * When to trigger this event:
   * 1. User lands on the welcome screen
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/7J47821YTZULMpjInvx__/trigger/6RfKHXJGmZm5Z12j-Ek-t
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {bool} properties.firstQuest - This stores True or False. If this is the first quest ever, it stores true otherwise false
   * @param {int} properties.targetValue - This stores today's target value
   * @param {int} properties.childLevel - This stores the level of the child
   * @param {int} properties.snCount - This stores the count of super novas a child has
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.questType - This stores the type of quest. If it is Coin Quest, Spark Quest or Level Quest
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/7J47821YTZULMpjInvx__}
   */
  function viewedWelcomeScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertFirstQuest(properties.firstQuest));
      messages = messages.concat(assertTargetValue(properties.targetValue));
      messages = messages.concat(assertChildLevel(properties.childLevel));
      messages = messages.concat(assertSnCount(properties.snCount));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertQuestType(properties.questType));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Welcome Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "firstQuest",
        "targetValue",
        "childLevel",
        "snCount",
        "grade",
        "elaGrade",
        "questType"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "7J47821YTZULMpjInvx__", "05505b29d6aaa81df78eb48b05512d164fc62c70a7c99825e35acf0587548aa1", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Welcome Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "First Quest": properties.firstQuest,
        "Target Value": properties.targetValue,
        "Child Level": properties.childLevel,
        "Sn Count": properties.snCount,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Quest Type": properties.questType,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("7J47821YTZULMpjInvx__", "Viewed Welcome Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "6JT-uGIorzYZLeLKXO-mB", name: "Quest Type", value: properties.questType},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "fIB6sY9mt", name: "Child Level", value: properties.childLevel},
        {id: "ggXrRwik-", name: "Sn Count", value: properties.snCount},
        {id: "hr6uH-iMXnpBW1gQsWcLH", name: "First Quest", value: properties.firstQuest},
        {id: "m8wssFRvZ8wgHs0IAO2mi", name: "Target Value", value: properties.targetValue},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Welcome Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Welcome Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "First Quest": properties.firstQuest,
          "Target Value": properties.targetValue,
          "Child Level": properties.childLevel,
          "Sn Count": properties.snCount,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Quest Type": properties.questType,
          "Screen Height": sysScreenHeight,
          }, "7J47821YTZULMpjInvx__", "05505b29d6aaa81df78eb48b05512d164fc62c70a7c99825e35acf0587548aa1");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Welcome Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "First Quest": properties.firstQuest,
      "Target Value": properties.targetValue,
      "Child Level": properties.childLevel,
      "Sn Count": properties.snCount,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Quest Type": properties.questType,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Quest Action Taken: This event gets fired when user takes any action on the quest - accepts or rejects it
   * 
   * When to trigger this event:
   * 1. When user accepts or rejects the quest
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/K_iOCYESwdL5IfrM2cY0d/trigger/gTnl2lCpJSBIPZQiPfExC
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {bool} properties.firstQuest - This stores True or False. If this is the first quest ever, it stores true otherwise false
   * @param {string} properties.questType - This stores the type of quest. If it is Coin Quest, Spark Quest or Level Quest
   * @param {int} properties.targetValue - This stores today's target value
   * @param {int} properties.childLevel - This stores the level of the child
   * @param {int} properties.snCount - This stores the count of super novas a child has
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/K_iOCYESwdL5IfrM2cY0d}
   */
  function questActionTaken(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertFirstQuest(properties.firstQuest));
      messages = messages.concat(assertQuestType(properties.questType));
      messages = messages.concat(assertTargetValue(properties.targetValue));
      messages = messages.concat(assertChildLevel(properties.childLevel));
      messages = messages.concat(assertSnCount(properties.snCount));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Quest Action Taken", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "clickedOn",
        "from",
        "firstQuest",
        "questType",
        "targetValue",
        "childLevel",
        "snCount",
        "grade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "K_iOCYESwdL5IfrM2cY0d", "a4e62b811b7fdea2455e4a1830237c0d258d1ee3b98ae46228caee2c2606d645", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Quest Action Taken", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Clicked On": properties.clickedOn,
        "From": properties.from,
        "First Quest": properties.firstQuest,
        "Quest Type": properties.questType,
        "Target Value": properties.targetValue,
        "Child Level": properties.childLevel,
        "Sn Count": properties.snCount,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("K_iOCYESwdL5IfrM2cY0d", "Quest Action Taken", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "6JT-uGIorzYZLeLKXO-mB", name: "Quest Type", value: properties.questType},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "fIB6sY9mt", name: "Child Level", value: properties.childLevel},
        {id: "ggXrRwik-", name: "Sn Count", value: properties.snCount},
        {id: "hr6uH-iMXnpBW1gQsWcLH", name: "First Quest", value: properties.firstQuest},
        {id: "m8wssFRvZ8wgHs0IAO2mi", name: "Target Value", value: properties.targetValue},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Quest Action Taken': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Quest Action Taken", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Clicked On": properties.clickedOn,
          "From": properties.from,
          "First Quest": properties.firstQuest,
          "Quest Type": properties.questType,
          "Target Value": properties.targetValue,
          "Child Level": properties.childLevel,
          "Sn Count": properties.snCount,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "K_iOCYESwdL5IfrM2cY0d", "a4e62b811b7fdea2455e4a1830237c0d258d1ee3b98ae46228caee2c2606d645");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Quest Action Taken", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Clicked On": properties.clickedOn,
      "From": properties.from,
      "First Quest": properties.firstQuest,
      "Quest Type": properties.questType,
      "Target Value": properties.targetValue,
      "Child Level": properties.childLevel,
      "Sn Count": properties.snCount,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Daily Quest Page: This event gets fired when user taps on the quest header widget and lands on a page that we are calling daily quest page
   * 
   * When to trigger this event:
   * 1. When user lands on this page from the click on the quest widget on the header on dashboard.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/iqJkX5pp5lfYaL1k5Tn1P/trigger/hnk8rrh8Zjxq9cAhvPZmN
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {int} properties.targetValueAchieved - This property stores the XPs and Coins accrued as part of today's quest
   * @param {bool} properties.firstQuest - This stores True or False. If this is the first quest ever, it stores true otherwise false
   * @param {string} properties.questType - This stores the type of quest. If it is Coin Quest, Spark Quest or Level Quest
   * @param {int} properties.targetValue - This stores today's target value
   * @param {int} properties.childLevel - This stores the level of the child
   * @param {int} properties.snCount - This stores the count of super novas a child has
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/iqJkX5pp5lfYaL1k5Tn1P}
   */
  function viewedDailyQuestPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertTargetValueAchieved(properties.targetValueAchieved));
      messages = messages.concat(assertFirstQuest(properties.firstQuest));
      messages = messages.concat(assertQuestType(properties.questType));
      messages = messages.concat(assertTargetValue(properties.targetValue));
      messages = messages.concat(assertChildLevel(properties.childLevel));
      messages = messages.concat(assertSnCount(properties.snCount));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Daily Quest Page", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "grade",
        "elaGrade",
        "targetValueAchieved",
        "firstQuest",
        "questType",
        "targetValue",
        "childLevel",
        "snCount"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "iqJkX5pp5lfYaL1k5Tn1P", "e000f71498aea83e9da807a4eb5b6d56dce7e2202844e43280c0a6493b28f829", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Daily Quest Page", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Target Value Achieved": properties.targetValueAchieved,
        "First Quest": properties.firstQuest,
        "Quest Type": properties.questType,
        "Target Value": properties.targetValue,
        "Child Level": properties.childLevel,
        "Sn Count": properties.snCount,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("iqJkX5pp5lfYaL1k5Tn1P", "Viewed Daily Quest Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "6JT-uGIorzYZLeLKXO-mB", name: "Quest Type", value: properties.questType},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "fIB6sY9mt", name: "Child Level", value: properties.childLevel},
        {id: "fyvryNv-n-eInsoGrt_P5", name: "Target Value Achieved", value: properties.targetValueAchieved},
        {id: "ggXrRwik-", name: "Sn Count", value: properties.snCount},
        {id: "hr6uH-iMXnpBW1gQsWcLH", name: "First Quest", value: properties.firstQuest},
        {id: "m8wssFRvZ8wgHs0IAO2mi", name: "Target Value", value: properties.targetValue},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Daily Quest Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Daily Quest Page", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Target Value Achieved": properties.targetValueAchieved,
          "First Quest": properties.firstQuest,
          "Quest Type": properties.questType,
          "Target Value": properties.targetValue,
          "Child Level": properties.childLevel,
          "Sn Count": properties.snCount,
          "Screen Height": sysScreenHeight,
          }, "iqJkX5pp5lfYaL1k5Tn1P", "e000f71498aea83e9da807a4eb5b6d56dce7e2202844e43280c0a6493b28f829");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Daily Quest Page", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Target Value Achieved": properties.targetValueAchieved,
      "First Quest": properties.firstQuest,
      "Quest Type": properties.questType,
      "Target Value": properties.targetValue,
      "Child Level": properties.childLevel,
      "Sn Count": properties.snCount,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Daily Quest Page: This event gets fired when the user interacts with the daily quest page
   * 
   * When to trigger this event:
   * 1. When user interacts with this page
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/LdnrwiyhDsAchiC7TQ1J4/trigger/4DwLtW7GqjavGxWfR0Rsf
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {int} properties.targetValue - This stores today's target value
   * @param {bool} properties.firstQuest - This stores True or False. If this is the first quest ever, it stores true otherwise false
   * @param {string} properties.questType - This stores the type of quest. If it is Coin Quest, Spark Quest or Level Quest
   * @param {int} properties.targetValueAchieved - This property stores the XPs and Coins accrued as part of today's quest
   * @param {int} properties.childLevel - This stores the level of the child
   * @param {int} properties.snCount - This stores the count of super novas a child has
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/LdnrwiyhDsAchiC7TQ1J4}
   */
  function interactedDailyQuestPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertTargetValue(properties.targetValue));
      messages = messages.concat(assertFirstQuest(properties.firstQuest));
      messages = messages.concat(assertQuestType(properties.questType));
      messages = messages.concat(assertTargetValueAchieved(properties.targetValueAchieved));
      messages = messages.concat(assertChildLevel(properties.childLevel));
      messages = messages.concat(assertSnCount(properties.snCount));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Daily Quest Page", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "elaGrade",
        "grade",
        "clickedOn",
        "targetValue",
        "firstQuest",
        "questType",
        "targetValueAchieved",
        "childLevel",
        "snCount"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "LdnrwiyhDsAchiC7TQ1J4", "f73556e3158ad103a79319d03aee69295a37c7f5d358ec24cb9c8f24b09728df", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Daily Quest Page", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Clicked On": properties.clickedOn,
        "Target Value": properties.targetValue,
        "First Quest": properties.firstQuest,
        "Quest Type": properties.questType,
        "Target Value Achieved": properties.targetValueAchieved,
        "Child Level": properties.childLevel,
        "Sn Count": properties.snCount,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("LdnrwiyhDsAchiC7TQ1J4", "Interacted Daily Quest Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "6JT-uGIorzYZLeLKXO-mB", name: "Quest Type", value: properties.questType},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "fIB6sY9mt", name: "Child Level", value: properties.childLevel},
        {id: "fyvryNv-n-eInsoGrt_P5", name: "Target Value Achieved", value: properties.targetValueAchieved},
        {id: "ggXrRwik-", name: "Sn Count", value: properties.snCount},
        {id: "hr6uH-iMXnpBW1gQsWcLH", name: "First Quest", value: properties.firstQuest},
        {id: "m8wssFRvZ8wgHs0IAO2mi", name: "Target Value", value: properties.targetValue},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Daily Quest Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Daily Quest Page", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Clicked On": properties.clickedOn,
          "Target Value": properties.targetValue,
          "First Quest": properties.firstQuest,
          "Quest Type": properties.questType,
          "Target Value Achieved": properties.targetValueAchieved,
          "Child Level": properties.childLevel,
          "Sn Count": properties.snCount,
          "Screen Height": sysScreenHeight,
          }, "LdnrwiyhDsAchiC7TQ1J4", "f73556e3158ad103a79319d03aee69295a37c7f5d358ec24cb9c8f24b09728df");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Daily Quest Page", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Clicked On": properties.clickedOn,
      "Target Value": properties.targetValue,
      "First Quest": properties.firstQuest,
      "Quest Type": properties.questType,
      "Target Value Achieved": properties.targetValueAchieved,
      "Child Level": properties.childLevel,
      "Sn Count": properties.snCount,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Parent Menu: When user interacts with the parent button, passes the age gate then Parent menu opens, it's a new page
   * 
   * When to trigger this event:
   * 1. When this page loads
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/31UK2P_OsMTw2dhb0o8Wr/trigger/eUc_-1Q45wAwPOZMiU5uR
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/31UK2P_OsMTw2dhb0o8Wr}
   */
  function viewedParentMenu(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Parent Menu", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "grade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "31UK2P_OsMTw2dhb0o8Wr", "1a612c3d025f3b6b850cfebb48a0a02292489e80941c131ab50a80a06d37f641", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Parent Menu", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("31UK2P_OsMTw2dhb0o8Wr", "Viewed Parent Menu", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Parent Menu': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Parent Menu", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "31UK2P_OsMTw2dhb0o8Wr", "1a612c3d025f3b6b850cfebb48a0a02292489e80941c131ab50a80a06d37f641");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Parent Menu", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Parent Menu: When user interacts with menu options or hits cross
   * 
   * When to trigger this event:
   * 1. When user taps on menu options or hits the cross button
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/bjDCGrPC9V3MKcPHAiMYj/trigger/Qf0aEoFOroeHSvwMBFV1H
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/bjDCGrPC9V3MKcPHAiMYj}
   */
  function interactedParentMenu(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Parent Menu", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "clickedOn",
        "grade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "bjDCGrPC9V3MKcPHAiMYj", "ee30f7cd94e52b3007e27f0131256a3788616fc86fc0a404c3aa3ba7c676dd5d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Parent Menu", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Clicked On": properties.clickedOn,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("bjDCGrPC9V3MKcPHAiMYj", "Interacted Parent Menu", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Parent Menu': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Parent Menu", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Clicked On": properties.clickedOn,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "bjDCGrPC9V3MKcPHAiMYj", "ee30f7cd94e52b3007e27f0131256a3788616fc86fc0a404c3aa3ba7c676dd5d");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Parent Menu", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Clicked On": properties.clickedOn,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Sound Not Found: This event gets fired when sound is not received from cdn for the quest intro.
   * 
   * When to trigger this event:
   * 1. Sound is not received from cdn
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/z2lSFGY9KzP-ey_Ybb00J/trigger/nq06SIt2MSPRtHlUMUQdr
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.fileName - This stores the name of the audio file
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/z2lSFGY9KzP-ey_Ybb00J}
   */
  function soundNotFound(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertFileName(properties.fileName));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Sound Not Found", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "fileName",
        "grade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "z2lSFGY9KzP-ey_Ybb00J", "1ed4cd884ee9d9064d6b20ffd70ba1a1c8e06f9cf540e225c8102d30f83f8f1b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Sound Not Found", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "File Name": properties.fileName,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("z2lSFGY9KzP-ey_Ybb00J", "Sound Not Found", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "HGBR29ljk7ONEgZDhxExr", name: "File Name", value: properties.fileName},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Sound Not Found': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Sound Not Found", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "File Name": properties.fileName,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "z2lSFGY9KzP-ey_Ybb00J", "1ed4cd884ee9d9064d6b20ffd70ba1a1c8e06f9cf540e225c8102d30f83f8f1b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Sound Not Found", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "File Name": properties.fileName,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Book Library [Teacher]: When a teacher lands on book library page
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/wbB1TuQTBzqwZf2HLN5RB/trigger/_4uAw6593SEnhBdwq8yDL
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.pageName - Includes the name of the page (Eg: Playzone game listing page, ). This is not the URL but a easily understandable definition of what page is the user at.
   * @param {object} properties.filtersApplied - All the filters that are applied for the page being viewed
   * @param {string} properties.searchTerm - Term searched by the user
   * @param {int} properties.numberOfResults - Number of results shown for search results
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {Array<string>} properties.readingLevel - Reading level like grade 2, grade 3 level, GRL A-C etc of the user
   * @param {string} properties.readingSystem - Reading system like lexile / GRL / Grade Level etc
   * @param {string} properties.tabName - Tab that the user has selected like Recommended / Audio books / Interactive books etc
   * @param {string} properties.categoryName - For Book Library
Category of the books like Animals, People and Culture etc

For Avatar Space
This property stores the categories within closer such as shirt, pant, goggles, hat, etc.

   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * @param {string} properties.topTab - Top horizontal tabs that user has interacted with on teacher product
   * @param {string} properties.section - This will capture the widget name that is being viewed/interacted by the user in that viewport. For example, 'Onboarding Widget', 'Home Access Widget', 'Assignment Widget', 'Assessment Widget', 'Math Fact Widget'
The list will only have 1 value for 'Section' property for Interacted event.
   * @param {string} properties.readingSkill - List of CCSS skills related to reading
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/wbB1TuQTBzqwZf2HLN5RB}
   */
  function viewedBookLibraryTeacher(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPageName(properties.pageName));
      messages = messages.concat(assertFiltersApplied(properties.filtersApplied));
      messages = messages.concat(assertSearchTerm(properties.searchTerm));
      messages = messages.concat(assertNumberOfResults(properties.numberOfResults));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertReadingLevel(properties.readingLevel));
      messages = messages.concat(assertReadingSystem(properties.readingSystem));
      messages = messages.concat(assertTabName(properties.tabName));
      messages = messages.concat(assertCategoryName(properties.categoryName));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertTopTab(properties.topTab));
      messages = messages.concat(assertSection(properties.section));
      messages = messages.concat(assertReadingSkill(properties.readingSkill));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Book Library [Teacher]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "pageName",
        "filtersApplied",
        "searchTerm",
        "numberOfResults",
        "from",
        "readingLevel",
        "readingSystem",
        "tabName",
        "categoryName",
        "fromPage",
        "topTab",
        "section",
        "readingSkill"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "wbB1TuQTBzqwZf2HLN5RB", "d98fc060b66ed873b9f2ebc0263c64103ea8d85bfde924913b60175302caf58b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Book Library [Teacher]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Page Name": properties.pageName,
        "Filters Applied": properties.filtersApplied,
        "Search Term": properties.searchTerm,
        "Number of Results": properties.numberOfResults,
        "From": properties.from,
        "Reading Level": properties.readingLevel,
        "Reading System": properties.readingSystem,
        "Tab Name": properties.tabName,
        "Category Name": properties.categoryName,
        "From Page": properties.fromPage,
        "Top Tab": properties.topTab,
        "Section": properties.section,
        "Reading Skill": properties.readingSkill,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("wbB1TuQTBzqwZf2HLN5RB", "Viewed Book Library [Teacher]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "8Mz1CdVTk", name: "Tab Name", value: properties.tabName},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "MJKSzmqfHu", name: "Page Name", value: properties.pageName},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "TYsaD1VcN", name: "Reading Level", value: properties.readingLevel},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "UtPMQu4JE", name: "Number of Results", value: properties.numberOfResults},
        {id: "aX1-5O7eP", name: "Filters Applied", value: properties.filtersApplied},
        {id: "bJOqfTjmu", name: "Reading System", value: properties.readingSystem},
        {id: "ctnr0D9n3", name: "Top Tab", value: properties.topTab},
        {id: "guJOTwi5T", name: "Search Term", value: properties.searchTerm},
        {id: "kZQO8-HD9", name: "Category Name", value: properties.categoryName},
        {id: "my9qL7M8w6", name: "Section", value: properties.section},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "tt7EpUhgU", name: "Reading Skill", value: properties.readingSkill},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Book Library [Teacher]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Book Library [Teacher]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Page Name": properties.pageName,
          "Filters Applied": properties.filtersApplied,
          "Search Term": properties.searchTerm,
          "Number of Results": properties.numberOfResults,
          "From": properties.from,
          "Reading Level": properties.readingLevel,
          "Reading System": properties.readingSystem,
          "Tab Name": properties.tabName,
          "Category Name": properties.categoryName,
          "From Page": properties.fromPage,
          "Top Tab": properties.topTab,
          "Section": properties.section,
          "Reading Skill": properties.readingSkill,
          "Screen Height": sysScreenHeight,
          }, "wbB1TuQTBzqwZf2HLN5RB", "d98fc060b66ed873b9f2ebc0263c64103ea8d85bfde924913b60175302caf58b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Book Library [Teacher]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Page Name": properties.pageName,
      "Filters Applied": properties.filtersApplied,
      "Search Term": properties.searchTerm,
      "Number of Results": properties.numberOfResults,
      "From": properties.from,
      "Reading Level": properties.readingLevel,
      "Reading System": properties.readingSystem,
      "Tab Name": properties.tabName,
      "Category Name": properties.categoryName,
      "From Page": properties.fromPage,
      "Top Tab": properties.topTab,
      "Section": properties.section,
      "Reading Skill": properties.readingSkill,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Book Library [Teacher]: When the user clicks/taps on anything in the book library page
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/OybLhLAMWUkJ-b2pkhqAr/trigger/Z1AYRocQXwPU_RqG9mbpN
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {Array<string>} properties.recommendedRailName - This is the name of the rail viewed by the user. 
Recommended rail property comes with rail name and rail rank, pipe separated - with the introduction of this property, we intend to separate rail name to calculate CTR on Mixpanel.
   * @param {string} properties.readingSystem - Reading system like lexile / GRL / Grade Level etc
   * @param {string} properties.valueName - This will capture the value/text of the field that is selected.
   * @param {string} properties.tabName - Tab that the user has selected like Recommended / Audio books / Interactive books etc
   * @param {string} properties.pageName - Includes the name of the page (Eg: Playzone game listing page, ). This is not the URL but a easily understandable definition of what page is the user at.
   * @param {string} properties.categoryName - For Book Library
Category of the books like Animals, People and Culture etc

For Avatar Space
This property stores the categories within closer such as shirt, pant, goggles, hat, etc.

   * @param {string} properties.searchTerm - Term searched by the user
   * @param {int} properties.numberOfResults - Number of results shown for search results
   * @param {object} properties.filtersApplied - All the filters that are applied for the page being viewed
   * @param {string} properties.filterName - Name of the filter that is clicked, eg. theme, fiction/Non-fiction in book library 
   * @param {Array<string>} properties.readingLevel - Reading level like grade 2, grade 3 level, GRL A-C etc of the user
   * @param {string} properties.topTab - Top horizontal tabs that user has interacted with on teacher product
   * @param {string} properties.readingSkill - List of CCSS skills related to reading
   * @param {string} properties.clickSource - This property will be used to identify the click that lead to this popup. The subscription popups can now be seen from various flows like play more on lp, play games again on lp, click on locked cards, save customised setting.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/OybLhLAMWUkJ-b2pkhqAr}
   */
  function interactedBookLibraryTeacher(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertRecommendedRailName(properties.recommendedRailName));
      messages = messages.concat(assertReadingSystem(properties.readingSystem));
      messages = messages.concat(assertValueName(properties.valueName));
      messages = messages.concat(assertTabName(properties.tabName));
      messages = messages.concat(assertPageName(properties.pageName));
      messages = messages.concat(assertCategoryName(properties.categoryName));
      messages = messages.concat(assertSearchTerm(properties.searchTerm));
      messages = messages.concat(assertNumberOfResults(properties.numberOfResults));
      messages = messages.concat(assertFiltersApplied(properties.filtersApplied));
      messages = messages.concat(assertFilterName(properties.filterName));
      messages = messages.concat(assertReadingLevel(properties.readingLevel));
      messages = messages.concat(assertTopTab(properties.topTab));
      messages = messages.concat(assertReadingSkill(properties.readingSkill));
      messages = messages.concat(assertClickSource(properties.clickSource));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Book Library [Teacher]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "clickedOn",
        "recommendedRailName",
        "readingSystem",
        "valueName",
        "tabName",
        "pageName",
        "categoryName",
        "searchTerm",
        "numberOfResults",
        "filtersApplied",
        "filterName",
        "readingLevel",
        "topTab",
        "readingSkill",
        "clickSource"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "OybLhLAMWUkJ-b2pkhqAr", "5a5379b3533b3a99e10f758dbb795abb1fde170c299716192fc5e2e5e23ff5a6", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Book Library [Teacher]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Clicked On": properties.clickedOn,
        "Recommended Rail Name": properties.recommendedRailName,
        "Reading System": properties.readingSystem,
        "Value Name": properties.valueName,
        "Tab Name": properties.tabName,
        "Page Name": properties.pageName,
        "Category Name": properties.categoryName,
        "Search Term": properties.searchTerm,
        "Number of Results": properties.numberOfResults,
        "Filters Applied": properties.filtersApplied,
        "Filter Name": properties.filterName,
        "Reading Level": properties.readingLevel,
        "Top Tab": properties.topTab,
        "Reading Skill": properties.readingSkill,
        "Click Source": properties.clickSource,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("OybLhLAMWUkJ-b2pkhqAr", "Interacted Book Library [Teacher]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "6lrsWYY5Y", name: "Recommended Rail Name", value: properties.recommendedRailName},
        {id: "8Mz1CdVTk", name: "Tab Name", value: properties.tabName},
        {id: "MJKSzmqfHu", name: "Page Name", value: properties.pageName},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "TYsaD1VcN", name: "Reading Level", value: properties.readingLevel},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "UtPMQu4JE", name: "Number of Results", value: properties.numberOfResults},
        {id: "aX1-5O7eP", name: "Filters Applied", value: properties.filtersApplied},
        {id: "bJOqfTjmu", name: "Reading System", value: properties.readingSystem},
        {id: "ctnr0D9n3", name: "Top Tab", value: properties.topTab},
        {id: "guJOTwi5T", name: "Search Term", value: properties.searchTerm},
        {id: "kZQO8-HD9", name: "Category Name", value: properties.categoryName},
        {id: "l-8JNUE0q", name: "Value Name", value: properties.valueName},
        {id: "mVqeh4I8W", name: "Click Source", value: properties.clickSource},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "tt7EpUhgU", name: "Reading Skill", value: properties.readingSkill},
        {id: "xU_rUr8u6", name: "Filter Name", value: properties.filterName},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Book Library [Teacher]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Book Library [Teacher]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Clicked On": properties.clickedOn,
          "Recommended Rail Name": properties.recommendedRailName,
          "Reading System": properties.readingSystem,
          "Value Name": properties.valueName,
          "Tab Name": properties.tabName,
          "Page Name": properties.pageName,
          "Category Name": properties.categoryName,
          "Search Term": properties.searchTerm,
          "Number of Results": properties.numberOfResults,
          "Filters Applied": properties.filtersApplied,
          "Filter Name": properties.filterName,
          "Reading Level": properties.readingLevel,
          "Top Tab": properties.topTab,
          "Reading Skill": properties.readingSkill,
          "Click Source": properties.clickSource,
          "Screen Height": sysScreenHeight,
          }, "OybLhLAMWUkJ-b2pkhqAr", "5a5379b3533b3a99e10f758dbb795abb1fde170c299716192fc5e2e5e23ff5a6");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Book Library [Teacher]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Clicked On": properties.clickedOn,
      "Recommended Rail Name": properties.recommendedRailName,
      "Reading System": properties.readingSystem,
      "Value Name": properties.valueName,
      "Tab Name": properties.tabName,
      "Page Name": properties.pageName,
      "Category Name": properties.categoryName,
      "Search Term": properties.searchTerm,
      "Number of Results": properties.numberOfResults,
      "Filters Applied": properties.filtersApplied,
      "Filter Name": properties.filterName,
      "Reading Level": properties.readingLevel,
      "Top Tab": properties.topTab,
      "Reading Skill": properties.readingSkill,
      "Click Source": properties.clickSource,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Playable Clicked [Teacher]: When the user clicks on a Playable to start it
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {string} properties.contentType - Type of content viz. Game/Learning Path/Activities/Worksheets
   * @param {string} properties.playableCode - Pass the 'Playable Code' of the Playable being started/clicked
   * @param {string} properties.playableName - Name of playable selected
   * @param {Array<string>} properties.recommendedRailName - This is the name of the rail viewed by the user. 
Recommended rail property comes with rail name and rail rank, pipe separated - with the introduction of this property, we intend to separate rail name to calculate CTR on Mixpanel.
   * @param {Array<int>} properties.recommendedRailRank - Recommended Rail Rank will carry the rank of the rail in integer format viewed by the user. 
   * @param {Array<string>} [properties.recommendedTileName] - This property will store the code of the tile user has interacted with - CG code for curriculum rails and game code for non curr. rails

   * @param {Array<int>} properties.recommendedTileRank - This property will store the position of the tile on which user has clciked. Earlier this was sent as column position

   * @param {string} properties.contentGroup - Code of content group user clicked/tapped on
   * @param {string} properties.clickId - unique id associated with distinct clicks on the home dashboard on playables
   * @param {string} properties.gameType - Type of game/playable selected
   * @param {string} properties.playableType - Type of playable selected
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.gameEngine - This property will contain the name of the game engine - unity, phaser, cocos, creator or worksheet

   * @param {string} properties.gameCode - Game code of the playable selected, for example: Math learning games have multiple variations, all those variations will have one game code
   * @param {string} properties.gameName - Name of the Game being tapped (Optional)
   * @param {string} properties.pageName - Includes the name of the page (Eg: Playzone game listing page, ). This is not the URL but a easily understandable definition of what page is the user at.
   * @param {string} properties.assignmentType - This will capture the type of assignment - Manual or Auto
   * @param {float} properties.totalMemory - This property stores the total memory allocated by the client device
   * @param {float} properties.usedMemory - This property stores the memory consumed by the website
   * @param {float} properties.memoryLimit - The max memory allocated by the client device
   * @param {float} properties.memoryUsagePercentage - This property stores the % used memory
   * @param {string} properties.playablePath - This property stores whether the playable is played from the fast path or default path
   * @param {string} properties.playableClickId - This property will hold a unique string for the playable events.
   * @param {string} properties.recommendedVia - This property holds a value when some playable is recommended which would not have in the default setting of the dashboard or CG path. For example, user played a playable on adaptive path, the default path would have recommended a different playable. So in this case, Recommended Via holds 'adaptive'
   * @param {Array<string>} properties.recommendedRail - This property will be used to store which rails were shown to the user in the HOME tab.

Where possible values are:
Rail Name = Curriculum, Game Zone, Math, Language, Logic & Thinking, Art & Creativity, General Knowledge, Motor Skills, Live Classes, Fluency, Multiplayer
This comes with Rank also with | separation
   * @param {string} properties.tabCode - Specifies the tab which has been opened in the event 'Viewed Tiled Dashboard' and Other events too
   * @param {Array<string>} properties.recommendedCategory - This property will be used to store what recommendations were shown to the user in the all tabs.
We'll be saving them in this format:
<Category Name>
where possible values are:
Category name =  MyToDo, Math_LP, ELA_LP, Math Facts, Books, Spelling, Reading Comprehension, Playzone, Activities, Learning Games
   * @param {int} properties.overallClickedCount - Streak count of Playable Clicked in a day from anywhere
   * @param {int} properties.overallStartedCount - Streak count of Playable Started in a day from anywhere
   * @param {int} properties.overallCompletedCount - Streak count of Playable Completed in a day from anywhere
   * @param {string} properties.railCode - Code of the Rail: Debugging purpose
   * @param {string} properties.tileCode - Code of the Tile: Debugging purpose by tech team
   * @param {bool} properties.staleData - in case of api failure in streak data it will set as 1
   * @param {string} properties.recommendationRailCode - This property will capture the code for recommended rails driven by algorithm
   * @param {string} properties.recommendationVersionName - Parent code for different versions of AB test
   * @param {string} properties.recommendationSubVersionName - It is a code that defines different version of different rail on book library dashboard
   * @param {int} properties.recommendationAlgorithmFlag - If a rail is driven by recommendation version then flag will be 1 else 0
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/tLH9WYJnQm4YWx7c8JN5j}
   */
  function playableClickedTeacher(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertContentType(properties.contentType));
      messages = messages.concat(assertPlayableCode(properties.playableCode));
      messages = messages.concat(assertPlayableName(properties.playableName));
      messages = messages.concat(assertRecommendedRailName(properties.recommendedRailName));
      messages = messages.concat(assertRecommendedRailRank(properties.recommendedRailRank));
      messages = messages.concat(assertOptionalRecommendedTileName(properties.recommendedTileName));
      messages = messages.concat(assertRecommendedTileRank(properties.recommendedTileRank));
      messages = messages.concat(assertContentGroup(properties.contentGroup));
      messages = messages.concat(assertClickId(properties.clickId));
      messages = messages.concat(assertGameType(properties.gameType));
      messages = messages.concat(assertPlayableType(properties.playableType));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGameEngine(properties.gameEngine));
      messages = messages.concat(assertGameCode(properties.gameCode));
      messages = messages.concat(assertGameName(properties.gameName));
      messages = messages.concat(assertPageName(properties.pageName));
      messages = messages.concat(assertAssignmentType(properties.assignmentType));
      messages = messages.concat(assertTotalMemory(properties.totalMemory));
      messages = messages.concat(assertUsedMemory(properties.usedMemory));
      messages = messages.concat(assertMemoryLimit(properties.memoryLimit));
      messages = messages.concat(assertMemoryUsagePercentage(properties.memoryUsagePercentage));
      messages = messages.concat(assertPlayablePath(properties.playablePath));
      messages = messages.concat(assertPlayableClickId(properties.playableClickId));
      messages = messages.concat(assertRecommendedVia(properties.recommendedVia));
      messages = messages.concat(assertRecommendedRail(properties.recommendedRail));
      messages = messages.concat(assertTabCode(properties.tabCode));
      messages = messages.concat(assertRecommendedCategory(properties.recommendedCategory));
      messages = messages.concat(assertOverallClickedCount(properties.overallClickedCount));
      messages = messages.concat(assertOverallStartedCount(properties.overallStartedCount));
      messages = messages.concat(assertOverallCompletedCount(properties.overallCompletedCount));
      messages = messages.concat(assertRailCode(properties.railCode));
      messages = messages.concat(assertTileCode(properties.tileCode));
      messages = messages.concat(assertStaleData(properties.staleData));
      messages = messages.concat(assertRecommendationRailCode(properties.recommendationRailCode));
      messages = messages.concat(assertRecommendationVersionName(properties.recommendationVersionName));
      messages = messages.concat(assertRecommendationSubVersionName(properties.recommendationSubVersionName));
      messages = messages.concat(assertRecommendationAlgorithmFlag(properties.recommendationAlgorithmFlag));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Playable Clicked [Teacher]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "from",
        "contentType",
        "playableCode",
        "playableName",
        "recommendedRailName",
        "recommendedRailRank",
        "recommendedTileName",
        "recommendedTileRank",
        "contentGroup",
        "clickId",
        "gameType",
        "playableType",
        "platform",
        "userType",
        "signupFlow",
        "gameEngine",
        "gameCode",
        "gameName",
        "pageName",
        "assignmentType",
        "totalMemory",
        "usedMemory",
        "memoryLimit",
        "memoryUsagePercentage",
        "playablePath",
        "playableClickId",
        "recommendedVia",
        "recommendedRail",
        "tabCode",
        "recommendedCategory",
        "overallClickedCount",
        "overallStartedCount",
        "overallCompletedCount",
        "railCode",
        "tileCode",
        "staleData",
        "recommendationRailCode",
        "recommendationVersionName",
        "recommendationSubVersionName",
        "recommendationAlgorithmFlag"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "tLH9WYJnQm4YWx7c8JN5j", "3731d2faa00c2cb80a50a69e858a6d1dd5803459d410fde4302ee58c86ba2685", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Playable Clicked [Teacher]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "From": properties.from,
        "Content Type": properties.contentType,
        "Playable Code": properties.playableCode,
        "Playable Name": properties.playableName,
        "Recommended Rail Name": properties.recommendedRailName,
        "Recommended Rail Rank": properties.recommendedRailRank,
        "Recommended Tile Name": properties.recommendedTileName,
        "Recommended Tile Rank": properties.recommendedTileRank,
        "Content Group": properties.contentGroup,
        "Click Id": properties.clickId,
        "Game Type": properties.gameType,
        "Playable Type": properties.playableType,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Game Engine": properties.gameEngine,
        "Game Code": properties.gameCode,
        "Game Name": properties.gameName,
        "Page Name": properties.pageName,
        "Assignment Type": properties.assignmentType,
        "Total Memory": properties.totalMemory,
        "Used Memory": properties.usedMemory,
        "Memory Limit": properties.memoryLimit,
        "Memory Usage Percentage": properties.memoryUsagePercentage,
        "Playable Path": properties.playablePath,
        "Playable Click Id": properties.playableClickId,
        "Recommended Via": properties.recommendedVia,
        "Recommended Rail": properties.recommendedRail,
        "Tab Code": properties.tabCode,
        "Recommended Category": properties.recommendedCategory,
        "Overall Clicked Count": properties.overallClickedCount,
        "Overall Started Count": properties.overallStartedCount,
        "Overall Completed Count": properties.overallCompletedCount,
        "Rail Code": properties.railCode,
        "Tile Code": properties.tileCode,
        "Stale Data": properties.staleData,
        "Recommendation Rail Code": properties.recommendationRailCode,
        "Recommendation Version Name": properties.recommendationVersionName,
        "Recommendation Sub Version Name": properties.recommendationSubVersionName,
        "Recommendation Algorithm Flag": properties.recommendationAlgorithmFlag,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("tLH9WYJnQm4YWx7c8JN5j", "Playable Clicked [Teacher]", messages, [
        {id: "2da5NLAEc", name: "Game Type", value: properties.gameType},
        {id: "2hMTTBgU30", name: "Total Memory", value: properties.totalMemory},
        {id: "2oZQdvXRu", name: "Game Code", value: properties.gameCode},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "6lrsWYY5Y", name: "Recommended Rail Name", value: properties.recommendedRailName},
        {id: "ADfS21LlJH", name: "Memory Limit", value: properties.memoryLimit},
        {id: "BchWbNpV0WYRnYxTnBQ-c", name: "Recommendation Sub Version Name", value: properties.recommendationSubVersionName},
        {id: "CptvN7aTfWej4MrTLiZsM", name: "Recommended Via", value: properties.recommendedVia},
        {id: "CxhubqT3Hp", name: "Playable Path", value: properties.playablePath},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "FH6REXldlxqxCPK0pvsML", name: "Recommendation Version Name", value: properties.recommendationVersionName},
        {id: "FLDtSJNKL", name: "Recommended Tile Rank", value: properties.recommendedTileRank},
        {id: "GJYEymipLkc1xy54AyhV8", name: "Tile Code", value: properties.tileCode},
        {id: "HJUIBmGrsUmqa_TYCtwQ0", name: "Overall Started Count", value: properties.overallStartedCount},
        {id: "JVkBdMN1_", name: "Game Engine", value: properties.gameEngine},
        {id: "MJKSzmqfHu", name: "Page Name", value: properties.pageName},
        {id: "Nfs9QLl8W7", name: "Content Type", value: properties.contentType},
        {id: "OHBx0fnhzlxvHhw0e87pM", name: "Overall Completed Count", value: properties.overallCompletedCount},
        {id: "Otu1r2JQW", name: "Content Group", value: properties.contentGroup},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "Q2q6j4dEnjH8uo-MY-mr7", name: "Recommendation Algorithm Flag", value: properties.recommendationAlgorithmFlag},
        {id: "QDMKmRkRjbW4pFvqlGOM6", name: "Rail Code", value: properties.railCode},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "QQeu-Td4-0", name: "Playable Click Id", value: properties.playableClickId},
        {id: "QjCwFasvW0", name: "Playable Code", value: properties.playableCode},
        {id: "Qwa4E7UWbmonbiv7JbciC", name: "Recommendation Rail Code", value: properties.recommendationRailCode},
        {id: "TYbmk5DQn", name: "Recommended Tile Name", value: properties.recommendedTileName},
        {id: "Ueowl7sRb", name: "Assignment Type", value: properties.assignmentType},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "VdJhEU0H6s", name: "Recommended Category", value: properties.recommendedCategory},
        {id: "X4kgAx81N5AHgcI6NaNiS", name: "Overall Clicked Count", value: properties.overallClickedCount},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "amiw6GdIfAgKr7MxhRYGM", name: "Stale Data", value: properties.staleData},
        {id: "c2W4X05Jy", name: "Playable Name", value: properties.playableName},
        {id: "drNgwJn5Xg", name: "Recommended Rail", value: properties.recommendedRail},
        {id: "fXWDPkk_PZ", name: "Memory Usage Percentage", value: properties.memoryUsagePercentage},
        {id: "gvDk2xQI4d", name: "Used Memory", value: properties.usedMemory},
        {id: "jVQaLzj_1", name: "Click Id", value: properties.clickId},
        {id: "l9PbANZBu", name: "Tab Code", value: properties.tabCode},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "tHAI3DRE4", name: "Playable Type", value: properties.playableType},
        {id: "uyLgqxbg7", name: "Recommended Rail Rank", value: properties.recommendedRailRank},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Playable Clicked [Teacher]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Playable Clicked [Teacher]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "From": properties.from,
          "Content Type": properties.contentType,
          "Playable Code": properties.playableCode,
          "Playable Name": properties.playableName,
          "Recommended Rail Name": properties.recommendedRailName,
          "Recommended Rail Rank": properties.recommendedRailRank,
          "Recommended Tile Name": properties.recommendedTileName,
          "Recommended Tile Rank": properties.recommendedTileRank,
          "Content Group": properties.contentGroup,
          "Click Id": properties.clickId,
          "Game Type": properties.gameType,
          "Playable Type": properties.playableType,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Game Engine": properties.gameEngine,
          "Game Code": properties.gameCode,
          "Game Name": properties.gameName,
          "Page Name": properties.pageName,
          "Assignment Type": properties.assignmentType,
          "Total Memory": properties.totalMemory,
          "Used Memory": properties.usedMemory,
          "Memory Limit": properties.memoryLimit,
          "Memory Usage Percentage": properties.memoryUsagePercentage,
          "Playable Path": properties.playablePath,
          "Playable Click Id": properties.playableClickId,
          "Recommended Via": properties.recommendedVia,
          "Recommended Rail": properties.recommendedRail,
          "Tab Code": properties.tabCode,
          "Recommended Category": properties.recommendedCategory,
          "Overall Clicked Count": properties.overallClickedCount,
          "Overall Started Count": properties.overallStartedCount,
          "Overall Completed Count": properties.overallCompletedCount,
          "Rail Code": properties.railCode,
          "Tile Code": properties.tileCode,
          "Stale Data": properties.staleData,
          "Recommendation Rail Code": properties.recommendationRailCode,
          "Recommendation Version Name": properties.recommendationVersionName,
          "Recommendation Sub Version Name": properties.recommendationSubVersionName,
          "Recommendation Algorithm Flag": properties.recommendationAlgorithmFlag,
          "Screen Height": sysScreenHeight,
          }, "tLH9WYJnQm4YWx7c8JN5j", "3731d2faa00c2cb80a50a69e858a6d1dd5803459d410fde4302ee58c86ba2685");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Playable Clicked [Teacher]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "From": properties.from,
      "Content Type": properties.contentType,
      "Playable Code": properties.playableCode,
      "Playable Name": properties.playableName,
      "Recommended Rail Name": properties.recommendedRailName,
      "Recommended Rail Rank": properties.recommendedRailRank,
      "Recommended Tile Name": properties.recommendedTileName,
      "Recommended Tile Rank": properties.recommendedTileRank,
      "Content Group": properties.contentGroup,
      "Click Id": properties.clickId,
      "Game Type": properties.gameType,
      "Playable Type": properties.playableType,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Game Engine": properties.gameEngine,
      "Game Code": properties.gameCode,
      "Game Name": properties.gameName,
      "Page Name": properties.pageName,
      "Assignment Type": properties.assignmentType,
      "Total Memory": properties.totalMemory,
      "Used Memory": properties.usedMemory,
      "Memory Limit": properties.memoryLimit,
      "Memory Usage Percentage": properties.memoryUsagePercentage,
      "Playable Path": properties.playablePath,
      "Playable Click Id": properties.playableClickId,
      "Recommended Via": properties.recommendedVia,
      "Recommended Rail": properties.recommendedRail,
      "Tab Code": properties.tabCode,
      "Recommended Category": properties.recommendedCategory,
      "Overall Clicked Count": properties.overallClickedCount,
      "Overall Started Count": properties.overallStartedCount,
      "Overall Completed Count": properties.overallCompletedCount,
      "Rail Code": properties.railCode,
      "Tile Code": properties.tileCode,
      "Stale Data": properties.staleData,
      "Recommendation Rail Code": properties.recommendationRailCode,
      "Recommendation Version Name": properties.recommendationVersionName,
      "Recommendation Sub Version Name": properties.recommendationSubVersionName,
      "Recommendation Algorithm Flag": properties.recommendationAlgorithmFlag,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Book Search Icon [Teacher]: When user clicks/taps on search bar on teacher dashboard
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/BIbC5NFvDf0w2ZSBf715o/trigger/zQhQ4EODWa3fqhDevrnF_
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {string} properties.pageName - Includes the name of the page (Eg: Playzone game listing page, ). This is not the URL but a easily understandable definition of what page is the user at.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/BIbC5NFvDf0w2ZSBf715o}
   */
  function interactedBookSearchIconTeacher(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertPageName(properties.pageName));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Book Search Icon [Teacher]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "from",
        "pageName"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "BIbC5NFvDf0w2ZSBf715o", "502f1aad696c653115db79b40e3f357213efbfc8df80a0ec6b49c2aec98affc7", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Book Search Icon [Teacher]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From": properties.from,
        "Page Name": properties.pageName,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("BIbC5NFvDf0w2ZSBf715o", "Interacted Book Search Icon [Teacher]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "MJKSzmqfHu", name: "Page Name", value: properties.pageName},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Book Search Icon [Teacher]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Book Search Icon [Teacher]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From": properties.from,
          "Page Name": properties.pageName,
          "Screen Height": sysScreenHeight,
          }, "BIbC5NFvDf0w2ZSBf715o", "502f1aad696c653115db79b40e3f357213efbfc8df80a0ec6b49c2aec98affc7");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Book Search Icon [Teacher]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From": properties.from,
      "Page Name": properties.pageName,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Book Search Icon: When user clicks/taps on search bar on student dashboard
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/6-gewjlMVXAy9rqmcNaJZ/trigger/kr5ZpOFIwNWOvaxSCXyQO
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {string} properties.pageName - Includes the name of the page (Eg: Playzone game listing page, ). This is not the URL but a easily understandable definition of what page is the user at.
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/6-gewjlMVXAy9rqmcNaJZ}
   */
  function interactedBookSearchIcon(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertPageName(properties.pageName));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Book Search Icon", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "elaGrade",
        "mathGrade",
        "mode",
        "grade",
        "from",
        "pageName"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "6-gewjlMVXAy9rqmcNaJZ", "d8e0f799b29bb409d4e858720d26d0a1f3eb5486b7239b820bcc85d8a8577243", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Book Search Icon", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Grade": properties.grade,
        "From": properties.from,
        "Page Name": properties.pageName,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("6-gewjlMVXAy9rqmcNaJZ", "Interacted Book Search Icon", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "MJKSzmqfHu", name: "Page Name", value: properties.pageName},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Book Search Icon': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Book Search Icon", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Grade": properties.grade,
          "From": properties.from,
          "Page Name": properties.pageName,
          "Screen Height": sysScreenHeight,
          }, "6-gewjlMVXAy9rqmcNaJZ", "d8e0f799b29bb409d4e858720d26d0a1f3eb5486b7239b820bcc85d8a8577243");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Book Search Icon", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Grade": properties.grade,
      "From": properties.from,
      "Page Name": properties.pageName,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Scrolled Book Dashboard [Teacher]: Capture how  much is the user scrolling on the page. Similar to Scrolled Student Dashboard event on B2C
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/SxyyL-xQ3_h3J9Jt4VzTQ/trigger/SwQH_8S4aRrRylF9c9Rba
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.pageName - Includes the name of the page (Eg: Playzone game listing page, ). This is not the URL but a easily understandable definition of what page is the user at.
   * @param {Array<string>} properties.recommendedRail - This property will be used to store which rails were shown to the user in the HOME tab.

Where possible values are:
Rail Name = Curriculum, Game Zone, Math, Language, Logic & Thinking, Art & Creativity, General Knowledge, Motor Skills, Live Classes, Fluency, Multiplayer
This comes with Rank also with | separation
   * @param {Array<string>} properties.recommendedRailName - This is the name of the rail viewed by the user. 
Recommended rail property comes with rail name and rail rank, pipe separated - with the introduction of this property, we intend to separate rail name to calculate CTR on Mixpanel.
   * @param {Array<int>} properties.recommendedRailRank - Recommended Rail Rank will carry the rank of the rail in integer format viewed by the user. 
   * @param {string} properties.recommendationRailCode - This property will capture the code for recommended rails driven by algorithm
   * @param {string} properties.recommendationVersionName - Parent code for different versions of AB test
   * @param {string} properties.recommendationSubVersionName - It is a code that defines different version of different rail on book library dashboard
   * @param {int} properties.recommendationAlgorithmFlag - If a rail is driven by recommendation version then flag will be 1 else 0
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/SxyyL-xQ3_h3J9Jt4VzTQ}
   */
  function scrolledBookDashboardTeacher(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPageName(properties.pageName));
      messages = messages.concat(assertRecommendedRail(properties.recommendedRail));
      messages = messages.concat(assertRecommendedRailName(properties.recommendedRailName));
      messages = messages.concat(assertRecommendedRailRank(properties.recommendedRailRank));
      messages = messages.concat(assertRecommendationRailCode(properties.recommendationRailCode));
      messages = messages.concat(assertRecommendationVersionName(properties.recommendationVersionName));
      messages = messages.concat(assertRecommendationSubVersionName(properties.recommendationSubVersionName));
      messages = messages.concat(assertRecommendationAlgorithmFlag(properties.recommendationAlgorithmFlag));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Scrolled Book Dashboard [Teacher]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "pageName",
        "recommendedRail",
        "recommendedRailName",
        "recommendedRailRank",
        "recommendationRailCode",
        "recommendationVersionName",
        "recommendationSubVersionName",
        "recommendationAlgorithmFlag",
        "from"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "SxyyL-xQ3_h3J9Jt4VzTQ", "c55fbfcd1b86094633df2a4b273e5bb1ddab2ea6f5dd7d89df6ec99293b8bdeb", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Scrolled Book Dashboard [Teacher]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Page Name": properties.pageName,
        "Recommended Rail": properties.recommendedRail,
        "Recommended Rail Name": properties.recommendedRailName,
        "Recommended Rail Rank": properties.recommendedRailRank,
        "Recommendation Rail Code": properties.recommendationRailCode,
        "Recommendation Version Name": properties.recommendationVersionName,
        "Recommendation Sub Version Name": properties.recommendationSubVersionName,
        "Recommendation Algorithm Flag": properties.recommendationAlgorithmFlag,
        "From": properties.from,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("SxyyL-xQ3_h3J9Jt4VzTQ", "Scrolled Book Dashboard [Teacher]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "6lrsWYY5Y", name: "Recommended Rail Name", value: properties.recommendedRailName},
        {id: "BchWbNpV0WYRnYxTnBQ-c", name: "Recommendation Sub Version Name", value: properties.recommendationSubVersionName},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "FH6REXldlxqxCPK0pvsML", name: "Recommendation Version Name", value: properties.recommendationVersionName},
        {id: "MJKSzmqfHu", name: "Page Name", value: properties.pageName},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "Q2q6j4dEnjH8uo-MY-mr7", name: "Recommendation Algorithm Flag", value: properties.recommendationAlgorithmFlag},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "Qwa4E7UWbmonbiv7JbciC", name: "Recommendation Rail Code", value: properties.recommendationRailCode},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "drNgwJn5Xg", name: "Recommended Rail", value: properties.recommendedRail},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "uyLgqxbg7", name: "Recommended Rail Rank", value: properties.recommendedRailRank},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Scrolled Book Dashboard [Teacher]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Scrolled Book Dashboard [Teacher]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Page Name": properties.pageName,
          "Recommended Rail": properties.recommendedRail,
          "Recommended Rail Name": properties.recommendedRailName,
          "Recommended Rail Rank": properties.recommendedRailRank,
          "Recommendation Rail Code": properties.recommendationRailCode,
          "Recommendation Version Name": properties.recommendationVersionName,
          "Recommendation Sub Version Name": properties.recommendationSubVersionName,
          "Recommendation Algorithm Flag": properties.recommendationAlgorithmFlag,
          "From": properties.from,
          "Screen Height": sysScreenHeight,
          }, "SxyyL-xQ3_h3J9Jt4VzTQ", "c55fbfcd1b86094633df2a4b273e5bb1ddab2ea6f5dd7d89df6ec99293b8bdeb");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Scrolled Book Dashboard [Teacher]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Page Name": properties.pageName,
      "Recommended Rail": properties.recommendedRail,
      "Recommended Rail Name": properties.recommendedRailName,
      "Recommended Rail Rank": properties.recommendedRailRank,
      "Recommendation Rail Code": properties.recommendationRailCode,
      "Recommendation Version Name": properties.recommendationVersionName,
      "Recommendation Sub Version Name": properties.recommendationSubVersionName,
      "Recommendation Algorithm Flag": properties.recommendationAlgorithmFlag,
      "From": properties.from,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Scrolled Book Dashboard: Capture how  much is the user scrolling on the page. Similar to Scrolled Student Dashboard event on B2C
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/NV4lpWcDH5EL5kwXPTWWu/trigger/q3xv9ecaVlludy4Vlft4-
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.pageName - Includes the name of the page (Eg: Playzone game listing page, ). This is not the URL but a easily understandable definition of what page is the user at.
   * @param {Array<string>} properties.recommendedRail - This property will be used to store which rails were shown to the user in the HOME tab.

Where possible values are:
Rail Name = Curriculum, Game Zone, Math, Language, Logic & Thinking, Art & Creativity, General Knowledge, Motor Skills, Live Classes, Fluency, Multiplayer
This comes with Rank also with | separation
   * @param {Array<string>} properties.recommendedRailName - This is the name of the rail viewed by the user. 
Recommended rail property comes with rail name and rail rank, pipe separated - with the introduction of this property, we intend to separate rail name to calculate CTR on Mixpanel.
   * @param {Array<int>} properties.recommendedRailRank - Recommended Rail Rank will carry the rank of the rail in integer format viewed by the user. 
   * @param {string} properties.recommendationRailCode - This property will capture the code for recommended rails driven by algorithm
   * @param {string} properties.recommendationVersionName - Parent code for different versions of AB test
   * @param {string} properties.recommendationSubVersionName - It is a code that defines different version of different rail on book library dashboard
   * @param {int} properties.recommendationAlgorithmFlag - If a rail is driven by recommendation version then flag will be 1 else 0
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/NV4lpWcDH5EL5kwXPTWWu}
   */
  function scrolledBookDashboard(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertPageName(properties.pageName));
      messages = messages.concat(assertRecommendedRail(properties.recommendedRail));
      messages = messages.concat(assertRecommendedRailName(properties.recommendedRailName));
      messages = messages.concat(assertRecommendedRailRank(properties.recommendedRailRank));
      messages = messages.concat(assertRecommendationRailCode(properties.recommendationRailCode));
      messages = messages.concat(assertRecommendationVersionName(properties.recommendationVersionName));
      messages = messages.concat(assertRecommendationSubVersionName(properties.recommendationSubVersionName));
      messages = messages.concat(assertRecommendationAlgorithmFlag(properties.recommendationAlgorithmFlag));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Scrolled Book Dashboard", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "pageName",
        "recommendedRail",
        "recommendedRailName",
        "recommendedRailRank",
        "recommendationRailCode",
        "recommendationVersionName",
        "recommendationSubVersionName",
        "recommendationAlgorithmFlag",
        "from",
        "mode",
        "grade",
        "elaGrade",
        "mathGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "NV4lpWcDH5EL5kwXPTWWu", "49812b7735920b4a6264e0e676a8b078276b0fd5b82485790c800db55c629a00", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Scrolled Book Dashboard", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Page Name": properties.pageName,
        "Recommended Rail": properties.recommendedRail,
        "Recommended Rail Name": properties.recommendedRailName,
        "Recommended Rail Rank": properties.recommendedRailRank,
        "Recommendation Rail Code": properties.recommendationRailCode,
        "Recommendation Version Name": properties.recommendationVersionName,
        "Recommendation Sub Version Name": properties.recommendationSubVersionName,
        "Recommendation Algorithm Flag": properties.recommendationAlgorithmFlag,
        "From": properties.from,
        "Mode": properties.mode,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("NV4lpWcDH5EL5kwXPTWWu", "Scrolled Book Dashboard", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "6lrsWYY5Y", name: "Recommended Rail Name", value: properties.recommendedRailName},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "BchWbNpV0WYRnYxTnBQ-c", name: "Recommendation Sub Version Name", value: properties.recommendationSubVersionName},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "FH6REXldlxqxCPK0pvsML", name: "Recommendation Version Name", value: properties.recommendationVersionName},
        {id: "MJKSzmqfHu", name: "Page Name", value: properties.pageName},
        {id: "Q2q6j4dEnjH8uo-MY-mr7", name: "Recommendation Algorithm Flag", value: properties.recommendationAlgorithmFlag},
        {id: "Qwa4E7UWbmonbiv7JbciC", name: "Recommendation Rail Code", value: properties.recommendationRailCode},
        {id: "drNgwJn5Xg", name: "Recommended Rail", value: properties.recommendedRail},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "uyLgqxbg7", name: "Recommended Rail Rank", value: properties.recommendedRailRank},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Scrolled Book Dashboard': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Scrolled Book Dashboard", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Page Name": properties.pageName,
          "Recommended Rail": properties.recommendedRail,
          "Recommended Rail Name": properties.recommendedRailName,
          "Recommended Rail Rank": properties.recommendedRailRank,
          "Recommendation Rail Code": properties.recommendationRailCode,
          "Recommendation Version Name": properties.recommendationVersionName,
          "Recommendation Sub Version Name": properties.recommendationSubVersionName,
          "Recommendation Algorithm Flag": properties.recommendationAlgorithmFlag,
          "From": properties.from,
          "Mode": properties.mode,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Screen Height": sysScreenHeight,
          }, "NV4lpWcDH5EL5kwXPTWWu", "49812b7735920b4a6264e0e676a8b078276b0fd5b82485790c800db55c629a00");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Scrolled Book Dashboard", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Page Name": properties.pageName,
      "Recommended Rail": properties.recommendedRail,
      "Recommended Rail Name": properties.recommendedRailName,
      "Recommended Rail Rank": properties.recommendedRailRank,
      "Recommendation Rail Code": properties.recommendationRailCode,
      "Recommendation Version Name": properties.recommendationVersionName,
      "Recommendation Sub Version Name": properties.recommendationSubVersionName,
      "Recommendation Algorithm Flag": properties.recommendationAlgorithmFlag,
      "From": properties.from,
      "Mode": properties.mode,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Completed Book Dashboard Scroll: When the user has reached the end of page where they would see no more results or see show more button

   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/S-CncNYEt8m2LqrHZ7l8n/trigger/xN2K3Y0N_zgbZeuihgvlw
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {Array<string>} properties.recommendedRail - This property will be used to store which rails were shown to the user in the HOME tab.

Where possible values are:
Rail Name = Curriculum, Game Zone, Math, Language, Logic & Thinking, Art & Creativity, General Knowledge, Motor Skills, Live Classes, Fluency, Multiplayer
This comes with Rank also with | separation
   * @param {Array<string>} properties.recommendedRailName - This is the name of the rail viewed by the user. 
Recommended rail property comes with rail name and rail rank, pipe separated - with the introduction of this property, we intend to separate rail name to calculate CTR on Mixpanel.
   * @param {Array<int>} properties.recommendedRailRank - Recommended Rail Rank will carry the rank of the rail in integer format viewed by the user. 
   * @param {string} properties.pageName - Includes the name of the page (Eg: Playzone game listing page, ). This is not the URL but a easily understandable definition of what page is the user at.
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done. 
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/S-CncNYEt8m2LqrHZ7l8n}
   */
  function completedBookDashboardScroll(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertRecommendedRail(properties.recommendedRail));
      messages = messages.concat(assertRecommendedRailName(properties.recommendedRailName));
      messages = messages.concat(assertRecommendedRailRank(properties.recommendedRailRank));
      messages = messages.concat(assertPageName(properties.pageName));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Completed Book Dashboard Scroll", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "recommendedRail",
        "recommendedRailName",
        "recommendedRailRank",
        "pageName",
        "from",
        "grade",
        "mode",
        "mathGrade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "S-CncNYEt8m2LqrHZ7l8n", "1c96ad0558f97e8f63670549af49338272de009af4a1313e4eb81daf4cdfe51b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Completed Book Dashboard Scroll", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Recommended Rail": properties.recommendedRail,
        "Recommended Rail Name": properties.recommendedRailName,
        "Recommended Rail Rank": properties.recommendedRailRank,
        "Page Name": properties.pageName,
        "From": properties.from,
        "Grade": properties.grade,
        "Mode": properties.mode,
        "Math Grade": properties.mathGrade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("S-CncNYEt8m2LqrHZ7l8n", "Completed Book Dashboard Scroll", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "6lrsWYY5Y", name: "Recommended Rail Name", value: properties.recommendedRailName},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "MJKSzmqfHu", name: "Page Name", value: properties.pageName},
        {id: "drNgwJn5Xg", name: "Recommended Rail", value: properties.recommendedRail},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "uyLgqxbg7", name: "Recommended Rail Rank", value: properties.recommendedRailRank},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Completed Book Dashboard Scroll': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Completed Book Dashboard Scroll", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Recommended Rail": properties.recommendedRail,
          "Recommended Rail Name": properties.recommendedRailName,
          "Recommended Rail Rank": properties.recommendedRailRank,
          "Page Name": properties.pageName,
          "From": properties.from,
          "Grade": properties.grade,
          "Mode": properties.mode,
          "Math Grade": properties.mathGrade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "S-CncNYEt8m2LqrHZ7l8n", "1c96ad0558f97e8f63670549af49338272de009af4a1313e4eb81daf4cdfe51b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Completed Book Dashboard Scroll", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Recommended Rail": properties.recommendedRail,
      "Recommended Rail Name": properties.recommendedRailName,
      "Recommended Rail Rank": properties.recommendedRailRank,
      "Page Name": properties.pageName,
      "From": properties.from,
      "Grade": properties.grade,
      "Mode": properties.mode,
      "Math Grade": properties.mathGrade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Viewed Avatar Options Screen: This event is associated with the avatar selection flow, where we are showing premade options to choose an avatar from
   * 
   * When to trigger this event:
   * 1. When user sees the avatar options
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/YFH-mL5SHr_6OAsiTNiU0/trigger/Qa4h--tBOKDfVIqAX4xyH
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/YFH-mL5SHr_6OAsiTNiU0}
   */
  function viewedAvatarOptionsScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Avatar Options Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "grade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "YFH-mL5SHr_6OAsiTNiU0", "5b9711ada42b42b5f84cd84d92dd24e5a14b92a97098f99719e441f846542ac3", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Viewed Avatar Options Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("YFH-mL5SHr_6OAsiTNiU0", "Viewed Avatar Options Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Avatar Options Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Avatar Options Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "YFH-mL5SHr_6OAsiTNiU0", "5b9711ada42b42b5f84cd84d92dd24e5a14b92a97098f99719e441f846542ac3");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Avatar Options Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * Interacted Avatar Options Screen: This event is fired when user taps on the elements of the screen
   * 
   * When to trigger this event:
   * 1. When user interacts with the elements of this page
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/xlLnP5hXlv0Zgv9B6JLx2/trigger/Vg5WkCG55qqopGQLgnY5U
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher, 
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * 
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/xlLnP5hXlv0Zgv9B6JLx2}
   */
  function interactedAvatarOptionsScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Avatar Options Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "clickedOn",
        "grade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "xlLnP5hXlv0Zgv9B6JLx2", "6fa70e52245a6e64d3bf2ed1ee5d6ebaa3535859fc131f48172996bfcc56546f", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("Interacted Avatar Options Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Clicked On": properties.clickedOn,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("xlLnP5hXlv0Zgv9B6JLx2", "Interacted Avatar Options Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Avatar Options Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Avatar Options Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Clicked On": properties.clickedOn,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "xlLnP5hXlv0Zgv9B6JLx2", "6fa70e52245a6e64d3bf2ed1ee5d6ebaa3535859fc131f48172996bfcc56546f");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Avatar Options Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Clicked On": properties.clickedOn,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }
  
  exports.DiscountPitch = DiscountPitch;
  exports.Difficulty = Difficulty;
  exports.State = State;
  exports.UserPersonaType = UserPersonaType;
  exports.Source = Source;
  exports.QuestionType = QuestionType;
  exports.CSVUploadStatus = CSVUploadStatus;
  exports.Grade = Grade;
  exports.Mode = Mode;
  exports.MFAssignedTo = MFAssignedTo;
  exports.WorksheetFilterAppliedOn = WorksheetFilterAppliedOn;
  exports.EndPoint = EndPoint;
  exports.Status = Status;
  exports.ClickedOnCustomReportPage = ClickedOnCustomReportPage;
  exports.MathGrade = MathGrade;
  exports.GradeSelected = GradeSelected;
  exports.WorksheetGrade = WorksheetGrade;
  exports.ReportType = ReportType;
  exports.APISource = APISource;
  exports.ClickedOnTrackCustomPage = ClickedOnTrackCustomPage;
  exports.InteractionType = InteractionType;
  exports.Subject = Subject;
  exports.GameMode = GameMode;
  exports.InteractedWith = InteractedWith;
  exports.ScrolledThrough = ScrolledThrough;
  exports.OpponentType = OpponentType;
  exports.MFMode = MFMode;
  exports.CardType = CardType;
  exports.CustomMFOperatorSelected = CustomMFOperatorSelected;
  exports.SchoolFormType = SchoolFormType;
  exports.MFOperatorSelected = MFOperatorSelected;
  exports.ClickedOnNewMFPractice = ClickedOnNewMFPractice;
  exports.PlayAgainState = PlayAgainState;
  exports.ClassType = ClassType;
  exports.MFCustomSettingsClickedOn = MFCustomSettingsClickedOn;
  exports.ReachedVia = ReachedVia;
  exports.Winner = Winner;
  exports.InteractionDetails = InteractionDetails;
  exports.ValidSavedCardExists = ValidSavedCardExists;
  exports.View = View;
  exports.GooglePayButtonAvailable = GooglePayButtonAvailable;
  exports.ElaGrade = ElaGrade;
  exports.MFPracticeQuestionsCount = MFPracticeQuestionsCount;
  exports.MFTimePerQuestion = MFTimePerQuestion;
  exports.UserType = UserType;
  exports.SignupFlow = SignupFlow;
  exports.ClickedOnStudentSelectionPopup = ClickedOnStudentSelectionPopup;
  exports.setAvoLogger = setAvoLogger;
  exports.viewedTakeTourPopup = viewedTakeTourPopup;
  exports.interactedOnTakeTourPopup = interactedOnTakeTourPopup;
  exports.interactedMpGameTab = interactedMpGameTab;
  exports.viewedMpClassmatesDrawer = viewedMpClassmatesDrawer;
  exports.viewedMpGameTab = viewedMpGameTab;
  exports.interactedMpClassmatesDrawer = interactedMpClassmatesDrawer;
  exports.viewedMpGameInvitesDrawer = viewedMpGameInvitesDrawer;
  exports.interactedMpGameInvitesDrawer = interactedMpGameInvitesDrawer;
  exports.viewedMpInviteNotification = viewedMpInviteNotification;
  exports.interactedMpInviteNotification = interactedMpInviteNotification;
  exports.viewedMpModeSelectionScreen = viewedMpModeSelectionScreen;
  exports.interactedMpModeSelectionScreen = interactedMpModeSelectionScreen;
  exports.viewedMpOptionsSelectionScreen = viewedMpOptionsSelectionScreen;
  exports.interactedMpOptionsSelectionScreen = interactedMpOptionsSelectionScreen;
  exports.viewedMpInviteFriendsScreen = viewedMpInviteFriendsScreen;
  exports.interactedMpInviteFriendsScreen = interactedMpInviteFriendsScreen;
  exports.viewedMpGameLoaderScreen = viewedMpGameLoaderScreen;
  exports.viewedMpGamePlayScreen = viewedMpGamePlayScreen;
  exports.opponentSearchStarted = opponentSearchStarted;
  exports.opponentFound = opponentFound;
  exports.countdownAnimationStarted = countdownAnimationStarted;
  exports.viewedMpQuestionsExhaustedScreen = viewedMpQuestionsExhaustedScreen;
  exports.viewedMpGameLobby = viewedMpGameLobby;
  exports.interactedMpGameLobby = interactedMpGameLobby;
  exports.viewedMpGameRewardsScreen = viewedMpGameRewardsScreen;
  exports.viewedMpRematchPopup = viewedMpRematchPopup;
  exports.interactedMpRematchPopup = interactedMpRematchPopup;
  exports.viewedPost3pmPopUp = viewedPost3pmPopUp;
  exports.interactedPost3pmPopUp = interactedPost3pmPopUp;
  exports.viewedErrorOnPost3pmPopUp = viewedErrorOnPost3pmPopUp;
  exports.viewedSuspectedEmailNudge = viewedSuspectedEmailNudge;
  exports.interactedSuspectedEmailNudge = interactedSuspectedEmailNudge;
  exports.viewedMpGameTabCoachmark = viewedMpGameTabCoachmark;
  exports.viewedMpGameTileCoachmark = viewedMpGameTileCoachmark;
  exports.visitedDashboardTab = visitedDashboardTab;
  exports.viewedMfWalkthroughPopup = viewedMfWalkthroughPopup;
  exports.interactedMfWalkthroughPopup = interactedMfWalkthroughPopup;
  exports.navClickedMfNewPractice = navClickedMfNewPractice;
  exports.viewedMfSettingsPopup = viewedMfSettingsPopup;
  exports.interactedMfSettingsPopup = interactedMfSettingsPopup;
  exports.successfullyAssigned = successfullyAssigned;
  exports.navClickedMfTrackFluency = navClickedMfTrackFluency;
  exports.viewedMfTrackAdaptivePage = viewedMfTrackAdaptivePage;
  exports.viewedMfTrackCustomPage = viewedMfTrackCustomPage;
  exports.interactedMfTrackAdaptivePage = interactedMfTrackAdaptivePage;
  exports.navClickedStudentReport = navClickedStudentReport;
  exports.viewedMfStudentProgressPage = viewedMfStudentProgressPage;
  exports.interactedMfStudentProgressPage = interactedMfStudentProgressPage;
  exports.navClickedClassReport = navClickedClassReport;
  exports.viewedClassCurriculumReportPage = viewedClassCurriculumReportPage;
  exports.viewedMfClassProgressPage = viewedMfClassProgressPage;
  exports.interactedMfClassProgressPage = interactedMfClassProgressPage;
  exports.viewedMfModifyPracticePage = viewedMfModifyPracticePage;
  exports.interactedMfModifyPracticePage = interactedMfModifyPracticePage;
  exports.viewedMytodoPage = viewedMytodoPage;
  exports.mathFactStarted = mathFactStarted;
  exports.completedMathFactAssignment = completedMathFactAssignment;
  exports.viewedDeleteAccountAlert = viewedDeleteAccountAlert;
  exports.interactedDeleteAccountAlert = interactedDeleteAccountAlert;
  exports.startedGame = startedGame;
  exports.viewedGames = viewedGames;
  exports.tappedGame = tappedGame;
  exports.interactedMfNewPracticePage = interactedMfNewPracticePage;
  exports.interactedMfCustomModeSettingsPopup = interactedMfCustomModeSettingsPopup;
  exports.interactedMfStudentSelectionPopup = interactedMfStudentSelectionPopup;
  exports.interactedMfTrackCustomPage = interactedMfTrackCustomPage;
  exports.interactedMfCustomReportPage = interactedMfCustomReportPage;
  exports.weeklyGoalInteracted = weeklyGoalInteracted;
  exports.viewedTiledDashboard = viewedTiledDashboard;
  exports.interactedTiledDashboard = interactedTiledDashboard;
  exports.completedStudentDashboardScroll = completedStudentDashboardScroll;
  exports.completedPageRendering = completedPageRendering;
  exports.downloadedWorksheet = downloadedWorksheet;
  exports.clickedWorksheetTab = clickedWorksheetTab;
  exports.appliedWorksheetFilters = appliedWorksheetFilters;
  exports.clearedWorksheetFilters = clearedWorksheetFilters;
  exports.viewedWorksheetListingPage = viewedWorksheetListingPage;
  exports.interactedWorksheetListingPage = interactedWorksheetListingPage;
  exports.savedWorksheet = savedWorksheet;
  exports.viewedSavedWorksheetPage = viewedSavedWorksheetPage;
  exports.viewedDownloadHistoryWorksheetPage = viewedDownloadHistoryWorksheetPage;
  exports.previewedWorksheet = previewedWorksheet;
  exports.closedMathFacts = closedMathFacts;
  exports.interactedActivityPage = interactedActivityPage;
  exports.emailVerifiedFrontend = emailVerifiedFrontend;
  exports.selectedGame = selectedGame;
  exports.visitedOnboardingWelcome = visitedOnboardingWelcome;
  exports.interactedTeacherOnboarding = interactedTeacherOnboarding;
  exports.ageQuestionScreenViewed = ageQuestionScreenViewed;
  exports.ageQuestionScreenInteracted = ageQuestionScreenInteracted;
  exports.onboardingQuestionScreenViewed = onboardingQuestionScreenViewed;
  exports.onboardingQuestionInteracted = onboardingQuestionInteracted;
  exports.interactedAssignmentSuccessfullyAssignedPage = interactedAssignmentSuccessfullyAssignedPage;
  exports.viewedMfSuccessfullyAssignedPage = viewedMfSuccessfullyAssignedPage;
  exports.viewedAssignmentSuccessfullyAssignedPage = viewedAssignmentSuccessfullyAssignedPage;
  exports.interactedMfSuccessfullyAssignedPage = interactedMfSuccessfullyAssignedPage;
  exports.viewedGameZone = viewedGameZone;
  exports.interactedGameZone = interactedGameZone;
  exports.playableClicked = playableClicked;
  exports.playableStarted = playableStarted;
  exports.playableCompleted = playableCompleted;
  exports.viewedSubscribePopup = viewedSubscribePopup;
  exports.interactedSubscribePopup = interactedSubscribePopup;
  exports.viewedWorksheetSearchDropdown = viewedWorksheetSearchDropdown;
  exports.interactedWorksheetSearchDropdown = interactedWorksheetSearchDropdown;
  exports.viewedWorksheetSearchResultsPage = viewedWorksheetSearchResultsPage;
  exports.interactedWorksheetSearchResultsPage = interactedWorksheetSearchResultsPage;
  exports.viewedWorksheetSearchResultsEndPage = viewedWorksheetSearchResultsEndPage;
  exports.interactedThemeToggle = interactedThemeToggle;
  exports.viewedNudge = viewedNudge;
  exports.interactedNudge = interactedNudge;
  exports.interactedStudentProgressPage = interactedStudentProgressPage;
  exports.recommendedItem = recommendedItem;
  exports.interactedPrintReportPopup = interactedPrintReportPopup;
  exports.interactedStudentProgress = interactedStudentProgress;
  exports.playableTapped = playableTapped;
  exports.mathFactsClosed = mathFactsClosed;
  exports.interactedLiveClassesTab = interactedLiveClassesTab;
  exports.interactedLiveClassesSubscriptionPopup = interactedLiveClassesSubscriptionPopup;
  exports.viewedTrialPitchScreen = viewedTrialPitchScreen;
  exports.interactedTrialPitchScreen = interactedTrialPitchScreen;
  exports.interactedLeftNavigationMenu = interactedLeftNavigationMenu;
  exports.interactedSplashcommunityDiscoverabilityPopUp = interactedSplashcommunityDiscoverabilityPopUp;
  exports.viewedSplashcommunityDiscoverabilityPopUp = viewedSplashcommunityDiscoverabilityPopUp;
  exports.interactedNewClassAdditionPage = interactedNewClassAdditionPage;
  exports.freemiumTimerExpired = freemiumTimerExpired;
  exports.freemiumTimerStarted = freemiumTimerStarted;
  exports.reachedDailyLimit = reachedDailyLimit;
  exports.studentAutoLoggedInSuccessfully = studentAutoLoggedInSuccessfully;
  exports.viewedSubscribePopUpOnPtl = viewedSubscribePopUpOnPtl;
  exports.viewedOnboardingStepCompletionAnimation = viewedOnboardingStepCompletionAnimation;
  exports.viewedTeacherDashboard = viewedTeacherDashboard;
  exports.interactedTeacherDashboard = interactedTeacherDashboard;
  exports.autoEnrolledForSpringboard = autoEnrolledForSpringboard;
  exports.viewedSpringboardNewIntro = viewedSpringboardNewIntro;
  exports.interactedSpringboardNewIntro = interactedSpringboardNewIntro;
  exports.viewedSpringboardTab = viewedSpringboardTab;
  exports.interactedSpringboardTab = interactedSpringboardTab;
  exports.interactedClassroomSettingsPage = interactedClassroomSettingsPage;
  exports.viewedUrgencyDiscountPopup = viewedUrgencyDiscountPopup;
  exports.interactedUrgencyDiscountPopup = interactedUrgencyDiscountPopup;
  exports.interactedUnlockContent = interactedUnlockContent;
  exports.visitedCertificateTabSpringboard = visitedCertificateTabSpringboard;
  exports.interactedCertificatesPageSpringboard = interactedCertificatesPageSpringboard;
  exports.viewedCertificate = viewedCertificate;
  exports.downloadedCertificate = downloadedCertificate;
  exports.viewedIntroducingCertificatesPopup = viewedIntroducingCertificatesPopup;
  exports.interactedIntroductoryCertificatesPopup = interactedIntroductoryCertificatesPopup;
  exports.viewedWeeklyHighlightsPopup = viewedWeeklyHighlightsPopup;
  exports.interactedWeeklyHighlightsPopup = interactedWeeklyHighlightsPopup;
  exports.viewedTutorLobby = viewedTutorLobby;
  exports.interactedTutorLobby = interactedTutorLobby;
  exports.classQuizStarted = classQuizStarted;
  exports.classQuizEnded = classQuizEnded;
  exports.viewedTutorInQuizScreen = viewedTutorInQuizScreen;
  exports.interactedTutorInQuizScreen = interactedTutorInQuizScreen;
  exports.nextQuestionWarningViewed = nextQuestionWarningViewed;
  exports.nextQuestionWarningInteracted = nextQuestionWarningInteracted;
  exports.viewedTutorQuizTimerRunOutPopup = viewedTutorQuizTimerRunOutPopup;
  exports.viewedTutorFinalLeaderboard = viewedTutorFinalLeaderboard;
  exports.viewedStudentLobbyScreen = viewedStudentLobbyScreen;
  exports.viewedStudentInQuizScreen = viewedStudentInQuizScreen;
  exports.interactedStudentInQuizScreen = interactedStudentInQuizScreen;
  exports.viewedStudentPitstopScreen = viewedStudentPitstopScreen;
  exports.problemsAnswered = problemsAnswered;
  exports.viewedStudentQuizTimerRunOut = viewedStudentQuizTimerRunOut;
  exports.viewedStudentFinalLeaderboard = viewedStudentFinalLeaderboard;
  exports.interactedSubscribePopUpOnPtl = interactedSubscribePopUpOnPtl;
  exports.problemsAnsweredInNeoWorksheets = problemsAnsweredInNeoWorksheets;
  exports.viewedUpcomingClassTab = viewedUpcomingClassTab;
  exports.interactedUpcomingClassTab = interactedUpcomingClassTab;
  exports.viewedLiveClassesIntroductionPopup = viewedLiveClassesIntroductionPopup;
  exports.interactedLiveClassesIntroductionPopup = interactedLiveClassesIntroductionPopup;
  exports.viewedAddParentEmailsPage = viewedAddParentEmailsPage;
  exports.interactedAddParentEmailsPage = interactedAddParentEmailsPage;
  exports.viewedProgramSelectionScreen = viewedProgramSelectionScreen;
  exports.interactedProgramSelectionScreen = interactedProgramSelectionScreen;
  exports.viewedAgeSelectionScreen = viewedAgeSelectionScreen;
  exports.interactedAgeSelectionScreen = interactedAgeSelectionScreen;
  exports.viewedProgramDetailsScreen = viewedProgramDetailsScreen;
  exports.interactedProgramDetailsScreen = interactedProgramDetailsScreen;
  exports.viewedAddParentsEmailPage = viewedAddParentsEmailPage;
  exports.interactedAddParentsEmailPage = interactedAddParentsEmailPage;
  exports.interactedLockedGame = interactedLockedGame;
  exports.viewedPlayAtHomeScreen = viewedPlayAtHomeScreen;
  exports.interactedPlayAtHomeScreen = interactedPlayAtHomeScreen;
  exports.viewedLockedGames = viewedLockedGames;
  exports.viewedCoqOptInScreen = viewedCoqOptInScreen;
  exports.interactedCoqOptInScreen = interactedCoqOptInScreen;
  exports.classWonSpringboardCertificate = classWonSpringboardCertificate;
  exports.studentWonSpringboardCertificate = studentWonSpringboardCertificate;
  exports.classAlmostWonSpringboardCertificate = classAlmostWonSpringboardCertificate;
  exports.studentAlmostWonSpringboardCertificate = studentAlmostWonSpringboardCertificate;
  exports.viewedCgSummary = viewedCgSummary;
  exports.interactedCgSummary = interactedCgSummary;
  exports.viewedCgMilestones = viewedCgMilestones;
  exports.interactedCgMilestones = interactedCgMilestones;
  exports.scrolledStudentDashboard = scrolledStudentDashboard;
  exports.startedPrintablesSearch = startedPrintablesSearch;
  exports.selectedPrintablesSearch = selectedPrintablesSearch;
  exports.interactedPrintablesFilters = interactedPrintablesFilters;
  exports.viewedShareDiscountBanner = viewedShareDiscountBanner;
  exports.interactedShareDiscountBanner = interactedShareDiscountBanner;
  exports.viewedCertificateTabOnParentDashboard = viewedCertificateTabOnParentDashboard;
  exports.interactedCertificateTabOnParentDashboard = interactedCertificateTabOnParentDashboard;
  exports.viewedSchoolHomeScreen = viewedSchoolHomeScreen;
  exports.interactedSchoolHomeScreen = interactedSchoolHomeScreen;
  exports.viewedSummerLearningOfferPage = viewedSummerLearningOfferPage;
  exports.interactedSummerLearningOfferPage = interactedSummerLearningOfferPage;
  exports.viewedSummerLearningPopUp = viewedSummerLearningPopUp;
  exports.interactedSummerLearningPopUp = interactedSummerLearningPopUp;
  exports.parentalGateFailed = parentalGateFailed;
  exports.parentalGateClosed = parentalGateClosed;
  exports.interactedLoginScreen = interactedLoginScreen;
  exports.viewedClassroomLinkedLoginScreen = viewedClassroomLinkedLoginScreen;
  exports.interactedClassroomLinkedLoginScreen = interactedClassroomLinkedLoginScreen;
  exports.viewedLoginViaOtpByClassroomLinkedParent = viewedLoginViaOtpByClassroomLinkedParent;
  exports.interactedLoginViaOtpByClassroomLinkedParent = interactedLoginViaOtpByClassroomLinkedParent;
  exports.interactedProfileIcon = interactedProfileIcon;
  exports.viewedCoTeacherCoachmark = viewedCoTeacherCoachmark;
  exports.interactedCoTeacherCoachmark = interactedCoTeacherCoachmark;
  exports.viewedManageAllClassesPage = viewedManageAllClassesPage;
  exports.viewedAddCoTeacherPopup = viewedAddCoTeacherPopup;
  exports.interactedAddCoTeacherPopup = interactedAddCoTeacherPopup;
  exports.viewedCoTeachingPopupByCoTeacher = viewedCoTeachingPopupByCoTeacher;
  exports.interactedCoTeachingPopupByCoTeacher = interactedCoTeachingPopupByCoTeacher;
  exports.viewedWelcomePageByNewlyCreatedCoTeacher = viewedWelcomePageByNewlyCreatedCoTeacher;
  exports.interactedWelcomePageByNewlyCreatedCoTeacher = interactedWelcomePageByNewlyCreatedCoTeacher;
  exports.viewedSummerBundleWidgetOnDashboard = viewedSummerBundleWidgetOnDashboard;
  exports.interactedSummerBundleWidgetOnDashboard = interactedSummerBundleWidgetOnDashboard;
  exports.clickedSupport = clickedSupport;
  exports.visitedAllPlansPage = visitedAllPlansPage;
  exports.interactedAllPlansPage = interactedAllPlansPage;
  exports.visitedPlanPurchaseCombinedPage = visitedPlanPurchaseCombinedPage;
  exports.interactedPlanPurchaseCombinedPage = interactedPlanPurchaseCombinedPage;
  exports.paymentFormError = paymentFormError;
  exports.completedPageScroll = completedPageScroll;
  exports.childProfilePageInteracted = childProfilePageInteracted;
  exports.viewedCoachmarkB2b = viewedCoachmarkB2b;
  exports.interactedCoachmarkB2b = interactedCoachmarkB2b;
  exports.viewedLiveClassesFreemiumPitch = viewedLiveClassesFreemiumPitch;
  exports.interactedLiveClassesFreemiumPitch = interactedLiveClassesFreemiumPitch;
  exports.viewedClassPreferenceScreen = viewedClassPreferenceScreen;
  exports.interactedClassPreferenceScreen = interactedClassPreferenceScreen;
  exports.viewedInterestConfirmationScreen = viewedInterestConfirmationScreen;
  exports.interactedInterestConfirmationScreen = interactedInterestConfirmationScreen;
  exports.interactedSearchIcon = interactedSearchIcon;
  exports.typingStartedOnSearchBar = typingStartedOnSearchBar;
  exports.typingStoppedOnSearchBar = typingStoppedOnSearchBar;
  exports.interactedSearchResult = interactedSearchResult;
  exports.viewedTransferPageB2b = viewedTransferPageB2b;
  exports.interactedTransferPageB2b = interactedTransferPageB2b;
  exports.viewedFeatureFeedbackPopUpB2b = viewedFeatureFeedbackPopUpB2b;
  exports.interactedFeatureFeedbackPopUpB2b = interactedFeatureFeedbackPopUpB2b;
  exports.viewedSuggestImprovementsPopupB2b = viewedSuggestImprovementsPopupB2b;
  exports.interactedSuggestImprovementsPopupB2b = interactedSuggestImprovementsPopupB2b;
  exports.interactedHelpIconB2b = interactedHelpIconB2b;
  exports.clickedOnHelpIconB2b = clickedOnHelpIconB2b;
  exports.viewedWorksheetPreview = viewedWorksheetPreview;
  exports.interactedWorksheetPreview = interactedWorksheetPreview;
  exports.interactedFabB2b = interactedFabB2b;
  exports.scrolledPlanPage = scrolledPlanPage;
  exports.interactedPromotePopupB2b = interactedPromotePopupB2b;
  exports.interactedContinueSameClassPopupB2b = interactedContinueSameClassPopupB2b;
  exports.interactedStudentLoginInstructionsPopupB2b = interactedStudentLoginInstructionsPopupB2b;
  exports.productPurchased = productPurchased;
  exports.creditCardSubmitted = creditCardSubmitted;
  exports.productPurchasedFrontend = productPurchasedFrontend;
  exports.viewedAllRecordingsPage = viewedAllRecordingsPage;
  exports.interactedAllRecordingsPage = interactedAllRecordingsPage;
  exports.viewedPersonaQuestionScreen = viewedPersonaQuestionScreen;
  exports.interactedPersonaQuestionScreen = interactedPersonaQuestionScreen;
  exports.viewedCompanion = viewedCompanion;
  exports.startedCompanionAnimation = startedCompanionAnimation;
  exports.completedCompanionAnimation = completedCompanionAnimation;
  exports.interactedCompanion = interactedCompanion;
  exports.dashboardGraphqlQueryStarted = dashboardGraphqlQueryStarted;
  exports.dashboardGraphqlQueryEnded = dashboardGraphqlQueryEnded;
  exports.dashboardRendered = dashboardRendered;
  exports.viewedCompleteTopicAssignmentPopupB2b = viewedCompleteTopicAssignmentPopupB2b;
  exports.interactedCompleteTopicAssignmentPopupB2b = interactedCompleteTopicAssignmentPopupB2b;
  exports.viewedDeleteTopicAssignmentPopupB2b = viewedDeleteTopicAssignmentPopupB2b;
  exports.interactedDeleteTopicAssignmentPopupB2b = interactedDeleteTopicAssignmentPopupB2b;
  exports.downloadedWorksheetB2c = downloadedWorksheetB2c;
  exports.interactedAssignmentSuccessfullyAssignedPageB2b = interactedAssignmentSuccessfullyAssignedPageB2b;
  exports.interactedSchoolSelectionScreenB2b = interactedSchoolSelectionScreenB2b;
  exports.viewedPricingInfoBox = viewedPricingInfoBox;
  exports.liveClassTabAvailable = liveClassTabAvailable;
  exports.endedCompanionAnimation = endedCompanionAnimation;
  exports.viewedCompanionRecommendation = viewedCompanionRecommendation;
  exports.interactedCompanionRecommendation = interactedCompanionRecommendation;
  exports.startedPitstopCompanionAnimation = startedPitstopCompanionAnimation;
  exports.endedPitstopCompanionAnimation = endedPitstopCompanionAnimation;
  exports.receivedRiveFile = receivedRiveFile;
  exports.companionEventsBackend = companionEventsBackend;
  exports.reachedDailyLimitBackend = reachedDailyLimitBackend;
  exports.viewedAddOnPitchScreen = viewedAddOnPitchScreen;
  exports.interactedAddOnPitchScreen = interactedAddOnPitchScreen;
  exports.viewedAddOnUpgradeScreen = viewedAddOnUpgradeScreen;
  exports.interactedAddOnUpgradeScreen = interactedAddOnUpgradeScreen;
  exports.viewedAddOnPurchaseThankYouScreen = viewedAddOnPurchaseThankYouScreen;
  exports.interactedAddOnPurchaseThankYouScreen = interactedAddOnPurchaseThankYouScreen;
  exports.viewedPostLiveClassPitch = viewedPostLiveClassPitch;
  exports.interactedPostLiveClassPitch = interactedPostLiveClassPitch;
  exports.viewedReinforcementAtHomeB2b = viewedReinforcementAtHomeB2b;
  exports.interactedReinforcementAtHomeB2b = interactedReinforcementAtHomeB2b;
  exports.viewedLiveClassPageB2b = viewedLiveClassPageB2b;
  exports.interactedLiveClassPageB2b = interactedLiveClassPageB2b;
  exports.viewedMaxLiveClassLimitReachedPopupB2b = viewedMaxLiveClassLimitReachedPopupB2b;
  exports.viewedShareLiveClassPopupB2b = viewedShareLiveClassPopupB2b;
  exports.interactedShareLiveClassPopupB2b = interactedShareLiveClassPopupB2b;
  exports.viewedLiveClassRecommendationPopup = viewedLiveClassRecommendationPopup;
  exports.interactedLiveClassRecommendationPopup = interactedLiveClassRecommendationPopup;
  exports.loadedQuestionForStudent = loadedQuestionForStudent;
  exports.loadedQuestionForTutor = loadedQuestionForTutor;
  exports.interactedTutorQuizTimerRunOut = interactedTutorQuizTimerRunOut;
  exports.viewedGoogleAccountSelectionScreenB2b = viewedGoogleAccountSelectionScreenB2b;
  exports.viewedGooglecleverClassImportScreenB2b = viewedGooglecleverClassImportScreenB2b;
  exports.errorMessageDisplayedB2b = errorMessageDisplayedB2b;
  exports.viewedChildNameScreen = viewedChildNameScreen;
  exports.interactedChildNameScreen = interactedChildNameScreen;
  exports.viewedGradeSelectionScreen = viewedGradeSelectionScreen;
  exports.interactedGradeSelectionScreen = interactedGradeSelectionScreen;
  exports.viewedSubjectSelectionScreen = viewedSubjectSelectionScreen;
  exports.interactedSubjectSelectionScreen = interactedSubjectSelectionScreen;
  exports.viewedOnboardingQuestionScreen = viewedOnboardingQuestionScreen;
  exports.interactedOnboardingQuestionScreen = interactedOnboardingQuestionScreen;
  exports.viewedLearningPlanScreen = viewedLearningPlanScreen;
  exports.interactedLearningPlanScreen = interactedLearningPlanScreen;
  exports.viewedWeeklyGoalScreen = viewedWeeklyGoalScreen;
  exports.interactedWeeklyGoalScreen = interactedWeeklyGoalScreen;
  exports.viewedLibraryLoadthrough = viewedLibraryLoadthrough;
  exports.viewedExcitingResourcesLoadthrough = viewedExcitingResourcesLoadthrough;
  exports.viewedLocalNotificationPrompt = viewedLocalNotificationPrompt;
  exports.interactedLocalNotificationPrompt = interactedLocalNotificationPrompt;
  exports.interactedMyToDoPopupB2b = interactedMyToDoPopupB2b;
  exports.viewedPendingActivityPopupB2b = viewedPendingActivityPopupB2b;
  exports.viewedStudentLevelBarDropdownB2b = viewedStudentLevelBarDropdownB2b;
  exports.interactedStudentLevelBarDropdownB2b = interactedStudentLevelBarDropdownB2b;
  exports.viewedMpGameExpiredPopupB2b = viewedMpGameExpiredPopupB2b;
  exports.classroomPtlLinkStarted = classroomPtlLinkStarted;
  exports.classroomPtlLinkEnded = classroomPtlLinkEnded;
  exports.viewedLessonPlansListingPageB2b = viewedLessonPlansListingPageB2b;
  exports.interactedLessonPlansListingPageB2b = interactedLessonPlansListingPageB2b;
  exports.viewedLessonPlanDetailPageB2b = viewedLessonPlanDetailPageB2b;
  exports.interactedLessonPlanDetailPageB2b = interactedLessonPlanDetailPageB2b;
  exports.viewedStudentRoundIntroScreen = viewedStudentRoundIntroScreen;
  exports.viewedTutorRoundIntroScreen = viewedTutorRoundIntroScreen;
  exports.interactedTutorRoundIntroScreen = interactedTutorRoundIntroScreen;
  exports.viewedBadgesAnimationInNeoQuiz = viewedBadgesAnimationInNeoQuiz;
  exports.viewedStudentRoundEndedScreen = viewedStudentRoundEndedScreen;
  exports.viewedTutorRoundEndedScreen = viewedTutorRoundEndedScreen;
  exports.interactedTutorRoundEndedScreen = interactedTutorRoundEndedScreen;
  exports.disenrolledClassB2b = disenrolledClassB2b;
  exports.autoEnrolledForSpringboardB2b = autoEnrolledForSpringboardB2b;
  exports.enrolledClassB2b = enrolledClassB2b;
  exports.interactedSpringboardTabB2b = interactedSpringboardTabB2b;
  exports.interactedDownloadLetterB2b = interactedDownloadLetterB2b;
  exports.viewedShareAssignmentPopupB2b = viewedShareAssignmentPopupB2b;
  exports.interactedShareAssignmentPopupB2b = interactedShareAssignmentPopupB2b;
  exports.viewedSkillSelectionScreenB2b = viewedSkillSelectionScreenB2b;
  exports.interactedSkillSelectionScreenB2b = interactedSkillSelectionScreenB2b;
  exports.viewedSkillPreviewScreenB2b = viewedSkillPreviewScreenB2b;
  exports.interactedSkillPreviewScreenB2b = interactedSkillPreviewScreenB2b;
  exports.viewedStudentSelectionScreenForSkillsB2b = viewedStudentSelectionScreenForSkillsB2b;
  exports.interactedStudentSelectionScreenForSkillsB2b = interactedStudentSelectionScreenForSkillsB2b;
  exports.finalPitstopShown = finalPitstopShown;
  exports.viewedMysteryCardsScreen = viewedMysteryCardsScreen;
  exports.interactedPitstop = interactedPitstop;
  exports.startedSound = startedSound;
  exports.viewedLearningPlanScreen1 = viewedLearningPlanScreen1;
  exports.interactedLearningPlanScreen1 = interactedLearningPlanScreen1;
  exports.viewedLearningPlanScreen2 = viewedLearningPlanScreen2;
  exports.interactedLearningPlanScreen2 = interactedLearningPlanScreen2;
  exports.viewedDailyLearningPathScreen = viewedDailyLearningPathScreen;
  exports.interactedDailyLearningPathScreen = interactedDailyLearningPathScreen;
  exports.viewedLibraryScreen = viewedLibraryScreen;
  exports.interactedLibraryScreen = interactedLibraryScreen;
  exports.viewedExcitingResourcesScreen = viewedExcitingResourcesScreen;
  exports.interactedExcitingResourcesScreen = interactedExcitingResourcesScreen;
  exports.startedNewLearningPath = startedNewLearningPath;
  exports.completedNewLearningPath = completedNewLearningPath;
  exports.viewedCustomisationScreen = viewedCustomisationScreen;
  exports.interactedCustomisationScreen = interactedCustomisationScreen;
  exports.viewedGoalsScreen = viewedGoalsScreen;
  exports.interactedGoalsScreen = interactedGoalsScreen;
  exports.viewedNewSubscriptionPopup = viewedNewSubscriptionPopup;
  exports.interactedNewSubscriptionPopup = interactedNewSubscriptionPopup;
  exports.viewedPopup = viewedPopup;
  exports.interactedPopup = interactedPopup;
  exports.viewedBookLibrary = viewedBookLibrary;
  exports.interactedBookLibrary = interactedBookLibrary;
  exports.scrolledDashboard = scrolledDashboard;
  exports.completedBookDashboardScrollTeacher = completedBookDashboardScrollTeacher;
  exports.viewedBookingConfirmationPopup = viewedBookingConfirmationPopup;
  exports.interactedBookingConfirmationPopup = interactedBookingConfirmationPopup;
  exports.viewedClassDetailsPopup = viewedClassDetailsPopup;
  exports.interactedClassDetailsPopup = interactedClassDetailsPopup;
  exports.viewedDailyBundleRail = viewedDailyBundleRail;
  exports.interactedDailyBundleRail = interactedDailyBundleRail;
  exports.bookAssigned = bookAssigned;
  exports.viewedBookLibraryReadingLog = viewedBookLibraryReadingLog;
  exports.interactedBookLibraryReadingLog = interactedBookLibraryReadingLog;
  exports.viewedBookLibraryStudentReport = viewedBookLibraryStudentReport;
  exports.interactedBookLibraryStudentReport = interactedBookLibraryStudentReport;
  exports.viewedBookLibraryAssignmentReport = viewedBookLibraryAssignmentReport;
  exports.interactedBookLibraryAssignmentReport = interactedBookLibraryAssignmentReport;
  exports.viewedBookLibraryAssignmentCard = viewedBookLibraryAssignmentCard;
  exports.interactedBookLibraryAssignmentCard = interactedBookLibraryAssignmentCard;
  exports.visitedYobB2b = visitedYobB2b;
  exports.interactedPrivacyNotice = interactedPrivacyNotice;
  exports.visitedTeacherOnboardingQuestionB2b = visitedTeacherOnboardingQuestionB2b;
  exports.visitedOnboardingEndLoadthroughB2b = visitedOnboardingEndLoadthroughB2b;
  exports.interactedAddStudentsPageB2b = interactedAddStudentsPageB2b;
  exports.visitedOtpScreen = visitedOtpScreen;
  exports.clickedStudentsCreated = clickedStudentsCreated;
  exports.googleClassroomcleverClassImportUnsuccessfulB2b = googleClassroomcleverClassImportUnsuccessfulB2b;
  exports.interactedOtpPage = interactedOtpPage;
  exports.viewedPrivacyNotice = viewedPrivacyNotice;
  exports.providedYob = providedYob;
  exports.visitedTeacherWelcome = visitedTeacherWelcome;
  exports.viewedParentDashboard = viewedParentDashboard;
  exports.interactedParentDashboard = interactedParentDashboard;
  exports.clickedOnBookAssign = clickedOnBookAssign;
  exports.visitedNewClass = visitedNewClass;
  exports.visitedAddStudentsparentEmailPageB2b = visitedAddStudentsparentEmailPageB2b;
  exports.interactedAddStudentsparentEmailPageB2b = interactedAddStudentsparentEmailPageB2b;
  exports.classCreated = classCreated;
  exports.viewedAddReimportedClassNamePageB2b = viewedAddReimportedClassNamePageB2b;
  exports.interactedAddReimportedClassNamePageB2b = interactedAddReimportedClassNamePageB2b;
  exports.viewedSyncConfirmationPopupB2b = viewedSyncConfirmationPopupB2b;
  exports.interactedPostClassSyncPopupB2b = interactedPostClassSyncPopupB2b;
  exports.interactedSyncConfirmationPopupB2b = interactedSyncConfirmationPopupB2b;
  exports.viewedPostClassSyncPopupB2b = viewedPostClassSyncPopupB2b;
  exports.syncGoogleClassroom = syncGoogleClassroom;
  exports.syncCleverClasses = syncCleverClasses;
  exports.viewedReimportedClassesSelectionScreenB2b = viewedReimportedClassesSelectionScreenB2b;
  exports.interactedReimportedClassesSelectionScreenB2b = interactedReimportedClassesSelectionScreenB2b;
  exports.interactedRosterPage = interactedRosterPage;
  exports.selectedClassesForImport = selectedClassesForImport;
  exports.interactedGooglecleverClassImportScreenB2b = interactedGooglecleverClassImportScreenB2b;
  exports.interactedManageAllClassesPage = interactedManageAllClassesPage;
  exports.classSyncUnsuccessfulB2b = classSyncUnsuccessfulB2b;
  exports.classSyncSuccessfulB2b = classSyncSuccessfulB2b;
  exports.viewedPreferredTimeInputPopup = viewedPreferredTimeInputPopup;
  exports.interactedPreferredTimeInputPopup = interactedPreferredTimeInputPopup;
  exports.viewedPreferredTimeConfirmationPopup = viewedPreferredTimeConfirmationPopup;
  exports.interactedPreferredTimeConfirmationPopup = interactedPreferredTimeConfirmationPopup;
  exports.interactedTodayClassPopup = interactedTodayClassPopup;
  exports.viewedTodayClassPopup = viewedTodayClassPopup;
  exports.paypalPaymentButtonRendered = paypalPaymentButtonRendered;
  exports.viewedProductSelectionB2b = viewedProductSelectionB2b;
  exports.interactedProductSelectionB2b = interactedProductSelectionB2b;
  exports.clickedProductSelectionB2b = clickedProductSelectionB2b;
  exports.visitedCurriculumTab = visitedCurriculumTab;
  exports.screenCurriculumRendered = screenCurriculumRendered;
  exports.clickedClassAssessments = clickedClassAssessments;
  exports.screenAssessmentRendered = screenAssessmentRendered;
  exports.visitedAssignmentTab = visitedAssignmentTab;
  exports.screenAssignmentRendered = screenAssignmentRendered;
  exports.clickedAssessmentReports = clickedAssessmentReports;
  exports.visitedReportsTab = visitedReportsTab;
  exports.visitedGridReport = visitedGridReport;
  exports.visitedDailyActivityReportTab = visitedDailyActivityReportTab;
  exports.visitedStudentCenter = visitedStudentCenter;
  exports.clickedOnProfileIcon = clickedOnProfileIcon;
  exports.viewedEditProfilePageB2b = viewedEditProfilePageB2b;
  exports.viewedReferSplashlearnPageB2b = viewedReferSplashlearnPageB2b;
  exports.viewedCommunityB2b = viewedCommunityB2b;
  exports.viewedManageRosterPageB2b = viewedManageRosterPageB2b;
  exports.clickedManageRoster = clickedManageRoster;
  exports.interactedEditProfilePageB2b = interactedEditProfilePageB2b;
  exports.interactedReferSplashlearnPageB2b = interactedReferSplashlearnPageB2b;
  exports.clickedClassroomSettings = clickedClassroomSettings;
  exports.viewedClassroomSettings = viewedClassroomSettings;
  exports.viewedStudentLoginInstructionsPopup = viewedStudentLoginInstructionsPopup;
  exports.visitedHomeAccess = visitedHomeAccess;
  exports.interactedHomeAccessPage = interactedHomeAccessPage;
  exports.viewedAvatarChangingRoom = viewedAvatarChangingRoom;
  exports.interactedAvatarChangingRoom = interactedAvatarChangingRoom;
  exports.viewedAvatarFeaturesSpace = viewedAvatarFeaturesSpace;
  exports.interactedAvatarFeaturesSpace = interactedAvatarFeaturesSpace;
  exports.updatedAvatar = updatedAvatar;
  exports.viewedClosetSpace = viewedClosetSpace;
  exports.interactedClosetSpace = interactedClosetSpace;
  exports.viewedGadgetSpace = viewedGadgetSpace;
  exports.interactedGadgetSpace = interactedGadgetSpace;
  exports.viewedLockedItemPopup = viewedLockedItemPopup;
  exports.interactedLockedItemPopup = interactedLockedItemPopup;
  exports.viewedNotEnoughSnPopup = viewedNotEnoughSnPopup;
  exports.interactedNotEnoughSnPopup = interactedNotEnoughSnPopup;
  exports.completedStateMachineLoading = completedStateMachineLoading;
  exports.purchasedAvatarItem = purchasedAvatarItem;
  exports.viewedCurriculumB2b = viewedCurriculumB2b;
  exports.interactedCurriculumB2b = interactedCurriculumB2b;
  exports.viewedTeacherResourcesTabB2b = viewedTeacherResourcesTabB2b;
  exports.interactedTeacherResourcesTabB2b = interactedTeacherResourcesTabB2b;
  exports.viewedCurriculumAssignmentReportPageB2b = viewedCurriculumAssignmentReportPageB2b;
  exports.interactedCurriculumReportTabB2b = interactedCurriculumReportTabB2b;
  exports.viewedBookLibraryReportTabB2b = viewedBookLibraryReportTabB2b;
  exports.interactedBookLibraryReportTabB2b = interactedBookLibraryReportTabB2b;
  exports.viewedPromotecontinueClassPopupB2b = viewedPromotecontinueClassPopupB2b;
  exports.interactedPromotecontinueClassPopupB2b = interactedPromotecontinueClassPopupB2b;
  exports.viewedTransferPopupB2b = viewedTransferPopupB2b;
  exports.interactedTransferPopupB2b = interactedTransferPopupB2b;
  exports.viewedDeleteClassPopupB2b = viewedDeleteClassPopupB2b;
  exports.interactedDeleteClassPopupB2b = interactedDeleteClassPopupB2b;
  exports.viewedTransferRequestSentPopupB2b = viewedTransferRequestSentPopupB2b;
  exports.viewedClassContinuedSuccessfullyPopupB2b = viewedClassContinuedSuccessfullyPopupB2b;
  exports.clickedAddToCollection = clickedAddToCollection;
  exports.viewedAddToCollectionScreen = viewedAddToCollectionScreen;
  exports.interactedAddToCollectionScreen = interactedAddToCollectionScreen;
  exports.viewedCreateANewCollectionScreen = viewedCreateANewCollectionScreen;
  exports.interactedCreateANewCollectionScreen = interactedCreateANewCollectionScreen;
  exports.viewedCollectionToastMessage = viewedCollectionToastMessage;
  exports.interactedCollectionToastMessage = interactedCollectionToastMessage;
  exports.viewedMyLibrary = viewedMyLibrary;
  exports.interactedMyLibrary = interactedMyLibrary;
  exports.interactedCollection = interactedCollection;
  exports.clickedOnRemove = clickedOnRemove;
  exports.viewedEditCollectionDetails = viewedEditCollectionDetails;
  exports.interactedEditCollectionDetails = interactedEditCollectionDetails;
  exports.viewedDeleteCollection = viewedDeleteCollection;
  exports.interactedDeleteCollection = interactedDeleteCollection;
  exports.viewedCreateANewAssignment = viewedCreateANewAssignment;
  exports.interactedCreateANewAssignment = interactedCreateANewAssignment;
  exports.clickedCollection = clickedCollection;
  exports.viewedMathFactsPageB2b = viewedMathFactsPageB2b;
  exports.viewedAssessmentsPageB2b = viewedAssessmentsPageB2b;
  exports.viewedMathFactsReportPageB2b = viewedMathFactsReportPageB2b;
  exports.viewedAssessmentsReportPageB2b = viewedAssessmentsReportPageB2b;
  exports.viewedClassReportPageB2b = viewedClassReportPageB2b;
  exports.viewedStudentReportPageB2b = viewedStudentReportPageB2b;
  exports.interactedCurriculumTab = interactedCurriculumTab;
  exports.viewedCurriculumReportTabB2b = viewedCurriculumReportTabB2b;
  exports.viewedBookLibraryTabB2b = viewedBookLibraryTabB2b;
  exports.viewedCurriculumTabB2b = viewedCurriculumTabB2b;
  exports.interactedBookLibraryTabB2b = interactedBookLibraryTabB2b;
  exports.childProfilePageViewed = childProfilePageViewed;
  exports.viewedAllProfilesPages = viewedAllProfilesPages;
  exports.interactedAllProfilesPage = interactedAllProfilesPage;
  exports.viewedDashboardNudge = viewedDashboardNudge;
  exports.interactedDashboardNudge = interactedDashboardNudge;
  exports.triggeredNudge = triggeredNudge;
  exports.startedPitstopAnimation = startedPitstopAnimation;
  exports.completedPitstopAnimation = completedPitstopAnimation;
  exports.viewedTopicsModificationScreen = viewedTopicsModificationScreen;
  exports.interactedTopicsModificationScreen = interactedTopicsModificationScreen;
  exports.viewedWelcomePageByTransferredTeacherb2b = viewedWelcomePageByTransferredTeacherb2b;
  exports.interactedWelcomePageByTransferredTeacherb2b = interactedWelcomePageByTransferredTeacherb2b;
  exports.viewedClassTransferPopupByTransferredTeacherb2b = viewedClassTransferPopupByTransferredTeacherb2b;
  exports.interactedClassTransferPopupByTransferredTeacherB2b = interactedClassTransferPopupByTransferredTeacherB2b;
  exports.viewedTransferSuccessfulPopupByTransferringTeacherB2b = viewedTransferSuccessfulPopupByTransferringTeacherB2b;
  exports.interactedTransferSuccessfulPopupByTransferringTeacherB2b = interactedTransferSuccessfulPopupByTransferringTeacherB2b;
  exports.viewedClassTransferFailedPopupByTransferringTeacherB2b = viewedClassTransferFailedPopupByTransferringTeacherB2b;
  exports.interactedClassTransferFailedByTransferringTeacherB2b = interactedClassTransferFailedByTransferringTeacherB2b;
  exports.viewedClassTransferFailedPopupByTransferredTeacherB2b = viewedClassTransferFailedPopupByTransferredTeacherB2b;
  exports.interactedClassTransferFailedByTransferredTeacherB2b = interactedClassTransferFailedByTransferredTeacherB2b;
  exports.interactedClassroomReport = interactedClassroomReport;
  exports.interactedStudentReport = interactedStudentReport;
  exports.getStartedWidgetVisibility = getStartedWidgetVisibility;
  exports.interactedGetStartedWidget = interactedGetStartedWidget;
  exports.dailyBundleGeneratedBe = dailyBundleGeneratedBe;
  exports.apiFailure = apiFailure;
  exports.tapEventSkipped = tapEventSkipped;
  exports.viewedSubjectPersonalisationConsentScreen = viewedSubjectPersonalisationConsentScreen;
  exports.interactedSubjectPersonalisationConsentScreen = interactedSubjectPersonalisationConsentScreen;
  exports.pageInteracted = pageInteracted;
  exports.bookFeedbackSubmitted = bookFeedbackSubmitted;
  exports.viewedDatePickerCalendarB2b = viewedDatePickerCalendarB2b;
  exports.interactedDatePickerCalendarB2b = interactedDatePickerCalendarB2b;
  exports.selectedAssignmentDueDateB2b = selectedAssignmentDueDateB2b;
  exports.visitedUpgradePitchPage = visitedUpgradePitchPage;
  exports.interactedUpgradePitchPage = interactedUpgradePitchPage;
  exports.adaptiveAlgoActivated = adaptiveAlgoActivated;
  exports.adaptiveAlgoDeactivated = adaptiveAlgoDeactivated;
  exports.gameLoadingStarted = gameLoadingStarted;
  exports.gameLoadingCompleted = gameLoadingCompleted;
  exports.nextButtonShown = nextButtonShown;
  exports.clickedNextButton = clickedNextButton;
  exports.viewedAvatarCelebrationScreen = viewedAvatarCelebrationScreen;
  exports.interactedAvatarCelebrationScreen = interactedAvatarCelebrationScreen;
  exports.viewedCurriculumScreen = viewedCurriculumScreen;
  exports.loStarted = loStarted;
  exports.loCompleted = loCompleted;
  exports.milestoneCompleted = milestoneCompleted;
  exports.interactedCurriculumScreen = interactedCurriculumScreen;
  exports.collectionAssigned = collectionAssigned;
  exports.viewedPtlParentSignupScreen = viewedPtlParentSignupScreen;
  exports.interactedPtlParentSignupScreen = interactedPtlParentSignupScreen;
  exports.ptlLinkingAttempted = ptlLinkingAttempted;
  exports.ptlLinkingSuccessful = ptlLinkingSuccessful;
  exports.ptlLinkingFailed = ptlLinkingFailed;
  exports.viewedStudentSelectionScreen = viewedStudentSelectionScreen;
  exports.interactedStudentSelectionScreen = interactedStudentSelectionScreen;
  exports.viewedStudentPasswordScreen = viewedStudentPasswordScreen;
  exports.interactedStudentPasswordScreen = interactedStudentPasswordScreen;
  exports.guestStudentLoginSuccessful = guestStudentLoginSuccessful;
  exports.guestStudentLoginFailed = guestStudentLoginFailed;
  exports.viewedPtlParentLoginScreen = viewedPtlParentLoginScreen;
  exports.interactedPtlParentLoginScreen = interactedPtlParentLoginScreen;
  exports.ptlParentLoginAttempted = ptlParentLoginAttempted;
  exports.ptlParentLoginSuccessful = ptlParentLoginSuccessful;
  exports.ptlParentLoginFailed = ptlParentLoginFailed;
  exports.viewedResetPasswordScreen = viewedResetPasswordScreen;
  exports.interactedResetPasswordScreen = interactedResetPasswordScreen;
  exports.viewedChangePasswordScreen = viewedChangePasswordScreen;
  exports.interactedChangePasswordScreen = interactedChangePasswordScreen;
  exports.viewedPasswordResetSuccessfulPopup = viewedPasswordResetSuccessfulPopup;
  exports.viewedAddreplaceStudentProfileScreen = viewedAddreplaceStudentProfileScreen;
  exports.interactedAddreplaceStudentProfileScreen = interactedAddreplaceStudentProfileScreen;
  exports.viewedPtlStudentLinkedSuccessfullyPopup = viewedPtlStudentLinkedSuccessfullyPopup;
  exports.viewedAccountExistsIntimationScreen = viewedAccountExistsIntimationScreen;
  exports.interactedPtlAccountExistsIntimationScreen = interactedPtlAccountExistsIntimationScreen;
  exports.viewedPaymentMethodScreen = viewedPaymentMethodScreen;
  exports.viewedDbIntermediateScreen = viewedDbIntermediateScreen;
  exports.interactedDbIntermediateScreen = interactedDbIntermediateScreen;
  exports.startedDbFtue = startedDbFtue;
  exports.viewedErrorOnPtlParentSignupScreen = viewedErrorOnPtlParentSignupScreen;
  exports.playableInteracted = playableInteracted;
  exports.pageTurned = pageTurned;
  exports.viewedPitstop = viewedPitstop;
  exports.gameExited = gameExited;
  exports.viewedStudentLoginPasswordSettingsPageB2b = viewedStudentLoginPasswordSettingsPageB2b;
  exports.interactedStudentLoginPasswordSettingsPageB2b = interactedStudentLoginPasswordSettingsPageB2b;
  exports.savedStudentLoginPasswordSettingB2b = savedStudentLoginPasswordSettingB2b;
  exports.viewedThankYouScreen = viewedThankYouScreen;
  exports.interactedThankYouScreen = interactedThankYouScreen;
  exports.viewedAppDownloadRedirectScreen = viewedAppDownloadRedirectScreen;
  exports.crossusageEmailTrigger = crossusageEmailTrigger;
  exports.visitedOtpScreenGuest = visitedOtpScreenGuest;
  exports.interactedOtpPageGuest = interactedOtpPageGuest;
  exports.viewedClassSelectionViaStudentExperience = viewedClassSelectionViaStudentExperience;
  exports.viewedStudentSelectionViaStudentExperience = viewedStudentSelectionViaStudentExperience;
  exports.interactedStudentSelectionViaStudentExperience = interactedStudentSelectionViaStudentExperience;
  exports.interactedClassSelectionViaStudentExperience = interactedClassSelectionViaStudentExperience;
  exports.viewedTiledDashboardViaStudentExpereince = viewedTiledDashboardViaStudentExpereince;
  exports.viewedWelcomeScreen = viewedWelcomeScreen;
  exports.questActionTaken = questActionTaken;
  exports.viewedDailyQuestPage = viewedDailyQuestPage;
  exports.interactedDailyQuestPage = interactedDailyQuestPage;
  exports.viewedParentMenu = viewedParentMenu;
  exports.interactedParentMenu = interactedParentMenu;
  exports.soundNotFound = soundNotFound;
  exports.viewedBookLibraryTeacher = viewedBookLibraryTeacher;
  exports.interactedBookLibraryTeacher = interactedBookLibraryTeacher;
  exports.playableClickedTeacher = playableClickedTeacher;
  exports.interactedBookSearchIconTeacher = interactedBookSearchIconTeacher;
  exports.interactedBookSearchIcon = interactedBookSearchIcon;
  exports.scrolledBookDashboardTeacher = scrolledBookDashboardTeacher;
  exports.scrolledBookDashboard = scrolledBookDashboard;
  exports.completedBookDashboardScroll = completedBookDashboardScroll;
  exports.viewedAvatarOptionsScreen = viewedAvatarOptionsScreen;
  exports.interactedAvatarOptionsScreen = interactedAvatarOptionsScreen;
  exports.setSystemProperties_ = setSystemProperties_;
  exports.setSystemProperties = setSystemProperties;
  exports.setup_ = setup_;
  exports.initAvo = initAvo;
  exports.WebDebuggerPosition = WebDebuggerPosition;
  exports.avoInspectorApiKey = avoInspectorApiKey;
}(typeof exports === 'undefined' ? this.Avo = {} : exports));

// AVOMODULEMAP:"Avo"
// AVOEVENTMAP:["viewedTakeTourPopup","interactedOnTakeTourPopup","interactedMpGameTab","viewedMpClassmatesDrawer","viewedMpGameTab","interactedMpClassmatesDrawer","viewedMpGameInvitesDrawer","interactedMpGameInvitesDrawer","viewedMpInviteNotification","interactedMpInviteNotification","viewedMpModeSelectionScreen","interactedMpModeSelectionScreen","viewedMpOptionsSelectionScreen","interactedMpOptionsSelectionScreen","viewedMpInviteFriendsScreen","interactedMpInviteFriendsScreen","viewedMpGameLoaderScreen","viewedMpGamePlayScreen","opponentSearchStarted","opponentFound","countdownAnimationStarted","viewedMpQuestionsExhaustedScreen","viewedMpGameLobby","interactedMpGameLobby","viewedMpGameRewardsScreen","viewedMpRematchPopup","interactedMpRematchPopup","viewedPost3pmPopUp","interactedPost3pmPopUp","viewedErrorOnPost3pmPopUp","viewedSuspectedEmailNudge","interactedSuspectedEmailNudge","viewedMpGameTabCoachmark","viewedMpGameTileCoachmark","visitedDashboardTab","viewedMfWalkthroughPopup","interactedMfWalkthroughPopup","navClickedMfNewPractice","viewedMfSettingsPopup","interactedMfSettingsPopup","successfullyAssigned","navClickedMfTrackFluency","viewedMfTrackAdaptivePage","viewedMfTrackCustomPage","interactedMfTrackAdaptivePage","navClickedStudentReport","viewedMfStudentProgressPage","interactedMfStudentProgressPage","navClickedClassReport","viewedClassCurriculumReportPage","viewedMfClassProgressPage","interactedMfClassProgressPage","viewedMfModifyPracticePage","interactedMfModifyPracticePage","viewedMytodoPage","mathFactStarted","completedMathFactAssignment","viewedDeleteAccountAlert","interactedDeleteAccountAlert","startedGame","viewedGames","tappedGame","interactedMfNewPracticePage","interactedMfCustomModeSettingsPopup","interactedMfStudentSelectionPopup","interactedMfTrackCustomPage","interactedMfCustomReportPage","weeklyGoalInteracted","viewedTiledDashboard","interactedTiledDashboard","completedStudentDashboardScroll","completedPageRendering","downloadedWorksheet","clickedWorksheetTab","appliedWorksheetFilters","clearedWorksheetFilters","viewedWorksheetListingPage","interactedWorksheetListingPage","savedWorksheet","viewedSavedWorksheetPage","viewedDownloadHistoryWorksheetPage","previewedWorksheet","closedMathFacts","interactedActivityPage","emailVerifiedFrontend","selectedGame","visitedOnboardingWelcome","interactedTeacherOnboarding","ageQuestionScreenViewed","ageQuestionScreenInteracted","onboardingQuestionScreenViewed","onboardingQuestionInteracted","interactedAssignmentSuccessfullyAssignedPage","viewedMfSuccessfullyAssignedPage","viewedAssignmentSuccessfullyAssignedPage","interactedMfSuccessfullyAssignedPage","viewedGameZone","interactedGameZone","playableClicked","playableStarted","playableCompleted","viewedSubscribePopup","interactedSubscribePopup","viewedWorksheetSearchDropdown","interactedWorksheetSearchDropdown","viewedWorksheetSearchResultsPage","interactedWorksheetSearchResultsPage","viewedWorksheetSearchResultsEndPage","interactedThemeToggle","viewedNudge","interactedNudge","interactedStudentProgressPage","recommendedItem","interactedPrintReportPopup","interactedStudentProgress","playableTapped","mathFactsClosed","interactedLiveClassesTab","interactedLiveClassesSubscriptionPopup","viewedTrialPitchScreen","interactedTrialPitchScreen","interactedLeftNavigationMenu","interactedSplashcommunityDiscoverabilityPopUp","viewedSplashcommunityDiscoverabilityPopUp","interactedNewClassAdditionPage","freemiumTimerExpired","freemiumTimerStarted","reachedDailyLimit","studentAutoLoggedInSuccessfully","viewedSubscribePopUpOnPtl","viewedOnboardingStepCompletionAnimation","viewedTeacherDashboard","interactedTeacherDashboard","autoEnrolledForSpringboard","viewedSpringboardNewIntro","interactedSpringboardNewIntro","viewedSpringboardTab","interactedSpringboardTab","interactedClassroomSettingsPage","viewedUrgencyDiscountPopup","interactedUrgencyDiscountPopup","interactedUnlockContent","visitedCertificateTabSpringboard","interactedCertificatesPageSpringboard","viewedCertificate","downloadedCertificate","viewedIntroducingCertificatesPopup","interactedIntroductoryCertificatesPopup","viewedWeeklyHighlightsPopup","interactedWeeklyHighlightsPopup","viewedTutorLobby","interactedTutorLobby","classQuizStarted","classQuizEnded","viewedTutorInQuizScreen","interactedTutorInQuizScreen","nextQuestionWarningViewed","nextQuestionWarningInteracted","viewedTutorQuizTimerRunOutPopup","viewedTutorFinalLeaderboard","viewedStudentLobbyScreen","viewedStudentInQuizScreen","interactedStudentInQuizScreen","viewedStudentPitstopScreen","problemsAnswered","viewedStudentQuizTimerRunOut","viewedStudentFinalLeaderboard","interactedSubscribePopUpOnPtl","problemsAnsweredInNeoWorksheets","viewedUpcomingClassTab","interactedUpcomingClassTab","viewedLiveClassesIntroductionPopup","interactedLiveClassesIntroductionPopup","viewedAddParentEmailsPage","interactedAddParentEmailsPage","viewedProgramSelectionScreen","interactedProgramSelectionScreen","viewedAgeSelectionScreen","interactedAgeSelectionScreen","viewedProgramDetailsScreen","interactedProgramDetailsScreen","viewedAddParentsEmailPage","interactedAddParentsEmailPage","interactedLockedGame","viewedPlayAtHomeScreen","interactedPlayAtHomeScreen","viewedLockedGames","viewedCoqOptInScreen","interactedCoqOptInScreen","classWonSpringboardCertificate","studentWonSpringboardCertificate","classAlmostWonSpringboardCertificate","studentAlmostWonSpringboardCertificate","viewedCgSummary","interactedCgSummary","viewedCgMilestones","interactedCgMilestones","scrolledStudentDashboard","startedPrintablesSearch","selectedPrintablesSearch","interactedPrintablesFilters","viewedShareDiscountBanner","interactedShareDiscountBanner","viewedCertificateTabOnParentDashboard","interactedCertificateTabOnParentDashboard","viewedSchoolHomeScreen","interactedSchoolHomeScreen","viewedSummerLearningOfferPage","interactedSummerLearningOfferPage","viewedSummerLearningPopUp","interactedSummerLearningPopUp","parentalGateFailed","parentalGateClosed","interactedLoginScreen","viewedClassroomLinkedLoginScreen","interactedClassroomLinkedLoginScreen","viewedLoginViaOtpByClassroomLinkedParent","interactedLoginViaOtpByClassroomLinkedParent","interactedProfileIcon","viewedCoTeacherCoachmark","interactedCoTeacherCoachmark","viewedManageAllClassesPage","viewedAddCoTeacherPopup","interactedAddCoTeacherPopup","viewedCoTeachingPopupByCoTeacher","interactedCoTeachingPopupByCoTeacher","viewedWelcomePageByNewlyCreatedCoTeacher","interactedWelcomePageByNewlyCreatedCoTeacher","viewedSummerBundleWidgetOnDashboard","interactedSummerBundleWidgetOnDashboard","clickedSupport","visitedAllPlansPage","interactedAllPlansPage","visitedPlanPurchaseCombinedPage","interactedPlanPurchaseCombinedPage","paymentFormError","completedPageScroll","childProfilePageInteracted","viewedCoachmarkB2b","interactedCoachmarkB2b","viewedLiveClassesFreemiumPitch","interactedLiveClassesFreemiumPitch","viewedClassPreferenceScreen","interactedClassPreferenceScreen","viewedInterestConfirmationScreen","interactedInterestConfirmationScreen","interactedSearchIcon","typingStartedOnSearchBar","typingStoppedOnSearchBar","interactedSearchResult","viewedTransferPageB2b","interactedTransferPageB2b","viewedFeatureFeedbackPopUpB2b","interactedFeatureFeedbackPopUpB2b","viewedSuggestImprovementsPopupB2b","interactedSuggestImprovementsPopupB2b","interactedHelpIconB2b","clickedOnHelpIconB2b","viewedWorksheetPreview","interactedWorksheetPreview","interactedFabB2b","scrolledPlanPage","interactedPromotePopupB2b","interactedContinueSameClassPopupB2b","interactedStudentLoginInstructionsPopupB2b","productPurchased","creditCardSubmitted","productPurchasedFrontend","viewedAllRecordingsPage","interactedAllRecordingsPage","viewedPersonaQuestionScreen","interactedPersonaQuestionScreen","viewedCompanion","startedCompanionAnimation","completedCompanionAnimation","interactedCompanion","dashboardGraphqlQueryStarted","dashboardGraphqlQueryEnded","dashboardRendered","viewedCompleteTopicAssignmentPopupB2b","interactedCompleteTopicAssignmentPopupB2b","viewedDeleteTopicAssignmentPopupB2b","interactedDeleteTopicAssignmentPopupB2b","downloadedWorksheetB2c","interactedAssignmentSuccessfullyAssignedPageB2b","interactedSchoolSelectionScreenB2b","viewedPricingInfoBox","liveClassTabAvailable","endedCompanionAnimation","viewedCompanionRecommendation","interactedCompanionRecommendation","startedPitstopCompanionAnimation","endedPitstopCompanionAnimation","receivedRiveFile","companionEventsBackend","reachedDailyLimitBackend","viewedAddOnPitchScreen","interactedAddOnPitchScreen","viewedAddOnUpgradeScreen","interactedAddOnUpgradeScreen","viewedAddOnPurchaseThankYouScreen","interactedAddOnPurchaseThankYouScreen","viewedPostLiveClassPitch","interactedPostLiveClassPitch","viewedReinforcementAtHomeB2b","interactedReinforcementAtHomeB2b","viewedLiveClassPageB2b","interactedLiveClassPageB2b","viewedMaxLiveClassLimitReachedPopupB2b","viewedShareLiveClassPopupB2b","interactedShareLiveClassPopupB2b","viewedLiveClassRecommendationPopup","interactedLiveClassRecommendationPopup","loadedQuestionForStudent","loadedQuestionForTutor","interactedTutorQuizTimerRunOut","viewedGoogleAccountSelectionScreenB2b","viewedGooglecleverClassImportScreenB2b","errorMessageDisplayedB2b","viewedChildNameScreen","interactedChildNameScreen","viewedGradeSelectionScreen","interactedGradeSelectionScreen","viewedSubjectSelectionScreen","interactedSubjectSelectionScreen","viewedOnboardingQuestionScreen","interactedOnboardingQuestionScreen","viewedLearningPlanScreen","interactedLearningPlanScreen","viewedWeeklyGoalScreen","interactedWeeklyGoalScreen","viewedLibraryLoadthrough","viewedExcitingResourcesLoadthrough","viewedLocalNotificationPrompt","interactedLocalNotificationPrompt","interactedMyToDoPopupB2b","viewedPendingActivityPopupB2b","viewedStudentLevelBarDropdownB2b","interactedStudentLevelBarDropdownB2b","viewedMpGameExpiredPopupB2b","classroomPtlLinkStarted","classroomPtlLinkEnded","viewedLessonPlansListingPageB2b","interactedLessonPlansListingPageB2b","viewedLessonPlanDetailPageB2b","interactedLessonPlanDetailPageB2b","viewedStudentRoundIntroScreen","viewedTutorRoundIntroScreen","interactedTutorRoundIntroScreen","viewedBadgesAnimationInNeoQuiz","viewedStudentRoundEndedScreen","viewedTutorRoundEndedScreen","interactedTutorRoundEndedScreen","disenrolledClassB2b","autoEnrolledForSpringboardB2b","enrolledClassB2b","interactedSpringboardTabB2b","interactedDownloadLetterB2b","viewedShareAssignmentPopupB2b","interactedShareAssignmentPopupB2b","viewedSkillSelectionScreenB2b","interactedSkillSelectionScreenB2b","viewedSkillPreviewScreenB2b","interactedSkillPreviewScreenB2b","viewedStudentSelectionScreenForSkillsB2b","interactedStudentSelectionScreenForSkillsB2b","finalPitstopShown","viewedMysteryCardsScreen","interactedPitstop","startedSound","viewedLearningPlanScreen1","interactedLearningPlanScreen1","viewedLearningPlanScreen2","interactedLearningPlanScreen2","viewedDailyLearningPathScreen","interactedDailyLearningPathScreen","viewedLibraryScreen","interactedLibraryScreen","viewedExcitingResourcesScreen","interactedExcitingResourcesScreen","startedNewLearningPath","completedNewLearningPath","viewedCustomisationScreen","interactedCustomisationScreen","viewedGoalsScreen","interactedGoalsScreen","viewedNewSubscriptionPopup","interactedNewSubscriptionPopup","viewedPopup","interactedPopup","viewedBookLibrary","interactedBookLibrary","scrolledDashboard","completedBookDashboardScrollTeacher","viewedBookingConfirmationPopup","interactedBookingConfirmationPopup","viewedClassDetailsPopup","interactedClassDetailsPopup","viewedDailyBundleRail","interactedDailyBundleRail","bookAssigned","viewedBookLibraryReadingLog","interactedBookLibraryReadingLog","viewedBookLibraryStudentReport","interactedBookLibraryStudentReport","viewedBookLibraryAssignmentReport","interactedBookLibraryAssignmentReport","viewedBookLibraryAssignmentCard","interactedBookLibraryAssignmentCard","visitedYobB2b","interactedPrivacyNotice","visitedTeacherOnboardingQuestionB2b","visitedOnboardingEndLoadthroughB2b","interactedAddStudentsPageB2b","visitedOtpScreen","clickedStudentsCreated","googleClassroomcleverClassImportUnsuccessfulB2b","interactedOtpPage","viewedPrivacyNotice","providedYob","visitedTeacherWelcome","viewedParentDashboard","interactedParentDashboard","clickedOnBookAssign","visitedNewClass","visitedAddStudentsparentEmailPageB2b","interactedAddStudentsparentEmailPageB2b","classCreated","viewedAddReimportedClassNamePageB2b","interactedAddReimportedClassNamePageB2b","viewedSyncConfirmationPopupB2b","interactedPostClassSyncPopupB2b","interactedSyncConfirmationPopupB2b","viewedPostClassSyncPopupB2b","syncGoogleClassroom","syncCleverClasses","viewedReimportedClassesSelectionScreenB2b","interactedReimportedClassesSelectionScreenB2b","interactedRosterPage","selectedClassesForImport","interactedGooglecleverClassImportScreenB2b","interactedManageAllClassesPage","classSyncUnsuccessfulB2b","classSyncSuccessfulB2b","viewedPreferredTimeInputPopup","interactedPreferredTimeInputPopup","viewedPreferredTimeConfirmationPopup","interactedPreferredTimeConfirmationPopup","interactedTodayClassPopup","viewedTodayClassPopup","paypalPaymentButtonRendered","viewedProductSelectionB2b","interactedProductSelectionB2b","clickedProductSelectionB2b","visitedCurriculumTab","screenCurriculumRendered","clickedClassAssessments","screenAssessmentRendered","visitedAssignmentTab","screenAssignmentRendered","clickedAssessmentReports","visitedReportsTab","visitedGridReport","visitedDailyActivityReportTab","visitedStudentCenter","clickedOnProfileIcon","viewedEditProfilePageB2b","viewedReferSplashlearnPageB2b","viewedCommunityB2b","viewedManageRosterPageB2b","clickedManageRoster","interactedEditProfilePageB2b","interactedReferSplashlearnPageB2b","clickedClassroomSettings","viewedClassroomSettings","viewedStudentLoginInstructionsPopup","visitedHomeAccess","interactedHomeAccessPage","viewedAvatarChangingRoom","interactedAvatarChangingRoom","viewedAvatarFeaturesSpace","interactedAvatarFeaturesSpace","updatedAvatar","viewedClosetSpace","interactedClosetSpace","viewedGadgetSpace","interactedGadgetSpace","viewedLockedItemPopup","interactedLockedItemPopup","viewedNotEnoughSnPopup","interactedNotEnoughSnPopup","completedStateMachineLoading","purchasedAvatarItem","viewedCurriculumB2b","interactedCurriculumB2b","viewedTeacherResourcesTabB2b","interactedTeacherResourcesTabB2b","viewedCurriculumAssignmentReportPageB2b","interactedCurriculumReportTabB2b","viewedBookLibraryReportTabB2b","interactedBookLibraryReportTabB2b","viewedPromotecontinueClassPopupB2b","interactedPromotecontinueClassPopupB2b","viewedTransferPopupB2b","interactedTransferPopupB2b","viewedDeleteClassPopupB2b","interactedDeleteClassPopupB2b","viewedTransferRequestSentPopupB2b","viewedClassContinuedSuccessfullyPopupB2b","clickedAddToCollection","viewedAddToCollectionScreen","interactedAddToCollectionScreen","viewedCreateANewCollectionScreen","interactedCreateANewCollectionScreen","viewedCollectionToastMessage","interactedCollectionToastMessage","viewedMyLibrary","interactedMyLibrary","interactedCollection","clickedOnRemove","viewedEditCollectionDetails","interactedEditCollectionDetails","viewedDeleteCollection","interactedDeleteCollection","viewedCreateANewAssignment","interactedCreateANewAssignment","clickedCollection","viewedMathFactsPageB2b","viewedAssessmentsPageB2b","viewedMathFactsReportPageB2b","viewedAssessmentsReportPageB2b","viewedClassReportPageB2b","viewedStudentReportPageB2b","interactedCurriculumTab","viewedCurriculumReportTabB2b","viewedBookLibraryTabB2b","viewedCurriculumTabB2b","interactedBookLibraryTabB2b","childProfilePageViewed","viewedAllProfilesPages","interactedAllProfilesPage","viewedDashboardNudge","interactedDashboardNudge","triggeredNudge","startedPitstopAnimation","completedPitstopAnimation","viewedTopicsModificationScreen","interactedTopicsModificationScreen","viewedWelcomePageByTransferredTeacherb2b","interactedWelcomePageByTransferredTeacherb2b","viewedClassTransferPopupByTransferredTeacherb2b","interactedClassTransferPopupByTransferredTeacherB2b","viewedTransferSuccessfulPopupByTransferringTeacherB2b","interactedTransferSuccessfulPopupByTransferringTeacherB2b","viewedClassTransferFailedPopupByTransferringTeacherB2b","interactedClassTransferFailedByTransferringTeacherB2b","viewedClassTransferFailedPopupByTransferredTeacherB2b","interactedClassTransferFailedByTransferredTeacherB2b","interactedClassroomReport","interactedStudentReport","getStartedWidgetVisibility","interactedGetStartedWidget","dailyBundleGeneratedBe","apiFailure","tapEventSkipped","viewedSubjectPersonalisationConsentScreen","interactedSubjectPersonalisationConsentScreen","pageInteracted","bookFeedbackSubmitted","viewedDatePickerCalendarB2b","interactedDatePickerCalendarB2b","selectedAssignmentDueDateB2b","visitedUpgradePitchPage","interactedUpgradePitchPage","adaptiveAlgoActivated","adaptiveAlgoDeactivated","gameLoadingStarted","gameLoadingCompleted","nextButtonShown","clickedNextButton","viewedAvatarCelebrationScreen","interactedAvatarCelebrationScreen","viewedCurriculumScreen","loStarted","loCompleted","milestoneCompleted","interactedCurriculumScreen","collectionAssigned","viewedPtlParentSignupScreen","interactedPtlParentSignupScreen","ptlLinkingAttempted","ptlLinkingSuccessful","ptlLinkingFailed","viewedStudentSelectionScreen","interactedStudentSelectionScreen","viewedStudentPasswordScreen","interactedStudentPasswordScreen","guestStudentLoginSuccessful","guestStudentLoginFailed","viewedPtlParentLoginScreen","interactedPtlParentLoginScreen","ptlParentLoginAttempted","ptlParentLoginSuccessful","ptlParentLoginFailed","viewedResetPasswordScreen","interactedResetPasswordScreen","viewedChangePasswordScreen","interactedChangePasswordScreen","viewedPasswordResetSuccessfulPopup","viewedAddreplaceStudentProfileScreen","interactedAddreplaceStudentProfileScreen","viewedPtlStudentLinkedSuccessfullyPopup","viewedAccountExistsIntimationScreen","interactedPtlAccountExistsIntimationScreen","viewedPaymentMethodScreen","viewedDbIntermediateScreen","interactedDbIntermediateScreen","startedDbFtue","viewedErrorOnPtlParentSignupScreen","playableInteracted","pageTurned","viewedPitstop","gameExited","viewedStudentLoginPasswordSettingsPageB2b","interactedStudentLoginPasswordSettingsPageB2b","savedStudentLoginPasswordSettingB2b","viewedThankYouScreen","interactedThankYouScreen","viewedAppDownloadRedirectScreen","crossusageEmailTrigger","visitedOtpScreenGuest","interactedOtpPageGuest","viewedClassSelectionViaStudentExperience","viewedStudentSelectionViaStudentExperience","interactedStudentSelectionViaStudentExperience","interactedClassSelectionViaStudentExperience","viewedTiledDashboardViaStudentExpereince","viewedWelcomeScreen","questActionTaken","viewedDailyQuestPage","interactedDailyQuestPage","viewedParentMenu","interactedParentMenu","soundNotFound","viewedBookLibraryTeacher","interactedBookLibraryTeacher","playableClickedTeacher","interactedBookSearchIconTeacher","interactedBookSearchIcon","scrolledBookDashboardTeacher","scrolledBookDashboard","completedBookDashboardScroll","viewedAvatarOptionsScreen","interactedAvatarOptionsScreen"]
